( () => {
    var __webpack_modules__ = {
        106: (e, t, i) => {
            "use strict";
            i.d(t, {
                MM: () => a,
                TY: () => l,
                fJ: () => d,
                nP: () => u,
                rQ: () => h,
                tQ: () => p,
                vC: () => c,
                x_: () => s
            });
            var o = i(981)
              , n = i(755)
              , r = i(755);
            function a() {
                return "<div style='display:none;'><div id='dialog' title='Basic dialog'><p>Your product isn't ready to go live. <br/>Delete all variants from the product and click save. <br/> </br/> Click <a target='_blank' href='https://support.custompricecalculator.com/en/articles/8077580-add-to-cart-not-working'>here</a> to learn more.</p></div></div>"
            }
            function s() {
                return "<div id='alert-block' class='hide-element alert float-left mt-4 w-100 clearfix alert-danger'>Please upload an image</div>"
            }
            function l(e) {
                for (var t = "1"; t.length < e; )
                    t = "0" + t;
                return e > 0 && (t = "0." + t),
                parseFloat(t)
            }
            function c() {
                n("#dialog").dialog({
                    draggable: !1,
                    resizable: !1,
                    title: "Custom Price Calculator Alert!",
                    width: 430,
                    height: 230
                })
            }
            function u(e) {
                return e.replace(/\"/g, '\\"')
            }
            function d(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                var i = window.location.href
                  , r = JSON.stringify(e, Object.getOwnPropertyNames(e));
                r = r + ", Msg1 = " + t + ", SourceUrl = " + i,
                n.ajax({
                    method: "POST",
                    url: o.baseCalculatorNewApiUrl + "logs/error",
                    data: JSON.stringify({
                        calculatorId: o.cpc_calculatorId,
                        productId: o.cpc_productId,
                        errorMessage: r
                    }),
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                }).done((function() {}
                ))
            }
            function p(e, t, i) {
                let n, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                n = 1 === t ? "," : 2 === t ? "." : 3 === t ? " " : "";
                const a = 1 === i ? "," : "."
                  , s = e.toFixed(r ? 2 : o.priceMarkerDecimals).split(".");
                return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, n) + (s.length > 1 ? a + s[1] : "")
            }
            function h() {
                r("#calculator").on("keypress", (function(e) {
                    if (console.log("checking for enter whether preseed for form."),
                    13 === (e.keyCode || e.which))
                        return console.log("Found Enter pressed for form."),
                        e.preventDefault(),
                        !1
                }
                ))
            }
        }
        ,
        196: (e, t, i) => {
            "use strict";
            i.d(t, {
                Hf: () => c,
                UN: () => a,
                V8: () => l,
                nC: () => s,
                vK: () => r,
                yu: () => u
            });
            var o = i(981)
              , n = i(755);
            function r() {
                let e = !1;
                return n(".calc-prop").each(( (t, i) => {
                    if (!1 === n(i).is(":hidden")) {
                        let t = n(i).val()
                          , o = n(i).data("isrequired")
                          , r = n(i).is(":checked")
                          , a = i.type;
                        void 0 !== o && 1 == o && ("checkbox" === a && !1 === r || "checkbox" !== a && t.length <= 0) && (console.log("element-if-clause", i),
                        e = !0,
                        n(i).addClass("error-border"))
                    }
                }
                )),
                setTimeout(( () => {
                    n(".calc-prop").each(( (e, t) => {
                        n(t).removeClass("error-border")
                    }
                    ))
                }
                ), 3e3),
                e
            }
            function a(e) {
                var t = o.cpc_data.Elements
                  , i = null;
                return t.forEach((t => {
                    t.Identifier === e && (i = t)
                }
                )),
                i
            }
            function s(e) {
                let t = e.toLowerCase();
                return t = t.replace(/\(/g, "\\("),
                t = t.replace(/\)/g, "\\)"),
                t = t.replace(/\[/g, "\\["),
                t = t.replace(/\]/g, "\\]"),
                t = t.replace(/\?/g, "\\?"),
                t = t.replace(/\//g, "\\/"),
                t = t.replace(/\+/g, "\\+"),
                t = t.replace(/\$/g, "\\$"),
                t = t.replace(/\€/g, "\\€"),
                t = t.replace(/\£/g, "\\£"),
                t = t.replace(/\¥/g, "\\¥"),
                t = t.replace(/\"/g, '\\"'),
                t = t.replace(/\'/g, "\\'"),
                new RegExp(t,"g")
            }
            function l() {
                n(".checkbox-element .checkbox:checked").each(( (e, t) => {
                    n(t).val("Yes")
                }
                ))
            }
            function c() {
                n("#calculator .element:hidden").each(( (e, t) => {
                    n(t).remove()
                }
                ))
            }
            function u() {
                var e, t;
                (e = document.createElement("link")).rel = "stylesheet",
                e.type = "text/css",
                e.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css",
                document.getElementsByTagName("head")[0].appendChild(e),
                (t = document.createElement("script")).type = "text/javascript",
                t.src = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/js/all.min.js",
                document.getElementsByTagName("head")[0].appendChild(t)
            }
        }
        ,
        981: e => {
            var t = function(e, t) {
                if (e)
                    try {
                        return JSON.parse(e)
                    } catch (e) {
                        return {}
                    }
            }(localStorage.getItem("cpc_configData")) || {}
              , i = new RegExp(" ","g");
            e.exports = {
                cpc_currentPrice: 0,
                miniMumCartValue: 0,
                priceMarkerDecimals: 0,
                baseVariantId: 0,
                cpc_calculatorId: "",
                cpc_waitforcartconfirmation: !0,
                baseCalculatorNewApiUrl: "https://api.custompricecalculator.com/api/v1/",
                calculatorStyling: null,
                cpc_data: {},
                cpc_configData: t,
                spaceRegex: i,
                specialCharactersRegex: /[^\w\s]/gi,
                cpc_shopUrl: "apippa",
                cpc_product_default_price: 0,
                cpc_pageLoaded: !1,
                cpc_isPreview: !1,
                cpc_productId: 0,
                cpc_metaFields: [],
                productForm: void 0,
                cpc_fasterCheckoutConfig: null,
                isError: !1,
                cdnURL: "https://cdn-assets.custompricecalculator.com/shopify",
                cpc_languageCode: "EN"
            }
        }
        ,
        392: (e, t, i) => {
            "use strict";
            i.d(t, {
                eN: () => a,
                fT: () => s,
                q6: () => n,
                qp: () => r,
                w9: () => c
            });
            var o = i(755);
            function n() {
                r() && (l(null),
                function() {
                    const e = sessionStorage.setItem;
                    sessionStorage.setItem = function(t, i) {
                        "bacurr_user_cur" === t && l(i),
                        e.apply(this, arguments)
                    }
                }())
            }
            function r() {
                var e = function(e, t) {
                    if (e)
                        try {
                            return JSON.parse(e)
                        } catch (e) {
                            return {}
                        }
                }(localStorage.getItem("cpc_configData")) || {};
                return window.baCurr && window.baCurr.config && window.baCurr.Currency && window.baCurr.Currency.rates && Object.keys(window.baCurr.Currency.rates).length > 0 && (!0 === e?.enableCurrencyConversion || o(location).attr("href").indexOf("cpc-qa") > 0 || o(location).attr("href").indexOf("unikportrait") > 0 || o(location).attr("href").indexOf("awspainting") > 0 || o(location).attr("href").indexOf("stickerprint") > 0)
            }
            function a(e, t) {
                if (r() && o(t).hasClass("cpc-priceTicker")) {
                    const i = window.baCurr.config
                      , o = u(window.baCurr.Currency.rates)
                      , n = c(null)
                      , r = bacurr$(t);
                    if (r.length) {
                        const t = r.attr("data-origMoney");
                        r.data("bacurr-origMoneyVal", t);
                        let a = o.convert(parseFloat(e), i.user_curr, n, !1);
                        return r.html(a),
                        !0
                    }
                }
                return !1
            }
            function s(e, t, i) {
                const o = u(window.baCurr.Currency.rates)
                  , n = c(i);
                return o.getConvertedAmount(parseFloat(e), t, n)
            }
            const l = function(e, t) {
                let i;
                return function() {
                    for (var t = arguments.length, o = new Array(t), n = 0; n < t; n++)
                        o[n] = arguments[n];
                    clearTimeout(i),
                    i = setTimeout(( () => e.apply(this, o)), 200)
                }
            }((function(e) {
                const t = window.baCurr.config
                  , i = u(window.baCurr.Currency.rates)
                  , n = c(e);
                o("span.money.cpc-priceTicker").each((function() {
                    ( () => {
                        let e = o(this).attr("id");
                        const r = bacurr$("#" + e);
                        if (r.length) {
                            const e = r.attr("data-origMoney");
                            r.data("bacurr-origMoneyVal", e);
                            const o = i.convert(parseFloat(e), t.user_curr, n, !1);
                            r.html(o)
                        }
                    }
                    )()
                }
                ))
            }
            ))
              , c = e => {
                const t = sessionStorage.getItem("bacurr_user_cur");
                try {
                    return e ? JSON.parse(e) : JSON.parse(t ?? null)
                } catch {
                    return JSON.parse(t ?? null)
                }
            }
              , u = e => {
                const t = {
                    USD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} USD"
                    },
                    EUR: {
                        money_format: "&euro;{{amount}}",
                        money_with_currency_format: "&euro;{{amount}} EUR"
                    },
                    GBP: {
                        money_format: "&pound;{{amount}}",
                        money_with_currency_format: "&pound;{{amount}} GBP"
                    },
                    CAD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} CAD"
                    },
                    ALL: {
                        money_format: "Lek {{amount}}",
                        money_with_currency_format: "Lek {{amount}} ALL"
                    },
                    DZD: {
                        money_format: "DA {{amount}}",
                        money_with_currency_format: "DA {{amount}} DZD"
                    },
                    AOA: {
                        money_format: "Kz{{amount}}",
                        money_with_currency_format: "Kz{{amount}} AOA"
                    },
                    ARS: {
                        money_format: "${{amount_with_comma_separator}}",
                        money_with_currency_format: "${{amount_with_comma_separator}} ARS"
                    },
                    AMD: {
                        money_format: "{{amount}} AMD",
                        money_with_currency_format: "{{amount}} AMD"
                    },
                    AWG: {
                        money_format: "Afl{{amount}}",
                        money_with_currency_format: "Afl{{amount}} AWG"
                    },
                    AUD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} AUD"
                    },
                    BBD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} Bds"
                    },
                    AZN: {
                        money_format: "m.{{amount}}",
                        money_with_currency_format: "m.{{amount}} AZN"
                    },
                    BDT: {
                        money_format: "Tk {{amount}}",
                        money_with_currency_format: "Tk {{amount}} BDT"
                    },
                    BSD: {
                        money_format: "BS${{amount}}",
                        money_with_currency_format: "BS${{amount}} BSD"
                    },
                    BHD: {
                        money_format: "{{amount}}0 BD",
                        money_with_currency_format: "{{amount}}0 BHD"
                    },
                    BYR: {
                        money_format: "Br {{amount}}",
                        money_with_currency_format: "Br {{amount}} BYR"
                    },
                    BZD: {
                        money_format: "BZ${{amount}}",
                        money_with_currency_format: "BZ${{amount}} BZD"
                    },
                    BTN: {
                        money_format: "Nu {{amount}}",
                        money_with_currency_format: "Nu {{amount}} BTN"
                    },
                    BAM: {
                        money_format: "KM {{amount_with_comma_separator}}",
                        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
                    },
                    BRL: {
                        money_format: "R$ {{amount_with_comma_separator}}",
                        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
                    },
                    BOB: {
                        money_format: "Bs{{amount_with_comma_separator}}",
                        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
                    },
                    BWP: {
                        money_format: "P{{amount}}",
                        money_with_currency_format: "P{{amount}} BWP"
                    },
                    BND: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} BND"
                    },
                    BGN: {
                        money_format: "{{amount}} BGN",
                        money_with_currency_format: "{{amount}} BGN"
                    },
                    MMK: {
                        money_format: "K{{amount}}",
                        money_with_currency_format: "K{{amount}} MMK"
                    },
                    KHR: {
                        money_format: "KHR{{amount}}",
                        money_with_currency_format: "KHR{{amount}}"
                    },
                    KYD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} KYD"
                    },
                    XAF: {
                        money_format: "FCFA{{amount}}",
                        money_with_currency_format: "FCFA{{amount}} XAF"
                    },
                    CLP: {
                        money_format: "${{amount_no_decimals}}",
                        money_with_currency_format: "${{amount_no_decimals}} CLP"
                    },
                    CNY: {
                        money_format: "&#165;{{amount}}",
                        money_with_currency_format: "&#165;{{amount}} CNY"
                    },
                    COP: {
                        money_format: "${{amount_with_comma_separator}}",
                        money_with_currency_format: "${{amount_with_comma_separator}} COP"
                    },
                    CRC: {
                        money_format: "&#8353; {{amount_with_comma_separator}}",
                        money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
                    },
                    HRK: {
                        money_format: "{{amount_with_comma_separator}} kn",
                        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
                    },
                    CZK: {
                        money_format: "{{amount_with_comma_separator}} K&#269;",
                        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
                    },
                    DKK: {
                        money_format: "{{amount_with_comma_separator}}",
                        money_with_currency_format: "kr.{{amount_with_comma_separator}}"
                    },
                    DOP: {
                        money_format: "RD$ {{amount}}",
                        money_with_currency_format: "RD$ {{amount}}"
                    },
                    XCD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "EC${{amount}}"
                    },
                    EGP: {
                        money_format: "LE {{amount}}",
                        money_with_currency_format: "LE {{amount}} EGP"
                    },
                    ETB: {
                        money_format: "Br{{amount}}",
                        money_with_currency_format: "Br{{amount}} ETB"
                    },
                    XPF: {
                        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
                        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
                    },
                    FJD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "FJ${{amount}}"
                    },
                    GMD: {
                        money_format: "D {{amount}}",
                        money_with_currency_format: "D {{amount}} GMD"
                    },
                    GHS: {
                        money_format: "GH&#8373;{{amount}}",
                        money_with_currency_format: "GH&#8373;{{amount}}"
                    },
                    GTQ: {
                        money_format: "Q{{amount}}",
                        money_with_currency_format: "{{amount}} GTQ"
                    },
                    GYD: {
                        money_format: "G${{amount}}",
                        money_with_currency_format: "${{amount}} GYD"
                    },
                    GEL: {
                        money_format: "{{amount}} GEL",
                        money_with_currency_format: "{{amount}} GEL"
                    },
                    HNL: {
                        money_format: "L {{amount}}",
                        money_with_currency_format: "L {{amount}} HNL"
                    },
                    HKD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "HK${{amount}}"
                    },
                    HUF: {
                        money_format: "{{amount_no_decimals_with_comma_separator}}",
                        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
                    },
                    ISK: {
                        money_format: "{{amount_no_decimals}} kr",
                        money_with_currency_format: "{{amount_no_decimals}} kr ISK"
                    },
                    INR: {
                        money_format: "Rs. {{amount}}",
                        money_with_currency_format: "Rs. {{amount}}"
                    },
                    IDR: {
                        money_format: "{{amount_with_comma_separator}}",
                        money_with_currency_format: "Rp {{amount_with_comma_separator}}"
                    },
                    ILS: {
                        money_format: "{{amount}} NIS",
                        money_with_currency_format: "{{amount}} NIS"
                    },
                    JMD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} JMD"
                    },
                    JPY: {
                        money_format: "&#165;{{amount_no_decimals}}",
                        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
                    },
                    JEP: {
                        money_format: "&pound;{{amount}}",
                        money_with_currency_format: "&pound;{{amount}} JEP"
                    },
                    JOD: {
                        money_format: "{{amount}}0 JD",
                        money_with_currency_format: "{{amount}}0 JOD"
                    },
                    KZT: {
                        money_format: "{{amount}} KZT",
                        money_with_currency_format: "{{amount}} KZT"
                    },
                    KES: {
                        money_format: "KSh{{amount}}",
                        money_with_currency_format: "KSh{{amount}}"
                    },
                    KWD: {
                        money_format: "{{amount}}0 KD",
                        money_with_currency_format: "{{amount}}0 KWD"
                    },
                    KGS: {
                        money_format: "KGS {{amount}}",
                        money_with_currency_format: "KGS {{amount}}"
                    },
                    LVL: {
                        money_format: "Ls {{amount}}",
                        money_with_currency_format: "Ls {{amount}} LVL"
                    },
                    LBP: {
                        money_format: "L&pound;{{amount}}",
                        money_with_currency_format: "L&pound;{{amount}} LBP"
                    },
                    LTL: {
                        money_format: "{{amount}} Lt",
                        money_with_currency_format: "{{amount}} Lt"
                    },
                    MGA: {
                        money_format: "Ar {{amount}}",
                        money_with_currency_format: "Ar {{amount}} MGA"
                    },
                    MKD: {
                        money_format: "РґРµРЅ {{amount}}",
                        money_with_currency_format: "РґРµРЅ {{amount}} MKD"
                    },
                    MOP: {
                        money_format: "MOP${{amount}}",
                        money_with_currency_format: "MOP${{amount}}"
                    },
                    MVR: {
                        money_format: "Rf{{amount}}",
                        money_with_currency_format: "Rf{{amount}} MRf"
                    },
                    MXN: {
                        money_format: "$ {{amount}}",
                        money_with_currency_format: "$ {{amount}} MXN"
                    },
                    MYR: {
                        money_format: "RM{{amount}} MYR",
                        money_with_currency_format: "RM{{amount}} MYR"
                    },
                    MUR: {
                        money_format: "Rs {{amount}}",
                        money_with_currency_format: "Rs {{amount}} MUR"
                    },
                    MDL: {
                        money_format: "{{amount}} MDL",
                        money_with_currency_format: "{{amount}} MDL"
                    },
                    MAD: {
                        money_format: "{{amount}} dh",
                        money_with_currency_format: "Dh {{amount}} MAD"
                    },
                    MNT: {
                        money_format: "{{amount_no_decimals}} &#8366",
                        money_with_currency_format: "{{amount_no_decimals}} MNT"
                    },
                    MZN: {
                        money_format: "{{amount}} Mt",
                        money_with_currency_format: "Mt {{amount}} MZN"
                    },
                    NAD: {
                        money_format: "N${{amount}}",
                        money_with_currency_format: "N${{amount}} NAD"
                    },
                    NPR: {
                        money_format: "Rs{{amount}}",
                        money_with_currency_format: "Rs{{amount}} NPR"
                    },
                    ANG: {
                        money_format: "&fnof;{{amount}}",
                        money_with_currency_format: "{{amount}} NA&fnof;"
                    },
                    NZD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} NZD"
                    },
                    NIO: {
                        money_format: "C${{amount}}",
                        money_with_currency_format: "C${{amount}} NIO"
                    },
                    NGN: {
                        money_format: "&#8358;{{amount}}",
                        money_with_currency_format: "&#8358;{{amount}} NGN"
                    },
                    NOK: {
                        money_format: "kr {{amount_with_comma_separator}}",
                        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
                    },
                    OMR: {
                        money_format: "{{amount_with_comma_separator}} OMR",
                        money_with_currency_format: "{{amount_with_comma_separator}} OMR"
                    },
                    PKR: {
                        money_format: "Rs.{{amount}}",
                        money_with_currency_format: "Rs.{{amount}} PKR"
                    },
                    PGK: {
                        money_format: "K {{amount}}",
                        money_with_currency_format: "K {{amount}} PGK"
                    },
                    PYG: {
                        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
                        money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
                    },
                    PEN: {
                        money_format: "S/. {{amount}}",
                        money_with_currency_format: "S/. {{amount}} PEN"
                    },
                    PHP: {
                        money_format: "&#8369;{{amount}}",
                        money_with_currency_format: "&#8369;{{amount}} PHP"
                    },
                    PLN: {
                        money_format: "{{amount_with_comma_separator}} zl",
                        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
                    },
                    QAR: {
                        money_format: "QAR {{amount_with_comma_separator}}",
                        money_with_currency_format: "QAR {{amount_with_comma_separator}}"
                    },
                    RON: {
                        money_format: "{{amount_with_comma_separator}} lei",
                        money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
                    },
                    RUB: {
                        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
                        money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
                    },
                    RWF: {
                        money_format: "{{amount_no_decimals}} RF",
                        money_with_currency_format: "{{amount_no_decimals}} RWF"
                    },
                    WST: {
                        money_format: "WS$ {{amount}}",
                        money_with_currency_format: "WS$ {{amount}} WST"
                    },
                    SAR: {
                        money_format: "{{amount}} SR",
                        money_with_currency_format: "{{amount}} SAR"
                    },
                    STD: {
                        money_format: "Db {{amount}}",
                        money_with_currency_format: "Db {{amount}} STD"
                    },
                    RSD: {
                        money_format: "{{amount}} RSD",
                        money_with_currency_format: "{{amount}} RSD"
                    },
                    SCR: {
                        money_format: "Rs {{amount}}",
                        money_with_currency_format: "Rs {{amount}} SCR"
                    },
                    SGD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} SGD"
                    },
                    SYP: {
                        money_format: "S&pound;{{amount}}",
                        money_with_currency_format: "S&pound;{{amount}} SYP"
                    },
                    ZAR: {
                        money_format: "R {{amount}}",
                        money_with_currency_format: "R {{amount}} ZAR"
                    },
                    KRW: {
                        money_format: "&#8361;{{amount_no_decimals}}",
                        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
                    },
                    LKR: {
                        money_format: "Rs {{amount}}",
                        money_with_currency_format: "Rs {{amount}} LKR"
                    },
                    SEK: {
                        money_format: "{{amount_no_decimals}} kr",
                        money_with_currency_format: "{{amount_no_decimals}} kr SEK"
                    },
                    CHF: {
                        money_format: "SFr. {{amount}}",
                        money_with_currency_format: "SFr. {{amount}} CHF"
                    },
                    TWD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} TWD"
                    },
                    THB: {
                        money_format: "{{amount}} &#xe3f;",
                        money_with_currency_format: "{{amount}} &#xe3f; THB"
                    },
                    TZS: {
                        money_format: "{{amount}} TZS",
                        money_with_currency_format: "{{amount}} TZS"
                    },
                    TTD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} TTD"
                    },
                    TND: {
                        money_format: "{{amount}}",
                        money_with_currency_format: "{{amount}} DT"
                    },
                    TRY: {
                        money_format: "{{amount}}TL",
                        money_with_currency_format: "{{amount}}TL"
                    },
                    UGX: {
                        money_format: "Ush {{amount_no_decimals}}",
                        money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
                    },
                    UAH: {
                        money_format: "в‚ґ{{amount}}",
                        money_with_currency_format: "в‚ґ{{amount}} UAH"
                    },
                    AED: {
                        money_format: "Dhs. {{amount}}",
                        money_with_currency_format: "Dhs. {{amount}} AED"
                    },
                    UYU: {
                        money_format: "${{amount_with_comma_separator}}",
                        money_with_currency_format: "${{amount_with_comma_separator}} UYU"
                    },
                    VUV: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}}VT"
                    },
                    VEF: {
                        money_format: "Bs. {{amount_with_comma_separator}}",
                        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
                    },
                    VND: {
                        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
                        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
                    },
                    XBT: {
                        money_format: "{{amount_no_decimals}} BTC",
                        money_with_currency_format: "{{amount_no_decimals}} BTC"
                    },
                    XOF: {
                        money_format: "CFA{{amount}}",
                        money_with_currency_format: "CFA{{amount}} XOF"
                    },
                    ZMW: {
                        money_format: "K{{amount_no_decimals_with_comma_separator}}",
                        money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
                    }
                };
                function i(e, t, i, o) {
                    if (t = void 0 === t ? 2 : t,
                    i = void 0 === i ? "," : i,
                    o = void 0 === o ? "." : o,
                    isNaN(e) || null == e)
                        return 0;
                    let n = Number(e).toFixed(t).split(".");
                    return n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + i) + (n[1] ? o + n[1] : "")
                }
                function o(e) {
                    let i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    const o = t[e] || {
                        money_format: "{{amount}}",
                        money_with_currency_format: "{{amount}} " + e
                    };
                    return i ? o.money_with_currency_format : o.money_format
                }
                function n(e, t) {
                    const n = o(t, arguments.length > 2 && void 0 !== arguments[2] && arguments[2])
                      , r = ["KWD", "JOD", "OMR", "BHD"].includes(t) ? 3 : 2;
                    let a = n.split("{{").pop().split("}}")[0];
                    var s = "";
                    switch (a) {
                    case "amount":
                        s = i(e, r);
                        break;
                    case "amount_no_decimals":
                        s = i(e, 0);
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        s = i(e, 0, ".", ",");
                        break;
                    case "amount_with_comma_separator":
                        s = i(e, r, ".", ",");
                        break;
                    default:
                        s = i(e, r, ",", ".")
                    }
                    return n.replace("{{" + a + "}}", s)
                }
                function r(t, i, o) {
                    if (!e || !e[i] || !e[o])
                        throw new Error(`Currency rate not found for ${i} or ${o}`);
                    const n = t * (e[i] / e[o]);
                    return console.log(`Converted ${t} from ${i} to ${o}:`, n),
                    n
                }
                return {
                    getFormat: o,
                    formatCurrency: n,
                    convert: function(e, t, i) {
                        let o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                        const a = r(e, t, i);
                        return console.log("Converted amount:", a),
                        n(a, i, o)
                    },
                    getConvertedAmount: r
                }
            }
        }
        ,
        286: (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
            "use strict";
            __webpack_require__.d(__webpack_exports__, {
                Q8: () => ProcessConditionalElements,
                cD: () => UpdatePrice,
                iO: () => PriceUpdation,
                kg: () => ChangeEvent,
                rd: () => firstLoad
            });
            var _global_variables__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(981)
              , _global_variables__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_global_variables__WEBPACK_IMPORTED_MODULE_0__)
              , _common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106)
              , _everything_else__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(196)
              , _nova_currency__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(392)
              , jQuery = __webpack_require__(755);
            function firstLoad() {
                let e;
                jQuery('form[action*="/cart/add"]').each((function(t, i) {
                    void 0 === e && i.querySelector('[type="submit"]') && (e = i),
                    void 0 === e && i.querySelector('button[class*="cart"]') && (e = i)
                }
                ));
                var t = e.querySelector("input[type='radio']:checked")
                  , i = e.querySelector("select[data-showimage='true']");
                null != t ? imageddlChange(t) : null != i && imageddlChange(i),
                ProcessConditionalElements(),
                UpdatePrice(),
                (0,
                _nova_currency__WEBPACK_IMPORTED_MODULE_3__.q6)(),
                (0,
                _common_utils__WEBPACK_IMPORTED_MODULE_1__.rQ)()
            }
            function ChangeEvent(e) {
                "ImageSelector" === e && imageddlChange(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null),
                ProcessConditionalElements(),
                UpdatePrice()
            }
            function imageddlChange(e) {
                let t = jQuery(e).is(":radio");
                var i = jQuery(e).data("showimage");
                !0 === t ? !0 === i && UpdateProductImage(jQuery(e).data("imgsrc")) : !0 === i && UpdateProductImage(jQuery(e).children("option:selected").data("imgsrc"))
            }
            function UpdateProductImage(e) {
                var t = document.querySelectorAll("[class^=product]>img");
                let i = !1
                  , o = !1;
                t.forEach((t => {
                    if (!1 === jQuery(t).is(":hidden"))
                        if (!1 === i) {
                            var n = t.getAttribute("calcset")
                              , r = t.getAttribute("data-index")
                              , a = null === r || "1" === r
                              , s = window.location.host + "/cdn";
                            (t.src.includes("cdn.shopify.com") || t.srcset.includes("cdn.shopify.com") || t.src.includes("myshopify.com") || t.srcset.includes("myshopify.com") || t.src.includes(s) || t.srcset.includes(s) || "true" === n) && !0 === a && (i = !0,
                            t.setAttribute("src", e),
                            t.setAttribute("calcset", !0),
                            t.setAttribute("data-srcset", ""),
                            t.setAttribute("data-zoom", e),
                            t.setAttribute("srcset", ""))
                        } else if (!0 === i && !1 === o) {
                            var l = document.querySelector('img[role="presentation"]');
                            null != l && (o = !0,
                            l.setAttribute("src", e),
                            l.setAttribute("calcset", !0),
                            l.setAttribute("data-zoom", e),
                            l.setAttribute("data-srcset", ""),
                            l.setAttribute("srcset", ""))
                        }
                }
                ))
            }
            function ProcessConditionalElements() {
                jQuery(".element").each(( (e, t) => {
                    let i = jQuery(t).data("conditionalelement")
                      , o = jQuery(t).data("conditionalelementvalue");
                    if (null != i) {
                        var n = (0,
                        _common_utils__WEBPACK_IMPORTED_MODULE_1__.nP)(i);
                        let e = document.querySelector('select[data-identifier="' + n + '"]')
                          , r = document.querySelector('input[type="radio"][data-identifier="' + n + '"]:checked')
                          , a = document.querySelector('input[type="checkbox"][data-identifier="' + n + '"]')
                          , s = null
                          , l = !1;
                        null !== e ? (s = jQuery(e).val(),
                        l = jQuery(e).is(":hidden")) : null !== r ? (s = jQuery(r).val(),
                        l = jQuery(r).is(":hidden")) : null !== a && (s = !0 === jQuery(a).is(":checked") ? "Checked" : "Unchecked",
                        l = jQuery(a).is(":hidden")),
                        null !== s && (s == o && !1 === l ? (jQuery(t).show(),
                        jQuery(t).find(".calc-prop").show()) : (jQuery(t).hide(),
                        jQuery(t).find(".calc-prop").hide()))
                    }
                }
                ))
            }
            function UpdatePrice() {
                var formulaBeforeEval = "";
                let curr = 10;
                if(Shopify.country == 'DE'){
                  curr = 0;
                }
                try {
                    var formula = _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_data.Formula;
                    EvaluateFormulaElements(),
                    formula = FormulaParser(formula),
                    "NaN" === formula && (formula = _global_variables__WEBPACK_IMPORTED_MODULE_0__.miniMumCartValue),
                    formulaBeforeEval = formula;
                    var evaluatedNewPrice = eval(formula)
                      , finalValue = Math.max(_global_variables__WEBPACK_IMPORTED_MODULE_0__.miniMumCartValue, evaluatedNewPrice);
                    finalValue = finalValue+((finalValue/100)*curr),
                    jQuery("#priceTicker").attr("data-origMoney", finalValue),
                    finalValue == _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_currentPrice || isNaN(finalValue) || (jQuery("#priceTicker").prop("Counter", _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_currentPrice).animate({
                        Counter: finalValue
                    }, {
                        duration: 200,
                        easing: "swing",
                        step: function(e) {
                            const t = (0,
                            _common_utils__WEBPACK_IMPORTED_MODULE_1__.tQ)(Number(e), +_global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_configData.thousandSeperator, +_global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_configData.decimalSeperator);
                            (0,
                            _nova_currency__WEBPACK_IMPORTED_MODULE_3__.eN)(Number(e), "#priceTicker") || jQuery(this).html(t)
                        }
                    }),
                    _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_currentPrice = finalValue),
                    EvaluateCalculationElements()
                } catch (e) {
                    var msg = "FormulaBeforeEval = " + formulaBeforeEval;
                    (0,
                    _common_utils__WEBPACK_IMPORTED_MODULE_1__.fJ)(e, msg)
                }
            }
            function EvaluateFormulaElements() {
                jQuery(".lookup-element-with-formula").each(( (d, elem) => {
                    let elem_formula = jQuery(elem).data("formula")
                      , elem_formula_minvalue = jQuery(elem).data("minvalue")
                      , parsedFormula = FormulaParser(elem_formula.toString())
                      , evaluatedValue = eval(parsedFormula)
                      , elem_finalValue = Math.max(elem_formula_minvalue, evaluatedValue);
                    elem.setAttribute("value", elem_finalValue)
                }
                ))
            }
            function EvaluateCalculationElements() {
                jQuery(".calculation-element").each(( (d, elem) => {
                    let elem_formula = jQuery(elem).data("formula")
                      , elem_formula_minvalue = jQuery(elem).data("minvalue")
                      , elem_current_value = jQuery(elem).data("val")
                      , elem_decimals = jQuery(elem).data("decimals")
                      , element_name = jQuery(elem).data("element_name")
                      , parsedFormula = FormulaParser(elem_formula.toString())
                      , evaluatedValue = eval(parsedFormula)
                      , elem_finalValue = Math.max(elem_formula_minvalue, evaluatedValue);
                    jQuery(elem).attr("data-origMoney", elem_finalValue),
                    elem_finalValue == elem_current_value || isNaN(elem_finalValue) || (jQuery(elem).prop("Counter", elem_current_value).animate({
                        Counter: elem_finalValue
                    }, {
                        duration: 200,
                        easing: "swing",
                        step: function(e) {
                            let t = Number(e).toFixed(elem_decimals);
                            (0,
                            _nova_currency__WEBPACK_IMPORTED_MODULE_3__.eN)(Number(e), elem) || jQuery(elem).html(t)
                        }
                    }),
                    jQuery(elem).data("val", elem_finalValue),
                    element_name = element_name.replace(_global_variables__WEBPACK_IMPORTED_MODULE_0__.spaceRegex, "_"),
                    element_name = element_name.replace(_global_variables__WEBPACK_IMPORTED_MODULE_0__.specialCharactersRegex, ""),
                    jQuery("#calculation_inp_" + element_name).val(Number(elem_finalValue).toFixed(elem_decimals)),
                    elem_current_value = elem_finalValue)
                }
                ))
            }
            function FormulaParser(e) {
                try {
                    e = e.toLowerCase();
                    var t = new RegExp("math.","g");
                    e = (e = e ? e.toString().replaceAll(t, "Math.") : "") ? e.toString().replaceAll("shopify_product_price", _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_product_default_price) : "",
                    _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_metaFields.forEach((t => {
                        e = e ? e.toString().replaceAll("shopify_meta_" + t.key, t.value) : ""
                    }
                    ));
                    var i = new RegExp("shopify_meta_(.*?)([*/+-]|$)","g");
                    let l;
                    do {
                        if (l = i.exec(e),
                        l && l.length > 1) {
                            var o = l[1];
                            e = e ? e.toString().replaceAll("shopify_meta_" + o, 1) : "",
                            console.log("meta_variable_name", o)
                        }
                    } while (l);
                    var n = jQuery(jQuery(".calc-prop").get());
                    n = (n = jQuery(jQuery(".calc-prop").get())).sort(( (e, t) => void 0 === jQuery(e).data("identifier") ? 1 : void 0 === jQuery(t).data("identifier") || jQuery(e).data("identifier").length > jQuery(t).data("identifier").length ? -1 : 1));
                    var r = {};
                    for (var a in n.each(( (t, i) => {
                        let o = jQuery(i).is(":hidden")
                          , n = jQuery(i).is(":checkbox")
                          , a = jQuery(i).is(":radio");
                        var s = jQuery(i).prop("nodeName");
                        let l = jQuery(i).data("identifier")
                          , c = jQuery(i).data("rangeenabled")
                          , u = jQuery(i).data("lengthtoggle")
                          , d = void 0 !== jQuery(i).data("lookup")
                          , p = !!d && !0 === jQuery(i).data("isformula");
                        if (void 0 !== l && void 0 !== l) {
                            var h = (0,
                            _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(l);
                            if (!1 === o || !0 === p && "none" != jQuery(i).css("display")) {
                                if ("SELECT" == s) {
                                    let t = jQuery(i).children("option:selected").data("val");
                                    e = e.replace(h, t)
                                } else if ("INPUT" == s && !0 === c) {
                                    let t = jQuery(i).val();
                                    t = parseFloat(t);
                                    var m = _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_data.Elements;
                                    let o = t;
                                    m.forEach((e => {
                                        e.Identifier === l && e.options.forEach((e => {
                                            t >= parseFloat(e.start) && t <= parseFloat(e.end) && (o = parseFloat(e.value))
                                        }
                                        ))
                                    }
                                    ));
                                    let n = l + "[ActualValue]";
                                    var f = (0,
                                    _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(n);
                                    e = e.replace(f, t),
                                    o = parseFloat(o, 10),
                                    e = e.replace(h, o)
                                }
                                if ("TEXTAREA" == s) {
                                    let t = jQuery(i).val();
                                    u || (t = t.replace(/\s/g, ""));
                                    let o = t.length
                                      , n = l + "[length]";
                                    var g = (0,
                                    _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(n);
                                    e = e.replace(g, o)
                                } else if (!0 === n) {
                                    let t = jQuery(i).is(":checked")
                                      , o = jQuery(i).data("checkedvalue")
                                      , n = jQuery(i).data("uncheckedvalue");
                                    var y = t ? o : n;
                                    e = e.replace(h, y)
                                } else if (!0 === a) {
                                    if (!0 === jQuery(i).is(":checked")) {
                                        let t = jQuery(i).data("val");
                                        e = e.replace(h, t)
                                    }
                                } else if (!0 === d) {
                                    let e = jQuery(i).data("lookupelementindex")
                                      , t = jQuery(i).data("identifier")
                                      , o = jQuery(i).data("calcname");
                                    if (void 0 === r[t]) {
                                        var $ = {
                                            elementName: t,
                                            input1_label: "",
                                            input1: 0,
                                            input2_label: "",
                                            input2: 0
                                        };
                                        1 === e ? ($.input1 = parseFloat(jQuery(i).val(), 10),
                                        $.input1_label = o) : 2 === e && ($.input2 = parseFloat(jQuery(i).val(), 10),
                                        $.input2_label = o),
                                        r[t] = $
                                    } else {
                                        let n = r[t];
                                        1 === e ? (n.input1 = jQuery(i).val(),
                                        n.input1_label = o) : 2 === e && (n.input2 = jQuery(i).val(),
                                        n.input2_label = o)
                                    }
                                } else {
                                    let t = jQuery(i).val();
                                    t = parseFloat(t, 10),
                                    e = e.replace(h, t)
                                }
                            } else {
                                var b = _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_data.Elements.filter((function(e, t) {
                                    if (e.Name === l)
                                        return e
                                }
                                ));
                                if (b.length > 0) {
                                    let t = b[0].value_when_not_displayed;
                                    if (void 0 === t && (t = 1),
                                    "INPUT" == s) {
                                        let i = l + "[ActualValue]";
                                        f = (0,
                                        _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(i),
                                        e = e.replace(f, t)
                                    }
                                    e = e.replace(h, t)
                                }
                                if (!0 === d) {
                                    let t = jQuery(i).data("lookupelementindex")
                                      , o = jQuery(i).data("identifier")
                                      , n = jQuery(i).data("calcname")
                                      , r = _global_variables__WEBPACK_IMPORTED_MODULE_0__.cpc_data.Elements.filter((function(e, t) {
                                        if (e.Name === o)
                                            return e
                                    }
                                    ));
                                    if (r.length > 0) {
                                        let i = o + "[" + n + "]";
                                        if (h = (0,
                                        _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(i),
                                        e = e.replace(h, 0),
                                        2 === t) {
                                            let t = r[0].value_when_not_displayed;
                                            void 0 === t && (t = 1),
                                            h = (0,
                                            _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(o),
                                            t = parseFloat(t, 10),
                                            e = e.replace(h, t)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    )),
                    r) {
                        let t = r[a];
                        var s = (0,
                        _everything_else__WEBPACK_IMPORTED_MODULE_2__.UN)(a);
                        let i = t.elementName + "[" + t.input1_label + "]"
                          , o = t.elementName + "[" + t.input2_label + "]"
                          , n = (0,
                        _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(i);
                        e = e.replace(n, t.input1),
                        n = (0,
                        _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(o),
                        e = e.replace(n, t.input2);
                        let l = s.sheet_data.input1_range.length - 1
                          , c = s.sheet_data.input2_range.length - 1;
                        for (let e = 0; e < s.sheet_data.input1_range.length - 1; e++)
                            if (parseFloat(t.input1) >= parseFloat(s.sheet_data.input1_range[e]) && parseFloat(t.input1) < parseFloat(s.sheet_data.input1_range[e + 1])) {
                                l = e;
                                break
                            }
                        for (let e = 0; e < s.sheet_data.input2_range.length - 1; e++)
                            if (parseFloat(t.input2) >= parseFloat(s.sheet_data.input2_range[e]) && parseFloat(t.input2) < parseFloat(s.sheet_data.input2_range[e + 1])) {
                                c = e;
                                break
                            }
                        0 === l && parseFloat(t.input1) > parseFloat(s.sheet_data.input1_range[s.sheet_data.input1_range.length - 1]) && (l = s.sheet_data.input1_range.length - 1),
                        0 === c && parseFloat(t.input2) > parseFloat(s.sheet_data.input2_range[s.sheet_data.input2_range.length - 1]) && (c = s.sheet_data.input2_range.length - 1);
                        let u = s.sheet_data.data_lookup[c][l];
                        n = (0,
                        _everything_else__WEBPACK_IMPORTED_MODULE_2__.nC)(a),
                        e = e.replace(n, u)
                    }
                    return e
                } catch (e) {
                    (0,
                    _common_utils__WEBPACK_IMPORTED_MODULE_1__.fJ)(e)
                }
            }
            function debounce(e, t, i) {
                var o;
                return function() {
                    var n = this
                      , r = arguments
                      , a = i && !o;
                    clearTimeout(o),
                    o = setTimeout((function() {
                        o = null,
                        i || e.apply(n, r)
                    }
                    ), t),
                    a && e.apply(n, r)
                }
            }
            const PriceUpdation = debounce((function(e) {
                UpdatePrice()
            }
            ), 500)
        }
        ,
        400: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.extend(e.expr.pseudos, {
                        data: e.expr.createPseudo((function(t) {
                            return function(i) {
                                return !!e.data(i, t)
                            }
                        }
                        ))
                    })
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        64: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.fn.extend({
                        disableSelection: (t = "onselectstart"in document.createElement("div") ? "selectstart" : "mousedown",
                        function() {
                            return this.on(t + ".ui-disableSelection", (function(e) {
                                e.preventDefault()
                            }
                            ))
                        }
                        ),
                        enableSelection: function() {
                            return this.off(".ui-disableSelection")
                        }
                    });
                    var t
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        436: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.ui.focusable = function(t, i) {
                        var o, n, r, a, s, l = t.nodeName.toLowerCase();
                        return "area" === l ? (n = (o = t.parentNode).name,
                        !(!t.href || !n || "map" !== o.nodeName.toLowerCase()) && (r = e("img[usemap='#" + n + "']")).length > 0 && r.is(":visible")) : (/^(input|select|textarea|button|object)$/.test(l) ? (a = !t.disabled) && (s = e(t).closest("fieldset")[0]) && (a = !s.disabled) : a = "a" === l && t.href || i,
                        a && e(t).is(":visible") && "visible" === e(t).css("visibility"))
                    }
                    ,
                    e.extend(e.expr.pseudos, {
                        focusable: function(t) {
                            return e.ui.focusable(t, null != e.attr(t, "tabindex"))
                        }
                    }),
                    e.ui.focusable
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        808: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.ui.formResetMixin = {
                        _formResetHandler: function() {
                            var t = e(this);
                            setTimeout((function() {
                                var i = t.data("ui-form-reset-instances");
                                e.each(i, (function() {
                                    this.refresh()
                                }
                                ))
                            }
                            ))
                        },
                        _bindFormResetHandler: function() {
                            if (this.form = e(this.element.prop("form")),
                            this.form.length) {
                                var t = this.form.data("ui-form-reset-instances") || [];
                                t.length || this.form.on("reset.ui-form-reset", this._formResetHandler),
                                t.push(this),
                                this.form.data("ui-form-reset-instances", t)
                            }
                        },
                        _unbindFormResetHandler: function() {
                            if (this.form.length) {
                                var t = this.form.data("ui-form-reset-instances");
                                t.splice(e.inArray(this, t), 1),
                                t.length ? this.form.data("ui-form-reset-instances", t) : this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")
                            }
                        }
                    }
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        53: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.ui.keyCode = {
                        BACKSPACE: 8,
                        COMMA: 188,
                        DELETE: 46,
                        DOWN: 40,
                        END: 35,
                        ENTER: 13,
                        ESCAPE: 27,
                        HOME: 36,
                        LEFT: 37,
                        PAGE_DOWN: 34,
                        PAGE_UP: 33,
                        PERIOD: 190,
                        RIGHT: 39,
                        SPACE: 32,
                        TAB: 9,
                        UP: 38
                    }
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        575: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.fn.labels = function() {
                        var e, t, i, o, n;
                        return this.length ? this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (o = this.eq(0).parents("label"),
                        (i = this.attr("id")) && (n = (e = this.eq(0).parents().last()).add(e.length ? e.siblings() : this.siblings()),
                        t = "label[for='" + CSS.escape(i) + "']",
                        o = o.add(n.find(t).addBack(t))),
                        this.pushStack(o)) : this.pushStack([])
                    }
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        624: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                o = function(e) {
                    return e.ui.plugin = {
                        add: function(t, i, o) {
                            var n, r = e.ui[t].prototype;
                            for (n in o)
                                r.plugins[n] = r.plugins[n] || [],
                                r.plugins[n].push([i, o[n]])
                        },
                        call: function(e, t, i, o) {
                            var n, r = e.plugins[t];
                            if (r && (o || e.element[0].parentNode && 11 !== e.element[0].parentNode.nodeType))
                                for (n = 0; n < r.length; n++)
                                    e.options[r[n][0]] && r[n][1].apply(e.element, i)
                        }
                    }
                }
                ,
                void 0 === (r = o.apply(t, n)) || (e.exports = r)
            }()
        }
        ,
        822: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                o = function(e) {
                    return function() {
                        var t, i = Math.max, o = Math.abs, n = /left|center|right/, r = /top|center|bottom/, a = /[\+\-]\d+(\.[\d]+)?%?/, s = /^\w+/, l = /%$/, c = e.fn.position;
                        function u(e, t, i) {
                            return [parseFloat(e[0]) * (l.test(e[0]) ? t / 100 : 1), parseFloat(e[1]) * (l.test(e[1]) ? i / 100 : 1)]
                        }
                        function d(t, i) {
                            return parseInt(e.css(t, i), 10) || 0
                        }
                        function p(e) {
                            return null != e && e === e.window
                        }
                        e.position = {
                            scrollbarWidth: function() {
                                if (void 0 !== t)
                                    return t;
                                var i, o, n = e("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>"), r = n.children()[0];
                                return e("body").append(n),
                                i = r.offsetWidth,
                                n.css("overflow", "scroll"),
                                i === (o = r.offsetWidth) && (o = n[0].clientWidth),
                                n.remove(),
                                t = i - o
                            },
                            getScrollInfo: function(t) {
                                var i = t.isWindow || t.isDocument ? "" : t.element.css("overflow-x")
                                  , o = t.isWindow || t.isDocument ? "" : t.element.css("overflow-y")
                                  , n = "scroll" === i || "auto" === i && t.width < t.element[0].scrollWidth;
                                return {
                                    width: "scroll" === o || "auto" === o && t.height < t.element[0].scrollHeight ? e.position.scrollbarWidth() : 0,
                                    height: n ? e.position.scrollbarWidth() : 0
                                }
                            },
                            getWithinInfo: function(t) {
                                var i = e(t || window)
                                  , o = p(i[0])
                                  , n = !!i[0] && 9 === i[0].nodeType;
                                return {
                                    element: i,
                                    isWindow: o,
                                    isDocument: n,
                                    offset: o || n ? {
                                        left: 0,
                                        top: 0
                                    } : e(t).offset(),
                                    scrollLeft: i.scrollLeft(),
                                    scrollTop: i.scrollTop(),
                                    width: i.outerWidth(),
                                    height: i.outerHeight()
                                }
                            }
                        },
                        e.fn.position = function(t) {
                            if (!t || !t.of)
                                return c.apply(this, arguments);
                            var l, h, m, f, g, y, $, b, v = "string" == typeof (t = e.extend({}, t)).of ? e(document).find(t.of) : e(t.of), x = e.position.getWithinInfo(t.within), w = e.position.getScrollInfo(x), S = (t.collision || "flip").split(" "), _ = {};
                            return y = 9 === (b = ($ = v)[0]).nodeType ? {
                                width: $.width(),
                                height: $.height(),
                                offset: {
                                    top: 0,
                                    left: 0
                                }
                            } : p(b) ? {
                                width: $.width(),
                                height: $.height(),
                                offset: {
                                    top: $.scrollTop(),
                                    left: $.scrollLeft()
                                }
                            } : b.preventDefault ? {
                                width: 0,
                                height: 0,
                                offset: {
                                    top: b.pageY,
                                    left: b.pageX
                                }
                            } : {
                                width: $.outerWidth(),
                                height: $.outerHeight(),
                                offset: $.offset()
                            },
                            v[0].preventDefault && (t.at = "left top"),
                            h = y.width,
                            m = y.height,
                            f = y.offset,
                            g = e.extend({}, f),
                            e.each(["my", "at"], (function() {
                                var e, i, o = (t[this] || "").split(" ");
                                1 === o.length && (o = n.test(o[0]) ? o.concat(["center"]) : r.test(o[0]) ? ["center"].concat(o) : ["center", "center"]),
                                o[0] = n.test(o[0]) ? o[0] : "center",
                                o[1] = r.test(o[1]) ? o[1] : "center",
                                e = a.exec(o[0]),
                                i = a.exec(o[1]),
                                _[this] = [e ? e[0] : 0, i ? i[0] : 0],
                                t[this] = [s.exec(o[0])[0], s.exec(o[1])[0]]
                            }
                            )),
                            1 === S.length && (S[1] = S[0]),
                            "right" === t.at[0] ? g.left += h : "center" === t.at[0] && (g.left += h / 2),
                            "bottom" === t.at[1] ? g.top += m : "center" === t.at[1] && (g.top += m / 2),
                            l = u(_.at, h, m),
                            g.left += l[0],
                            g.top += l[1],
                            this.each((function() {
                                var n, r, a = e(this), s = a.outerWidth(), c = a.outerHeight(), p = d(this, "marginLeft"), y = d(this, "marginTop"), $ = s + p + d(this, "marginRight") + w.width, b = c + y + d(this, "marginBottom") + w.height, k = e.extend({}, g), C = u(_.my, a.outerWidth(), a.outerHeight());
                                "right" === t.my[0] ? k.left -= s : "center" === t.my[0] && (k.left -= s / 2),
                                "bottom" === t.my[1] ? k.top -= c : "center" === t.my[1] && (k.top -= c / 2),
                                k.left += C[0],
                                k.top += C[1],
                                n = {
                                    marginLeft: p,
                                    marginTop: y
                                },
                                e.each(["left", "top"], (function(i, o) {
                                    e.ui.position[S[i]] && e.ui.position[S[i]][o](k, {
                                        targetWidth: h,
                                        targetHeight: m,
                                        elemWidth: s,
                                        elemHeight: c,
                                        collisionPosition: n,
                                        collisionWidth: $,
                                        collisionHeight: b,
                                        offset: [l[0] + C[0], l[1] + C[1]],
                                        my: t.my,
                                        at: t.at,
                                        within: x,
                                        elem: a
                                    })
                                }
                                )),
                                t.using && (r = function(e) {
                                    var n = f.left - k.left
                                      , r = n + h - s
                                      , l = f.top - k.top
                                      , u = l + m - c
                                      , d = {
                                        target: {
                                            element: v,
                                            left: f.left,
                                            top: f.top,
                                            width: h,
                                            height: m
                                        },
                                        element: {
                                            element: a,
                                            left: k.left,
                                            top: k.top,
                                            width: s,
                                            height: c
                                        },
                                        horizontal: r < 0 ? "left" : n > 0 ? "right" : "center",
                                        vertical: u < 0 ? "top" : l > 0 ? "bottom" : "middle"
                                    };
                                    h < s && o(n + r) < h && (d.horizontal = "center"),
                                    m < c && o(l + u) < m && (d.vertical = "middle"),
                                    i(o(n), o(r)) > i(o(l), o(u)) ? d.important = "horizontal" : d.important = "vertical",
                                    t.using.call(this, e, d)
                                }
                                ),
                                a.offset(e.extend(k, {
                                    using: r
                                }))
                            }
                            ))
                        }
                        ,
                        e.ui.position = {
                            fit: {
                                left: function(e, t) {
                                    var o, n = t.within, r = n.isWindow ? n.scrollLeft : n.offset.left, a = n.width, s = e.left - t.collisionPosition.marginLeft, l = r - s, c = s + t.collisionWidth - a - r;
                                    t.collisionWidth > a ? l > 0 && c <= 0 ? (o = e.left + l + t.collisionWidth - a - r,
                                    e.left += l - o) : e.left = c > 0 && l <= 0 ? r : l > c ? r + a - t.collisionWidth : r : l > 0 ? e.left += l : c > 0 ? e.left -= c : e.left = i(e.left - s, e.left)
                                },
                                top: function(e, t) {
                                    var o, n = t.within, r = n.isWindow ? n.scrollTop : n.offset.top, a = t.within.height, s = e.top - t.collisionPosition.marginTop, l = r - s, c = s + t.collisionHeight - a - r;
                                    t.collisionHeight > a ? l > 0 && c <= 0 ? (o = e.top + l + t.collisionHeight - a - r,
                                    e.top += l - o) : e.top = c > 0 && l <= 0 ? r : l > c ? r + a - t.collisionHeight : r : l > 0 ? e.top += l : c > 0 ? e.top -= c : e.top = i(e.top - s, e.top)
                                }
                            },
                            flip: {
                                left: function(e, t) {
                                    var i, n, r = t.within, a = r.offset.left + r.scrollLeft, s = r.width, l = r.isWindow ? r.scrollLeft : r.offset.left, c = e.left - t.collisionPosition.marginLeft, u = c - l, d = c + t.collisionWidth - s - l, p = "left" === t.my[0] ? -t.elemWidth : "right" === t.my[0] ? t.elemWidth : 0, h = "left" === t.at[0] ? t.targetWidth : "right" === t.at[0] ? -t.targetWidth : 0, m = -2 * t.offset[0];
                                    u < 0 ? ((i = e.left + p + h + m + t.collisionWidth - s - a) < 0 || i < o(u)) && (e.left += p + h + m) : d > 0 && ((n = e.left - t.collisionPosition.marginLeft + p + h + m - l) > 0 || o(n) < d) && (e.left += p + h + m)
                                },
                                top: function(e, t) {
                                    var i, n, r = t.within, a = r.offset.top + r.scrollTop, s = r.height, l = r.isWindow ? r.scrollTop : r.offset.top, c = e.top - t.collisionPosition.marginTop, u = c - l, d = c + t.collisionHeight - s - l, p = "top" === t.my[1] ? -t.elemHeight : "bottom" === t.my[1] ? t.elemHeight : 0, h = "top" === t.at[1] ? t.targetHeight : "bottom" === t.at[1] ? -t.targetHeight : 0, m = -2 * t.offset[1];
                                    u < 0 ? ((n = e.top + p + h + m + t.collisionHeight - s - a) < 0 || n < o(u)) && (e.top += p + h + m) : d > 0 && ((i = e.top - t.collisionPosition.marginTop + p + h + m - l) > 0 || o(i) < d) && (e.top += p + h + m)
                                }
                            },
                            flipfit: {
                                left: function() {
                                    e.ui.position.flip.left.apply(this, arguments),
                                    e.ui.position.fit.left.apply(this, arguments)
                                },
                                top: function() {
                                    e.ui.position.flip.top.apply(this, arguments),
                                    e.ui.position.fit.top.apply(this, arguments)
                                }
                            }
                        }
                    }(),
                    e.ui.position
                }
                ,
                void 0 === (r = o.apply(t, n)) || (e.exports = r)
            }()
        }
        ,
        464: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.fn.scrollParent = function(t) {
                        var i = this.css("position")
                          , o = "absolute" === i
                          , n = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/
                          , r = this.parents().filter((function() {
                            var t = e(this);
                            return (!o || "static" !== t.css("position")) && n.test(t.css("overflow") + t.css("overflow-y") + t.css("overflow-x"))
                        }
                        )).eq(0);
                        return "fixed" !== i && r.length ? r : e(this[0].ownerDocument || document)
                    }
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        614: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592), i(436)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.extend(e.expr.pseudos, {
                        tabbable: function(t) {
                            var i = e.attr(t, "tabindex")
                              , o = null != i;
                            return (!o || i >= 0) && e.ui.focusable(t, o)
                        }
                    })
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        138: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.fn.extend({
                        uniqueId: (t = 0,
                        function() {
                            return this.each((function() {
                                this.id || (this.id = "ui-id-" + ++t)
                            }
                            ))
                        }
                        ),
                        removeUniqueId: function() {
                            return this.each((function() {
                                /^ui-id-\d+$/.test(this.id) && e(this).removeAttr("id")
                            }
                            ))
                        }
                    });
                    var t
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        592: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.ui = e.ui || {},
                    e.ui.version = "1.14.0"
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        891: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592)],
                o = function(e) {
                    var t, i = 0, o = Array.prototype.hasOwnProperty, n = Array.prototype.slice;
                    return e.cleanData = (t = e.cleanData,
                    function(i) {
                        var o, n, r;
                        for (r = 0; null != (n = i[r]); r++)
                            (o = e._data(n, "events")) && o.remove && e(n).triggerHandler("remove");
                        t(i)
                    }
                    ),
                    e.widget = function(t, i, o) {
                        var n, r, a, s = {}, l = t.split(".")[0], c = l + "-" + (t = t.split(".")[1]);
                        return o || (o = i,
                        i = e.Widget),
                        Array.isArray(o) && (o = e.extend.apply(null, [{}].concat(o))),
                        e.expr.pseudos[c.toLowerCase()] = function(t) {
                            return !!e.data(t, c)
                        }
                        ,
                        e[l] = e[l] || {},
                        n = e[l][t],
                        r = e[l][t] = function(e, t) {
                            if (!this || !this._createWidget)
                                return new r(e,t);
                            arguments.length && this._createWidget(e, t)
                        }
                        ,
                        e.extend(r, n, {
                            version: o.version,
                            _proto: e.extend({}, o),
                            _childConstructors: []
                        }),
                        (a = new i).options = e.widget.extend({}, a.options),
                        e.each(o, (function(e, t) {
                            s[e] = "function" == typeof t ? function() {
                                function o() {
                                    return i.prototype[e].apply(this, arguments)
                                }
                                function n(t) {
                                    return i.prototype[e].apply(this, t)
                                }
                                return function() {
                                    var e, i = this._super, r = this._superApply;
                                    return this._super = o,
                                    this._superApply = n,
                                    e = t.apply(this, arguments),
                                    this._super = i,
                                    this._superApply = r,
                                    e
                                }
                            }() : t
                        }
                        )),
                        r.prototype = e.widget.extend(a, {
                            widgetEventPrefix: n && a.widgetEventPrefix || t
                        }, s, {
                            constructor: r,
                            namespace: l,
                            widgetName: t,
                            widgetFullName: c
                        }),
                        n ? (e.each(n._childConstructors, (function(t, i) {
                            var o = i.prototype;
                            e.widget(o.namespace + "." + o.widgetName, r, i._proto)
                        }
                        )),
                        delete n._childConstructors) : i._childConstructors.push(r),
                        e.widget.bridge(t, r),
                        r
                    }
                    ,
                    e.widget.extend = function(t) {
                        for (var i, r, a = n.call(arguments, 1), s = 0, l = a.length; s < l; s++)
                            for (i in a[s])
                                r = a[s][i],
                                o.call(a[s], i) && void 0 !== r && (e.isPlainObject(r) ? t[i] = e.isPlainObject(t[i]) ? e.widget.extend({}, t[i], r) : e.widget.extend({}, r) : t[i] = r);
                        return t
                    }
                    ,
                    e.widget.bridge = function(t, i) {
                        var o = i.prototype.widgetFullName || t;
                        e.fn[t] = function(r) {
                            var a = "string" == typeof r
                              , s = n.call(arguments, 1)
                              , l = this;
                            return a ? this.length || "instance" !== r ? this.each((function() {
                                var i, n = e.data(this, o);
                                return "instance" === r ? (l = n,
                                !1) : n ? "function" != typeof n[r] || "_" === r.charAt(0) ? e.error("no such method '" + r + "' for " + t + " widget instance") : (i = n[r].apply(n, s)) !== n && void 0 !== i ? (l = i && i.jquery ? l.pushStack(i.get()) : i,
                                !1) : void 0 : e.error("cannot call methods on " + t + " prior to initialization; attempted to call method '" + r + "'")
                            }
                            )) : l = void 0 : (s.length && (r = e.widget.extend.apply(null, [r].concat(s))),
                            this.each((function() {
                                var t = e.data(this, o);
                                t ? (t.option(r || {}),
                                t._init && t._init()) : e.data(this, o, new i(r,this))
                            }
                            ))),
                            l
                        }
                    }
                    ,
                    e.Widget = function() {}
                    ,
                    e.Widget._childConstructors = [],
                    e.Widget.prototype = {
                        widgetName: "widget",
                        widgetEventPrefix: "",
                        defaultElement: "<div>",
                        options: {
                            classes: {},
                            disabled: !1,
                            create: null
                        },
                        _createWidget: function(t, o) {
                            o = e(o || this.defaultElement || this)[0],
                            this.element = e(o),
                            this.uuid = i++,
                            this.eventNamespace = "." + this.widgetName + this.uuid,
                            this.bindings = e(),
                            this.hoverable = e(),
                            this.focusable = e(),
                            this.classesElementLookup = {},
                            o !== this && (e.data(o, this.widgetFullName, this),
                            this._on(!0, this.element, {
                                remove: function(e) {
                                    e.target === o && this.destroy()
                                }
                            }),
                            this.document = e(o.style ? o.ownerDocument : o.document || o),
                            this.window = e(this.document[0].defaultView || this.document[0].parentWindow)),
                            this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t),
                            this._create(),
                            this.options.disabled && this._setOptionDisabled(this.options.disabled),
                            this._trigger("create", null, this._getCreateEventData()),
                            this._init()
                        },
                        _getCreateOptions: function() {
                            return {}
                        },
                        _getCreateEventData: e.noop,
                        _create: e.noop,
                        _init: e.noop,
                        destroy: function() {
                            var t = this;
                            this._destroy(),
                            e.each(this.classesElementLookup, (function(e, i) {
                                t._removeClass(i, e)
                            }
                            )),
                            this.element.off(this.eventNamespace).removeData(this.widgetFullName),
                            this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),
                            this.bindings.off(this.eventNamespace)
                        },
                        _destroy: e.noop,
                        widget: function() {
                            return this.element
                        },
                        option: function(t, i) {
                            var o, n, r, a = t;
                            if (0 === arguments.length)
                                return e.widget.extend({}, this.options);
                            if ("string" == typeof t)
                                if (a = {},
                                o = t.split("."),
                                t = o.shift(),
                                o.length) {
                                    for (n = a[t] = e.widget.extend({}, this.options[t]),
                                    r = 0; r < o.length - 1; r++)
                                        n[o[r]] = n[o[r]] || {},
                                        n = n[o[r]];
                                    if (t = o.pop(),
                                    1 === arguments.length)
                                        return void 0 === n[t] ? null : n[t];
                                    n[t] = i
                                } else {
                                    if (1 === arguments.length)
                                        return void 0 === this.options[t] ? null : this.options[t];
                                    a[t] = i
                                }
                            return this._setOptions(a),
                            this
                        },
                        _setOptions: function(e) {
                            var t;
                            for (t in e)
                                this._setOption(t, e[t]);
                            return this
                        },
                        _setOption: function(e, t) {
                            return "classes" === e && this._setOptionClasses(t),
                            this.options[e] = t,
                            "disabled" === e && this._setOptionDisabled(t),
                            this
                        },
                        _setOptionClasses: function(t) {
                            var i, o, n;
                            for (i in t)
                                n = this.classesElementLookup[i],
                                t[i] !== this.options.classes[i] && n && n.length && (o = e(n.get()),
                                this._removeClass(n, i),
                                o.addClass(this._classes({
                                    element: o,
                                    keys: i,
                                    classes: t,
                                    add: !0
                                })))
                        },
                        _setOptionDisabled: function(e) {
                            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e),
                            e && (this._removeClass(this.hoverable, null, "ui-state-hover"),
                            this._removeClass(this.focusable, null, "ui-state-focus"))
                        },
                        enable: function() {
                            return this._setOptions({
                                disabled: !1
                            })
                        },
                        disable: function() {
                            return this._setOptions({
                                disabled: !0
                            })
                        },
                        _classes: function(t) {
                            var i = []
                              , o = this;
                            function n() {
                                var i = [];
                                t.element.each((function(t, n) {
                                    e.map(o.classesElementLookup, (function(e) {
                                        return e
                                    }
                                    )).some((function(e) {
                                        return e.is(n)
                                    }
                                    )) || i.push(n)
                                }
                                )),
                                o._on(e(i), {
                                    remove: "_untrackClassesElement"
                                })
                            }
                            function r(r, a) {
                                var s, l;
                                for (l = 0; l < r.length; l++)
                                    s = o.classesElementLookup[r[l]] || e(),
                                    t.add ? (n(),
                                    s = e(e.uniqueSort(s.get().concat(t.element.get())))) : s = e(s.not(t.element).get()),
                                    o.classesElementLookup[r[l]] = s,
                                    i.push(r[l]),
                                    a && t.classes[r[l]] && i.push(t.classes[r[l]])
                            }
                            return (t = e.extend({
                                element: this.element,
                                classes: this.options.classes || {}
                            }, t)).keys && r(t.keys.match(/\S+/g) || [], !0),
                            t.extra && r(t.extra.match(/\S+/g) || []),
                            i.join(" ")
                        },
                        _untrackClassesElement: function(t) {
                            var i = this;
                            e.each(i.classesElementLookup, (function(o, n) {
                                -1 !== e.inArray(t.target, n) && (i.classesElementLookup[o] = e(n.not(t.target).get()))
                            }
                            )),
                            this._off(e(t.target))
                        },
                        _removeClass: function(e, t, i) {
                            return this._toggleClass(e, t, i, !1)
                        },
                        _addClass: function(e, t, i) {
                            return this._toggleClass(e, t, i, !0)
                        },
                        _toggleClass: function(e, t, i, o) {
                            o = "boolean" == typeof o ? o : i;
                            var n = "string" == typeof e || null === e
                              , r = {
                                extra: n ? t : i,
                                keys: n ? e : t,
                                element: n ? this.element : e,
                                add: o
                            };
                            return r.element.toggleClass(this._classes(r), o),
                            this
                        },
                        _on: function(t, i, o) {
                            var n, r = this;
                            "boolean" != typeof t && (o = i,
                            i = t,
                            t = !1),
                            o ? (i = n = e(i),
                            this.bindings = this.bindings.add(i)) : (o = i,
                            i = this.element,
                            n = this.widget()),
                            e.each(o, (function(o, a) {
                                function s() {
                                    if (t || !0 !== r.options.disabled && !e(this).hasClass("ui-state-disabled"))
                                        return ("string" == typeof a ? r[a] : a).apply(r, arguments)
                                }
                                "string" != typeof a && (s.guid = a.guid = a.guid || s.guid || e.guid++);
                                var l = o.match(/^([\w:-]*)\s*(.*)$/)
                                  , c = l[1] + r.eventNamespace
                                  , u = l[2];
                                u ? n.on(c, u, s) : i.on(c, s)
                            }
                            ))
                        },
                        _off: function(t, i) {
                            i = (i || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace,
                            t.off(i),
                            this.bindings = e(this.bindings.not(t).get()),
                            this.focusable = e(this.focusable.not(t).get()),
                            this.hoverable = e(this.hoverable.not(t).get())
                        },
                        _delay: function(e, t) {
                            var i = this;
                            return setTimeout((function() {
                                return ("string" == typeof e ? i[e] : e).apply(i, arguments)
                            }
                            ), t || 0)
                        },
                        _hoverable: function(t) {
                            this.hoverable = this.hoverable.add(t),
                            this._on(t, {
                                mouseenter: function(t) {
                                    this._addClass(e(t.currentTarget), null, "ui-state-hover")
                                },
                                mouseleave: function(t) {
                                    this._removeClass(e(t.currentTarget), null, "ui-state-hover")
                                }
                            })
                        },
                        _focusable: function(t) {
                            this.focusable = this.focusable.add(t),
                            this._on(t, {
                                focusin: function(t) {
                                    this._addClass(e(t.currentTarget), null, "ui-state-focus")
                                },
                                focusout: function(t) {
                                    this._removeClass(e(t.currentTarget), null, "ui-state-focus")
                                }
                            })
                        },
                        _trigger: function(t, i, o) {
                            var n, r, a = this.options[t];
                            if (o = o || {},
                            (i = e.Event(i)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(),
                            i.target = this.element[0],
                            r = i.originalEvent)
                                for (n in r)
                                    n in i || (i[n] = r[n]);
                            return this.element.trigger(i, o),
                            !("function" == typeof a && !1 === a.apply(this.element[0], [i].concat(o)) || i.isDefaultPrevented())
                        }
                    },
                    e.each({
                        show: "fadeIn",
                        hide: "fadeOut"
                    }, (function(t, i) {
                        e.Widget.prototype["_" + t] = function(o, n, r) {
                            var a;
                            "string" == typeof n && (n = {
                                effect: n
                            });
                            var s = n ? !0 === n || "number" == typeof n ? i : n.effect || i : t;
                            "number" == typeof (n = n || {}) ? n = {
                                duration: n
                            } : !0 === n && (n = {}),
                            a = !e.isEmptyObject(n),
                            n.complete = r,
                            n.delay && o.delay(n.delay),
                            a && e.effects && e.effects.effect[s] ? o[t](n) : s !== t && o[s] ? o[s](n.duration, n.easing, r) : o.queue((function(i) {
                                e(this)[t](),
                                r && r.call(o[0]),
                                i()
                            }
                            ))
                        }
                    }
                    )),
                    e.widget
                }
                ,
                void 0 === (r = o.apply(t, n)) || (e.exports = r)
            }()
        }
        ,
        366: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(341), i(193), i(53), i(891)],
                o = function(e) {
                    var t;
                    return e.widget("ui.button", {
                        version: "1.14.0",
                        defaultElement: "<button>",
                        options: {
                            classes: {
                                "ui-button": "ui-corner-all"
                            },
                            disabled: null,
                            icon: null,
                            iconPosition: "beginning",
                            label: null,
                            showLabel: !0
                        },
                        _getCreateOptions: function() {
                            var e, t = this._super() || {};
                            return this.isInput = this.element.is("input"),
                            null != (e = this.element[0].disabled) && (t.disabled = e),
                            this.originalLabel = this.isInput ? this.element.val() : this.element.html(),
                            this.originalLabel && (t.label = this.originalLabel),
                            t
                        },
                        _create: function() {
                            !this.option.showLabel & !this.options.icon && (this.options.showLabel = !0),
                            null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1),
                            this.hasTitle = !!this.element.attr("title"),
                            this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)),
                            this._addClass("ui-button", "ui-widget"),
                            this._setOption("disabled", this.options.disabled),
                            this._enhance(),
                            this.element.is("a") && this._on({
                                keyup: function(t) {
                                    t.keyCode === e.ui.keyCode.SPACE && (t.preventDefault(),
                                    this.element[0].click ? this.element[0].click() : this.element.trigger("click"))
                                }
                            })
                        },
                        _enhance: function() {
                            this.element.is("button") || this.element.attr("role", "button"),
                            this.options.icon && (this._updateIcon("icon", this.options.icon),
                            this._updateTooltip())
                        },
                        _updateTooltip: function() {
                            this.title = this.element.attr("title"),
                            this.options.showLabel || this.title || this.element.attr("title", this.options.label)
                        },
                        _updateIcon: function(t, i) {
                            var o = "iconPosition" !== t
                              , n = o ? this.options.iconPosition : i
                              , r = "top" === n || "bottom" === n;
                            this.icon ? o && this._removeClass(this.icon, null, this.options.icon) : (this.icon = e("<span>"),
                            this._addClass(this.icon, "ui-button-icon", "ui-icon"),
                            this.options.showLabel || this._addClass("ui-button-icon-only")),
                            o && this._addClass(this.icon, null, i),
                            this._attachIcon(n),
                            r ? (this._addClass(this.icon, null, "ui-widget-icon-block"),
                            this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = e("<span> </span>"),
                            this._addClass(this.iconSpace, "ui-button-icon-space")),
                            this._removeClass(this.icon, null, "ui-wiget-icon-block"),
                            this._attachIconSpace(n))
                        },
                        _destroy: function() {
                            this.element.removeAttr("role"),
                            this.icon && this.icon.remove(),
                            this.iconSpace && this.iconSpace.remove(),
                            this.hasTitle || this.element.removeAttr("title")
                        },
                        _attachIconSpace: function(e) {
                            this.icon[/^(?:end|bottom)/.test(e) ? "before" : "after"](this.iconSpace)
                        },
                        _attachIcon: function(e) {
                            this.element[/^(?:end|bottom)/.test(e) ? "append" : "prepend"](this.icon)
                        },
                        _setOptions: function(e) {
                            var t = void 0 === e.showLabel ? this.options.showLabel : e.showLabel
                              , i = void 0 === e.icon ? this.options.icon : e.icon;
                            t || i || (e.showLabel = !0),
                            this._super(e)
                        },
                        _setOption: function(e, t) {
                            "icon" === e && (t ? this._updateIcon(e, t) : this.icon && (this.icon.remove(),
                            this.iconSpace && this.iconSpace.remove())),
                            "iconPosition" === e && this._updateIcon(e, t),
                            "showLabel" === e && (this._toggleClass("ui-button-icon-only", null, !t),
                            this._updateTooltip()),
                            "label" === e && (this.isInput ? this.element.val(t) : (this.element.html(t),
                            this.icon && (this._attachIcon(this.options.iconPosition),
                            this._attachIconSpace(this.options.iconPosition)))),
                            this._super(e, t),
                            "disabled" === e && (this._toggleClass(null, "ui-state-disabled", t),
                            this.element[0].disabled = t,
                            t && this.element.trigger("blur"))
                        },
                        refresh: function() {
                            var e = this.element.is("input, button") ? this.element[0].disabled : this.element.hasClass("ui-button-disabled");
                            e !== this.options.disabled && this._setOptions({
                                disabled: e
                            }),
                            this._updateTooltip()
                        }
                    }),
                    !0 === e.uiBackCompat && (e.widget("ui.button", e.ui.button, {
                        options: {
                            text: !0,
                            icons: {
                                primary: null,
                                secondary: null
                            }
                        },
                        _create: function() {
                            this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text),
                            !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel),
                            this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary,
                            this.options.iconPosition = "end"),
                            this._super()
                        },
                        _setOption: function(e, t) {
                            "text" !== e ? ("showLabel" === e && (this.options.text = t),
                            "icon" === e && (this.options.icons.primary = t),
                            "icons" === e && (t.primary ? (this._super("icon", t.primary),
                            this._super("iconPosition", "beginning")) : t.secondary && (this._super("icon", t.secondary),
                            this._super("iconPosition", "end"))),
                            this._superApply(arguments)) : this._super("showLabel", t)
                        }
                    }),
                    e.fn.button = (t = e.fn.button,
                    function(i) {
                        var o = "string" == typeof i
                          , n = Array.prototype.slice.call(arguments, 1)
                          , r = this;
                        return o ? this.length || "instance" !== i ? this.each((function() {
                            var t, o = e(this).attr("type"), a = "checkbox" !== o && "radio" !== o ? "button" : "checkboxradio", s = e.data(this, "ui-" + a);
                            return "instance" === i ? (r = s,
                            !1) : s ? "function" != typeof s[i] || "_" === i.charAt(0) ? e.error("no such method '" + i + "' for button widget instance") : (t = s[i].apply(s, n)) !== s && void 0 !== t ? (r = t && t.jquery ? r.pushStack(t.get()) : t,
                            !1) : void 0 : e.error("cannot call methods on button prior to initialization; attempted to call method '" + i + "'")
                        }
                        )) : r = void 0 : (n.length && (i = e.widget.extend.apply(null, [i].concat(n))),
                        this.each((function() {
                            var o = e(this).attr("type")
                              , n = "checkbox" !== o && "radio" !== o ? "button" : "checkboxradio"
                              , r = e.data(this, "ui-" + n);
                            if (r)
                                r.option(i || {}),
                                r._init && r._init();
                            else {
                                if ("button" === n)
                                    return void t.call(e(this), i);
                                e(this).checkboxradio(e.extend({
                                    icon: !1
                                }, i))
                            }
                        }
                        ))),
                        r
                    }
                    ),
                    e.fn.buttonset = function() {
                        return e.ui.controlgroup || e.error("Controlgroup widget missing"),
                        "option" === arguments[0] && "items" === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], "items.button", arguments[2]]) : "option" === arguments[0] && "items" === arguments[1] ? this.controlgroup.apply(this, [arguments[0], "items.button"]) : ("object" == typeof arguments[0] && arguments[0].items && (arguments[0].items = {
                            button: arguments[0].items
                        }),
                        this.controlgroup.apply(this, arguments))
                    }
                    ),
                    e.ui.button
                }
                ,
                void 0 === (r = o.apply(t, n)) || (e.exports = r)
            }()
        }
        ,
        193: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(808), i(575), i(891)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.widget("ui.checkboxradio", [e.ui.formResetMixin, {
                        version: "1.14.0",
                        options: {
                            disabled: null,
                            label: null,
                            icon: !0,
                            classes: {
                                "ui-checkboxradio-label": "ui-corner-all",
                                "ui-checkboxradio-icon": "ui-corner-all"
                            }
                        },
                        _getCreateOptions: function() {
                            var t, i, o, n = this._super() || {};
                            return this._readType(),
                            i = this.element.labels(),
                            this.label = e(i[i.length - 1]),
                            this.label.length || e.error("No label found for checkboxradio widget"),
                            this.originalLabel = "",
                            (o = this.label.contents().not(this.element[0])).length && (this.originalLabel += o.clone().wrapAll("<div></div>").parent().html()),
                            this.originalLabel && (n.label = this.originalLabel),
                            null != (t = this.element[0].disabled) && (n.disabled = t),
                            n
                        },
                        _create: function() {
                            var e = this.element[0].checked;
                            this._bindFormResetHandler(),
                            null == this.options.disabled && (this.options.disabled = this.element[0].disabled),
                            this._setOption("disabled", this.options.disabled),
                            this._addClass("ui-checkboxradio", "ui-helper-hidden-accessible"),
                            this._addClass(this.label, "ui-checkboxradio-label", "ui-button ui-widget"),
                            "radio" === this.type && this._addClass(this.label, "ui-checkboxradio-radio-label"),
                            this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel),
                            this._enhance(),
                            e && this._addClass(this.label, "ui-checkboxradio-checked", "ui-state-active"),
                            this._on({
                                change: "_toggleClasses",
                                focus: function() {
                                    this._addClass(this.label, null, "ui-state-focus ui-visual-focus")
                                },
                                blur: function() {
                                    this._removeClass(this.label, null, "ui-state-focus ui-visual-focus")
                                }
                            })
                        },
                        _readType: function() {
                            var t = this.element[0].nodeName.toLowerCase();
                            this.type = this.element[0].type,
                            "input" === t && /radio|checkbox/.test(this.type) || e.error("Can't create checkboxradio on element.nodeName=" + t + " and element.type=" + this.type)
                        },
                        _enhance: function() {
                            this._updateIcon(this.element[0].checked)
                        },
                        widget: function() {
                            return this.label
                        },
                        _getRadioGroup: function() {
                            var t = this.element[0].name
                              , i = "input[name='" + CSS.escape(t) + "']";
                            return t ? (this.form.length ? e(this.form[0].elements).filter(i) : e(i).filter((function() {
                                return 0 === e(e(this).prop("form")).length
                            }
                            ))).not(this.element) : e([])
                        },
                        _toggleClasses: function() {
                            var t = this.element[0].checked;
                            this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", t),
                            this.options.icon && "checkbox" === this.type && this._toggleClass(this.icon, null, "ui-icon-check ui-state-checked", t)._toggleClass(this.icon, null, "ui-icon-blank", !t),
                            "radio" === this.type && this._getRadioGroup().each((function() {
                                var t = e(this).checkboxradio("instance");
                                t && t._removeClass(t.label, "ui-checkboxradio-checked", "ui-state-active")
                            }
                            ))
                        },
                        _destroy: function() {
                            this._unbindFormResetHandler(),
                            this.icon && (this.icon.remove(),
                            this.iconSpace.remove())
                        },
                        _setOption: function(e, t) {
                            if ("label" !== e || t) {
                                if (this._super(e, t),
                                "disabled" === e)
                                    return this._toggleClass(this.label, null, "ui-state-disabled", t),
                                    void (this.element[0].disabled = t);
                                this.refresh()
                            }
                        },
                        _updateIcon: function(t) {
                            var i = "ui-icon ui-icon-background ";
                            this.options.icon ? (this.icon || (this.icon = e("<span>"),
                            this.iconSpace = e("<span> </span>"),
                            this._addClass(this.iconSpace, "ui-checkboxradio-icon-space")),
                            "checkbox" === this.type ? (i += t ? "ui-icon-check ui-state-checked" : "ui-icon-blank",
                            this._removeClass(this.icon, null, t ? "ui-icon-blank" : "ui-icon-check")) : i += "ui-icon-blank",
                            this._addClass(this.icon, "ui-checkboxradio-icon", i),
                            t || this._removeClass(this.icon, null, "ui-icon-check ui-state-checked"),
                            this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(),
                            this.iconSpace.remove(),
                            delete this.icon)
                        },
                        _updateLabel: function() {
                            var e = this.label.contents().not(this.element[0]);
                            this.icon && (e = e.not(this.icon[0])),
                            this.iconSpace && (e = e.not(this.iconSpace[0])),
                            e.remove(),
                            this.label.append(this.options.label)
                        },
                        refresh: function() {
                            var e = this.element[0].checked
                              , t = this.element[0].disabled;
                            this._updateIcon(e),
                            this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", e),
                            null !== this.options.label && this._updateLabel(),
                            t !== this.options.disabled && this._setOptions({
                                disabled: t
                            })
                        }
                    }]),
                    e.ui.checkboxradio
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        341: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(891)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    var t = /ui-corner-([a-z]){2,6}/g;
                    return e.widget("ui.controlgroup", {
                        version: "1.14.0",
                        defaultElement: "<div>",
                        options: {
                            direction: "horizontal",
                            disabled: null,
                            onlyVisible: !0,
                            items: {
                                button: "input[type=button], input[type=submit], input[type=reset], button, a",
                                controlgroupLabel: ".ui-controlgroup-label",
                                checkboxradio: "input[type='checkbox'], input[type='radio']",
                                selectmenu: "select",
                                spinner: ".ui-spinner-input"
                            }
                        },
                        _create: function() {
                            this._enhance()
                        },
                        _enhance: function() {
                            this.element.attr("role", "toolbar"),
                            this.refresh()
                        },
                        _destroy: function() {
                            this._callChildMethod("destroy"),
                            this.childWidgets.removeData("ui-controlgroup-data"),
                            this.element.removeAttr("role"),
                            this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()
                        },
                        _initWidgets: function() {
                            var t = this
                              , i = [];
                            e.each(this.options.items, (function(o, n) {
                                var r, a = {};
                                if (n)
                                    return "controlgroupLabel" === o ? ((r = t.element.find(n)).each((function() {
                                        var t = e(this);
                                        t.children(".ui-controlgroup-label-contents").length || t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")
                                    }
                                    )),
                                    t._addClass(r, null, "ui-widget ui-widget-content ui-state-default"),
                                    void (i = i.concat(r.get()))) : void (e.fn[o] && (a = t["_" + o + "Options"] ? t["_" + o + "Options"]("middle") : {
                                        classes: {}
                                    },
                                    t.element.find(n).each((function() {
                                        var n = e(this)
                                          , r = n[o]("instance")
                                          , s = e.widget.extend({}, a);
                                        if ("button" !== o || !n.parent(".ui-spinner").length) {
                                            r || (r = n[o]()[o]("instance")),
                                            r && (s.classes = t._resolveClassesValues(s.classes, r)),
                                            n[o](s);
                                            var l = n[o]("widget");
                                            e.data(l[0], "ui-controlgroup-data", r || n[o]("instance")),
                                            i.push(l[0])
                                        }
                                    }
                                    ))))
                            }
                            )),
                            this.childWidgets = e(e.uniqueSort(i)),
                            this._addClass(this.childWidgets, "ui-controlgroup-item")
                        },
                        _callChildMethod: function(t) {
                            this.childWidgets.each((function() {
                                var i = e(this).data("ui-controlgroup-data");
                                i && i[t] && i[t]()
                            }
                            ))
                        },
                        _updateCornerClass: function(e, t) {
                            var i = this._buildSimpleOptions(t, "label").classes.label;
                            this._removeClass(e, null, "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all"),
                            this._addClass(e, null, i)
                        },
                        _buildSimpleOptions: function(e, t) {
                            var i = "vertical" === this.options.direction
                              , o = {
                                classes: {}
                            };
                            return o.classes[t] = {
                                middle: "",
                                first: "ui-corner-" + (i ? "top" : "left"),
                                last: "ui-corner-" + (i ? "bottom" : "right"),
                                only: "ui-corner-all"
                            }[e],
                            o
                        },
                        _spinnerOptions: function(e) {
                            var t = this._buildSimpleOptions(e, "ui-spinner");
                            return t.classes["ui-spinner-up"] = "",
                            t.classes["ui-spinner-down"] = "",
                            t
                        },
                        _buttonOptions: function(e) {
                            return this._buildSimpleOptions(e, "ui-button")
                        },
                        _checkboxradioOptions: function(e) {
                            return this._buildSimpleOptions(e, "ui-checkboxradio-label")
                        },
                        _selectmenuOptions: function(e) {
                            var t = "vertical" === this.options.direction;
                            return {
                                width: !!t && "auto",
                                classes: {
                                    middle: {
                                        "ui-selectmenu-button-open": "",
                                        "ui-selectmenu-button-closed": ""
                                    },
                                    first: {
                                        "ui-selectmenu-button-open": "ui-corner-" + (t ? "top" : "tl"),
                                        "ui-selectmenu-button-closed": "ui-corner-" + (t ? "top" : "left")
                                    },
                                    last: {
                                        "ui-selectmenu-button-open": t ? "" : "ui-corner-tr",
                                        "ui-selectmenu-button-closed": "ui-corner-" + (t ? "bottom" : "right")
                                    },
                                    only: {
                                        "ui-selectmenu-button-open": "ui-corner-top",
                                        "ui-selectmenu-button-closed": "ui-corner-all"
                                    }
                                }[e]
                            }
                        },
                        _resolveClassesValues: function(i, o) {
                            var n = {};
                            return e.each(i, (function(e) {
                                var r = o.options.classes[e] || "";
                                r = String.prototype.trim.call(r.replace(t, "")),
                                n[e] = (r + " " + i[e]).replace(/\s+/g, " ")
                            }
                            )),
                            n
                        },
                        _setOption: function(e, t) {
                            "direction" === e && this._removeClass("ui-controlgroup-" + this.options.direction),
                            this._super(e, t),
                            "disabled" !== e ? this.refresh() : this._callChildMethod(t ? "disable" : "enable")
                        },
                        refresh: function() {
                            var t, i = this;
                            this._addClass("ui-controlgroup ui-controlgroup-" + this.options.direction),
                            "horizontal" === this.options.direction && this._addClass(null, "ui-helper-clearfix"),
                            this._initWidgets(),
                            t = this.childWidgets,
                            this.options.onlyVisible && (t = t.filter(":visible")),
                            t.length && (e.each(["first", "last"], (function(e, o) {
                                var n = t[o]().data("ui-controlgroup-data");
                                if (n && i["_" + n.widgetName + "Options"]) {
                                    var r = i["_" + n.widgetName + "Options"](1 === t.length ? "only" : o);
                                    r.classes = i._resolveClassesValues(r.classes, n),
                                    n.element[n.widgetName](r)
                                } else
                                    i._updateCornerClass(t[o](), o)
                            }
                            )),
                            this._callChildMethod("refresh"))
                        }
                    })
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        466: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(366), i(285), i(177), i(707), i(436), i(53), i(822), i(614), i(138), i(592), i(891)],
                o = function(e) {
                    return e.widget("ui.dialog", {
                        version: "1.14.0",
                        options: {
                            appendTo: "body",
                            autoOpen: !0,
                            buttons: [],
                            classes: {
                                "ui-dialog": "ui-corner-all",
                                "ui-dialog-titlebar": "ui-corner-all"
                            },
                            closeOnEscape: !0,
                            closeText: "Close",
                            draggable: !0,
                            hide: null,
                            height: "auto",
                            maxHeight: null,
                            maxWidth: null,
                            minHeight: 150,
                            minWidth: 150,
                            modal: !1,
                            position: {
                                my: "center",
                                at: "center",
                                of: window,
                                collision: "fit",
                                using: function(t) {
                                    var i = e(this).css(t).offset().top;
                                    i < 0 && e(this).css("top", t.top - i)
                                }
                            },
                            resizable: !0,
                            show: null,
                            title: null,
                            width: 300,
                            beforeClose: null,
                            close: null,
                            drag: null,
                            dragStart: null,
                            dragStop: null,
                            focus: null,
                            open: null,
                            resize: null,
                            resizeStart: null,
                            resizeStop: null
                        },
                        sizeRelatedOptions: {
                            buttons: !0,
                            height: !0,
                            maxHeight: !0,
                            maxWidth: !0,
                            minHeight: !0,
                            minWidth: !0,
                            width: !0
                        },
                        resizableRelatedOptions: {
                            maxHeight: !0,
                            maxWidth: !0,
                            minHeight: !0,
                            minWidth: !0
                        },
                        _create: function() {
                            this.originalCss = {
                                display: this.element[0].style.display,
                                width: this.element[0].style.width,
                                minHeight: this.element[0].style.minHeight,
                                maxHeight: this.element[0].style.maxHeight,
                                height: this.element[0].style.height
                            },
                            this.originalPosition = {
                                parent: this.element.parent(),
                                index: this.element.parent().children().index(this.element)
                            },
                            this.originalTitle = this.element.attr("title"),
                            null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle),
                            this.options.disabled && (this.options.disabled = !1),
                            this._createWrapper(),
                            this.element.show().removeAttr("title").appendTo(this.uiDialog),
                            this._addClass("ui-dialog-content", "ui-widget-content"),
                            this._createTitlebar(),
                            this._createButtonPane(),
                            this.options.draggable && e.fn.draggable && this._makeDraggable(),
                            this.options.resizable && e.fn.resizable && this._makeResizable(),
                            this._isOpen = !1,
                            this._trackFocus()
                        },
                        _init: function() {
                            this.options.autoOpen && this.open()
                        },
                        _appendTo: function() {
                            var t = this.options.appendTo;
                            return t && (t.jquery || t.nodeType) ? e(t) : this.document.find(t || "body").eq(0)
                        },
                        _destroy: function() {
                            var e, t = this.originalPosition;
                            this._untrackInstance(),
                            this._destroyOverlay(),
                            this.element.removeUniqueId().css(this.originalCss).detach(),
                            this.uiDialog.remove(),
                            this.originalTitle && this.element.attr("title", this.originalTitle),
                            (e = t.parent.children().eq(t.index)).length && e[0] !== this.element[0] ? e.before(this.element) : t.parent.append(this.element)
                        },
                        widget: function() {
                            return this.uiDialog
                        },
                        disable: e.noop,
                        enable: e.noop,
                        close: function(t) {
                            var i = this;
                            this._isOpen && !1 !== this._trigger("beforeClose", t) && (this._isOpen = !1,
                            this._focusedElement = null,
                            this._destroyOverlay(),
                            this._untrackInstance(),
                            this.opener.filter(":focusable").trigger("focus").length || e(this.document[0].activeElement).trigger("blur"),
                            this._hide(this.uiDialog, this.options.hide, (function() {
                                i._trigger("close", t)
                            }
                            )))
                        },
                        isOpen: function() {
                            return this._isOpen
                        },
                        moveToTop: function() {
                            this._moveToTop()
                        },
                        _moveToTop: function(t, i) {
                            var o = !1
                              , n = this.uiDialog.siblings(".ui-front:visible").map((function() {
                                return +e(this).css("z-index")
                            }
                            )).get()
                              , r = Math.max.apply(null, n);
                            return r >= +this.uiDialog.css("z-index") && (this.uiDialog.css("z-index", r + 1),
                            o = !0),
                            o && !i && this._trigger("focus", t),
                            o
                        },
                        open: function() {
                            var t = this;
                            this._isOpen ? this._moveToTop() && this._focusTabbable() : (this._isOpen = !0,
                            this.opener = e(this.document[0].activeElement),
                            this._size(),
                            this._position(),
                            this._createOverlay(),
                            this._moveToTop(null, !0),
                            this.overlay && this.overlay.css("z-index", this.uiDialog.css("z-index") - 1),
                            this._show(this.uiDialog, this.options.show, (function() {
                                t._focusTabbable(),
                                t._trigger("focus")
                            }
                            )),
                            this._makeFocusTarget(),
                            this._trigger("open"))
                        },
                        _focusTabbable: function() {
                            var e = this._focusedElement;
                            e || (e = this.element.find("[autofocus]")),
                            e.length || (e = this.element.find(":tabbable")),
                            e.length || (e = this.uiDialogButtonPane.find(":tabbable")),
                            e.length || (e = this.uiDialogTitlebarClose.filter(":tabbable")),
                            e.length || (e = this.uiDialog),
                            e.eq(0).trigger("focus")
                        },
                        _restoreTabbableFocus: function() {
                            var t = this.document[0].activeElement;
                            this.uiDialog[0] === t || e.contains(this.uiDialog[0], t) || this._focusTabbable()
                        },
                        _keepFocus: function(e) {
                            e.preventDefault(),
                            this._restoreTabbableFocus()
                        },
                        _createWrapper: function() {
                            this.uiDialog = e("<div>").hide().attr({
                                tabIndex: -1,
                                role: "dialog",
                                "aria-modal": this.options.modal ? "true" : null
                            }).appendTo(this._appendTo()),
                            this._addClass(this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front"),
                            this._on(this.uiDialog, {
                                keydown: function(t) {
                                    if (this.options.closeOnEscape && !t.isDefaultPrevented() && t.keyCode && t.keyCode === e.ui.keyCode.ESCAPE)
                                        return t.preventDefault(),
                                        void this.close(t);
                                    if (t.keyCode === e.ui.keyCode.TAB && !t.isDefaultPrevented()) {
                                        var i = this.uiDialog.find(":tabbable")
                                          , o = i.first()
                                          , n = i.last();
                                        t.target !== n[0] && t.target !== this.uiDialog[0] || t.shiftKey ? t.target !== o[0] && t.target !== this.uiDialog[0] || !t.shiftKey || (this._delay((function() {
                                            n.trigger("focus")
                                        }
                                        )),
                                        t.preventDefault()) : (this._delay((function() {
                                            o.trigger("focus")
                                        }
                                        )),
                                        t.preventDefault())
                                    }
                                },
                                mousedown: function(e) {
                                    this._moveToTop(e) && this._focusTabbable()
                                }
                            }),
                            this.element.find("[aria-describedby]").length || this.uiDialog.attr({
                                "aria-describedby": this.element.uniqueId().attr("id")
                            })
                        },
                        _createTitlebar: function() {
                            var t;
                            this.uiDialogTitlebar = e("<div>"),
                            this._addClass(this.uiDialogTitlebar, "ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix"),
                            this._on(this.uiDialogTitlebar, {
                                mousedown: function(t) {
                                    e(t.target).closest(".ui-dialog-titlebar-close") || this.uiDialog.trigger("focus")
                                }
                            }),
                            this.uiDialogTitlebarClose = e("<button type='button'></button>").button({
                                label: e("<a>").text(this.options.closeText).html(),
                                icon: "ui-icon-closethick",
                                showLabel: !1
                            }).appendTo(this.uiDialogTitlebar),
                            this._addClass(this.uiDialogTitlebarClose, "ui-dialog-titlebar-close"),
                            this._on(this.uiDialogTitlebarClose, {
                                click: function(e) {
                                    e.preventDefault(),
                                    this.close(e)
                                }
                            }),
                            t = e("<span>").uniqueId().prependTo(this.uiDialogTitlebar),
                            this._addClass(t, "ui-dialog-title"),
                            this._title(t),
                            this.uiDialogTitlebar.prependTo(this.uiDialog),
                            this.uiDialog.attr({
                                "aria-labelledby": t.attr("id")
                            })
                        },
                        _title: function(e) {
                            this.options.title ? e.text(this.options.title) : e.html("&#160;")
                        },
                        _createButtonPane: function() {
                            this.uiDialogButtonPane = e("<div>"),
                            this._addClass(this.uiDialogButtonPane, "ui-dialog-buttonpane", "ui-widget-content ui-helper-clearfix"),
                            this.uiButtonSet = e("<div>").appendTo(this.uiDialogButtonPane),
                            this._addClass(this.uiButtonSet, "ui-dialog-buttonset"),
                            this._createButtons()
                        },
                        _createButtons: function() {
                            var t = this
                              , i = this.options.buttons;
                            this.uiDialogButtonPane.remove(),
                            this.uiButtonSet.empty(),
                            e.isEmptyObject(i) || Array.isArray(i) && !i.length ? this._removeClass(this.uiDialog, "ui-dialog-buttons") : (e.each(i, (function(i, o) {
                                var n, r;
                                o = "function" == typeof o ? {
                                    click: o,
                                    text: i
                                } : o,
                                o = e.extend({
                                    type: "button"
                                }, o),
                                n = o.click,
                                r = {
                                    icon: o.icon,
                                    iconPosition: o.iconPosition,
                                    showLabel: o.showLabel,
                                    icons: o.icons,
                                    text: o.text
                                },
                                delete o.click,
                                delete o.icon,
                                delete o.iconPosition,
                                delete o.showLabel,
                                delete o.icons,
                                "boolean" == typeof o.text && delete o.text,
                                e("<button></button>", o).button(r).appendTo(t.uiButtonSet).on("click", (function() {
                                    n.apply(t.element[0], arguments)
                                }
                                ))
                            }
                            )),
                            this._addClass(this.uiDialog, "ui-dialog-buttons"),
                            this.uiDialogButtonPane.appendTo(this.uiDialog))
                        },
                        _makeDraggable: function() {
                            var t = this
                              , i = this.options;
                            function o(e) {
                                return {
                                    position: e.position,
                                    offset: e.offset
                                }
                            }
                            this.uiDialog.draggable({
                                cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
                                handle: ".ui-dialog-titlebar",
                                containment: "document",
                                start: function(i, n) {
                                    t._addClass(e(this), "ui-dialog-dragging"),
                                    t._blockFrames(),
                                    t._trigger("dragStart", i, o(n))
                                },
                                drag: function(e, i) {
                                    t._trigger("drag", e, o(i))
                                },
                                stop: function(n, r) {
                                    var a = r.offset.left - t.document.scrollLeft()
                                      , s = r.offset.top - t.document.scrollTop();
                                    i.position = {
                                        my: "left top",
                                        at: "left" + (a >= 0 ? "+" : "") + a + " top" + (s >= 0 ? "+" : "") + s,
                                        of: t.window
                                    },
                                    t._removeClass(e(this), "ui-dialog-dragging"),
                                    t._unblockFrames(),
                                    t._trigger("dragStop", n, o(r))
                                }
                            })
                        },
                        _makeResizable: function() {
                            var t = this
                              , i = this.options
                              , o = i.resizable
                              , n = this.uiDialog.css("position")
                              , r = "string" == typeof o ? o : "n,e,s,w,se,sw,ne,nw";
                            function a(e) {
                                return {
                                    originalPosition: e.originalPosition,
                                    originalSize: e.originalSize,
                                    position: e.position,
                                    size: e.size
                                }
                            }
                            this.uiDialog.resizable({
                                cancel: ".ui-dialog-content",
                                containment: "document",
                                alsoResize: this.element,
                                maxWidth: i.maxWidth,
                                maxHeight: i.maxHeight,
                                minWidth: i.minWidth,
                                minHeight: this._minHeight(),
                                handles: r,
                                start: function(i, o) {
                                    t._addClass(e(this), "ui-dialog-resizing"),
                                    t._blockFrames(),
                                    t._trigger("resizeStart", i, a(o))
                                },
                                resize: function(e, i) {
                                    t._trigger("resize", e, a(i))
                                },
                                stop: function(o, n) {
                                    var r = t.uiDialog.offset()
                                      , s = r.left - t.document.scrollLeft()
                                      , l = r.top - t.document.scrollTop();
                                    i.height = t.uiDialog.height(),
                                    i.width = t.uiDialog.width(),
                                    i.position = {
                                        my: "left top",
                                        at: "left" + (s >= 0 ? "+" : "") + s + " top" + (l >= 0 ? "+" : "") + l,
                                        of: t.window
                                    },
                                    t._removeClass(e(this), "ui-dialog-resizing"),
                                    t._unblockFrames(),
                                    t._trigger("resizeStop", o, a(n))
                                }
                            }).css("position", n)
                        },
                        _trackFocus: function() {
                            this._on(this.widget(), {
                                focusin: function(t) {
                                    this._makeFocusTarget(),
                                    this._focusedElement = e(t.target)
                                }
                            })
                        },
                        _makeFocusTarget: function() {
                            this._untrackInstance(),
                            this._trackingInstances().unshift(this)
                        },
                        _untrackInstance: function() {
                            var t = this._trackingInstances()
                              , i = e.inArray(this, t);
                            -1 !== i && t.splice(i, 1)
                        },
                        _trackingInstances: function() {
                            var e = this.document.data("ui-dialog-instances");
                            return e || (e = [],
                            this.document.data("ui-dialog-instances", e)),
                            e
                        },
                        _minHeight: function() {
                            var e = this.options;
                            return "auto" === e.height ? e.minHeight : Math.min(e.minHeight, e.height)
                        },
                        _position: function() {
                            var e = this.uiDialog.is(":visible");
                            e || this.uiDialog.show(),
                            this.uiDialog.position(this.options.position),
                            e || this.uiDialog.hide()
                        },
                        _setOptions: function(t) {
                            var i = this
                              , o = !1
                              , n = {};
                            e.each(t, (function(e, t) {
                                i._setOption(e, t),
                                e in i.sizeRelatedOptions && (o = !0),
                                e in i.resizableRelatedOptions && (n[e] = t)
                            }
                            )),
                            o && (this._size(),
                            this._position()),
                            this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", n)
                        },
                        _setOption: function(t, i) {
                            var o, n, r = this.uiDialog;
                            "disabled" !== t && (this._super(t, i),
                            "appendTo" === t && this.uiDialog.appendTo(this._appendTo()),
                            "buttons" === t && this._createButtons(),
                            "closeText" === t && this.uiDialogTitlebarClose.button({
                                label: e("<a>").text("" + this.options.closeText).html()
                            }),
                            "draggable" === t && ((o = r.is(":data(ui-draggable)")) && !i && r.draggable("destroy"),
                            !o && i && this._makeDraggable()),
                            "position" === t && this._position(),
                            "resizable" === t && ((n = r.is(":data(ui-resizable)")) && !i && r.resizable("destroy"),
                            n && "string" == typeof i && r.resizable("option", "handles", i),
                            n || !1 === i || this._makeResizable()),
                            "title" === t && this._title(this.uiDialogTitlebar.find(".ui-dialog-title")),
                            "modal" === t && r.attr("aria-modal", i ? "true" : null))
                        },
                        _size: function() {
                            var e, t, i, o = this.options;
                            this.element.show().css({
                                width: "auto",
                                minHeight: 0,
                                maxHeight: "none",
                                height: 0
                            }),
                            o.minWidth > o.width && (o.width = o.minWidth),
                            e = this.uiDialog.css({
                                height: "auto",
                                width: o.width
                            }).outerHeight(),
                            t = Math.max(0, o.minHeight - e),
                            i = "number" == typeof o.maxHeight ? Math.max(0, o.maxHeight - e) : "none",
                            "auto" === o.height ? this.element.css({
                                minHeight: t,
                                maxHeight: i,
                                height: "auto"
                            }) : this.element.height(Math.max(0, o.height - e)),
                            this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", "minHeight", this._minHeight())
                        },
                        _blockFrames: function() {
                            this.iframeBlocks = this.document.find("iframe").map((function() {
                                var t = e(this);
                                return e("<div>").css({
                                    position: "absolute",
                                    width: t.outerWidth(),
                                    height: t.outerHeight()
                                }).appendTo(t.parent()).offset(t.offset())[0]
                            }
                            ))
                        },
                        _unblockFrames: function() {
                            this.iframeBlocks && (this.iframeBlocks.remove(),
                            delete this.iframeBlocks)
                        },
                        _allowInteraction: function(t) {
                            return !!e(t.target).closest(".ui-dialog").length || !!e(t.target).closest(".ui-datepicker").length
                        },
                        _createOverlay: function() {
                            if (this.options.modal) {
                                var t = !0;
                                this._delay((function() {
                                    t = !1
                                }
                                )),
                                this.document.data("ui-dialog-overlays") || this.document.on("focusin.ui-dialog", function(e) {
                                    if (!t) {
                                        var i = this._trackingInstances()[0];
                                        i._allowInteraction(e) || (e.preventDefault(),
                                        i._focusTabbable())
                                    }
                                }
                                .bind(this)),
                                this.overlay = e("<div>").appendTo(this._appendTo()),
                                this._addClass(this.overlay, null, "ui-widget-overlay ui-front"),
                                this._on(this.overlay, {
                                    mousedown: "_keepFocus"
                                }),
                                this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1)
                            }
                        },
                        _destroyOverlay: function() {
                            if (this.options.modal && this.overlay) {
                                var e = this.document.data("ui-dialog-overlays") - 1;
                                e ? this.document.data("ui-dialog-overlays", e) : (this.document.off("focusin.ui-dialog"),
                                this.document.removeData("ui-dialog-overlays")),
                                this.overlay.remove(),
                                this.overlay = null
                            }
                        }
                    }),
                    !0 === e.uiBackCompat && e.widget("ui.dialog", e.ui.dialog, {
                        options: {
                            dialogClass: ""
                        },
                        _createWrapper: function() {
                            this._super(),
                            this.uiDialog.addClass(this.options.dialogClass)
                        },
                        _setOption: function(e, t) {
                            "dialogClass" === e && this.uiDialog.removeClass(this.options.dialogClass).addClass(t),
                            this._superApply(arguments)
                        }
                    }),
                    e.ui.dialog
                }
                ,
                void 0 === (r = o.apply(t, n)) || (e.exports = r)
            }()
        }
        ,
        285: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(177), i(400), i(624), i(464), i(592), i(891)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    return e.widget("ui.draggable", e.ui.mouse, {
                        version: "1.14.0",
                        widgetEventPrefix: "drag",
                        options: {
                            addClasses: !0,
                            appendTo: "parent",
                            axis: !1,
                            connectToSortable: !1,
                            containment: !1,
                            cursor: "auto",
                            cursorAt: !1,
                            grid: !1,
                            handle: !1,
                            helper: "original",
                            iframeFix: !1,
                            opacity: !1,
                            refreshPositions: !1,
                            revert: !1,
                            revertDuration: 500,
                            scope: "default",
                            scroll: !0,
                            scrollSensitivity: 20,
                            scrollSpeed: 20,
                            snap: !1,
                            snapMode: "both",
                            snapTolerance: 20,
                            stack: !1,
                            zIndex: !1,
                            drag: null,
                            start: null,
                            stop: null
                        },
                        _create: function() {
                            "original" === this.options.helper && this._setPositionRelative(),
                            this.options.addClasses && this._addClass("ui-draggable"),
                            this._setHandleClassName(),
                            this._mouseInit()
                        },
                        _setOption: function(e, t) {
                            this._super(e, t),
                            "handle" === e && (this._removeHandleClassName(),
                            this._setHandleClassName())
                        },
                        _destroy: function() {
                            (this.helper || this.element).is(".ui-draggable-dragging") ? this.destroyOnClear = !0 : (this._removeHandleClassName(),
                            this._mouseDestroy())
                        },
                        _mouseCapture: function(t) {
                            var i = this.options;
                            return !(this.helper || i.disabled || e(t.target).closest(".ui-resizable-handle").length > 0 || (this.handle = this._getHandle(t),
                            !this.handle || (this._blurActiveElement(t),
                            this._blockFrames(!0 === i.iframeFix ? "iframe" : i.iframeFix),
                            0)))
                        },
                        _blockFrames: function(t) {
                            this.iframeBlocks = this.document.find(t).map((function() {
                                var t = e(this);
                                return e("<div>").css("position", "absolute").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]
                            }
                            ))
                        },
                        _unblockFrames: function() {
                            this.iframeBlocks && (this.iframeBlocks.remove(),
                            delete this.iframeBlocks)
                        },
                        _blurActiveElement: function(t) {
                            var i = this.document[0].activeElement;
                            e(t.target).closest(i).length || e(i).trigger("blur")
                        },
                        _mouseStart: function(t) {
                            var i = this.options;
                            return this.helper = this._createHelper(t),
                            this._addClass(this.helper, "ui-draggable-dragging"),
                            this._cacheHelperProportions(),
                            e.ui.ddmanager && (e.ui.ddmanager.current = this),
                            this._cacheMargins(),
                            this.cssPosition = this.helper.css("position"),
                            this.scrollParent = this.helper.scrollParent(!0),
                            this.offsetParent = this.helper.offsetParent(),
                            this.hasFixedAncestor = this.helper.parents().filter((function() {
                                return "fixed" === e(this).css("position")
                            }
                            )).length > 0,
                            this.positionAbs = this.element.offset(),
                            this._refreshOffsets(t),
                            this.originalPosition = this.position = this._generatePosition(t, !1),
                            this.originalPageX = t.pageX,
                            this.originalPageY = t.pageY,
                            i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt),
                            this._setContainment(),
                            !1 === this._trigger("start", t) ? (this._clear(),
                            !1) : (this._cacheHelperProportions(),
                            e.ui.ddmanager && !i.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t),
                            this._mouseDrag(t, !0),
                            e.ui.ddmanager && e.ui.ddmanager.dragStart(this, t),
                            !0)
                        },
                        _refreshOffsets: function(e) {
                            this.offset = {
                                top: this.positionAbs.top - this.margins.top,
                                left: this.positionAbs.left - this.margins.left,
                                scroll: !1,
                                parent: this._getParentOffset(),
                                relative: this._getRelativeOffset()
                            },
                            this.offset.click = {
                                left: e.pageX - this.offset.left,
                                top: e.pageY - this.offset.top
                            }
                        },
                        _mouseDrag: function(t, i) {
                            if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()),
                            this.position = this._generatePosition(t, !0),
                            this.positionAbs = this._convertPositionTo("absolute"),
                            !i) {
                                var o = this._uiHash();
                                if (!1 === this._trigger("drag", t, o))
                                    return this._mouseUp(new e.Event("mouseup",t)),
                                    !1;
                                this.position = o.position
                            }
                            return this.helper[0].style.left = this.position.left + "px",
                            this.helper[0].style.top = this.position.top + "px",
                            e.ui.ddmanager && e.ui.ddmanager.drag(this, t),
                            !1
                        },
                        _mouseStop: function(t) {
                            var i = this
                              , o = !1;
                            return e.ui.ddmanager && !this.options.dropBehaviour && (o = e.ui.ddmanager.drop(this, t)),
                            this.dropped && (o = this.dropped,
                            this.dropped = !1),
                            "invalid" === this.options.revert && !o || "valid" === this.options.revert && o || !0 === this.options.revert || "function" == typeof this.options.revert && this.options.revert.call(this.element, o) ? e(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), (function() {
                                !1 !== i._trigger("stop", t) && i._clear()
                            }
                            )) : !1 !== this._trigger("stop", t) && this._clear(),
                            !1
                        },
                        _mouseUp: function(t) {
                            return this._unblockFrames(),
                            e.ui.ddmanager && e.ui.ddmanager.dragStop(this, t),
                            this.handleElement.is(t.target) && this.element.trigger("focus"),
                            e.ui.mouse.prototype._mouseUp.call(this, t)
                        },
                        cancel: function() {
                            return this.helper.is(".ui-draggable-dragging") ? this._mouseUp(new e.Event("mouseup",{
                                target: this.element[0]
                            })) : this._clear(),
                            this
                        },
                        _getHandle: function(t) {
                            return !this.options.handle || !!e(t.target).closest(this.element.find(this.options.handle)).length
                        },
                        _setHandleClassName: function() {
                            this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element,
                            this._addClass(this.handleElement, "ui-draggable-handle")
                        },
                        _removeHandleClassName: function() {
                            this._removeClass(this.handleElement, "ui-draggable-handle")
                        },
                        _createHelper: function(t) {
                            var i = this.options
                              , o = "function" == typeof i.helper
                              , n = o ? e(i.helper.apply(this.element[0], [t])) : "clone" === i.helper ? this.element.clone().removeAttr("id") : this.element;
                            return n.parents("body").length || n.appendTo("parent" === i.appendTo ? this.element[0].parentNode : i.appendTo),
                            o && n[0] === this.element[0] && this._setPositionRelative(),
                            n[0] === this.element[0] || /(fixed|absolute)/.test(n.css("position")) || n.css("position", "absolute"),
                            n
                        },
                        _setPositionRelative: function() {
                            /^(?:r|a|f)/.test(this.element.css("position")) || (this.element[0].style.position = "relative")
                        },
                        _adjustOffsetFromHelper: function(e) {
                            "string" == typeof e && (e = e.split(" ")),
                            Array.isArray(e) && (e = {
                                left: +e[0],
                                top: +e[1] || 0
                            }),
                            "left"in e && (this.offset.click.left = e.left + this.margins.left),
                            "right"in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left),
                            "top"in e && (this.offset.click.top = e.top + this.margins.top),
                            "bottom"in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top)
                        },
                        _isRootNode: function(e) {
                            return /(html|body)/i.test(e.tagName) || e === this.document[0]
                        },
                        _getParentOffset: function() {
                            var t = this.offsetParent.offset()
                              , i = this.document[0];
                            return "absolute" === this.cssPosition && this.scrollParent[0] !== i && e.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(),
                            t.top += this.scrollParent.scrollTop()),
                            this._isRootNode(this.offsetParent[0]) && (t = {
                                top: 0,
                                left: 0
                            }),
                            {
                                top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                                left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
                            }
                        },
                        _getRelativeOffset: function() {
                            if ("relative" !== this.cssPosition)
                                return {
                                    top: 0,
                                    left: 0
                                };
                            var e = this.element.position()
                              , t = this._isRootNode(this.scrollParent[0]);
                            return {
                                top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + (t ? 0 : this.scrollParent.scrollTop()),
                                left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + (t ? 0 : this.scrollParent.scrollLeft())
                            }
                        },
                        _cacheMargins: function() {
                            this.margins = {
                                left: parseInt(this.element.css("marginLeft"), 10) || 0,
                                top: parseInt(this.element.css("marginTop"), 10) || 0,
                                right: parseInt(this.element.css("marginRight"), 10) || 0,
                                bottom: parseInt(this.element.css("marginBottom"), 10) || 0
                            }
                        },
                        _cacheHelperProportions: function() {
                            this.helperProportions = {
                                width: this.helper.outerWidth(),
                                height: this.helper.outerHeight()
                            }
                        },
                        _setContainment: function() {
                            var t, i, o, n = this.options, r = this.document[0];
                            this.relativeContainer = null,
                            n.containment ? "window" !== n.containment ? "document" !== n.containment ? n.containment.constructor !== Array ? ("parent" === n.containment && (n.containment = this.helper[0].parentNode),
                            (o = (i = e(n.containment))[0]) && (t = /(scroll|auto)/.test(i.css("overflow")),
                            this.containment = [(parseInt(i.css("borderLeftWidth"), 10) || 0) + (parseInt(i.css("paddingLeft"), 10) || 0), (parseInt(i.css("borderTopWidth"), 10) || 0) + (parseInt(i.css("paddingTop"), 10) || 0), (t ? Math.max(o.scrollWidth, o.offsetWidth) : o.offsetWidth) - (parseInt(i.css("borderRightWidth"), 10) || 0) - (parseInt(i.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (t ? Math.max(o.scrollHeight, o.offsetHeight) : o.offsetHeight) - (parseInt(i.css("borderBottomWidth"), 10) || 0) - (parseInt(i.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom],
                            this.relativeContainer = i)) : this.containment = n.containment : this.containment = [0, 0, e(r).width() - this.helperProportions.width - this.margins.left, (e(r).height() || r.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top] : this.containment = [e(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, e(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, e(window).scrollLeft() + e(window).width() - this.helperProportions.width - this.margins.left, e(window).scrollTop() + (e(window).height() || r.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top] : this.containment = null
                        },
                        _convertPositionTo: function(e, t) {
                            t || (t = this.position);
                            var i = "absolute" === e ? 1 : -1
                              , o = this._isRootNode(this.scrollParent[0]);
                            return {
                                top: t.top + this.offset.relative.top * i + this.offset.parent.top * i - ("fixed" === this.cssPosition ? -this.offset.scroll.top : o ? 0 : this.offset.scroll.top) * i,
                                left: t.left + this.offset.relative.left * i + this.offset.parent.left * i - ("fixed" === this.cssPosition ? -this.offset.scroll.left : o ? 0 : this.offset.scroll.left) * i
                            }
                        },
                        _generatePosition: function(e, t) {
                            var i, o, n, r, a = this.options, s = this._isRootNode(this.scrollParent[0]), l = e.pageX, c = e.pageY;
                            return s && this.offset.scroll || (this.offset.scroll = {
                                top: this.scrollParent.scrollTop(),
                                left: this.scrollParent.scrollLeft()
                            }),
                            t && (this.containment && (this.relativeContainer ? (o = this.relativeContainer.offset(),
                            i = [this.containment[0] + o.left, this.containment[1] + o.top, this.containment[2] + o.left, this.containment[3] + o.top]) : i = this.containment,
                            e.pageX - this.offset.click.left < i[0] && (l = i[0] + this.offset.click.left),
                            e.pageY - this.offset.click.top < i[1] && (c = i[1] + this.offset.click.top),
                            e.pageX - this.offset.click.left > i[2] && (l = i[2] + this.offset.click.left),
                            e.pageY - this.offset.click.top > i[3] && (c = i[3] + this.offset.click.top)),
                            a.grid && (n = a.grid[1] ? this.originalPageY + Math.round((c - this.originalPageY) / a.grid[1]) * a.grid[1] : this.originalPageY,
                            c = i ? n - this.offset.click.top >= i[1] || n - this.offset.click.top > i[3] ? n : n - this.offset.click.top >= i[1] ? n - a.grid[1] : n + a.grid[1] : n,
                            r = a.grid[0] ? this.originalPageX + Math.round((l - this.originalPageX) / a.grid[0]) * a.grid[0] : this.originalPageX,
                            l = i ? r - this.offset.click.left >= i[0] || r - this.offset.click.left > i[2] ? r : r - this.offset.click.left >= i[0] ? r - a.grid[0] : r + a.grid[0] : r),
                            "y" === a.axis && (l = this.originalPageX),
                            "x" === a.axis && (c = this.originalPageY)),
                            {
                                top: c - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.offset.scroll.top : s ? 0 : this.offset.scroll.top),
                                left: l - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.offset.scroll.left : s ? 0 : this.offset.scroll.left)
                            }
                        },
                        _clear: function() {
                            this._removeClass(this.helper, "ui-draggable-dragging"),
                            this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(),
                            this.helper = null,
                            this.cancelHelperRemoval = !1,
                            this.destroyOnClear && this.destroy()
                        },
                        _trigger: function(t, i, o) {
                            return o = o || this._uiHash(),
                            e.ui.plugin.call(this, t, [i, o, this], !0),
                            /^(drag|start|stop)/.test(t) && (this.positionAbs = this._convertPositionTo("absolute"),
                            o.offset = this.positionAbs),
                            e.Widget.prototype._trigger.call(this, t, i, o)
                        },
                        plugins: {},
                        _uiHash: function() {
                            return {
                                helper: this.helper,
                                position: this.position,
                                originalPosition: this.originalPosition,
                                offset: this.positionAbs
                            }
                        }
                    }),
                    e.ui.plugin.add("draggable", "connectToSortable", {
                        start: function(t, i, o) {
                            var n = e.extend({}, i, {
                                item: o.element
                            });
                            o.sortables = [],
                            e(o.options.connectToSortable).each((function() {
                                var i = e(this).sortable("instance");
                                i && !i.options.disabled && (o.sortables.push(i),
                                i.refreshPositions(),
                                i._trigger("activate", t, n))
                            }
                            ))
                        },
                        stop: function(t, i, o) {
                            var n = e.extend({}, i, {
                                item: o.element
                            });
                            o.cancelHelperRemoval = !1,
                            e.each(o.sortables, (function() {
                                var e = this;
                                e.isOver ? (e.isOver = 0,
                                o.cancelHelperRemoval = !0,
                                e.cancelHelperRemoval = !1,
                                e._storedCSS = {
                                    position: e.placeholder.css("position"),
                                    top: e.placeholder.css("top"),
                                    left: e.placeholder.css("left")
                                },
                                e._mouseStop(t),
                                e.options.helper = e.options._helper) : (e.cancelHelperRemoval = !0,
                                e._trigger("deactivate", t, n))
                            }
                            ))
                        },
                        drag: function(t, i, o) {
                            e.each(o.sortables, (function() {
                                var n = !1
                                  , r = this;
                                r.positionAbs = o.positionAbs,
                                r.helperProportions = o.helperProportions,
                                r.offset.click = o.offset.click,
                                r._intersectsWith(r.containerCache) && (n = !0,
                                e.each(o.sortables, (function() {
                                    return this.positionAbs = o.positionAbs,
                                    this.helperProportions = o.helperProportions,
                                    this.offset.click = o.offset.click,
                                    this !== r && this._intersectsWith(this.containerCache) && e.contains(r.element[0], this.element[0]) && (n = !1),
                                    n
                                }
                                ))),
                                n ? (r.isOver || (r.isOver = 1,
                                o._parent = i.helper.parent(),
                                r.currentItem = i.helper.appendTo(r.element).data("ui-sortable-item", !0),
                                r.options._helper = r.options.helper,
                                r.options.helper = function() {
                                    return i.helper[0]
                                }
                                ,
                                t.target = r.currentItem[0],
                                r._mouseCapture(t, !0),
                                r._mouseStart(t, !0, !0),
                                r.offset.click.top = o.offset.click.top,
                                r.offset.click.left = o.offset.click.left,
                                r.offset.parent.left -= o.offset.parent.left - r.offset.parent.left,
                                r.offset.parent.top -= o.offset.parent.top - r.offset.parent.top,
                                o._trigger("toSortable", t),
                                o.dropped = r.element,
                                e.each(o.sortables, (function() {
                                    this.refreshPositions()
                                }
                                )),
                                o.currentItem = o.element,
                                r.fromOutside = o),
                                r.currentItem && (r._mouseDrag(t),
                                i.position = r.position)) : r.isOver && (r.isOver = 0,
                                r.cancelHelperRemoval = !0,
                                r.options._revert = r.options.revert,
                                r.options.revert = !1,
                                r._trigger("out", t, r._uiHash(r)),
                                r._mouseStop(t, !0),
                                r.options.revert = r.options._revert,
                                r.options.helper = r.options._helper,
                                r.placeholder && r.placeholder.remove(),
                                i.helper.appendTo(o._parent),
                                o._refreshOffsets(t),
                                i.position = o._generatePosition(t, !0),
                                o._trigger("fromSortable", t),
                                o.dropped = !1,
                                e.each(o.sortables, (function() {
                                    this.refreshPositions()
                                }
                                )))
                            }
                            ))
                        }
                    }),
                    e.ui.plugin.add("draggable", "cursor", {
                        start: function(t, i, o) {
                            var n = e("body")
                              , r = o.options;
                            n.css("cursor") && (r._cursor = n.css("cursor")),
                            n.css("cursor", r.cursor)
                        },
                        stop: function(t, i, o) {
                            var n = o.options;
                            n._cursor && e("body").css("cursor", n._cursor)
                        }
                    }),
                    e.ui.plugin.add("draggable", "opacity", {
                        start: function(t, i, o) {
                            var n = e(i.helper)
                              , r = o.options;
                            n.css("opacity") && (r._opacity = n.css("opacity")),
                            n.css("opacity", r.opacity)
                        },
                        stop: function(t, i, o) {
                            var n = o.options;
                            n._opacity && e(i.helper).css("opacity", n._opacity)
                        }
                    }),
                    e.ui.plugin.add("draggable", "scroll", {
                        start: function(e, t, i) {
                            i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)),
                            i.scrollParentNotHidden[0] !== i.document[0] && "HTML" !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset())
                        },
                        drag: function(t, i, o) {
                            var n = o.options
                              , r = !1
                              , a = o.scrollParentNotHidden[0]
                              , s = o.document[0];
                            a !== s && "HTML" !== a.tagName ? (n.axis && "x" === n.axis || (o.overflowOffset.top + a.offsetHeight - t.pageY < n.scrollSensitivity ? a.scrollTop = r = a.scrollTop + n.scrollSpeed : t.pageY - o.overflowOffset.top < n.scrollSensitivity && (a.scrollTop = r = a.scrollTop - n.scrollSpeed)),
                            n.axis && "y" === n.axis || (o.overflowOffset.left + a.offsetWidth - t.pageX < n.scrollSensitivity ? a.scrollLeft = r = a.scrollLeft + n.scrollSpeed : t.pageX - o.overflowOffset.left < n.scrollSensitivity && (a.scrollLeft = r = a.scrollLeft - n.scrollSpeed))) : (n.axis && "x" === n.axis || (t.pageY - e(s).scrollTop() < n.scrollSensitivity ? r = e(s).scrollTop(e(s).scrollTop() - n.scrollSpeed) : e(window).height() - (t.pageY - e(s).scrollTop()) < n.scrollSensitivity && (r = e(s).scrollTop(e(s).scrollTop() + n.scrollSpeed))),
                            n.axis && "y" === n.axis || (t.pageX - e(s).scrollLeft() < n.scrollSensitivity ? r = e(s).scrollLeft(e(s).scrollLeft() - n.scrollSpeed) : e(window).width() - (t.pageX - e(s).scrollLeft()) < n.scrollSensitivity && (r = e(s).scrollLeft(e(s).scrollLeft() + n.scrollSpeed)))),
                            !1 !== r && e.ui.ddmanager && !n.dropBehaviour && e.ui.ddmanager.prepareOffsets(o, t)
                        }
                    }),
                    e.ui.plugin.add("draggable", "snap", {
                        start: function(t, i, o) {
                            var n = o.options;
                            o.snapElements = [],
                            e(n.snap.constructor !== String ? n.snap.items || ":data(ui-draggable)" : n.snap).each((function() {
                                var t = e(this)
                                  , i = t.offset();
                                this !== o.element[0] && o.snapElements.push({
                                    item: this,
                                    width: t.outerWidth(),
                                    height: t.outerHeight(),
                                    top: i.top,
                                    left: i.left
                                })
                            }
                            ))
                        },
                        drag: function(t, i, o) {
                            var n, r, a, s, l, c, u, d, p, h, m = o.options, f = m.snapTolerance, g = i.offset.left, y = g + o.helperProportions.width, $ = i.offset.top, b = $ + o.helperProportions.height;
                            for (p = o.snapElements.length - 1; p >= 0; p--)
                                c = (l = o.snapElements[p].left - o.margins.left) + o.snapElements[p].width,
                                d = (u = o.snapElements[p].top - o.margins.top) + o.snapElements[p].height,
                                y < l - f || g > c + f || b < u - f || $ > d + f || !e.contains(o.snapElements[p].item.ownerDocument, o.snapElements[p].item) ? (o.snapElements[p].snapping && o.options.snap.release && o.options.snap.release.call(o.element, t, e.extend(o._uiHash(), {
                                    snapItem: o.snapElements[p].item
                                })),
                                o.snapElements[p].snapping = !1) : ("inner" !== m.snapMode && (n = Math.abs(u - b) <= f,
                                r = Math.abs(d - $) <= f,
                                a = Math.abs(l - y) <= f,
                                s = Math.abs(c - g) <= f,
                                n && (i.position.top = o._convertPositionTo("relative", {
                                    top: u - o.helperProportions.height,
                                    left: 0
                                }).top),
                                r && (i.position.top = o._convertPositionTo("relative", {
                                    top: d,
                                    left: 0
                                }).top),
                                a && (i.position.left = o._convertPositionTo("relative", {
                                    top: 0,
                                    left: l - o.helperProportions.width
                                }).left),
                                s && (i.position.left = o._convertPositionTo("relative", {
                                    top: 0,
                                    left: c
                                }).left)),
                                h = n || r || a || s,
                                "outer" !== m.snapMode && (n = Math.abs(u - $) <= f,
                                r = Math.abs(d - b) <= f,
                                a = Math.abs(l - g) <= f,
                                s = Math.abs(c - y) <= f,
                                n && (i.position.top = o._convertPositionTo("relative", {
                                    top: u,
                                    left: 0
                                }).top),
                                r && (i.position.top = o._convertPositionTo("relative", {
                                    top: d - o.helperProportions.height,
                                    left: 0
                                }).top),
                                a && (i.position.left = o._convertPositionTo("relative", {
                                    top: 0,
                                    left: l
                                }).left),
                                s && (i.position.left = o._convertPositionTo("relative", {
                                    top: 0,
                                    left: c - o.helperProportions.width
                                }).left)),
                                !o.snapElements[p].snapping && (n || r || a || s || h) && o.options.snap.snap && o.options.snap.snap.call(o.element, t, e.extend(o._uiHash(), {
                                    snapItem: o.snapElements[p].item
                                })),
                                o.snapElements[p].snapping = n || r || a || s || h)
                        }
                    }),
                    e.ui.plugin.add("draggable", "stack", {
                        start: function(t, i, o) {
                            var n, r = o.options, a = e.makeArray(e(r.stack)).sort((function(t, i) {
                                return (parseInt(e(t).css("zIndex"), 10) || 0) - (parseInt(e(i).css("zIndex"), 10) || 0)
                            }
                            ));
                            a.length && (n = parseInt(e(a[0]).css("zIndex"), 10) || 0,
                            e(a).each((function(t) {
                                e(this).css("zIndex", n + t)
                            }
                            )),
                            this.css("zIndex", n + a.length))
                        }
                    }),
                    e.ui.plugin.add("draggable", "zIndex", {
                        start: function(t, i, o) {
                            var n = e(i.helper)
                              , r = o.options;
                            n.css("zIndex") && (r._zIndex = n.css("zIndex")),
                            n.css("zIndex", r.zIndex)
                        },
                        stop: function(t, i, o) {
                            var n = o.options;
                            n._zIndex && e(i.helper).css("zIndex", n._zIndex)
                        }
                    }),
                    e.ui.draggable
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        177: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(592), i(891)],
                void 0 === (r = "function" == typeof (o = function(e) {
                    var t = !1;
                    return e(document).on("mouseup", (function() {
                        t = !1
                    }
                    )),
                    e.widget("ui.mouse", {
                        version: "1.14.0",
                        options: {
                            cancel: "input, textarea, button, select, option",
                            distance: 1,
                            delay: 0
                        },
                        _mouseInit: function() {
                            var t = this;
                            this.element.on("mousedown." + this.widgetName, (function(e) {
                                return t._mouseDown(e)
                            }
                            )).on("click." + this.widgetName, (function(i) {
                                if (!0 === e.data(i.target, t.widgetName + ".preventClickEvent"))
                                    return e.removeData(i.target, t.widgetName + ".preventClickEvent"),
                                    i.stopImmediatePropagation(),
                                    !1
                            }
                            )),
                            this.started = !1
                        },
                        _mouseDestroy: function() {
                            this.element.off("." + this.widgetName),
                            this._mouseMoveDelegate && this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate)
                        },
                        _mouseDown: function(i) {
                            if (!t) {
                                this._mouseMoved = !1,
                                this._mouseStarted && this._mouseUp(i),
                                this._mouseDownEvent = i;
                                var o = this
                                  , n = 1 === i.which
                                  , r = "string" == typeof this.options.cancel && e(i.target).closest(this.options.cancel).length;
                                return !(n && !r && this._mouseCapture(i) && (this.mouseDelayMet = !this.options.delay,
                                this.mouseDelayMet || (this._mouseDelayTimer = setTimeout((function() {
                                    o.mouseDelayMet = !0
                                }
                                ), this.options.delay)),
                                this._mouseDistanceMet(i) && this._mouseDelayMet(i) && (this._mouseStarted = !1 !== this._mouseStart(i),
                                !this._mouseStarted) ? (i.preventDefault(),
                                0) : (!0 === e.data(i.target, this.widgetName + ".preventClickEvent") && e.removeData(i.target, this.widgetName + ".preventClickEvent"),
                                this._mouseMoveDelegate = function(e) {
                                    return o._mouseMove(e)
                                }
                                ,
                                this._mouseUpDelegate = function(e) {
                                    return o._mouseUp(e)
                                }
                                ,
                                this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate),
                                i.preventDefault(),
                                t = !0,
                                0)))
                            }
                        },
                        _mouseMove: function(e) {
                            if (this._mouseMoved && !e.which)
                                if (e.originalEvent.altKey || e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.shiftKey)
                                    this.ignoreMissingWhich = !0;
                                else if (!this.ignoreMissingWhich)
                                    return this._mouseUp(e);
                            return (e.which || e.button) && (this._mouseMoved = !0),
                            this._mouseStarted ? (this._mouseDrag(e),
                            e.preventDefault()) : (this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = !1 !== this._mouseStart(this._mouseDownEvent, e),
                            this._mouseStarted ? this._mouseDrag(e) : this._mouseUp(e)),
                            !this._mouseStarted)
                        },
                        _mouseUp: function(i) {
                            this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate),
                            this._mouseStarted && (this._mouseStarted = !1,
                            i.target === this._mouseDownEvent.target && e.data(i.target, this.widgetName + ".preventClickEvent", !0),
                            this._mouseStop(i)),
                            this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer),
                            delete this._mouseDelayTimer),
                            this.ignoreMissingWhich = !1,
                            t = !1,
                            i.preventDefault()
                        },
                        _mouseDistanceMet: function(e) {
                            return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance
                        },
                        _mouseDelayMet: function() {
                            return this.mouseDelayMet
                        },
                        _mouseStart: function() {},
                        _mouseDrag: function() {},
                        _mouseStop: function() {},
                        _mouseCapture: function() {
                            return !0
                        }
                    })
                }
                ) ? o.apply(t, n) : o) || (e.exports = r)
            }()
        }
        ,
        707: (e, t, i) => {
            var o, n, r;
            !function(a) {
                "use strict";
                n = [i(755), i(177), i(64), i(624), i(592), i(891)],
                o = function(e) {
                    return e.widget("ui.resizable", e.ui.mouse, {
                        version: "1.14.0",
                        widgetEventPrefix: "resize",
                        options: {
                            alsoResize: !1,
                            animate: !1,
                            animateDuration: "slow",
                            animateEasing: "swing",
                            aspectRatio: !1,
                            autoHide: !1,
                            classes: {
                                "ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
                            },
                            containment: !1,
                            ghost: !1,
                            grid: !1,
                            handles: "e,s,se",
                            helper: !1,
                            maxHeight: null,
                            maxWidth: null,
                            minHeight: 10,
                            minWidth: 10,
                            zIndex: 90,
                            resize: null,
                            start: null,
                            stop: null
                        },
                        _num: function(e) {
                            return parseFloat(e) || 0
                        },
                        _isNumber: function(e) {
                            return !isNaN(parseFloat(e))
                        },
                        _hasScroll: function(t, i) {
                            if ("hidden" === e(t).css("overflow"))
                                return !1;
                            var o = i && "left" === i ? "scrollLeft" : "scrollTop"
                              , n = !1;
                            if (t[o] > 0)
                                return !0;
                            try {
                                t[o] = 1,
                                n = t[o] > 0,
                                t[o] = 0
                            } catch (e) {}
                            return n
                        },
                        _create: function() {
                            var t, i = this.options, o = this;
                            this._addClass("ui-resizable"),
                            e.extend(this, {
                                _aspectRatio: !!i.aspectRatio,
                                aspectRatio: i.aspectRatio,
                                originalElement: this.element,
                                _proportionallyResizeElements: [],
                                _helper: i.helper || i.ghost || i.animate ? i.helper || "ui-resizable-helper" : null
                            }),
                            this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(e("<div class='ui-wrapper'></div>").css({
                                overflow: "hidden",
                                position: this.element.css("position"),
                                width: this.element.outerWidth(),
                                height: this.element.outerHeight(),
                                top: this.element.css("top"),
                                left: this.element.css("left")
                            })),
                            this.element = this.element.parent().data("ui-resizable", this.element.resizable("instance")),
                            this.elementIsWrapper = !0,
                            t = {
                                marginTop: this.originalElement.css("marginTop"),
                                marginRight: this.originalElement.css("marginRight"),
                                marginBottom: this.originalElement.css("marginBottom"),
                                marginLeft: this.originalElement.css("marginLeft")
                            },
                            this.element.css(t),
                            this.originalResizeStyle = this.originalElement.css("resize"),
                            this.originalElement.css("resize", "none"),
                            this._proportionallyResizeElements.push(this.originalElement.css({
                                position: "static",
                                zoom: 1,
                                display: "block"
                            })),
                            this._proportionallyResize()),
                            this._setupHandles(),
                            i.autoHide && e(this.element).on("mouseenter", (function() {
                                i.disabled || (o._removeClass("ui-resizable-autohide"),
                                o._handles.show())
                            }
                            )).on("mouseleave", (function() {
                                i.disabled || o.resizing || (o._addClass("ui-resizable-autohide"),
                                o._handles.hide())
                            }
                            )),
                            this._mouseInit()
                        },
                        _destroy: function() {
                            this._mouseDestroy(),
                            this._addedHandles.remove();
                            var t, i = function(t) {
                                e(t).removeData("resizable").removeData("ui-resizable").off(".resizable")
                            };
                            return this.elementIsWrapper && (i(this.element),
                            t = this.element,
                            this.originalElement.css({
                                position: t.css("position"),
                                width: t.outerWidth(),
                                height: t.outerHeight(),
                                top: t.css("top"),
                                left: t.css("left")
                            }).insertAfter(t),
                            t.remove()),
                            this.originalElement.css("resize", this.originalResizeStyle),
                            i(this.originalElement),
                            this
                        },
                        _setOption: function(e, t) {
                            switch (this._super(e, t),
                            e) {
                            case "handles":
                                this._removeHandles(),
                                this._setupHandles();
                                break;
                            case "aspectRatio":
                                this._aspectRatio = !!t
                            }
                        },
                        _setupHandles: function() {
                            var t, i, o, n, r, a = this.options, s = this;
                            if (this.handles = a.handles || (e(".ui-resizable-handle", this.element).length ? {
                                n: ".ui-resizable-n",
                                e: ".ui-resizable-e",
                                s: ".ui-resizable-s",
                                w: ".ui-resizable-w",
                                se: ".ui-resizable-se",
                                sw: ".ui-resizable-sw",
                                ne: ".ui-resizable-ne",
                                nw: ".ui-resizable-nw"
                            } : "e,s,se"),
                            this._handles = e(),
                            this._addedHandles = e(),
                            this.handles.constructor === String)
                                for ("all" === this.handles && (this.handles = "n,e,s,w,se,sw,ne,nw"),
                                o = this.handles.split(","),
                                this.handles = {},
                                i = 0; i < o.length; i++)
                                    n = "ui-resizable-" + (t = String.prototype.trim.call(o[i])),
                                    r = e("<div>"),
                                    this._addClass(r, "ui-resizable-handle " + n),
                                    r.css({
                                        zIndex: a.zIndex
                                    }),
                                    this.handles[t] = ".ui-resizable-" + t,
                                    this.element.children(this.handles[t]).length || (this.element.append(r),
                                    this._addedHandles = this._addedHandles.add(r));
                            this._renderAxis = function(t) {
                                var i, o, n, r;
                                for (i in t = t || this.element,
                                this.handles)
                                    this.handles[i].constructor === String ? this.handles[i] = this.element.children(this.handles[i]).first().show() : (this.handles[i].jquery || this.handles[i].nodeType) && (this.handles[i] = e(this.handles[i]),
                                    this._on(this.handles[i], {
                                        mousedown: s._mouseDown
                                    })),
                                    this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (o = e(this.handles[i], this.element),
                                    r = /sw|ne|nw|se|n|s/.test(i) ? o.outerHeight() : o.outerWidth(),
                                    n = ["padding", /ne|nw|n/.test(i) ? "Top" : /se|sw|s/.test(i) ? "Bottom" : /^e$/.test(i) ? "Right" : "Left"].join(""),
                                    t.css(n, r),
                                    this._proportionallyResize()),
                                    this._handles = this._handles.add(this.handles[i])
                            }
                            ,
                            this._renderAxis(this.element),
                            this._handles = this._handles.add(this.element.find(".ui-resizable-handle")),
                            this._handles.disableSelection(),
                            this._handles.on("mouseover", (function() {
                                s.resizing || (this.className && (r = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),
                                s.axis = r && r[1] ? r[1] : "se")
                            }
                            )),
                            a.autoHide && (this._handles.hide(),
                            this._addClass("ui-resizable-autohide"))
                        },
                        _removeHandles: function() {
                            this._addedHandles.remove()
                        },
                        _mouseCapture: function(t) {
                            var i, o, n = !1;
                            for (i in this.handles)
                                ((o = e(this.handles[i])[0]) === t.target || e.contains(o, t.target)) && (n = !0);
                            return !this.options.disabled && n
                        },
                        _mouseStart: function(t) {
                            var i, o, n, r = this.options, a = this.element;
                            return this.resizing = !0,
                            this._renderProxy(),
                            i = this._num(this.helper.css("left")),
                            o = this._num(this.helper.css("top")),
                            r.containment && (i += e(r.containment).scrollLeft() || 0,
                            o += e(r.containment).scrollTop() || 0),
                            this.offset = this.helper.offset(),
                            this.position = {
                                left: i,
                                top: o
                            },
                            this.size = this._helper ? {
                                width: this.helper.width(),
                                height: this.helper.height()
                            } : {
                                width: a.width(),
                                height: a.height()
                            },
                            this.originalSize = this._helper ? {
                                width: a.outerWidth(),
                                height: a.outerHeight()
                            } : {
                                width: a.width(),
                                height: a.height()
                            },
                            this.sizeDiff = {
                                width: a.outerWidth() - a.width(),
                                height: a.outerHeight() - a.height()
                            },
                            this.originalPosition = {
                                left: i,
                                top: o
                            },
                            this.originalMousePosition = {
                                left: t.pageX,
                                top: t.pageY
                            },
                            this.aspectRatio = "number" == typeof r.aspectRatio ? r.aspectRatio : this.originalSize.width / this.originalSize.height || 1,
                            n = e(".ui-resizable-" + this.axis).css("cursor"),
                            e("body").css("cursor", "auto" === n ? this.axis + "-resize" : n),
                            this._addClass("ui-resizable-resizing"),
                            this._propagate("start", t),
                            !0
                        },
                        _mouseDrag: function(t) {
                            var i, o, n = this.originalMousePosition, r = this.axis, a = t.pageX - n.left || 0, s = t.pageY - n.top || 0, l = this._change[r];
                            return this._updatePrevProperties(),
                            !!l && (i = l.apply(this, [t, a, s]),
                            this._updateVirtualBoundaries(t.shiftKey),
                            (this._aspectRatio || t.shiftKey) && (i = this._updateRatio(i, t)),
                            i = this._respectSize(i, t),
                            this._updateCache(i),
                            this._propagate("resize", t),
                            o = this._applyChanges(),
                            !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(),
                            e.isEmptyObject(o) || (this._updatePrevProperties(),
                            this._trigger("resize", t, this.ui()),
                            this._applyChanges()),
                            !1)
                        },
                        _mouseStop: function(t) {
                            this.resizing = !1;
                            var i, o, n, r, a, s, l, c = this.options, u = this;
                            return this._helper && (n = (o = (i = this._proportionallyResizeElements).length && /textarea/i.test(i[0].nodeName)) && this._hasScroll(i[0], "left") ? 0 : u.sizeDiff.height,
                            r = o ? 0 : u.sizeDiff.width,
                            a = {
                                width: u.helper.width() - r,
                                height: u.helper.height() - n
                            },
                            s = parseFloat(u.element.css("left")) + (u.position.left - u.originalPosition.left) || null,
                            l = parseFloat(u.element.css("top")) + (u.position.top - u.originalPosition.top) || null,
                            c.animate || this.element.css(e.extend(a, {
                                top: l,
                                left: s
                            })),
                            u.helper.height(u.size.height),
                            u.helper.width(u.size.width),
                            this._helper && !c.animate && this._proportionallyResize()),
                            e("body").css("cursor", "auto"),
                            this._removeClass("ui-resizable-resizing"),
                            this._propagate("stop", t),
                            this._helper && this.helper.remove(),
                            !1
                        },
                        _updatePrevProperties: function() {
                            this.prevPosition = {
                                top: this.position.top,
                                left: this.position.left
                            },
                            this.prevSize = {
                                width: this.size.width,
                                height: this.size.height
                            }
                        },
                        _applyChanges: function() {
                            var e = {};
                            return this.position.top !== this.prevPosition.top && (e.top = this.position.top + "px"),
                            this.position.left !== this.prevPosition.left && (e.left = this.position.left + "px"),
                            this.helper.css(e),
                            this.size.width !== this.prevSize.width && (e.width = this.size.width + "px",
                            this.helper.width(e.width)),
                            this.size.height !== this.prevSize.height && (e.height = this.size.height + "px",
                            this.helper.height(e.height)),
                            e
                        },
                        _updateVirtualBoundaries: function(e) {
                            var t, i, o, n, r, a = this.options;
                            r = {
                                minWidth: this._isNumber(a.minWidth) ? a.minWidth : 0,
                                maxWidth: this._isNumber(a.maxWidth) ? a.maxWidth : 1 / 0,
                                minHeight: this._isNumber(a.minHeight) ? a.minHeight : 0,
                                maxHeight: this._isNumber(a.maxHeight) ? a.maxHeight : 1 / 0
                            },
                            (this._aspectRatio || e) && (t = r.minHeight * this.aspectRatio,
                            o = r.minWidth / this.aspectRatio,
                            i = r.maxHeight * this.aspectRatio,
                            n = r.maxWidth / this.aspectRatio,
                            t > r.minWidth && (r.minWidth = t),
                            o > r.minHeight && (r.minHeight = o),
                            i < r.maxWidth && (r.maxWidth = i),
                            n < r.maxHeight && (r.maxHeight = n)),
                            this._vBoundaries = r
                        },
                        _updateCache: function(e) {
                            this.offset = this.helper.offset(),
                            this._isNumber(e.left) && (this.position.left = e.left),
                            this._isNumber(e.top) && (this.position.top = e.top),
                            this._isNumber(e.height) && (this.size.height = e.height),
                            this._isNumber(e.width) && (this.size.width = e.width)
                        },
                        _updateRatio: function(e) {
                            var t = this.position
                              , i = this.size
                              , o = this.axis;
                            return this._isNumber(e.height) ? e.width = e.height * this.aspectRatio : this._isNumber(e.width) && (e.height = e.width / this.aspectRatio),
                            "sw" === o && (e.left = t.left + (i.width - e.width),
                            e.top = null),
                            "nw" === o && (e.top = t.top + (i.height - e.height),
                            e.left = t.left + (i.width - e.width)),
                            e
                        },
                        _respectSize: function(e) {
                            var t = this._vBoundaries
                              , i = this.axis
                              , o = this._isNumber(e.width) && t.maxWidth && t.maxWidth < e.width
                              , n = this._isNumber(e.height) && t.maxHeight && t.maxHeight < e.height
                              , r = this._isNumber(e.width) && t.minWidth && t.minWidth > e.width
                              , a = this._isNumber(e.height) && t.minHeight && t.minHeight > e.height
                              , s = this.originalPosition.left + this.originalSize.width
                              , l = this.originalPosition.top + this.originalSize.height
                              , c = /sw|nw|w/.test(i)
                              , u = /nw|ne|n/.test(i);
                            return r && (e.width = t.minWidth),
                            a && (e.height = t.minHeight),
                            o && (e.width = t.maxWidth),
                            n && (e.height = t.maxHeight),
                            r && c && (e.left = s - t.minWidth),
                            o && c && (e.left = s - t.maxWidth),
                            a && u && (e.top = l - t.minHeight),
                            n && u && (e.top = l - t.maxHeight),
                            e.width || e.height || e.left || !e.top ? e.width || e.height || e.top || !e.left || (e.left = null) : e.top = null,
                            e
                        },
                        _getPaddingPlusBorderDimensions: function(e) {
                            for (var t = 0, i = [], o = [e.css("borderTopWidth"), e.css("borderRightWidth"), e.css("borderBottomWidth"), e.css("borderLeftWidth")], n = [e.css("paddingTop"), e.css("paddingRight"), e.css("paddingBottom"), e.css("paddingLeft")]; t < 4; t++)
                                i[t] = parseFloat(o[t]) || 0,
                                i[t] += parseFloat(n[t]) || 0;
                            return {
                                height: i[0] + i[2],
                                width: i[1] + i[3]
                            }
                        },
                        _proportionallyResize: function() {
                            if (this._proportionallyResizeElements.length)
                                for (var e, t = 0, i = this.helper || this.element; t < this._proportionallyResizeElements.length; t++)
                                    e = this._proportionallyResizeElements[t],
                                    this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(e)),
                                    e.css({
                                        height: i.height() - this.outerDimensions.height || 0,
                                        width: i.width() - this.outerDimensions.width || 0
                                    })
                        },
                        _renderProxy: function() {
                            var t = this.element
                              , i = this.options;
                            this.elementOffset = t.offset(),
                            this._helper ? (this.helper = this.helper || e("<div></div>").css({
                                overflow: "hidden"
                            }),
                            this._addClass(this.helper, this._helper),
                            this.helper.css({
                                width: this.element.outerWidth(),
                                height: this.element.outerHeight(),
                                position: "absolute",
                                left: this.elementOffset.left + "px",
                                top: this.elementOffset.top + "px",
                                zIndex: ++i.zIndex
                            }),
                            this.helper.appendTo("body").disableSelection()) : this.helper = this.element
                        },
                        _change: {
                            e: function(e, t) {
                                return {
                                    width: this.originalSize.width + t
                                }
                            },
                            w: function(e, t) {
                                var i = this.originalSize;
                                return {
                                    left: this.originalPosition.left + t,
                                    width: i.width - t
                                }
                            },
                            n: function(e, t, i) {
                                var o = this.originalSize;
                                return {
                                    top: this.originalPosition.top + i,
                                    height: o.height - i
                                }
                            },
                            s: function(e, t, i) {
                                return {
                                    height: this.originalSize.height + i
                                }
                            },
                            se: function(t, i, o) {
                                return e.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [t, i, o]))
                            },
                            sw: function(t, i, o) {
                                return e.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [t, i, o]))
                            },
                            ne: function(t, i, o) {
                                return e.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [t, i, o]))
                            },
                            nw: function(t, i, o) {
                                return e.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [t, i, o]))
                            }
                        },
                        _propagate: function(t, i) {
                            e.ui.plugin.call(this, t, [i, this.ui()]),
                            "resize" !== t && this._trigger(t, i, this.ui())
                        },
                        plugins: {},
                        ui: function() {
                            return {
                                originalElement: this.originalElement,
                                element: this.element,
                                helper: this.helper,
                                position: this.position,
                                size: this.size,
                                originalSize: this.originalSize,
                                originalPosition: this.originalPosition
                            }
                        }
                    }),
                    e.ui.plugin.add("resizable", "animate", {
                        stop: function(t) {
                            var i = e(this).resizable("instance")
                              , o = i.options
                              , n = i._proportionallyResizeElements
                              , r = n.length && /textarea/i.test(n[0].nodeName)
                              , a = r && i._hasScroll(n[0], "left") ? 0 : i.sizeDiff.height
                              , s = r ? 0 : i.sizeDiff.width
                              , l = {
                                width: i.size.width - s,
                                height: i.size.height - a
                            }
                              , c = parseFloat(i.element.css("left")) + (i.position.left - i.originalPosition.left) || null
                              , u = parseFloat(i.element.css("top")) + (i.position.top - i.originalPosition.top) || null;
                            i.element.animate(e.extend(l, u && c ? {
                                top: u,
                                left: c
                            } : {}), {
                                duration: o.animateDuration,
                                easing: o.animateEasing,
                                step: function() {
                                    var o = {
                                        width: parseFloat(i.element.css("width")),
                                        height: parseFloat(i.element.css("height")),
                                        top: parseFloat(i.element.css("top")),
                                        left: parseFloat(i.element.css("left"))
                                    };
                                    n && n.length && e(n[0]).css({
                                        width: o.width,
                                        height: o.height
                                    }),
                                    i._updateCache(o),
                                    i._propagate("resize", t)
                                }
                            })
                        }
                    }),
                    e.ui.plugin.add("resizable", "containment", {
                        start: function() {
                            var t, i, o, n, r, a, s, l = e(this).resizable("instance"), c = l.options, u = l.element, d = c.containment, p = d instanceof e ? d.get(0) : /parent/.test(d) ? u.parent().get(0) : d;
                            p && (l.containerElement = e(p),
                            /document/.test(d) || d === document ? (l.containerOffset = {
                                left: 0,
                                top: 0
                            },
                            l.containerPosition = {
                                left: 0,
                                top: 0
                            },
                            l.parentData = {
                                element: e(document),
                                left: 0,
                                top: 0,
                                width: e(document).width(),
                                height: e(document).height() || document.body.parentNode.scrollHeight
                            }) : (t = e(p),
                            i = [],
                            e(["Top", "Right", "Left", "Bottom"]).each((function(e, o) {
                                i[e] = l._num(t.css("padding" + o))
                            }
                            )),
                            l.containerOffset = t.offset(),
                            l.containerPosition = t.position(),
                            l.containerSize = {
                                height: t.innerHeight() - i[3],
                                width: t.innerWidth() - i[1]
                            },
                            o = l.containerOffset,
                            n = l.containerSize.height,
                            r = l.containerSize.width,
                            a = l._hasScroll(p, "left") ? p.scrollWidth : r,
                            s = l._hasScroll(p) ? p.scrollHeight : n,
                            l.parentData = {
                                element: p,
                                left: o.left,
                                top: o.top,
                                width: a,
                                height: s
                            }))
                        },
                        resize: function(t) {
                            var i, o, n, r, a = e(this).resizable("instance"), s = a.options, l = a.containerOffset, c = a.position, u = a._aspectRatio || t.shiftKey, d = {
                                top: 0,
                                left: 0
                            }, p = a.containerElement, h = !0;
                            p[0] !== document && /static/.test(p.css("position")) && (d = l),
                            c.left < (a._helper ? l.left : 0) && (a.size.width = a.size.width + (a._helper ? a.position.left - l.left : a.position.left - d.left),
                            u && (a.size.height = a.size.width / a.aspectRatio,
                            h = !1),
                            a.position.left = s.helper ? l.left : 0),
                            c.top < (a._helper ? l.top : 0) && (a.size.height = a.size.height + (a._helper ? a.position.top - l.top : a.position.top),
                            u && (a.size.width = a.size.height * a.aspectRatio,
                            h = !1),
                            a.position.top = a._helper ? l.top : 0),
                            n = a.containerElement.get(0) === a.element.parent().get(0),
                            r = /relative|absolute/.test(a.containerElement.css("position")),
                            n && r ? (a.offset.left = a.parentData.left + a.position.left,
                            a.offset.top = a.parentData.top + a.position.top) : (a.offset.left = a.element.offset().left,
                            a.offset.top = a.element.offset().top),
                            i = Math.abs(a.sizeDiff.width + (a._helper ? a.offset.left - d.left : a.offset.left - l.left)),
                            o = Math.abs(a.sizeDiff.height + (a._helper ? a.offset.top - d.top : a.offset.top - l.top)),
                            i + a.size.width >= a.parentData.width && (a.size.width = a.parentData.width - i,
                            u && (a.size.height = a.size.width / a.aspectRatio,
                            h = !1)),
                            o + a.size.height >= a.parentData.height && (a.size.height = a.parentData.height - o,
                            u && (a.size.width = a.size.height * a.aspectRatio,
                            h = !1)),
                            h || (a.position.left = a.prevPosition.left,
                            a.position.top = a.prevPosition.top,
                            a.size.width = a.prevSize.width,
                            a.size.height = a.prevSize.height)
                        },
                        stop: function() {
                            var t = e(this).resizable("instance")
                              , i = t.options
                              , o = t.containerOffset
                              , n = t.containerPosition
                              , r = t.containerElement
                              , a = e(t.helper)
                              , s = a.offset()
                              , l = a.outerWidth() - t.sizeDiff.width
                              , c = a.outerHeight() - t.sizeDiff.height;
                            t._helper && !i.animate && /relative/.test(r.css("position")) && e(this).css({
                                left: s.left - n.left - o.left,
                                width: l,
                                height: c
                            }),
                            t._helper && !i.animate && /static/.test(r.css("position")) && e(this).css({
                                left: s.left - n.left - o.left,
                                width: l,
                                height: c
                            })
                        }
                    }),
                    e.ui.plugin.add("resizable", "alsoResize", {
                        start: function() {
                            var t = e(this).resizable("instance").options;
                            e(t.alsoResize).each((function() {
                                var t = e(this);
                                t.data("ui-resizable-alsoresize", {
                                    width: parseFloat(t.css("width")),
                                    height: parseFloat(t.css("height")),
                                    left: parseFloat(t.css("left")),
                                    top: parseFloat(t.css("top"))
                                })
                            }
                            ))
                        },
                        resize: function(t, i) {
                            var o = e(this).resizable("instance")
                              , n = o.options
                              , r = o.originalSize
                              , a = o.originalPosition
                              , s = {
                                height: o.size.height - r.height || 0,
                                width: o.size.width - r.width || 0,
                                top: o.position.top - a.top || 0,
                                left: o.position.left - a.left || 0
                            };
                            e(n.alsoResize).each((function() {
                                var t = e(this)
                                  , o = e(this).data("ui-resizable-alsoresize")
                                  , n = {}
                                  , r = t.parents(i.originalElement[0]).length ? ["width", "height"] : ["width", "height", "top", "left"];
                                e.each(r, (function(e, t) {
                                    var i = (o[t] || 0) + (s[t] || 0);
                                    i && i >= 0 && (n[t] = i || null)
                                }
                                )),
                                t.css(n)
                            }
                            ))
                        },
                        stop: function() {
                            e(this).removeData("ui-resizable-alsoresize")
                        }
                    }),
                    e.ui.plugin.add("resizable", "ghost", {
                        start: function() {
                            var t = e(this).resizable("instance")
                              , i = t.size;
                            t.ghost = t.originalElement.clone(),
                            t.ghost.css({
                                opacity: .25,
                                display: "block",
                                position: "relative",
                                height: i.height,
                                width: i.width,
                                margin: 0,
                                left: 0,
                                top: 0
                            }),
                            t._addClass(t.ghost, "ui-resizable-ghost"),
                            !0 === e.uiBackCompat && "string" == typeof t.options.ghost && t.ghost.addClass(this.options.ghost),
                            t.ghost.appendTo(t.helper)
                        },
                        resize: function() {
                            var t = e(this).resizable("instance");
                            t.ghost && t.ghost.css({
                                position: "relative",
                                height: t.size.height,
                                width: t.size.width
                            })
                        },
                        stop: function() {
                            var t = e(this).resizable("instance");
                            t.ghost && t.helper && t.helper.get(0).removeChild(t.ghost.get(0))
                        }
                    }),
                    e.ui.plugin.add("resizable", "grid", {
                        resize: function() {
                            var t, i = e(this).resizable("instance"), o = i.options, n = i.size, r = i.originalSize, a = i.originalPosition, s = i.axis, l = "number" == typeof o.grid ? [o.grid, o.grid] : o.grid, c = l[0] || 1, u = l[1] || 1, d = Math.round((n.width - r.width) / c) * c, p = Math.round((n.height - r.height) / u) * u, h = r.width + d, m = r.height + p, f = o.maxWidth && o.maxWidth < h, g = o.maxHeight && o.maxHeight < m, y = o.minWidth && o.minWidth > h, $ = o.minHeight && o.minHeight > m;
                            o.grid = l,
                            y && (h += c),
                            $ && (m += u),
                            f && (h -= c),
                            g && (m -= u),
                            /^(se|s|e)$/.test(s) ? (i.size.width = h,
                            i.size.height = m) : /^(ne)$/.test(s) ? (i.size.width = h,
                            i.size.height = m,
                            i.position.top = a.top - p) : /^(sw)$/.test(s) ? (i.size.width = h,
                            i.size.height = m,
                            i.position.left = a.left - d) : ((m - u <= 0 || h - c <= 0) && (t = i._getPaddingPlusBorderDimensions(this)),
                            m - u > 0 ? (i.size.height = m,
                            i.position.top = a.top - p) : (m = u - t.height,
                            i.size.height = m,
                            i.position.top = a.top + r.height - m),
                            h - c > 0 ? (i.size.width = h,
                            i.position.left = a.left - d) : (h = c - t.width,
                            i.size.width = h,
                            i.position.left = a.left + r.width - h))
                        }
                    }),
                    e.ui.resizable
                }
                ,
                void 0 === (r = o.apply(t, n)) || (e.exports = r)
            }()
        }
        ,
        755: function(e, t) {
            var i;
            !function(t, i) {
                "use strict";
                "object" == typeof e.exports ? e.exports = t.document ? i(t, !0) : function(e) {
                    if (!e.document)
                        throw new Error("jQuery requires a window with a document");
                    return i(e)
                }
                : i(t)
            }("undefined" != typeof window ? window : this, (function(o, n) {
                "use strict";
                var r = []
                  , a = Object.getPrototypeOf
                  , s = r.slice
                  , l = r.flat ? function(e) {
                    return r.flat.call(e)
                }
                : function(e) {
                    return r.concat.apply([], e)
                }
                  , c = r.push
                  , u = r.indexOf
                  , d = {}
                  , p = d.toString
                  , h = d.hasOwnProperty
                  , m = h.toString
                  , f = m.call(Object)
                  , g = {}
                  , y = function(e) {
                    return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item
                }
                  , $ = function(e) {
                    return null != e && e === e.window
                }
                  , b = o.document
                  , v = {
                    type: !0,
                    src: !0,
                    nonce: !0,
                    noModule: !0
                };
                function x(e, t, i) {
                    var o, n, r = (i = i || b).createElement("script");
                    if (r.text = e,
                    t)
                        for (o in v)
                            (n = t[o] || t.getAttribute && t.getAttribute(o)) && r.setAttribute(o, n);
                    i.head.appendChild(r).parentNode.removeChild(r)
                }
                function w(e) {
                    return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? d[p.call(e)] || "object" : typeof e
                }
                var S = "3.7.1"
                  , _ = /HTML$/i
                  , k = function(e, t) {
                    return new k.fn.init(e,t)
                };
                function C(e) {
                    var t = !!e && "length"in e && e.length
                      , i = w(e);
                    return !y(e) && !$(e) && ("array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
                }
                function T(e, t) {
                    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
                }
                k.fn = k.prototype = {
                    jquery: S,
                    constructor: k,
                    length: 0,
                    toArray: function() {
                        return s.call(this)
                    },
                    get: function(e) {
                        return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e]
                    },
                    pushStack: function(e) {
                        var t = k.merge(this.constructor(), e);
                        return t.prevObject = this,
                        t
                    },
                    each: function(e) {
                        return k.each(this, e)
                    },
                    map: function(e) {
                        return this.pushStack(k.map(this, (function(t, i) {
                            return e.call(t, i, t)
                        }
                        )))
                    },
                    slice: function() {
                        return this.pushStack(s.apply(this, arguments))
                    },
                    first: function() {
                        return this.eq(0)
                    },
                    last: function() {
                        return this.eq(-1)
                    },
                    even: function() {
                        return this.pushStack(k.grep(this, (function(e, t) {
                            return (t + 1) % 2
                        }
                        )))
                    },
                    odd: function() {
                        return this.pushStack(k.grep(this, (function(e, t) {
                            return t % 2
                        }
                        )))
                    },
                    eq: function(e) {
                        var t = this.length
                          , i = +e + (e < 0 ? t : 0);
                        return this.pushStack(i >= 0 && i < t ? [this[i]] : [])
                    },
                    end: function() {
                        return this.prevObject || this.constructor()
                    },
                    push: c,
                    sort: r.sort,
                    splice: r.splice
                },
                k.extend = k.fn.extend = function() {
                    var e, t, i, o, n, r, a = arguments[0] || {}, s = 1, l = arguments.length, c = !1;
                    for ("boolean" == typeof a && (c = a,
                    a = arguments[s] || {},
                    s++),
                    "object" == typeof a || y(a) || (a = {}),
                    s === l && (a = this,
                    s--); s < l; s++)
                        if (null != (e = arguments[s]))
                            for (t in e)
                                o = e[t],
                                "__proto__" !== t && a !== o && (c && o && (k.isPlainObject(o) || (n = Array.isArray(o))) ? (i = a[t],
                                r = n && !Array.isArray(i) ? [] : n || k.isPlainObject(i) ? i : {},
                                n = !1,
                                a[t] = k.extend(c, r, o)) : void 0 !== o && (a[t] = o));
                    return a
                }
                ,
                k.extend({
                    expando: "jQuery" + (S + Math.random()).replace(/\D/g, ""),
                    isReady: !0,
                    error: function(e) {
                        throw new Error(e)
                    },
                    noop: function() {},
                    isPlainObject: function(e) {
                        var t, i;
                        return !(!e || "[object Object]" !== p.call(e) || (t = a(e)) && ("function" != typeof (i = h.call(t, "constructor") && t.constructor) || m.call(i) !== f))
                    },
                    isEmptyObject: function(e) {
                        var t;
                        for (t in e)
                            return !1;
                        return !0
                    },
                    globalEval: function(e, t, i) {
                        x(e, {
                            nonce: t && t.nonce
                        }, i)
                    },
                    each: function(e, t) {
                        var i, o = 0;
                        if (C(e))
                            for (i = e.length; o < i && !1 !== t.call(e[o], o, e[o]); o++)
                                ;
                        else
                            for (o in e)
                                if (!1 === t.call(e[o], o, e[o]))
                                    break;
                        return e
                    },
                    text: function(e) {
                        var t, i = "", o = 0, n = e.nodeType;
                        if (!n)
                            for (; t = e[o++]; )
                                i += k.text(t);
                        return 1 === n || 11 === n ? e.textContent : 9 === n ? e.documentElement.textContent : 3 === n || 4 === n ? e.nodeValue : i
                    },
                    makeArray: function(e, t) {
                        var i = t || [];
                        return null != e && (C(Object(e)) ? k.merge(i, "string" == typeof e ? [e] : e) : c.call(i, e)),
                        i
                    },
                    inArray: function(e, t, i) {
                        return null == t ? -1 : u.call(t, e, i)
                    },
                    isXMLDoc: function(e) {
                        var t = e && e.namespaceURI
                          , i = e && (e.ownerDocument || e).documentElement;
                        return !_.test(t || i && i.nodeName || "HTML")
                    },
                    merge: function(e, t) {
                        for (var i = +t.length, o = 0, n = e.length; o < i; o++)
                            e[n++] = t[o];
                        return e.length = n,
                        e
                    },
                    grep: function(e, t, i) {
                        for (var o = [], n = 0, r = e.length, a = !i; n < r; n++)
                            !t(e[n], n) !== a && o.push(e[n]);
                        return o
                    },
                    map: function(e, t, i) {
                        var o, n, r = 0, a = [];
                        if (C(e))
                            for (o = e.length; r < o; r++)
                                null != (n = t(e[r], r, i)) && a.push(n);
                        else
                            for (r in e)
                                null != (n = t(e[r], r, i)) && a.push(n);
                        return l(a)
                    },
                    guid: 1,
                    support: g
                }),
                "function" == typeof Symbol && (k.fn[Symbol.iterator] = r[Symbol.iterator]),
                k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), (function(e, t) {
                    d["[object " + t + "]"] = t.toLowerCase()
                }
                ));
                var M = r.pop
                  , P = r.sort
                  , E = r.splice
                  , R = "[\\x20\\t\\r\\n\\f]"
                  , A = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$","g");
                k.contains = function(e, t) {
                    var i = t && t.parentNode;
                    return e === i || !(!i || 1 !== i.nodeType || !(e.contains ? e.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
                }
                ;
                var I = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
                function L(e, t) {
                    return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
                }
                k.escapeSelector = function(e) {
                    return (e + "").replace(I, L)
                }
                ;
                var D = b
                  , z = c;
                !function() {
                    var e, t, i, n, a, l, c, d, p, m, f = z, y = k.expando, $ = 0, b = 0, v = ee(), x = ee(), w = ee(), S = ee(), _ = function(e, t) {
                        return e === t && (a = !0),
                        0
                    }, C = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", I = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", L = "\\[" + R + "*(" + I + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + R + "*\\]", F = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + L + ")*)|.*)\\)|)", O = new RegExp(R + "+","g"), B = new RegExp("^" + R + "*," + R + "*"), N = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"), W = new RegExp(R + "|>"), H = new RegExp(F), j = new RegExp("^" + I + "$"), U = {
                        ID: new RegExp("^#(" + I + ")"),
                        CLASS: new RegExp("^\\.(" + I + ")"),
                        TAG: new RegExp("^(" + I + "|[*])"),
                        ATTR: new RegExp("^" + L),
                        PSEUDO: new RegExp("^" + F),
                        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)","i"),
                        bool: new RegExp("^(?:" + C + ")$","i"),
                        needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)","i")
                    }, V = /^(?:input|select|textarea|button)$/i, q = /^h\d$/i, G = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, K = /[+~]/, X = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])","g"), Z = function(e, t) {
                        var i = "0x" + e.slice(1) - 65536;
                        return t || (i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320))
                    }, Y = function() {
                        le()
                    }, Q = pe((function(e) {
                        return !0 === e.disabled && T(e, "fieldset")
                    }
                    ), {
                        dir: "parentNode",
                        next: "legend"
                    });
                    try {
                        f.apply(r = s.call(D.childNodes), D.childNodes),
                        r[D.childNodes.length].nodeType
                    } catch (e) {
                        f = {
                            apply: function(e, t) {
                                z.apply(e, s.call(t))
                            },
                            call: function(e) {
                                z.apply(e, s.call(arguments, 1))
                            }
                        }
                    }
                    function J(e, t, i, o) {
                        var n, r, a, s, c, u, h, m = t && t.ownerDocument, $ = t ? t.nodeType : 9;
                        if (i = i || [],
                        "string" != typeof e || !e || 1 !== $ && 9 !== $ && 11 !== $)
                            return i;
                        if (!o && (le(t),
                        t = t || l,
                        d)) {
                            if (11 !== $ && (c = G.exec(e)))
                                if (n = c[1]) {
                                    if (9 === $) {
                                        if (!(a = t.getElementById(n)))
                                            return i;
                                        if (a.id === n)
                                            return f.call(i, a),
                                            i
                                    } else if (m && (a = m.getElementById(n)) && J.contains(t, a) && a.id === n)
                                        return f.call(i, a),
                                        i
                                } else {
                                    if (c[2])
                                        return f.apply(i, t.getElementsByTagName(e)),
                                        i;
                                    if ((n = c[3]) && t.getElementsByClassName)
                                        return f.apply(i, t.getElementsByClassName(n)),
                                        i
                                }
                            if (!(S[e + " "] || p && p.test(e))) {
                                if (h = e,
                                m = t,
                                1 === $ && (W.test(e) || N.test(e))) {
                                    for ((m = K.test(e) && se(t.parentNode) || t) == t && g.scope || ((s = t.getAttribute("id")) ? s = k.escapeSelector(s) : t.setAttribute("id", s = y)),
                                    r = (u = ue(e)).length; r--; )
                                        u[r] = (s ? "#" + s : ":scope") + " " + de(u[r]);
                                    h = u.join(",")
                                }
                                try {
                                    return f.apply(i, m.querySelectorAll(h)),
                                    i
                                } catch (t) {
                                    S(e, !0)
                                } finally {
                                    s === y && t.removeAttribute("id")
                                }
                            }
                        }
                        return $e(e.replace(A, "$1"), t, i, o)
                    }
                    function ee() {
                        var e = [];
                        return function i(o, n) {
                            return e.push(o + " ") > t.cacheLength && delete i[e.shift()],
                            i[o + " "] = n
                        }
                    }
                    function te(e) {
                        return e[y] = !0,
                        e
                    }
                    function ie(e) {
                        var t = l.createElement("fieldset");
                        try {
                            return !!e(t)
                        } catch (e) {
                            return !1
                        } finally {
                            t.parentNode && t.parentNode.removeChild(t),
                            t = null
                        }
                    }
                    function oe(e) {
                        return function(t) {
                            return T(t, "input") && t.type === e
                        }
                    }
                    function ne(e) {
                        return function(t) {
                            return (T(t, "input") || T(t, "button")) && t.type === e
                        }
                    }
                    function re(e) {
                        return function(t) {
                            return "form"in t ? t.parentNode && !1 === t.disabled ? "label"in t ? "label"in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && Q(t) === e : t.disabled === e : "label"in t && t.disabled === e
                        }
                    }
                    function ae(e) {
                        return te((function(t) {
                            return t = +t,
                            te((function(i, o) {
                                for (var n, r = e([], i.length, t), a = r.length; a--; )
                                    i[n = r[a]] && (i[n] = !(o[n] = i[n]))
                            }
                            ))
                        }
                        ))
                    }
                    function se(e) {
                        return e && void 0 !== e.getElementsByTagName && e
                    }
                    function le(e) {
                        var i, o = e ? e.ownerDocument || e : D;
                        return o != l && 9 === o.nodeType && o.documentElement ? (c = (l = o).documentElement,
                        d = !k.isXMLDoc(l),
                        m = c.matches || c.webkitMatchesSelector || c.msMatchesSelector,
                        c.msMatchesSelector && D != l && (i = l.defaultView) && i.top !== i && i.addEventListener("unload", Y),
                        g.getById = ie((function(e) {
                            return c.appendChild(e).id = k.expando,
                            !l.getElementsByName || !l.getElementsByName(k.expando).length
                        }
                        )),
                        g.disconnectedMatch = ie((function(e) {
                            return m.call(e, "*")
                        }
                        )),
                        g.scope = ie((function() {
                            return l.querySelectorAll(":scope")
                        }
                        )),
                        g.cssHas = ie((function() {
                            try {
                                return l.querySelector(":has(*,:jqfake)"),
                                !1
                            } catch (e) {
                                return !0
                            }
                        }
                        )),
                        g.getById ? (t.filter.ID = function(e) {
                            var t = e.replace(X, Z);
                            return function(e) {
                                return e.getAttribute("id") === t
                            }
                        }
                        ,
                        t.find.ID = function(e, t) {
                            if (void 0 !== t.getElementById && d) {
                                var i = t.getElementById(e);
                                return i ? [i] : []
                            }
                        }
                        ) : (t.filter.ID = function(e) {
                            var t = e.replace(X, Z);
                            return function(e) {
                                var i = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                return i && i.value === t
                            }
                        }
                        ,
                        t.find.ID = function(e, t) {
                            if (void 0 !== t.getElementById && d) {
                                var i, o, n, r = t.getElementById(e);
                                if (r) {
                                    if ((i = r.getAttributeNode("id")) && i.value === e)
                                        return [r];
                                    for (n = t.getElementsByName(e),
                                    o = 0; r = n[o++]; )
                                        if ((i = r.getAttributeNode("id")) && i.value === e)
                                            return [r]
                                }
                                return []
                            }
                        }
                        ),
                        t.find.TAG = function(e, t) {
                            return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : t.querySelectorAll(e)
                        }
                        ,
                        t.find.CLASS = function(e, t) {
                            if (void 0 !== t.getElementsByClassName && d)
                                return t.getElementsByClassName(e)
                        }
                        ,
                        p = [],
                        ie((function(e) {
                            var t;
                            c.appendChild(e).innerHTML = "<a id='" + y + "' href='' disabled='disabled'></a><select id='" + y + "-\r\\' disabled='disabled'><option selected=''></option></select>",
                            e.querySelectorAll("[selected]").length || p.push("\\[" + R + "*(?:value|" + C + ")"),
                            e.querySelectorAll("[id~=" + y + "-]").length || p.push("~="),
                            e.querySelectorAll("a#" + y + "+*").length || p.push(".#.+[+~]"),
                            e.querySelectorAll(":checked").length || p.push(":checked"),
                            (t = l.createElement("input")).setAttribute("type", "hidden"),
                            e.appendChild(t).setAttribute("name", "D"),
                            c.appendChild(e).disabled = !0,
                            2 !== e.querySelectorAll(":disabled").length && p.push(":enabled", ":disabled"),
                            (t = l.createElement("input")).setAttribute("name", ""),
                            e.appendChild(t),
                            e.querySelectorAll("[name='']").length || p.push("\\[" + R + "*name" + R + "*=" + R + "*(?:''|\"\")")
                        }
                        )),
                        g.cssHas || p.push(":has"),
                        p = p.length && new RegExp(p.join("|")),
                        _ = function(e, t) {
                            if (e === t)
                                return a = !0,
                                0;
                            var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                            return i || (1 & (i = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !g.sortDetached && t.compareDocumentPosition(e) === i ? e === l || e.ownerDocument == D && J.contains(D, e) ? -1 : t === l || t.ownerDocument == D && J.contains(D, t) ? 1 : n ? u.call(n, e) - u.call(n, t) : 0 : 4 & i ? -1 : 1)
                        }
                        ,
                        l) : l
                    }
                    for (e in J.matches = function(e, t) {
                        return J(e, null, null, t)
                    }
                    ,
                    J.matchesSelector = function(e, t) {
                        if (le(e),
                        d && !S[t + " "] && (!p || !p.test(t)))
                            try {
                                var i = m.call(e, t);
                                if (i || g.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                                    return i
                            } catch (e) {
                                S(t, !0)
                            }
                        return J(t, l, null, [e]).length > 0
                    }
                    ,
                    J.contains = function(e, t) {
                        return (e.ownerDocument || e) != l && le(e),
                        k.contains(e, t)
                    }
                    ,
                    J.attr = function(e, i) {
                        (e.ownerDocument || e) != l && le(e);
                        var o = t.attrHandle[i.toLowerCase()]
                          , n = o && h.call(t.attrHandle, i.toLowerCase()) ? o(e, i, !d) : void 0;
                        return void 0 !== n ? n : e.getAttribute(i)
                    }
                    ,
                    J.error = function(e) {
                        throw new Error("Syntax error, unrecognized expression: " + e)
                    }
                    ,
                    k.uniqueSort = function(e) {
                        var t, i = [], o = 0, r = 0;
                        if (a = !g.sortStable,
                        n = !g.sortStable && s.call(e, 0),
                        P.call(e, _),
                        a) {
                            for (; t = e[r++]; )
                                t === e[r] && (o = i.push(r));
                            for (; o--; )
                                E.call(e, i[o], 1)
                        }
                        return n = null,
                        e
                    }
                    ,
                    k.fn.uniqueSort = function() {
                        return this.pushStack(k.uniqueSort(s.apply(this)))
                    }
                    ,
                    t = k.expr = {
                        cacheLength: 50,
                        createPseudo: te,
                        match: U,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": {
                                dir: "parentNode",
                                first: !0
                            },
                            " ": {
                                dir: "parentNode"
                            },
                            "+": {
                                dir: "previousSibling",
                                first: !0
                            },
                            "~": {
                                dir: "previousSibling"
                            }
                        },
                        preFilter: {
                            ATTR: function(e) {
                                return e[1] = e[1].replace(X, Z),
                                e[3] = (e[3] || e[4] || e[5] || "").replace(X, Z),
                                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                                e.slice(0, 4)
                            },
                            CHILD: function(e) {
                                return e[1] = e[1].toLowerCase(),
                                "nth" === e[1].slice(0, 3) ? (e[3] || J.error(e[0]),
                                e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                                e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && J.error(e[0]),
                                e
                            },
                            PSEUDO: function(e) {
                                var t, i = !e[6] && e[2];
                                return U.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && H.test(i) && (t = ue(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t),
                                e[2] = i.slice(0, t)),
                                e.slice(0, 3))
                            }
                        },
                        filter: {
                            TAG: function(e) {
                                var t = e.replace(X, Z).toLowerCase();
                                return "*" === e ? function() {
                                    return !0
                                }
                                : function(e) {
                                    return T(e, t)
                                }
                            },
                            CLASS: function(e) {
                                var t = v[e + " "];
                                return t || (t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) && v(e, (function(e) {
                                    return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                                }
                                ))
                            },
                            ATTR: function(e, t, i) {
                                return function(o) {
                                    var n = J.attr(o, e);
                                    return null == n ? "!=" === t : !t || (n += "",
                                    "=" === t ? n === i : "!=" === t ? n !== i : "^=" === t ? i && 0 === n.indexOf(i) : "*=" === t ? i && n.indexOf(i) > -1 : "$=" === t ? i && n.slice(-i.length) === i : "~=" === t ? (" " + n.replace(O, " ") + " ").indexOf(i) > -1 : "|=" === t && (n === i || n.slice(0, i.length + 1) === i + "-"))
                                }
                            },
                            CHILD: function(e, t, i, o, n) {
                                var r = "nth" !== e.slice(0, 3)
                                  , a = "last" !== e.slice(-4)
                                  , s = "of-type" === t;
                                return 1 === o && 0 === n ? function(e) {
                                    return !!e.parentNode
                                }
                                : function(t, i, l) {
                                    var c, u, d, p, h, m = r !== a ? "nextSibling" : "previousSibling", f = t.parentNode, g = s && t.nodeName.toLowerCase(), b = !l && !s, v = !1;
                                    if (f) {
                                        if (r) {
                                            for (; m; ) {
                                                for (d = t; d = d[m]; )
                                                    if (s ? T(d, g) : 1 === d.nodeType)
                                                        return !1;
                                                h = m = "only" === e && !h && "nextSibling"
                                            }
                                            return !0
                                        }
                                        if (h = [a ? f.firstChild : f.lastChild],
                                        a && b) {
                                            for (v = (p = (c = (u = f[y] || (f[y] = {}))[e] || [])[0] === $ && c[1]) && c[2],
                                            d = p && f.childNodes[p]; d = ++p && d && d[m] || (v = p = 0) || h.pop(); )
                                                if (1 === d.nodeType && ++v && d === t) {
                                                    u[e] = [$, p, v];
                                                    break
                                                }
                                        } else if (b && (v = p = (c = (u = t[y] || (t[y] = {}))[e] || [])[0] === $ && c[1]),
                                        !1 === v)
                                            for (; (d = ++p && d && d[m] || (v = p = 0) || h.pop()) && (!(s ? T(d, g) : 1 === d.nodeType) || !++v || (b && ((u = d[y] || (d[y] = {}))[e] = [$, v]),
                                            d !== t)); )
                                                ;
                                        return (v -= n) === o || v % o == 0 && v / o >= 0
                                    }
                                }
                            },
                            PSEUDO: function(e, i) {
                                var o, n = t.pseudos[e] || t.setFilters[e.toLowerCase()] || J.error("unsupported pseudo: " + e);
                                return n[y] ? n(i) : n.length > 1 ? (o = [e, e, "", i],
                                t.setFilters.hasOwnProperty(e.toLowerCase()) ? te((function(e, t) {
                                    for (var o, r = n(e, i), a = r.length; a--; )
                                        e[o = u.call(e, r[a])] = !(t[o] = r[a])
                                }
                                )) : function(e) {
                                    return n(e, 0, o)
                                }
                                ) : n
                            }
                        },
                        pseudos: {
                            not: te((function(e) {
                                var t = []
                                  , i = []
                                  , o = ye(e.replace(A, "$1"));
                                return o[y] ? te((function(e, t, i, n) {
                                    for (var r, a = o(e, null, n, []), s = e.length; s--; )
                                        (r = a[s]) && (e[s] = !(t[s] = r))
                                }
                                )) : function(e, n, r) {
                                    return t[0] = e,
                                    o(t, null, r, i),
                                    t[0] = null,
                                    !i.pop()
                                }
                            }
                            )),
                            has: te((function(e) {
                                return function(t) {
                                    return J(e, t).length > 0
                                }
                            }
                            )),
                            contains: te((function(e) {
                                return e = e.replace(X, Z),
                                function(t) {
                                    return (t.textContent || k.text(t)).indexOf(e) > -1
                                }
                            }
                            )),
                            lang: te((function(e) {
                                return j.test(e || "") || J.error("unsupported lang: " + e),
                                e = e.replace(X, Z).toLowerCase(),
                                function(t) {
                                    var i;
                                    do {
                                        if (i = d ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                            return (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                                    } while ((t = t.parentNode) && 1 === t.nodeType);
                                    return !1
                                }
                            }
                            )),
                            target: function(e) {
                                var t = o.location && o.location.hash;
                                return t && t.slice(1) === e.id
                            },
                            root: function(e) {
                                return e === c
                            },
                            focus: function(e) {
                                return e === function() {
                                    try {
                                        return l.activeElement
                                    } catch (e) {}
                                }() && l.hasFocus() && !!(e.type || e.href || ~e.tabIndex)
                            },
                            enabled: re(!1),
                            disabled: re(!0),
                            checked: function(e) {
                                return T(e, "input") && !!e.checked || T(e, "option") && !!e.selected
                            },
                            selected: function(e) {
                                return e.parentNode && e.parentNode.selectedIndex,
                                !0 === e.selected
                            },
                            empty: function(e) {
                                for (e = e.firstChild; e; e = e.nextSibling)
                                    if (e.nodeType < 6)
                                        return !1;
                                return !0
                            },
                            parent: function(e) {
                                return !t.pseudos.empty(e)
                            },
                            header: function(e) {
                                return q.test(e.nodeName)
                            },
                            input: function(e) {
                                return V.test(e.nodeName)
                            },
                            button: function(e) {
                                return T(e, "input") && "button" === e.type || T(e, "button")
                            },
                            text: function(e) {
                                var t;
                                return T(e, "input") && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                            },
                            first: ae((function() {
                                return [0]
                            }
                            )),
                            last: ae((function(e, t) {
                                return [t - 1]
                            }
                            )),
                            eq: ae((function(e, t, i) {
                                return [i < 0 ? i + t : i]
                            }
                            )),
                            even: ae((function(e, t) {
                                for (var i = 0; i < t; i += 2)
                                    e.push(i);
                                return e
                            }
                            )),
                            odd: ae((function(e, t) {
                                for (var i = 1; i < t; i += 2)
                                    e.push(i);
                                return e
                            }
                            )),
                            lt: ae((function(e, t, i) {
                                var o;
                                for (o = i < 0 ? i + t : i > t ? t : i; --o >= 0; )
                                    e.push(o);
                                return e
                            }
                            )),
                            gt: ae((function(e, t, i) {
                                for (var o = i < 0 ? i + t : i; ++o < t; )
                                    e.push(o);
                                return e
                            }
                            ))
                        }
                    },
                    t.pseudos.nth = t.pseudos.eq,
                    {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    })
                        t.pseudos[e] = oe(e);
                    for (e in {
                        submit: !0,
                        reset: !0
                    })
                        t.pseudos[e] = ne(e);
                    function ce() {}
                    function ue(e, i) {
                        var o, n, r, a, s, l, c, u = x[e + " "];
                        if (u)
                            return i ? 0 : u.slice(0);
                        for (s = e,
                        l = [],
                        c = t.preFilter; s; ) {
                            for (a in o && !(n = B.exec(s)) || (n && (s = s.slice(n[0].length) || s),
                            l.push(r = [])),
                            o = !1,
                            (n = N.exec(s)) && (o = n.shift(),
                            r.push({
                                value: o,
                                type: n[0].replace(A, " ")
                            }),
                            s = s.slice(o.length)),
                            t.filter)
                                !(n = U[a].exec(s)) || c[a] && !(n = c[a](n)) || (o = n.shift(),
                                r.push({
                                    value: o,
                                    type: a,
                                    matches: n
                                }),
                                s = s.slice(o.length));
                            if (!o)
                                break
                        }
                        return i ? s.length : s ? J.error(e) : x(e, l).slice(0)
                    }
                    function de(e) {
                        for (var t = 0, i = e.length, o = ""; t < i; t++)
                            o += e[t].value;
                        return o
                    }
                    function pe(e, t, i) {
                        var o = t.dir
                          , n = t.next
                          , r = n || o
                          , a = i && "parentNode" === r
                          , s = b++;
                        return t.first ? function(t, i, n) {
                            for (; t = t[o]; )
                                if (1 === t.nodeType || a)
                                    return e(t, i, n);
                            return !1
                        }
                        : function(t, i, l) {
                            var c, u, d = [$, s];
                            if (l) {
                                for (; t = t[o]; )
                                    if ((1 === t.nodeType || a) && e(t, i, l))
                                        return !0
                            } else
                                for (; t = t[o]; )
                                    if (1 === t.nodeType || a)
                                        if (u = t[y] || (t[y] = {}),
                                        n && T(t, n))
                                            t = t[o] || t;
                                        else {
                                            if ((c = u[r]) && c[0] === $ && c[1] === s)
                                                return d[2] = c[2];
                                            if (u[r] = d,
                                            d[2] = e(t, i, l))
                                                return !0
                                        }
                            return !1
                        }
                    }
                    function he(e) {
                        return e.length > 1 ? function(t, i, o) {
                            for (var n = e.length; n--; )
                                if (!e[n](t, i, o))
                                    return !1;
                            return !0
                        }
                        : e[0]
                    }
                    function me(e, t, i, o, n) {
                        for (var r, a = [], s = 0, l = e.length, c = null != t; s < l; s++)
                            (r = e[s]) && (i && !i(r, o, n) || (a.push(r),
                            c && t.push(s)));
                        return a
                    }
                    function fe(e, t, i, o, n, r) {
                        return o && !o[y] && (o = fe(o)),
                        n && !n[y] && (n = fe(n, r)),
                        te((function(r, a, s, l) {
                            var c, d, p, h, m = [], g = [], y = a.length, $ = r || function(e, t, i) {
                                for (var o = 0, n = t.length; o < n; o++)
                                    J(e, t[o], i);
                                return i
                            }(t || "*", s.nodeType ? [s] : s, []), b = !e || !r && t ? $ : me($, m, e, s, l);
                            if (i ? i(b, h = n || (r ? e : y || o) ? [] : a, s, l) : h = b,
                            o)
                                for (c = me(h, g),
                                o(c, [], s, l),
                                d = c.length; d--; )
                                    (p = c[d]) && (h[g[d]] = !(b[g[d]] = p));
                            if (r) {
                                if (n || e) {
                                    if (n) {
                                        for (c = [],
                                        d = h.length; d--; )
                                            (p = h[d]) && c.push(b[d] = p);
                                        n(null, h = [], c, l)
                                    }
                                    for (d = h.length; d--; )
                                        (p = h[d]) && (c = n ? u.call(r, p) : m[d]) > -1 && (r[c] = !(a[c] = p))
                                }
                            } else
                                h = me(h === a ? h.splice(y, h.length) : h),
                                n ? n(null, a, h, l) : f.apply(a, h)
                        }
                        ))
                    }
                    function ge(e) {
                        for (var o, n, r, a = e.length, s = t.relative[e[0].type], l = s || t.relative[" "], c = s ? 1 : 0, d = pe((function(e) {
                            return e === o
                        }
                        ), l, !0), p = pe((function(e) {
                            return u.call(o, e) > -1
                        }
                        ), l, !0), h = [function(e, t, n) {
                            var r = !s && (n || t != i) || ((o = t).nodeType ? d(e, t, n) : p(e, t, n));
                            return o = null,
                            r
                        }
                        ]; c < a; c++)
                            if (n = t.relative[e[c].type])
                                h = [pe(he(h), n)];
                            else {
                                if ((n = t.filter[e[c].type].apply(null, e[c].matches))[y]) {
                                    for (r = ++c; r < a && !t.relative[e[r].type]; r++)
                                        ;
                                    return fe(c > 1 && he(h), c > 1 && de(e.slice(0, c - 1).concat({
                                        value: " " === e[c - 2].type ? "*" : ""
                                    })).replace(A, "$1"), n, c < r && ge(e.slice(c, r)), r < a && ge(e = e.slice(r)), r < a && de(e))
                                }
                                h.push(n)
                            }
                        return he(h)
                    }
                    function ye(e, o) {
                        var n, r = [], a = [], s = w[e + " "];
                        if (!s) {
                            for (o || (o = ue(e)),
                            n = o.length; n--; )
                                (s = ge(o[n]))[y] ? r.push(s) : a.push(s);
                            s = w(e, function(e, o) {
                                var n = o.length > 0
                                  , r = e.length > 0
                                  , a = function(a, s, c, u, p) {
                                    var h, m, g, y = 0, b = "0", v = a && [], x = [], w = i, S = a || r && t.find.TAG("*", p), _ = $ += null == w ? 1 : Math.random() || .1, C = S.length;
                                    for (p && (i = s == l || s || p); b !== C && null != (h = S[b]); b++) {
                                        if (r && h) {
                                            for (m = 0,
                                            s || h.ownerDocument == l || (le(h),
                                            c = !d); g = e[m++]; )
                                                if (g(h, s || l, c)) {
                                                    f.call(u, h);
                                                    break
                                                }
                                            p && ($ = _)
                                        }
                                        n && ((h = !g && h) && y--,
                                        a && v.push(h))
                                    }
                                    if (y += b,
                                    n && b !== y) {
                                        for (m = 0; g = o[m++]; )
                                            g(v, x, s, c);
                                        if (a) {
                                            if (y > 0)
                                                for (; b--; )
                                                    v[b] || x[b] || (x[b] = M.call(u));
                                            x = me(x)
                                        }
                                        f.apply(u, x),
                                        p && !a && x.length > 0 && y + o.length > 1 && k.uniqueSort(u)
                                    }
                                    return p && ($ = _,
                                    i = w),
                                    v
                                };
                                return n ? te(a) : a
                            }(a, r)),
                            s.selector = e
                        }
                        return s
                    }
                    function $e(e, i, o, n) {
                        var r, a, s, l, c, u = "function" == typeof e && e, p = !n && ue(e = u.selector || e);
                        if (o = o || [],
                        1 === p.length) {
                            if ((a = p[0] = p[0].slice(0)).length > 2 && "ID" === (s = a[0]).type && 9 === i.nodeType && d && t.relative[a[1].type]) {
                                if (!(i = (t.find.ID(s.matches[0].replace(X, Z), i) || [])[0]))
                                    return o;
                                u && (i = i.parentNode),
                                e = e.slice(a.shift().value.length)
                            }
                            for (r = U.needsContext.test(e) ? 0 : a.length; r-- && (s = a[r],
                            !t.relative[l = s.type]); )
                                if ((c = t.find[l]) && (n = c(s.matches[0].replace(X, Z), K.test(a[0].type) && se(i.parentNode) || i))) {
                                    if (a.splice(r, 1),
                                    !(e = n.length && de(a)))
                                        return f.apply(o, n),
                                        o;
                                    break
                                }
                        }
                        return (u || ye(e, p))(n, i, !d, o, !i || K.test(e) && se(i.parentNode) || i),
                        o
                    }
                    ce.prototype = t.filters = t.pseudos,
                    t.setFilters = new ce,
                    g.sortStable = y.split("").sort(_).join("") === y,
                    le(),
                    g.sortDetached = ie((function(e) {
                        return 1 & e.compareDocumentPosition(l.createElement("fieldset"))
                    }
                    )),
                    k.find = J,
                    k.expr[":"] = k.expr.pseudos,
                    k.unique = k.uniqueSort,
                    J.compile = ye,
                    J.select = $e,
                    J.setDocument = le,
                    J.tokenize = ue,
                    J.escape = k.escapeSelector,
                    J.getText = k.text,
                    J.isXML = k.isXMLDoc,
                    J.selectors = k.expr,
                    J.support = k.support,
                    J.uniqueSort = k.uniqueSort
                }();
                var F = function(e, t, i) {
                    for (var o = [], n = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
                        if (1 === e.nodeType) {
                            if (n && k(e).is(i))
                                break;
                            o.push(e)
                        }
                    return o
                }
                  , O = function(e, t) {
                    for (var i = []; e; e = e.nextSibling)
                        1 === e.nodeType && e !== t && i.push(e);
                    return i
                }
                  , B = k.expr.match.needsContext
                  , N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
                function W(e, t, i) {
                    return y(t) ? k.grep(e, (function(e, o) {
                        return !!t.call(e, o, e) !== i
                    }
                    )) : t.nodeType ? k.grep(e, (function(e) {
                        return e === t !== i
                    }
                    )) : "string" != typeof t ? k.grep(e, (function(e) {
                        return u.call(t, e) > -1 !== i
                    }
                    )) : k.filter(t, e, i)
                }
                k.filter = function(e, t, i) {
                    var o = t[0];
                    return i && (e = ":not(" + e + ")"),
                    1 === t.length && 1 === o.nodeType ? k.find.matchesSelector(o, e) ? [o] : [] : k.find.matches(e, k.grep(t, (function(e) {
                        return 1 === e.nodeType
                    }
                    )))
                }
                ,
                k.fn.extend({
                    find: function(e) {
                        var t, i, o = this.length, n = this;
                        if ("string" != typeof e)
                            return this.pushStack(k(e).filter((function() {
                                for (t = 0; t < o; t++)
                                    if (k.contains(n[t], this))
                                        return !0
                            }
                            )));
                        for (i = this.pushStack([]),
                        t = 0; t < o; t++)
                            k.find(e, n[t], i);
                        return o > 1 ? k.uniqueSort(i) : i
                    },
                    filter: function(e) {
                        return this.pushStack(W(this, e || [], !1))
                    },
                    not: function(e) {
                        return this.pushStack(W(this, e || [], !0))
                    },
                    is: function(e) {
                        return !!W(this, "string" == typeof e && B.test(e) ? k(e) : e || [], !1).length
                    }
                });
                var H, j = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                (k.fn.init = function(e, t, i) {
                    var o, n;
                    if (!e)
                        return this;
                    if (i = i || H,
                    "string" == typeof e) {
                        if (!(o = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : j.exec(e)) || !o[1] && t)
                            return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
                        if (o[1]) {
                            if (t = t instanceof k ? t[0] : t,
                            k.merge(this, k.parseHTML(o[1], t && t.nodeType ? t.ownerDocument || t : b, !0)),
                            N.test(o[1]) && k.isPlainObject(t))
                                for (o in t)
                                    y(this[o]) ? this[o](t[o]) : this.attr(o, t[o]);
                            return this
                        }
                        return (n = b.getElementById(o[2])) && (this[0] = n,
                        this.length = 1),
                        this
                    }
                    return e.nodeType ? (this[0] = e,
                    this.length = 1,
                    this) : y(e) ? void 0 !== i.ready ? i.ready(e) : e(k) : k.makeArray(e, this)
                }
                ).prototype = k.fn,
                H = k(b);
                var U = /^(?:parents|prev(?:Until|All))/
                  , V = {
                    children: !0,
                    contents: !0,
                    next: !0,
                    prev: !0
                };
                function q(e, t) {
                    for (; (e = e[t]) && 1 !== e.nodeType; )
                        ;
                    return e
                }
                k.fn.extend({
                    has: function(e) {
                        var t = k(e, this)
                          , i = t.length;
                        return this.filter((function() {
                            for (var e = 0; e < i; e++)
                                if (k.contains(this, t[e]))
                                    return !0
                        }
                        ))
                    },
                    closest: function(e, t) {
                        var i, o = 0, n = this.length, r = [], a = "string" != typeof e && k(e);
                        if (!B.test(e))
                            for (; o < n; o++)
                                for (i = this[o]; i && i !== t; i = i.parentNode)
                                    if (i.nodeType < 11 && (a ? a.index(i) > -1 : 1 === i.nodeType && k.find.matchesSelector(i, e))) {
                                        r.push(i);
                                        break
                                    }
                        return this.pushStack(r.length > 1 ? k.uniqueSort(r) : r)
                    },
                    index: function(e) {
                        return e ? "string" == typeof e ? u.call(k(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                    },
                    add: function(e, t) {
                        return this.pushStack(k.uniqueSort(k.merge(this.get(), k(e, t))))
                    },
                    addBack: function(e) {
                        return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
                    }
                }),
                k.each({
                    parent: function(e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null
                    },
                    parents: function(e) {
                        return F(e, "parentNode")
                    },
                    parentsUntil: function(e, t, i) {
                        return F(e, "parentNode", i)
                    },
                    next: function(e) {
                        return q(e, "nextSibling")
                    },
                    prev: function(e) {
                        return q(e, "previousSibling")
                    },
                    nextAll: function(e) {
                        return F(e, "nextSibling")
                    },
                    prevAll: function(e) {
                        return F(e, "previousSibling")
                    },
                    nextUntil: function(e, t, i) {
                        return F(e, "nextSibling", i)
                    },
                    prevUntil: function(e, t, i) {
                        return F(e, "previousSibling", i)
                    },
                    siblings: function(e) {
                        return O((e.parentNode || {}).firstChild, e)
                    },
                    children: function(e) {
                        return O(e.firstChild)
                    },
                    contents: function(e) {
                        return null != e.contentDocument && a(e.contentDocument) ? e.contentDocument : (T(e, "template") && (e = e.content || e),
                        k.merge([], e.childNodes))
                    }
                }, (function(e, t) {
                    k.fn[e] = function(i, o) {
                        var n = k.map(this, t, i);
                        return "Until" !== e.slice(-5) && (o = i),
                        o && "string" == typeof o && (n = k.filter(o, n)),
                        this.length > 1 && (V[e] || k.uniqueSort(n),
                        U.test(e) && n.reverse()),
                        this.pushStack(n)
                    }
                }
                ));
                var G = /[^\x20\t\r\n\f]+/g;
                function K(e) {
                    return e
                }
                function X(e) {
                    throw e
                }
                function Z(e, t, i, o) {
                    var n;
                    try {
                        e && y(n = e.promise) ? n.call(e).done(t).fail(i) : e && y(n = e.then) ? n.call(e, t, i) : t.apply(void 0, [e].slice(o))
                    } catch (e) {
                        i.apply(void 0, [e])
                    }
                }
                k.Callbacks = function(e) {
                    e = "string" == typeof e ? function(e) {
                        var t = {};
                        return k.each(e.match(G) || [], (function(e, i) {
                            t[i] = !0
                        }
                        )),
                        t
                    }(e) : k.extend({}, e);
                    var t, i, o, n, r = [], a = [], s = -1, l = function() {
                        for (n = n || e.once,
                        o = t = !0; a.length; s = -1)
                            for (i = a.shift(); ++s < r.length; )
                                !1 === r[s].apply(i[0], i[1]) && e.stopOnFalse && (s = r.length,
                                i = !1);
                        e.memory || (i = !1),
                        t = !1,
                        n && (r = i ? [] : "")
                    }, c = {
                        add: function() {
                            return r && (i && !t && (s = r.length - 1,
                            a.push(i)),
                            function t(i) {
                                k.each(i, (function(i, o) {
                                    y(o) ? e.unique && c.has(o) || r.push(o) : o && o.length && "string" !== w(o) && t(o)
                                }
                                ))
                            }(arguments),
                            i && !t && l()),
                            this
                        },
                        remove: function() {
                            return k.each(arguments, (function(e, t) {
                                for (var i; (i = k.inArray(t, r, i)) > -1; )
                                    r.splice(i, 1),
                                    i <= s && s--
                            }
                            )),
                            this
                        },
                        has: function(e) {
                            return e ? k.inArray(e, r) > -1 : r.length > 0
                        },
                        empty: function() {
                            return r && (r = []),
                            this
                        },
                        disable: function() {
                            return n = a = [],
                            r = i = "",
                            this
                        },
                        disabled: function() {
                            return !r
                        },
                        lock: function() {
                            return n = a = [],
                            i || t || (r = i = ""),
                            this
                        },
                        locked: function() {
                            return !!n
                        },
                        fireWith: function(e, i) {
                            return n || (i = [e, (i = i || []).slice ? i.slice() : i],
                            a.push(i),
                            t || l()),
                            this
                        },
                        fire: function() {
                            return c.fireWith(this, arguments),
                            this
                        },
                        fired: function() {
                            return !!o
                        }
                    };
                    return c
                }
                ,
                k.extend({
                    Deferred: function(e) {
                        var t = [["notify", "progress", k.Callbacks("memory"), k.Callbacks("memory"), 2], ["resolve", "done", k.Callbacks("once memory"), k.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", k.Callbacks("once memory"), k.Callbacks("once memory"), 1, "rejected"]]
                          , i = "pending"
                          , n = {
                            state: function() {
                                return i
                            },
                            always: function() {
                                return r.done(arguments).fail(arguments),
                                this
                            },
                            catch: function(e) {
                                return n.then(null, e)
                            },
                            pipe: function() {
                                var e = arguments;
                                return k.Deferred((function(i) {
                                    k.each(t, (function(t, o) {
                                        var n = y(e[o[4]]) && e[o[4]];
                                        r[o[1]]((function() {
                                            var e = n && n.apply(this, arguments);
                                            e && y(e.promise) ? e.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[o[0] + "With"](this, n ? [e] : arguments)
                                        }
                                        ))
                                    }
                                    )),
                                    e = null
                                }
                                )).promise()
                            },
                            then: function(e, i, n) {
                                var r = 0;
                                function a(e, t, i, n) {
                                    return function() {
                                        var s = this
                                          , l = arguments
                                          , c = function() {
                                            var o, c;
                                            if (!(e < r)) {
                                                if ((o = i.apply(s, l)) === t.promise())
                                                    throw new TypeError("Thenable self-resolution");
                                                c = o && ("object" == typeof o || "function" == typeof o) && o.then,
                                                y(c) ? n ? c.call(o, a(r, t, K, n), a(r, t, X, n)) : (r++,
                                                c.call(o, a(r, t, K, n), a(r, t, X, n), a(r, t, K, t.notifyWith))) : (i !== K && (s = void 0,
                                                l = [o]),
                                                (n || t.resolveWith)(s, l))
                                            }
                                        }
                                          , u = n ? c : function() {
                                            try {
                                                c()
                                            } catch (o) {
                                                k.Deferred.exceptionHook && k.Deferred.exceptionHook(o, u.error),
                                                e + 1 >= r && (i !== X && (s = void 0,
                                                l = [o]),
                                                t.rejectWith(s, l))
                                            }
                                        }
                                        ;
                                        e ? u() : (k.Deferred.getErrorHook ? u.error = k.Deferred.getErrorHook() : k.Deferred.getStackHook && (u.error = k.Deferred.getStackHook()),
                                        o.setTimeout(u))
                                    }
                                }
                                return k.Deferred((function(o) {
                                    t[0][3].add(a(0, o, y(n) ? n : K, o.notifyWith)),
                                    t[1][3].add(a(0, o, y(e) ? e : K)),
                                    t[2][3].add(a(0, o, y(i) ? i : X))
                                }
                                )).promise()
                            },
                            promise: function(e) {
                                return null != e ? k.extend(e, n) : n
                            }
                        }
                          , r = {};
                        return k.each(t, (function(e, o) {
                            var a = o[2]
                              , s = o[5];
                            n[o[1]] = a.add,
                            s && a.add((function() {
                                i = s
                            }
                            ), t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock),
                            a.add(o[3].fire),
                            r[o[0]] = function() {
                                return r[o[0] + "With"](this === r ? void 0 : this, arguments),
                                this
                            }
                            ,
                            r[o[0] + "With"] = a.fireWith
                        }
                        )),
                        n.promise(r),
                        e && e.call(r, r),
                        r
                    },
                    when: function(e) {
                        var t = arguments.length
                          , i = t
                          , o = Array(i)
                          , n = s.call(arguments)
                          , r = k.Deferred()
                          , a = function(e) {
                            return function(i) {
                                o[e] = this,
                                n[e] = arguments.length > 1 ? s.call(arguments) : i,
                                --t || r.resolveWith(o, n)
                            }
                        };
                        if (t <= 1 && (Z(e, r.done(a(i)).resolve, r.reject, !t),
                        "pending" === r.state() || y(n[i] && n[i].then)))
                            return r.then();
                        for (; i--; )
                            Z(n[i], a(i), r.reject);
                        return r.promise()
                    }
                });
                var Y = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                k.Deferred.exceptionHook = function(e, t) {
                    o.console && o.console.warn && e && Y.test(e.name) && o.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
                }
                ,
                k.readyException = function(e) {
                    o.setTimeout((function() {
                        throw e
                    }
                    ))
                }
                ;
                var Q = k.Deferred();
                function J() {
                    b.removeEventListener("DOMContentLoaded", J),
                    o.removeEventListener("load", J),
                    k.ready()
                }
                k.fn.ready = function(e) {
                    return Q.then(e).catch((function(e) {
                        k.readyException(e)
                    }
                    )),
                    this
                }
                ,
                k.extend({
                    isReady: !1,
                    readyWait: 1,
                    ready: function(e) {
                        (!0 === e ? --k.readyWait : k.isReady) || (k.isReady = !0,
                        !0 !== e && --k.readyWait > 0 || Q.resolveWith(b, [k]))
                    }
                }),
                k.ready.then = Q.then,
                "complete" === b.readyState || "loading" !== b.readyState && !b.documentElement.doScroll ? o.setTimeout(k.ready) : (b.addEventListener("DOMContentLoaded", J),
                o.addEventListener("load", J));
                var ee = function(e, t, i, o, n, r, a) {
                    var s = 0
                      , l = e.length
                      , c = null == i;
                    if ("object" === w(i))
                        for (s in n = !0,
                        i)
                            ee(e, t, s, i[s], !0, r, a);
                    else if (void 0 !== o && (n = !0,
                    y(o) || (a = !0),
                    c && (a ? (t.call(e, o),
                    t = null) : (c = t,
                    t = function(e, t, i) {
                        return c.call(k(e), i)
                    }
                    )),
                    t))
                        for (; s < l; s++)
                            t(e[s], i, a ? o : o.call(e[s], s, t(e[s], i)));
                    return n ? e : c ? t.call(e) : l ? t(e[0], i) : r
                }
                  , te = /^-ms-/
                  , ie = /-([a-z])/g;
                function oe(e, t) {
                    return t.toUpperCase()
                }
                function ne(e) {
                    return e.replace(te, "ms-").replace(ie, oe)
                }
                var re = function(e) {
                    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
                };
                function ae() {
                    this.expando = k.expando + ae.uid++
                }
                ae.uid = 1,
                ae.prototype = {
                    cache: function(e) {
                        var t = e[this.expando];
                        return t || (t = {},
                        re(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                            value: t,
                            configurable: !0
                        }))),
                        t
                    },
                    set: function(e, t, i) {
                        var o, n = this.cache(e);
                        if ("string" == typeof t)
                            n[ne(t)] = i;
                        else
                            for (o in t)
                                n[ne(o)] = t[o];
                        return n
                    },
                    get: function(e, t) {
                        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][ne(t)]
                    },
                    access: function(e, t, i) {
                        return void 0 === t || t && "string" == typeof t && void 0 === i ? this.get(e, t) : (this.set(e, t, i),
                        void 0 !== i ? i : t)
                    },
                    remove: function(e, t) {
                        var i, o = e[this.expando];
                        if (void 0 !== o) {
                            if (void 0 !== t) {
                                i = (t = Array.isArray(t) ? t.map(ne) : (t = ne(t))in o ? [t] : t.match(G) || []).length;
                                for (; i--; )
                                    delete o[t[i]]
                            }
                            (void 0 === t || k.isEmptyObject(o)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
                        }
                    },
                    hasData: function(e) {
                        var t = e[this.expando];
                        return void 0 !== t && !k.isEmptyObject(t)
                    }
                };
                var se = new ae
                  , le = new ae
                  , ce = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
                  , ue = /[A-Z]/g;
                function de(e, t, i) {
                    var o;
                    if (void 0 === i && 1 === e.nodeType)
                        if (o = "data-" + t.replace(ue, "-$&").toLowerCase(),
                        "string" == typeof (i = e.getAttribute(o))) {
                            try {
                                i = function(e) {
                                    return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ce.test(e) ? JSON.parse(e) : e)
                                }(i)
                            } catch (e) {}
                            le.set(e, t, i)
                        } else
                            i = void 0;
                    return i
                }
                k.extend({
                    hasData: function(e) {
                        return le.hasData(e) || se.hasData(e)
                    },
                    data: function(e, t, i) {
                        return le.access(e, t, i)
                    },
                    removeData: function(e, t) {
                        le.remove(e, t)
                    },
                    _data: function(e, t, i) {
                        return se.access(e, t, i)
                    },
                    _removeData: function(e, t) {
                        se.remove(e, t)
                    }
                }),
                k.fn.extend({
                    data: function(e, t) {
                        var i, o, n, r = this[0], a = r && r.attributes;
                        if (void 0 === e) {
                            if (this.length && (n = le.get(r),
                            1 === r.nodeType && !se.get(r, "hasDataAttrs"))) {
                                for (i = a.length; i--; )
                                    a[i] && 0 === (o = a[i].name).indexOf("data-") && (o = ne(o.slice(5)),
                                    de(r, o, n[o]));
                                se.set(r, "hasDataAttrs", !0)
                            }
                            return n
                        }
                        return "object" == typeof e ? this.each((function() {
                            le.set(this, e)
                        }
                        )) : ee(this, (function(t) {
                            var i;
                            if (r && void 0 === t)
                                return void 0 !== (i = le.get(r, e)) || void 0 !== (i = de(r, e)) ? i : void 0;
                            this.each((function() {
                                le.set(this, e, t)
                            }
                            ))
                        }
                        ), null, t, arguments.length > 1, null, !0)
                    },
                    removeData: function(e) {
                        return this.each((function() {
                            le.remove(this, e)
                        }
                        ))
                    }
                }),
                k.extend({
                    queue: function(e, t, i) {
                        var o;
                        if (e)
                            return t = (t || "fx") + "queue",
                            o = se.get(e, t),
                            i && (!o || Array.isArray(i) ? o = se.access(e, t, k.makeArray(i)) : o.push(i)),
                            o || []
                    },
                    dequeue: function(e, t) {
                        t = t || "fx";
                        var i = k.queue(e, t)
                          , o = i.length
                          , n = i.shift()
                          , r = k._queueHooks(e, t);
                        "inprogress" === n && (n = i.shift(),
                        o--),
                        n && ("fx" === t && i.unshift("inprogress"),
                        delete r.stop,
                        n.call(e, (function() {
                            k.dequeue(e, t)
                        }
                        ), r)),
                        !o && r && r.empty.fire()
                    },
                    _queueHooks: function(e, t) {
                        var i = t + "queueHooks";
                        return se.get(e, i) || se.access(e, i, {
                            empty: k.Callbacks("once memory").add((function() {
                                se.remove(e, [t + "queue", i])
                            }
                            ))
                        })
                    }
                }),
                k.fn.extend({
                    queue: function(e, t) {
                        var i = 2;
                        return "string" != typeof e && (t = e,
                        e = "fx",
                        i--),
                        arguments.length < i ? k.queue(this[0], e) : void 0 === t ? this : this.each((function() {
                            var i = k.queue(this, e, t);
                            k._queueHooks(this, e),
                            "fx" === e && "inprogress" !== i[0] && k.dequeue(this, e)
                        }
                        ))
                    },
                    dequeue: function(e) {
                        return this.each((function() {
                            k.dequeue(this, e)
                        }
                        ))
                    },
                    clearQueue: function(e) {
                        return this.queue(e || "fx", [])
                    },
                    promise: function(e, t) {
                        var i, o = 1, n = k.Deferred(), r = this, a = this.length, s = function() {
                            --o || n.resolveWith(r, [r])
                        };
                        for ("string" != typeof e && (t = e,
                        e = void 0),
                        e = e || "fx"; a--; )
                            (i = se.get(r[a], e + "queueHooks")) && i.empty && (o++,
                            i.empty.add(s));
                        return s(),
                        n.promise(t)
                    }
                });
                var pe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
                  , he = new RegExp("^(?:([+-])=|)(" + pe + ")([a-z%]*)$","i")
                  , me = ["Top", "Right", "Bottom", "Left"]
                  , fe = b.documentElement
                  , ge = function(e) {
                    return k.contains(e.ownerDocument, e)
                }
                  , ye = {
                    composed: !0
                };
                fe.getRootNode && (ge = function(e) {
                    return k.contains(e.ownerDocument, e) || e.getRootNode(ye) === e.ownerDocument
                }
                );
                var $e = function(e, t) {
                    return "none" === (e = t || e).style.display || "" === e.style.display && ge(e) && "none" === k.css(e, "display")
                };
                function be(e, t, i, o) {
                    var n, r, a = 20, s = o ? function() {
                        return o.cur()
                    }
                    : function() {
                        return k.css(e, t, "")
                    }
                    , l = s(), c = i && i[3] || (k.cssNumber[t] ? "" : "px"), u = e.nodeType && (k.cssNumber[t] || "px" !== c && +l) && he.exec(k.css(e, t));
                    if (u && u[3] !== c) {
                        for (l /= 2,
                        c = c || u[3],
                        u = +l || 1; a--; )
                            k.style(e, t, u + c),
                            (1 - r) * (1 - (r = s() / l || .5)) <= 0 && (a = 0),
                            u /= r;
                        u *= 2,
                        k.style(e, t, u + c),
                        i = i || []
                    }
                    return i && (u = +u || +l || 0,
                    n = i[1] ? u + (i[1] + 1) * i[2] : +i[2],
                    o && (o.unit = c,
                    o.start = u,
                    o.end = n)),
                    n
                }
                var ve = {};
                function xe(e) {
                    var t, i = e.ownerDocument, o = e.nodeName, n = ve[o];
                    return n || (t = i.body.appendChild(i.createElement(o)),
                    n = k.css(t, "display"),
                    t.parentNode.removeChild(t),
                    "none" === n && (n = "block"),
                    ve[o] = n,
                    n)
                }
                function we(e, t) {
                    for (var i, o, n = [], r = 0, a = e.length; r < a; r++)
                        (o = e[r]).style && (i = o.style.display,
                        t ? ("none" === i && (n[r] = se.get(o, "display") || null,
                        n[r] || (o.style.display = "")),
                        "" === o.style.display && $e(o) && (n[r] = xe(o))) : "none" !== i && (n[r] = "none",
                        se.set(o, "display", i)));
                    for (r = 0; r < a; r++)
                        null != n[r] && (e[r].style.display = n[r]);
                    return e
                }
                k.fn.extend({
                    show: function() {
                        return we(this, !0)
                    },
                    hide: function() {
                        return we(this)
                    },
                    toggle: function(e) {
                        return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each((function() {
                            $e(this) ? k(this).show() : k(this).hide()
                        }
                        ))
                    }
                });
                var Se, _e, ke = /^(?:checkbox|radio)$/i, Ce = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, Te = /^$|^module$|\/(?:java|ecma)script/i;
                Se = b.createDocumentFragment().appendChild(b.createElement("div")),
                (_e = b.createElement("input")).setAttribute("type", "radio"),
                _e.setAttribute("checked", "checked"),
                _e.setAttribute("name", "t"),
                Se.appendChild(_e),
                g.checkClone = Se.cloneNode(!0).cloneNode(!0).lastChild.checked,
                Se.innerHTML = "<textarea>x</textarea>",
                g.noCloneChecked = !!Se.cloneNode(!0).lastChild.defaultValue,
                Se.innerHTML = "<option></option>",
                g.option = !!Se.lastChild;
                var Me = {
                    thead: [1, "<table>", "</table>"],
                    col: [2, "<table><colgroup>", "</colgroup></table>"],
                    tr: [2, "<table><tbody>", "</tbody></table>"],
                    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                    _default: [0, "", ""]
                };
                function Pe(e, t) {
                    var i;
                    return i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [],
                    void 0 === t || t && T(e, t) ? k.merge([e], i) : i
                }
                function Ee(e, t) {
                    for (var i = 0, o = e.length; i < o; i++)
                        se.set(e[i], "globalEval", !t || se.get(t[i], "globalEval"))
                }
                Me.tbody = Me.tfoot = Me.colgroup = Me.caption = Me.thead,
                Me.th = Me.td,
                g.option || (Me.optgroup = Me.option = [1, "<select multiple='multiple'>", "</select>"]);
                var Re = /<|&#?\w+;/;
                function Ae(e, t, i, o, n) {
                    for (var r, a, s, l, c, u, d = t.createDocumentFragment(), p = [], h = 0, m = e.length; h < m; h++)
                        if ((r = e[h]) || 0 === r)
                            if ("object" === w(r))
                                k.merge(p, r.nodeType ? [r] : r);
                            else if (Re.test(r)) {
                                for (a = a || d.appendChild(t.createElement("div")),
                                s = (Ce.exec(r) || ["", ""])[1].toLowerCase(),
                                l = Me[s] || Me._default,
                                a.innerHTML = l[1] + k.htmlPrefilter(r) + l[2],
                                u = l[0]; u--; )
                                    a = a.lastChild;
                                k.merge(p, a.childNodes),
                                (a = d.firstChild).textContent = ""
                            } else
                                p.push(t.createTextNode(r));
                    for (d.textContent = "",
                    h = 0; r = p[h++]; )
                        if (o && k.inArray(r, o) > -1)
                            n && n.push(r);
                        else if (c = ge(r),
                        a = Pe(d.appendChild(r), "script"),
                        c && Ee(a),
                        i)
                            for (u = 0; r = a[u++]; )
                                Te.test(r.type || "") && i.push(r);
                    return d
                }
                var Ie = /^([^.]*)(?:\.(.+)|)/;
                function Le() {
                    return !0
                }
                function De() {
                    return !1
                }
                function ze(e, t, i, o, n, r) {
                    var a, s;
                    if ("object" == typeof t) {
                        for (s in "string" != typeof i && (o = o || i,
                        i = void 0),
                        t)
                            ze(e, s, i, o, t[s], r);
                        return e
                    }
                    if (null == o && null == n ? (n = i,
                    o = i = void 0) : null == n && ("string" == typeof i ? (n = o,
                    o = void 0) : (n = o,
                    o = i,
                    i = void 0)),
                    !1 === n)
                        n = De;
                    else if (!n)
                        return e;
                    return 1 === r && (a = n,
                    n = function(e) {
                        return k().off(e),
                        a.apply(this, arguments)
                    }
                    ,
                    n.guid = a.guid || (a.guid = k.guid++)),
                    e.each((function() {
                        k.event.add(this, t, n, o, i)
                    }
                    ))
                }
                function Fe(e, t, i) {
                    i ? (se.set(e, t, !1),
                    k.event.add(e, t, {
                        namespace: !1,
                        handler: function(e) {
                            var i, o = se.get(this, t);
                            if (1 & e.isTrigger && this[t]) {
                                if (o)
                                    (k.event.special[t] || {}).delegateType && e.stopPropagation();
                                else if (o = s.call(arguments),
                                se.set(this, t, o),
                                this[t](),
                                i = se.get(this, t),
                                se.set(this, t, !1),
                                o !== i)
                                    return e.stopImmediatePropagation(),
                                    e.preventDefault(),
                                    i
                            } else
                                o && (se.set(this, t, k.event.trigger(o[0], o.slice(1), this)),
                                e.stopPropagation(),
                                e.isImmediatePropagationStopped = Le)
                        }
                    })) : void 0 === se.get(e, t) && k.event.add(e, t, Le)
                }
                k.event = {
                    global: {},
                    add: function(e, t, i, o, n) {
                        var r, a, s, l, c, u, d, p, h, m, f, g = se.get(e);
                        if (re(e))
                            for (i.handler && (i = (r = i).handler,
                            n = r.selector),
                            n && k.find.matchesSelector(fe, n),
                            i.guid || (i.guid = k.guid++),
                            (l = g.events) || (l = g.events = Object.create(null)),
                            (a = g.handle) || (a = g.handle = function(t) {
                                return void 0 !== k && k.event.triggered !== t.type ? k.event.dispatch.apply(e, arguments) : void 0
                            }
                            ),
                            c = (t = (t || "").match(G) || [""]).length; c--; )
                                h = f = (s = Ie.exec(t[c]) || [])[1],
                                m = (s[2] || "").split(".").sort(),
                                h && (d = k.event.special[h] || {},
                                h = (n ? d.delegateType : d.bindType) || h,
                                d = k.event.special[h] || {},
                                u = k.extend({
                                    type: h,
                                    origType: f,
                                    data: o,
                                    handler: i,
                                    guid: i.guid,
                                    selector: n,
                                    needsContext: n && k.expr.match.needsContext.test(n),
                                    namespace: m.join(".")
                                }, r),
                                (p = l[h]) || ((p = l[h] = []).delegateCount = 0,
                                d.setup && !1 !== d.setup.call(e, o, m, a) || e.addEventListener && e.addEventListener(h, a)),
                                d.add && (d.add.call(e, u),
                                u.handler.guid || (u.handler.guid = i.guid)),
                                n ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                                k.event.global[h] = !0)
                    },
                    remove: function(e, t, i, o, n) {
                        var r, a, s, l, c, u, d, p, h, m, f, g = se.hasData(e) && se.get(e);
                        if (g && (l = g.events)) {
                            for (c = (t = (t || "").match(G) || [""]).length; c--; )
                                if (h = f = (s = Ie.exec(t[c]) || [])[1],
                                m = (s[2] || "").split(".").sort(),
                                h) {
                                    for (d = k.event.special[h] || {},
                                    p = l[h = (o ? d.delegateType : d.bindType) || h] || [],
                                    s = s[2] && new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                                    a = r = p.length; r--; )
                                        u = p[r],
                                        !n && f !== u.origType || i && i.guid !== u.guid || s && !s.test(u.namespace) || o && o !== u.selector && ("**" !== o || !u.selector) || (p.splice(r, 1),
                                        u.selector && p.delegateCount--,
                                        d.remove && d.remove.call(e, u));
                                    a && !p.length && (d.teardown && !1 !== d.teardown.call(e, m, g.handle) || k.removeEvent(e, h, g.handle),
                                    delete l[h])
                                } else
                                    for (h in l)
                                        k.event.remove(e, h + t[c], i, o, !0);
                            k.isEmptyObject(l) && se.remove(e, "handle events")
                        }
                    },
                    dispatch: function(e) {
                        var t, i, o, n, r, a, s = new Array(arguments.length), l = k.event.fix(e), c = (se.get(this, "events") || Object.create(null))[l.type] || [], u = k.event.special[l.type] || {};
                        for (s[0] = l,
                        t = 1; t < arguments.length; t++)
                            s[t] = arguments[t];
                        if (l.delegateTarget = this,
                        !u.preDispatch || !1 !== u.preDispatch.call(this, l)) {
                            for (a = k.event.handlers.call(this, l, c),
                            t = 0; (n = a[t++]) && !l.isPropagationStopped(); )
                                for (l.currentTarget = n.elem,
                                i = 0; (r = n.handlers[i++]) && !l.isImmediatePropagationStopped(); )
                                    l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace) || (l.handleObj = r,
                                    l.data = r.data,
                                    void 0 !== (o = ((k.event.special[r.origType] || {}).handle || r.handler).apply(n.elem, s)) && !1 === (l.result = o) && (l.preventDefault(),
                                    l.stopPropagation()));
                            return u.postDispatch && u.postDispatch.call(this, l),
                            l.result
                        }
                    },
                    handlers: function(e, t) {
                        var i, o, n, r, a, s = [], l = t.delegateCount, c = e.target;
                        if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                            for (; c !== this; c = c.parentNode || this)
                                if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                                    for (r = [],
                                    a = {},
                                    i = 0; i < l; i++)
                                        void 0 === a[n = (o = t[i]).selector + " "] && (a[n] = o.needsContext ? k(n, this).index(c) > -1 : k.find(n, this, null, [c]).length),
                                        a[n] && r.push(o);
                                    r.length && s.push({
                                        elem: c,
                                        handlers: r
                                    })
                                }
                        return c = this,
                        l < t.length && s.push({
                            elem: c,
                            handlers: t.slice(l)
                        }),
                        s
                    },
                    addProp: function(e, t) {
                        Object.defineProperty(k.Event.prototype, e, {
                            enumerable: !0,
                            configurable: !0,
                            get: y(t) ? function() {
                                if (this.originalEvent)
                                    return t(this.originalEvent)
                            }
                            : function() {
                                if (this.originalEvent)
                                    return this.originalEvent[e]
                            }
                            ,
                            set: function(t) {
                                Object.defineProperty(this, e, {
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0,
                                    value: t
                                })
                            }
                        })
                    },
                    fix: function(e) {
                        return e[k.expando] ? e : new k.Event(e)
                    },
                    special: {
                        load: {
                            noBubble: !0
                        },
                        click: {
                            setup: function(e) {
                                var t = this || e;
                                return ke.test(t.type) && t.click && T(t, "input") && Fe(t, "click", !0),
                                !1
                            },
                            trigger: function(e) {
                                var t = this || e;
                                return ke.test(t.type) && t.click && T(t, "input") && Fe(t, "click"),
                                !0
                            },
                            _default: function(e) {
                                var t = e.target;
                                return ke.test(t.type) && t.click && T(t, "input") && se.get(t, "click") || T(t, "a")
                            }
                        },
                        beforeunload: {
                            postDispatch: function(e) {
                                void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                            }
                        }
                    }
                },
                k.removeEvent = function(e, t, i) {
                    e.removeEventListener && e.removeEventListener(t, i)
                }
                ,
                k.Event = function(e, t) {
                    if (!(this instanceof k.Event))
                        return new k.Event(e,t);
                    e && e.type ? (this.originalEvent = e,
                    this.type = e.type,
                    this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Le : De,
                    this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
                    this.currentTarget = e.currentTarget,
                    this.relatedTarget = e.relatedTarget) : this.type = e,
                    t && k.extend(this, t),
                    this.timeStamp = e && e.timeStamp || Date.now(),
                    this[k.expando] = !0
                }
                ,
                k.Event.prototype = {
                    constructor: k.Event,
                    isDefaultPrevented: De,
                    isPropagationStopped: De,
                    isImmediatePropagationStopped: De,
                    isSimulated: !1,
                    preventDefault: function() {
                        var e = this.originalEvent;
                        this.isDefaultPrevented = Le,
                        e && !this.isSimulated && e.preventDefault()
                    },
                    stopPropagation: function() {
                        var e = this.originalEvent;
                        this.isPropagationStopped = Le,
                        e && !this.isSimulated && e.stopPropagation()
                    },
                    stopImmediatePropagation: function() {
                        var e = this.originalEvent;
                        this.isImmediatePropagationStopped = Le,
                        e && !this.isSimulated && e.stopImmediatePropagation(),
                        this.stopPropagation()
                    }
                },
                k.each({
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    code: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: !0
                }, k.event.addProp),
                k.each({
                    focus: "focusin",
                    blur: "focusout"
                }, (function(e, t) {
                    function i(e) {
                        if (b.documentMode) {
                            var i = se.get(this, "handle")
                              , o = k.event.fix(e);
                            o.type = "focusin" === e.type ? "focus" : "blur",
                            o.isSimulated = !0,
                            i(e),
                            o.target === o.currentTarget && i(o)
                        } else
                            k.event.simulate(t, e.target, k.event.fix(e))
                    }
                    k.event.special[e] = {
                        setup: function() {
                            var o;
                            if (Fe(this, e, !0),
                            !b.documentMode)
                                return !1;
                            (o = se.get(this, t)) || this.addEventListener(t, i),
                            se.set(this, t, (o || 0) + 1)
                        },
                        trigger: function() {
                            return Fe(this, e),
                            !0
                        },
                        teardown: function() {
                            var e;
                            if (!b.documentMode)
                                return !1;
                            (e = se.get(this, t) - 1) ? se.set(this, t, e) : (this.removeEventListener(t, i),
                            se.remove(this, t))
                        },
                        _default: function(t) {
                            return se.get(t.target, e)
                        },
                        delegateType: t
                    },
                    k.event.special[t] = {
                        setup: function() {
                            var o = this.ownerDocument || this.document || this
                              , n = b.documentMode ? this : o
                              , r = se.get(n, t);
                            r || (b.documentMode ? this.addEventListener(t, i) : o.addEventListener(e, i, !0)),
                            se.set(n, t, (r || 0) + 1)
                        },
                        teardown: function() {
                            var o = this.ownerDocument || this.document || this
                              , n = b.documentMode ? this : o
                              , r = se.get(n, t) - 1;
                            r ? se.set(n, t, r) : (b.documentMode ? this.removeEventListener(t, i) : o.removeEventListener(e, i, !0),
                            se.remove(n, t))
                        }
                    }
                }
                )),
                k.each({
                    mouseenter: "mouseover",
                    mouseleave: "mouseout",
                    pointerenter: "pointerover",
                    pointerleave: "pointerout"
                }, (function(e, t) {
                    k.event.special[e] = {
                        delegateType: t,
                        bindType: t,
                        handle: function(e) {
                            var i, o = e.relatedTarget, n = e.handleObj;
                            return o && (o === this || k.contains(this, o)) || (e.type = n.origType,
                            i = n.handler.apply(this, arguments),
                            e.type = t),
                            i
                        }
                    }
                }
                )),
                k.fn.extend({
                    on: function(e, t, i, o) {
                        return ze(this, e, t, i, o)
                    },
                    one: function(e, t, i, o) {
                        return ze(this, e, t, i, o, 1)
                    },
                    off: function(e, t, i) {
                        var o, n;
                        if (e && e.preventDefault && e.handleObj)
                            return o = e.handleObj,
                            k(e.delegateTarget).off(o.namespace ? o.origType + "." + o.namespace : o.origType, o.selector, o.handler),
                            this;
                        if ("object" == typeof e) {
                            for (n in e)
                                this.off(n, t, e[n]);
                            return this
                        }
                        return !1 !== t && "function" != typeof t || (i = t,
                        t = void 0),
                        !1 === i && (i = De),
                        this.each((function() {
                            k.event.remove(this, e, i, t)
                        }
                        ))
                    }
                });
                var Oe = /<script|<style|<link/i
                  , Be = /checked\s*(?:[^=]|=\s*.checked.)/i
                  , Ne = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
                function We(e, t) {
                    return T(e, "table") && T(11 !== t.nodeType ? t : t.firstChild, "tr") && k(e).children("tbody")[0] || e
                }
                function He(e) {
                    return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
                    e
                }
                function je(e) {
                    return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
                    e
                }
                function Ue(e, t) {
                    var i, o, n, r, a, s;
                    if (1 === t.nodeType) {
                        if (se.hasData(e) && (s = se.get(e).events))
                            for (n in se.remove(t, "handle events"),
                            s)
                                for (i = 0,
                                o = s[n].length; i < o; i++)
                                    k.event.add(t, n, s[n][i]);
                        le.hasData(e) && (r = le.access(e),
                        a = k.extend({}, r),
                        le.set(t, a))
                    }
                }
                function Ve(e, t) {
                    var i = t.nodeName.toLowerCase();
                    "input" === i && ke.test(e.type) ? t.checked = e.checked : "input" !== i && "textarea" !== i || (t.defaultValue = e.defaultValue)
                }
                function qe(e, t, i, o) {
                    t = l(t);
                    var n, r, a, s, c, u, d = 0, p = e.length, h = p - 1, m = t[0], f = y(m);
                    if (f || p > 1 && "string" == typeof m && !g.checkClone && Be.test(m))
                        return e.each((function(n) {
                            var r = e.eq(n);
                            f && (t[0] = m.call(this, n, r.html())),
                            qe(r, t, i, o)
                        }
                        ));
                    if (p && (r = (n = Ae(t, e[0].ownerDocument, !1, e, o)).firstChild,
                    1 === n.childNodes.length && (n = r),
                    r || o)) {
                        for (s = (a = k.map(Pe(n, "script"), He)).length; d < p; d++)
                            c = n,
                            d !== h && (c = k.clone(c, !0, !0),
                            s && k.merge(a, Pe(c, "script"))),
                            i.call(e[d], c, d);
                        if (s)
                            for (u = a[a.length - 1].ownerDocument,
                            k.map(a, je),
                            d = 0; d < s; d++)
                                c = a[d],
                                Te.test(c.type || "") && !se.access(c, "globalEval") && k.contains(u, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? k._evalUrl && !c.noModule && k._evalUrl(c.src, {
                                    nonce: c.nonce || c.getAttribute("nonce")
                                }, u) : x(c.textContent.replace(Ne, ""), c, u))
                    }
                    return e
                }
                function Ge(e, t, i) {
                    for (var o, n = t ? k.filter(t, e) : e, r = 0; null != (o = n[r]); r++)
                        i || 1 !== o.nodeType || k.cleanData(Pe(o)),
                        o.parentNode && (i && ge(o) && Ee(Pe(o, "script")),
                        o.parentNode.removeChild(o));
                    return e
                }
                k.extend({
                    htmlPrefilter: function(e) {
                        return e
                    },
                    clone: function(e, t, i) {
                        var o, n, r, a, s = e.cloneNode(!0), l = ge(e);
                        if (!(g.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || k.isXMLDoc(e)))
                            for (a = Pe(s),
                            o = 0,
                            n = (r = Pe(e)).length; o < n; o++)
                                Ve(r[o], a[o]);
                        if (t)
                            if (i)
                                for (r = r || Pe(e),
                                a = a || Pe(s),
                                o = 0,
                                n = r.length; o < n; o++)
                                    Ue(r[o], a[o]);
                            else
                                Ue(e, s);
                        return (a = Pe(s, "script")).length > 0 && Ee(a, !l && Pe(e, "script")),
                        s
                    },
                    cleanData: function(e) {
                        for (var t, i, o, n = k.event.special, r = 0; void 0 !== (i = e[r]); r++)
                            if (re(i)) {
                                if (t = i[se.expando]) {
                                    if (t.events)
                                        for (o in t.events)
                                            n[o] ? k.event.remove(i, o) : k.removeEvent(i, o, t.handle);
                                    i[se.expando] = void 0
                                }
                                i[le.expando] && (i[le.expando] = void 0)
                            }
                    }
                }),
                k.fn.extend({
                    detach: function(e) {
                        return Ge(this, e, !0)
                    },
                    remove: function(e) {
                        return Ge(this, e)
                    },
                    text: function(e) {
                        return ee(this, (function(e) {
                            return void 0 === e ? k.text(this) : this.empty().each((function() {
                                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                            }
                            ))
                        }
                        ), null, e, arguments.length)
                    },
                    append: function() {
                        return qe(this, arguments, (function(e) {
                            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || We(this, e).appendChild(e)
                        }
                        ))
                    },
                    prepend: function() {
                        return qe(this, arguments, (function(e) {
                            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                var t = We(this, e);
                                t.insertBefore(e, t.firstChild)
                            }
                        }
                        ))
                    },
                    before: function() {
                        return qe(this, arguments, (function(e) {
                            this.parentNode && this.parentNode.insertBefore(e, this)
                        }
                        ))
                    },
                    after: function() {
                        return qe(this, arguments, (function(e) {
                            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
                        }
                        ))
                    },
                    empty: function() {
                        for (var e, t = 0; null != (e = this[t]); t++)
                            1 === e.nodeType && (k.cleanData(Pe(e, !1)),
                            e.textContent = "");
                        return this
                    },
                    clone: function(e, t) {
                        return e = null != e && e,
                        t = null == t ? e : t,
                        this.map((function() {
                            return k.clone(this, e, t)
                        }
                        ))
                    },
                    html: function(e) {
                        return ee(this, (function(e) {
                            var t = this[0] || {}
                              , i = 0
                              , o = this.length;
                            if (void 0 === e && 1 === t.nodeType)
                                return t.innerHTML;
                            if ("string" == typeof e && !Oe.test(e) && !Me[(Ce.exec(e) || ["", ""])[1].toLowerCase()]) {
                                e = k.htmlPrefilter(e);
                                try {
                                    for (; i < o; i++)
                                        1 === (t = this[i] || {}).nodeType && (k.cleanData(Pe(t, !1)),
                                        t.innerHTML = e);
                                    t = 0
                                } catch (e) {}
                            }
                            t && this.empty().append(e)
                        }
                        ), null, e, arguments.length)
                    },
                    replaceWith: function() {
                        var e = [];
                        return qe(this, arguments, (function(t) {
                            var i = this.parentNode;
                            k.inArray(this, e) < 0 && (k.cleanData(Pe(this)),
                            i && i.replaceChild(t, this))
                        }
                        ), e)
                    }
                }),
                k.each({
                    appendTo: "append",
                    prependTo: "prepend",
                    insertBefore: "before",
                    insertAfter: "after",
                    replaceAll: "replaceWith"
                }, (function(e, t) {
                    k.fn[e] = function(e) {
                        for (var i, o = [], n = k(e), r = n.length - 1, a = 0; a <= r; a++)
                            i = a === r ? this : this.clone(!0),
                            k(n[a])[t](i),
                            c.apply(o, i.get());
                        return this.pushStack(o)
                    }
                }
                ));
                var Ke = new RegExp("^(" + pe + ")(?!px)[a-z%]+$","i")
                  , Xe = /^--/
                  , Ze = function(e) {
                    var t = e.ownerDocument.defaultView;
                    return t && t.opener || (t = o),
                    t.getComputedStyle(e)
                }
                  , Ye = function(e, t, i) {
                    var o, n, r = {};
                    for (n in t)
                        r[n] = e.style[n],
                        e.style[n] = t[n];
                    for (n in o = i.call(e),
                    t)
                        e.style[n] = r[n];
                    return o
                }
                  , Qe = new RegExp(me.join("|"),"i");
                function Je(e, t, i) {
                    var o, n, r, a, s = Xe.test(t), l = e.style;
                    return (i = i || Ze(e)) && (a = i.getPropertyValue(t) || i[t],
                    s && a && (a = a.replace(A, "$1") || void 0),
                    "" !== a || ge(e) || (a = k.style(e, t)),
                    !g.pixelBoxStyles() && Ke.test(a) && Qe.test(t) && (o = l.width,
                    n = l.minWidth,
                    r = l.maxWidth,
                    l.minWidth = l.maxWidth = l.width = a,
                    a = i.width,
                    l.width = o,
                    l.minWidth = n,
                    l.maxWidth = r)),
                    void 0 !== a ? a + "" : a
                }
                function et(e, t) {
                    return {
                        get: function() {
                            if (!e())
                                return (this.get = t).apply(this, arguments);
                            delete this.get
                        }
                    }
                }
                !function() {
                    function e() {
                        if (u) {
                            c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                            u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                            fe.appendChild(c).appendChild(u);
                            var e = o.getComputedStyle(u);
                            i = "1%" !== e.top,
                            l = 12 === t(e.marginLeft),
                            u.style.right = "60%",
                            a = 36 === t(e.right),
                            n = 36 === t(e.width),
                            u.style.position = "absolute",
                            r = 12 === t(u.offsetWidth / 3),
                            fe.removeChild(c),
                            u = null
                        }
                    }
                    function t(e) {
                        return Math.round(parseFloat(e))
                    }
                    var i, n, r, a, s, l, c = b.createElement("div"), u = b.createElement("div");
                    u.style && (u.style.backgroundClip = "content-box",
                    u.cloneNode(!0).style.backgroundClip = "",
                    g.clearCloneStyle = "content-box" === u.style.backgroundClip,
                    k.extend(g, {
                        boxSizingReliable: function() {
                            return e(),
                            n
                        },
                        pixelBoxStyles: function() {
                            return e(),
                            a
                        },
                        pixelPosition: function() {
                            return e(),
                            i
                        },
                        reliableMarginLeft: function() {
                            return e(),
                            l
                        },
                        scrollboxSize: function() {
                            return e(),
                            r
                        },
                        reliableTrDimensions: function() {
                            var e, t, i, n;
                            return null == s && (e = b.createElement("table"),
                            t = b.createElement("tr"),
                            i = b.createElement("div"),
                            e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate",
                            t.style.cssText = "box-sizing:content-box;border:1px solid",
                            t.style.height = "1px",
                            i.style.height = "9px",
                            i.style.display = "block",
                            fe.appendChild(e).appendChild(t).appendChild(i),
                            n = o.getComputedStyle(t),
                            s = parseInt(n.height, 10) + parseInt(n.borderTopWidth, 10) + parseInt(n.borderBottomWidth, 10) === t.offsetHeight,
                            fe.removeChild(e)),
                            s
                        }
                    }))
                }();
                var tt = ["Webkit", "Moz", "ms"]
                  , it = b.createElement("div").style
                  , ot = {};
                function nt(e) {
                    return k.cssProps[e] || ot[e] || (e in it ? e : ot[e] = function(e) {
                        for (var t = e[0].toUpperCase() + e.slice(1), i = tt.length; i--; )
                            if ((e = tt[i] + t)in it)
                                return e
                    }(e) || e)
                }
                var rt = /^(none|table(?!-c[ea]).+)/
                  , at = {
                    position: "absolute",
                    visibility: "hidden",
                    display: "block"
                }
                  , st = {
                    letterSpacing: "0",
                    fontWeight: "400"
                };
                function lt(e, t, i) {
                    var o = he.exec(t);
                    return o ? Math.max(0, o[2] - (i || 0)) + (o[3] || "px") : t
                }
                function ct(e, t, i, o, n, r) {
                    var a = "width" === t ? 1 : 0
                      , s = 0
                      , l = 0
                      , c = 0;
                    if (i === (o ? "border" : "content"))
                        return 0;
                    for (; a < 4; a += 2)
                        "margin" === i && (c += k.css(e, i + me[a], !0, n)),
                        o ? ("content" === i && (l -= k.css(e, "padding" + me[a], !0, n)),
                        "margin" !== i && (l -= k.css(e, "border" + me[a] + "Width", !0, n))) : (l += k.css(e, "padding" + me[a], !0, n),
                        "padding" !== i ? l += k.css(e, "border" + me[a] + "Width", !0, n) : s += k.css(e, "border" + me[a] + "Width", !0, n));
                    return !o && r >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - s - .5)) || 0),
                    l + c
                }
                function ut(e, t, i) {
                    var o = Ze(e)
                      , n = (!g.boxSizingReliable() || i) && "border-box" === k.css(e, "boxSizing", !1, o)
                      , r = n
                      , a = Je(e, t, o)
                      , s = "offset" + t[0].toUpperCase() + t.slice(1);
                    if (Ke.test(a)) {
                        if (!i)
                            return a;
                        a = "auto"
                    }
                    return (!g.boxSizingReliable() && n || !g.reliableTrDimensions() && T(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === k.css(e, "display", !1, o)) && e.getClientRects().length && (n = "border-box" === k.css(e, "boxSizing", !1, o),
                    (r = s in e) && (a = e[s])),
                    (a = parseFloat(a) || 0) + ct(e, t, i || (n ? "border" : "content"), r, o, a) + "px"
                }
                function dt(e, t, i, o, n) {
                    return new dt.prototype.init(e,t,i,o,n)
                }
                k.extend({
                    cssHooks: {
                        opacity: {
                            get: function(e, t) {
                                if (t) {
                                    var i = Je(e, "opacity");
                                    return "" === i ? "1" : i
                                }
                            }
                        }
                    },
                    cssNumber: {
                        animationIterationCount: !0,
                        aspectRatio: !0,
                        borderImageSlice: !0,
                        columnCount: !0,
                        flexGrow: !0,
                        flexShrink: !0,
                        fontWeight: !0,
                        gridArea: !0,
                        gridColumn: !0,
                        gridColumnEnd: !0,
                        gridColumnStart: !0,
                        gridRow: !0,
                        gridRowEnd: !0,
                        gridRowStart: !0,
                        lineHeight: !0,
                        opacity: !0,
                        order: !0,
                        orphans: !0,
                        scale: !0,
                        widows: !0,
                        zIndex: !0,
                        zoom: !0,
                        fillOpacity: !0,
                        floodOpacity: !0,
                        stopOpacity: !0,
                        strokeMiterlimit: !0,
                        strokeOpacity: !0
                    },
                    cssProps: {},
                    style: function(e, t, i, o) {
                        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                            var n, r, a, s = ne(t), l = Xe.test(t), c = e.style;
                            if (l || (t = nt(s)),
                            a = k.cssHooks[t] || k.cssHooks[s],
                            void 0 === i)
                                return a && "get"in a && void 0 !== (n = a.get(e, !1, o)) ? n : c[t];
                            "string" == (r = typeof i) && (n = he.exec(i)) && n[1] && (i = be(e, t, n),
                            r = "number"),
                            null != i && i == i && ("number" !== r || l || (i += n && n[3] || (k.cssNumber[s] ? "" : "px")),
                            g.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                            a && "set"in a && void 0 === (i = a.set(e, i, o)) || (l ? c.setProperty(t, i) : c[t] = i))
                        }
                    },
                    css: function(e, t, i, o) {
                        var n, r, a, s = ne(t);
                        return Xe.test(t) || (t = nt(s)),
                        (a = k.cssHooks[t] || k.cssHooks[s]) && "get"in a && (n = a.get(e, !0, i)),
                        void 0 === n && (n = Je(e, t, o)),
                        "normal" === n && t in st && (n = st[t]),
                        "" === i || i ? (r = parseFloat(n),
                        !0 === i || isFinite(r) ? r || 0 : n) : n
                    }
                }),
                k.each(["height", "width"], (function(e, t) {
                    k.cssHooks[t] = {
                        get: function(e, i, o) {
                            if (i)
                                return !rt.test(k.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ut(e, t, o) : Ye(e, at, (function() {
                                    return ut(e, t, o)
                                }
                                ))
                        },
                        set: function(e, i, o) {
                            var n, r = Ze(e), a = !g.scrollboxSize() && "absolute" === r.position, s = (a || o) && "border-box" === k.css(e, "boxSizing", !1, r), l = o ? ct(e, t, o, s, r) : 0;
                            return s && a && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(r[t]) - ct(e, t, "border", !1, r) - .5)),
                            l && (n = he.exec(i)) && "px" !== (n[3] || "px") && (e.style[t] = i,
                            i = k.css(e, t)),
                            lt(0, i, l)
                        }
                    }
                }
                )),
                k.cssHooks.marginLeft = et(g.reliableMarginLeft, (function(e, t) {
                    if (t)
                        return (parseFloat(Je(e, "marginLeft")) || e.getBoundingClientRect().left - Ye(e, {
                            marginLeft: 0
                        }, (function() {
                            return e.getBoundingClientRect().left
                        }
                        ))) + "px"
                }
                )),
                k.each({
                    margin: "",
                    padding: "",
                    border: "Width"
                }, (function(e, t) {
                    k.cssHooks[e + t] = {
                        expand: function(i) {
                            for (var o = 0, n = {}, r = "string" == typeof i ? i.split(" ") : [i]; o < 4; o++)
                                n[e + me[o] + t] = r[o] || r[o - 2] || r[0];
                            return n
                        }
                    },
                    "margin" !== e && (k.cssHooks[e + t].set = lt)
                }
                )),
                k.fn.extend({
                    css: function(e, t) {
                        return ee(this, (function(e, t, i) {
                            var o, n, r = {}, a = 0;
                            if (Array.isArray(t)) {
                                for (o = Ze(e),
                                n = t.length; a < n; a++)
                                    r[t[a]] = k.css(e, t[a], !1, o);
                                return r
                            }
                            return void 0 !== i ? k.style(e, t, i) : k.css(e, t)
                        }
                        ), e, t, arguments.length > 1)
                    }
                }),
                k.Tween = dt,
                dt.prototype = {
                    constructor: dt,
                    init: function(e, t, i, o, n, r) {
                        this.elem = e,
                        this.prop = i,
                        this.easing = n || k.easing._default,
                        this.options = t,
                        this.start = this.now = this.cur(),
                        this.end = o,
                        this.unit = r || (k.cssNumber[i] ? "" : "px")
                    },
                    cur: function() {
                        var e = dt.propHooks[this.prop];
                        return e && e.get ? e.get(this) : dt.propHooks._default.get(this)
                    },
                    run: function(e) {
                        var t, i = dt.propHooks[this.prop];
                        return this.options.duration ? this.pos = t = k.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
                        this.now = (this.end - this.start) * t + this.start,
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        i && i.set ? i.set(this) : dt.propHooks._default.set(this),
                        this
                    }
                },
                dt.prototype.init.prototype = dt.prototype,
                dt.propHooks = {
                    _default: {
                        get: function(e) {
                            var t;
                            return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = k.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
                        },
                        set: function(e) {
                            k.fx.step[e.prop] ? k.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !k.cssHooks[e.prop] && null == e.elem.style[nt(e.prop)] ? e.elem[e.prop] = e.now : k.style(e.elem, e.prop, e.now + e.unit)
                        }
                    }
                },
                dt.propHooks.scrollTop = dt.propHooks.scrollLeft = {
                    set: function(e) {
                        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
                    }
                },
                k.easing = {
                    linear: function(e) {
                        return e
                    },
                    swing: function(e) {
                        return .5 - Math.cos(e * Math.PI) / 2
                    },
                    _default: "swing"
                },
                k.fx = dt.prototype.init,
                k.fx.step = {};
                var pt, ht, mt = /^(?:toggle|show|hide)$/, ft = /queueHooks$/;
                function gt() {
                    ht && (!1 === b.hidden && o.requestAnimationFrame ? o.requestAnimationFrame(gt) : o.setTimeout(gt, k.fx.interval),
                    k.fx.tick())
                }
                function yt() {
                    return o.setTimeout((function() {
                        pt = void 0
                    }
                    )),
                    pt = Date.now()
                }
                function $t(e, t) {
                    var i, o = 0, n = {
                        height: e
                    };
                    for (t = t ? 1 : 0; o < 4; o += 2 - t)
                        n["margin" + (i = me[o])] = n["padding" + i] = e;
                    return t && (n.opacity = n.width = e),
                    n
                }
                function bt(e, t, i) {
                    for (var o, n = (vt.tweeners[t] || []).concat(vt.tweeners["*"]), r = 0, a = n.length; r < a; r++)
                        if (o = n[r].call(i, t, e))
                            return o
                }
                function vt(e, t, i) {
                    var o, n, r = 0, a = vt.prefilters.length, s = k.Deferred().always((function() {
                        delete l.elem
                    }
                    )), l = function() {
                        if (n)
                            return !1;
                        for (var t = pt || yt(), i = Math.max(0, c.startTime + c.duration - t), o = 1 - (i / c.duration || 0), r = 0, a = c.tweens.length; r < a; r++)
                            c.tweens[r].run(o);
                        return s.notifyWith(e, [c, o, i]),
                        o < 1 && a ? i : (a || s.notifyWith(e, [c, 1, 0]),
                        s.resolveWith(e, [c]),
                        !1)
                    }, c = s.promise({
                        elem: e,
                        props: k.extend({}, t),
                        opts: k.extend(!0, {
                            specialEasing: {},
                            easing: k.easing._default
                        }, i),
                        originalProperties: t,
                        originalOptions: i,
                        startTime: pt || yt(),
                        duration: i.duration,
                        tweens: [],
                        createTween: function(t, i) {
                            var o = k.Tween(e, c.opts, t, i, c.opts.specialEasing[t] || c.opts.easing);
                            return c.tweens.push(o),
                            o
                        },
                        stop: function(t) {
                            var i = 0
                              , o = t ? c.tweens.length : 0;
                            if (n)
                                return this;
                            for (n = !0; i < o; i++)
                                c.tweens[i].run(1);
                            return t ? (s.notifyWith(e, [c, 1, 0]),
                            s.resolveWith(e, [c, t])) : s.rejectWith(e, [c, t]),
                            this
                        }
                    }), u = c.props;
                    for (function(e, t) {
                        var i, o, n, r, a;
                        for (i in e)
                            if (n = t[o = ne(i)],
                            r = e[i],
                            Array.isArray(r) && (n = r[1],
                            r = e[i] = r[0]),
                            i !== o && (e[o] = r,
                            delete e[i]),
                            (a = k.cssHooks[o]) && "expand"in a)
                                for (i in r = a.expand(r),
                                delete e[o],
                                r)
                                    i in e || (e[i] = r[i],
                                    t[i] = n);
                            else
                                t[o] = n
                    }(u, c.opts.specialEasing); r < a; r++)
                        if (o = vt.prefilters[r].call(c, e, u, c.opts))
                            return y(o.stop) && (k._queueHooks(c.elem, c.opts.queue).stop = o.stop.bind(o)),
                            o;
                    return k.map(u, bt, c),
                    y(c.opts.start) && c.opts.start.call(e, c),
                    c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
                    k.fx.timer(k.extend(l, {
                        elem: e,
                        anim: c,
                        queue: c.opts.queue
                    })),
                    c
                }
                k.Animation = k.extend(vt, {
                    tweeners: {
                        "*": [function(e, t) {
                            var i = this.createTween(e, t);
                            return be(i.elem, e, he.exec(t), i),
                            i
                        }
                        ]
                    },
                    tweener: function(e, t) {
                        y(e) ? (t = e,
                        e = ["*"]) : e = e.match(G);
                        for (var i, o = 0, n = e.length; o < n; o++)
                            i = e[o],
                            vt.tweeners[i] = vt.tweeners[i] || [],
                            vt.tweeners[i].unshift(t)
                    },
                    prefilters: [function(e, t, i) {
                        var o, n, r, a, s, l, c, u, d = "width"in t || "height"in t, p = this, h = {}, m = e.style, f = e.nodeType && $e(e), g = se.get(e, "fxshow");
                        for (o in i.queue || (null == (a = k._queueHooks(e, "fx")).unqueued && (a.unqueued = 0,
                        s = a.empty.fire,
                        a.empty.fire = function() {
                            a.unqueued || s()
                        }
                        ),
                        a.unqueued++,
                        p.always((function() {
                            p.always((function() {
                                a.unqueued--,
                                k.queue(e, "fx").length || a.empty.fire()
                            }
                            ))
                        }
                        ))),
                        t)
                            if (n = t[o],
                            mt.test(n)) {
                                if (delete t[o],
                                r = r || "toggle" === n,
                                n === (f ? "hide" : "show")) {
                                    if ("show" !== n || !g || void 0 === g[o])
                                        continue;
                                    f = !0
                                }
                                h[o] = g && g[o] || k.style(e, o)
                            }
                        if ((l = !k.isEmptyObject(t)) || !k.isEmptyObject(h))
                            for (o in d && 1 === e.nodeType && (i.overflow = [m.overflow, m.overflowX, m.overflowY],
                            null == (c = g && g.display) && (c = se.get(e, "display")),
                            "none" === (u = k.css(e, "display")) && (c ? u = c : (we([e], !0),
                            c = e.style.display || c,
                            u = k.css(e, "display"),
                            we([e]))),
                            ("inline" === u || "inline-block" === u && null != c) && "none" === k.css(e, "float") && (l || (p.done((function() {
                                m.display = c
                            }
                            )),
                            null == c && (u = m.display,
                            c = "none" === u ? "" : u)),
                            m.display = "inline-block")),
                            i.overflow && (m.overflow = "hidden",
                            p.always((function() {
                                m.overflow = i.overflow[0],
                                m.overflowX = i.overflow[1],
                                m.overflowY = i.overflow[2]
                            }
                            ))),
                            l = !1,
                            h)
                                l || (g ? "hidden"in g && (f = g.hidden) : g = se.access(e, "fxshow", {
                                    display: c
                                }),
                                r && (g.hidden = !f),
                                f && we([e], !0),
                                p.done((function() {
                                    for (o in f || we([e]),
                                    se.remove(e, "fxshow"),
                                    h)
                                        k.style(e, o, h[o])
                                }
                                ))),
                                l = bt(f ? g[o] : 0, o, p),
                                o in g || (g[o] = l.start,
                                f && (l.end = l.start,
                                l.start = 0))
                    }
                    ],
                    prefilter: function(e, t) {
                        t ? vt.prefilters.unshift(e) : vt.prefilters.push(e)
                    }
                }),
                k.speed = function(e, t, i) {
                    var o = e && "object" == typeof e ? k.extend({}, e) : {
                        complete: i || !i && t || y(e) && e,
                        duration: e,
                        easing: i && t || t && !y(t) && t
                    };
                    return k.fx.off ? o.duration = 0 : "number" != typeof o.duration && (o.duration in k.fx.speeds ? o.duration = k.fx.speeds[o.duration] : o.duration = k.fx.speeds._default),
                    null != o.queue && !0 !== o.queue || (o.queue = "fx"),
                    o.old = o.complete,
                    o.complete = function() {
                        y(o.old) && o.old.call(this),
                        o.queue && k.dequeue(this, o.queue)
                    }
                    ,
                    o
                }
                ,
                k.fn.extend({
                    fadeTo: function(e, t, i, o) {
                        return this.filter($e).css("opacity", 0).show().end().animate({
                            opacity: t
                        }, e, i, o)
                    },
                    animate: function(e, t, i, o) {
                        var n = k.isEmptyObject(e)
                          , r = k.speed(t, i, o)
                          , a = function() {
                            var t = vt(this, k.extend({}, e), r);
                            (n || se.get(this, "finish")) && t.stop(!0)
                        };
                        return a.finish = a,
                        n || !1 === r.queue ? this.each(a) : this.queue(r.queue, a)
                    },
                    stop: function(e, t, i) {
                        var o = function(e) {
                            var t = e.stop;
                            delete e.stop,
                            t(i)
                        };
                        return "string" != typeof e && (i = t,
                        t = e,
                        e = void 0),
                        t && this.queue(e || "fx", []),
                        this.each((function() {
                            var t = !0
                              , n = null != e && e + "queueHooks"
                              , r = k.timers
                              , a = se.get(this);
                            if (n)
                                a[n] && a[n].stop && o(a[n]);
                            else
                                for (n in a)
                                    a[n] && a[n].stop && ft.test(n) && o(a[n]);
                            for (n = r.length; n--; )
                                r[n].elem !== this || null != e && r[n].queue !== e || (r[n].anim.stop(i),
                                t = !1,
                                r.splice(n, 1));
                            !t && i || k.dequeue(this, e)
                        }
                        ))
                    },
                    finish: function(e) {
                        return !1 !== e && (e = e || "fx"),
                        this.each((function() {
                            var t, i = se.get(this), o = i[e + "queue"], n = i[e + "queueHooks"], r = k.timers, a = o ? o.length : 0;
                            for (i.finish = !0,
                            k.queue(this, e, []),
                            n && n.stop && n.stop.call(this, !0),
                            t = r.length; t--; )
                                r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0),
                                r.splice(t, 1));
                            for (t = 0; t < a; t++)
                                o[t] && o[t].finish && o[t].finish.call(this);
                            delete i.finish
                        }
                        ))
                    }
                }),
                k.each(["toggle", "show", "hide"], (function(e, t) {
                    var i = k.fn[t];
                    k.fn[t] = function(e, o, n) {
                        return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate($t(t, !0), e, o, n)
                    }
                }
                )),
                k.each({
                    slideDown: $t("show"),
                    slideUp: $t("hide"),
                    slideToggle: $t("toggle"),
                    fadeIn: {
                        opacity: "show"
                    },
                    fadeOut: {
                        opacity: "hide"
                    },
                    fadeToggle: {
                        opacity: "toggle"
                    }
                }, (function(e, t) {
                    k.fn[e] = function(e, i, o) {
                        return this.animate(t, e, i, o)
                    }
                }
                )),
                k.timers = [],
                k.fx.tick = function() {
                    var e, t = 0, i = k.timers;
                    for (pt = Date.now(); t < i.length; t++)
                        (e = i[t])() || i[t] !== e || i.splice(t--, 1);
                    i.length || k.fx.stop(),
                    pt = void 0
                }
                ,
                k.fx.timer = function(e) {
                    k.timers.push(e),
                    k.fx.start()
                }
                ,
                k.fx.interval = 13,
                k.fx.start = function() {
                    ht || (ht = !0,
                    gt())
                }
                ,
                k.fx.stop = function() {
                    ht = null
                }
                ,
                k.fx.speeds = {
                    slow: 600,
                    fast: 200,
                    _default: 400
                },
                k.fn.delay = function(e, t) {
                    return e = k.fx && k.fx.speeds[e] || e,
                    t = t || "fx",
                    this.queue(t, (function(t, i) {
                        var n = o.setTimeout(t, e);
                        i.stop = function() {
                            o.clearTimeout(n)
                        }
                    }
                    ))
                }
                ,
                function() {
                    var e = b.createElement("input")
                      , t = b.createElement("select").appendChild(b.createElement("option"));
                    e.type = "checkbox",
                    g.checkOn = "" !== e.value,
                    g.optSelected = t.selected,
                    (e = b.createElement("input")).value = "t",
                    e.type = "radio",
                    g.radioValue = "t" === e.value
                }();
                var xt, wt = k.expr.attrHandle;
                k.fn.extend({
                    attr: function(e, t) {
                        return ee(this, k.attr, e, t, arguments.length > 1)
                    },
                    removeAttr: function(e) {
                        return this.each((function() {
                            k.removeAttr(this, e)
                        }
                        ))
                    }
                }),
                k.extend({
                    attr: function(e, t, i) {
                        var o, n, r = e.nodeType;
                        if (3 !== r && 8 !== r && 2 !== r)
                            return void 0 === e.getAttribute ? k.prop(e, t, i) : (1 === r && k.isXMLDoc(e) || (n = k.attrHooks[t.toLowerCase()] || (k.expr.match.bool.test(t) ? xt : void 0)),
                            void 0 !== i ? null === i ? void k.removeAttr(e, t) : n && "set"in n && void 0 !== (o = n.set(e, i, t)) ? o : (e.setAttribute(t, i + ""),
                            i) : n && "get"in n && null !== (o = n.get(e, t)) ? o : null == (o = k.find.attr(e, t)) ? void 0 : o)
                    },
                    attrHooks: {
                        type: {
                            set: function(e, t) {
                                if (!g.radioValue && "radio" === t && T(e, "input")) {
                                    var i = e.value;
                                    return e.setAttribute("type", t),
                                    i && (e.value = i),
                                    t
                                }
                            }
                        }
                    },
                    removeAttr: function(e, t) {
                        var i, o = 0, n = t && t.match(G);
                        if (n && 1 === e.nodeType)
                            for (; i = n[o++]; )
                                e.removeAttribute(i)
                    }
                }),
                xt = {
                    set: function(e, t, i) {
                        return !1 === t ? k.removeAttr(e, i) : e.setAttribute(i, i),
                        i
                    }
                },
                k.each(k.expr.match.bool.source.match(/\w+/g), (function(e, t) {
                    var i = wt[t] || k.find.attr;
                    wt[t] = function(e, t, o) {
                        var n, r, a = t.toLowerCase();
                        return o || (r = wt[a],
                        wt[a] = n,
                        n = null != i(e, t, o) ? a : null,
                        wt[a] = r),
                        n
                    }
                }
                ));
                var St = /^(?:input|select|textarea|button)$/i
                  , _t = /^(?:a|area)$/i;
                function kt(e) {
                    return (e.match(G) || []).join(" ")
                }
                function Ct(e) {
                    return e.getAttribute && e.getAttribute("class") || ""
                }
                function Tt(e) {
                    return Array.isArray(e) ? e : "string" == typeof e && e.match(G) || []
                }
                k.fn.extend({
                    prop: function(e, t) {
                        return ee(this, k.prop, e, t, arguments.length > 1)
                    },
                    removeProp: function(e) {
                        return this.each((function() {
                            delete this[k.propFix[e] || e]
                        }
                        ))
                    }
                }),
                k.extend({
                    prop: function(e, t, i) {
                        var o, n, r = e.nodeType;
                        if (3 !== r && 8 !== r && 2 !== r)
                            return 1 === r && k.isXMLDoc(e) || (t = k.propFix[t] || t,
                            n = k.propHooks[t]),
                            void 0 !== i ? n && "set"in n && void 0 !== (o = n.set(e, i, t)) ? o : e[t] = i : n && "get"in n && null !== (o = n.get(e, t)) ? o : e[t]
                    },
                    propHooks: {
                        tabIndex: {
                            get: function(e) {
                                var t = k.find.attr(e, "tabindex");
                                return t ? parseInt(t, 10) : St.test(e.nodeName) || _t.test(e.nodeName) && e.href ? 0 : -1
                            }
                        }
                    },
                    propFix: {
                        for: "htmlFor",
                        class: "className"
                    }
                }),
                g.optSelected || (k.propHooks.selected = {
                    get: function(e) {
                        var t = e.parentNode;
                        return t && t.parentNode && t.parentNode.selectedIndex,
                        null
                    },
                    set: function(e) {
                        var t = e.parentNode;
                        t && (t.selectedIndex,
                        t.parentNode && t.parentNode.selectedIndex)
                    }
                }),
                k.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], (function() {
                    k.propFix[this.toLowerCase()] = this
                }
                )),
                k.fn.extend({
                    addClass: function(e) {
                        var t, i, o, n, r, a;
                        return y(e) ? this.each((function(t) {
                            k(this).addClass(e.call(this, t, Ct(this)))
                        }
                        )) : (t = Tt(e)).length ? this.each((function() {
                            if (o = Ct(this),
                            i = 1 === this.nodeType && " " + kt(o) + " ") {
                                for (r = 0; r < t.length; r++)
                                    n = t[r],
                                    i.indexOf(" " + n + " ") < 0 && (i += n + " ");
                                a = kt(i),
                                o !== a && this.setAttribute("class", a)
                            }
                        }
                        )) : this
                    },
                    removeClass: function(e) {
                        var t, i, o, n, r, a;
                        return y(e) ? this.each((function(t) {
                            k(this).removeClass(e.call(this, t, Ct(this)))
                        }
                        )) : arguments.length ? (t = Tt(e)).length ? this.each((function() {
                            if (o = Ct(this),
                            i = 1 === this.nodeType && " " + kt(o) + " ") {
                                for (r = 0; r < t.length; r++)
                                    for (n = t[r]; i.indexOf(" " + n + " ") > -1; )
                                        i = i.replace(" " + n + " ", " ");
                                a = kt(i),
                                o !== a && this.setAttribute("class", a)
                            }
                        }
                        )) : this : this.attr("class", "")
                    },
                    toggleClass: function(e, t) {
                        var i, o, n, r, a = typeof e, s = "string" === a || Array.isArray(e);
                        return y(e) ? this.each((function(i) {
                            k(this).toggleClass(e.call(this, i, Ct(this), t), t)
                        }
                        )) : "boolean" == typeof t && s ? t ? this.addClass(e) : this.removeClass(e) : (i = Tt(e),
                        this.each((function() {
                            if (s)
                                for (r = k(this),
                                n = 0; n < i.length; n++)
                                    o = i[n],
                                    r.hasClass(o) ? r.removeClass(o) : r.addClass(o);
                            else
                                void 0 !== e && "boolean" !== a || ((o = Ct(this)) && se.set(this, "__className__", o),
                                this.setAttribute && this.setAttribute("class", o || !1 === e ? "" : se.get(this, "__className__") || ""))
                        }
                        )))
                    },
                    hasClass: function(e) {
                        var t, i, o = 0;
                        for (t = " " + e + " "; i = this[o++]; )
                            if (1 === i.nodeType && (" " + kt(Ct(i)) + " ").indexOf(t) > -1)
                                return !0;
                        return !1
                    }
                });
                var Mt = /\r/g;
                k.fn.extend({
                    val: function(e) {
                        var t, i, o, n = this[0];
                        return arguments.length ? (o = y(e),
                        this.each((function(i) {
                            var n;
                            1 === this.nodeType && (null == (n = o ? e.call(this, i, k(this).val()) : e) ? n = "" : "number" == typeof n ? n += "" : Array.isArray(n) && (n = k.map(n, (function(e) {
                                return null == e ? "" : e + ""
                            }
                            ))),
                            (t = k.valHooks[this.type] || k.valHooks[this.nodeName.toLowerCase()]) && "set"in t && void 0 !== t.set(this, n, "value") || (this.value = n))
                        }
                        ))) : n ? (t = k.valHooks[n.type] || k.valHooks[n.nodeName.toLowerCase()]) && "get"in t && void 0 !== (i = t.get(n, "value")) ? i : "string" == typeof (i = n.value) ? i.replace(Mt, "") : null == i ? "" : i : void 0
                    }
                }),
                k.extend({
                    valHooks: {
                        option: {
                            get: function(e) {
                                var t = k.find.attr(e, "value");
                                return null != t ? t : kt(k.text(e))
                            }
                        },
                        select: {
                            get: function(e) {
                                var t, i, o, n = e.options, r = e.selectedIndex, a = "select-one" === e.type, s = a ? null : [], l = a ? r + 1 : n.length;
                                for (o = r < 0 ? l : a ? r : 0; o < l; o++)
                                    if (((i = n[o]).selected || o === r) && !i.disabled && (!i.parentNode.disabled || !T(i.parentNode, "optgroup"))) {
                                        if (t = k(i).val(),
                                        a)
                                            return t;
                                        s.push(t)
                                    }
                                return s
                            },
                            set: function(e, t) {
                                for (var i, o, n = e.options, r = k.makeArray(t), a = n.length; a--; )
                                    ((o = n[a]).selected = k.inArray(k.valHooks.option.get(o), r) > -1) && (i = !0);
                                return i || (e.selectedIndex = -1),
                                r
                            }
                        }
                    }
                }),
                k.each(["radio", "checkbox"], (function() {
                    k.valHooks[this] = {
                        set: function(e, t) {
                            if (Array.isArray(t))
                                return e.checked = k.inArray(k(e).val(), t) > -1
                        }
                    },
                    g.checkOn || (k.valHooks[this].get = function(e) {
                        return null === e.getAttribute("value") ? "on" : e.value
                    }
                    )
                }
                ));
                var Pt = o.location
                  , Et = {
                    guid: Date.now()
                }
                  , Rt = /\?/;
                k.parseXML = function(e) {
                    var t, i;
                    if (!e || "string" != typeof e)
                        return null;
                    try {
                        t = (new o.DOMParser).parseFromString(e, "text/xml")
                    } catch (e) {}
                    return i = t && t.getElementsByTagName("parsererror")[0],
                    t && !i || k.error("Invalid XML: " + (i ? k.map(i.childNodes, (function(e) {
                        return e.textContent
                    }
                    )).join("\n") : e)),
                    t
                }
                ;
                var At = /^(?:focusinfocus|focusoutblur)$/
                  , It = function(e) {
                    e.stopPropagation()
                };
                k.extend(k.event, {
                    trigger: function(e, t, i, n) {
                        var r, a, s, l, c, u, d, p, m = [i || b], f = h.call(e, "type") ? e.type : e, g = h.call(e, "namespace") ? e.namespace.split(".") : [];
                        if (a = p = s = i = i || b,
                        3 !== i.nodeType && 8 !== i.nodeType && !At.test(f + k.event.triggered) && (f.indexOf(".") > -1 && (g = f.split("."),
                        f = g.shift(),
                        g.sort()),
                        c = f.indexOf(":") < 0 && "on" + f,
                        (e = e[k.expando] ? e : new k.Event(f,"object" == typeof e && e)).isTrigger = n ? 2 : 3,
                        e.namespace = g.join("."),
                        e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
                        e.result = void 0,
                        e.target || (e.target = i),
                        t = null == t ? [e] : k.makeArray(t, [e]),
                        d = k.event.special[f] || {},
                        n || !d.trigger || !1 !== d.trigger.apply(i, t))) {
                            if (!n && !d.noBubble && !$(i)) {
                                for (l = d.delegateType || f,
                                At.test(l + f) || (a = a.parentNode); a; a = a.parentNode)
                                    m.push(a),
                                    s = a;
                                s === (i.ownerDocument || b) && m.push(s.defaultView || s.parentWindow || o)
                            }
                            for (r = 0; (a = m[r++]) && !e.isPropagationStopped(); )
                                p = a,
                                e.type = r > 1 ? l : d.bindType || f,
                                (u = (se.get(a, "events") || Object.create(null))[e.type] && se.get(a, "handle")) && u.apply(a, t),
                                (u = c && a[c]) && u.apply && re(a) && (e.result = u.apply(a, t),
                                !1 === e.result && e.preventDefault());
                            return e.type = f,
                            n || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(m.pop(), t) || !re(i) || c && y(i[f]) && !$(i) && ((s = i[c]) && (i[c] = null),
                            k.event.triggered = f,
                            e.isPropagationStopped() && p.addEventListener(f, It),
                            i[f](),
                            e.isPropagationStopped() && p.removeEventListener(f, It),
                            k.event.triggered = void 0,
                            s && (i[c] = s)),
                            e.result
                        }
                    },
                    simulate: function(e, t, i) {
                        var o = k.extend(new k.Event, i, {
                            type: e,
                            isSimulated: !0
                        });
                        k.event.trigger(o, null, t)
                    }
                }),
                k.fn.extend({
                    trigger: function(e, t) {
                        return this.each((function() {
                            k.event.trigger(e, t, this)
                        }
                        ))
                    },
                    triggerHandler: function(e, t) {
                        var i = this[0];
                        if (i)
                            return k.event.trigger(e, t, i, !0)
                    }
                });
                var Lt = /\[\]$/
                  , Dt = /\r?\n/g
                  , zt = /^(?:submit|button|image|reset|file)$/i
                  , Ft = /^(?:input|select|textarea|keygen)/i;
                function Ot(e, t, i, o) {
                    var n;
                    if (Array.isArray(t))
                        k.each(t, (function(t, n) {
                            i || Lt.test(e) ? o(e, n) : Ot(e + "[" + ("object" == typeof n && null != n ? t : "") + "]", n, i, o)
                        }
                        ));
                    else if (i || "object" !== w(t))
                        o(e, t);
                    else
                        for (n in t)
                            Ot(e + "[" + n + "]", t[n], i, o)
                }
                k.param = function(e, t) {
                    var i, o = [], n = function(e, t) {
                        var i = y(t) ? t() : t;
                        o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i)
                    };
                    if (null == e)
                        return "";
                    if (Array.isArray(e) || e.jquery && !k.isPlainObject(e))
                        k.each(e, (function() {
                            n(this.name, this.value)
                        }
                        ));
                    else
                        for (i in e)
                            Ot(i, e[i], t, n);
                    return o.join("&")
                }
                ,
                k.fn.extend({
                    serialize: function() {
                        return k.param(this.serializeArray())
                    },
                    serializeArray: function() {
                        return this.map((function() {
                            var e = k.prop(this, "elements");
                            return e ? k.makeArray(e) : this
                        }
                        )).filter((function() {
                            var e = this.type;
                            return this.name && !k(this).is(":disabled") && Ft.test(this.nodeName) && !zt.test(e) && (this.checked || !ke.test(e))
                        }
                        )).map((function(e, t) {
                            var i = k(this).val();
                            return null == i ? null : Array.isArray(i) ? k.map(i, (function(e) {
                                return {
                                    name: t.name,
                                    value: e.replace(Dt, "\r\n")
                                }
                            }
                            )) : {
                                name: t.name,
                                value: i.replace(Dt, "\r\n")
                            }
                        }
                        )).get()
                    }
                });
                var Bt = /%20/g
                  , Nt = /#.*$/
                  , Wt = /([?&])_=[^&]*/
                  , Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm
                  , jt = /^(?:GET|HEAD)$/
                  , Ut = /^\/\//
                  , Vt = {}
                  , qt = {}
                  , Gt = "*/".concat("*")
                  , Kt = b.createElement("a");
                function Xt(e) {
                    return function(t, i) {
                        "string" != typeof t && (i = t,
                        t = "*");
                        var o, n = 0, r = t.toLowerCase().match(G) || [];
                        if (y(i))
                            for (; o = r[n++]; )
                                "+" === o[0] ? (o = o.slice(1) || "*",
                                (e[o] = e[o] || []).unshift(i)) : (e[o] = e[o] || []).push(i)
                    }
                }
                function Zt(e, t, i, o) {
                    var n = {}
                      , r = e === qt;
                    function a(s) {
                        var l;
                        return n[s] = !0,
                        k.each(e[s] || [], (function(e, s) {
                            var c = s(t, i, o);
                            return "string" != typeof c || r || n[c] ? r ? !(l = c) : void 0 : (t.dataTypes.unshift(c),
                            a(c),
                            !1)
                        }
                        )),
                        l
                    }
                    return a(t.dataTypes[0]) || !n["*"] && a("*")
                }
                function Yt(e, t) {
                    var i, o, n = k.ajaxSettings.flatOptions || {};
                    for (i in t)
                        void 0 !== t[i] && ((n[i] ? e : o || (o = {}))[i] = t[i]);
                    return o && k.extend(!0, e, o),
                    e
                }
                Kt.href = Pt.href,
                k.extend({
                    active: 0,
                    lastModified: {},
                    etag: {},
                    ajaxSettings: {
                        url: Pt.href,
                        type: "GET",
                        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Pt.protocol),
                        global: !0,
                        processData: !0,
                        async: !0,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        accepts: {
                            "*": Gt,
                            text: "text/plain",
                            html: "text/html",
                            xml: "application/xml, text/xml",
                            json: "application/json, text/javascript"
                        },
                        contents: {
                            xml: /\bxml\b/,
                            html: /\bhtml/,
                            json: /\bjson\b/
                        },
                        responseFields: {
                            xml: "responseXML",
                            text: "responseText",
                            json: "responseJSON"
                        },
                        converters: {
                            "* text": String,
                            "text html": !0,
                            "text json": JSON.parse,
                            "text xml": k.parseXML
                        },
                        flatOptions: {
                            url: !0,
                            context: !0
                        }
                    },
                    ajaxSetup: function(e, t) {
                        return t ? Yt(Yt(e, k.ajaxSettings), t) : Yt(k.ajaxSettings, e)
                    },
                    ajaxPrefilter: Xt(Vt),
                    ajaxTransport: Xt(qt),
                    ajax: function(e, t) {
                        "object" == typeof e && (t = e,
                        e = void 0),
                        t = t || {};
                        var i, n, r, a, s, l, c, u, d, p, h = k.ajaxSetup({}, t), m = h.context || h, f = h.context && (m.nodeType || m.jquery) ? k(m) : k.event, g = k.Deferred(), y = k.Callbacks("once memory"), $ = h.statusCode || {}, v = {}, x = {}, w = "canceled", S = {
                            readyState: 0,
                            getResponseHeader: function(e) {
                                var t;
                                if (c) {
                                    if (!a)
                                        for (a = {}; t = Ht.exec(r); )
                                            a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                    t = a[e.toLowerCase() + " "]
                                }
                                return null == t ? null : t.join(", ")
                            },
                            getAllResponseHeaders: function() {
                                return c ? r : null
                            },
                            setRequestHeader: function(e, t) {
                                return null == c && (e = x[e.toLowerCase()] = x[e.toLowerCase()] || e,
                                v[e] = t),
                                this
                            },
                            overrideMimeType: function(e) {
                                return null == c && (h.mimeType = e),
                                this
                            },
                            statusCode: function(e) {
                                var t;
                                if (e)
                                    if (c)
                                        S.always(e[S.status]);
                                    else
                                        for (t in e)
                                            $[t] = [$[t], e[t]];
                                return this
                            },
                            abort: function(e) {
                                var t = e || w;
                                return i && i.abort(t),
                                _(0, t),
                                this
                            }
                        };
                        if (g.promise(S),
                        h.url = ((e || h.url || Pt.href) + "").replace(Ut, Pt.protocol + "//"),
                        h.type = t.method || t.type || h.method || h.type,
                        h.dataTypes = (h.dataType || "*").toLowerCase().match(G) || [""],
                        null == h.crossDomain) {
                            l = b.createElement("a");
                            try {
                                l.href = h.url,
                                l.href = l.href,
                                h.crossDomain = Kt.protocol + "//" + Kt.host != l.protocol + "//" + l.host
                            } catch (e) {
                                h.crossDomain = !0
                            }
                        }
                        if (h.data && h.processData && "string" != typeof h.data && (h.data = k.param(h.data, h.traditional)),
                        Zt(Vt, h, t, S),
                        c)
                            return S;
                        for (d in (u = k.event && h.global) && 0 == k.active++ && k.event.trigger("ajaxStart"),
                        h.type = h.type.toUpperCase(),
                        h.hasContent = !jt.test(h.type),
                        n = h.url.replace(Nt, ""),
                        h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Bt, "+")) : (p = h.url.slice(n.length),
                        h.data && (h.processData || "string" == typeof h.data) && (n += (Rt.test(n) ? "&" : "?") + h.data,
                        delete h.data),
                        !1 === h.cache && (n = n.replace(Wt, "$1"),
                        p = (Rt.test(n) ? "&" : "?") + "_=" + Et.guid++ + p),
                        h.url = n + p),
                        h.ifModified && (k.lastModified[n] && S.setRequestHeader("If-Modified-Since", k.lastModified[n]),
                        k.etag[n] && S.setRequestHeader("If-None-Match", k.etag[n])),
                        (h.data && h.hasContent && !1 !== h.contentType || t.contentType) && S.setRequestHeader("Content-Type", h.contentType),
                        S.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Gt + "; q=0.01" : "") : h.accepts["*"]),
                        h.headers)
                            S.setRequestHeader(d, h.headers[d]);
                        if (h.beforeSend && (!1 === h.beforeSend.call(m, S, h) || c))
                            return S.abort();
                        if (w = "abort",
                        y.add(h.complete),
                        S.done(h.success),
                        S.fail(h.error),
                        i = Zt(qt, h, t, S)) {
                            if (S.readyState = 1,
                            u && f.trigger("ajaxSend", [S, h]),
                            c)
                                return S;
                            h.async && h.timeout > 0 && (s = o.setTimeout((function() {
                                S.abort("timeout")
                            }
                            ), h.timeout));
                            try {
                                c = !1,
                                i.send(v, _)
                            } catch (e) {
                                if (c)
                                    throw e;
                                _(-1, e)
                            }
                        } else
                            _(-1, "No Transport");
                        function _(e, t, a, l) {
                            var d, p, b, v, x, w = t;
                            c || (c = !0,
                            s && o.clearTimeout(s),
                            i = void 0,
                            r = l || "",
                            S.readyState = e > 0 ? 4 : 0,
                            d = e >= 200 && e < 300 || 304 === e,
                            a && (v = function(e, t, i) {
                                for (var o, n, r, a, s = e.contents, l = e.dataTypes; "*" === l[0]; )
                                    l.shift(),
                                    void 0 === o && (o = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (o)
                                    for (n in s)
                                        if (s[n] && s[n].test(o)) {
                                            l.unshift(n);
                                            break
                                        }
                                if (l[0]in i)
                                    r = l[0];
                                else {
                                    for (n in i) {
                                        if (!l[0] || e.converters[n + " " + l[0]]) {
                                            r = n;
                                            break
                                        }
                                        a || (a = n)
                                    }
                                    r = r || a
                                }
                                if (r)
                                    return r !== l[0] && l.unshift(r),
                                    i[r]
                            }(h, S, a)),
                            !d && k.inArray("script", h.dataTypes) > -1 && k.inArray("json", h.dataTypes) < 0 && (h.converters["text script"] = function() {}
                            ),
                            v = function(e, t, i, o) {
                                var n, r, a, s, l, c = {}, u = e.dataTypes.slice();
                                if (u[1])
                                    for (a in e.converters)
                                        c[a.toLowerCase()] = e.converters[a];
                                for (r = u.shift(); r; )
                                    if (e.responseFields[r] && (i[e.responseFields[r]] = t),
                                    !l && o && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                                    l = r,
                                    r = u.shift())
                                        if ("*" === r)
                                            r = l;
                                        else if ("*" !== l && l !== r) {
                                            if (!(a = c[l + " " + r] || c["* " + r]))
                                                for (n in c)
                                                    if ((s = n.split(" "))[1] === r && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                                                        !0 === a ? a = c[n] : !0 !== c[n] && (r = s[0],
                                                        u.unshift(s[1]));
                                                        break
                                                    }
                                            if (!0 !== a)
                                                if (a && e.throws)
                                                    t = a(t);
                                                else
                                                    try {
                                                        t = a(t)
                                                    } catch (e) {
                                                        return {
                                                            state: "parsererror",
                                                            error: a ? e : "No conversion from " + l + " to " + r
                                                        }
                                                    }
                                        }
                                return {
                                    state: "success",
                                    data: t
                                }
                            }(h, v, S, d),
                            d ? (h.ifModified && ((x = S.getResponseHeader("Last-Modified")) && (k.lastModified[n] = x),
                            (x = S.getResponseHeader("etag")) && (k.etag[n] = x)),
                            204 === e || "HEAD" === h.type ? w = "nocontent" : 304 === e ? w = "notmodified" : (w = v.state,
                            p = v.data,
                            d = !(b = v.error))) : (b = w,
                            !e && w || (w = "error",
                            e < 0 && (e = 0))),
                            S.status = e,
                            S.statusText = (t || w) + "",
                            d ? g.resolveWith(m, [p, w, S]) : g.rejectWith(m, [S, w, b]),
                            S.statusCode($),
                            $ = void 0,
                            u && f.trigger(d ? "ajaxSuccess" : "ajaxError", [S, h, d ? p : b]),
                            y.fireWith(m, [S, w]),
                            u && (f.trigger("ajaxComplete", [S, h]),
                            --k.active || k.event.trigger("ajaxStop")))
                        }
                        return S
                    },
                    getJSON: function(e, t, i) {
                        return k.get(e, t, i, "json")
                    },
                    getScript: function(e, t) {
                        return k.get(e, void 0, t, "script")
                    }
                }),
                k.each(["get", "post"], (function(e, t) {
                    k[t] = function(e, i, o, n) {
                        return y(i) && (n = n || o,
                        o = i,
                        i = void 0),
                        k.ajax(k.extend({
                            url: e,
                            type: t,
                            dataType: n,
                            data: i,
                            success: o
                        }, k.isPlainObject(e) && e))
                    }
                }
                )),
                k.ajaxPrefilter((function(e) {
                    var t;
                    for (t in e.headers)
                        "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
                }
                )),
                k._evalUrl = function(e, t, i) {
                    return k.ajax({
                        url: e,
                        type: "GET",
                        dataType: "script",
                        cache: !0,
                        async: !1,
                        global: !1,
                        converters: {
                            "text script": function() {}
                        },
                        dataFilter: function(e) {
                            k.globalEval(e, t, i)
                        }
                    })
                }
                ,
                k.fn.extend({
                    wrapAll: function(e) {
                        var t;
                        return this[0] && (y(e) && (e = e.call(this[0])),
                        t = k(e, this[0].ownerDocument).eq(0).clone(!0),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t.map((function() {
                            for (var e = this; e.firstElementChild; )
                                e = e.firstElementChild;
                            return e
                        }
                        )).append(this)),
                        this
                    },
                    wrapInner: function(e) {
                        return y(e) ? this.each((function(t) {
                            k(this).wrapInner(e.call(this, t))
                        }
                        )) : this.each((function() {
                            var t = k(this)
                              , i = t.contents();
                            i.length ? i.wrapAll(e) : t.append(e)
                        }
                        ))
                    },
                    wrap: function(e) {
                        var t = y(e);
                        return this.each((function(i) {
                            k(this).wrapAll(t ? e.call(this, i) : e)
                        }
                        ))
                    },
                    unwrap: function(e) {
                        return this.parent(e).not("body").each((function() {
                            k(this).replaceWith(this.childNodes)
                        }
                        )),
                        this
                    }
                }),
                k.expr.pseudos.hidden = function(e) {
                    return !k.expr.pseudos.visible(e)
                }
                ,
                k.expr.pseudos.visible = function(e) {
                    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
                }
                ,
                k.ajaxSettings.xhr = function() {
                    try {
                        return new o.XMLHttpRequest
                    } catch (e) {}
                }
                ;
                var Qt = {
                    0: 200,
                    1223: 204
                }
                  , Jt = k.ajaxSettings.xhr();
                g.cors = !!Jt && "withCredentials"in Jt,
                g.ajax = Jt = !!Jt,
                k.ajaxTransport((function(e) {
                    var t, i;
                    if (g.cors || Jt && !e.crossDomain)
                        return {
                            send: function(n, r) {
                                var a, s = e.xhr();
                                if (s.open(e.type, e.url, e.async, e.username, e.password),
                                e.xhrFields)
                                    for (a in e.xhrFields)
                                        s[a] = e.xhrFields[a];
                                for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType),
                                e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest"),
                                n)
                                    s.setRequestHeader(a, n[a]);
                                t = function(e) {
                                    return function() {
                                        t && (t = i = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null,
                                        "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? r(0, "error") : r(s.status, s.statusText) : r(Qt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                                            binary: s.response
                                        } : {
                                            text: s.responseText
                                        }, s.getAllResponseHeaders()))
                                    }
                                }
                                ,
                                s.onload = t(),
                                i = s.onerror = s.ontimeout = t("error"),
                                void 0 !== s.onabort ? s.onabort = i : s.onreadystatechange = function() {
                                    4 === s.readyState && o.setTimeout((function() {
                                        t && i()
                                    }
                                    ))
                                }
                                ,
                                t = t("abort");
                                try {
                                    s.send(e.hasContent && e.data || null)
                                } catch (e) {
                                    if (t)
                                        throw e
                                }
                            },
                            abort: function() {
                                t && t()
                            }
                        }
                }
                )),
                k.ajaxPrefilter((function(e) {
                    e.crossDomain && (e.contents.script = !1)
                }
                )),
                k.ajaxSetup({
                    accepts: {
                        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                    },
                    contents: {
                        script: /\b(?:java|ecma)script\b/
                    },
                    converters: {
                        "text script": function(e) {
                            return k.globalEval(e),
                            e
                        }
                    }
                }),
                k.ajaxPrefilter("script", (function(e) {
                    void 0 === e.cache && (e.cache = !1),
                    e.crossDomain && (e.type = "GET")
                }
                )),
                k.ajaxTransport("script", (function(e) {
                    var t, i;
                    if (e.crossDomain || e.scriptAttrs)
                        return {
                            send: function(o, n) {
                                t = k("<script>").attr(e.scriptAttrs || {}).prop({
                                    charset: e.scriptCharset,
                                    src: e.url
                                }).on("load error", i = function(e) {
                                    t.remove(),
                                    i = null,
                                    e && n("error" === e.type ? 404 : 200, e.type)
                                }
                                ),
                                b.head.appendChild(t[0])
                            },
                            abort: function() {
                                i && i()
                            }
                        }
                }
                ));
                var ei, ti = [], ii = /(=)\?(?=&|$)|\?\?/;
                k.ajaxSetup({
                    jsonp: "callback",
                    jsonpCallback: function() {
                        var e = ti.pop() || k.expando + "_" + Et.guid++;
                        return this[e] = !0,
                        e
                    }
                }),
                k.ajaxPrefilter("json jsonp", (function(e, t, i) {
                    var n, r, a, s = !1 !== e.jsonp && (ii.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && ii.test(e.data) && "data");
                    if (s || "jsonp" === e.dataTypes[0])
                        return n = e.jsonpCallback = y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
                        s ? e[s] = e[s].replace(ii, "$1" + n) : !1 !== e.jsonp && (e.url += (Rt.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
                        e.converters["script json"] = function() {
                            return a || k.error(n + " was not called"),
                            a[0]
                        }
                        ,
                        e.dataTypes[0] = "json",
                        r = o[n],
                        o[n] = function() {
                            a = arguments
                        }
                        ,
                        i.always((function() {
                            void 0 === r ? k(o).removeProp(n) : o[n] = r,
                            e[n] && (e.jsonpCallback = t.jsonpCallback,
                            ti.push(n)),
                            a && y(r) && r(a[0]),
                            a = r = void 0
                        }
                        )),
                        "script"
                }
                )),
                g.createHTMLDocument = ((ei = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
                2 === ei.childNodes.length),
                k.parseHTML = function(e, t, i) {
                    return "string" != typeof e ? [] : ("boolean" == typeof t && (i = t,
                    t = !1),
                    t || (g.createHTMLDocument ? ((o = (t = b.implementation.createHTMLDocument("")).createElement("base")).href = b.location.href,
                    t.head.appendChild(o)) : t = b),
                    r = !i && [],
                    (n = N.exec(e)) ? [t.createElement(n[1])] : (n = Ae([e], t, r),
                    r && r.length && k(r).remove(),
                    k.merge([], n.childNodes)));
                    var o, n, r
                }
                ,
                k.fn.load = function(e, t, i) {
                    var o, n, r, a = this, s = e.indexOf(" ");
                    return s > -1 && (o = kt(e.slice(s)),
                    e = e.slice(0, s)),
                    y(t) ? (i = t,
                    t = void 0) : t && "object" == typeof t && (n = "POST"),
                    a.length > 0 && k.ajax({
                        url: e,
                        type: n || "GET",
                        dataType: "html",
                        data: t
                    }).done((function(e) {
                        r = arguments,
                        a.html(o ? k("<div>").append(k.parseHTML(e)).find(o) : e)
                    }
                    )).always(i && function(e, t) {
                        a.each((function() {
                            i.apply(this, r || [e.responseText, t, e])
                        }
                        ))
                    }
                    ),
                    this
                }
                ,
                k.expr.pseudos.animated = function(e) {
                    return k.grep(k.timers, (function(t) {
                        return e === t.elem
                    }
                    )).length
                }
                ,
                k.offset = {
                    setOffset: function(e, t, i) {
                        var o, n, r, a, s, l, c = k.css(e, "position"), u = k(e), d = {};
                        "static" === c && (e.style.position = "relative"),
                        s = u.offset(),
                        r = k.css(e, "top"),
                        l = k.css(e, "left"),
                        ("absolute" === c || "fixed" === c) && (r + l).indexOf("auto") > -1 ? (a = (o = u.position()).top,
                        n = o.left) : (a = parseFloat(r) || 0,
                        n = parseFloat(l) || 0),
                        y(t) && (t = t.call(e, i, k.extend({}, s))),
                        null != t.top && (d.top = t.top - s.top + a),
                        null != t.left && (d.left = t.left - s.left + n),
                        "using"in t ? t.using.call(e, d) : u.css(d)
                    }
                },
                k.fn.extend({
                    offset: function(e) {
                        if (arguments.length)
                            return void 0 === e ? this : this.each((function(t) {
                                k.offset.setOffset(this, e, t)
                            }
                            ));
                        var t, i, o = this[0];
                        return o ? o.getClientRects().length ? (t = o.getBoundingClientRect(),
                        i = o.ownerDocument.defaultView,
                        {
                            top: t.top + i.pageYOffset,
                            left: t.left + i.pageXOffset
                        }) : {
                            top: 0,
                            left: 0
                        } : void 0
                    },
                    position: function() {
                        if (this[0]) {
                            var e, t, i, o = this[0], n = {
                                top: 0,
                                left: 0
                            };
                            if ("fixed" === k.css(o, "position"))
                                t = o.getBoundingClientRect();
                            else {
                                for (t = this.offset(),
                                i = o.ownerDocument,
                                e = o.offsetParent || i.documentElement; e && (e === i.body || e === i.documentElement) && "static" === k.css(e, "position"); )
                                    e = e.parentNode;
                                e && e !== o && 1 === e.nodeType && ((n = k(e).offset()).top += k.css(e, "borderTopWidth", !0),
                                n.left += k.css(e, "borderLeftWidth", !0))
                            }
                            return {
                                top: t.top - n.top - k.css(o, "marginTop", !0),
                                left: t.left - n.left - k.css(o, "marginLeft", !0)
                            }
                        }
                    },
                    offsetParent: function() {
                        return this.map((function() {
                            for (var e = this.offsetParent; e && "static" === k.css(e, "position"); )
                                e = e.offsetParent;
                            return e || fe
                        }
                        ))
                    }
                }),
                k.each({
                    scrollLeft: "pageXOffset",
                    scrollTop: "pageYOffset"
                }, (function(e, t) {
                    var i = "pageYOffset" === t;
                    k.fn[e] = function(o) {
                        return ee(this, (function(e, o, n) {
                            var r;
                            if ($(e) ? r = e : 9 === e.nodeType && (r = e.defaultView),
                            void 0 === n)
                                return r ? r[t] : e[o];
                            r ? r.scrollTo(i ? r.pageXOffset : n, i ? n : r.pageYOffset) : e[o] = n
                        }
                        ), e, o, arguments.length)
                    }
                }
                )),
                k.each(["top", "left"], (function(e, t) {
                    k.cssHooks[t] = et(g.pixelPosition, (function(e, i) {
                        if (i)
                            return i = Je(e, t),
                            Ke.test(i) ? k(e).position()[t] + "px" : i
                    }
                    ))
                }
                )),
                k.each({
                    Height: "height",
                    Width: "width"
                }, (function(e, t) {
                    k.each({
                        padding: "inner" + e,
                        content: t,
                        "": "outer" + e
                    }, (function(i, o) {
                        k.fn[o] = function(n, r) {
                            var a = arguments.length && (i || "boolean" != typeof n)
                              , s = i || (!0 === n || !0 === r ? "margin" : "border");
                            return ee(this, (function(t, i, n) {
                                var r;
                                return $(t) ? 0 === o.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (r = t.documentElement,
                                Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === n ? k.css(t, i, s) : k.style(t, i, n, s)
                            }
                            ), t, a ? n : void 0, a)
                        }
                    }
                    ))
                }
                )),
                k.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], (function(e, t) {
                    k.fn[t] = function(e) {
                        return this.on(t, e)
                    }
                }
                )),
                k.fn.extend({
                    bind: function(e, t, i) {
                        return this.on(e, null, t, i)
                    },
                    unbind: function(e, t) {
                        return this.off(e, null, t)
                    },
                    delegate: function(e, t, i, o) {
                        return this.on(t, e, i, o)
                    },
                    undelegate: function(e, t, i) {
                        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i)
                    },
                    hover: function(e, t) {
                        return this.on("mouseenter", e).on("mouseleave", t || e)
                    }
                }),
                k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), (function(e, t) {
                    k.fn[t] = function(e, i) {
                        return arguments.length > 0 ? this.on(t, null, e, i) : this.trigger(t)
                    }
                }
                ));
                var oi = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
                k.proxy = function(e, t) {
                    var i, o, n;
                    if ("string" == typeof t && (i = e[t],
                    t = e,
                    e = i),
                    y(e))
                        return o = s.call(arguments, 2),
                        n = function() {
                            return e.apply(t || this, o.concat(s.call(arguments)))
                        }
                        ,
                        n.guid = e.guid = e.guid || k.guid++,
                        n
                }
                ,
                k.holdReady = function(e) {
                    e ? k.readyWait++ : k.ready(!0)
                }
                ,
                k.isArray = Array.isArray,
                k.parseJSON = JSON.parse,
                k.nodeName = T,
                k.isFunction = y,
                k.isWindow = $,
                k.camelCase = ne,
                k.type = w,
                k.now = Date.now,
                k.isNumeric = function(e) {
                    var t = k.type(e);
                    return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
                }
                ,
                k.trim = function(e) {
                    return null == e ? "" : (e + "").replace(oi, "$1")
                }
                ,
                void 0 === (i = function() {
                    return k
                }
                .apply(t, [])) || (e.exports = i);
                var ni = o.jQuery
                  , ri = o.$;
                return k.noConflict = function(e) {
                    return o.$ === k && (o.$ = ri),
                    e && o.jQuery === k && (o.jQuery = ni),
                    k
                }
                ,
                void 0 === n && (o.jQuery = o.$ = k),
                k
            }
            ))
        },
        837: (e, t, i) => {
            "use strict";
            i.r(t)
        }
        ,
        89: (e, t, i) => {
            "use strict";
            i.r(t)
        }
        ,
        912: (e, t, i) => {
            "use strict";
            i.r(t)
        }
        ,
        697: (e, t, i) => {
            "use strict";
            i.r(t)
        }
    }
      , __webpack_module_cache__ = {};
    function __webpack_require__(e) {
        var t = __webpack_module_cache__[e];
        if (void 0 !== t)
            return t.exports;
        var i = __webpack_module_cache__[e] = {
            exports: {}
        };
        return __webpack_modules__[e].call(i.exports, i, i.exports, __webpack_require__),
        i.exports
    }
    __webpack_require__.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return __webpack_require__.d(t, {
            a: t
        }),
        t
    }
    ,
    __webpack_require__.d = (e, t) => {
        for (var i in t)
            __webpack_require__.o(t, i) && !__webpack_require__.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: t[i]
            })
    }
    ,
    __webpack_require__.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t),
    __webpack_require__.r = e => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }),
        Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }
    ;
    var __webpack_exports__ = {};
    ( () => {
        "use strict";
        var e = __webpack_require__(981)
          , t = __webpack_require__(106)
          , i = __webpack_require__(392)
          , o = __webpack_require__(755)
          , n = __webpack_require__(755);
        var r = [];
        function a() {
            o('input[class*="qty"]').on("change", (function() {
                setTimeout(( () => {
                    console.log("quantity changed"),
                    a()
                }
                ), 1e3)
            }
            ));
            for (var t = 0, n = document.querySelectorAll("li,p,span,label").length; t < n; t++)
                ;
            fetch("/cart.js?cache=false&q=" + Math.random()).then((e => e.json())).then((async function(t) {
                r = t;
                let n = t.items
                  , a = t.total_price
                  , s = (0,
                i.qp)();
                if (s) {
                    let e = t.currency;
                    const o = (0,
                    i.fT)(parseFloat(a), e, null);
                    a = o
                }
                t.original_total_price;
                let u = [];
                for (let e = 0; e < n.length; e++)
                    u.push({
                        index: e,
                        item: n[e]
                    });
                var d = u.map((e => e.item)).filter((e => 0 === e.price));
                d = d.length > 0 ? d : u.length > 0 ? [u[0].item] : [];
                var p = await async function(t) {
                    let i = null
                      , o = new Request(e.baseCalculatorNewApiUrl + "variant:fetchvariants",{
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            shop: e.cpc_shopUrl,
                            variants: t
                        })
                    });
                    return await fetch(o).then((e => e.json())).then((async e => {
                        i = e
                    }
                    )),
                    i
                }(d);
                if (null !== e.cpc_fasterCheckoutConfig.fasterCheckoutConfig && !0 === e.cpc_fasterCheckoutConfig.fasterCheckoutConfig.enabled)
                    console.log("Faster checkout behavior: New"),
                    c(u, p);
                else if (p && p.length > 0) {
                    for (let e = 0; e < p.length; e++) {
                        let n = p[e]
                          , r = 0;
                        if (o.each(u, (function(e, o) {
                            if (o.item.variant_id == n.shopifyVariantId) {
                                let e = n.amount;
                                if (r = o.item.quantity,
                                0 === o.item.price) {
                                    if (s) {
                                        let o = t.currency;
                                        e = (0,
                                        i.fT)(parseFloat(e), o, null)
                                    }
                                    a += e * r * 100
                                }
                            }
                        }
                        )),
                        s) {
                            let e = t.currency;
                            t.currency = (0,
                            i.w9)(null);
                            const o = (0,
                            i.fT)(parseFloat(n.amount), e, t.currency);
                            n.amount = o
                        }
                        o("cpc.product_title[data-id='" + n.shopifyVariantId + "']").html(n.shopifyProductTitle),
                        l("cpc.original_price[data-id='" + n.shopifyVariantId + "']", t.currency, n.amount, !1, s),
                        l("cpc.price[data-id='" + n.shopifyVariantId + "']", t.currency, n.amount, !1, s),
                        l("cpc.discounted_price[data-id='" + n.shopifyVariantId + "']", t.currency, n.amount, !1, s),
                        l("cpc.final_line_price[data-id='" + n.shopifyVariantId + "']", t.currency, n.amount * r, !1, s),
                        l("cpc.line_price[data-id='" + n.shopifyVariantId + "']", t.currency, n.amount * r, !1, s),
                        l("cpc.original_line_price[data-id='" + n.shopifyVariantId + "']", t.currency, n.amount * r, !1, s);
                        var h = o("img[data-cpcimageid='" + n.shopifyVariantId + "']");
                        void 0 !== h && null !== n.productImageUrl && h.length > 0 && (h[0].setAttribute("src", n.productImageUrl),
                        h[0].setAttribute("data-src", n.productImageUrl))
                    }
                    l("cpc.final_price", t.currency, a / 100, !0, s),
                    l("cpc.cart_total_price", t.currency, a / 100, !0, s)
                }
            }
            ))
        }
        function s(i, o, n) {
            let r = Number(o).toFixed(2)
              , a = function(t) {
                let i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                var o = t.toUpperCase();
                let n = i && !0 === e.cpc_fasterCheckoutConfig.checkoutConfig?.includeCurrencySuffix;
                switch (o) {
                case "USD":
                case "SGD":
                case "SGD":
                    return {
                        before: "$",
                        after: n ? o : ""
                    };
                case "CAD":
                    return {
                        before: "$",
                        after: n ? o : "CAD"
                    };
                case "DKK":
                    return {
                        before: "",
                        after: n ? o : "KR"
                    };
                case "GBP":
                    return {
                        before: "&pound;",
                        after: n ? o : ""
                    };
                case "AUD":
                    return {
                        before: "$",
                        after: n ? o : "AUD"
                    };
                case "BRL":
                    return {
                        before: "R$",
                        after: n ? o : ""
                    };
                case "ZAR":
                    return {
                        before: "R",
                        after: n ? o : ""
                    };
                case "EUR":
                    return {
                        before: "&euro;",
                        after: n ? o : ""
                    };
                case "MAD":
                    return {
                        before: "",
                        after: "dh"
                    };
                case "OMR":
                    return {
                        before: "",
                        after: o
                    };
                case "TRY":
                    return {
                        before: "",
                        after: n ? o : "&#8378;"
                    };
                case "CLP":
                case "MXN":
                    return {
                        before: "$",
                        after: ""
                    };
                case "IDR":
                    return {
                        before: "RP",
                        after: ""
                    };
                case "TRY":
                    return {
                        before: "",
                        after: "TL"
                    };
                case "MYR":
                    return {
                        before: "RM ",
                        after: ""
                    };
                default:
                    return {
                        before: "",
                        after: t.toUpperCase()
                    }
                }
            }(i, n);
            return a.before + (0,
            t.tQ)(Number(r), +e.cpc_configData.thousandSeperator, +e.cpc_configData.decimalSeperator, !0) + " " + a.after
        }
        function l(e, t, i, n, r) {
            var a = s(t, i, n);
            r && (a = '<span class="money">' + a + "</span>"),
            o(e).html(a)
        }
        async function c(t, o) {
            let a = (0,
            i.qp)();
            if (null === e.cpc_fasterCheckoutConfig)
                return void console.log("faster checkout configuration not found for the store");
            console.log("cartData", r),
            console.log("allVariantsFromCart", t);
            var s = document.querySelectorAll(e.cpc_fasterCheckoutConfig.fasterCheckoutConfig.itemPriceSelector)
              , l = document.querySelectorAll(e.cpc_fasterCheckoutConfig.fasterCheckoutConfig.totalPriceSelector)
              , c = document.querySelectorAll(e.cpc_fasterCheckoutConfig.fasterCheckoutConfig.titleSelector)
              , h = null === e.cpc_fasterCheckoutConfig.fasterCheckoutConfig.productImageSelector ? [] : document.querySelectorAll(e.cpc_fasterCheckoutConfig.fasterCheckoutConfig.productImageSelector);
            console.log("totalPriceElement", l);
            let m = r.total_price / 100;
            if (a) {
                let e = cartData.currency
                  , t = (0,
                i.fT)(parseFloat(m), e, null);
                m = t
            }
            s.length === r.items.length ? s.forEach(( (e, r) => {
                var s = t.find((function(e) {
                    return e.index === r
                }
                ));
                if (void 0 !== s) {
                    var f = s.item.variant_id
                      , g = o.find((e => e.shopifyVariantId == f));
                    if (void 0 !== g) {
                        if (a) {
                            let e = cartData.currency
                              , t = (0,
                            i.fT)(parseFloat(g.amount), e, null);
                            g.amount = t
                        }
                        var y = g.amount * s.item.quantity;
                        m += y,
                        u(e) ? d(e.children[0], y) : d(e, y);
                        var $ = c.length > r ? c[r] : null;
                        null != $ && (u($) ? p($.children[0], g.shopifyProductTitle) : p($, g.shopifyProductTitle));
                        var b = h.length > r ? h[r] : null;
                        if (null != b)
                            if (n(b).html().includes("<img"))
                                b.setAttribute("src", g.productImageUrl);
                            else {
                                var v = document.createElement("img");
                                v.src = g.productImageUrl,
                                v.width = 150,
                                b.appendChild(v)
                            }
                        l.length >= 1 && (u(e = l[0]) ? d(e.children[0], m) : d(e, m))
                    }
                } else
                    console.log(`Skipping index ${r + 1}`)
            }
            )) : console.log(`Skipping faster checkout as the selector doesn't match. Selector count: ${s.length}, Cart Item Count = ${r.items.length}`)
        }
        function u(e) {
            return e.children.length > 0
        }
        function d(e, t) {
            var i = s(r.currency, t);
            e.textContent = i
        }
        function p(e, t) {
            "" === e.textContent.trim() && (e.textContent = t)
        }
        var h = __webpack_require__(286);
        const m = [{
            value: 65504,
            name: "jfif"
        }, {
            value: 65498,
            name: "sos"
        }, {
            value: 65505,
            subvalue: 17784,
            name: "exif"
        }, {
            value: 65505,
            subvalue: 26740,
            name: "xmp"
        }, {
            value: 65506,
            subvalue: 19792,
            name: "mpf"
        }, {
            value: 65506,
            name: "app2"
        }];
        var f = (e, t, i) => {
            if (!e)
                return;
            const o = new DataView(e)
              , n = (e => {
                if (65496 !== e.getUint16(0))
                    return;
                const t = e.byteLength;
                let i, o, n = 2;
                for (; n < t && 255 === e.getUint8(n); ) {
                    i = e.getUint16(n);
                    const t = m.find((t => t.value === i && (!t.subvalue || t.subvalue === e.getUint16(n + 2 + 2))));
                    if (t) {
                        const {name: i} = t;
                        o || (o = {}),
                        o[i] || (o[i] = {
                            offset: n,
                            size: e.getUint16(n + 2)
                        })
                    }
                    if (65498 === i)
                        break;
                    n += 2 + e.getUint16(n + 2)
                }
                return o
            }
            )(o);
            if (!n || !n.exif)
                return;
            const r = ( (e, t) => {
                if (65505 !== e.getUint16(t))
                    return;
                const i = e.getUint16(t + 2);
                if (t += 4,
                1165519206 !== e.getUint32(t))
                    return;
                t += 6;
                const o = e.getUint16(t);
                if (18761 !== o && 19789 !== o)
                    return;
                const n = 18761 === o;
                if (t += 2,
                42 !== e.getUint16(t, n))
                    return;
                t += e.getUint32(t + 2, n);
                const r = o => {
                    const r = [];
                    let a = t;
                    const s = Math.min(e.byteLength, t + i - 16);
                    for (; a < s; a += 12) {
                        const t = a;
                        e.getUint16(t, n) === o && r.push(t)
                    }
                    return r
                }
                ;
                return {
                    read: t => {
                        const i = r(t);
                        if (i.length)
                            return e.getUint16(i[0] + 8, n)
                    }
                    ,
                    write: (t, i) => {
                        const o = r(t);
                        return !!o.length && (o.forEach((t => e.setUint16(t + 8, i, n))),
                        !0)
                    }
                }
            }
            )(o, n.exif.offset);
            return r ? void 0 === i ? r.read(t) : r.write(t, i) : void 0
        }
        ;
        const g = "__pqina_webapi__";
        var y = e => window[g] ? window[g][e] : window[e]
          , $ = (...e) => {}
        ;
        const b = {
            ArrayBuffer: "readAsArrayBuffer"
        };
        var v = (e, t=$, i={}) => new Promise(( (o, n) => {
            const {dataFormat: r=b.ArrayBuffer} = i
              , a = new (y("FileReader"));
            a.onload = () => o(a.result),
            a.onerror = () => n(a.error),
            a.onprogress = t,
            a[r](e)
        }
        ))
          , x = async (e, t=[0, e.size], i) => await v(e.slice(...t), i)
          , w = async (e, t) => {
            const i = await x(e, [0, 262144], t);
            return f(i, 274) || 1
        }
        ;
        let S = null;
        var _ = () => (null === S && (S = "undefined" != typeof window && void 0 !== window.document),
        S);
        let k = null;
        var C = () => new Promise((e => {
            if (null === k) {
                const t = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4QA6RXhpZgAATU0AKgAAAAgAAwESAAMAAAABAAYAAAEoAAMAAAABAAIAAAITAAMAAAABAAEAAAAAAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////wAALCAABAAIBASIA/8QAJgABAAAAAAAAAAAAAAAAAAAAAxABAAAAAAAAAAAAAAAAAAAAAP/aAAgBAQAAPwBH/9k=";
                let i = _() ? new Image : {};
                return i.onload = () => {
                    k = 1 === i.naturalWidth,
                    i = void 0,
                    e(k)
                }
                ,
                void (i.src = t)
            }
            return e(k)
        }
        ))
          , T = e => e.getContext("2d").getImageData(0, 0, e.width, e.height)
          , M = (e, t, i=[]) => {
            const o = document.createElement(e)
              , n = Object.getOwnPropertyDescriptors(o.__proto__);
            for (const e in t)
                "style" === e ? o.style.cssText = t[e] : n[e] && n[e].set || /textContent|innerHTML/.test(e) || "function" == typeof t[e] ? o[e] = t[e] : o.setAttribute(e, t[e]);
            return i.forEach((e => o.appendChild(e))),
            o
        }
        ;
        const P = {
            1: () => [1, 0, 0, 1, 0, 0],
            2: e => [-1, 0, 0, 1, e, 0],
            3: (e, t) => [-1, 0, 0, -1, e, t],
            4: (e, t) => [1, 0, 0, -1, 0, t],
            5: () => [0, 1, 1, 0, 0, 0],
            6: (e, t) => [0, 1, -1, 0, t, 0],
            7: (e, t) => [0, -1, -1, 0, t, e],
            8: e => [0, -1, 1, 0, 0, e]
        };
        var E = e => {
            e.width = 1,
            e.height = 1;
            const t = e.getContext("2d");
            t && t.clearRect(0, 0, 1, 1)
        }
          , R = e => "data"in e
          , A = e => _() ? RegExp(e).test(window.navigator.userAgent) : void 0;
        let I = null;
        var L = () => (null === I && (I = A(/Android/)),
        I)
          , D = (e, t) => {
            const i = M("canvas", {
                width: e.width,
                height: e.height
            });
            return i.getContext("2d", t).drawImage(e, 0, 0),
            i
        }
          , z = async (e, t=1) => {
            const i = await C()
              , [o,n] = i || t < 5 ? [e.width, e.height] : [e.height, e.width]
              , r = M("canvas", {
                width: o,
                height: n
            })
              , a = r.getContext("2d", {
                willReadFrequently: !0
            });
            if (R(e) && !i && t > 1) {
                const t = M("canvas", {
                    width: e.width,
                    height: e.height
                });
                t.getContext("2d", {
                    willReadFrequently: !0
                }).putImageData(e, 0, 0),
                e = t
            }
            if (!i && t > 1 && a.transform.apply(a, ( (e, t, i=-1) => (-1 === i && (i = 1),
            P[i](e, t)))(e.width, e.height, t)),
            R(e)) {
                if (a.putImageData(e, 0, 0),
                L())
                    return D(r)
            } else
                a.drawImage(e, 0, 0);
            return e instanceof HTMLCanvasElement && E(e),
            r
        }
          , F = async (e, t=1) => 1 === t || await C() ? e : T(await z(e, t))
          , O = e => "object" == typeof e;
        const B = e => e instanceof HTMLElement ? e : O(e) ? N(e) : e
          , N = e => {
            let t;
            return Array.isArray(e) ? (t = [],
            e.forEach(( (e, i) => {
                t[i] = B(e)
            }
            ))) : (t = {},
            null !== e && Object.keys(e).forEach((i => {
                const o = e[i];
                t[i] = B(o)
            }
            ))),
            t
        }
        ;
        var W = e => "string" == typeof e
          , H = e => "function" == typeof e
          , j = () => "createImageBitmap"in window
          , U = e => /svg/.test(e.type)
          , V = () => Math.random().toString(36).substring(2, 9);
        const q = new Map;
        var G = (e, t, i) => new Promise(( (o, n) => {
            const r = e.toString();
            let a = q.get(r);
            if (!a) {
                const t = (e => `function () {self.onmessage = function (message) {(${e.toString()}).apply(null, message.data.content.concat([function (err, response) {\n    response = response || {};\n    const transfer = 'data' in response ? [response.data.buffer] : 'width' in response ? [response] : [];\n    return self.postMessage({ id: message.data.id, content: response, error: err }, transfer);\n}]))}}`)(e)
                  , i = URL.createObjectURL((e => new Blob(["(", "function" == typeof e ? e.toString() : e, ")()"],{
                    type: "application/javascript"
                }))(t))
                  , o = new Map
                  , n = new Worker(i);
                a = {
                    url: i,
                    worker: n,
                    messages: o,
                    terminationTimeout: void 0,
                    terminate: () => {
                        clearTimeout(a.terminationTimeout),
                        a.worker.terminate(),
                        URL.revokeObjectURL(i),
                        q.delete(r)
                    }
                },
                n.onmessage = function(e) {
                    const {id: t, content: i, error: n} = e.data;
                    if (clearTimeout(a.terminationTimeout),
                    a.terminationTimeout = setTimeout(( () => {
                        o.size > 0 || a.terminate()
                    }
                    ), 500),
                    !o.has(t))
                        return;
                    const r = o.get(t);
                    o.delete(t),
                    null != n ? r.reject(n) : r.resolve(i)
                }
                ,
                q.set(r, a)
            }
            const s = V();
            a.messages.set(s, {
                resolve: o,
                reject: n
            }),
            a.worker.postMessage({
                id: s,
                content: t
            }, i)
        }
        ));
        let K = null;
        var X = () => (null === K && (K = A(/Firefox/)),
        K);
        const Z = async (e, t) => {
            const i = await (async (e, t) => {
                const i = M("img", {
                    src: URL.createObjectURL(e)
                })
                  , o = await ( (e, t) => new Promise(( (i, o) => {
                    const n = () => i(( (e, {width: t, height: i, canvasMemoryLimit: o, contextOptions: n}) => {
                        let r = t || e.naturalWidth
                          , a = i || e.naturalHeight;
                        r || a || (r = 300,
                        a = 150);
                        const s = r * a;
                        if (o && s > o) {
                            const e = Math.sqrt(o) / Math.sqrt(s);
                            r = Math.floor(r * e),
                            a = Math.floor(a * e)
                        }
                        const l = M("canvas");
                        return l.width = r,
                        l.height = a,
                        l.getContext("2d", n).drawImage(e, 0, 0, r, a),
                        l
                    }
                    )(e, t));
                    e.complete && e.width ? n() : (e.onload = n,
                    e.onerror = () => o(new Error("Failed to load image")))
                }
                )))(i, t);
                return URL.revokeObjectURL(i.src),
                o
            }
            )(e, {
                canvasMemoryLimit: t,
                contextOptions: {
                    willReadFrequently: !0
                }
            })
              , o = T(i);
            return E(i),
            o
        }
        ;
        var Y = async (e, t) => {
            if (L() && !X())
                return await Z(e, t);
            let i;
            if (j() && !U(e) && "OffscreenCanvas"in window)
                try {
                    i = await G(( (e, t, i) => {
                        createImageBitmap(e).then((e => {
                            let o = e.width
                              , n = e.height;
                            const r = o * n;
                            if (t && r > t) {
                                const e = Math.sqrt(t) / Math.sqrt(r);
                                o = Math.floor(o * e),
                                n = Math.floor(n * e)
                            }
                            const a = new OffscreenCanvas(o,n)
                              , s = a.getContext("2d", {
                                willReadFrequently: !0
                            });
                            s.drawImage(e, 0, 0, o, n);
                            const l = s.getImageData(0, 0, a.width, a.height);
                            i(null, l)
                        }
                        )).catch((e => {
                            i(e)
                        }
                        ))
                    }
                    ), [e, t])
                } catch (e) {}
            return i && i.width ? i : await Z(e, t)
        }
          , Q = (e, t=void 0, i=void 0) => new Promise(( (o, n) => {
            try {
                e.toBlob((e => {
                    if (!e)
                        return n(new Error("Failed to create blob"));
                    o(e)
                }
                ), t, i)
            } catch (e) {
                n(e)
            }
        }
        ))
          , J = async (e, t, i) => {
            const o = await z(e)
              , n = await Q(o, t, i);
            return E(o),
            n
        }
        ;
        const ee = {
            matroska: "mkv"
        };
        var te = e => {
            const t = (e.match(/\/([a-z0-9]+)/) || [])[1];
            if (/^x/.test(t)) {
                const [,t=""] = e.split("/x-");
                return ee[t]
            }
            return t
        }
          , ie = e => e.substring(0, e.lastIndexOf(".")) || e;
        const oe = /avif|bmp|gif|jpg|jpeg|jpe|jif|jfif|png|svg|tiff|webp/;
        var ne = e => {
            return e && (t = (i = e,
            i.split(".").pop()).toLowerCase(),
            oe.test(t) ? "image/" + (/jfif|jif|jpe|jpg/.test(t) ? "jpeg" : "svg" === t ? "svg+xml" : t) : "");
            var t, i
        }
          , re = (e, t, i) => {
            const o = (new Date).getTime()
              , n = e.type.length && !/null|text/.test(e.type)
              , r = n ? e.type : i
              , a = ( (e, t) => {
                const i = ne(e);
                if (i === t)
                    return e;
                const o = te(t) || i;
                return `${ie(e)}.${o}`
            }
            )(t, r);
            try {
                return new (y("File"))([e],a,{
                    lastModified: o,
                    type: n ? e.type : r
                })
            } catch (t) {
                const i = n ? e.slice() : e.slice(0, e.size, r);
                return i.lastModified = o,
                i.name = a,
                i
            }
        }
          , ae = (e, t) => e / t
          , se = e => e;
        const le = Math.PI
          , ce = Math.PI / 2
          , ue = ce / 2;
        var de = e => {
            const t = Math.abs(e) % Math.PI;
            return t > ue && t < Math.PI - ue
        }
        ;
        const pe = {
            Top: "t",
            Right: "r",
            Bottom: "b",
            Left: "l",
            TopLeft: "tl",
            TopRight: "tr",
            BottomRight: "br",
            BottomLeft: "bl"
        }
          , {Top: he, Right: me, Bottom: fe, Left: ge, TopLeft: ye, TopRight: $e, BottomRight: be, BottomLeft: ve} = pe;
        var xe = {
            [he]: [.5, 0],
            [me]: [1, .5],
            [fe]: [.5, 1],
            [ge]: [0, .5],
            [ye]: [0, 0],
            [$e]: [1, 0],
            [be]: [1, 1],
            [ve]: [0, 1]
        }
          , we = (e, t=12) => parseFloat(e.toFixed(t));
        const Se = (e, t, i) => i + (e - i) * t
          , _e = e => ({
            x: e.x + .5 * e.width,
            y: e.y + .5 * e.height,
            rx: .5 * e.width,
            ry: .5 * e.height
        })
          , ke = () => Ce(0, 0)
          , Ce = (e, t) => ({
            x: e,
            y: t
        })
          , Te = e => Ce(e.pageX, e.pageY)
          , Me = e => Ce(e.x, e.y)
          , Pe = e => (e.x = -e.x,
        e.y = -e.y,
        e)
          , Ee = (e, t, i=ke()) => {
            const o = Math.cos(t)
              , n = Math.sin(t)
              , r = e.x - i.x
              , a = e.y - i.y;
            return e.x = i.x + o * r - n * a,
            e.y = i.y + n * r + o * a,
            e
        }
          , Re = e => Math.sqrt(e.x * e.x + e.y * e.y)
          , Ae = e => {
            const t = Math.sqrt(e.x * e.x + e.y * e.y);
            return 0 === t ? ke() : (e.x /= t,
            e.y /= t,
            e)
        }
          , Ie = (e, t) => Math.atan2(t.y - e.y, t.x - e.x)
          , Le = (e, t) => e.x === t.x && e.y === t.y
          , De = (e, t) => (e.x = t(e.x),
        e.y = t(e.y),
        e)
          , ze = (e, t) => (e.x += t.x,
        e.y += t.y,
        e)
          , Fe = (e, t) => (e.x -= t.x,
        e.y -= t.y,
        e)
          , Oe = (e, t) => (e.x /= t,
        e.y /= t,
        e)
          , Be = (e, t) => (e.x *= t,
        e.y *= t,
        e)
          , Ne = (e, t) => e.x * t.x + e.y * t.y
          , We = (e, t) => e.x * t.y - e.y * t.x
          , He = (e, t=ke()) => {
            const i = e.x - t.x
              , o = e.y - t.y;
            return i * i + o * o
        }
          , je = (e, t=ke()) => Math.sqrt(He(e, t))
          , Ue = (e, t, i) => (e.x = Se(e.x, t, i.x),
        e.y = Se(e.y, t, i.y),
        e)
          , Ve = e => {
            let t = 0
              , i = 0;
            return e.forEach((e => {
                t += e.x,
                i += e.y
            }
            )),
            Ce(t / e.length, i / e.length)
        }
          , qe = (e, t, i, o, n) => (e.forEach((e => {
            e.x = t ? o - (e.x - o) : e.x,
            e.y = i ? n - (e.y - n) : e.y
        }
        )),
        e)
          , Ge = (e, t, i, o) => {
            const n = Math.sin(t)
              , r = Math.cos(t);
            return e.forEach((e => {
                e.x -= i,
                e.y -= o;
                const t = e.x * r - e.y * n
                  , a = e.x * n + e.y * r;
                e.x = i + t,
                e.y = o + a
            }
            )),
            e
        }
          , Ke = (e, t) => ({
            width: e,
            height: t
        })
          , Xe = e => Ke(e.width, e.height)
          , Ze = e => Ke(e.width, e.height)
          , Ye = e => Ke(e.width, e.height)
          , Qe = e => Ke(e[0], e[1])
          , Je = e => {
            return /img/i.test(e.nodeName) ? Ke((t = e).naturalWidth, t.naturalHeight) : Ze(e);
            var t
        }
          , et = (e, t) => Ke(e, t)
          , tt = (e, t, i=se) => i(e.width) === i(t.width) && i(e.height) === i(t.height)
          , it = (e, t) => (e.width *= t,
        e.height *= t,
        e)
          , ot = e => Ce(.5 * e.width, .5 * e.height)
          , nt = (e, t) => {
            const i = Math.abs(t)
              , o = Math.abs(Math.cos(i))
              , n = Math.abs(Math.sin(i))
              , r = o * e.width + n * e.height
              , a = n * e.width + o * e.height;
            return e.width = r,
            e.height = a,
            e
        }
          , rt = (e, t) => e.width >= t.width && e.height >= t.height
          , at = (e, t) => (e.width = t(e.width),
        e.height = t(e.height),
        e)
          , st = (e, t) => ({
            start: e,
            end: t
        })
          , lt = e => st(Me(e.start), Me(e.end))
          , ct = (e, t) => {
            if (0 === t)
                return e;
            const i = Ce(e.start.x - e.end.x, e.start.y - e.end.y)
              , o = Ae(i)
              , n = Be(o, t);
            return e.start.x += n.x,
            e.start.y += n.y,
            e.end.x -= n.x,
            e.end.y -= n.y,
            e
        }
          , ut = [Ce(-1, -1), Ce(-1, 1), Ce(1, 1), Ce(1, -1)]
          , dt = (e, t, i, o) => ({
            x: e,
            y: t,
            width: i,
            height: o
        })
          , pt = e => dt(e.x, e.y, e.width, e.height)
          , ht = () => dt(0, 0, 0, 0)
          , mt = e => dt(0, 0, e.width, e.height)
          , ft = e => dt(e.x || 0, e.y || 0, e.width || 0, e.height || 0)
          , gt = e => {
            let t = e[0].x
              , i = e[0].x
              , o = e[0].y
              , n = e[0].y;
            return e.forEach((e => {
                t = Math.min(t, e.x),
                i = Math.max(i, e.x),
                o = Math.min(o, e.y),
                n = Math.max(n, e.y)
            }
            )),
            dt(t, o, i - t, n - o)
        }
          , yt = e => bt(e.x - e.rx, e.y - e.ry, 2 * e.rx, 2 * e.ry)
          , $t = (e, t) => dt(e.x - .5 * t.width, e.y - .5 * t.height, t.width, t.height)
          , bt = (e, t, i, o) => dt(e, t, i, o)
          , vt = e => Ce(e.x + .5 * e.width, e.y + .5 * e.height)
          , xt = (e, t) => (e.x += t.x,
        e.y += t.y,
        e)
          , wt = (e, t, i) => (i = i || vt(e),
        e.x = t * (e.x - i.x) + i.x,
        e.y = t * (e.y - i.y) + i.y,
        e.width = t * e.width,
        e.height = t * e.height,
        e)
          , St = (e, t, i, o) => {
            const n = (o.x - e.x) / e.width
              , r = (o.y - e.y) / e.height;
            let a = Math.max(t.width, e.width)
              , s = Math.max(t.height, e.height);
            return a = Math.min(i.width, a),
            s = Math.min(i.height, s),
            e.x = o.x - n * a,
            e.y = o.y - r * s,
            e.width = a,
            e.height = s,
            e
        }
          , _t = (e, t) => {
            const [i,o] = xe[t]
              , n = i * e.width
              , r = o * e.height;
            return Ce(e.x + n, e.y + r)
        }
          , kt = (e, t) => (e.x *= t,
        e.y *= t,
        e.width *= t,
        e.height *= t,
        e)
          , Ct = (e, t, i=se) => i(e.x) === i(t.x) && i(e.y) === i(t.y) && i(e.width) === i(t.width) && i(e.height) === i(t.height)
          , Tt = e => ae(e.width, e.height)
          , Mt = (e, t, i, o, n) => (e.x = t,
        e.y = i,
        e.width = o,
        e.height = n,
        e)
          , Pt = (e, t) => (e.x = t.x,
        e.y = t.y,
        e.width = t.width,
        e.height = t.height,
        e)
          , Et = (e, t, i) => (i || (i = vt(e)),
        zt(e).map((e => Ee(e, t, i))))
          , Rt = (e, t) => dt(.5 * e.width - .5 * t.width, .5 * e.height - .5 * t.height, t.width, t.height)
          , At = (e, t) => !(t.x < e.x || t.y < e.y || t.x > e.x + e.width || t.y > e.y + e.height)
          , It = (e, t, i=ke()) => {
            if (0 === e.width || 0 === e.height)
                return ht();
            const o = Tt(e);
            t || (t = o);
            let n = e.width
              , r = e.height;
            return t > o ? n = r * t : r = n / t,
            dt(i.x + .5 * (e.width - n), i.y + .5 * (e.height - r), n, r)
        }
          , Lt = (e, t=Tt(e), i=ke()) => {
            if (0 === e.width || 0 === e.height)
                return ht();
            let o = e.width
              , n = o / t;
            return n > e.height && (n = e.height,
            o = n * t),
            dt(i.x + .5 * (e.width - o), i.y + .5 * (e.height - n), o, n)
        }
          , Dt = e => [Math.min(e.y, e.y + e.height), Math.max(e.x, e.x + e.width), Math.max(e.y, e.y + e.height), Math.min(e.x, e.x + e.width)]
          , zt = e => [Ce(e.x, e.y), Ce(e.x + e.width, e.y), Ce(e.x + e.width, e.y + e.height), Ce(e.x, e.y + e.height)]
          , Ft = (e, t) => {
            if (e)
                return e.x = t(e.x),
                e.y = t(e.y),
                e.width = t(e.width),
                e.height = t(e.height),
                e
        }
          , Ot = (e, t, i=vt(e)) => zt(e).map(( (e, o) => {
            const n = ut[o];
            return Ce(Se(e.x, 1 + n.x * t.x, i.x), Se(e.y, 1 + n.y * t.y, i.y))
        }
        ))
          , Bt = e => (e.x = 0,
        e.y = 0,
        e)
          , Nt = e => {
            const t = e[0]
              , i = e[e.length - 1];
            e = Le(t, i) ? e : [...e, t];
            const o = t.x
              , n = t.y;
            let r, a, s, l = 0, c = 0, u = 0, d = 0;
            const p = e.length;
            for (; c < p; c++)
                r = e[c],
                a = e[c + 1 > p - 1 ? 0 : c + 1],
                s = (r.y - n) * (a.x - o) - (a.y - n) * (r.x - o),
                l += s,
                u += (r.x + a.x - 2 * o) * s,
                d += (r.y + a.y - 2 * n) * s;
            return s = 3 * l,
            Ce(o + u / s, n + d / s)
        }
          , Wt = (e, t) => Ht(e.start, e.end, t.start, t.end)
          , Ht = (e, t, i, o) => {
            const n = (o.y - i.y) * (t.x - e.x) - (o.x - i.x) * (t.y - e.y);
            if (0 === n)
                return;
            const r = ((o.x - i.x) * (e.y - i.y) - (o.y - i.y) * (e.x - i.x)) / n
              , a = ((t.x - e.x) * (e.y - i.y) - (t.y - e.y) * (e.x - i.x)) / n;
            return r < 0 || r > 1 || a < 0 || a > 1 ? void 0 : Ce(e.x + r * (t.x - e.x), e.y + r * (t.y - e.y))
        }
          , jt = (e, t, {ignoreIdenticalLines: i=!1, breakOnIntersection: o=!1}={}) => {
            const n = t.length
              , r = [];
            for (let a = 0; a < n - 1; a++) {
                if (i && (Le(e.start, t[a]) || Le(e.start, t[a + 1]) || Le(e.end, t[a]) || Le(e.end, t[a + 1])))
                    continue;
                const n = Ht(e.start, e.end, t[a], t[a + 1]);
                if (n) {
                    if (o)
                        return [n];
                    r.push(n)
                }
            }
            return r.length ? r : void 0
        }
          , Ut = (e, t) => {
            let i = 0
              , o = 0
              , n = !1;
            const r = t.length;
            for (i = 0,
            o = r - 1; i < r; o = i++)
                t[i].y > e.y != t[o].y > e.y && e.x < (t[o].x - t[i].x) * (e.y - t[i].y) / (t[o].y - t[i].y) + t[i].x && (n = !n);
            return n
        }
          , Vt = e => {
            const t = [];
            for (let i = 0; i < e.length; i++) {
                let o = i + 1;
                o === e.length && (o = 0),
                t.push(st(Me(e[i]), Me(e[o])))
            }
            return t
        }
          , qt = (e, t=0) => Vt(e).map((e => ct(e, t)))
          , Gt = (e, t, i, o=0, n=!1, r=!1, a=12) => {
            const s = [];
            for (let o = 0; o < a; o++)
                s.push(Ce(e.x + t * Math.cos(o * (2 * Math.PI) / a), e.y + i * Math.sin(o * (2 * Math.PI) / a)));
            return (n || r) && qe(s, n, r, e.x, e.y),
            o && Ge(s, o, e.x, e.y),
            s
        }
          , Kt = (e, t, i, o) => {
            const n = Ce(e.x - i.x, e.y - i.y)
              , r = Ce(o.x - i.x, o.y - i.y)
              , a = Ne(r, r);
            let s = Ne(n, r) / a;
            s = s < 0 ? 0 : s,
            s = s > 1 ? 1 : s;
            const l = Ce(r.x * s + i.x - e.x, r.y * s + i.y - e.y);
            return Ne(l, l) <= t * t
        }
          , Xt = (e, t, i) => {
            const o = i.length;
            for (let n = 0; n < o - 1; n++)
                if (Kt(e, t, i[n], i[n + 1]))
                    return !0;
            return !1
        }
          , Zt = (e, t, i) => !!Ut(e, i) || !!Xt(e, t, i) || Kt(e, t, i[0], i[i.length - 1])
          , Yt = (e, t, i, o, n) => Zt(e, t, Et(i, o, n || vt(i)));
        var Qt = (e, t) => e instanceof HTMLElement && (!t || new RegExp(`^${t}$`,"i").test(e.nodeName))
          , Jt = e => e instanceof File
          , ei = async (e, t, i) => {
            const o = await Q(e, t, i);
            return re(o, "canvas")
        }
          , ti = e => e.split("/").pop().split(/\?|\#/).shift();
        const ii = _() && Node.prototype.replaceChildren ? (e, t) => e.replaceChildren(t) : (e, t) => {
            for (; e.lastChild; )
                e.removeChild(e.lastChild);
            void 0 !== t && e.append(t)
        }
          , oi = _() && M("div", {
            class: "PinturaMeasure",
            style: "position:absolute;left:0;top:0;width:99999px;height:0;pointer-events:none;contain:strict;margin:0;padding:0;"
        });
        let ni;
        var ri = e => (ii(oi, e),
        oi.parentNode || document.body.append(oi),
        clearTimeout(ni),
        ni = setTimeout(( () => {
            oi.remove()
        }
        ), 500),
        e);
        let ai = null;
        var si = () => (null === ai && (ai = _() && /^((?!chrome|android).)*(safari|iphone|ipad)/i.test(navigator.userAgent)),
        ai)
          , li = e => new Promise(( (t, i) => {
            let o = !1;
            !e.parentNode && si() && (o = !0,
            e.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:0;height:0;",
            ri(e));
            const n = () => {
                const i = e.naturalWidth
                  , n = e.naturalHeight;
                i && n && (o && e.remove(),
                clearInterval(r),
                t({
                    width: i,
                    height: n
                }))
            }
            ;
            e.onerror = e => {
                clearInterval(r),
                i(e)
            }
            ;
            const r = setInterval(n, 1);
            n()
        }
        ))
          , ci = e => new Promise(( (t, i) => {
            const o = () => {
                t({
                    width: e.videoWidth,
                    height: e.videoHeight
                })
            }
            ;
            if (e.readyState >= 1)
                return o();
            e.onloadedmetadata = o,
            e.onerror = () => i(e.error)
        }
        ))
          , ui = e => /^image/.test(e.type)
          , di = e => new Promise((t => {
            const i = W(e) ? e : URL.createObjectURL(e)
              , o = () => {
                const e = new Image;
                e.src = i,
                t(e)
            }
            ;
            if (e instanceof Blob && ui(e))
                return o();
            const n = document.createElement("video");
            n.preload = "metadata",
            n.onloadedmetadata = () => t(n),
            n.onerror = o,
            n.src = i
        }
        ))
          , pi = e => "VIDEO" === e.nodeName
          , hi = async e => {
            let t, i;
            t = e.src ? e : await di(e);
            try {
                i = pi(t) ? await ci(t) : await li(t)
            } finally {
                Jt(e) && URL.revokeObjectURL(t.src)
            }
            return i
        }
          , mi = (e=0, t=!0) => new (y("ProgressEvent"))("progress",{
            loaded: 100 * e,
            total: 100,
            lengthComputable: t
        })
          , fi = (e, t, i=(e => e)) => e.getAllResponseHeaders().indexOf(t) >= 0 ? i(e.getResponseHeader(t)) : void 0
          , gi = e => {
            if (!e)
                return null;
            const t = e.split(/filename=|filename\*=.+''/).splice(1).map((e => e.trim().replace(/^["']|[;"']{0,2}$/g, ""))).filter((e => e.length));
            return t.length ? decodeURI(t[t.length - 1]) : null
        }
        ;
        class yi extends Error {
            constructor(e, t, i) {
                super(e),
                this.name = "EditorError",
                this.code = t,
                this.metadata = i
            }
        }
        var $i = (e, t) => {
            const {headers: i={}, credentials: o} = t || {};
            Object.entries(i).forEach(( ([t,i]) => e.setRequestHeader(t, i))),
            o && (e.withCredentials = "omit" !== o)
        }
          , bi = e => e instanceof Blob && !(e instanceof File)
          , vi = e => "close"in e
          , xi = async (e, t, i) => {
            if (Jt(e) || bi(e))
                return e;
            if (W(e))
                return await ( (e, t, i) => /^data:/.test(e) ? (async (e, t="data-uri", i=$) => {
                    i(mi(0));
                    const o = await fetch(e);
                    i(mi(.33));
                    const n = await o.blob();
                    let r;
                    ui(n) || (r = "image/" + (e.includes(",/9j/") ? "jpeg" : "png")),
                    i(mi(.66));
                    const a = re(n, t, r);
                    return i(mi(1)),
                    a
                }
                )(e, void 0, t) : ( (e, t, i) => new Promise(( (o, n) => {
                    const r = () => n(new yi("Error fetching image","URL_REQUEST",a))
                      , a = new XMLHttpRequest;
                    a.onprogress = t,
                    a.onerror = r,
                    a.onload = () => {
                        if (!a.response || a.status >= 300 || a.status < 200)
                            return r();
                        const t = fi(a, "Content-Type")
                          , i = fi(a, "Content-Disposition", gi) || ti(e);
                        o(re(a.response, i, t || ne(i)))
                    }
                    ;
                    const {willRequest: s} = i;
                    Promise.resolve(s && s(e, {
                        resourceType: "image"
                    })).then((t => {
                        if (!1 === t)
                            return n("Image load rejected");
                        a.open("GET", e, !0),
                        $i(a, t),
                        a.responseType = "blob",
                        a.send()
                    }
                    )).catch(console.error)
                }
                )))(e, t, i))(e, t, i);
            if (Qt(e, "canvas"))
                return await ei(e);
            if (Qt(e, "img"))
                return await (async e => {
                    const t = await hi(e)
                      , i = await (e => new Promise(( (t, i) => {
                        if (e.complete)
                            return t(e);
                        e.onload = () => t(e),
                        e.onerror = () => i(new Error("Failed to load image"))
                    }
                    )))(e)
                      , o = M("canvas", t);
                    o.getContext("2d", {
                        willReadFrequently: !0
                    }).drawImage(i, 0, 0);
                    const n = await Q(o);
                    return re(n, ti(i.src))
                }
                )(e);
            if (R(e) || vi(e))
                return await ei(await z(e));
            throw new yi("Invalid image source","invalid-image-source")
        }
        ;
        let wi = null;
        var Si = () => (null === wi && (wi = _() && /^mac/i.test(navigator.platform)),
        wi);
        let _i = null;
        var ki = () => (null === _i && (_i = _() && (A(/iPhone|iPad|iPod/) || Si() && navigator.maxTouchPoints >= 1)),
        _i)
          , Ci = async (e, t=1) => await C() || ki() || t < 5 ? e : et(e.height, e.width)
          , Ti = e => /jpeg/.test(e.type)
          , Mi = e => {
            return "object" != typeof (t = e) || t.constructor != Object ? e : JSON.stringify(e);
            var t
        }
          , Pi = (e, t=0, i) => (0 === t || (e.translate(i.x, i.y),
        e.rotate(t),
        e.translate(-i.x, -i.y)),
        e)
          , Ei = (e, t, i) => (e.scale(t, i),
        e)
          , Ri = async (e, t={}) => {
            const {flipX: i, flipY: o, rotation: n, crop: r} = t
              , a = Ze(e)
              , s = i || o
              , l = !!n
              , c = r && (r.x || r.y || r.width || r.height)
              , u = c && Ct(r, mt(a))
              , d = c && !u;
            if (!s && !l && !d)
                return e;
            let p, h = M("canvas", {
                width: e.width,
                height: e.height
            });
            if (h.getContext("2d", {
                willReadFrequently: !0
            }).putImageData(e, 0, 0),
            s) {
                const e = M("canvas", {
                    width: h.width,
                    height: h.height
                }).getContext("2d", {
                    willReadFrequently: !0
                });
                Ei(e, i ? -1 : 1, o ? -1 : 1),
                e.drawImage(h, i ? -h.width : 0, o ? -h.height : 0),
                e.restore(),
                E(h),
                h = e.canvas
            }
            if (l) {
                const e = at(Ye(gt(Et(ft(h), n))), Math.floor)
                  , t = M("canvas", {
                    width: r.width,
                    height: r.height
                }).getContext("2d", {
                    willReadFrequently: !0
                });
                ( (e, t, i) => {
                    e.translate(t, i)
                }
                )(t, -r.x, -r.y),
                Pi(t, n, ot(e)),
                t.drawImage(h, .5 * (e.width - h.width), .5 * (e.height - h.height)),
                t.restore(),
                E(h),
                h = t.canvas
            } else if (d)
                return p = h.getContext("2d", {
                    willReadFrequently: !0
                }).getImageData(r.x, r.y, r.width, r.height),
                E(h),
                p;
            return p = h.getContext("2d", {
                willReadFrequently: !0
            }).getImageData(0, 0, h.width, h.height),
            E(h),
            p
        }
          , Ai = (e, t) => {
            const {imageData: i, width: o, height: n} = e
              , r = i.width
              , a = i.height
              , s = Math.round(o)
              , l = Math.round(n)
              , c = i.data
              , u = new Uint8ClampedArray(s * l * 4)
              , d = r / s
              , p = a / l
              , h = Math.ceil(.5 * d)
              , m = Math.ceil(.5 * p);
            for (let e = 0; e < l; e++)
                for (let t = 0; t < s; t++) {
                    const i = 4 * (t + e * s);
                    let o = 0
                      , n = 0
                      , a = 0
                      , l = 0
                      , f = 0
                      , g = 0
                      , y = 0;
                    const $ = (e + .5) * p;
                    for (let i = Math.floor(e * p); i < (e + 1) * p; i++) {
                        const e = Math.abs($ - (i + .5)) / m
                          , s = (t + .5) * d
                          , u = e * e;
                        for (let e = Math.floor(t * d); e < (t + 1) * d; e++) {
                            let t = Math.abs(s - (e + .5)) / h;
                            const d = Math.sqrt(u + t * t);
                            if (d < -1 || d > 1)
                                continue;
                            if (o = 2 * d * d * d - 3 * d * d + 1,
                            o <= 0)
                                continue;
                            t = 4 * (e + i * r);
                            const p = c[t + 3];
                            y += o * p,
                            a += o,
                            p < 255 && (o = o * p / 250),
                            l += o * c[t],
                            f += o * c[t + 1],
                            g += o * c[t + 2],
                            n += o
                        }
                    }
                    u[i] = l / n,
                    u[i + 1] = f / n,
                    u[i + 2] = g / n,
                    u[i + 3] = y / a
                }
            t(null, {
                data: u,
                width: s,
                height: l
            })
        }
          , Ii = e => {
            if (e instanceof ImageData)
                return e;
            let t;
            try {
                t = new ImageData(e.width,e.height)
            } catch (i) {
                t = M("canvas").getContext("2d").createImageData(e.width, e.height)
            }
            return t.data.set(e.data),
            t
        }
          , Li = async (e, t={}, i) => {
            const {width: o, height: n, fit: r, upscale: a} = t;
            if (!o && !n)
                return e;
            let s = o
              , l = n;
            if (o ? n || (l = o) : s = n,
            "force" !== r) {
                const t = s / e.width
                  , i = l / e.height;
                let o = 1;
                if ("cover" === r ? o = Math.max(t, i) : "contain" === r && (o = Math.min(t, i)),
                o > 1 && !1 === a)
                    return e;
                s = Math.round(e.width * o),
                l = Math.round(e.height * o)
            }
            return s = Math.max(s, 1),
            l = Math.max(l, 1),
            e.width === s && e.height === l ? e : i ? i(e, s, l) : (e = await G(Ai, [{
                imageData: e,
                width: s,
                height: l
            }], [e.data.buffer]),
            Ii(e))
        }
          , Di = (e, t) => {
            const {imageData: i, matrix: o} = e;
            if (!o)
                return t(null, i);
            const n = new Uint8ClampedArray(i.width * i.height * 4)
              , r = i.data
              , a = r.length
              , s = o[0]
              , l = o[1]
              , c = o[2]
              , u = o[3]
              , d = o[4]
              , p = o[5]
              , h = o[6]
              , m = o[7]
              , f = o[8]
              , g = o[9]
              , y = o[10]
              , $ = o[11]
              , b = o[12]
              , v = o[13]
              , x = o[14]
              , w = o[15]
              , S = o[16]
              , _ = o[17]
              , k = o[18]
              , C = o[19];
            let T = 0
              , M = 0
              , P = 0
              , E = 0
              , R = 0
              , A = 0
              , I = 0
              , L = 0
              , D = 0
              , z = 0
              , F = 0
              , O = 0;
            for (; T < a; T += 4)
                M = r[T] / 255,
                P = r[T + 1] / 255,
                E = r[T + 2] / 255,
                R = r[T + 3] / 255,
                A = M * s + P * l + E * c + R * u + d,
                I = M * p + P * h + E * m + R * f + g,
                L = M * y + P * $ + E * b + R * v + x,
                D = M * w + P * S + E * _ + R * k + C,
                z = Math.max(0, A * D) + (1 - D),
                F = Math.max(0, I * D) + (1 - D),
                O = Math.max(0, L * D) + (1 - D),
                n[T] = 255 * Math.max(0, Math.min(1, z)),
                n[T + 1] = 255 * Math.max(0, Math.min(1, F)),
                n[T + 2] = 255 * Math.max(0, Math.min(1, O)),
                n[T + 3] = 255 * R;
            t(null, {
                data: n,
                width: i.width,
                height: i.height
            })
        }
          , zi = (e, t) => {
            const {imageData: i, matrix: o} = e;
            if (!o)
                return t(null, i);
            let n = o.reduce(( (e, t) => e + t));
            n = n <= 0 ? 1 : n;
            const r = i.width
              , a = i.height
              , s = i.data;
            let l = 0
              , c = 0
              , u = 0;
            const d = Math.round(Math.sqrt(o.length))
              , p = Math.floor(d / 2);
            let h = 0
              , m = 0
              , f = 0
              , g = 0
              , y = 0
              , $ = 0
              , b = 0
              , v = 0
              , x = 0
              , w = 0;
            const S = new Uint8ClampedArray(r * a * 4);
            for (u = 0; u < a; u++)
                for (c = 0; c < r; c++) {
                    for (h = 0,
                    m = 0,
                    f = 0,
                    g = 0,
                    $ = 0; $ < d; $++)
                        for (y = 0; y < d; y++)
                            b = u + $ - p,
                            v = c + y - p,
                            b < 0 && (b = a - 1),
                            b >= a && (b = 0),
                            v < 0 && (v = r - 1),
                            v >= r && (v = 0),
                            x = 4 * (b * r + v),
                            w = o[$ * d + y],
                            h += s[x] * w,
                            m += s[x + 1] * w,
                            f += s[x + 2] * w,
                            g += s[x + 3] * w;
                    S[l] = h / n,
                    S[l + 1] = m / n,
                    S[l + 2] = f / n,
                    S[l + 3] = g / n,
                    l += 4
                }
            t(null, {
                data: S,
                width: r,
                height: a
            })
        }
          , Fi = (e, t) => {
            let {imageData: i, strength: o} = e;
            if (!o)
                return t(null, i);
            const n = new Uint8ClampedArray(i.width * i.height * 4)
              , r = i.width
              , a = i.height
              , s = i.data
              , l = (e, t) => (c = e - w,
            u = t - S,
            Math.sqrt(c * c + u * u));
            let c, u, d, p, h, m, f, g, y, $, b, v = 0, x = 0, w = .5 * r, S = .5 * a, _ = l(0, 0);
            for (o > 0 ? (d = 0,
            p = 0,
            h = 0) : (o = Math.abs(o),
            d = 1,
            p = 1,
            h = 1),
            x = 0; x < a; x++)
                for (v = 0; v < r; v++)
                    k = 4 * (v + x * r),
                    C = s,
                    T = n,
                    M = l(v, x) * o / _,
                    m = C[k] / 255,
                    f = C[k + 1] / 255,
                    g = C[k + 2] / 255,
                    y = C[k + 3] / 255,
                    $ = 1 - M,
                    b = $ * y + M,
                    T[k] = ($ * y * m + M * d) / b * 255,
                    T[k + 1] = ($ * y * f + M * p) / b * 255,
                    T[k + 2] = ($ * y * g + M * h) / b * 255,
                    T[k + 3] = 255 * b;
            var k, C, T, M;
            t(null, {
                data: n,
                width: i.width,
                height: i.height
            })
        }
          , Oi = (e, t) => {
            const {imageData: i, level: o, monochrome: n=!1} = e;
            if (!o)
                return t(null, i);
            const r = new Uint8ClampedArray(i.width * i.height * 4)
              , a = i.data
              , s = a.length;
            let l, c, u, d = 0;
            const p = () => 255 * (2 * Math.random() - 1) * o
              , h = n ? () => {
                const e = p();
                return [e, e, e]
            }
            : () => [p(), p(), p()];
            for (; d < s; d += 4)
                [l,c,u] = h(),
                r[d] = a[d] + l,
                r[d + 1] = a[d + 1] + c,
                r[d + 2] = a[d + 2] + u,
                r[d + 3] = a[d + 3];
            t(null, {
                data: r,
                width: i.width,
                height: i.height
            })
        }
          , Bi = (e, t) => {
            const {imageData: i, level: o} = e;
            if (!o)
                return t(null, i);
            const n = new Uint8ClampedArray(i.width * i.height * 4)
              , r = i.data
              , a = r.length;
            let s, l, c, u = 0;
            for (; u < a; u += 4)
                s = r[u] / 255,
                l = r[u + 1] / 255,
                c = r[u + 2] / 255,
                n[u] = 255 * Math.pow(s, o),
                n[u + 1] = 255 * Math.pow(l, o),
                n[u + 2] = 255 * Math.pow(c, o),
                n[u + 3] = r[u + 3];
            t(null, {
                data: n,
                width: i.width,
                height: i.height
            })
        }
          , Ni = async (e, t={}) => {
            const {colorMatrix: i, convolutionMatrix: o, gamma: n, noise: r, vignette: a} = t
              , s = [];
            if (o && s.push([zi, {
                matrix: o.clarity
            }]),
            n > 0 && s.push([Bi, {
                level: 1 / n
            }]),
            i && !(e => {
                const t = e.length;
                let i;
                const o = t >= 20 ? 6 : t >= 16 ? 5 : 3;
                for (let n = 0; n < t; n++) {
                    if (i = e[n],
                    1 === i && n % o != 0)
                        return !1;
                    if (0 !== i && 1 !== i)
                        return !1
                }
                return !0
            }
            )(i) && s.push([Di, {
                matrix: i
            }]),
            (r > 0 || r < 0) && s.push([Oi, {
                level: r
            }]),
            (a > 0 || a < 0) && s.push([Fi, {
                strength: a
            }]),
            !s.length)
                return e;
            const l = (e, t) => `(err, imageData) => {\n            (${e[t][0].toString()})(Object.assign({ imageData: imageData }, filterInstructions[${t}]), \n                ${e[t + 1] ? l(e, t + 1) : "done"})\n        }`
              , c = `function (options, done) {\n        const filterInstructions = options.filterInstructions;\n        const imageData = options.imageData;\n        (${l(s, 0)})(null, imageData)\n    }`;
            return e = await G(c, [{
                imageData: e,
                filterInstructions: s.map((e => e[1]))
            }], [e.data.buffer]),
            Ii(e)
        }
          , Wi = e => "number" == typeof e
          , Hi = e => W(e) && null !== e.match(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g)
          , ji = (e, t) => e.hasOwnProperty(t)
          , Ui = e => Array.isArray(e);
        let Vi = 64
          , qi = 102
          , Gi = 112
          , Ki = !1;
        var Xi = (e, t) => (!Ki && _() && (/^win/i.test(navigator.platform) && (qi = 103),
        (ki() || Si()) && (Vi = 63.5,
        qi = 110,
        Gi = 123),
        Ki = !0),
        `<svg${t ? ` aria-label="${t}"` : ""} width="128" height="128" viewBox="0 0 128 128" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg"><text x="${Vi}" y="${qi}" alignment-baseline="text-top" dominant-baseline="text-top" text-anchor="middle" font-size="${Gi}px">${e}</text></svg>`)
          , Zi = e => e instanceof Blob
          , Yi = (e, t) => e / t * 100 + "%"
          , Qi = e => `rgba(${Math.round(255 * e[0])}, ${Math.round(255 * e[1])}, ${Math.round(255 * e[2])}, ${Wi(e[3]) ? e[3] : 1})`
          , Ji = e => Object.values(e).join("_");
        const eo = async (e, t=0) => {
            const i = M("canvas", {
                width: 80,
                height: 80
            }).getContext("2d");
            return await ( (e=0) => new Promise((t => {
                setTimeout(t, e)
            }
            )))(t),
            i.drawImage(e, 0, 0, 80, 80),
            !((e => !new Uint32Array(e.getImageData(0, 0, e.canvas.width, e.canvas.height).data.buffer).some((e => 0 !== e)))(i) && t <= 256) || await eo(e, t + 16)
        }
          , to = new Map;
        var io = e => new Promise(( (t, i) => {
            const o = new FileReader;
            o.onerror = () => i(o.error),
            o.onload = () => t(o.result),
            o.readAsDataURL(e)
        }
        ))
          , oo = () => {
            let e = [];
            return {
                sub: (t, i) => (e.push({
                    event: t,
                    callback: i
                }),
                () => e = e.filter((e => e.event !== t || e.callback !== i))),
                pub: (t, i) => {
                    e.filter((e => e.event === t)).forEach((e => e.callback(i)))
                }
            }
        }
        ;
        const no = 32
          , ro = ({color: e=[0, 0, 0], fontSize: t=16, fontFamily: i="sans-serif", fontVariant: o="normal", fontWeight: n="normal", fontStyle: r="normal", textAlign: a="left", letterSpacing: s="normal", lineHeight: l=20}, c=1) => `font-size:${t * c}px;font-style:${r};font-weight:${n};font-family:${i};font-variant:${o};line-height:${l * c}px;text-align:${a};letter-spacing:${Wi(s) ? s + "px" : "normal"};color:${Qi(e)};`
          , ao = (e, t, i=1) => {
            const {width: o, height: n, disableNewline: r} = t
              , a = !o
              , s = !1 === r ? ( (e="") => e.split("\n").length)(e) : void 0
              , l = a ? "auto" : o * i + "px"
              , c = n ? n * i + "px" : "auto"
              , u = a ? "normal" : "break-word"
              , d = a && !s ? "nowrap" : "pre-line"
              , p = ( ({fontSize: e=16, lineHeight: t=20}={}) => .5 * Math.max(0, e - t))(t) * i;
            return `max-width:none;min-width:auto;width:${l};height:${c};margin-top:0;margin-bottom:0;padding-top:${p}px;word-break:${u};word-wrap:normal;white-space:${d};`
        }
          , so = new Map
          , lo = e => {
            const t = [];
            for (const i of Array.from(e.childNodes))
                i.nodeType === Node.TEXT_NODE ? t.push(uo(i)) : t.push(...lo(i));
            return t
        }
          , co = "pointer-events:none;visibility:hidden;position:absolute;left:0;top:0;"
          , uo = e => {
            const t = e.nodeValue;
            if (!t)
                return [];
            const i = t.length
              , o = document.createRange();
            o.selectNodeContents(e);
            const n = [];
            for (let r = 0; r < i; r++) {
                o.setStart(e, 0),
                o.setEnd(e, r + 1);
                const i = o.getClientRects().length - 1
                  , a = t.charAt(r);
                n[i] ? n[i] += a : n.push(a)
            }
            const r = o.getClientRects();
            return n.map(( (e, t) => ({
                rect: r[t],
                text: e
            })))
        }
          , po = new Map
          , ho = (e="", t) => {
            const {width: i=0, height: o=0} = t;
            if (i && o)
                return et(i, o);
            let {fontSize: n=16, fontFamily: r, lineHeight: a=20, fontWeight: s, fontStyle: l, fontVariant: c, letterSpacing: u} = t;
            const d = Ji({
                text: e,
                fontFamily: r,
                fontWeight: s,
                fontStyle: l,
                fontVariant: c,
                fontSize: n,
                letterSpacing: u,
                lineHeight: a,
                width: i
            });
            let p = po.get(d);
            if (p)
                return p;
            let h = 1;
            n > 1e3 && X() && (h = n / 1e3,
            n = 1e3,
            a /= h);
            const m = ri(M("pre", {
                contenteditable: "true",
                spellcheck: "false",
                style: `${co}${ro({
                    ...t,
                    fontSize: n,
                    lineHeight: a
                })};${ao(e, t)}"`,
                innerHTML: e
            })).getBoundingClientRect();
            return p = Ze(m),
            p = at(p, (e => e * h)),
            i && (p.width = i),
            po.set(d, p),
            p
        }
          , mo = new Map
          , fo = async (e, t, i) => {
            let o;
            try {
                o = await ( (e, t) => new Promise(( (i, o) => {
                    let n = mo.get(e);
                    void 0 === n && (n = ( (e, t) => {
                        const {sub: i, pub: o} = oo();
                        let n, r;
                        return Promise.resolve(t && t(e, {
                            resourceType: "stylesheet"
                        })).then((t => {
                            if (!1 === t)
                                return r = "requestPrevented",
                                o("error", r);
                            const {headers: i, credentials: a} = t || {};
                            fetch(e, {
                                headers: i,
                                credentials: a
                            }).then((e => e.text())).then((e => {
                                n = e,
                                o("load", n)
                            }
                            )).catch((e => {
                                r = e,
                                o("error", r)
                            }
                            ))
                        }
                        )),
                        {
                            sub: (e, t) => "load" === e && n ? t(n) : "error" === e && r ? t(r) : void i(e, t)
                        }
                    }
                    )(e, t),
                    mo.set(e, n)),
                    n.sub("load", i),
                    n.sub("error", o)
                }
                )))(e, t)
            } catch (e) {
                return []
            }
            const n = {
                innerHTML: o,
                id: V()
            };
            i && (n.nonce = i);
            const r = M("style", n);
            document.head.append(r);
            const a = Array.from(document.styleSheets).find((e => e.ownerNode.id === r.id));
            return r.remove(),
            Array.from(a.cssRules)
        }
          , go = new Map
          , yo = (e, t) => e.style.getPropertyValue(t)
          , $o = (e, t) => !!e.style && yo(e, "font-family").replace(/^"|"$/g, "") == t
          , bo = async (e, t, i) => {
            const o = await (async (e, t) => {
                const i = Array.from(document.styleSheets).map((i => (async (e, t, i) => {
                    if (go.has(e.href))
                        return go.get(e.href);
                    let o;
                    try {
                        o = Array.from(e.cssRules);
                        for (const e of (e => e.filter((e => e instanceof CSSImportRule)))(o)) {
                            const n = e.href;
                            if (go.has(n)) {
                                const e = go.get(n);
                                o = [...o, ...e];
                                continue
                            }
                            const r = await fo(n, t, i);
                            go.set(n, r),
                            o = [...o, ...r]
                        }
                    } catch (n) {
                        const r = e.href;
                        o = await fo(r, t, i),
                        go.set(r, o)
                    }
                    return (e => e.filter((e => e instanceof CSSFontFaceRule)))(o)
                }
                )(i, e, t)))
                  , o = await Promise.all(i)
                  , n = [];
                return o.forEach((e => n.push(...e))),
                n
            }
            )(t, i)
              , n = ( (e, t) => {
                const i = [];
                for (const o of e)
                    $o(o, t) && i.push(o);
                return i
            }
            )(o, e);
            return n.length ? n.map((e => {
                const t = e.parentStyleSheet && e.parentStyleSheet.href && new URL(e.parentStyleSheet.href)
                  , i = t ? t.origin + (e => e.pathname.split("/").slice(0, -1).join("/"))(t) + "/" : ""
                  , o = e.style.getPropertyValue("src").match(/url\("?(.*?)"?\)/)[1]
                  , n = Array.from(e.style).filter((e => "src" != e)).reduce(( (t, i) => t + (i + ":") + yo(e, i) + ";"), "");
                return [/^http/.test(o) ? o : i + o, n]
            }
            )) : []
        }
          , vo = new Map
          , xo = new Map;
        var wo = async (e="", t) => {
            if (!e.length)
                return;
            let {color: i, imageWidth: o=300, imageHeight: n=150, paddingTop: r=0, paddingRight: a=no, paddingBottom: s=0, paddingLeft: l=no, fontFamily: c, fontSize: u, pixelRatio: d=1, willRequest: p, outline: h, blur: m, styleNonce: f} = t
              , g = 1
              , y = "";
            u > 1e3 && X() && (g = u / 1e3,
            y = `transform-origin:0 0;transform:scale(${g})`);
            const $ = d / g
              , b = (o + l + a) * d
              , v = (n + s + r) * d
              , x = await (async (e, t, i) => {
                if (vo.get(e))
                    return;
                let o = xo.get(e);
                if (!o) {
                    const r = await bo(e, t, i);
                    if (!r.length)
                        return void vo.set(e, !0);
                    const a = [];
                    for (const [e,t] of r) {
                        const i = await fetch(e).then((e => e.blob()))
                          , o = !(n = i.type) || /woff2/.test(n) ? "woff2" : /woff/.test(n) ? "woff" : /ttf|truetype/.test(n) ? "truetype" : /otf|opentype/.test(n) ? "opentype" : /svg/.test(n) ? "svg" : "woff2"
                          , r = await io(i);
                        a.push(`@font-face { src:url(${r}) format('${o}');${t};font-display:block; }`)
                    }
                    o = a.join(""),
                    xo.set(e, o)
                }
                var n;
                return o
            }
            )(c, p, f);
            let w = "";
            x && (w = `<style${f ? ` nonce="${f}"` : ""}>${x}</style>`);
            const S = e.replace(/%/g, "%25").replace(/#/g, "%23").replace(/&nbsp;/g, " ").replace(/&(?!#\d{4};|[a-z]+;)/gi, "&amp;").replace(/<br>|\n/g, "<br/>")
              , _ = `top:${r * $}px;right:${a * $}px;bottom:${s * $}px;left:${l * $}px`;
            let k = i
              , C = ""
              , T = "";
            if (h || m) {
                const e = Qi(i);
                h && (k = [0, 0, 0, 0],
                C = `-webkit-text-stroke: ${2 * h * $}px ${e}`),
                m && (si() ? T = `filter:blur(${m * $ * .4}px)` : (k = [0, 0, 0, 0],
                T = `text-shadow: 0 0 ${m * $}px ${e}`))
            }
            return ( (e, {safariCacheKey: t="*"}={}) => new Promise(( (i, o) => {
                const n = new Image;
                n.onerror = () => o(new Error("Failed to load SVG")),
                n.onload = () => {
                    if (!si() || !e.includes("@font-face") || to.has(t))
                        return i(n);
                    eo(n).then(( () => {
                        to.set(t, !0),
                        i(n)
                    }
                    ))
                }
                ,
                n.src = "data:image/svg+xml," + e
            }
            )))(`<svg xmlns="http://www.w3.org/2000/svg" width="${b}" height="${v}" viewBox="0 0 ${b} ${v}"><foreignObject x="0" y="0" width="${b}" height="${v}"><div xmlns="http://www.w3.org/1999/xhtml">${w}<pre contenteditable="true" spellcheck="false" style="position:absolute;${_};${ro({
                ...t,
                color: k,
                fontSize: u
            }, $)};${ao(e, t, $)};${y};${C};${T}">${S}</pre></div></foreignObject></svg>`, {
                safariCacheKey: c
            })
        }
        ;
        const So = e => {
            const t = {
                ...e
            };
            return N(t)
        }
          , _o = (e, t={}) => {
            const i = Tt(e);
            let o, n;
            const r = t.width || t.rx
              , a = t.height || t.ry;
            if (r && a)
                return Xe(t);
            if (r || a) {
                o = parseFloat(r || Number.MAX_SAFE_INTEGER),
                n = parseFloat(a || Number.MAX_SAFE_INTEGER);
                const e = Math.min(o, n);
                W(r) || W(a) ? (o = `${e}%`,
                n = e * i + "%") : (o = e,
                n = e)
            } else {
                const e = 10;
                o = `${e}%`,
                n = e * i + "%"
            }
            return {
                [(t.width ? "width" : t.rx ? "rx" : void 0) || "width"]: o,
                [(t.width ? "height" : t.rx ? "ry" : void 0) || "height"]: n
            }
        }
          , ko = (e, t={}) => {
            return {
                width: void 0,
                height: void 0,
                ...t,
                aspectRatio: 1,
                backgroundImage: (i = Xi(e),
                `data:image/svg+xml,${i.replace("<", "%3C").replace(">", "%3E")}`)
            };
            var i
        }
          , Co = (e, t={}) => ({
            backgroundColor: [0, 0, 0, 0],
            ...Lo(t) ? {} : {
                width: void 0,
                height: void 0,
                aspectRatio: void 0
            },
            ...t,
            backgroundImage: W(e) ? e : Zi(e) ? URL.createObjectURL(e) : e
        })
          , To = (e, t) => {
            let i;
            if (W(e) || Zi(e)) {
                const o = {
                    ..._o(t),
                    backgroundSize: "contain"
                };
                i = Hi(e) ? ko(e, o) : Co(e, o)
            } else if (e.src) {
                const o = _o(t, e.shape || e)
                  , n = {
                    ...e.shape,
                    ...o
                };
                if (e.width && e.height && !ji(n, "aspectRatio")) {
                    const e = Sn(o, "width", t)
                      , i = Sn(o, "height", t);
                    n.aspectRatio = ae(e, i)
                }
                n.backgroundSize || e.shape || e.width && e.height || (n.backgroundSize = "contain"),
                i = Hi(e.src) ? ko(e.src, n) : Co(e.src, n)
            } else
                e.shape && (i = So(e.shape));
            return ji(i, "backgroundImage") && (ji(i, "backgroundColor") || (i.backgroundColor = [0, 0, 0, 0]),
            ji(i, "disableStyle") || (i.disableStyle = ["cornerRadius", "backgroundColor", "strokeColor", "strokeWidth"])),
            t ? xn(i, t) : i
        }
          , Mo = e => Ce(e.x1, e.y1)
          , Po = e => Ce(e.x2, e.y2)
          , Eo = e => ji(e, "text")
          , Ro = e => Eo(e) && !(Uo(e) || ji(e, "width"))
          , Ao = e => Eo(e) && (Uo(e) || ji(e, "width"))
          , Io = e => !Eo(e) && Vo(e)
          , Lo = e => ji(e, "rx")
          , Do = e => ji(e, "x1")
          , zo = e => ji(e, "points")
          , Fo = e => Eo(e) && e.isEditing
          , Oo = e => !ji(e, "opacity") || e.opacity > 0
          , Bo = e => e.isSelected
          , No = e => e.isEditing
          , Wo = e => e._isDraft
          , Ho = e => ji(e, "width") && ji(e, "height")
          , jo = e => {
            const t = ji(e, "right")
              , i = ji(e, "bottom");
            return t || i
        }
          , Uo = e => (ji(e, "x") || ji(e, "left")) && ji(e, "right") || (ji(e, "y") || ji(e, "top")) && ji(e, "bottom")
          , Vo = e => Ho(e) || Uo(e)
          , qo = e => (e._isDraft = !0,
        e)
          , Go = e => (e._isDraft = !1,
        e)
          , Ko = (e, t) => !(!0 === e.disableStyle || Ui(e.disableStyle) && t && e.disableStyle.includes(t))
          , Xo = e => !0 !== e.disableSelect
          , Zo = e => !0 !== e.disableRemove
          , Yo = e => !0 !== e.disableDuplicate && nn(e)
          , Qo = (e, t) => !!Eo(e) && !0 !== e.disableInput && (H(e.disableInput) ? e.disableInput(null != t ? t : e.text) : t || !0)
          , Jo = (e, t) => !(!0 === e.disableTextLayout || Ui(e.disableTextLayout) && t && e.disableTextLayout.includes(t))
          , en = e => tn(e) && e.points.length > 3
          , tn = e => !!zo(e) && void 0 !== e.disableAddPoints && !0 !== e.disableAddPoints
          , on = e => !0 !== e.disableManipulate && !Wo(e) && !jo(e)
          , nn = e => on(e) && !0 !== e.disableMove
          , rn = e => (delete e.left,
        delete e.right,
        delete e.top,
        delete e.bottom,
        e)
          , an = e => (delete e.rotation,
        e)
          , sn = e => (e.strokeWidth = e.strokeWidth || 1,
        e.strokeColor = e.strokeColor || [0, 0, 0],
        e)
          , ln = e => (e.backgroundColor = e.backgroundColor ? e.backgroundColor : e.strokeWidth || e.backgroundImage ? void 0 : [0, 0, 0],
        e)
          , cn = e => {
            let t = e.text;
            t = t.replace(/&(#[0-9]+|[a-z]+);/gi, ( (e, t) => `___${t}___`)),
            t = t.replace(/&/, "&amp;"),
            e.text = t.replace(/___(#[0-9]+|[a-z]+)___/gi, ( (e, t) => `&${t};`))
        }
          , un = e => (!1 !== e.disableNewline && (delete e.textAlign,
        e.text = e.text.replace(/\n/g, " ")),
        rn(e))
          , dn = e => (e.textAlign = e.textAlign || "left",
        e)
          , pn = e => ((e => {
            W(e.id) || (e.id = V()),
            ji(e, "rotation") || (e.rotation = 0),
            ji(e, "opacity") || (e.opacity = 1),
            ji(e, "disableErase") || (e.disableErase = !0)
        }
        )(e),
        Eo(e) ? (e => {
            if (e.fontSize = e.fontSize || "4%",
            e.fontFamily = e.fontFamily || "sans-serif",
            e.fontWeight = e.fontWeight || "normal",
            e.fontStyle = e.fontStyle || "normal",
            e.fontVariant = e.fontVariant || "normal",
            e.lineHeight = e.lineHeight || "120%",
            e.color = e.color || [0, 0, 0],
            e.format = "html" === e.format ? "html" : "text",
            e.textShadow) {
                const [t,i,o,n] = e.textShadow;
                e.textShadowX = t,
                e.textShadowY = i,
                e.textShadowBlur = o,
                e.textShadowColor = n,
                delete e.textShadow
            }
            if (e.textOutline) {
                const [t,i] = e.textOutline;
                e.textOutlineWidth = t,
                e.textOutlineColor = i,
                delete e.textOutline
            }
            "html" === e.format ? cn(e) : (e => {
                cn(e);
                let t = e.text;
                t = t.replace(/</g, "&gt;"),
                t = t.replace(/>/g, "&lt;"),
                e.text = t
            }
            )(e),
            Ro(e) ? un(e) : dn(e)
        }
        )(e) : Io(e) ? (e => {
            e.cornerRadius = e.cornerRadius || 0,
            e.strokeWidth = e.strokeWidth || 0,
            e.strokeColor = e.strokeColor || [0, 0, 0],
            ln(e)
        }
        )(e) : zo(e) ? (e => {
            sn(e),
            an(e),
            ji(e, "pathClose") || (e.disableResize = !0,
            ji(e, "disableMove") || (e.disableMove = !0)),
            rn(e)
        }
        )(e) : Do(e) ? (e => {
            sn(e),
            e.lineStart = e.lineStart || void 0,
            e.lineEnd = e.lineEnd || void 0,
            an(e),
            rn(e)
        }
        )(e) : Lo(e) && (e => {
            e.strokeWidth = e.strokeWidth || 0,
            e.strokeColor = e.strokeColor || [0, 0, 0],
            ln(e)
        }
        )(e),
        e)
          , hn = e => Eo(e) ? "text" : Io(e) ? "rectangle" : zo(e) ? "path" : Do(e) ? "line" : Lo(e) ? "ellipse" : void 0
          , mn = (e, t) => parseFloat(e) / 100 * t
          , fn = new RegExp(/^x|left|right|^width|rx|fontSize|eraseRadius|feather|cornerRadius|strokeWidth|strokeDash/,"i")
          , gn = new RegExp(/^y|top|bottom|^height|ry/,"i")
          , yn = (e, t, {width: i, height: o}) => {
            if (Array.isArray(t))
                return t.map((t => (O(t) && vn(t, {
                    width: i,
                    height: o
                }),
                W(t) && (t = yn(e, t, {
                    width: i,
                    height: o
                })),
                t)));
            if ("string" != typeof t)
                return t;
            if (!t.endsWith("%"))
                return t;
            const n = parseFloat(t) / 100;
            return fn.test(e) ? we(i * n, 6) : gn.test(e) ? we(o * n, 6) : t
        }
          , $n = yn
          , bn = ["lineHeight", "textOutlineWidth", "textShadowX", "textShadowY", "textShadowBlur"]
          , vn = (e, t) => {
            Object.entries(e).map(( ([i,o]) => {
                e[i] = yn(i, o, t)
            }
            )),
            e.text && bn.filter((t => W(e[t]))).forEach((t => {
                var i, o;
                e[t] = (i = e[t],
                o = e.fontSize,
                Math.round(o * (parseFloat(i) / 100)))
            }
            ))
        }
          , xn = (e, t) => (vn(e, t),
        Mn(e, t),
        e)
          , wn = (e, t) => {
            let i;
            return /^x|width|rx|fontSize|strokeWidth|cornerRadius/.test(e) ? i = t.width : /^y|height|ry/.test(e) && (i = t.height),
            i
        }
          , Sn = (e, t, i) => Array.isArray(e[t]) ? e[t].map((e => Object.entries(e).reduce(( (e, [t,o]) => (e[t] = W(o) ? mn(o, wn(t, i)) : o,
        e)), {}))) : W(e[t]) ? mn(e[t], wn(t, i)) : e[t]
          , _n = (e, t, i) => t.reduce(( (t, o) => {
            const n = Sn(e, o, i);
            return t[o] = n,
            t
        }
        ), {})
          , kn = (e, t, i) => (Object.keys(t).forEach((o => ( (e, t, i, o) => {
            if (!W(e[t]))
                return e[t] = i,
                e;
            const n = wn(t, o);
            return e[t] = void 0 === n ? i : Yi(i, n),
            e
        }
        )(e, o, t[o], i))),
        e)
          , Cn = (e, t) => {
            const i = e.filter((e => e.x < 0 || e.y < 0 || e.x1 < 0 || e.y1 < 0)).reduce(( (e, t) => {
                const [i,o,n,r] = (e => {
                    const t = ht()
                      , i = e.strokeWidth || 0;
                    if (Io(e))
                        t.x = e.x - .5 * i,
                        t.y = e.y - .5 * i,
                        t.width = e.width + i,
                        t.height = e.height + i;
                    else if (Do(e)) {
                        const {x1: o, y1: n, x2: r, y2: a} = e
                          , s = Math.abs(Math.min(o, r))
                          , l = Math.abs(Math.max(o, r))
                          , c = Math.abs(Math.min(n, a))
                          , u = Math.abs(Math.min(n, a));
                        t.x = s + .5 * i,
                        t.y = l + .5 * i,
                        t.width = l - s + i,
                        t.height = u - c + i
                    } else
                        Lo(e) && (t.x = e.x - e.rx + .5 * i,
                        t.y = e.y - e.ry + .5 * i,
                        t.width = 2 * e.rx + i,
                        t.height = 2 * e.ry + i);
                    return t && ji(e, "rotation") && Et(t, e.rotation),
                    Dt(t)
                }
                )(t);
                return e.top = Math.min(i, e.top),
                e.left = Math.min(r, e.left),
                e.bottom = Math.max(n, e.bottom),
                e.right = Math.max(o, e.right),
                e
            }
            ), {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            });
            return i.right > 0 && (i.right -= t.width),
            i.bottom > 0 && (i.bottom -= t.height),
            i
        }
          , Tn = (e, t, i) => {
            const o = So(e);
            xn(o, t);
            const n = i(o);
            return Array.isArray(n) ? n : [n]
        }
          , Mn = (e, t) => {
            if (ji(e, "left") && (e.x = e.left),
            ji(e, "right") && !W(e.right)) {
                const i = t.width - e.right;
                ji(e, "left") ? (e.x = e.left,
                e.width = Math.max(0, i - e.left)) : ji(e, "width") && (e.x = i - e.width)
            }
            if (ji(e, "top") && (e.y = e.top),
            ji(e, "bottom") && !W(e.bottom)) {
                const i = t.height - e.bottom;
                ji(e, "top") ? (e.y = e.top,
                e.height = Math.max(0, i - e.top)) : ji(e, "height") && (e.y = i - e.height)
            }
            return e
        }
          , Pn = (e, t) => (zo(e) && e.points.filter((e => Wi(e.x))).forEach((e => {
            e.x *= t,
            e.y *= t
        }
        )),
        Do(e) && Wi(e.x1) && (e.x1 *= t,
        e.y1 *= t,
        e.x2 *= t,
        e.y2 *= t),
        Wi(e.x) && Wi(e.y) && (e.x *= t,
        e.y *= t),
        Wi(e.width) && Wi(e.height) && (e.width *= t,
        e.height *= t),
        Wi(e.rx) && Wi(e.ry) && (e.rx *= t,
        e.ry *= t),
        (e => Wi(e.strokeWidth) && e.strokeWidth > 0)(e) && (e.strokeWidth *= t),
        Eo(e) && (e._scale = t,
        Wi(e.fontSize) && (e.fontSize *= t),
        Wi(e.lineHeight) && (e.lineHeight *= t),
        Wi(e.width) && !Wi(e.height) && (e.width *= t)),
        ji(e, "cornerRadius") && Wi(e.cornerRadius) && (e.cornerRadius *= t),
        e)
          , En = e => {
            if (Io(e))
                return Ce(e.x + .5 * e.width, e.y + .5 * e.height);
            if (Lo(e))
                return Ce(e.x, e.y);
            if (e.text) {
                if (Ao(e)) {
                    const t = e.height || ho(e.text, e).height;
                    return Ce(e.x + .5 * e.width, e.y + .5 * t)
                }
                const t = ho(e.text, e);
                return Ce(e.x + .5 * t.width, e.y + .5 * t.height)
            }
            return zo(e) ? Ve(e.points) : Do(e) ? Ve([Mo(e), Po(e)]) : void 0
        }
        ;
        var Rn = e => /canvas/i.test(e.nodeName);
        const An = new Map([])
          , In = (e, t={}) => new Promise(( (i, o) => {
            const {onMetadata: n=$, onLoad: r=i, onError: a=o, onComplete: s=$} = t;
            let l = An.get(e);
            if (l || (l = {
                loading: !1,
                complete: !1,
                error: !1,
                image: void 0,
                size: void 0,
                bus: oo()
            },
            An.set(e, l)),
            l.bus.sub("meta", n),
            l.bus.sub("load", r),
            l.bus.sub("error", a),
            l.bus.sub("complete", s),
            Rn(e)) {
                const t = e
                  , i = t.cloneNode();
                l.complete = !0,
                l.image = i,
                l.size = Je(t)
            }
            if (l.complete)
                return l.bus.pub("meta", {
                    size: l.size
                }),
                l.error ? l.bus.pub("error", l.error) : l.bus.pub("load", l.image),
                l.bus.pub("complete"),
                void (l.bus = oo());
            var c, u;
            l.loading || (l.loading = !0,
            (c = e,
            u = e => {
                l.size = e,
                l.bus.pub("meta", {
                    size: e
                })
            }
            ,
            new Promise(( (e, t) => {
                let i = c
                  , o = !1;
                const n = () => {
                    o || (o = !0,
                    H(u) && Promise.resolve().then(( () => u(et(i.naturalWidth, i.naturalHeight)))))
                }
                ;
                if (i.src || (i = new Image,
                W(c) && new URL(c,location.href).origin !== location.origin && (i.crossOrigin = "anonymous"),
                i.src = W(c) ? c : URL.createObjectURL(c)),
                i.complete)
                    return n(),
                    e(i);
                H(u) && li(i).then(n).catch(t),
                i.onload = () => {
                    n(),
                    e(i)
                }
                ,
                i.onerror = () => t(new Error("Failed to load image"))
            }
            ))).then((e => {
                l.image = e,
                l.bus.pub("load", e)
            }
            )).catch((e => {
                l.error = e,
                l.bus.pub("error", e)
            }
            )).finally(( () => {
                l.complete = !0,
                l.loading = !1,
                l.bus.pub("complete"),
                l.bus = oo()
            }
            )))
        }
        ))
          , Ln = (e, t, i, o) => e.drawImage(t, i.x, i.x, i.width, i.height, o.x, o.y, o.width, o.height);
        var Dn = async (e, t, i, o, n=Ln, r) => {
            e.save(),
            e.clip(),
            await n(e, t, i, o, r),
            e.restore()
        }
        ;
        const zn = (e, t, i, o, n) => {
            const r = pt(e);
            if (o) {
                const e = Ft(gt(o), we);
                return e.x *= i.width,
                e.width *= i.width,
                e.y *= i.height,
                e.height *= i.height,
                {
                    srcRect: e,
                    destRect: r
                }
            }
            const a = bt(0, 0, i.width, i.height);
            if ("contain" === t) {
                const t = Lt(e, Tt(a));
                r.width = t.width,
                r.height = t.height,
                n ? (r.x += n.x,
                r.y += n.y) : (r.x += t.x,
                r.y += t.y)
            } else if ("cover" === t) {
                const e = It(r, a.width / a.height);
                r.width = e.width,
                r.height = e.height,
                n ? (r.x += n.x,
                r.y += n.y) : (r.x += e.x,
                r.y += e.y)
            } else
                t ? (r.width = t.width,
                r.height = t.height,
                n && (r.x += n.x,
                r.y += n.y)) : n && (r.width = i.width,
                r.height = i.height,
                r.x += n.x,
                r.y += n.y);
            return {
                srcRect: a,
                destRect: r
            }
        }
          , Fn = (e, t) => (t.cornerRadius > 0 ? ( (e, t, i, o, n, r) => {
            o < 2 * r && (r = o / 2),
            n < 2 * r && (r = n / 2),
            e.beginPath(),
            e.moveTo(t + r, i),
            e.arcTo(t + o, i, t + o, i + n, r),
            e.arcTo(t + o, i + n, t, i + n, r),
            e.arcTo(t, i + n, t, i, r),
            e.arcTo(t, i, t + o, i, r),
            e.closePath()
        }
        )(e, t.x, t.y, t.width, t.height, t.cornerRadius) : e.rect(t.x, t.y, t.width, t.height),
        e)
          , On = (e, t) => (t.backgroundColor && e.fill(),
        e)
          , Bn = (e, t) => (t.strokeWidth && e.stroke(),
        e);
        var Nn = async (e, t, i={}) => {
            const {drawImage: o} = i;
            if (e.lineWidth = t.strokeWidth ? t.strokeWidth : 1,
            e.strokeStyle = t.strokeColor ? Qi(t.strokeColor) : "none",
            e.fillStyle = t.backgroundColor ? Qi(t.backgroundColor) : "none",
            e.globalAlpha = t.opacity,
            t.backgroundImage) {
                let i;
                if (i = Rn(t.backgroundImage) ? t.backgroundImage : await In(t.backgroundImage),
                Fn(e, t),
                On(e, t),
                "repeat" === t.backgroundRepeat) {
                    const n = t.backgroundPosition || {
                        x: 0,
                        y: 0
                    }
                      , {srcRect: r, destRect: a} = zn(t, t.backgroundSize || Je(i), Je(i), t.backgroundCorners, {
                        x: 0,
                        y: 0
                    })
                      , s = document.createElement("canvas");
                    s.width = a.width,
                    s.height = a.height;
                    const l = s.getContext("2d", {
                        willReadFrequently: !1,
                        desynchronized: !0
                    });
                    await o(l, i, r, {
                        ...a,
                        x: 0,
                        y: 0
                    });
                    const c = e.createPattern(s, "repeat");
                    e.fillStyle = c,
                    e.save(),
                    e.beginPath(),
                    e.rect(t.x + n.x, t.y + n.y, t.width - n.x, t.height - n.y),
                    e.clip(),
                    e.translate(a.x + n.x, a.y + n.y),
                    e.fill(),
                    E(s),
                    e.restore()
                } else {
                    const {srcRect: n, destRect: r} = zn(t, t.backgroundSize, Je(i), t.backgroundCorners, t.backgroundPosition);
                    await Dn(e, i, n, r, o, {
                        feather: t.feather
                    })
                }
                return e.beginPath(),
                Fn(e, t),
                Bn(e, t),
                []
            }
            return Fn(e, t),
            On(e, t),
            Bn(e, t),
            []
        }
          , Wn = async (e, t, i={}) => new Promise((async (o, n) => {
            const {drawImage: r} = i;
            if (e.lineWidth = t.strokeWidth || 1,
            e.strokeStyle = t.strokeColor ? Qi(t.strokeColor) : "none",
            e.fillStyle = t.backgroundColor ? Qi(t.backgroundColor) : "none",
            e.globalAlpha = t.opacity,
            e.ellipse(t.x, t.y, t.rx, t.ry, 0, 0, 2 * Math.PI),
            t.backgroundColor && e.fill(),
            t.backgroundImage) {
                let i;
                try {
                    i = await In(t.backgroundImage)
                } catch (e) {
                    n(e)
                }
                const a = bt(t.x - t.rx, t.y - t.ry, 2 * t.rx, 2 * t.ry)
                  , {srcRect: s, destRect: l} = zn(a, t.backgroundSize, Je(i), t.backgroundCorners, t.backgroundPosition);
                await Dn(e, i, s, l, r),
                t.strokeWidth && e.stroke(),
                o([])
            } else
                t.strokeWidth && e.stroke(),
                o([])
        }
        ))
          , Hn = async (e, t, i) => {
            const o = t.width && t.height ? Ze(t) : ho(t.text, t)
              , n = {
                x: t.x,
                y: t.y,
                width: o.width,
                height: o.height
            };
            if (Nn(e, {
                ...t,
                ...n,
                options: i
            }),
            !t.text.length)
                return [];
            const {textOutlineWidth: r=0, textShadowX: a=0, textShadowY: s=0, textShadowBlur: l=0, textShadowColor: c, outline: u, blur: d, ...p} = t
              , h = !!t.height;
            if (h && (e.rect(n.x, n.y, n.width, n.height),
            e.save(),
            e.clip()),
            a || s || l) {
                e.save(),
                e.translate(a, s);
                const o = {
                    ...n
                };
                h || (o.height += no + l),
                await jn(e, o, t, {
                    ...i,
                    paddingLeft: no + l,
                    paddingRight: no + l,
                    paddingTop: l,
                    paddingBottom: l + (h ? -1 * s : t.fontSize),
                    shapeExtendedProps: {
                        color: c,
                        blur: l
                    }
                }),
                e.restore()
            }
            if (r) {
                const o = {
                    ...n
                };
                h || (o.height += no + r),
                await jn(e, o, t, {
                    ...i,
                    paddingLeft: no + r,
                    paddingRight: no + r,
                    paddingTop: r,
                    paddingBottom: r + h ? 0 : t.fontSize,
                    shapeExtendedProps: {
                        color: t.textOutlineColor,
                        outline: r
                    }
                })
            }
            return h && e.restore(),
            await jn(e, n, p, {
                ...i,
                paddingLeft: no,
                paddingRight: no,
                paddingTop: 0,
                paddingBottom: h ? 0 : t.fontSize
            }),
            []
        }
        ;
        const jn = async (e, t, i, o) => {
            const {willRequest: n, shapeExtendedProps: r, paddingLeft: a, paddingRight: s, paddingTop: l, paddingBottom: c, styleNonce: u} = o
              , d = await wo(i.text, {
                ...i,
                ...r,
                ...t,
                paddingLeft: a,
                paddingRight: s,
                paddingTop: l,
                paddingBottom: c,
                imageWidth: t.width,
                imageHeight: t.height,
                willRequest: n,
                styleNonce: u
            });
            e.drawImage(d, i.x - a, i.y - l, d.width, d.height)
        }
        ;
        var Un = async (e, t) => new Promise((async i => {
            e.lineWidth = t.strokeWidth || 1,
            e.strokeStyle = t.strokeColor ? Qi(t.strokeColor) : "none",
            e.globalAlpha = t.opacity,
            t.bitmap && (e.lineCap = t.strokeCap,
            e.lineJoin = t.strokeJoin,
            e.setLineDash(t.strokeDash || []));
            let o = Mo(t)
              , n = Po(t);
            e.moveTo(o.x, o.y),
            e.lineTo(n.x, n.y),
            t.strokeWidth && e.stroke(),
            i([])
        }
        ))
          , Vn = async (e, t) => new Promise(( (i, o) => {
            if (t.bitmap && 1 === t.points.length)
                return void Wn(e, {
                    x: t.points[0].x,
                    y: t.points[0].y,
                    rx: .5 * t.strokeWidth,
                    ry: .5 * t.strokeWidth,
                    backgroundColor: t.strokeColor
                }).then(( () => i([])));
            e.lineWidth = t.strokeWidth || 1,
            e.strokeStyle = t.strokeColor ? Qi(t.strokeColor) : "none",
            e.fillStyle = t.backgroundColor ? Qi(t.backgroundColor) : "none",
            e.globalAlpha = t.opacity;
            const {points: n} = t;
            t.bitmap && (e.lineCap = t.strokeCap,
            e.lineJoin = t.strokeJoin,
            e.setLineDash(t.strokeDash || [])),
            t.pathClose && e.beginPath(),
            e.moveTo(n[0].x, n[0].y);
            const r = n.length;
            for (let t = 1; t < r; t++)
                e.lineTo(n[t].x, n[t].y);
            t.pathClose && e.closePath(),
            t.strokeWidth && e.stroke(),
            t.backgroundColor && e.fill(),
            i([])
        }
        ))
          , qn = (e, t, i, o) => t || i ? (e.translate(o.x, o.y),
        e.scale(t ? -1 : 1, i ? -1 : 1),
        e.translate(-o.x, -o.y),
        e) : e;
        const Gn = async (e, t, i) => {
            e.globalCompositeOperation = "subtract" === t.drawMode ? "destination-out" : "source-over";
            const o = En(t);
            let n;
            if (Pi(e, t.rotation, o),
            qn(e, t.flipX, t.flipY, o),
            Io(t) ? n = Nn : Lo(t) ? n = Wn : Do(t) ? n = Un : zo(t) ? n = Vn : Eo(t) && (n = Hn),
            n) {
                const o = await n(e, t, i);
                return o.length ? [t, ...await Kn(e, o, i)] : []
            }
            return []
        }
        ;
        var Kn = async (e, t, i) => {
            let o = [];
            for (const n of t)
                e.save(),
                e.beginPath(),
                o = [...o, ...await Gn(e, n, i)],
                e.restore();
            return o
        }
          , Xn = async (e, t={}) => {
            const {shapes: i=[], contextBounds: o=e, transform: n=$, drawImage: r, willRequest: a, styleNonce: s, canvasMemoryLimit: l, computeShape: c=se, preprocessShape: u=se} = t;
            if (!i.length)
                return e;
            const d = M("canvas");
            d.width = o.width,
            d.height = o.height;
            const p = d.getContext("2d", {
                willReadFrequently: !0
            });
            p.putImageData(e, o.x || 0, o.y || 0);
            const h = i.map(So).map(c).map(u).flat();
            n(p),
            await Kn(p, h, {
                drawImage: r,
                canvasMemoryLimit: l,
                willRequest: a,
                styleNonce: s
            });
            const m = p.getImageData(0, 0, d.width, d.height);
            return E(d),
            m
        }
          , Zn = async (e, t={}) => {
            const {backgroundColor: i, backgroundImage: o} = t
              , n = !(!i || i && 0 === i[3]);
            if (!o && !n)
                return e;
            const r = M("canvas");
            r.width = e.width,
            r.height = e.height;
            const a = r.getContext("2d", {
                willReadFrequently: !0
            });
            if (a.putImageData(e, 0, 0),
            a.globalCompositeOperation = "destination-over",
            n && (a.fillStyle = Qi(i),
            a.fillRect(0, 0, r.width, r.height)),
            o) {
                let t;
                t = Rn(o) ? o : await In(o);
                const {srcRect: i, destRect: n} = zn({
                    x: 0,
                    y: 0,
                    width: e.width,
                    height: e.height
                }, "cover", {
                    width: t.width,
                    height: t.height
                });
                a.drawImage(t, i.x, i.y, i.width, i.height, n.x, n.y, n.width, n.height)
            }
            const s = a.getImageData(0, 0, r.width, r.height);
            return E(r),
            s
        }
          , Yn = e => e.length ? e.reduce(( (e, t) => ( (e, t) => {
            const i = new Array(20);
            return i[0] = e[0] * t[0] + e[1] * t[5] + e[2] * t[10] + e[3] * t[15],
            i[1] = e[0] * t[1] + e[1] * t[6] + e[2] * t[11] + e[3] * t[16],
            i[2] = e[0] * t[2] + e[1] * t[7] + e[2] * t[12] + e[3] * t[17],
            i[3] = e[0] * t[3] + e[1] * t[8] + e[2] * t[13] + e[3] * t[18],
            i[4] = e[0] * t[4] + e[1] * t[9] + e[2] * t[14] + e[3] * t[19] + e[4],
            i[5] = e[5] * t[0] + e[6] * t[5] + e[7] * t[10] + e[8] * t[15],
            i[6] = e[5] * t[1] + e[6] * t[6] + e[7] * t[11] + e[8] * t[16],
            i[7] = e[5] * t[2] + e[6] * t[7] + e[7] * t[12] + e[8] * t[17],
            i[8] = e[5] * t[3] + e[6] * t[8] + e[7] * t[13] + e[8] * t[18],
            i[9] = e[5] * t[4] + e[6] * t[9] + e[7] * t[14] + e[8] * t[19] + e[9],
            i[10] = e[10] * t[0] + e[11] * t[5] + e[12] * t[10] + e[13] * t[15],
            i[11] = e[10] * t[1] + e[11] * t[6] + e[12] * t[11] + e[13] * t[16],
            i[12] = e[10] * t[2] + e[11] * t[7] + e[12] * t[12] + e[13] * t[17],
            i[13] = e[10] * t[3] + e[11] * t[8] + e[12] * t[13] + e[13] * t[18],
            i[14] = e[10] * t[4] + e[11] * t[9] + e[12] * t[14] + e[13] * t[19] + e[14],
            i[15] = e[15] * t[0] + e[16] * t[5] + e[17] * t[10] + e[18] * t[15],
            i[16] = e[15] * t[1] + e[16] * t[6] + e[17] * t[11] + e[18] * t[16],
            i[17] = e[15] * t[2] + e[16] * t[7] + e[17] * t[12] + e[18] * t[17],
            i[18] = e[15] * t[3] + e[16] * t[8] + e[17] * t[13] + e[18] * t[18],
            i[19] = e[15] * t[4] + e[16] * t[9] + e[17] * t[14] + e[18] * t[19] + e[19],
            i
        }
        )([...e], t)), e.shift()) : []
          , Qn = (e, t) => {
            const i = e.width * e.height
              , o = t.reduce(( (e, t) => (t.width > e.width && t.height > e.height && (e.width = t.width,
            e.height = t.height),
            e)), {
                width: 0,
                height: 0
            })
              , n = o.width * o.height;
            return ( (e, t=2) => Math.round(e * t) / t)(Math.max(.5, .5 + (1 - n / i) / 2), 5)
        }
        ;
        function Jn() {}
        const er = e => e;
        function tr(e, t) {
            for (const i in t)
                e[i] = t[i];
            return e
        }
        function ir(e) {
            return e()
        }
        function or() {
            return Object.create(null)
        }
        function nr(e) {
            e.forEach(ir)
        }
        function rr(e) {
            return "function" == typeof e
        }
        function ar(e, t) {
            return e != e ? t == t : e !== t || e && "object" == typeof e || "function" == typeof e
        }
        function sr(e, ...t) {
            if (null == e)
                return Jn;
            const i = e.subscribe(...t);
            return i.unsubscribe ? () => i.unsubscribe() : i
        }
        function lr(e) {
            let t;
            return sr(e, (e => t = e))(),
            t
        }
        function cr(e, t, i) {
            e.$$.on_destroy.push(sr(t, i))
        }
        function ur(e, t, i, o) {
            if (e) {
                const n = dr(e, t, i, o);
                return e[0](n)
            }
        }
        function dr(e, t, i, o) {
            return e[1] && o ? tr(i.ctx.slice(), e[1](o(t))) : i.ctx
        }
        function pr(e, t, i, o) {
            if (e[2] && o) {
                const n = e[2](o(i));
                if (void 0 === t.dirty)
                    return n;
                if ("object" == typeof n) {
                    const e = []
                      , i = Math.max(t.dirty.length, n.length);
                    for (let o = 0; o < i; o += 1)
                        e[o] = t.dirty[o] | n[o];
                    return e
                }
                return t.dirty | n
            }
            return t.dirty
        }
        function hr(e, t, i, o, n, r) {
            if (n) {
                const a = dr(t, i, o, r);
                e.p(a, n)
            }
        }
        function mr(e) {
            if (e.ctx.length > 32) {
                const t = []
                  , i = e.ctx.length / 32;
                for (let e = 0; e < i; e++)
                    t[e] = -1;
                return t
            }
            return -1
        }
        function fr(e) {
            const t = {};
            for (const i in e)
                "$" !== i[0] && (t[i] = e[i]);
            return t
        }
        function gr(e, t) {
            const i = {};
            t = new Set(t);
            for (const o in e)
                t.has(o) || "$" === o[0] || (i[o] = e[o]);
            return i
        }
        function yr(e, t, i) {
            return e.set(i),
            t
        }
        function $r(e) {
            return e && rr(e.destroy) ? e.destroy : Jn
        }
        const br = "undefined" != typeof window;
        let vr = br ? () => window.performance.now() : () => Date.now()
          , xr = br ? e => requestAnimationFrame(e) : Jn;
        const wr = new Set;
        function Sr(e) {
            wr.forEach((t => {
                t.c(e) || (wr.delete(t),
                t.f())
            }
            )),
            0 !== wr.size && xr(Sr)
        }
        function _r(e) {
            let t;
            return 0 === wr.size && xr(Sr),
            {
                promise: new Promise((i => {
                    wr.add(t = {
                        c: e,
                        f: i
                    })
                }
                )),
                abort() {
                    wr.delete(t)
                }
            }
        }
        function kr(e, t) {
            e.appendChild(t)
        }
        function Cr(e) {
            if (!e)
                return document;
            const t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
            return t && t.host ? t : e.ownerDocument
        }
        function Tr(e) {
            const t = Er("style");
            return function(e, t) {
                kr(e.head || e, t),
                t.sheet
            }(Cr(e), t),
            t.sheet
        }
        function Mr(e, t, i) {
            e.insertBefore(t, i || null)
        }
        function Pr(e) {
            e.parentNode.removeChild(e)
        }
        function Er(e) {
            return document.createElement(e)
        }
        function Rr(e) {
            return document.createElementNS("http://www.w3.org/2000/svg", e)
        }
        function Ar(e) {
            return document.createTextNode(e)
        }
        function Ir() {
            return Ar(" ")
        }
        function Lr() {
            return Ar("")
        }
        function Dr(e, t, i, o) {
            return e.addEventListener(t, i, o),
            () => e.removeEventListener(t, i, o)
        }
        function zr(e) {
            return function(t) {
                return t.preventDefault(),
                e.call(this, t)
            }
        }
        function Fr(e) {
            return function(t) {
                return t.stopPropagation(),
                e.call(this, t)
            }
        }
        function Or(e, t, i) {
            null == i ? e.removeAttribute(t) : e.getAttribute(t) !== i && e.setAttribute(t, i)
        }
        function Br(e, t) {
            const i = Object.getOwnPropertyDescriptors(e.__proto__);
            for (const o in t)
                null == t[o] ? e.removeAttribute(o) : "style" === o ? e.style.cssText = t[o] : "__value" === o ? e.value = e[o] = t[o] : i[o] && i[o].set ? e[o] = t[o] : Or(e, o, t[o])
        }
        function Nr(e, t) {
            Object.keys(t).forEach((i => {
                !function(e, t, i) {
                    t in e ? e[t] = "boolean" == typeof e[t] && "" === i || i : Or(e, t, i)
                }(e, i, t[i])
            }
            ))
        }
        function Wr(e, t) {
            t = "" + t,
            e.wholeText !== t && (e.data = t)
        }
        function Hr(e, t) {
            e.value = null == t ? "" : t
        }
        function jr(e, t, {bubbles: i=!1, cancelable: o=!1}={}) {
            const n = document.createEvent("CustomEvent");
            return n.initCustomEvent(e, i, o, t),
            n
        }
        class Ur {
            constructor(e=!1) {
                this.is_svg = !1,
                this.is_svg = e,
                this.e = this.n = null
            }
            c(e) {
                this.h(e)
            }
            m(e, t, i=null) {
                this.e || (this.is_svg ? this.e = Rr(t.nodeName) : this.e = Er(t.nodeName),
                this.t = t,
                this.c(e)),
                this.i(i)
            }
            h(e) {
                this.e.innerHTML = e,
                this.n = Array.from(this.e.childNodes)
            }
            i(e) {
                for (let t = 0; t < this.n.length; t += 1)
                    Mr(this.t, this.n[t], e)
            }
            p(e) {
                this.d(),
                this.h(e),
                this.i(this.a)
            }
            d() {
                this.n.forEach(Pr)
            }
        }
        function Vr(e, t) {
            return new e(t)
        }
        const qr = new Map;
        let Gr, Kr = 0;
        function Xr(e, t, i, o, n, r, a, s=0) {
            const l = 16.666 / o;
            let c = "{\n";
            for (let e = 0; e <= 1; e += l) {
                const o = t + (i - t) * r(e);
                c += 100 * e + `%{${a(o, 1 - o)}}\n`
            }
            const u = c + `100% {${a(i, 1 - i)}}\n}`
              , d = `__svelte_${function(e) {
                let t = 5381
                  , i = e.length;
                for (; i--; )
                    t = (t << 5) - t ^ e.charCodeAt(i);
                return t >>> 0
            }(u)}_${s}`
              , p = Cr(e)
              , {stylesheet: h, rules: m} = qr.get(p) || function(e, t) {
                const i = {
                    stylesheet: Tr(t),
                    rules: {}
                };
                return qr.set(e, i),
                i
            }(p, e);
            m[d] || (m[d] = !0,
            h.insertRule(`@keyframes ${d} ${u}`, h.cssRules.length));
            const f = e.style.animation || "";
            return e.style.animation = `${f ? `${f}, ` : ""}${d} ${o}ms linear ${n}ms 1 both`,
            Kr += 1,
            d
        }
        function Zr(e) {
            Gr = e
        }
        function Yr() {
            if (!Gr)
                throw new Error("Function called outside component initialization");
            return Gr
        }
        function Qr(e) {
            Yr().$$.on_mount.push(e)
        }
        function Jr(e) {
            Yr().$$.after_update.push(e)
        }
        function ea(e) {
            Yr().$$.on_destroy.push(e)
        }
        function ta() {
            const e = Yr();
            return (t, i, {cancelable: o=!1}={}) => {
                const n = e.$$.callbacks[t];
                if (n) {
                    const r = jr(t, i, {
                        cancelable: o
                    });
                    return n.slice().forEach((t => {
                        t.call(e, r)
                    }
                    )),
                    !r.defaultPrevented
                }
                return !0
            }
        }
        function ia(e, t) {
            return Yr().$$.context.set(e, t),
            t
        }
        function oa(e) {
            return Yr().$$.context.get(e)
        }
        function na(e, t) {
            const i = e.$$.callbacks[t.type];
            i && i.slice().forEach((e => e.call(this, t)))
        }
        const ra = []
          , aa = []
          , sa = []
          , la = []
          , ca = Promise.resolve();
        let ua = !1;
        function da() {
            ua || (ua = !0,
            ca.then($a))
        }
        function pa() {
            return da(),
            ca
        }
        function ha(e) {
            sa.push(e)
        }
        function ma(e) {
            la.push(e)
        }
        const fa = new Set;
        let ga, ya = 0;
        function $a() {
            const e = Gr;
            do {
                for (; ya < ra.length; ) {
                    const e = ra[ya];
                    ya++,
                    Zr(e),
                    ba(e.$$)
                }
                for (Zr(null),
                ra.length = 0,
                ya = 0; aa.length; )
                    aa.pop()();
                for (let e = 0; e < sa.length; e += 1) {
                    const t = sa[e];
                    fa.has(t) || (fa.add(t),
                    t())
                }
                sa.length = 0
            } while (ra.length);
            for (; la.length; )
                la.pop()();
            ua = !1,
            fa.clear(),
            Zr(e)
        }
        function ba(e) {
            if (null !== e.fragment) {
                e.update(),
                nr(e.before_update);
                const t = e.dirty;
                e.dirty = [-1],
                e.fragment && e.fragment.p(e.ctx, t),
                e.after_update.forEach(ha)
            }
        }
        function va(e, t, i) {
            e.dispatchEvent(jr(`${t ? "intro" : "outro"}${i}`))
        }
        const xa = new Set;
        let wa;
        function Sa() {
            wa = {
                r: 0,
                c: [],
                p: wa
            }
        }
        function _a() {
            wa.r || nr(wa.c),
            wa = wa.p
        }
        function ka(e, t) {
            e && e.i && (xa.delete(e),
            e.i(t))
        }
        function Ca(e, t, i, o) {
            if (e && e.o) {
                if (xa.has(e))
                    return;
                xa.add(e),
                wa.c.push(( () => {
                    xa.delete(e),
                    o && (i && e.d(1),
                    o())
                }
                )),
                e.o(t)
            } else
                o && o()
        }
        const Ta = {
            duration: 0
        };
        function Ma(e, t, i, o) {
            let n = t(e, i)
              , r = o ? 0 : 1
              , a = null
              , s = null
              , l = null;
            function c() {
                l && function(e, t) {
                    const i = (e.style.animation || "").split(", ")
                      , o = i.filter(t ? e => e.indexOf(t) < 0 : e => -1 === e.indexOf("__svelte"))
                      , n = i.length - o.length;
                    n && (e.style.animation = o.join(", "),
                    Kr -= n,
                    Kr || xr(( () => {
                        Kr || (qr.forEach((e => {
                            const {ownerNode: t} = e.stylesheet;
                            t && Pr(t)
                        }
                        )),
                        qr.clear())
                    }
                    )))
                }(e, l)
            }
            function u(e, t) {
                const i = e.b - r;
                return t *= Math.abs(i),
                {
                    a: r,
                    b: e.b,
                    d: i,
                    duration: t,
                    start: e.start,
                    end: e.start + t,
                    group: e.group
                }
            }
            function d(t) {
                const {delay: i=0, duration: o=300, easing: d=er, tick: p=Jn, css: h} = n || Ta
                  , m = {
                    start: vr() + i,
                    b: t
                };
                t || (m.group = wa,
                wa.r += 1),
                a || s ? s = m : (h && (c(),
                l = Xr(e, r, t, o, i, d, h)),
                t && p(0, 1),
                a = u(m, o),
                ha(( () => va(e, t, "start"))),
                _r((t => {
                    if (s && t > s.start && (a = u(s, o),
                    s = null,
                    va(e, a.b, "start"),
                    h && (c(),
                    l = Xr(e, r, a.b, a.duration, 0, d, n.css))),
                    a)
                        if (t >= a.end)
                            p(r = a.b, 1 - r),
                            va(e, a.b, "end"),
                            s || (a.b ? c() : --a.group.r || nr(a.group.c)),
                            a = null;
                        else if (t >= a.start) {
                            const e = t - a.start;
                            r = a.a + a.d * d(e / a.duration),
                            p(r, 1 - r)
                        }
                    return !(!a && !s)
                }
                )))
            }
            return {
                run(e) {
                    rr(n) ? (ga || (ga = Promise.resolve(),
                    ga.then(( () => {
                        ga = null
                    }
                    ))),
                    ga).then(( () => {
                        n = n(),
                        d(e)
                    }
                    )) : d(e)
                },
                end() {
                    c(),
                    a = s = null
                }
            }
        }
        const Pa = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;
        function Ea(e, t) {
            e.d(1),
            t.delete(e.key)
        }
        function Ra(e, t) {
            Ca(e, 1, 1, ( () => {
                t.delete(e.key)
            }
            ))
        }
        function Aa(e, t, i, o, n, r, a, s, l, c, u, d) {
            let p = e.length
              , h = r.length
              , m = p;
            const f = {};
            for (; m--; )
                f[e[m].key] = m;
            const g = []
              , y = new Map
              , $ = new Map;
            for (m = h; m--; ) {
                const e = d(n, r, m)
                  , s = i(e);
                let l = a.get(s);
                l ? o && l.p(e, t) : (l = c(s, e),
                l.c()),
                y.set(s, g[m] = l),
                s in f && $.set(s, Math.abs(m - f[s]))
            }
            const b = new Set
              , v = new Set;
            function x(e) {
                ka(e, 1),
                e.m(s, u),
                a.set(e.key, e),
                u = e.first,
                h--
            }
            for (; p && h; ) {
                const t = g[h - 1]
                  , i = e[p - 1]
                  , o = t.key
                  , n = i.key;
                t === i ? (u = t.first,
                p--,
                h--) : y.has(n) ? !a.has(o) || b.has(o) ? x(t) : v.has(n) ? p-- : $.get(o) > $.get(n) ? (v.add(o),
                x(t)) : (b.add(n),
                p--) : (l(i, a),
                p--)
            }
            for (; p--; ) {
                const t = e[p];
                y.has(t.key) || l(t, a)
            }
            for (; h; )
                x(g[h - 1]);
            return g
        }
        function Ia(e, t) {
            const i = {}
              , o = {}
              , n = {
                $$scope: 1
            };
            let r = e.length;
            for (; r--; ) {
                const a = e[r]
                  , s = t[r];
                if (s) {
                    for (const e in a)
                        e in s || (o[e] = 1);
                    for (const e in s)
                        n[e] || (i[e] = s[e],
                        n[e] = 1);
                    e[r] = s
                } else
                    for (const e in a)
                        n[e] = 1
            }
            for (const e in o)
                e in i || (i[e] = void 0);
            return i
        }
        function La(e) {
            return "object" == typeof e && null !== e ? e : {}
        }
        function Da(e, t, i) {
            const o = e.$$.props[t];
            void 0 !== o && (e.$$.bound[o] = i,
            i(e.$$.ctx[o]))
        }
        function za(e) {
            e && e.c()
        }
        function Fa(e, t, i, o) {
            const {fragment: n, after_update: r} = e.$$;
            n && n.m(t, i),
            o || ha(( () => {
                const t = e.$$.on_mount.map(ir).filter(rr);
                e.$$.on_destroy ? e.$$.on_destroy.push(...t) : nr(t),
                e.$$.on_mount = []
            }
            )),
            r.forEach(ha)
        }
        function Oa(e, t) {
            const i = e.$$;
            null !== i.fragment && (nr(i.on_destroy),
            i.fragment && i.fragment.d(t),
            i.on_destroy = i.fragment = null,
            i.ctx = [])
        }
        function Ba(e, t, i, o, n, r, a, s=[-1]) {
            const l = Gr;
            Zr(e);
            const c = e.$$ = {
                fragment: null,
                ctx: [],
                props: r,
                update: Jn,
                not_equal: n,
                bound: or(),
                on_mount: [],
                on_destroy: [],
                on_disconnect: [],
                before_update: [],
                after_update: [],
                context: new Map(t.context || (l ? l.$$.context : [])),
                callbacks: or(),
                dirty: s,
                skip_bound: !1,
                root: t.target || l.$$.root
            };
            a && a(c.root);
            let u = !1;
            if (c.ctx = i ? i(e, t.props || {}, ( (t, i, ...o) => {
                const r = o.length ? o[0] : i;
                return c.ctx && n(c.ctx[t], c.ctx[t] = r) && (!c.skip_bound && c.bound[t] && c.bound[t](r),
                u && function(e, t) {
                    -1 === e.$$.dirty[0] && (ra.push(e),
                    da(),
                    e.$$.dirty.fill(0)),
                    e.$$.dirty[t / 31 | 0] |= 1 << t % 31
                }(e, t)),
                i
            }
            )) : [],
            c.update(),
            u = !0,
            nr(c.before_update),
            c.fragment = !!o && o(c.ctx),
            t.target) {
                if (t.hydrate) {
                    const e = (d = t.target,
                    Array.from(d.childNodes));
                    c.fragment && c.fragment.l(e),
                    e.forEach(Pr)
                } else
                    c.fragment && c.fragment.c();
                t.intro && ka(e.$$.fragment),
                Fa(e, t.target, t.anchor, t.customElement),
                $a()
            }
            var d;
            Zr(l)
        }
        class Na {
            $destroy() {
                Oa(this, 1),
                this.$destroy = Jn
            }
            $on(e, t) {
                if (!rr(t))
                    return Jn;
                const i = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
                return i.push(t),
                () => {
                    const e = i.indexOf(t);
                    -1 !== e && i.splice(e, 1)
                }
            }
            $set(e) {
                var t;
                this.$$set && (t = e,
                0 !== Object.keys(t).length) && (this.$$.skip_bound = !0,
                this.$$set(e),
                this.$$.skip_bound = !1)
            }
        }
        const Wa = [];
        function Ha(e, t) {
            return {
                subscribe: ja(e, t).subscribe
            }
        }
        function ja(e, t=Jn) {
            let i;
            const o = new Set;
            function n(t) {
                if (ar(e, t) && (e = t,
                i)) {
                    const t = !Wa.length;
                    for (const t of o)
                        t[1](),
                        Wa.push(t, e);
                    if (t) {
                        for (let e = 0; e < Wa.length; e += 2)
                            Wa[e][0](Wa[e + 1]);
                        Wa.length = 0
                    }
                }
            }
            return {
                set: n,
                update: function(t) {
                    n(t(e))
                },
                subscribe: function(r, a=Jn) {
                    const s = [r, a];
                    return o.add(s),
                    1 === o.size && (i = t(n) || Jn),
                    r(e),
                    () => {
                        o.delete(s),
                        0 === o.size && (i(),
                        i = null)
                    }
                }
            }
        }
        function Ua(e, t, i) {
            const o = !Array.isArray(e)
              , n = o ? [e] : e
              , r = t.length < 2;
            return Ha(i, (e => {
                let i = !1;
                const a = [];
                let s = 0
                  , l = Jn;
                const c = () => {
                    if (s)
                        return;
                    l();
                    const i = t(o ? a[0] : a, e);
                    r ? e(i) : l = rr(i) ? i : Jn
                }
                  , u = n.map(( (e, t) => sr(e, (e => {
                    a[t] = e,
                    s &= ~(1 << t),
                    i && c()
                }
                ), ( () => {
                    s |= 1 << t
                }
                ))));
                return i = !0,
                c(),
                function() {
                    nr(u),
                    l()
                }
            }
            ))
        }
        var Va = e => e.reduce(( (e, t) => Object.assign(e, t)), {});
        const qa = e => ({
            updateValue: e
        })
          , Ga = e => ({
            defaultValue: e
        })
          , Ka = e => ({
            store: e
        })
          , Xa = e => ({
            store: (t, i) => Ua(...e(i))
        })
          , Za = e => ({
            store: (t, i) => {
                const [o,n,r=( () => !1)] = e(i);
                let a, s = !0;
                return Ua(o, ( (e, t) => {
                    n(e, (e => {
                        !s && r(a, e) || (a = e,
                        s = !1,
                        t(e))
                    }
                    ))
                }
                ))
            }
        })
          , Ya = e => ({
            store: (t, i) => {
                const [o,n={},r] = e(i);
                let a = [];
                const s = {}
                  , l = e => o(e, s)
                  , c = e => {
                    (a.length || e.length) && (a = e,
                    u())
                }
                  , u = () => {
                    const e = a.map(l);
                    r && e.sort(r),
                    a = [...e],
                    p(e)
                }
                ;
                Object.entries(n).map(( ([e,t]) => t.subscribe((t => {
                    s[e] = t,
                    t && u()
                }
                ))));
                const {subscribe: d, set: p} = ja(t || []);
                return {
                    set: c,
                    update: e => c(e(a)),
                    subscribe: d
                }
            }
        });
        var Qa = e => {
            const t = {}
              , i = {};
            return e.forEach(( ([e,...o]) => {
                const n = Va(o)
                  , r = t[e] = ( (e, t, i) => {
                    const {store: o=(e => ja(e)), defaultValue: n=$, updateValue: r} = i
                      , a = o(n(), t, e)
                      , {subscribe: s, update: l=$} = a;
                    let c;
                    const u = e => {
                        let t = !0;
                        c && c(),
                        c = s((i => {
                            if (t)
                                return t = !1;
                            e(i),
                            c(),
                            c = void 0
                        }
                        ))
                    }
                      , d = r ? r(e) : se;
                    return a.set = e => l((t => d(e, t, u))),
                    a.defaultValue = n,
                    a
                }
                )(i, t, n)
                  , a = {
                    get: () => lr(r),
                    set: r.set
                };
                Object.defineProperty(i, e, a)
            }
            )),
            {
                stores: t,
                accessors: i
            }
        }
          , Ja = [["src", Ka(( () => {
            let e;
            const {subscribe: t, set: i} = ja()
              , o = t => {
                e !== t && (e = t,
                i(e))
            }
            ;
            return {
                set: o,
                subscribe: t,
                update: t => o(t(e))
            }
        }
        ))], ["imageReader"], ["imageWriter"], ["imageScrambler"], ["imageRedactionRendering", Ga(( () => "pixelated"))], ["images", Ga(( () => []))], ["shapePreprocessor"], ["willRequestResource"], ["willRequest"], ["csp"]]
          , es = e => e.charAt(0).toUpperCase() + e.slice(1)
          , ts = (e, t) => {
            Object.keys(t).forEach((i => {
                const o = H(t[i]) ? {
                    value: t[i],
                    writable: !1
                } : t[i];
                Object.defineProperty(e, i, o)
            }
            ))
        }
        ;
        const is = (e, t) => {
            let i, o, n, r, a, s, l, c, u, d;
            const p = t.length;
            for (i = 0; i < p; i++)
                if (o = t[i],
                n = t[i + 1 > p - 1 ? 0 : i + 1],
                r = o.x - e.x,
                a = o.y - e.y,
                s = n.x - e.x,
                l = n.y - e.y,
                c = r - s,
                u = a - l,
                d = c * a - u * r,
                d < -1e-5)
                    return !1;
            return !0
        }
          , os = 1e4;
        var ns = (e, t) => {
            const i = Vt(t)
              , o = ke();
            zt(e).forEach((e => {
                ze(e, o),
                is(e, t) || i.forEach((t => {
                    const i = Math.atan2(t.start.y - t.end.y, t.start.x - t.end.x)
                      , n = Math.sin(Math.PI - i) * os
                      , r = Math.cos(Math.PI - i) * os
                      , a = Ce(e.x + n, e.y + r)
                      , s = ct(lt(t), os)
                      , l = Wt(st(e, a), s);
                    l && ze(o, Fe(Me(l), e))
                }
                ))
            }
            ));
            const n = pt(e);
            return ze(n, o),
            !!zt(n).every((e => is(e, t))) && (Pt(e, n),
            !0)
        }
          , rs = (e, t) => {
            const i = zt(e)
              , o = qt(t, 5)
              , n = vt(e)
              , r = [];
            i.forEach((e => {
                const t = ( (e, t) => {
                    const i = Ce(e.start.x - e.end.x, e.start.y - e.end.y)
                      , o = Ae(i)
                      , n = Be(o, t);
                    return e.end.x += n.x,
                    e.end.y += n.y,
                    e
                }
                )(st(Me(n), Me(e)), 1e6);
                let i = !1;
                o.map(lt).forEach((e => {
                    const o = Wt(t, e);
                    o && !i && (r.push(o),
                    i = !0)
                }
                ))
            }
            ));
            const a = je(r[0], r[2]) < je(r[1], r[3]) ? [r[0], r[2]] : [r[1], r[3]]
              , s = gt(a);
            return s.width < e.width && (Pt(e, s),
            !0)
        }
          , as = (e, t, i={
            x: 0,
            y: 0
        }) => {
            const o = mt(e)
              , n = vt(o)
              , r = Ot(o, i, n).map((e => Ee(e, t, n)))
              , a = gt(r);
            return r.map((e => Fe(e, a)))
        }
          , ss = (e, t=0, i=Tt(e)) => {
            let o, n;
            if (0 !== t) {
                const r = Math.atan2(1, i)
                  , a = Math.sign(t) * t
                  , s = a % Math.PI
                  , l = a % ce;
                let c;
                c = s > ue && s < ce + ue ? l > ue ? a : ce - l : l > ue ? ce - l : a;
                const u = Math.min(Math.abs(e.height / Math.sin(r + c)), Math.abs(e.width / Math.cos(r - c)));
                o = Math.cos(r) * u,
                n = o / i
            } else
                o = e.width,
                n = o / i,
                n > e.height && (n = e.height,
                o = n * i);
            return et(o, n)
        }
          , ls = (e, t, i) => {
            const o = mt(e)
              , n = vt(o)
              , r = Et(o, i, n)
              , a = vt(Bt(gt(r)))
              , s = vt(t)
              , l = Ee(s, -i, a)
              , c = Fe(l, a)
              , u = De(ze(n, c), we);
            return bt(u.x - .5 * t.width, u.y - .5 * t.height, t.width, t.height)
        }
          , cs = (e, t, i) => Math.max(t, Math.min(e, i));
        const us = ["cropLimitToImage", "cropMinSize", "cropMaxSize", "cropAspectRatio", "flipX", "flipY", "rotation", "crop", "colorMatrix", "convolutionMatrix", "gamma", "vignette", "manipulation", "redaction", "annotation", "decoration", "selection", "frame", "backgroundColor", "backgroundImage", "targetSize", "metadata", "trim", "volume", "minDuration", "maxDuration", "currentTime"]
          , ds = e => Ui(e) ? e.map(ds) : bi(e) || Jt(e) ? e : O(e) ? {
            ...e
        } : e
          , ps = e => e.map((e => Object.entries(e).reduce(( (e, [t,i]) => (t.startsWith("_") || (e[t] = i),
        e)), {})))
          , hs = (e, t) => e === t;
        var ms = (e, t, i=hs) => {
            if (e.length !== t.length)
                return !1;
            for (let o = 0; o < e.length; o++)
                if (!i(e[o], t[o]))
                    return !1;
            return !0
        }
        ;
        const fs = (e, t, i) => {
            const o = De(vt(e), (e => we(e, 8)))
              , n = mt(t)
              , r = vt(n)
              , a = Et(n, i, r)
              , s = De(ot(gt(a)), (e => we(e, 8)))
              , l = Math.abs(s.x - o.x)
              , c = Math.abs(s.y - o.y);
            return l < 1 && c < 1
        }
          , gs = (e, t) => {
            const {context: i, props: o} = t;
            return e._isFormatted || ((e = pn(e))._isFormatted = !0,
            Object.assign(e, o)),
            e._isDraft || !Uo(e) || e._context && Ct(i, e._context) || (Mn(e, i),
            e._context = {
                ...i
            }),
            e
        }
          , ys = (e, t) => (e._isFormatted || (e.disableMove = !0,
        e.disableSelect = !0,
        e.disableResize = !0,
        e.disableRotate = !0),
        gs(e, t));
        var $s = [["file"], ["size"], ["loadState"], ["processState"], ["aspectRatio", Xa(( ({size: e}) => [e, e => e ? Tt(e) : void 0]))], ["perspectiveX", Ga(( () => 0))], ["perspectiveY", Ga(( () => 0))], ["perspective", Xa(( ({perspectiveX: e, perspectiveY: t}) => [[e, t], ([e,t]) => ({
            x: e,
            y: t
        })]))], ["rotation", Ga(( () => 0)), qa((e => (t, i, o) => {
            if (t === i)
                return t;
            const {loadState: n, size: r, rotationRange: a, cropMinSize: s, cropMaxSize: l, crop: c, perspective: u, cropLimitToImage: d, cropOrigin: p} = e;
            if (!c || !n || !n.beforeComplete)
                return t;
            const h = d && ( (e, t, i) => {
                const o = ss(t, i, Tt(e));
                return tt(at(o, Math.round), at(Xe(e), Math.round))
            }
            )(c, r, i)
              , m = d && fs(c, r, i)
              , f = ( (e, t, i, o, n, r, a, s, l, c) => {
                const u = Xe(l)
                  , d = Xe(c);
                a && (d.width = Math.min(c.width, n.width),
                d.height = Math.min(c.height, n.height));
                let p = !1;
                const h = (t, i) => {
                    const l = ls(n, o, t)
                      , c = mt(n)
                      , m = vt(c)
                      , f = Ot(c, r, m)
                      , g = Fe(Me(m), Nt(f))
                      , y = Ee(vt(l), i, m)
                      , $ = Fe(Me(m), y);
                    f.forEach((e => Ee(e, i, m)));
                    const b = gt(f)
                      , v = Nt(f)
                      , x = ze(Fe(Fe(v, $), b), g)
                      , w = bt(x.x - .5 * l.width, x.y - .5 * l.height, l.width, l.height);
                    if (s && wt(w, s.width / w.width),
                    a) {
                        const e = as(n, i, r);
                        rs(w, e)
                    }
                    const S = we(Math.min(w.width / u.width, w.height / u.height), 8)
                      , _ = we(Math.max(w.width / d.width, w.height / d.height), 8);
                    return (S < 1 || _ > 1) && we(Math.abs(i - t)) === we(Math.PI / 2) && !p ? (p = !0,
                    h(e, e + Math.sign(i - t) * Math.PI)) : {
                        rotation: i,
                        crop: Ft(w, (e => we(e, 8)))
                    }
                }
                  , m = Math.sign(t) * Math.round(Math.abs(t) / ce) * ce
                  , f = cs(t, m + i[0], m + i[1]);
                return h(e, f)
            }
            )(i, t, a, c, r, u, d, p, s, l);
            if (h && m) {
                const e = ss(r, t, Tt(f.crop));
                f.crop.x += .5 * f.crop.width,
                f.crop.y += .5 * f.crop.height,
                f.crop.x -= .5 * e.width,
                f.crop.y -= .5 * e.height,
                f.crop.width = e.width,
                f.crop.height = e.height
            }
            return o(( () => {
                e.crop = Ft(f.crop, (e => we(e, 8)))
            }
            )),
            f.rotation
        }
        ))], ["flipX", Ga(( () => !1))], ["flipY", Ga(( () => !1))], ["flip", Xa(( ({flipX: e, flipY: t}) => [[e, t], ([e,t]) => ({
            x: e,
            y: t
        })]))], ["isRotatedSideways", Za(( ({rotation: e}) => [[e], ([e], t) => t(de(e)), (e, t) => e !== t]))], ["crop", qa((e => (t, i=t) => {
            const {loadState: o, size: n, cropMinSize: r, cropMaxSize: a, cropLimitToImage: s, cropAspectRatio: l, rotation: c, perspective: u} = e;
            if (!t && !i || !o || !o.beforeComplete)
                return t;
            t || (t = mt(ss(n, c, l || Tt(n))));
            const d = ( (e, t, i, o, n, r, a, s) => {
                const l = Xe(a)
                  , c = Xe(s)
                  , u = we(Math.max(t.width / c.width, t.height / c.height))
                  , d = we(Math.min(t.width / l.width, t.height / l.height))
                  , p = pt(t);
                if (d < 1 || u > 1) {
                    const i = vt(e)
                      , o = vt(t)
                      , n = d < 1 ? d : u
                      , r = (o.x + i.x) / 2
                      , a = (o.y + i.y) / 2
                      , s = p.width / n
                      , l = p.height / n;
                    Mt(p, r - .5 * s, a - .5 * l, s, l)
                }
                return r ? (( (e, t, i=0, o=ke(), n) => {
                    if (Wi(i) && 0 !== i || o.x || o.y) {
                        const n = Tt(e)
                          , r = as(t, i, o)
                          , a = ss(t, i, n);
                        if (!(e.width < a.width && e.height < a.height)) {
                            const t = .5 * e.width - .5 * a.width
                              , i = .5 * e.height - .5 * a.height;
                            e.width > a.width && (e.width = a.width,
                            e.x += t),
                            e.height > a.height && (e.height = a.height,
                            e.y += i)
                        }
                        ns(e, r),
                        rs(e, r) && ns(e, r)
                    } else {
                        const i = Tt(e);
                        e.width = Math.min(e.width, t.width),
                        e.height = Math.min(e.height, t.height),
                        e.x = Math.max(e.x, 0),
                        e.x + e.width > t.width && (e.x -= e.x + e.width - t.width),
                        e.y = Math.max(e.y, 0),
                        e.y + e.height > t.height && (e.y -= e.y + e.height - t.height);
                        const o = vt(e)
                          , r = Lt(e, i);
                        r.width = Math.max(n.width, r.width),
                        r.height = Math.max(n.height, r.height),
                        r.x = o.x - .5 * r.width,
                        r.y = o.y - .5 * r.height,
                        Pt(e, r)
                    }
                }
                )(p, i, o, n, l),
                {
                    crop: p
                }) : {
                    crop: p
                }
            }
            )(i, t, n, c, u, s, r, a)
              , p = Ft(d.crop, (e => we(e, 8)));
            return Ct(i, p) ? i : p
        }
        ))], ["cropAspectRatio", qa((e => (t, i) => {
            const {loadState: o, crop: n, size: r, rotation: a, cropLimitToImage: s} = e
              , l = (e => {
                if (e) {
                    if (/:/.test(e)) {
                        const [t,i] = e.split(":");
                        return t / i
                    }
                    return parseFloat(e)
                }
            }
            )(t);
            if (!l)
                return;
            if (!n || !o || !o.beforeComplete)
                return l;
            const c = i ? Math.abs(t - i) : 1;
            if (fs(n, r, a) && s && c >= .1) {
                const i = ( (e, t) => {
                    const i = e.width
                      , o = e.height;
                    return de(t) && (e.width = o,
                    e.height = i),
                    e
                }
                )(Xe(r), a);
                e.crop = Ft(Lt(mt(i), t), we)
            } else {
                const t = {
                    width: n.height * l,
                    height: n.height
                }
                  , i = .5 * (n.width - t.width)
                  , o = .5 * (n.height - t.height);
                e.crop = Ft(bt(n.x + i, n.y + o, t.width, t.height), we)
            }
            return l
        }
        ))], ["cropOrigin"], ["cropMinSize", Ga(( () => ({
            width: 1,
            height: 1
        })))], ["cropMaxSize", Ga(( () => ({
            width: 32768,
            height: 32768
        })))], ["cropLimitToImage", Ga(( () => !0)), qa((e => (t, i, o) => {
            const {crop: n} = e;
            return n ? (!i && t && o(( () => e.crop = pt(e.crop))),
            t) : t
        }
        ))], ["cropSize", Za(( ({crop: e}) => [[e], ([e], t) => {
            e && t(et(e.width, e.height))
        }
        , (e, t) => tt(e, t)]))], ["cropRectAspectRatio", Xa(( ({cropSize: e}) => [[e], ([e], t) => {
            e && t(we(Tt(e), 5))
        }
        ]))], ["cropRange", Za(( ({size: e, rotation: t, cropRectAspectRatio: i, cropMinSize: o, cropMaxSize: n, cropLimitToImage: r}) => [[e, t, i, o, n, r], ([e,t,i,o,n,r], a) => {
            if (!e)
                return;
            const s = ( (e, t, i, o, n, r) => {
                const a = Xe(o)
                  , s = Xe(n);
                return r ? [a, at(ss(e, t, i), Math.round)] : [a, s]
            }
            )(e, t, i, o, n, r);
            a(s)
        }
        , (e, t) => ms(e, t)]))], ["rotationRange", Za(( ({size: e, isRotatedSideways: t, cropMinSize: i, cropSize: o, cropLimitToImage: n}) => [[e, t, i, o, n], ([e,t,i,o,n], r) => {
            e && o && r(( (e, t, i, o, n) => {
                if (!n)
                    return [-1 / 0, 1 / 0];
                const r = Math.max(i.width / o.width, i.height / o.height)
                  , a = et(o.width * r, o.height * r)
                  , s = (l = a,
                Math.sqrt(l.width * l.width + l.height * l.height));
                var l;
                if (s < Math.min(e.width, e.height))
                    return [-1 / 0, 1 / 0];
                const c = t ? e.height : e.width
                  , u = t ? e.width : e.height
                  , d = Math.acos(a.height / s)
                  , p = d - Math.acos(u / s)
                  , h = Math.asin(c / s) - d;
                if (Number.isNaN(p) && Number.isNaN(h))
                    return [-1 / 0, 1 / 0];
                const m = Number.isNaN(p) ? h : Number.isNaN(h) ? p : Math.min(p, h);
                return [-m, m]
            }
            )(e, t, i, o, n))
        }
        , (e, t) => ms(e, t)]))], ["backgroundColor", qa(( () => e => ( (e=[0, 0, 0, 0], t=1) => 4 === e.length ? e : [...e, t])(e)))], ["backgroundImage"], ["targetSize"], ["colorMatrix"], ["convolutionMatrix"], ["gamma"], ["noise"], ["vignette"], ["duration"], ["currentTime"], ["minDuration", Ga(( () => 1 / 24))], ["maxDuration", Ga(( () => 1 / 0))], ["volume", Ga(( () => 1))], ["trim"], ["redaction", Ya(( ({size: e}) => [gs, {
            context: e
        }]))], ["manipulation", Ya(( ({size: e}) => [gs, {
            context: e
        }]))], ["annotation", Ya(( ({size: e}) => [gs, {
            context: e
        }]))], ["decoration", Ya(( ({crop: e}) => [gs, {
            context: e
        }]))], ["selection", Ya(( ({size: e}) => [ys, {
            context: e
        }]))], ["frame", qa(( () => e => {
            if (!e)
                return;
            const t = {
                frameStyle: void 0,
                x: 0,
                y: 0,
                width: "100%",
                height: "100%",
                disableStyle: ["backgroundColor", "strokeColor", "strokeWidth"]
            };
            return W(e) ? t.frameStyle = e : Object.assign(t, e),
            t
        }
        ))], ["metadata"], ["state", Ka(( (e, t, i) => {
            const o = us.map((e => t[e]));
            let n = !1;
            const r = ja({})
              , {subscribe: a} = Ua([...o, r], ( (e, t) => {
                if (n)
                    return;
                const i = us.reduce(( (t, i, o) => (t[i] = ds(e[o]),
                t)), {});
                i.crop && Ft(i.crop, Math.round),
                i.manipulation = i.manipulation && ps(i.manipulation),
                i.redaction = i.redaction && ps(i.redaction),
                i.annotation = i.annotation && ps(i.annotation),
                i.decoration = i.decoration && ps(i.decoration),
                i.selection = i.selection && ps(i.selection),
                t(i)
            }
            ))
              , s = e => {
                e && (n = !0,
                i.cropOrigin = void 0,
                us.filter((t => ji(e, t))).forEach((t => {
                    const o = e[t];
                    i[t] = null === o ? void 0 : ds(o)
                }
                )),
                n = !1,
                r.set({}))
            }
            ;
            return {
                set: s,
                update: e => s(e(null)),
                subscribe: a
            }
        }
        ))]]
          , bs = async (e, t, i={}, o) => {
            const {ontaskstart: n, ontaskprogress: r, ontaskend: a, token: s} = o;
            let l = !1;
            const c = {
                cancel: $
            };
            s.cancel = () => {
                l = !0,
                c.cancel()
            }
            ;
            for (const [o,s] of t.entries()) {
                if (l)
                    return;
                const [t,u] = s;
                n(o, u);
                try {
                    e = await t(e, {
                        ...i,
                        taskCancelToken: c
                    }, (e => r(o, u, e)))
                } catch (e) {
                    throw l = !0,
                    e
                }
                a(o, u)
            }
            return e
        }
        ;
        const vs = ["loadstart", "loadabort", "loaderror", "loadprogress", "load", "processstart", "processabort", "processerror", "processprogress", "process"]
          , xs = ["flip", "cropOrigin", "isRotatedSideways", "perspective", "perspectiveX", "perspectiveY", "cropRange"]
          , ws = $s.map(( ([e]) => e)).filter((e => !xs.includes(e)))
          , Ss = e => `image${es(e)}`
          , _s = e => ji(e, "crop");
        var ks = () => {
            const {stores: e, accessors: t} = Qa(Ja)
              , {sub: i, pub: o} = oo()
              , n = () => t.images ? t.images[0] : {};
            let r = {};
            const a = {};
            ws.forEach((e => {
                Object.defineProperty(t, Ss(e), {
                    get: () => {
                        const t = n();
                        if (t)
                            return t.accessors[e]
                    }
                    ,
                    set: t => {
                        r[Ss(e)] = t,
                        a[Ss(e)] = t;
                        const i = n();
                        i && (i.accessors[e] = t)
                    }
                })
            }
            ));
            const s = () => t.images && t.images[0]
              , l = e.src.subscribe((e => {
                if (!e)
                    return t.images = [];
                t.imageReader && (t.images.length && (r = {}),
                u(e))
            }
            ))
              , c = e.imageReader.subscribe((e => {
                e && (t.images.length || t.src && u(t.src))
            }
            ))
              , u = e => {
                Promise.resolve().then(( () => p(e, r))).catch(( () => {}
                ))
            }
            ;
            let d;
            const p = (e, i={}) => new Promise(( (n, l) => {
                let c = s();
                const u = !(!1 === i.cropLimitToImage || !1 === i.imageCropLimitToImage || !1 === a.imageCropLmitedToImage)
                  , p = i.cropMinSize || i.imageCropMinSize || a.imageCropMinSize
                  , h = u ? p : c && c.accessors.cropMinSize
                  , f = i.minDuration || i.imageMinDuration;
                c && m(),
                c = ( ({minSize: e={
                    width: 1,
                    height: 1
                }, minDuration: t=0}={}) => {
                    const {stores: i, accessors: o} = Qa($s)
                      , {pub: n, sub: r} = oo()
                      , a = (e, t) => {
                        const i = () => o[e] || {}
                          , r = t => {
                            o[e] = {
                                ...i(),
                                ...t,
                                timeStamp: Date.now()
                            }
                        }
                          , a = () => i().error
                          , s = e => {
                            a() || (r({
                                error: e
                            }),
                            n(`${t}error`, {
                                ...i()
                            }))
                        }
                        ;
                        return {
                            start() {
                                n(`${t}start`)
                            },
                            onabort() {
                                r({
                                    abort: !0
                                }),
                                n(`${t}abort`, {
                                    ...i()
                                })
                            },
                            ontaskstart(e, o) {
                                a() || (r({
                                    index: e,
                                    task: o,
                                    taskProgress: void 0,
                                    taskLengthComputable: void 0
                                }),
                                n(`${t}taskstart`, {
                                    ...i()
                                }))
                            },
                            ontaskprogress(e, o, s) {
                                a() || (r({
                                    index: e,
                                    task: o,
                                    taskProgress: s.loaded / s.total,
                                    taskLengthComputable: s.lengthComputable
                                }),
                                n(`${t}taskprogress`, {
                                    ...i()
                                }),
                                n(`${t}progress`, {
                                    ...i()
                                }))
                            },
                            ontaskend(e, o) {
                                a() || (r({
                                    index: e,
                                    task: o
                                }),
                                n(`${t}taskend`, {
                                    ...i()
                                }))
                            },
                            ontaskerror(e) {
                                s(e)
                            },
                            error(e) {
                                s(e)
                            },
                            beforeComplete(e) {
                                a() || (r({
                                    beforeComplete: !0
                                }),
                                n(`before${t}`, e))
                            },
                            complete(e) {
                                a() || (r({
                                    complete: !0
                                }),
                                n(t, e))
                            }
                        }
                    }
                    ;
                    return ts(o, {
                        read: (i, {reader: n}, r={}) => {
                            if (!n)
                                return;
                            Object.assign(o, {
                                file: void 0,
                                size: void 0,
                                loadState: void 0
                            });
                            let s = {
                                cancel: $
                            }
                              , l = !1;
                            const c = a("loadState", "load")
                              , u = {
                                token: s,
                                ...c
                            }
                              , d = {
                                src: i,
                                size: void 0,
                                dest: void 0,
                                duration: void 0
                            };
                            return Promise.resolve().then((async () => {
                                try {
                                    if (c.start(),
                                    l)
                                        return c.onabort();
                                    const i = await bs(d, n, r, u);
                                    if (l)
                                        return c.onabort();
                                    const {size: a, duration: s, dest: p} = i || {};
                                    if (!a || !a.width || !a.height)
                                        throw new yi("Image size missing","IMAGE_SIZE_MISSING",i);
                                    if (s > 0 && s < t)
                                        throw new yi("Video too short","VIDEO_TOO_SHORT",{
                                            ...i,
                                            minDuration: t
                                        });
                                    if (a.width < e.width || a.height < e.height)
                                        throw new yi("Image too small","IMAGE_TOO_SMALL",{
                                            ...i,
                                            minWidth: e.width,
                                            minHeight: e.height
                                        });
                                    Object.assign(o, {
                                        file: p,
                                        size: a,
                                        duration: s
                                    }),
                                    c.beforeComplete(i),
                                    c.complete(i)
                                } catch (e) {
                                    c.error(e)
                                } finally {
                                    s = void 0
                                }
                            }
                            )),
                            () => {
                                l = !0,
                                s && s.cancel(),
                                c.onabort()
                            }
                        }
                        ,
                        write: (e, t) => {
                            if (!o.loadState.complete)
                                return;
                            o.processState = void 0;
                            const i = a("processState", "process")
                              , n = {
                                src: o.file,
                                imageState: o.state,
                                dest: void 0
                            };
                            if (H(e) && (e = e(o.file, o.state)),
                            !e)
                                return i.start(),
                                void i.complete(n);
                            let r = {
                                cancel: $
                            }
                              , s = !1;
                            const l = t
                              , c = {
                                token: r,
                                ...i
                            };
                            return Promise.resolve().then((async () => {
                                try {
                                    if (i.start(),
                                    s)
                                        return i.onabort();
                                    const t = await bs(n, e, l, c);
                                    if (s)
                                        return i.onabort();
                                    i.complete(t)
                                } catch (e) {
                                    i.error(e)
                                } finally {
                                    r = void 0
                                }
                            }
                            )),
                            () => {
                                s = !0,
                                r && r.cancel()
                            }
                        }
                        ,
                        on: r
                    }),
                    {
                        accessors: o,
                        stores: i
                    }
                }
                )({
                    minSize: h,
                    minDuration: f
                }),
                vs.map((e => {
                    return c.accessors.on(e, (t = e,
                    e => o(t, e)));
                    var t
                }
                ));
                const g = () => {
                    r = {},
                    y.forEach((e => e()))
                }
                  , y = [];
                y.push(c.accessors.on("loaderror", (e => {
                    g(),
                    l(e)
                }
                ))),
                y.push(c.accessors.on("loadabort", ( () => {
                    g(),
                    l({
                        name: "AbortError"
                    })
                }
                ))),
                y.push(c.accessors.on("load", (e => {
                    d = void 0,
                    g(),
                    n(e)
                }
                ))),
                y.push(c.accessors.on("beforeload", ( () => ( (e, i) => {
                    if (_s(i))
                        return void (t.imageState = i);
                    if (!i.imageCrop) {
                        const t = e.accessors.size
                          , o = i.imageRotation || 0
                          , n = nt(Xe(t), o)
                          , r = mt(n);
                        r.width = we(Math.abs(r.width), 6),
                        r.height = we(Math.abs(r.height), 6);
                        const a = i.imageCropAspectRatio || (i.imageCropLimitToImage ? Tt(t) : Tt(r));
                        let s;
                        i.imageCropLimitToImage ? s = Lt(r, a) : (s = It(r, a),
                        s.x = (t.width - s.width) / 2,
                        s.y = (t.height - s.height) / 2),
                        i.imageCrop = s
                    }
                    if (e.accessors.duration && !i.imageTrim && i.imageMaxDuration) {
                        const {duration: t} = e.accessors;
                        i.imageTrim = [[0, Math.min(i.imageMaxDuration / t, 1)]]
                    }
                    const o = ["imageCropLimitToImage", "imageCrop", "imageCropAspectRatio", "imageRotation"];
                    o.filter((e => ji(i, e))).forEach((e => {
                        t[e] = i[e],
                        delete i[e]
                    }
                    ));
                    const n = Object.keys(i).filter((e => !o.includes(e))).reduce(( (e, t) => (e[t] = i[t],
                    e)), {});
                    Object.assign(t, n)
                }
                )(c, i)))),
                t.images = [c],
                i.imageReader && (t.imageReader = i.imageReader),
                i.imageWriter && (t.imageWriter = i.imageWriter),
                d = c.accessors.read(e, {
                    reader: t.imageReader
                }, {
                    willRequest: t.willRequest
                })
            }
            ));
            let h;
            const m = () => {
                const e = s();
                e && (d && d(),
                e.accessors.loadState = void 0,
                t.images = [])
            }
            ;
            return Object.defineProperty(t, "stores", {
                get: () => e
            }),
            ts(t, {
                on: i,
                loadImage: p,
                abortLoadImage: () => {
                    d && d(),
                    t.images = []
                }
                ,
                editImage: (e, i) => new Promise(( (o, n) => {
                    p(e, i).then(( () => {
                        const {images: e} = t
                          , i = e[0]
                          , r = () => {
                            a(),
                            s()
                        }
                          , a = i.accessors.on("processerror", (e => {
                            r(),
                            n(e)
                        }
                        ))
                          , s = i.accessors.on("process", (e => {
                            r(),
                            o(e)
                        }
                        ))
                    }
                    )).catch(n)
                }
                )),
                removeImage: m,
                processImage: (e, i) => new Promise(( (o, n) => {
                    try {
                        const r = []
                          , a = () => {
                            h = void 0,
                            r.forEach((e => e()))
                        }
                        ;
                        (async () => {
                            if ((e => W(e) || Zi(e) || Qt(e))(e))
                                try {
                                    await p(e, i)
                                } catch (e) {
                                    n(e)
                                }
                            else
                                e && (_s(e) ? t.imageState = e : Object.assign(t, e));
                            const l = s();
                            if (!l)
                                return n("no image");
                            r.push(l.accessors.on("processerror", (e => {
                                a(),
                                n(e)
                            }
                            ))),
                            r.push(l.accessors.on("processabort", ( () => {
                                a(),
                                n({
                                    name: "AbortError"
                                })
                            }
                            ))),
                            r.push(l.accessors.on("process", (e => {
                                a(),
                                o(e)
                            }
                            ))),
                            h = l.accessors.write(t.imageWriter, {
                                redactionRenderStyle: t.imageRedactionRendering,
                                shapePreprocessor: t.shapePreprocessor || se,
                                imageScrambler: t.imageScrambler,
                                willRequest: t.willRequest,
                                csp: t.csp || {},
                                willRequestResource: t.willRequestResource
                            })
                        }
                        )()
                    } catch (e) {
                        n(e)
                    }
                }
                )),
                abortProcessImage: () => {
                    const e = s();
                    e && (h && h(),
                    e.accessors.processState = void 0)
                }
                ,
                destroy: () => {
                    l && l(),
                    c && c()
                }
            }),
            t
        }
        ;
        var Cs = () => si() ? ki() ? /15_|16_/.test(navigator.userAgent) ? 14745600 : 16777216 : /15_/.test(navigator.userAgent) ? 16777216 : 1 / 0 : 1 / 0
          , Ts = (e, t) => Object.keys(e).filter((e => !t.includes(e))).reduce(( (t, i) => (t[i] = e[i],
        t)), {})
          , Ms = e => new Promise((t => {
            if (e.duration === 1 / 0)
                return e.ontimeupdate = () => {
                    e.ontimeupdate = void 0,
                    t(e)
                }
                ,
                void (e.currentTime = Number.MAX_SAFE_INTEGER);
            t(e)
        }
        ));
        const Ps = 1836476516
          , Es = (e, t=0, i=e.byteLength) => {
            const o = []
              , n = t + i;
            for (; t < n; ) {
                const i = e.getUint32(t);
                if (i < 0)
                    break;
                const n = e.getUint32(t + 4);
                if (o.push({
                    type: n,
                    size: i,
                    offset: t,
                    bodyOffset: t + 8,
                    bodySize: i - 8
                }),
                i < 8)
                    break;
                t += i
            }
            return o
        }
        ;
        var Rs = e => new Promise(( (t, i) => {
            (X() ? (async e => {
                const t = await (i = e,
                new Promise((e => {
                    const t = new FileReader;
                    t.onload = () => e(t.result),
                    t.readAsArrayBuffer(i)
                }
                )));
                var i;
                return ( (e, {limit: t=1024}={}) => {
                    let i = 0;
                    if (i += 4,
                    1718909296 !== e.getUint32(i))
                        return 0;
                    i += 4;
                    const o = e.getUint32(i);
                    return 1836069938 === o ? ( (e, t, i) => {
                        let o = !1
                          , n = -1;
                        for (let r = t; r < i; r++)
                            if (o || 1953653099 !== e.getUint32(r) || (o = !0,
                            r += 4),
                            o && 64 == e.getUint8(r)) {
                                n = r;
                                break
                            }
                        if (n < 0)
                            return 0;
                        const r = e.getUint32(n - 28)
                          , a = e.getUint32(n - 20)
                          , s = e.getUint32(n - 32)
                          , l = e.getUint32(n - 16);
                        return 65536 === r && 4294901760 === a ? 90 : 4294901760 === s && 4294901760 === l ? 180 : 4294901760 === r && 65536 === a ? 270 : 0
                    }
                    )(e, i, t) : 1903435808 === o ? (e => {
                        const t = Es(e).find((e => 1836019574 === e.type));
                        if (!t)
                            return 0;
                        const i = Es(e, t.bodyOffset, t.bodySize);
                        i.filter((e => 1953653099 === e.type)).forEach((t => {
                            i.push(...Es(e, t.bodyOffset, t.bodySize))
                        }
                        ));
                        const o = [Ps, 1953196132]
                          , n = i.filter((e => o.includes(e.type)));
                        for (const {type: t, bodyOffset: i} of n) {
                            const o = e.getUint8(i);
                            let n = i + 4;
                            n += t === Ps ? 32 : 36,
                            n += 1 === o ? 12 : 0;
                            const r = e.getInt32(n)
                              , a = e.getInt32(n + 4);
                            if (0 === r && a > 0)
                                return 90;
                            if (r < 0 && 0 === a)
                                return 180;
                            if (0 === r && a < 0)
                                return 270
                        }
                        return 0
                    }
                    )(e) : 0
                }
                )(new DataView(t))
            }
            )(e) : Promise.resolve(0)).then((o => {
                const n = document.createElement("video");
                n.onerror = () => i(n.error),
                n.playsInline = !0,
                n.preload = "auto",
                n.onseeked = () => {
                    n.onseeked = void 0,
                    t(n)
                }
                ,
                n.onloadeddata = () => {
                    n.onloadeddata = void 0,
                    n.dataset.rotation = o ? `${o}` : "0",
                    Ms(n).then(t),
                    n.currentTime = 0
                }
                ,
                n.src = URL.createObjectURL(e),
                (e => {
                    ki() && (e.load(),
                    e.play().catch(( () => {}
                    )),
                    e.pause())
                }
                )(n)
            }
            ))
        }
        ))
          , As = (e, t) => new Promise((i => {
            if (e.currentTime === t)
                return i(e);
            let o = e.onseeked;
            e.onseeked = () => {
                e.onseeked = o,
                i(e)
            }
            ,
            e.currentTime = cs(t, 0, e.duration)
        }
        ))
          , Is = (e, t=0) => new Promise(( (i, o) => {
            Rs(e).then((e => {
                As(e, t).then((e => {
                    const t = M("canvas");
                    ci(e).then(( ({width: o, height: n}) => {
                        t.width = o,
                        t.height = n;
                        const r = t.getContext("2d", {
                            willReadFrequently: !0
                        })
                          , a = () => {
                            r.drawImage(e, 0, 0, t.width, t.height);
                            const o = r.getImageData(0, 0, t.width, t.height);
                            E(t),
                            URL.revokeObjectURL(e.src),
                            i(o)
                        }
                        ;
                        si() ? setTimeout(a, 16) : a()
                    }
                    ))
                }
                ))
            }
            ))
        }
        ))
          , Ls = e => /video/.test(e.type);
        const Ds = ({imageDataResizer: e, canvasMemoryLimit: t}={}) => async (i, o, n, r, a) => {
            n.width = Math.max(n.width, 1),
            n.height = Math.max(n.height, 1),
            r.width = Math.max(r.width, 1),
            r.height = Math.max(r.height, 1);
            const {dest: s} = await ( (e, t) => {
                const {processImage: i} = ks();
                return i(e, t)
            }
            )(o, {
                imageReader: ul(),
                imageWriter: pl({
                    format: "canvas",
                    targetSize: {
                        ...r,
                        upscale: !0
                    },
                    imageDataResizer: e,
                    canvasMemoryLimit: t
                }),
                imageCrop: n
            })
              , {feather: l=0} = a || {};
            if (l > 0) {
                const e = M("canvas");
                e.width = s.width,
                e.height = s.height;
                const t = e.getContext("2d", {
                    willReadFrequently: !0
                })
                  , i = 1 / l;
                let o = 0;
                for (o = 0; o < l; o++) {
                    const e = o * i;
                    t.strokeStyle = `rgba(0,0,0,${e * e})`,
                    t.strokeRect(o + .5, o + .5, s.width - 2 * o - 1, s.height - 2 * o - 1)
                }
                t.fillStyle = "#000",
                t.fillRect(o, o, s.width + .5 - 2 * o, s.height + .5 - 2 * o);
                const n = s.getContext("2d");
                n.globalCompositeOperation = "destination-in",
                n.drawImage(e, 0, 0),
                E(e)
            }
            i.drawImage(s, r.x, r.y, r.width, r.height),
            E(s)
        }
          , zs = (e, t=( (...e) => e), i) => async (o, n, r) => {
            r(mi(0, !1));
            let a = !1;
            const s = await e(...t(o, n, (e => {
                a = !0,
                r(e)
            }
            )));
            return i && i(o, s),
            a || r(mi(1, !1)),
            o
        }
          , Fs = ({willRequest: e, srcProp: t="src", destProp: i="dest"}={}) => [zs(xi, ( (i, o, n) => [i[t], n, {
            ...o,
            willRequest: e
        }]), ( (e, t) => e[i] = t)), "any-to-file"]
          , Os = ({srcProp: e="dest", destProp: t="dest"}={}) => [zs((async e => {
            if (/octet-stream/.test(e.type)) {
                console.warn(`Pintura: File has unknown mime type "${e.type}", make sure your server sets the correct Content-Type header.`);
                let t = "image";
                const i = await di(e);
                /video/i.test(i.nodeName) && (t = "video");
                const o = {
                    type: t + "/unknown"
                };
                return Jt(e) ? new File([e],e.name,{
                    ...o,
                    lastModified: e.lastModified
                }) : new Blob([e],o)
            }
            return e
        }
        ), (t => [t[e]]), ( (e, i) => e[t] = i)), "any-to-file"]
          , Bs = ({srcProp: e="src", destProp: t="size"}={}) => [zs(hi, (t => [t[e]]), ( (e, i) => e[t] = i)), "read-image-size"]
          , Ns = async e => {
            const t = await di(e);
            if (pi(t))
                return await (i = t,
                new Promise(( (e, t) => {
                    const o = () => {
                        Ms(i).then(( () => {
                            e(i.duration)
                        }
                        ))
                    }
                    ;
                    if (i.readyState >= 1)
                        return o();
                    i.onloadedmetadata = o,
                    i.onerror = () => t(i.error)
                }
                )));
            var i
        }
          , Ws = ({srcProp: e="src", destProp: t="duration"}={}) => [zs(Ns, (t => [t[e]]), ( (e, i) => e[t] = i)), "read-media-duration"]
          , Hs = ({srcSize: e="size", srcOrientation: t="orientation", destSize: i="size"}={}) => [zs(Ci, (i => [i[e], i[t]]), ( (e, t) => e[i] = t)), "image-size-match-orientation"]
          , js = ({srcProp: e="src", destProp: t="head"}={}) => [zs(( (e, t) => Ti(e) ? x(e, t) : void 0), (t => [t[e], [0, 262144], onprogress]), ( (e, i) => e[t] = i)), "read-image-head"]
          , Us = ({srcProp: e="head", destProp: t="orientation"}={}) => [zs(f, (t => [t[e], 274]), ( (e, i=1) => e[t] = i)), "read-exif-orientation-tag"]
          , Vs = ({srcProp: e="head"}={}) => [zs(f, (t => [t[e], 274, 1])), "clear-exif-orientation-tag"]
          , qs = ({srcImageSize: e="size", srcCanvasSize: t="imageData", srcImageState: i="imageState", destImageSize: o="size", destScalar: n="scalar"}={}) => [zs(( (e, t) => [Math.min(t.width / e.width, t.height / e.height), Ze(t)]), (o => [o[e], o[t], o[i]]), ( (e, [t,i]) => {
            e[n] = t,
            e[o] = i
        }
        )), "calculate-canvas-scalar"]
          , Gs = ({srcProp: e="src", destProp: t="imageData", canvasMemoryLimit: i, srcImageState: o="imageState"}={}) => [zs(( (e, t, i) => Ls(e) ? Is(e, i.currentTime) : Y(e, t)), (t => [t[e], i, t[o]]), ( (e, i) => e[t] = i)), "blob-to-image-data"]
          , Ks = ({srcImageData: e="imageData", srcOrientation: t="orientation"}={}) => [zs(F, (i => [i[e], i[t]]), ( (e, t) => e.imageData = t)), "image-data-match-orientation"]
          , Xs = ({srcImageData: e="imageData", srcImageState: t="imageState"}={}) => [zs(Zn, (i => [i[e], {
            backgroundColor: i[t].backgroundColor,
            backgroundImage: i[t].backgroundImage
        }]), ( (e, t) => e.imageData = t)), "image-data-fill"]
          , Zs = ({srcImageData: e="imageData", srcImageState: t="imageState", destScalar: i="scalar"}={}) => [zs(Ri, (o => {
            const n = o[i];
            let {crop: r} = o[t];
            return r && 1 !== n && (r = wt(pt(r), n, ke())),
            [o[e], {
                crop: r,
                rotation: o[t].rotation,
                flipX: o[t].flipX,
                flipY: o[t].flipY
            }]
        }
        ), ( (e, t) => e.imageData = t)), "image-data-crop"]
          , Ys = ({targetSize: e={
            width: void 0,
            height: void 0,
            fit: void 0,
            upscale: void 0
        }, imageDataResizer: t, srcProp: i="imageData", srcImageState: o="imageState", destImageScaledSize: n="imageScaledSize"}) => [zs(Li, (n => {
            const r = Math.min(e.width || Number.MAX_SAFE_INTEGER, n[o].targetSize && n[o].targetSize.width || Number.MAX_SAFE_INTEGER)
              , a = Math.min(e.height || Number.MAX_SAFE_INTEGER, n[o].targetSize && n[o].targetSize.height || Number.MAX_SAFE_INTEGER);
            return [n[i], {
                width: r,
                height: a,
                fit: e.fit || "contain",
                upscale: (s = n[o],
                !!(s.targetSize && s.targetSize.width || s.targetSize && s.targetSize.height) || e.upscale || !1)
            }, t];
            var s
        }
        ), ( (e, t) => {
            tt(e.imageData, t) || (e[n] = Ze(t)),
            e.imageData = t
        }
        )), "image-data-resize"]
          , Qs = ({srcImageData: e="imageData", srcImageState: t="imageState", destImageData: i="imageData"}={}) => [zs(Ni, (i => {
            const {colorMatrix: o} = i[t]
              , n = o && Object.keys(o).map((e => o[e])).filter(Boolean);
            return [i[e], {
                colorMatrix: n && Yn(n),
                convolutionMatrix: i[t].convolutionMatrix,
                gamma: i[t].gamma,
                noise: i[t].noise,
                vignette: i[t].vignette
            }]
        }
        ), ( (e, t) => e[i] = t)), "image-data-filter"]
          , Js = ({srcImageData: e="imageData", srcImageState: t="imageState", destImageData: i="imageData", destScalar: o="scalar"}={}) => [zs((async (e, t, i, o, n, r) => {
            if (!t || !o.length)
                return e;
            let a;
            try {
                const n = {
                    dataSizeScalar: Qn(e, o)
                };
                i && i[3] > 0 && (n.backgroundColor = [...i]),
                a = await t(e, n)
            } catch (e) {}
            const s = M("canvas");
            s.width = e.width,
            s.height = e.height;
            const l = s.getContext("2d", {
                willReadFrequently: !0
            });
            if (l.putImageData(e, 0, 0),
            "auto" === r) {
                const t = Math.sqrt(e.width * e.height);
                l.filter = `blur(${Math.round(t / 100)}px)`
            }
            const c = new Path2D;
            o.forEach((e => {
                const t = bt(e.x, e.y, e.width, e.height);
                kt(t, n);
                const i = Et(pt(t), e.rotation)
                  , o = new Path2D;
                i.forEach(( (e, t) => {
                    if (0 === t)
                        return o.moveTo(e.x, e.y);
                    o.lineTo(e.x, e.y)
                }
                )),
                c.addPath(o)
            }
            )),
            l.clip(c, "nonzero"),
            l.imageSmoothingEnabled = !1,
            l.drawImage(a, 0, 0, s.width, s.height),
            E(a);
            const u = l.getImageData(0, 0, s.width, s.height);
            return E(s),
            u
        }
        ), ( (i, {imageScrambler: n, redactionRenderStyle: r}) => [i[e], n, i[t].backgroundColor, i[t].redaction, i[o], r]), ( (e, t) => e[i] = t)), "image-data-redact"]
          , el = ({srcImageData: e="imageData", srcSize: t="size", srcImageState: i="imageState", srcShapes: o="annotation", destImageData: n="imageData", destImageScaledSize: r="imageScaledSize", destScalar: a="scalar", imageDataResizer: s, canvasMemoryLimit: l, shapeFilter: c=se, shapeClip: u=!0, destImageContext: d="imageContext"}={}) => [zs(Xn, ( (n, {shapePreprocessor: p, willRequestResource: h, csp: m, willRequest: f}) => {
            const g = n[i][o].filter(c);
            if (!g.length)
                return [n[e]];
            const y = n[a]
              , {crop: $} = n[i]
              , b = n[t];
            let v = y;
            const x = n[r];
            x && (v = Math.min(x.width / $.width, x.height / $.height));
            const w = {
                width: b.width / y,
                height: b.height / y
            };
            return [n[e], {
                shapes: g,
                computeShape: e => (e = xn(e, w),
                e = Ts(e, ["left", "right", "top", "bottom"]),
                Pn(e, v)),
                transform: e => {
                    const o = n[t]
                      , {rotation: a=0, flipX: s, flipY: l, cropLimitToImage: c} = n[i]
                      , {crop: p=mt(o)} = n[i];
                    let h = 1;
                    h = n[r] ? v : y;
                    const m = {
                        width: o.width / y * h,
                        height: o.height / y * h
                    }
                      , f = ( (e, t) => {
                        const i = mt(e)
                          , o = vt(i)
                          , n = Et(i, t, o);
                        return Bt(gt(n))
                    }
                    )(m, a)
                      , g = f.width
                      , $ = f.height
                      , b = .5 * m.width - .5 * g
                      , x = .5 * m.height - .5 * $
                      , w = ot(m);
                    e.translate(-b, -x),
                    e.translate(-p.x * h, -p.y * h),
                    e.translate(w.x, w.y),
                    e.rotate(a),
                    e.translate(-w.x, -w.y);
                    const S = n[d] || {
                        x: 0,
                        y: 0
                    };
                    e.translate(S.x, S.y),
                    e.scale(s ? -1 : 1, l ? -1 : 1),
                    e.translate(s ? -m.width * y : 0, l ? -m.height * y : 0),
                    c && u && (e.rect(0, 0, m.width, m.height),
                    e.clip())
                }
                ,
                drawImage: Ds({
                    imageDataResizer: s,
                    canvasMemoryLimit: l
                }),
                preprocessShape: e => p(e, {
                    isPreview: !1,
                    ...n[i]
                }),
                canvasMemoryLimit: l,
                willRequest: f || h,
                styleNonce: m.styleNonce
            }]
        }
        ), ( (e, t) => e[n] = t)), "image-data-annotate"]
          , tl = ({srcImageData: e="imageData", srcImageState: t="imageState", destImageData: i="imageData", destImageScaledSize: o="imageScaledSize", imageDataResizer: n, canvasMemoryLimit: r, destScalar: a="scalar", shapeFilter: s=se, destImageContext: l="imageContext"}={}) => [zs(Xn, ( (i, {shapePreprocessor: c, willRequestResource: u, willRequest: d, csp: p}) => {
            let h = i[t].decoration.filter(s);
            if (!h.length)
                return [i[e]];
            let m = i[a];
            const {crop: f} = i[t]
              , g = i[o];
            if (g) {
                const e = Math.min(g.width / f.width, g.height / f.height);
                m = e
            }
            return [i[e], {
                shapes: h,
                drawImage: Ds({
                    imageDataResizer: n,
                    canvasMemoryLimit: r
                }),
                computeShape: e => (e = xn(e, f),
                e = Ts(e, ["left", "right", "top", "bottom"]),
                Pn(e, m)),
                preprocessShape: e => c(e, {
                    isPreview: !1,
                    ...i[t]
                }),
                canvasMemoryLimit: r,
                willRequest: d || u,
                styleNonce: p.styleNonce,
                transform: e => {
                    const t = i[l] || {
                        x: 0,
                        y: 0
                    };
                    e.translate(t.x, t.y)
                }
            }]
        }
        ), ( (e, t) => e[i] = t)), "image-data-decorate"]
          , il = ({srcImageData: e="imageData", srcImageState: t="imageState", destImageData: i="imageData", destImageScaledSize: o="imageScaledSize", imageDataResizer: n, canvasMemoryLimit: r, destScalar: a="scalar", destImageContext: s="imageContext"}={}) => [zs(( (e, t) => new Promise((i => {
            if (!t)
                return i([e]);
            Xn(e, t).then((e => {
                i([e, t.contextBounds])
            }
            ))
        }
        ))), ( (i, {shapePreprocessor: s, willRequestResource: l, willRequest: c, csp: u}) => {
            const d = i[t].frame;
            if (!d)
                return [i[e]];
            const p = i[a];
            let {crop: h} = i[t];
            h && 1 !== p && (h = wt(pt(h), p, ke()));
            const m = {
                ...h
            }
              , f = Cn(Tn(d, m, s), m);
            m.x = Math.abs(f.left),
            m.y = Math.abs(f.top),
            m.width += Math.abs(f.left) + Math.abs(f.right),
            m.height += Math.abs(f.top) + Math.abs(f.bottom);
            const g = i[o]
              , y = g ? Math.min(g.width / h.width, g.height / h.height) : 1;
            return kt(m, y),
            m.x = Math.floor(m.x),
            m.y = Math.floor(m.y),
            m.width = Math.floor(m.width),
            m.height = Math.floor(m.height),
            [i[e], {
                shapes: [d],
                contextBounds: m,
                computeShape: t => xn(t, i[e]),
                transform: e => {
                    e.translate(m.x, m.y)
                }
                ,
                drawImage: Ds({
                    imageDataResizer: n,
                    canvasMemoryLimit: r
                }),
                preprocessShape: e => s(e, {
                    isPreview: !1,
                    ...i[t]
                }),
                canvasMemoryLimit: r,
                willRequest: c || l,
                styleNonce: u.styleNonce
            }]
        }
        ), ( (e, [t,o]) => {
            e[s] = o,
            e[i] = t
        }
        )), "image-data-frame"]
          , ol = ({mimeType: e, quality: t, srcImageData: i="imageData", srcFile: o="src", destBlob: n="blob"}={}) => [zs(J, (n => [n[i], e || ne(n[o].name) || n[o].type, t]), ( (e, t) => e[n] = t)), "image-data-to-blob"]
          , nl = ({srcImageData: e="imageData", srcOrientation: t="orientation", destCanvas: i="dest"}={}) => [zs(z, (i => [i[e], i[t]]), ( (e, t) => e[i] = t)), "image-data-to-canvas"]
          , rl = async (e, t) => {
            if (!Ti(e) || !t)
                return e;
            const i = (e, t) => {
                let i = 2;
                const o = new DataView(e);
                for (t(o.getUint8(0), 0, 2, o.byteLength); i < o.byteLength && 255 == o.getUint8(i); ) {
                    const e = o.getUint8(i + 1)
                      , n = o.getUint16(i + 2) + 2;
                    if (!1 === t(e, i, n, o.byteLength))
                        break;
                    i += n
                }
            }
              , o = e => 224 === e || 225 === e || 226 === e
              , n = (e => {
                const t = [];
                return i(e, ( (i, n, r) => {
                    if (218 === i)
                        return !1;
                    o(i) && t.push(new Uint8Array(e,n,r))
                }
                )),
                t
            }
            )(t)
              , r = ( (e, t) => {
                const n = [];
                i(e, ( (i, r, a, s) => 0 === r ? (n.push(new Uint8Array(e,r,a)),
                void n.push(...t)) : 218 === i ? (n.push(new Uint8Array(e,r,s - r)),
                !1) : void (o(i) || n.push(new Uint8Array(e,r,a)))));
                let r = n.reduce(( (e, t) => e + t.length), 0)
                  , a = new Uint8Array(r)
                  , s = 0;
                return n.forEach((e => {
                    a.set(e, s),
                    s += e.length
                }
                )),
                a
            }
            )(await v(e), n);
            return new Blob([r],{
                type: "image/jpeg"
            })
        }
          , al = (e="blob", t="head", i="blob") => [zs(rl, (i => [i[e], i[t]]), ( (e, t) => e[i] = t)), "blob-write-image-head"]
          , sl = ({renameFile: e, srcBlob: t="blob", srcFile: i="src", destFile: o="dest", defaultFilename: n}={}) => [zs(re, (o => [o[t], e ? e(o[i]) : o[i].name || `${n}.${te(o[t].type)}`]), ( (e, t) => e[o] = t)), "blob-to-file"]
          , ll = ({url: e="./", dataset: t=(e => [["dest", e.dest, e.dest.name], ["imageState", e.imageState]]), destStore: i="store", credentials: o, headers: n={}}) => [zs((async (t, i) => await ( (e, t, i) => new Promise(( (o, n) => {
            const {token: r={}, beforeSend: a=$, onprogress: s=$} = i;
            r.cancel = () => l.abort();
            const l = new XMLHttpRequest;
            l.upload.onprogress = s,
            l.onload = () => l.status >= 200 && l.status < 300 ? o(l) : n(l),
            l.onerror = () => n(l),
            l.ontimeout = () => n(l),
            l.open("POST", encodeURI(e)),
            a(l),
            l.send(t instanceof FormData ? t : t.reduce(( (e, t) => (e.append(...t.map(Mi)),
            e)), new FormData))
        }
        )))(e, t, {
            onprogress: i,
            beforeSend: e => $i(e, {
                headers: n,
                credentials: o
            })
        })), ( (e, i, o) => [t(e), o]), ( (e, t) => e[i] = t)), "store"]
          , cl = e => [zs((t => e && e.length ? (Object.keys(t).forEach((i => {
            e.includes(i) || delete t[i]
        }
        )),
        t) : t)), "prop-filter"]
          , ul = (e={}) => {
            const {orientImage: t=!0, outputProps: i=["src", "dest", "size", "duration"], preprocessImageFile: o, request: n={}} = e;
            return [Fs({
                willRequest: () => n
            }), Os(), o && [zs(o, ( (e, t, i) => [e.dest, t, i]), ( (e, t) => e.dest = t)), "preprocess-image-file"], Bs({
                srcProp: "dest"
            }), Ws({
                srcProp: "dest"
            }), t && js({
                srcProp: "dest"
            }), t && Us(), t && Hs(), cl(i)].filter(Boolean)
        }
          , dl = e => e && (W(e) ? ll({
            url: e
        }) : H(e) ? [e, "store"] : ll(e))
          , pl = (e={}) => (t, i, o={}) => {
            let {canvasMemoryLimit: n=Cs(), orientImage: r=!0, copyImageHead: a=!0, mimeType: s, quality: l, renameFile: c, targetSize: u, imageDataResizer: d, store: p, format: h="file", outputProps: m=["src", "dest", "imageState", "store"], preprocessImageSource: f, preprocessImageState: g, postprocessImageData: y, postprocessImageBlob: $, testSrcSupport: b=!1} = {
                ...e,
                ...o
            };
            if (!b || ui(t))
                return "blob" === h && (h = "file"),
                [f && [zs(f, ( (e, t, i) => [e.src, t, i, e.imageState]), ( (e, t) => e.src = t)), "preprocess-image-source"], (r || a) && js(), r && Us(), Bs(), g && [zs(g, ( (e, t, i, o) => [e.imageState, t, i, {
                    size: e.size,
                    orientation: e.orientation
                }]), ( (e, t) => e.imageState = t)), "preprocess-image-state"], Gs({
                    canvasMemoryLimit: n
                }), r && Hs(), r && Ks(), qs(), Js(), Zs(), Ys({
                    imageDataResizer: d,
                    targetSize: u
                }), el({
                    imageDataResizer: d,
                    canvasMemoryLimit: n,
                    srcShapes: "manipulation"
                }), Qs(), Xs(), el({
                    imageDataResizer: d,
                    canvasMemoryLimit: n,
                    srcShapes: "annotation",
                    shapeFilter: e => !e.aboveFrame
                }), tl({
                    imageDataResizer: d,
                    canvasMemoryLimit: n,
                    shapeFilter: e => !e.aboveFrame
                }), il({
                    imageDataResizer: d,
                    canvasMemoryLimit: n
                }), el({
                    imageDataResizer: d,
                    canvasMemoryLimit: n,
                    srcShapes: "annotation",
                    shapeFilter: e => e.aboveFrame,
                    shapeClip: !1
                }), tl({
                    imageDataResizer: d,
                    canvasMemoryLimit: n,
                    shapeFilter: e => e.aboveFrame
                }), y && [zs(y, ( (e, t, i) => [e.imageData, t, i]), ( (e, t) => e.imageData = t)), "postprocess-image-data"], "file" === h ? ol({
                    mimeType: s,
                    quality: l
                }) : "canvas" === h ? nl() : [e => (e.dest = e.imageData,
                e)], "file" === h && r && Vs(), "file" === h && a && al(), $ && [zs($, ( ({blob: e, imageData: t, src: i}, o, n) => [{
                    blob: e,
                    imageData: t,
                    src: i
                }, o, n]), ( (e, t) => e.blob = t)), "postprocess-image-file"], "file" === h && sl({
                    defaultFilename: "image",
                    renameFile: c
                }), "file" === h ? dl(p) : H(p) && [p, "store"], cl(m)].filter(Boolean)
        }
        ;
        let hl = null;
        var ml = () => {
            if (null === hl)
                if ("WebGL2RenderingContext"in window) {
                    let e;
                    try {
                        e = M("canvas"),
                        hl = !!e.getContext("webgl2")
                    } catch (e) {
                        hl = !1
                    }
                    e && E(e),
                    e = void 0
                } else
                    hl = !1;
            return hl
        }
          , fl = e => 0 == (e & e - 1)
          , gl = (e, t={}, i="", o="") => Object.keys(t).filter((e => !O(t[e]))).reduce(( (e, n) => e.replace(new RegExp(i + n + o), t[n])), e);
        const yl = {
            head: "#version 300 es\n\nin vec4 aPosition;uniform mat4 uMatrix;",
            text: "\nin vec2 aTexCoord;out vec2 vTexCoord;",
            matrix: "\ngl_Position=uMatrix*vec4(aPosition.x,aPosition.y,0,1);"
        }
          , $l = {
            head: "#version 300 es\nprecision highp float;\n\nout vec4 fragColor;",
            mask: "\nuniform float uMaskFeather[8];uniform float uMaskBounds[4];uniform float uMaskOpacity;float mask(float x,float y,float bounds[4],float opacity){return 1.0-(1.0-(smoothstep(bounds[3],bounds[3]+1.0,x)*(1.0-smoothstep(bounds[1]-1.0,bounds[1],x))*(1.0-step(bounds[0],y))*step(bounds[2],y)))*(1.0-opacity);}",
            init: "\nfloat a=1.0;vec4 fillColor=uColor;vec4 textureColor=texture(uTexture,vTexCoord);textureColor*=(1.0-step(uRepeat.y,vTexCoord.y))*step(0.0,vTexCoord.y)*(1.0-step(uRepeat.x,vTexCoord.x))*step(0.0,vTexCoord.x);",
            colorize: "\nif(uTextureColor.a!=0.0&&textureColor.a>0.0){vec3 colorFlattened=textureColor.rgb/textureColor.a;if(colorFlattened.r>=.9999&&colorFlattened.g==0.0&&colorFlattened.b>=.9999){textureColor.rgb=uTextureColor.rgb*textureColor.a;}textureColor*=uTextureColor.a;}",
            maskapply: "\nfloat m=mask(gl_FragCoord.x,gl_FragCoord.y,uMaskBounds,uMaskOpacity);",
            maskfeatherapply: "\nfloat leftFeatherOpacity=step(uMaskFeather[1],gl_FragCoord.x)*uMaskFeather[0]+((1.0-uMaskFeather[0])*smoothstep(uMaskFeather[1],uMaskFeather[3],gl_FragCoord.x));float rightFeatherOpacity=(1.0-step(uMaskFeather[7],gl_FragCoord.x))*uMaskFeather[4]+((1.0-uMaskFeather[4])*smoothstep(uMaskFeather[7],uMaskFeather[5],gl_FragCoord.x));a*=leftFeatherOpacity*rightFeatherOpacity;",
            rectaa: "\nvec2 scaledPoint=vec2(vRectCoord.x*uSize.x,vRectCoord.y*uSize.y);a*=smoothstep(0.0,uEdgeFeather,uSize.x-scaledPoint.x);a*=smoothstep(0.0,uEdgeFeather,uSize.y-scaledPoint.y);a*=smoothstep(0.0,uEdgeFeather,scaledPoint.x);a*=smoothstep(0.0,uEdgeFeather,scaledPoint.y);",
            cornerradius: "\nvec2 s=(uSize-2.0)*.5;vec2 r=(vRectCoord*uSize)-1.0;vec2 p=r-s;float cornerRadius=uCornerRadius[0];bool left=r.x<s.x;bool top=r.y<s.y;if(!left&&top){cornerRadius=uCornerRadius[1];}if(!left&&!top){cornerRadius=uCornerRadius[3];}if(left&&!top){cornerRadius=uCornerRadius[2];}a*=1.0-clamp(length(max(abs(p)-(s-cornerRadius),0.0))-cornerRadius,0.0,1.0);",
            fragcolor: "\nif(m<=0.0)discard;fillColor.a*=a;fillColor.rgb*=fillColor.a;fillColor.rgb*=m;fillColor.rgb+=(1.0-m)*(uCanvasColor.rgb*fillColor.a);textureColor*=uTextureOpacity;textureColor.a*=a;textureColor.rgb*=m*a;textureColor.rgb+=(1.0-m)*(uCanvasColor.rgb*textureColor.a);fragColor=textureColor+(fillColor*(1.0-textureColor.a));"
        }
          , bl = (e, t, i) => {
            const o = e.createShader(i)
              , n = ( (e, t, i) => (t = gl(t, i === e.VERTEX_SHADER ? yl : $l, "##").trim(),
            ml() ? t : (t = (t = t.replace(/#version.+/gm, "").trim()).replace(/^\/\/\#/gm, "#"),
            i === e.VERTEX_SHADER && (t = t.replace(/in /gm, "attribute ").replace(/out /g, "varying ")),
            i === e.FRAGMENT_SHADER && (t = t.replace(/in /gm, "varying ").replace(/out.*?;/gm, "").replace(/texture\(/g, "texture2D(").replace(/fragColor/g, "gl_FragColor")),
            `${t}`)))(e, t, i);
            return e.shaderSource(o, n),
            e.compileShader(o),
            e.getShaderParameter(o, e.COMPILE_STATUS) || console.error(e.getShaderInfoLog(o)),
            o
        }
          , vl = (e, t, i, o, n) => {
            const r = bl(e, t, e.VERTEX_SHADER)
              , a = bl(e, i, e.FRAGMENT_SHADER)
              , s = e.createProgram();
            e.attachShader(s, r),
            e.attachShader(s, a),
            e.linkProgram(s);
            const l = {};
            return o.forEach((t => {
                l[t] = e.getAttribLocation(s, t)
            }
            )),
            n.forEach((t => {
                l[t] = e.getUniformLocation(s, t)
            }
            )),
            {
                program: s,
                locations: l,
                destroy() {
                    e.detachShader(s, r),
                    e.detachShader(s, a),
                    e.deleteShader(r),
                    e.deleteShader(a),
                    e.deleteProgram(s)
                }
            }
        }
          , xl = e => "VIDEO" !== e.nodeName && (!!ml() || fl(e.width) && fl(e.height))
          , wl = (e, t=1) => e ? [e[0], e[1], e[2], Wi(e[3]) ? t * e[3] : t] : [0, 0, 0, 0]
          , Sl = () => {
            const e = new Float32Array(16);
            return e[0] = 1,
            e[5] = 1,
            e[10] = 1,
            e[15] = 1,
            e
        }
          , _l = (e, t, i, o, n, r, a) => {
            const s = 1 / (t - i)
              , l = 1 / (o - n)
              , c = 1 / (r - a);
            e[0] = -2 * s,
            e[1] = 0,
            e[2] = 0,
            e[3] = 0,
            e[4] = 0,
            e[5] = -2 * l,
            e[6] = 0,
            e[7] = 0,
            e[8] = 0,
            e[9] = 0,
            e[10] = 2 * c,
            e[11] = 0,
            e[12] = (t + i) * s,
            e[13] = (n + o) * l,
            e[14] = (a + r) * c,
            e[15] = 1
        }
          , kl = (e, t, i, o) => {
            e[12] = e[0] * t + e[4] * i + e[8] * o + e[12],
            e[13] = e[1] * t + e[5] * i + e[9] * o + e[13],
            e[14] = e[2] * t + e[6] * i + e[10] * o + e[14],
            e[15] = e[3] * t + e[7] * i + e[11] * o + e[15]
        }
          , Cl = (e, t) => {
            e[0] *= t,
            e[1] *= t,
            e[2] *= t,
            e[3] *= t,
            e[4] *= t,
            e[5] *= t,
            e[6] *= t,
            e[7] *= t,
            e[8] *= t,
            e[9] *= t,
            e[10] *= t,
            e[11] *= t
        }
          , Tl = (e, t) => {
            const i = Math.sin(t)
              , o = Math.cos(t)
              , n = e[4]
              , r = e[5]
              , a = e[6]
              , s = e[7]
              , l = e[8]
              , c = e[9]
              , u = e[10]
              , d = e[11];
            e[4] = n * o + l * i,
            e[5] = r * o + c * i,
            e[6] = a * o + u * i,
            e[7] = s * o + d * i,
            e[8] = l * o - n * i,
            e[9] = c * o - r * i,
            e[10] = u * o - a * i,
            e[11] = d * o - s * i
        }
          , Ml = (e, t) => {
            const i = Math.sin(t)
              , o = Math.cos(t)
              , n = e[0]
              , r = e[1]
              , a = e[2]
              , s = e[3]
              , l = e[8]
              , c = e[9]
              , u = e[10]
              , d = e[11];
            e[0] = n * o - l * i,
            e[1] = r * o - c * i,
            e[2] = a * o - u * i,
            e[3] = s * o - d * i,
            e[8] = n * i + l * o,
            e[9] = r * i + c * o,
            e[10] = a * i + u * o,
            e[11] = s * i + d * o
        }
          , Pl = (e, t) => {
            const i = Math.sin(t)
              , o = Math.cos(t)
              , n = e[0]
              , r = e[1]
              , a = e[2]
              , s = e[3]
              , l = e[4]
              , c = e[5]
              , u = e[6]
              , d = e[7];
            e[0] = n * o + l * i,
            e[1] = r * o + c * i,
            e[2] = a * o + u * i,
            e[3] = s * o + d * i,
            e[4] = l * o - n * i,
            e[5] = c * o - r * i,
            e[6] = u * o - a * i,
            e[7] = d * o - s * i
        }
        ;
        var El = (e, t) => ml() ? e.getContext("webgl2", t) : e.getContext("webgl", t) || e.getContext("experimental-webgl", t);
        const Rl = (e, t) => {
            const i = e.length;
            return t >= i ? e[t % i] : t < 0 ? e[t % i + i] : e[t]
        }
          , Al = (e, t, i, o) => {
            const n = Ce(i.x - t.x, i.y - t.y)
              , r = Ce(o.x - i.x, o.y - i.y)
              , a = Ce(t.x - o.x, t.y - o.y)
              , s = Ce(e.x - t.x, e.y - t.y)
              , l = Ce(e.x - i.x, e.y - i.y)
              , c = Ce(e.x - o.x, e.y - o.y)
              , u = We(n, s)
              , d = We(r, l)
              , p = We(a, c);
            return u <= 0 && d <= 0 && p <= 0
        }
          , Il = (e, t, i, o, n) => {
            const r = Ae(Ce(o.x - i.x, o.y - i.y))
              , a = Ae(Ce(n.x - o.x, n.y - o.y))
              , s = Ae(Ce(r.x + a.x, r.y + a.y))
              , l = Ce(-s.y, s.x)
              , c = Ce(-r.y, r.x)
              , u = Math.min(1 / Ne(l, c), 5);
            e[t] = o.x,
            e[t + 1] = o.y,
            e[t + 2] = l.x * u,
            e[t + 3] = l.y * u,
            e[t + 4] = -1,
            e[t + 5] = o.x,
            e[t + 6] = o.y,
            e[t + 7] = l.x * u,
            e[t + 8] = l.y * u,
            e[t + 9] = 1
        }
          , Ll = e => {
            const t = new Float32Array(8);
            return t[0] = e[3].x,
            t[1] = e[3].y,
            t[2] = e[0].x,
            t[3] = e[0].y,
            t[4] = e[2].x,
            t[5] = e[2].y,
            t[6] = e[1].x,
            t[7] = e[1].y,
            t
        }
          , Dl = (e, t=0, i, o) => {
            const n = zt(e)
              , r = e.x + .5 * e.width
              , a = e.y + .5 * e.height;
            return (i || o) && qe(n, i, o, r, a),
            0 !== t && Ge(n, t, r, a),
            n
        }
          , zl = (e, t, i, o, n) => {
            const r = Math.min(20, Math.max(4, Math.round(o / 2)));
            let a = 0
              , s = 0
              , l = 0
              , c = 0
              , u = 0;
            for (; u < r; u++)
                a = u / r,
                s = n * ce + a * ce,
                l = o * Math.cos(s),
                c = o * Math.sin(s),
                e.push(Ce(t + l, i + c))
        }
        ;
        let Fl = null;
        var Ol = () => {
            if (null !== Fl)
                return Fl;
            let e = M("canvas");
            const t = El(e);
            return Fl = t ? t.getParameter(t.MAX_TEXTURE_SIZE) : void 0,
            E(e),
            e = void 0,
            Fl
        }
          , Bl = () => _() && !!window.chrome;
        const Nl = new Float32Array([0, 1, 0, 0, 1, 1, 1, 0])
          , Wl = new Float32Array([1, 0, 0, 0, 1, 1, 0, 1])
          , Hl = _() && X()
          , jl = [0, 0, 0, 0, 1, 0, 0, 0, 0]
          , Ul = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
          , Vl = [0, 0, 0, 0]
          , ql = [0, 0, 0, 0]
          , Gl = (e, t, i, o, n) => {
            if (!i || !o)
                return Nl;
            let r = o.x / i.width
              , a = o.y / i.height
              , s = e / i.width / n
              , l = t / i.height / n;
            return s -= r,
            l -= a,
            new Float32Array([-r, l, -r, -a, s, l, s, -a])
        }
        ;
        var Kl = (e, t={}) => {
            const {alpha: i=!1} = t
              , o = {
                width: 0,
                height: 0
            }
              , n = {
                width: 0,
                height: 0
            }
              , r = Ol() || 1024;
            let a, s, l;
            const c = Sl()
              , u = Sl();
            let d, p, h, m, f, g, y, $, b, v = 0, x = 0, w = 0, S = 1;
            const _ = new Map([])
              , k = () => {
                M.stencilOp(M.KEEP, M.KEEP, M.KEEP),
                M.stencilFunc(M.ALWAYS, 1, 255),
                M.stencilMask(255)
            }
              , C = 30 * Math.PI / 180
              , T = Math.tan(C / 2)
              , M = El(e, {
                alpha: i,
                antialias: !1,
                premultipliedAlpha: !0,
                stencil: !0
            });
            if (!M)
                return;
            M.getExtension("OES_standard_derivatives"),
            M.disable(M.DEPTH_TEST),
            M.enable(M.STENCIL_TEST),
            M.enable(M.BLEND),
            M.blendFunc(M.ONE, M.ONE_MINUS_SRC_ALPHA),
            M.pixelStorei(M.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !(!i && X())),
            k();
            const P = M.createTexture();
            M.bindTexture(M.TEXTURE_2D, P),
            M.texImage2D(M.TEXTURE_2D, 0, M.RGBA, 1, 1, 0, M.RGBA, M.UNSIGNED_BYTE, new Uint8Array(Vl)),
            _.set(0, P);
            const R = M.createTexture();
            _.set(2, R);
            const A = M.createFramebuffer()
              , I = M.createTexture();
            _.set(1, I);
            const L = M.createFramebuffer()
              , D = vl(M, "\n##head\n##text\nvoid main(){vTexCoord=aTexCoord;gl_Position=uMatrix*aPosition;}", "\n##head\nin vec2 vTexCoord;uniform sampler2D uTexture;uniform sampler2D uTextureOverlay;uniform sampler2D uTextureBlend;uniform vec2 uTextureSize;uniform float uOpacity;uniform int uAntialias;uniform vec4 uOverlayColor;uniform mat4 uColorMatrix;uniform vec4 uColorOffset;uniform float uClarityKernel[9];uniform float uClarityKernelWeight;uniform float uColorGamma;uniform float uColorVignette;uniform float uMaskClip;uniform float uMaskOpacity;uniform float uMaskBounds[4];uniform float uMaskCornerRadius[4];uniform float uMaskFeather[8];vec4 applyGamma(vec4 c,float g){c.r=pow(c.r,g);c.g=pow(c.g,g);c.b=pow(c.b,g);return c;}vec4 applyColorMatrix(vec4 c,mat4 m,vec4 o){vec4 res=(c*m)+(o*c.a);res=clamp(res,0.0,1.0);return res;}vec4 applyConvolutionMatrix(vec4 c,float k0,float k1,float k2,float k3,float k4,float k5,float k6,float k7,float k8,float w){vec2 pixel=vec2(1)/uTextureSize;vec4 colorSum=texture(uTexture,vTexCoord-pixel)*k0+texture(uTexture,vTexCoord+pixel*vec2(0.0,-1.0))*k1+texture(uTexture,vTexCoord+pixel*vec2(1.0,-1.0))*k2+texture(uTexture,vTexCoord+pixel*vec2(-1.0,0.0))*k3+texture(uTexture,vTexCoord)*k4+texture(uTexture,vTexCoord+pixel*vec2(1.0,0.0))*k5+texture(uTexture,vTexCoord+pixel*vec2(-1.0,1.0))*k6+texture(uTexture,vTexCoord+pixel*vec2(0.0,1.0))*k7+texture(uTexture,vTexCoord+pixel)*k8;vec4 color=vec4(clamp((colorSum/w),0.0,1.0).rgb,c.a);return color;}vec4 blendPremultipliedAlpha(vec4 back,vec4 front){return front+(back*(1.0-front.a));}vec4 applyVignette(vec4 c,vec2 pos,vec2 center,float v){float d=distance(pos,center)/length(center);float f=1.0-(d*abs(v));if(v>0.0){c.rgb*=f;}else if(v<0.0){c.rgb+=(1.0-f)*(1.0-c.rgb);}return c;}void main(){float x=gl_FragCoord.x;float y=gl_FragCoord.y;float a=1.0;float maskTop=uMaskBounds[0];float maskRight=uMaskBounds[1];float maskBottom=uMaskBounds[2];float maskLeft=uMaskBounds[3];float leftFeatherOpacity=step(uMaskFeather[1],x)*uMaskFeather[0]+((1.0-uMaskFeather[0])*smoothstep(uMaskFeather[1],uMaskFeather[3],x));float rightFeatherOpacity=(1.0-step(uMaskFeather[7],x))*uMaskFeather[4]+((1.0-uMaskFeather[4])*smoothstep(uMaskFeather[7],uMaskFeather[5],x));a*=leftFeatherOpacity*rightFeatherOpacity;float overlayColorAlpha=(smoothstep(maskLeft,maskLeft+1.0,x)*(1.0-smoothstep(maskRight-1.0,maskRight,x))*(1.0-step(maskTop,y))*step(maskBottom,y));if(uOverlayColor.a==0.0){a*=overlayColorAlpha;}vec2 offset=vec2(maskLeft,maskBottom);vec2 size=vec2(maskRight-maskLeft,maskTop-maskBottom)*.5;vec2 center=offset.xy+size.xy;int pixelX=int(step(center.x,x));int pixelY=int(step(y,center.y));float cornerRadius=0.0;if(pixelX==0&&pixelY==0)cornerRadius=uMaskCornerRadius[0];if(pixelX==1&&pixelY==0)cornerRadius=uMaskCornerRadius[1];if(pixelX==0&&pixelY==1)cornerRadius=uMaskCornerRadius[2];if(pixelX==1&&pixelY==1)cornerRadius=uMaskCornerRadius[3];float cornerOffset=sign(cornerRadius)*length(max(abs(gl_FragCoord.xy-size-offset)-size+cornerRadius,0.0))-cornerRadius;float cornerOpacity=1.0-smoothstep(0.0,1.0,cornerOffset);a*=cornerOpacity;if(uAntialias==1){vec2 scaledPoint=vec2(vTexCoord.x*uTextureSize.x,vTexCoord.y*uTextureSize.y);a*=smoothstep(0.0,1.0,uTextureSize.x-scaledPoint.x);a*=smoothstep(0.0,1.0,uTextureSize.y-scaledPoint.y);a*=smoothstep(0.0,1.0,scaledPoint.x);a*=smoothstep(0.0,1.0,scaledPoint.y);}vec4 color=texture(uTexture,vTexCoord);if(uClarityKernelWeight!=-1.0){color=applyConvolutionMatrix(color,uClarityKernel[0],uClarityKernel[1],uClarityKernel[2],uClarityKernel[3],uClarityKernel[4],uClarityKernel[5],uClarityKernel[6],uClarityKernel[7],uClarityKernel[8],uClarityKernelWeight);}color=blendPremultipliedAlpha(color,texture(uTextureBlend,vTexCoord));color=applyGamma(color,uColorGamma);color=applyColorMatrix(color,uColorMatrix,uColorOffset);color*=a;if(uColorVignette!=0.0){vec2 pos=gl_FragCoord.xy-offset;color=applyVignette(color,pos,center-offset,uColorVignette);}color=blendPremultipliedAlpha(color,texture(uTextureOverlay,vTexCoord));if(overlayColorAlpha<=0.0){color*=1.0-uOverlayColor.a;}color*=uOpacity;fragColor=color;}", ["aPosition", "aTexCoord"], ["uMatrix", "uTexture", "uTextureBlend", "uTextureOverlay", "uTextureSize", "uColorGamma", "uColorVignette", "uColorOffset", "uColorMatrix", "uClarityKernel", "uClarityKernelWeight", "uOpacity", "uMaskOpacity", "uMaskBounds", "uMaskCornerRadius", "uMaskFeather", "uOverlayColor", "uAntialias"])
              , z = M.createBuffer()
              , F = M.createBuffer();
            M.bindBuffer(M.ARRAY_BUFFER, F),
            M.bufferData(M.ARRAY_BUFFER, Nl, M.STATIC_DRAW);
            const O = M.createBuffer();
            M.bindBuffer(M.ARRAY_BUFFER, O),
            M.bufferData(M.ARRAY_BUFFER, Wl, M.STATIC_DRAW);
            const B = vl(M, "#version 300 es\n\nin vec4 aPosition;in vec2 aNormal;in float aMiter;out vec2 vNormal;out float vMiter;out float vWidth;uniform float uWidth;uniform float uSharpness;uniform mat4 uMatrix;void main(){vMiter=aMiter;vNormal=aNormal;vWidth=(uWidth*.5)+uSharpness;gl_Position=uMatrix*vec4(aPosition.x+(aNormal.x*vWidth*aMiter),aPosition.y+(aNormal.y*vWidth*aMiter),0,1);}", "\n##head\n##mask\nin vec2 vNormal;in float vMiter;in float vWidth;uniform float uWidth;uniform vec4 uColor;uniform vec4 uCanvasColor;void main(){vec4 fillColor=uColor;float m=mask(gl_FragCoord.x,gl_FragCoord.y,uMaskBounds,uMaskOpacity);if(m<=0.0)discard;fillColor.a*=clamp(smoothstep(vWidth-.5,vWidth-1.0,abs(vMiter)*vWidth),0.0,1.0);fillColor.rgb*=fillColor.a;fillColor.rgb*=m;fillColor.rgb+=(1.0-m)*(uCanvasColor.rgb*fillColor.a);fragColor=fillColor;}", ["aPosition", "aNormal", "aMiter"], ["uColor", "uCanvasColor", "uMatrix", "uWidth", "uSharpness", "uMaskBounds", "uMaskOpacity"])
              , N = M.createBuffer();
            Bl() && (M.bindBuffer(M.ARRAY_BUFFER, N),
            M.bufferData(M.ARRAY_BUFFER, 1, M.DYNAMIC_DRAW));
            const W = (e, t, i, o=!1) => {
                const {program: n, locations: r} = B;
                M.useProgram(n),
                M.enableVertexAttribArray(r.aPosition),
                M.enableVertexAttribArray(r.aNormal),
                M.enableVertexAttribArray(r.aMiter);
                const a = ( (e, t) => {
                    let i, o, n, r = 0;
                    const a = e.length
                      , s = new Float32Array(10 * (t ? a + 1 : a))
                      , l = e[0]
                      , c = e[a - 1];
                    for (r = 0; r < a; r++)
                        i = e[r - 1],
                        o = e[r],
                        n = e[r + 1],
                        i || (i = t ? c : Ce(o.x + (o.x - n.x), o.y + (o.y - n.y))),
                        n || (n = t ? l : Ce(o.x + (o.x - i.x), o.y + (o.y - i.y))),
                        Il(s, 10 * r, i, o, n);
                    return t && Il(s, 10 * a, c, l, e[1]),
                    s
                }
                )(e, o)
                  , s = 5 * Float32Array.BYTES_PER_ELEMENT
                  , c = 2 * Float32Array.BYTES_PER_ELEMENT
                  , u = 4 * Float32Array.BYTES_PER_ELEMENT;
                M.uniform1f(r.uWidth, t),
                M.uniform1f(r.uSharpness, l),
                M.uniform4fv(r.uColor, i),
                M.uniformMatrix4fv(r.uMatrix, !1, d),
                M.uniform4f(r.uCanvasColor, v, x, w, S),
                M.uniform1fv(r.uMaskBounds, y),
                M.uniform1f(r.uMaskOpacity, g),
                M.bindBuffer(M.ARRAY_BUFFER, N),
                M.bufferData(M.ARRAY_BUFFER, a, M.STATIC_DRAW),
                M.vertexAttribPointer(r.aPosition, 2, M.FLOAT, !1, s, 0),
                M.vertexAttribPointer(r.aNormal, 2, M.FLOAT, !1, s, c),
                M.vertexAttribPointer(r.aMiter, 1, M.FLOAT, !1, s, u),
                M.drawArrays(M.TRIANGLE_STRIP, 0, a.length / 5),
                M.disableVertexAttribArray(r.aPosition),
                M.disableVertexAttribArray(r.aNormal),
                M.disableVertexAttribArray(r.aMiter)
            }
              , H = vl(M, "\n##head\nvoid main(){\n##matrix\n}", "\n##head\n##mask\nuniform vec4 uColor;uniform vec4 uCanvasColor;void main(){vec4 fillColor=uColor;\n##maskapply\nfillColor.rgb*=fillColor.a;fillColor.rgb*=m;fillColor.rgb+=(1.0-m)*(uCanvasColor.rgb*fillColor.a);fragColor=fillColor;}", ["aPosition"], ["uColor", "uCanvasColor", "uMatrix", "uMaskBounds", "uMaskOpacity"])
              , j = M.createBuffer()
              , U = vl(M, "\n##head\n##text\nin vec2 aRectCoord;out vec2 vRectCoord;void main(){vTexCoord=aTexCoord;vRectCoord=aRectCoord;\n##matrix\n}", "\n##head\n##mask\nin vec2 vTexCoord;in vec2 vRectCoord;uniform sampler2D uTexture;uniform vec4 uTextureColor;uniform float uTextureOpacity;uniform vec2 uRepeat;uniform vec4 uColor;uniform float uCornerRadius[4];uniform vec2 uSize;uniform vec2 uPosition;uniform vec4 uCanvasColor;uniform int uInverted;uniform float uEdgeFeather;void main(){\n##init\n##colorize\n##rectaa\n##cornerradius\n##maskfeatherapply\nif(uInverted==1)a=1.0-a;\n##maskapply\n##fragcolor\n}", ["aPosition", "aTexCoord", "aRectCoord"], ["uTexture", "uColor", "uMatrix", "uCanvasColor", "uTextureColor", "uTextureOpacity", "uRepeat", "uPosition", "uSize", "uMaskBounds", "uMaskOpacity", "uMaskFeather", "uCornerRadius", "uInverted", "uEdgeFeather"])
              , V = M.createBuffer()
              , q = M.createBuffer()
              , G = M.createBuffer()
              , K = vl(M, "\n##head\n##text\nout vec2 vTexCoordDouble;void main(){vTexCoordDouble=vec2(aTexCoord.x*2.0-1.0,aTexCoord.y*2.0-1.0);vTexCoord=aTexCoord;\n##matrix\n}", "\n##head\n##mask\nin vec2 vTexCoord;in vec2 vTexCoordDouble;uniform sampler2D uTexture;uniform float uTextureOpacity;uniform vec2 uTextureAdjust;uniform vec2 uRepeat;uniform vec2 uRadius;uniform vec4 uColor;uniform int uInverted;uniform vec4 uCanvasColor;void main(){\n##init\nfloat ar=uRadius.x/uRadius.y;vec2 rAA=vec2(uRadius.x-1.0,uRadius.y-(1.0/ar));vec2 scaledPointSq=vec2((vTexCoordDouble.x*uTextureAdjust.x*uRadius.x)*(vTexCoordDouble.x*uTextureAdjust.x*uRadius.x),(vTexCoordDouble.y*uTextureAdjust.y*uRadius.y)*(vTexCoordDouble.y*uTextureAdjust.y*uRadius.y));float p=(scaledPointSq.x/(uRadius.x*uRadius.x))+(scaledPointSq.y/(uRadius.y*uRadius.y));float pAA=(scaledPointSq.x/(rAA.x*rAA.x))+(scaledPointSq.y/(rAA.y*rAA.y));a=smoothstep(1.0,p/pAA,p);if(uInverted==1)a=1.0-a;\n##maskapply\n##fragcolor\n}", ["aPosition", "aTexCoord"], ["uTexture", "uTextureOpacity", "uTextureAdjust", "uRepeat", "uColor", "uCanvasColor", "uMatrix", "uRadius", "uInverted", "uMaskBounds", "uMaskOpacity"])
              , Z = M.createBuffer()
              , Y = M.createBuffer()
              , Q = new Map
              , J = {
                2: {
                    width: 0,
                    height: 0
                },
                1: {
                    width: 0,
                    height: 0
                }
            }
              , ee = (e, t, i, n=1) => {
                const a = Math.min(Math.min(4096, r) / i.width, Math.min(4096, r) / i.height, n)
                  , l = Math.floor(a * i.width)
                  , c = Math.floor(a * i.height);
                tt(i, J[e]) ? M.bindFramebuffer(M.FRAMEBUFFER, t) : (M.bindTexture(M.TEXTURE_2D, _.get(e)),
                M.texImage2D(M.TEXTURE_2D, 0, M.RGBA, l, c, 0, M.RGBA, M.UNSIGNED_BYTE, null),
                M.texParameteri(M.TEXTURE_2D, M.TEXTURE_MIN_FILTER, M.LINEAR),
                M.texParameteri(M.TEXTURE_2D, M.TEXTURE_WRAP_S, M.CLAMP_TO_EDGE),
                M.texParameteri(M.TEXTURE_2D, M.TEXTURE_WRAP_T, M.CLAMP_TO_EDGE),
                M.bindFramebuffer(M.FRAMEBUFFER, t),
                M.framebufferTexture2D(M.FRAMEBUFFER, M.COLOR_ATTACHMENT0, M.TEXTURE_2D, _.get(e), 0),
                J[e] = i);
                const p = i.width * s
                  , h = i.height * s;
                var m;
                _l(u, 0, p, h, 0, -1, 1),
                kl(u, 0, h, 0),
                (m = u)[0] *= 1,
                m[1] *= 1,
                m[2] *= 1,
                m[3] *= 1,
                ( (e, t) => {
                    e[4] *= -1,
                    e[5] *= -1,
                    e[6] *= -1,
                    e[7] *= -1
                }
                )(u),
                d = u,
                M.viewport(0, 0, l, c),
                M.colorMask(!0, !0, !0, !0),
                M.clearColor(0, 0, 0, 0),
                M.clear(M.COLOR_BUFFER_BIT),
                b = [1, 0, 1, 0, 1, Math.max(o.width, i.width), 1, Math.max(o.width, i.width)]
            }
              , te = (e, t) => {
                const {forceRelease: i=!1} = t || {}
                  , {src: o} = Q.get(e);
                o instanceof HTMLCanvasElement && (i || o.dataset.retain || E(o)),
                Q.delete(e),
                M.deleteTexture(e)
            }
            ;
            return {
                drawPath: (e, t=0, i=!1, o=!1, n, r, a, l, c) => {
                    if (e.length < 2)
                        return;
                    const u = e.map((e => ({
                        x: e.x * s,
                        y: e.y * s
                    })))
                      , p = n * s;
                    if (p > 0 && W(u, p, wl(r, c), a),
                    u.length < 3 || !l || 0 === l[3] || !a)
                        return;
                    const h = (e => {
                        if (e.length < 3)
                            return [];
                        if ((e => {
                            const t = e.length;
                            for (let i = 0; i < t; i++) {
                                const t = st(e[i], Rl(e, i + 1));
                                if (jt(t, e, {
                                    ignoreIdenticalLines: !0,
                                    breakOnIntersection: !0
                                }))
                                    return !0
                            }
                            return !1
                        }
                        )(e))
                            return [];
                        (e => {
                            let t, i, o, n, r, a = 0;
                            const s = e.length;
                            for (t = 0; t < s; t++)
                                i = e[t],
                                o = e[(t + 1) % s],
                                n = o.x - i.x,
                                r = (o.y + i.y) / 2,
                                a += n * r;
                            return a
                        }
                        )(e) < 0 && e.reverse();
                        const t = e.length
                          , i = [...Array(t).keys()]
                          , o = [];
                        let n, r, a, s, l, c, u, d, p, h, m, f, g = 1024;
                        for (; i.length > 3; ) {
                            if (g <= 0)
                                return [];
                            for (g--,
                            n = 0; n < i.length; n++)
                                if (a = i[n],
                                s = Rl(i, n - 1),
                                l = Rl(i, n + 1),
                                c = e[a],
                                u = e[s],
                                d = e[l],
                                p = Ce(u.x - c.x, u.y - c.y),
                                h = Ce(d.x - c.x, d.y - c.y),
                                !(We(p, h) < 0)) {
                                    for (m = !0,
                                    r = 0; r < t; r++)
                                        if (r !== a && r !== s && r !== l && (f = e[r],
                                        Al(f, u, c, d))) {
                                            m = !1;
                                            break
                                        }
                                    if (m) {
                                        o.push([u, c, d]),
                                        i.splice(n, 1);
                                        break
                                    }
                                }
                        }
                        return o.push([e[i[0]], e[i[1]], e[i[2]]]),
                        o
                    }
                    )(u)
                      , m = new Float32Array(6 * h.length);
                    h.forEach(( ([e,t,i], o) => {
                        const n = 6 * o;
                        m[n + 0] = e.x,
                        m[n + 1] = e.y,
                        m[n + 2] = t.x,
                        m[n + 3] = t.y,
                        m[n + 4] = i.x,
                        m[n + 5] = i.y
                    }
                    )),
                    ( (e, t) => {
                        const {program: i, locations: o} = H;
                        M.useProgram(i),
                        M.enableVertexAttribArray(o.aPosition),
                        M.uniform4fv(o.uColor, t),
                        M.uniformMatrix4fv(o.uMatrix, !1, d),
                        M.uniform1fv(o.uMaskBounds, y),
                        M.uniform1f(o.uMaskOpacity, g),
                        M.uniform4f(o.uCanvasColor, v, x, w, S),
                        M.bindBuffer(M.ARRAY_BUFFER, j),
                        M.bufferData(M.ARRAY_BUFFER, e, M.STATIC_DRAW),
                        M.vertexAttribPointer(o.aPosition, 2, M.FLOAT, !1, 0, 0),
                        M.drawArrays(M.TRIANGLES, 0, e.length / 2),
                        M.disableVertexAttribArray(o.aPosition)
                    }
                    )(m, wl(l, c))
                }
                ,
                drawRect: (e, t=0, i=!1, o=!1, n, r, a, l=void 0, c=void 0, u=!1, p=void 0, h, m, f, $=void 0, _=1 / s, k, C) => {
                    const T = kt(pt(e), s)
                      , E = n.map((t => ( (e, t) => Math.floor(cs(e, 0, Math.min(.5 * (t.width - 1), .5 * (t.height - 1)))))(t || 0, e))).map((e => e * s));
                    if (r || a) {
                        const e = pt(T);
                        e.x -= .5,
                        e.y -= .5,
                        e.width += 1,
                        e.height += 1;
                        const n = Dl(e, t, i, o)
                          , h = Ll(n);
                        let m;
                        k && (m = wl(k),
                        0 === m[3] && (m[3] = .001));
                        const R = l && u ? [e.width / l.width, e.height / l.height] : [1, 1];
                        ( (e, t, i, o, n, r=P, a, l=1, c=Vl, u=Nl, p=b, h=1, m) => {
                            const {program: f, locations: $} = U;
                            M.useProgram(f),
                            M.enableVertexAttribArray($.aPosition),
                            M.enableVertexAttribArray($.aTexCoord),
                            M.enableVertexAttribArray($.aRectCoord),
                            M.uniform4fv($.uColor, n),
                            M.uniform2fv($.uSize, [t, i]),
                            M.uniform2fv($.uPosition, [e[2], e[3]]),
                            M.uniform2fv($.uRepeat, a),
                            M.uniform1i($.uInverted, m ? 1 : 0),
                            M.uniform1fv($.uCornerRadius, o),
                            M.uniform4f($.uCanvasColor, v, x, w, S),
                            M.uniform1fv($.uMaskFeather, p.map(( (e, t) => t % 2 == 0 ? e : e * s))),
                            M.uniform1fv($.uMaskBounds, y),
                            M.uniform1f($.uMaskOpacity, g),
                            M.uniform1f($.uEdgeFeather, Math.max(0, h)),
                            M.uniformMatrix4fv($.uMatrix, !1, d),
                            M.uniform1i($.uTexture, 4),
                            M.uniform4fv($.uTextureColor, c),
                            M.uniform1f($.uTextureOpacity, l),
                            M.activeTexture(M.TEXTURE0 + 4),
                            M.bindTexture(M.TEXTURE_2D, r),
                            M.bindBuffer(M.ARRAY_BUFFER, q),
                            M.bufferData(M.ARRAY_BUFFER, u, M.STATIC_DRAW),
                            M.vertexAttribPointer($.aTexCoord, 2, M.FLOAT, !1, 0, 0),
                            M.bindBuffer(M.ARRAY_BUFFER, G),
                            M.bufferData(M.ARRAY_BUFFER, Nl, M.STATIC_DRAW),
                            M.vertexAttribPointer($.aRectCoord, 2, M.FLOAT, !1, 0, 0),
                            M.bindBuffer(M.ARRAY_BUFFER, V),
                            M.bufferData(M.ARRAY_BUFFER, e, M.STATIC_DRAW),
                            M.vertexAttribPointer($.aPosition, 2, M.FLOAT, !1, 0, 0),
                            M.drawArrays(M.TRIANGLE_STRIP, 0, e.length / 2),
                            M.disableVertexAttribArray($.aPosition),
                            M.disableVertexAttribArray($.aTexCoord),
                            M.disableVertexAttribArray($.aRectCoord)
                        }
                        )(h, e.width, e.height, E, wl(r, f), a, R, f, m, p ? new Float32Array(p) : Gl(e.width, e.height, l, c, s), $, _ * s, C)
                    }
                    h && (h = Math.min(h, T.width, T.height),
                    W(( (e, t, i, o, n, r, a, s) => {
                        const l = [];
                        if (r.every((e => 0 === e)))
                            l.push(Ce(e, t), Ce(e + i, t), Ce(e + i, t + o), Ce(e, t + o));
                        else {
                            const [n,a,s,c] = r
                              , u = e
                              , d = e + i
                              , p = t
                              , h = t + o;
                            l.push(Ce(u + n, p)),
                            zl(l, d - a, p + a, a, -1),
                            l.push(Ce(d, p + a)),
                            zl(l, d - c, h - c, c, 0),
                            l.push(Ce(d - c, h)),
                            zl(l, u + s, h - s, s, 1),
                            l.push(Ce(u, h - s)),
                            zl(l, u + n, p + n, n, 2)
                        }
                        return (a || s) && qe(l, a, s, e + .5 * i, t + .5 * o),
                        n && Ge(l, n, e + .5 * i, t + .5 * o),
                        l
                    }
                    )(T.x, T.y, T.width, T.height, t, E, i, o), h * s, wl(m, f), !0))
                }
                ,
                drawEllipse: (e, t, i, o, n, r, a, l, c=void 0, u=void 0, p=void 0, h, m, f, $) => {
                    const b = kt(bt(e.x - t, e.y - i, 2 * t, 2 * i), s);
                    if (a || l) {
                        const e = pt(b);
                        $ || (e.x -= .5,
                        e.y -= .5,
                        e.width += 1,
                        e.height += 1);
                        const t = Dl(e, o, n, r);
                        ( (e, t, i, o, n=P, r, a=Nl, s=1, l=!1) => {
                            const {program: c, locations: u} = K;
                            M.useProgram(c),
                            M.enableVertexAttribArray(u.aPosition),
                            M.enableVertexAttribArray(u.aTexCoord),
                            M.uniformMatrix4fv(u.uMatrix, !1, d),
                            M.uniform2fv(u.uRadius, [.5 * t, .5 * i]),
                            M.uniform2fv(u.uTextureAdjust, [r.width / (.5 * t), r.height / (.5 * i)]),
                            M.uniform1i(u.uInverted, l ? 1 : 0),
                            M.uniform4fv(u.uColor, o),
                            M.uniform4f(u.uCanvasColor, v, x, w, S),
                            M.uniform2fv(u.uRepeat, [1, 1]),
                            M.uniform1fv(u.uMaskBounds, y),
                            M.uniform1f(u.uMaskOpacity, g),
                            M.uniform1i(u.uTexture, 4),
                            M.uniform1f(u.uTextureOpacity, s),
                            M.activeTexture(M.TEXTURE0 + 4),
                            M.bindTexture(M.TEXTURE_2D, n),
                            M.bindBuffer(M.ARRAY_BUFFER, Y),
                            M.bufferData(M.ARRAY_BUFFER, a, M.STATIC_DRAW),
                            M.vertexAttribPointer(u.aTexCoord, 2, M.FLOAT, !1, 0, 0),
                            M.bindBuffer(M.ARRAY_BUFFER, Z),
                            M.bufferData(M.ARRAY_BUFFER, e, M.STATIC_DRAW),
                            M.vertexAttribPointer(u.aPosition, 2, M.FLOAT, !1, 0, 0),
                            M.drawArrays(M.TRIANGLE_STRIP, 0, e.length / 2),
                            M.disableVertexAttribArray(u.aPosition),
                            M.disableVertexAttribArray(u.aTexCoord)
                        }
                        )(Ll(t), e.width, e.height, wl(a, f), l, c || et(.5 * e.width, .5 * e.height), p ? new Float32Array(p) : Gl(e.width, e.height, c, u, s), f, $)
                    }
                    h && W(( (e, t, i, o, n, r, a) => {
                        const s = .5 * Math.abs(i)
                          , l = .5 * Math.abs(o)
                          , c = Math.abs(i) + Math.abs(o)
                          , u = Math.max(20, Math.round(c / 6));
                        return Gt(Ce(e + s, t + l), s, l, n, r, a, u)
                    }
                    )(b.x, b.y, b.width, b.height, o, n, r), h * s, wl(m, f), !0)
                }
                ,
                drawImage: (e, t, i, n, r, l, c, u, d, p, h=Ul, m=1, f, b=1, v=0, x=$, w=ql, S=Vl, k=!1, P=!1, E=!0) => {
                    const R = t.width * s
                      , A = t.height * s
                      , I = -.5 * R
                      , L = .5 * A
                      , B = .5 * R
                      , N = -.5 * A
                      , W = new Float32Array([I, N, 0, I, L, 0, B, N, 0, B, L, 0]);
                    M.bindBuffer(M.ARRAY_BUFFER, z),
                    M.bufferData(M.ARRAY_BUFFER, W, M.STATIC_DRAW);
                    const H = t.height / 2 / T * (o.height / t.height) * -1;
                    r *= s,
                    l *= s,
                    i *= s,
                    n *= s;
                    const {program: j, locations: U} = D
                      , V = Sl();
                    ( (e, t, i, o, n) => {
                        const r = 1 / Math.tan(t / 2)
                          , a = 1 / (1 - n);
                        e[0] = r / i,
                        e[1] = 0,
                        e[2] = 0,
                        e[3] = 0,
                        e[4] = 0,
                        e[5] = r,
                        e[6] = 0,
                        e[7] = 0,
                        e[8] = 0,
                        e[9] = 0,
                        e[10] = (n + 1) * a,
                        e[11] = -1,
                        e[12] = 0,
                        e[13] = 0,
                        e[14] = 2 * n * 1 * a,
                        e[15] = 0
                    }
                    )(V, C, a, 0, 2 * -H),
                    kl(V, r, -l, H),
                    kl(V, i, -n, 0),
                    Pl(V, -d),
                    Cl(V, p),
                    kl(V, -i, n, 0),
                    Ml(V, u),
                    Tl(V, c),
                    M.useProgram(j),
                    M.enableVertexAttribArray(U.aPosition),
                    M.enableVertexAttribArray(U.aTexCoord),
                    M.uniform1i(U.uTexture, 3),
                    M.uniform2f(U.uTextureSize, t.width, t.height),
                    M.activeTexture(M.TEXTURE0 + 3),
                    M.bindTexture(M.TEXTURE_2D, e);
                    const q = P ? 1 : 0
                      , G = _.get(q);
                    M.uniform1i(U.uTextureBlend, q),
                    M.activeTexture(M.TEXTURE0 + q),
                    M.bindTexture(M.TEXTURE_2D, G);
                    const K = k ? 2 : 0
                      , X = _.get(K);
                    M.uniform1i(U.uTextureOverlay, K),
                    M.activeTexture(M.TEXTURE0 + K),
                    M.bindTexture(M.TEXTURE_2D, X),
                    M.bindBuffer(M.ARRAY_BUFFER, z),
                    M.vertexAttribPointer(U.aPosition, 3, M.FLOAT, !1, 0, 0);
                    const Z = Hl && (e => Q.get(e).isRotatedVideo)(e);
                    let Y;
                    M.bindBuffer(M.ARRAY_BUFFER, Z ? O : F),
                    M.vertexAttribPointer(U.aTexCoord, 2, M.FLOAT, !1, 0, 0),
                    M.uniformMatrix4fv(U.uMatrix, !1, V),
                    M.uniform4fv(U.uOverlayColor, S),
                    !f || ms(f, jl) ? (f = jl,
                    Y = -1) : (Y = f.reduce(( (e, t) => e + t), 0),
                    Y = Y <= 0 ? 1 : Y),
                    M.uniform1fv(U.uClarityKernel, f),
                    M.uniform1f(U.uClarityKernelWeight, Y),
                    M.uniform1f(U.uColorGamma, 1 / b),
                    M.uniform1f(U.uColorVignette, v),
                    M.uniform1i(U.uAntialias, E ? 1 : 0),
                    M.uniform4f(U.uColorOffset, h[4], h[9], h[14], h[19]),
                    M.uniformMatrix4fv(U.uColorMatrix, !1, [h[0], h[1], h[2], h[3], h[5], h[6], h[7], h[8], h[10], h[11], h[12], h[13], h[15], h[16], h[17], h[18]]),
                    M.uniform1f(U.uOpacity, m),
                    M.uniform1f(U.uMaskOpacity, g),
                    M.uniform1fv(U.uMaskBounds, y),
                    M.uniform1fv(U.uMaskCornerRadius, w.map((e => e * s))),
                    M.uniform1fv(U.uMaskFeather, x.map(( (e, t) => t % 2 == 0 ? e : e * s))),
                    M.drawArrays(M.TRIANGLE_STRIP, 0, 4),
                    M.disableVertexAttribArray(U.aPosition),
                    M.disableVertexAttribArray(U.aTexCoord)
                }
                ,
                textureFilterNearest: M.NEAREST,
                textureFilterLinear: M.LINEAR,
                textureClamp: M.CLAMP_TO_EDGE,
                textureRepeat: M.REPEAT,
                textureCreate: () => M.createTexture(),
                textureUpdate: (e, t, i) => (Q.set(e, {
                    src: t,
                    options: i,
                    isRotatedVideo: "VIDEO" === t.nodeName && (t.dataset && 90 == t.dataset.rotation || 270 == t.dataset.rotation)
                }),
                ( (e, t, i, o) => (e.bindTexture(e.TEXTURE_2D, t),
                e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, i),
                ( (e, t, i) => {
                    e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, xl(t) ? e.LINEAR_MIPMAP_LINEAR : e.LINEAR),
                    e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, i.filterParam),
                    e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, i.wrapParam),
                    e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, i.wrapParam),
                    xl(t) && e.generateMipmap(e.TEXTURE_2D)
                }
                )(e, i, o),
                e.bindTexture(e.TEXTURE_2D, null),
                t))(M, e, t, i)),
                textureGetSize: e => {
                    const {src: t, options: i} = Q.get(e)
                      , o = Ze(t);
                    return i.scalar ? at(o, (e => e / i.scalar)) : o
                }
                ,
                textureDelete: te,
                enablePreviewStencil: () => {
                    M.stencilOp(M.KEEP, M.KEEP, M.REPLACE),
                    M.stencilFunc(M.ALWAYS, 1, 255),
                    M.stencilMask(255)
                }
                ,
                applyPreviewStencil: () => {
                    M.stencilFunc(M.EQUAL, 1, 255),
                    M.stencilMask(0)
                }
                ,
                disablePreviewStencil: k,
                setCanvasColor(e) {
                    v = e[0],
                    x = e[1],
                    w = e[2],
                    S = i ? e[3] : 1,
                    M.clear(M.COLOR_BUFFER_BIT)
                },
                resetCanvasMatrix: () => {
                    _l(c, 0, o.width, o.height, 0, -1, 1)
                }
                ,
                updateCanvasMatrix(e, t, i, n, r) {
                    const a = e.width
                      , l = e.height
                      , u = o.width * (.5 / s)
                      , d = o.height * (.5 / s)
                      , p = {
                        x: u + (i.x + t.x),
                        y: d + (i.y + t.y)
                    }
                      , h = {
                        x: p.x - t.x,
                        y: p.y - t.y
                    }
                      , m = .5 * a
                      , f = .5 * l;
                    Ee(h, r.z, p),
                    Ue(h, n, p),
                    kl(c, (h.x - m) * s, (h.y - f) * s, 0),
                    kl(c, m * s, f * s, 0),
                    Pl(c, r.z);
                    const g = r.x > Math.PI / 2;
                    Tl(c, g ? Math.PI : 0);
                    const y = r.y > Math.PI / 2;
                    Ml(c, y ? Math.PI : 0),
                    Cl(c, n),
                    kl(c, -m * s, -f * s, 0)
                },
                drawToCanvas() {
                    M.bindFramebuffer(M.FRAMEBUFFER, null),
                    d = c,
                    M.viewport(0, 0, M.drawingBufferWidth, M.drawingBufferHeight),
                    M.colorMask(!0, !0, !0, !0),
                    M.clearColor(v, x, w, S),
                    M.clear(M.COLOR_BUFFER_BIT),
                    b = [1, 0, 1, 0, 1, o.width, 1, o.width]
                },
                drawToImageBlendBuffer(e, t) {
                    ee(1, L, e, t)
                },
                drawToImageOverlayBuffer(e, t) {
                    ee(2, A, e, t)
                },
                enableMask(e, t) {
                    const i = e.x * s
                      , n = e.y * s
                      , r = e.width * s
                      , a = e.height * s;
                    f = i,
                    h = f + r,
                    p = o.height - n,
                    m = o.height - (n + a),
                    g = 1 - t,
                    y = [p, h, m, f]
                },
                disableMask() {
                    f = 0,
                    h = o.width,
                    p = o.height,
                    m = 0,
                    g = 1,
                    y = [p, h, m, f]
                },
                resize: (t, i, r) => {
                    s = Math.max(1, r),
                    l = 1 === s ? .75 : 1,
                    n.width = t,
                    n.height = i,
                    o.width = t * s,
                    o.height = i * s,
                    a = ae(o.width, o.height),
                    e.width = o.width,
                    e.height = o.height,
                    _l(c, 0, o.width, o.height, 0, -1, 1),
                    $ = [1, 0, 1, 0, 1, n.width, 1, n.width]
                }
                ,
                release() {
                    Array.from(Q.keys()).forEach((e => te(e, {
                        forceRelease: !0
                    }))),
                    Q.clear(),
                    _.forEach((e => {
                        M.deleteTexture(e)
                    }
                    )),
                    _.clear(),
                    D.destroy(),
                    B.destroy(),
                    H.destroy(),
                    U.destroy(),
                    K.destroy(),
                    e.width = 1,
                    e.height = 1,
                    e = void 0
                }
            }
        }
          , Xl = (e, t) => {
            const {imageData: i, amount: o=1} = e
              , n = Math.round(2 * Math.max(1, o))
              , r = Math.round(.5 * n)
              , a = i.width
              , s = i.height
              , l = new Uint8ClampedArray(a * s * 4)
              , c = i.data;
            let u, d, p, h, m, f = 0, g = 0, y = 0;
            const $ = a * s * 4 - 4;
            for (p = 0; p < s; p++)
                for (u = crypto.getRandomValues(new Uint8ClampedArray(s)),
                d = 0; d < a; d++)
                    h = u[p] / 255,
                    g = 0,
                    y = 0,
                    h < .5 && (g = 4 * (-r + Math.round(Math.random() * n))),
                    h > .5 && (y = (-r + Math.round(Math.random() * n)) * (4 * a)),
                    m = Math.min(Math.max(0, f + g + y), $),
                    l[f] = c[m],
                    l[f + 1] = c[m + 1],
                    l[f + 2] = c[m + 2],
                    l[f + 3] = c[m + 3],
                    f += 4;
            t(null, {
                data: l,
                width: i.width,
                height: i.height
            })
        }
        ;
        const Zl = [.0625, .125, .0625, .125, .25, .125, .0625, .125, .0625];
        function Yl(e) {
            return Math.sqrt(1 - --e * e)
        }
        function Ql(e) {
            return "[object Date]" === Object.prototype.toString.call(e)
        }
        function Jl(e, t) {
            if (e === t || e != e)
                return () => e;
            const i = typeof e;
            if (i !== typeof t || Array.isArray(e) !== Array.isArray(t))
                throw new Error("Cannot interpolate values of different type");
            if (Array.isArray(e)) {
                const i = t.map(( (t, i) => Jl(e[i], t)));
                return e => i.map((t => t(e)))
            }
            if ("object" === i) {
                if (!e || !t)
                    throw new Error("Object cannot be null");
                if (Ql(e) && Ql(t)) {
                    e = e.getTime();
                    const i = (t = t.getTime()) - e;
                    return t => new Date(e + t * i)
                }
                const i = Object.keys(t)
                  , o = {};
                return i.forEach((i => {
                    o[i] = Jl(e[i], t[i])
                }
                )),
                e => {
                    const t = {};
                    return i.forEach((i => {
                        t[i] = o[i](e)
                    }
                    )),
                    t
                }
            }
            if ("number" === i) {
                const i = t - e;
                return t => e + t * i
            }
            throw new Error(`Cannot interpolate ${i} values`)
        }
        function ec(e, t={}) {
            const i = ja(e);
            let o, n = e;
            function r(r, a) {
                if (null == e)
                    return i.set(e = r),
                    Promise.resolve();
                n = r;
                let s = o
                  , l = !1
                  , {delay: c=0, duration: u=400, easing: d=er, interpolate: p=Jl} = tr(tr({}, t), a);
                if (0 === u)
                    return s && (s.abort(),
                    s = null),
                    i.set(e = n),
                    Promise.resolve();
                const h = vr() + c;
                let m;
                return o = _r((t => {
                    if (t < h)
                        return !0;
                    l || (m = p(e, r),
                    "function" == typeof u && (u = u(e, r)),
                    l = !0),
                    s && (s.abort(),
                    s = null);
                    const o = t - h;
                    return o > u ? (i.set(e = r),
                    !1) : (i.set(e = m(d(o / u))),
                    !0)
                }
                )),
                o.promise
            }
            return {
                set: r,
                update: (t, i) => r(t(n, e), i),
                subscribe: i.subscribe
            }
        }
        function tc(e, t, i, o) {
            if ("number" == typeof i) {
                const n = o - i
                  , r = (i - t) / (e.dt || 1 / 60)
                  , a = (r + (e.opts.stiffness * n - e.opts.damping * r) * e.inv_mass) * e.dt;
                return Math.abs(a) < e.opts.precision && Math.abs(n) < e.opts.precision ? o : (e.settled = !1,
                i + a)
            }
            if (Ui(i))
                return i.map(( (n, r) => tc(e, t[r], i[r], o[r])));
            if ("object" == typeof i) {
                const n = {};
                for (const r in i)
                    n[r] = tc(e, t[r], i[r], o[r]);
                return n
            }
            throw new Error(`Cannot spring ${typeof i} values`)
        }
        function ic(e, t={}) {
            const i = ja(e)
              , {stiffness: o=.15, damping: n=.8, precision: r=.01} = t;
            let a, s, l, c = e, u = e, d = 1, p = 0, h = !1;
            function m(t, o={}) {
                u = t;
                const n = l = {};
                if (null == e || o.hard || f.stiffness >= 1 && f.damping >= 1)
                    return h = !0,
                    a = null,
                    c = t,
                    i.set(e = u),
                    Promise.resolve();
                if (o.soft) {
                    const e = !0 === o.soft ? .5 : +o.soft;
                    p = 1 / (60 * e),
                    d = 0
                }
                if (!s) {
                    a = null,
                    h = !1;
                    const t = {
                        inv_mass: void 0,
                        opts: f,
                        settled: !0,
                        dt: void 0
                    };
                    s = _r((o => {
                        if (null === a && (a = o),
                        h)
                            return h = !1,
                            s = null,
                            !1;
                        d = Math.min(d + p, 1),
                        t.inv_mass = d,
                        t.opts = f,
                        t.settled = !0,
                        t.dt = 60 * (o - a) / 1e3;
                        const n = tc(t, c, e, u);
                        return a = o,
                        c = e,
                        i.set(e = n),
                        t.settled && (s = null),
                        !t.settled
                    }
                    ))
                }
                return new Promise((e => {
                    s.promise.then(( () => {
                        n === l && e()
                    }
                    ))
                }
                ))
            }
            const f = {
                set: m,
                update: (t, i) => m(t(u, e), i),
                subscribe: i.subscribe,
                stiffness: o,
                damping: n,
                precision: r
            };
            return f
        }
        var oc = Ha(!1, (e => {
            const t = window.matchMedia("(prefers-reduced-motion:reduce)")
              , i = () => e(t.matches);
            return i(),
            t.addListener(i),
            () => t.removeListener(i)
        }
        ))
          , nc = () => "ResizeObserver"in window;
        const rc = ht()
          , ac = (e, t, i, o, n) => {
            e.rect || (e.rect = ht());
            const r = e.rect;
            Mt(rc, t, i, o, n),
            Ct(r, rc) || (Pt(r, rc),
            e.dispatchEvent(new CustomEvent("measure",{
                detail: r
            })))
        }
          , sc = Math.round
          , lc = e => {
            const t = e.getBoundingClientRect();
            dc && ac(e, sc(t.x), sc(t.y), sc(t.width), sc(t.height))
        }
          , cc = e => {
            dc && ac(e, e.offsetLeft, e.offsetTop, e.offsetWidth, e.offsetHeight)
        }
          , uc = [];
        let dc, pc, hc;
        function mc() {
            uc.length ? (uc.forEach((e => e.measure(e))),
            dc = requestAnimationFrame(mc)) : dc = void 0
        }
        let fc = new Map([])
          , gc = 0
          , yc = 0;
        var $c = (e, t={}) => {
            const {observePosition: i=!1, observeViewRect: o=!1, once: n=!1, disabled: r=!1, isMeasureRoot: a=!1} = t;
            if (nc() && a && (hc || (hc = new ResizeObserver((e => {
                e.forEach((e => {
                    fc.set(e.target, e.contentRect)
                }
                ));
                const t = Array.from(fc.values()).some(( ({width: e, height: t}) => e > 0 && t > 0));
                t ? t && !1 === dc && mc() : (dc && cancelAnimationFrame(dc),
                dc = !1)
            }
            ))),
            hc.observe(e),
            gc++),
            !r)
                return !nc() || i || o ? (e.measure = o ? lc : cc,
                uc.push(e),
                void 0 === dc && (dc = requestAnimationFrame(mc)),
                e.measure(e),
                {
                    destroy() {
                        a && hc && (fc.delete(e),
                        hc.unobserve(e),
                        gc--,
                        0 === gc && (hc.disconnect(),
                        hc = void 0));
                        const t = uc.indexOf(e);
                        uc.splice(t, 1),
                        delete e.measure
                    }
                }) : (pc || (pc = new ResizeObserver((e => {
                    e.forEach((e => {
                        dc && cc(e.target)
                    }
                    ))
                }
                ))),
                pc.observe(e),
                cc(e),
                n ? pc.unobserve(e) : yc++,
                {
                    destroy() {
                        a && hc && (fc.delete(e),
                        hc.unobserve(e),
                        gc--,
                        0 === gc && (hc.disconnect(),
                        hc = void 0)),
                        n || (pc.unobserve(e),
                        yc--,
                        0 === yc && (pc.disconnect(),
                        pc = void 0))
                    }
                })
        }
          , bc = e => {
            let t = !1;
            const i = {
                pointerdown: () => {
                    t = !1
                }
                ,
                keydown: () => {
                    t = !0
                }
                ,
                keyup: () => {
                    t = !1
                }
                ,
                focus: e => {
                    t && (e.target.dataset.focusVisible = "")
                }
                ,
                blur: e => {
                    delete e.target.dataset.focusVisible
                }
            };
            return Object.keys(i).forEach((t => e.addEventListener(t, i[t], !0))),
            {
                destroy() {
                    Object.keys(i).forEach((t => e.removeEventListener(t, i[t], !0)))
                }
            }
        }
        ;
        const vc = async e => new Promise((t => {
            if ("file" === e.kind)
                return t(e.getAsFile());
            e.getAsString(t)
        }
        ));
        var xc = (e, t={}) => {
            const i = e => {
                e.preventDefault()
            }
              , o = async i => {
                i.preventDefault(),
                i.stopPropagation();
                try {
                    const o = await (e => new Promise(( (t, i) => {
                        const {items: o} = e.dataTransfer;
                        if (!o)
                            return t([]);
                        Promise.all(Array.from(o).map(vc)).then((e => {
                            t(e.filter((e => Zi(e) && ui(e) || /^http/.test(e))))
                        }
                        )).catch(i)
                    }
                    )))(i);
                    e.dispatchEvent(new CustomEvent("dropfiles",{
                        detail: {
                            event: i,
                            resources: o
                        },
                        ...t
                    }))
                } catch (e) {}
            }
            ;
            return e.addEventListener("drop", o),
            e.addEventListener("dragover", i),
            {
                destroy() {
                    e.removeEventListener("drop", o),
                    e.removeEventListener("dragover", i)
                }
            }
        }
        ;
        let wc = null;
        var Sc = () => {
            if (null === wc)
                if (_()) {
                    const e = M("canvas");
                    wc = !El(e, {
                        failIfMajorPerformanceCaveat: !0
                    }),
                    E(e)
                } else
                    wc = !1;
            return wc
        }
          , _c = e => e instanceof WebGLTexture
          , kc = ([e,t,i,o]) => [o.x, o.y, e.x, e.y, i.x, i.y, t.x, t.y];
        function Cc(e) {
            let t, i, o, n;
            return {
                c() {
                    t = Er("div"),
                    i = Er("canvas"),
                    Or(t, "class", "PinturaCanvas")
                },
                m(r, a) {
                    Mr(r, t, a),
                    kr(t, i),
                    e[37](i),
                    o || (n = [Dr(i, "measure", e[38]), $r($c.call(null, i))],
                    o = !0)
                },
                p: Jn,
                i: Jn,
                o: Jn,
                d(i) {
                    i && Pr(t),
                    e[37](null),
                    o = !1,
                    nr(n)
                }
            }
        }
        function Tc(e, t, i) {
            let o, n, r, a, s, l, c;
            const u = [0, 0, 0, 0]
              , d = ke()
              , p = _() && (e => {
                const t = 64
                  , i = M("canvas", {
                    "data-retain": !0,
                    width: 128,
                    height: 128
                })
                  , o = i.getContext("2d");
                return o.fillStyle = "#f0f",
                o.fillRect(0, 0, t, t),
                o.fillRect(t, t, t, t),
                i
            }
            )()
              , h = ta();
            let m, {isAnimated: f} = t, {isTransparent: g} = t, {maskRect: y} = t, {maskOpacity: b=1} = t, {maskFrameOpacity: v=.95} = t, {maskMarkupOpacity: x=1} = t, {clipAnnotationsToImage: w=!0} = t, {pixelRatio: S=1} = t, {textPixelRatio: k=S} = t, {backgroundColor: C} = t, {willRender: T=se} = t, {didRender: P=se} = t, {willRequest: A} = t, {csp: I} = t, {loadImageData: L=se} = t, {enableGrid: D=!1} = t, {gridColors: z} = t, {gridSize: F} = t, {gridOpacity: O=0} = t, {images: B=[]} = t, {interfaceImages: N=[]} = t, {selectionColor: H} = t, j = null, U = null, V = null;
            const q = (e, t) => e.set(t, {
                hard: !f
            })
              , G = {
                precision: 1e-4 * .01
            };
            let K = 0;
            const Z = ec(void 0, {
                duration: 0
            });
            cr(e, Z, (e => i(36, c = e)));
            const Y = ic(1, G);
            cr(e, Y, (e => i(35, s = e)));
            const Q = ic(1, G);
            cr(e, Q, (e => i(51, r = e)));
            const J = ja();
            cr(e, J, (e => i(53, l = e)));
            const ee = ja();
            cr(e, ee, (e => i(52, a = e)));
            const te = {};
            let ie;
            const oe = () => {
                cancelAnimationFrame(ie),
                ie = requestAnimationFrame(( () => {
                    Se = !0,
                    ze = 0,
                    n()
                }
                ))
            }
              , ne = new Map([])
              , re = new Map([])
              , le = (e, t) => ({
                filterParam: "pixelated" === e ? j.textureFilterNearest : j.textureFilterLinear,
                wrapParam: "repeat" === t ? j.textureRepeat : j.textureClamp
            })
              , ce = (e, t, i) => {
                if (!ne.has(e)) {
                    ne.set(e, e);
                    const n = le(t, i);
                    if (!W(o = e) && (vi(o) || R(o) || Rn(o) || pi(o))) {
                        const t = j.textureCreate();
                        j.textureUpdate(t, e, n),
                        ne.set(e, t)
                    } else
                        L(e).then((t => {
                            if (!j || !t)
                                return;
                            const i = j.textureCreate();
                            j.textureUpdate(i, t, n),
                            ne.set(e, i),
                            oe()
                        }
                        )).catch((t => {
                            ne.set(e, t)
                        }
                        ))
                }
                var o, n;
                if (pi(e) && ((n = e).currentTime > 0 && !n.paused && !n.ended && n.readyState > 2 || "true" === e.dataset.redraw)) {
                    const o = ne.get(e)
                      , n = le(t, i);
                    return j.textureUpdate(o, e, n),
                    e.dataset.redraw = !1,
                    o
                }
                return ne.get(e)
            }
              , ue = (e, t={}) => {
                const i = t.id || e.id;
                if (e.width && e.width < 1 || e.height && e.height < 1 || !e.text.length)
                    return void re.delete(i);
                let {text: o, textAlign: n, fontFamily: r, fontSize: a=16, fontWeight: s, fontVariant: l, fontStyle: c, letterSpacing: u, lineHeight: d=a, width: p, height: h} = e
                  , {outline: m=0, blur: f=0, paddingTop: g=0, paddingRight: y=0, paddingBottom: $=0, paddingLeft: b=0} = t;
                p = Wi(p) ? Math.floor(p) : p,
                h = Wi(h) ? Math.floor(h) : h;
                const {textSize: v, signature: x} = ( (e="", t) => {
                    let {width: i=0, height: o="auto", fontSize: n, fontFamily: r, lineHeight: a, fontWeight: s, fontStyle: l, fontVariant: c, letterSpacing: u} = t;
                    const d = Ji({
                        text: e,
                        fontFamily: r,
                        fontWeight: s,
                        fontStyle: l,
                        fontVariant: c,
                        fontSize: n,
                        lineHeight: a,
                        letterSpacing: u,
                        width: i,
                        height: o
                    });
                    let p = so.get(d);
                    if (p)
                        return p;
                    let h = 1;
                    n > 1e3 && X() && (h = n / 1e3,
                    n = 1e3,
                    a *= h);
                    const m = ri(M("pre", {
                        contenteditable: "true",
                        spellcheck: "false",
                        style: `${co}${ro({
                            fontFamily: r,
                            fontWeight: s,
                            fontStyle: l,
                            fontVariant: c,
                            fontSize: n,
                            letterSpacing: u,
                            lineHeight: a
                        })};${ao(e, t)}"`,
                        innerHTML: e
                    }))
                      , f = m.getBoundingClientRect();
                    return p = {
                        signature: lo(m).flat().map((e => e.text)).join("_;_"),
                        textSize: at(Ze(f), (e => Math.ceil(e * h)))
                    },
                    so.set(d, p),
                    m.remove(),
                    p
                }
                )(o, {
                    ...e,
                    width: p,
                    height: void 0
                })
                  , w = Ji({
                    text: o,
                    textAlign: n,
                    fontFamily: r,
                    fontSize: a,
                    fontWeight: s,
                    fontVariant: l,
                    fontStyle: c,
                    lineHeight: d,
                    letterSpacing: u,
                    outline: m,
                    blur: f,
                    signature: x
                });
                if (!ne.has(w)) {
                    ne.set(w, o);
                    const e = Math.ceil(v.width)
                      , t = Math.ceil(v.height);
                    if (0 === e || 0 === t)
                        return;
                    const x = Ol()
                      , S = Math.min(1, (x - (b + y) * k) / (e * k), (x - (g + $) * k) / (t * k));
                    wo(o, {
                        fontSize: a,
                        fontFamily: r,
                        fontWeight: s,
                        fontVariant: l,
                        fontStyle: c,
                        letterSpacing: u,
                        textAlign: n,
                        lineHeight: d,
                        width: p,
                        height: h,
                        imageWidth: e,
                        imageHeight: t,
                        paddingLeft: b,
                        paddingTop: g,
                        paddingRight: y,
                        paddingBottom: $,
                        pixelRatio: k * S,
                        willRequest: A,
                        outline: m,
                        blur: f,
                        styleNonce: I.styleNonce,
                        color: [1, 0, 1]
                    }).then((e => {
                        if (!j)
                            return;
                        const t = j.textureCreate();
                        j.textureUpdate(t, e, {
                            filterParam: j.textureFilterLinear,
                            wrapParam: j.textureClamp,
                            scalar: S
                        }),
                        ne.set(w, t),
                        re.set(i, t),
                        oe()
                    }
                    )).catch(console.error)
                }
                const S = ne.get(w);
                return _c(S) ? S : re.get(i)
            }
              , de = new Map
              , pe = ({texture: e, size: t, origin: i, translation: o, rotation: n, scale: r, colorMatrix: a, opacity: s, convolutionMatrix: l, gamma: c, vignette: u, maskFeather: d, maskCornerRadius: p, overlayColor: h, enableOverlay: m, enableManipulation: f, enableAntialiasing: g}) => {
                let y = 0
                  , $ = 0;
                if (1 === S) {
                    const e = Math.abs(1 - r) < Number.EPSILON;
                    y = e && U % 2 != 0 ? .5 : 0,
                    $ = e && V % 2 != 0 ? .5 : 0
                }
                return j.drawImage(e, t, i.x, i.y, o.x + y, o.y + $, n.x, n.y, n.z, r, a, cs(s, 0, 1), l, c, u, d, p, h, m, f, g),
                e
            }
              , he = (e, t, i) => {
                const o = vt(t)
                  , n = vt(e)
                  , r = o.x - n.x
                  , a = o.y - n.y
                  , s = Ee(o, i, n);
                return {
                    x: s.x - n.x - r,
                    y: s.y - n.y - a
                }
            }
              , me = (e, t, i) => {
                let o, n;
                const r = ae(i.width, i.height);
                if ("repeat" === e.backgroundRepeat && (o = {
                    ...i
                },
                n = {
                    x: 0,
                    y: 0
                }),
                "contain" === e.backgroundSize) {
                    const i = Lt(t, r, t);
                    o = Ye(i),
                    n = e.backgroundPosition ? e.backgroundPosition : Ce(.5 * (t.width - o.width), .5 * (t.height - o.height))
                } else if ("cover" === e.backgroundSize) {
                    const i = It(t, r, t);
                    o = Ye(i),
                    e.backgroundPosition ? n = e.backgroundPosition : (n = Ce(i.x, i.y),
                    n = Ce(.5 * (t.width - o.width), .5 * (t.height - o.height)))
                } else
                    e.backgroundSize ? (o = e.backgroundSize,
                    n = e.backgroundPosition || {
                        x: 0,
                        y: 0
                    }) : e.backgroundPosition && (o = {
                        ...i
                    },
                    n = e.backgroundPosition);
                return {
                    backgroundSize: o,
                    backgroundPosition: n
                }
            }
              , fe = (e=[], t) => {
                e.forEach((e => {
                    let i = (e => {
                        let t;
                        return e.backgroundImage ? t = ce(e.backgroundImage, e.backgroundImageRendering, "repeat" === e.backgroundRepeat ? "repeat" : void 0) : e.bitmap && e.points && (t = (e => {
                            const {id: t, points: i, strokeWidth: o, strokeCap: n, strokeJoin: r, strokeColor: a, strokeDash: s} = e;
                            let l = ne.get(t)
                              , c = de.get(t);
                            const u = Ji({
                                points: i.map((e => `${e.x},${e.y}`)).join(","),
                                strokeWidth: o,
                                strokeCap: n,
                                strokeJoin: r,
                                strokeColor: a,
                                strokeDash: (s || []).join(",")
                            });
                            if (c) {
                                const {hash: e} = c;
                                if (ne.has(t)) {
                                    if (u === e)
                                        return ne.get(t)
                                } else
                                    c = void 0
                            }
                            if (!c) {
                                const i = M("canvas", {
                                    width: 1,
                                    height: 1
                                });
                                c = {
                                    canvas: i,
                                    hash: void 0
                                },
                                de.set(e.id, c),
                                l = j.textureCreate(),
                                j.textureUpdate(l, i, {
                                    filterParam: j.textureFilterLinear,
                                    wrapParam: j.textureClamp
                                }),
                                ne.set(t, l)
                            }
                            const {canvas: d} = c
                              , p = Math.ceil(e.strokeWidth)
                              , h = gt(i)
                              , m = Math.floor(h.x) - .5 * p
                              , f = Math.floor(h.y) - .5 * p
                              , g = Math.ceil(h.width + p)
                              , y = Math.ceil(h.height + p);
                            d.width = Math.max(g, 1),
                            d.height = Math.max(y, 1);
                            const $ = d.getContext("2d");
                            return $.clearRect(0, 0, d.width, d.height),
                            g >= 1 && y >= 1 && ($.translate(-m, -f),
                            Vn($, e),
                            $.resetTransform()),
                            j.textureUpdate(l, d, {
                                filterParam: j.textureFilterLinear,
                                wrapParam: j.textureClamp
                            }),
                            de.set(t, {
                                canvas: d,
                                hash: u
                            }),
                            ne.get(t)
                        }
                        )(e)),
                        t
                    }
                    )(e);
                    const o = "complete" !== e.status && ("loading" === e.status || e.backgroundImage && i === e.backgroundImage);
                    o && oe();
                    const n = "error" === e.status || e.backgroundImage && i instanceof Error;
                    let r = _c(i) ? i : void 0;
                    const a = e._scale || 1
                      , s = e._translate || d
                      , l = e.strokeWidth && e.strokeWidth * a
                      , c = e.cornerRadius ? ( (e, t) => [e, e, e, e].map((e => e * t)))(e.cornerRadius, a) : u
                      , p = !!e.width
                      , h = W(e.text)
                      , m = Ui(e.points)
                      , f = Lo(e);
                    if (m) {
                        const o = e.points.map((e => Ce(e.x * a + s.x, e.y * a + s.y)));
                        if (e.bitmap) {
                            i && t.push(i);
                            const n = gt(o)
                              , s = Math.ceil(e.strokeWidth * a);
                            j.drawRect({
                                x: Math.floor(n.x) - .5 * s,
                                y: Math.floor(n.y) - .5 * s,
                                width: Math.ceil(n.width + s),
                                height: Math.ceil(n.height + s)
                            }, e.rotation, e.flipX, e.flipY, [0, 0, 0, 0], void 0, r, void 0, void 0, void 0, void 0, void 0, void 0, e.opacity, void 0, void 0, !1, !1)
                        } else
                            j.drawPath(o, e.rotation, e.flipX, e.flipY, l, e.strokeColor, e.pathClose, e.backgroundColor, e.opacity)
                    } else if (f) {
                        let c = e.x
                          , u = e.y;
                        c *= a,
                        u *= a,
                        c += s.x,
                        u += s.y;
                        const d = yt({
                            x: c,
                            y: u,
                            rx: e.rx * a,
                            ry: e.ry * a
                        })
                          , p = Ce(c, u)
                          , h = r && j.textureGetSize(r);
                        let m, f;
                        if (h && e.backgroundImage && (e.backgroundSize || e.backgroundPosition || e.backgroundRepeat)) {
                            const t = me(e, d, h);
                            m = t.backgroundSize,
                            f = t.backgroundPosition
                        }
                        j.drawEllipse(p, e.rx * a, e.ry * a, e.rotation, e.flipX, e.flipY, e.backgroundColor, r, m, f, e.backgroundCorners && kc(e.backgroundCorners), l, e.strokeColor, e.opacity, e.inverted),
                        i && t.push(i),
                        (o || n) && (e.backgroundColor || e.strokeColor && e.strokeWidth || j.drawEllipse(p, e.rx * a, e.ry * a, e.rotation, e.flipX, e.flipY, n ? [1, 0, 0, .25 * e.opacity] : [0, 0, 0, .25 * e.opacity]),
                        n && xe(p),
                        o && ve(p))
                    } else if (h) {
                        const {fontSize: i=16} = e
                          , o = i > 1e3 && X() ? i / 1e3 : 1
                          , n = Math.max(16, Math.ceil(i / o * .25))
                          , r = Math.abs(e.rotation) > 0
                          , d = ho(e.text, e)
                          , p = {
                            x: e.x * a + s.x,
                            y: e.y * a + s.y,
                            width: d.width * a,
                            height: d.height * a
                        }
                          , h = !!e.height;
                        (e.backgroundColor || e.strokeColor) && j.drawRect(p, e.rotation, e.flipX, e.flipY, c, e.backgroundColor, void 0, void 0, void 0, !1, void 0, l, e.strokeColor, e.opacity, void 0, void 0, void 0, e.inverted);
                        const {textShadowX: m, textShadowY: f, textShadowBlur: g} = e;
                        if (m || f || g) {
                            const i = Math.ceil(.5 * g)
                              , l = Math.max(n, h ? 0 : i)
                              , c = ue(e, {
                                id: e.id + "shadow",
                                blur: g,
                                paddingTop: l,
                                paddingRight: l,
                                paddingBottom: l,
                                paddingLeft: l
                            });
                            if (c && !e._prerender) {
                                t.push(c);
                                const i = j.textureGetSize(c)
                                  , l = {
                                    x: 0,
                                    y: 0
                                }
                                  , u = {
                                    width: i.width / k * a,
                                    height: i.height / k * a
                                }
                                  , d = n * a / o;
                                let g;
                                if (h)
                                    g = {
                                        ...p
                                    },
                                    l.x = m - d,
                                    l.y = f - d;
                                else if (g = {
                                    x: e.x * a + s.x - d,
                                    y: e.y * a + s.y - d,
                                    width: u.width,
                                    height: u.height
                                },
                                r) {
                                    const t = he(p, g, e.rotation);
                                    g.x += t.x,
                                    g.y += t.y;
                                    const i = Ee(Ce(m, f), e.rotation);
                                    g.x += i.x,
                                    g.y += i.y
                                } else
                                    g.x += m,
                                    g.y += f;
                                j.drawRect(g, e.rotation, e.flipX, e.flipY, [0, 0, 0, 0], void 0, c, u, l, !1, void 0, void 0, void 0, e.opacity, void 0, 0, e.textShadowColor)
                            }
                        }
                        if (e.textOutlineWidth) {
                            const i = Math.ceil(.5 * e.textOutlineWidth)
                              , l = n + i
                              , c = ue(e, {
                                id: e.id + "outline",
                                outline: e.textOutlineWidth,
                                paddingTop: l,
                                paddingRight: l,
                                paddingBottom: l,
                                paddingLeft: l
                            });
                            if (c && !e._prerender) {
                                t.push(c);
                                const l = j.textureGetSize(c)
                                  , u = {
                                    x: 0,
                                    y: 0
                                }
                                  , h = {
                                    width: l.width / k * a,
                                    height: l.height / k * a
                                }
                                  , m = (n + i) * a / o
                                  , f = {
                                    x: e.x * a + s.x - m,
                                    y: e.y * a + s.y - m,
                                    width: h.width,
                                    height: e.height ? d.height + m : h.height
                                };
                                if (r) {
                                    const t = he(p, f, e.rotation);
                                    f.x += t.x,
                                    f.y += t.y
                                }
                                j.drawRect(f, e.rotation, e.flipX, e.flipY, [0, 0, 0, 0], void 0, c, h, u, !1, void 0, void 0, void 0, e.opacity, void 0, 0, e.textOutlineColor)
                            }
                        }
                        const y = ue(e, {
                            id: e.id + "text",
                            paddingTop: n,
                            paddingRight: n,
                            paddingBottom: n,
                            paddingLeft: n
                        });
                        if (y && !e._prerender) {
                            t.push(y);
                            const i = j.textureGetSize(y)
                              , l = {
                                x: 0,
                                y: 0
                            }
                              , c = {
                                width: i.width / k * a,
                                height: i.height / k * a
                            }
                              , h = n * a / o
                              , m = {
                                x: e.x * a + s.x - h,
                                y: e.y * a + s.y - h,
                                width: c.width,
                                height: e.height ? d.height + h : c.height
                            };
                            if (r) {
                                const t = he(p, m, e.rotation);
                                m.x += t.x,
                                m.y += t.y
                            }
                            const f = e.color || [0, 0, 0];
                            e._prerender && (f[3] = 0),
                            j.drawRect(m, e.rotation, e.flipX, e.flipY, u, !1, y, c, l, !1, !1, void 0, void 0, e.opacity, void 0, e.feather, f, e.inverted)
                        }
                    } else if (p) {
                        i && t.push(i);
                        const u = ft(e);
                        let d, p;
                        a && s && (u.x *= a,
                        u.y *= a,
                        u.x += s.x,
                        u.y += s.y,
                        u.width *= a,
                        u.height *= a);
                        const {backgroundRepeat: h="no-repeat"} = e
                          , m = r && j.textureGetSize(r);
                        if (m && e.backgroundImage && (e.backgroundSize || e.backgroundPosition || e.backgroundRepeat)) {
                            const t = me(e, u, m);
                            d = t.backgroundSize,
                            p = t.backgroundPosition
                        }
                        if (j.drawRect(u, e.rotation, e.flipX, e.flipY, c, e.backgroundColor, r, d, p, "repeat" === h, e.backgroundCorners && kc(e.backgroundCorners), l, e.strokeColor, e.opacity, void 0, e.feather, e.fillColor, e.inverted),
                        o || n) {
                            e.backgroundColor && 0 !== e.backgroundColor[3] || e.strokeColor && e.strokeWidth || j.drawRect(u, e.rotation, e.flipX, e.flipY, c, n ? [1, .2549, .2118, .25 * e.opacity] : [0, 0, 0, .25 * e.opacity]);
                            const t = vt(u);
                            n && xe(t),
                            o && ve(t)
                        }
                    } else
                        i && t.push(i)
                }
                ))
            }
            ;
            let ge = 0;
            const ye = [{
                x: -5,
                y: -5
            }, {
                x: 5,
                y: 5
            }]
              , $e = [{
                x: 5,
                y: -5
            }, {
                x: -5,
                y: 5
            }]
              , be = Gt({
                x: 0,
                y: 0
            }, 10, 10, 0, !1, !1, 16);
            be.length = 9;
            const ve = e => {
                ge = Date.now() / 50,
                j.drawEllipse(e, 15, 15, 0, !1, !1, [0, 0, 0, .5]);
                const t = Ge(be.map((t => ({
                    x: t.x + e.x,
                    y: t.y + e.y
                }))), ge, e.x, e.y);
                j.drawPath(t, 0, !1, !1, 2, [1, 1, 1])
            }
              , xe = e => {
                j.drawEllipse(e, 13, 13, 0, !1, !1, [1, .2549, .2118, .75]);
                const t = ye.map((t => ({
                    x: t.x + e.x,
                    y: t.y + e.y
                })))
                  , i = $e.map((t => ({
                    x: t.x + e.x,
                    y: t.y + e.y
                })));
                j.drawPath(t, 0, !1, !1, 3, [1, 1, 1]),
                j.drawPath(i, 0, !1, !1, 3, [1, 1, 1])
            }
              , we = (e, t, i, o, n, r) => j.drawRect(t, 0, !1, !1, u, u, e, o, i, !0, void 0, 0, void 0, r, void 0, void 0, n);
            let Se = !1
              , _e = !0
              , Te = !1;
            const Me = []
              , Pe = []
              , Re = []
              , Ae = e => !e.aboveFrame
              , Ie = e => e.aboveFrame
              , Le = () => {
                Re.length = 0;
                const e = B[0]
                  , {manipulationShapes: t, manipulationShapesDirty: i, annotationShapes: o, annotationShapesDirty: n, interfaceShapes: d, decorationShapes: h, frameShapes: m, selectionShapes: f} = T({
                    opacity: e.opacity,
                    rotation: e.rotation,
                    scale: e.scale,
                    images: B,
                    size: et(U, V),
                    backgroundColor: [...c],
                    selectionRect: l
                })
                  , $ = [...c]
                  , b = l
                  , v = cs(s, 0, 1)
                  , S = a
                  , _ = Math.abs(e.rotation.x / Math.PI * 2 - 1)
                  , C = Math.abs(e.rotation.y / Math.PI * 2 - 1)
                  , E = _ < .99 || C < .99
                  , R = {
                    ...e.size
                }
                  , A = e.backgroundColor
                  , I = e.backgroundImage
                  , L = t.length > 0
                  , W = o.length > 0
                  , q = o.filter(Ie).length > 0
                  , G = h.filter(Ie).length > 0
                  , K = A[3] > 0
                  , X = !!w && x >= 1;
                if (v < 1 && K) {
                    const e = $[0]
                      , t = $[1]
                      , i = $[2]
                      , o = 1 - v
                      , n = A[0] * o
                      , r = A[1] * o
                      , a = A[2] * o
                      , s = 1 - o;
                    $[0] = n + e * s,
                    $[1] = r + t * s,
                    $[2] = a + i * s,
                    $[3] = 1
                }
                if (j.setCanvasColor(g ? u : $),
                L && (i || Se) ? (j.disableMask(),
                j.drawToImageBlendBuffer(R),
                Me.length = 0,
                fe(t, Me)) : L || (Me.length = 0),
                Re.push(...Me),
                _e && (j.drawToImageOverlayBuffer(R, k),
                _e = !1),
                E) {
                    if (W && (n || Se) || !Te) {
                        j.disableMask(),
                        j.drawToImageOverlayBuffer(R, k),
                        Pe.length = 0;
                        const e = q ? o.filter(Ae) : o;
                        fe(e, Pe)
                    } else
                        W || (Pe.length = 0);
                    Te = !0
                } else
                    Te = !1;
                if (j.drawToCanvas(),
                j.enableMask(b, v),
                D && F >= 1 && 2 === z.length && O && ( (e, t, i, o, n) => {
                    const r = et(t, t)
                      , a = ce(p, "pixelated", "repeat")
                      , s = Ce(-e.x % t, -e.y % t)
                      , l = Ce(s.x + .5 * r.width, s.y);
                    we(a, e, s, r, i, n),
                    we(a, e, l, r, o, n)
                }
                )(b, F, z[0], z[1], O),
                K && j.drawRect(b, 0, !1, !1, u, A),
                I) {
                    j.enableMask(b, 1);
                    const e = Math.max(y.width / I.width, y.height / I.height)
                      , t = I.width * e
                      , i = I.height * e
                      , o = {
                        x: y.x + .5 * y.width - .5 * t,
                        y: y.y + .5 * y.height - .5 * i,
                        width: t,
                        height: i
                    };
                    j.drawRect(o, 0, !1, !1, u, u, ce(I, "linear")),
                    j.enableMask(b, v)
                }
                if (X && j.enablePreviewStencil(),
                Re.push(...[...B].reverse().map((e => pe({
                    ...e,
                    texture: ce(e.data),
                    enableOverlay: E && W,
                    enableManipulation: L,
                    enableAntialiasing: !0,
                    mask: b,
                    maskOpacity: v,
                    overlayColor: S
                })))),
                j.enableMask(b, x),
                !E) {
                    X && j.applyPreviewStencil(),
                    j.resetCanvasMatrix(),
                    j.updateCanvasMatrix(R, e.origin, e.translation, e.scale, e.rotation),
                    Pe.length = 0;
                    const t = q ? o.filter(Ae) : o;
                    fe(t, Pe),
                    X && j.disablePreviewStencil()
                }
                if (Re.push(...Pe),
                j.resetCanvasMatrix(),
                j.enableMask(b, x),
                fe(G ? h.filter(Ae) : h, Re),
                m.length) {
                    j.enableMask(b, 1);
                    const e = m.filter((e => !e.expandsCanvas))
                      , t = m.filter((e => e.expandsCanvas));
                    e.length && fe(e, Re),
                    t.length && (j.enableMask({
                        x: b.x + .5,
                        y: b.y + .5,
                        width: b.width - 1,
                        height: b.height - 1
                    }, r),
                    fe(t, Re))
                }
                if (q && (j.resetCanvasMatrix(),
                j.updateCanvasMatrix(R, e.origin, e.translation, e.scale, e.rotation),
                fe(o.filter(Ie), Re),
                j.resetCanvasMatrix()),
                G && (j.resetCanvasMatrix(),
                fe(h.filter(Ie), Re),
                j.resetCanvasMatrix()),
                H && f.length && !E) {
                    j.resetCanvasMatrix(),
                    j.updateCanvasMatrix(R, e.origin, e.translation, e.scale, e.rotation);
                    const t = [...H];
                    t[3] = .5;
                    const i = [{
                        id: "selection",
                        color: t,
                        actions: [...f]
                    }].map((e => ( (e, t) => {
                        let i = te[e.id];
                        const o = Math.min(1, 2048 / t.width);
                        let n = i ? i.element : M("canvas", {
                            width: t.width * o,
                            height: t.height * o,
                            "data-retain": !0
                        });
                        if (!i || ( (e, t) => {
                            if (e.total !== t.length)
                                return !0;
                            const i = e.last
                              , o = t[t.length - 1];
                            return i.drawMode !== o.drawMode || !(!Io(i) || Io(o) && Ct(i, o)) || !(!Lo(i) || Lo(o) && i.x === o.x && i.y === o.y && i.rx === o.rx && i.ry === o.ry) || !(!zo(i) || zo(o) && o.points.length === i.points.length)
                        }
                        )(i, e.actions)) {
                            n = n.cloneNode(),
                            ( (e, t, i) => {
                                const {selectionColor: o=[1, 1, 1], scalar: n=1} = i || {};
                                let r = !1;
                                for (const i of t) {
                                    const t = "subtract" === i.drawMode;
                                    if (t && !r)
                                        continue;
                                    e.globalCompositeOperation = t ? "destination-out" : "source-over",
                                    e.save(),
                                    e.beginPath();
                                    const a = En(i);
                                    Ei(e, n, n),
                                    Pi(e, i.rotation, a),
                                    qn(e, i.flipX, i.flipY, a),
                                    i.width ? Nn(e, {
                                        ...i,
                                        backgroundColor: o
                                    }) : i.points ? Vn(e, Object.assign({}, i, i.pathClose ? {
                                        backgroundColor: o,
                                        strokeColor: [0, 0, 0, 0]
                                    } : {
                                        strokeColor: o,
                                        strokeJoin: "round",
                                        strokeCap: "round"
                                    })) : i.rx && Wn(e, {
                                        ...i,
                                        backgroundColor: o,
                                        strokeColor: [0, 0, 0, 0],
                                        strokeJoin: "round",
                                        strokeCap: "round"
                                    }),
                                    e.restore(),
                                    r = !0
                                }
                            }
                            )(n.getContext("2d"), e.actions, {
                                selectionColor: [1, 0, 1],
                                scalar: o
                            });
                            const t = e.actions.length;
                            te[e.id] = {
                                total: t,
                                last: {
                                    ...e.actions[t - 1]
                                },
                                element: n
                            }
                        }
                        return {
                            x: 0,
                            y: 0,
                            ...t,
                            fillColor: e.color || [1, 1, 1],
                            backgroundImage: n
                        }
                    }
                    )(e, R)));
                    fe(i, Re),
                    j.resetCanvasMatrix()
                }
                j.disableMask(),
                fe(d, Re),
                N.forEach((e => {
                    if (j.enableMask(e.mask, e.maskOpacity),
                    e.backgroundColor) {
                        const t = I && It({
                            ...e.mask
                        }, I.width / I.height)
                          , i = I && ce(I, "linear");
                        j.drawRect(e.mask, 0, !1, !1, e.maskCornerRadius, e.backgroundColor, i, t, t, void 0, void 0, void 0, void 0, e.opacity, e.maskFeather),
                        i && Re.push(i)
                    }
                    const t = pe({
                        ...e,
                        texture: ce(e.data),
                        enableAntialiasing: !1,
                        translation: {
                            x: e.translation.x + e.offset.x - .5 * U,
                            y: e.translation.y + e.offset.y - .5 * V
                        }
                    });
                    Re.push(t)
                }
                )),
                j.disableMask(),
                (e => {
                    ne.forEach(( (t, i) => {
                        !e.find((e => e === t)) && _c(t) && (Array.from(re.values()).includes(t) || (ne.delete(i),
                        j.textureDelete(t)))
                    }
                    ))
                }
                )(Re),
                P(),
                Se = !1
            }
            ;
            let De, ze = 0;
            const Fe = () => {
                clearTimeout(De);
                const e = Date.now();
                e - ze < 48 ? De = setTimeout(Fe, 48) : (ze = e,
                Le())
            }
            ;
            return Jr(( () => n())),
            Qr(( () => i(31, j = Kl(m, {
                alpha: g
            })))),
            ea(( () => {
                j && (de.forEach(( ({canvas: e}) => E(e))),
                de.clear(),
                j.release(),
                i(31, j = void 0),
                i(0, m = void 0))
            }
            )),
            e.$$set = e => {
                "isAnimated"in e && i(9, f = e.isAnimated),
                "isTransparent"in e && i(10, g = e.isTransparent),
                "maskRect"in e && i(11, y = e.maskRect),
                "maskOpacity"in e && i(12, b = e.maskOpacity),
                "maskFrameOpacity"in e && i(13, v = e.maskFrameOpacity),
                "maskMarkupOpacity"in e && i(14, x = e.maskMarkupOpacity),
                "clipAnnotationsToImage"in e && i(15, w = e.clipAnnotationsToImage),
                "pixelRatio"in e && i(16, S = e.pixelRatio),
                "textPixelRatio"in e && i(17, k = e.textPixelRatio),
                "backgroundColor"in e && i(18, C = e.backgroundColor),
                "willRender"in e && i(19, T = e.willRender),
                "didRender"in e && i(20, P = e.didRender),
                "willRequest"in e && i(21, A = e.willRequest),
                "csp"in e && i(22, I = e.csp),
                "loadImageData"in e && i(23, L = e.loadImageData),
                "enableGrid"in e && i(24, D = e.enableGrid),
                "gridColors"in e && i(25, z = e.gridColors),
                "gridSize"in e && i(26, F = e.gridSize),
                "gridOpacity"in e && i(27, O = e.gridOpacity),
                "images"in e && i(28, B = e.images),
                "interfaceImages"in e && i(29, N = e.interfaceImages),
                "selectionColor"in e && i(30, H = e.selectionColor)
            }
            ,
            e.$$.update = () => {
                if (1 & e.$$.dirty[0] && m) {
                    const e = getComputedStyle(m).getPropertyValue("--color-transition-duration");
                    i(32, K = (e => {
                        let t = parseFloat(e);
                        return /^[0-9]+s$/.test(e) ? 1e3 * t : t
                    }
                    )(e))
                }
                262656 & e.$$.dirty[0] | 2 & e.$$.dirty[1] && C && Z.set(C, {
                    duration: f ? K : 0
                }),
                4096 & e.$$.dirty[0] && q(Y, Wi(b) ? b : 1),
                8192 & e.$$.dirty[0] && q(Q, Wi(v) ? v : 1),
                2048 & e.$$.dirty[0] && y && J.set(y),
                48 & e.$$.dirty[1] && c && ee.set([c[0], c[1], c[2], cs(s, 0, 1)]),
                268435462 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && i(34, o = !!(j && U && V && B.length)),
                65542 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && U && V && j && (ze = 0,
                j.resize(U, V, S)),
                8 & e.$$.dirty[1] && i(33, n = o ? Sc() ? Fe : Le : $),
                12 & e.$$.dirty[1] && o && n && n()
            }
            ,
            [m, U, V, h, Z, Y, Q, J, ee, f, g, y, b, v, x, w, S, k, C, T, P, A, I, L, D, z, F, O, B, N, H, j, K, n, o, s, c, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    m = e,
                    i(0, m)
                }
                ))
            }
            , e => {
                i(1, U = e.detail.width),
                i(2, V = e.detail.height),
                h("measure", {
                    width: U,
                    height: V
                })
            }
            ]
        }
        class Mc extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Tc, Cc, ar, {
                    isAnimated: 9,
                    isTransparent: 10,
                    maskRect: 11,
                    maskOpacity: 12,
                    maskFrameOpacity: 13,
                    maskMarkupOpacity: 14,
                    clipAnnotationsToImage: 15,
                    pixelRatio: 16,
                    textPixelRatio: 17,
                    backgroundColor: 18,
                    willRender: 19,
                    didRender: 20,
                    willRequest: 21,
                    csp: 22,
                    loadImageData: 23,
                    enableGrid: 24,
                    gridColors: 25,
                    gridSize: 26,
                    gridOpacity: 27,
                    images: 28,
                    interfaceImages: 29,
                    selectionColor: 30
                }, null, [-1, -1, -1])
            }
        }
        var Pc = (e, t=Boolean, i=" ") => e.filter(t).join(i);
        function Ec(e, t, i) {
            const o = e.slice();
            return o[17] = t[i],
            o
        }
        const Rc = e => ({
            tab: 4 & e
        })
          , Ac = e => ({
            tab: e[17]
        });
        function Ic(e) {
            let t, i, o, n = [], r = new Map, a = e[2];
            const s = e => e[17].id;
            for (let t = 0; t < a.length; t += 1) {
                let i = Ec(e, a, t)
                  , o = s(i);
                r.set(o, n[t] = Lc(o, i))
            }
            return {
                c() {
                    t = Er("ul");
                    for (let e = 0; e < n.length; e += 1)
                        n[e].c();
                    Or(t, "class", i = Pc(["PinturaTabList", e[0]])),
                    Or(t, "role", "tablist"),
                    Or(t, "data-layout", e[1])
                },
                m(i, r) {
                    Mr(i, t, r);
                    for (let e = 0; e < n.length; e += 1)
                        n[e].m(t, null);
                    e[14](t),
                    o = !0
                },
                p(e, l) {
                    1124 & l && (a = e[2],
                    Sa(),
                    n = Aa(n, l, s, 1, e, a, r, t, Ra, Lc, null, Ec),
                    _a()),
                    (!o || 1 & l && i !== (i = Pc(["PinturaTabList", e[0]]))) && Or(t, "class", i),
                    (!o || 2 & l) && Or(t, "data-layout", e[1])
                },
                i(e) {
                    if (!o) {
                        for (let e = 0; e < a.length; e += 1)
                            ka(n[e]);
                        o = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < n.length; e += 1)
                        Ca(n[e]);
                    o = !1
                },
                d(i) {
                    i && Pr(t);
                    for (let e = 0; e < n.length; e += 1)
                        n[e].d();
                    e[14](null)
                }
            }
        }
        function Lc(e, t) {
            let i, o, n, r, a, s, l, c, u, d;
            const p = t[11].default
              , h = ur(p, t, t[10], Ac);
            function m(...e) {
                return t[12](t[17], ...e)
            }
            function f(...e) {
                return t[13](t[17], ...e)
            }
            return {
                key: e,
                first: null,
                c() {
                    i = Er("li"),
                    o = Er("button"),
                    h && h.c(),
                    r = Ir(),
                    Or(o, "type", "button"),
                    o.disabled = n = t[17].disabled,
                    Or(i, "role", "tab"),
                    Or(i, "aria-controls", a = t[17].href.substring(1)),
                    Or(i, "id", s = t[17].tabId),
                    Or(i, "aria-selected", l = t[17].selected),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    kr(i, o),
                    h && h.m(o, null),
                    kr(i, r),
                    c = !0,
                    u || (d = [Dr(o, "keydown", m), Dr(o, "click", f)],
                    u = !0)
                },
                p(e, r) {
                    t = e,
                    h && h.p && (!c || 1028 & r) && hr(h, p, t, t[10], c ? pr(p, t[10], r, Rc) : mr(t[10]), Ac),
                    (!c || 4 & r && n !== (n = t[17].disabled)) && (o.disabled = n),
                    (!c || 4 & r && a !== (a = t[17].href.substring(1))) && Or(i, "aria-controls", a),
                    (!c || 4 & r && s !== (s = t[17].tabId)) && Or(i, "id", s),
                    (!c || 4 & r && l !== (l = t[17].selected)) && Or(i, "aria-selected", l)
                },
                i(e) {
                    c || (ka(h, e),
                    c = !0)
                },
                o(e) {
                    Ca(h, e),
                    c = !1
                },
                d(e) {
                    e && Pr(i),
                    h && h.d(e),
                    u = !1,
                    nr(d)
                }
            }
        }
        function Dc(e) {
            let t, i, o = e[4] && Ic(e);
            return {
                c() {
                    o && o.c(),
                    t = Lr()
                },
                m(e, n) {
                    o && o.m(e, n),
                    Mr(e, t, n),
                    i = !0
                },
                p(e, [i]) {
                    e[4] ? o ? (o.p(e, i),
                    16 & i && ka(o, 1)) : (o = Ic(e),
                    o.c(),
                    ka(o, 1),
                    o.m(t.parentNode, t)) : o && (Sa(),
                    Ca(o, 1, 1, ( () => {
                        o = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    i || (ka(o),
                    i = !0)
                },
                o(e) {
                    Ca(o),
                    i = !1
                },
                d(e) {
                    o && o.d(e),
                    e && Pr(t)
                }
            }
        }
        function zc(e, t, i) {
            let o, n, r, {$$slots: a={}, $$scope: s} = t, {class: l} = t, {name: c} = t, {selected: u} = t, {tabs: d=[]} = t, {layout: p} = t;
            const h = ta()
              , m = e => {
                const t = r.querySelectorAll('[role="tab"] button')[e];
                t && t.focus()
            }
              , f = (e, t) => {
                e.preventDefault(),
                e.stopPropagation(),
                h("select", t)
            }
              , g = ({key: e}, t) => {
                if (!/arrow/i.test(e))
                    return;
                const i = d.findIndex((e => e.id === t));
                return /right|down/i.test(e) ? m(i < d.length - 1 ? i + 1 : 0) : /left|up/i.test(e) ? m(i > 0 ? i - 1 : d.length - 1) : void 0
            }
            ;
            return e.$$set = e => {
                "class"in e && i(0, l = e.class),
                "name"in e && i(7, c = e.name),
                "selected"in e && i(8, u = e.selected),
                "tabs"in e && i(9, d = e.tabs),
                "layout"in e && i(1, p = e.layout),
                "$$scope"in e && i(10, s = e.$$scope)
            }
            ,
            e.$$.update = () => {
                896 & e.$$.dirty && i(2, o = d.map((e => {
                    const t = e.id === u;
                    return {
                        ...e,
                        tabId: `tab-${c}-${e.id}`,
                        href: `#panel-${c}-${e.id}`,
                        selected: t
                    }
                }
                ))),
                4 & e.$$.dirty && i(4, n = o.length > 1)
            }
            ,
            [l, p, o, r, n, f, g, c, u, d, s, a, (e, t) => g(t, e.id), (e, t) => f(t, e.id), function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    r = e,
                    i(3, r)
                }
                ))
            }
            ]
        }
        class Fc extends Na {
            constructor(e) {
                super(),
                Ba(this, e, zc, Dc, ar, {
                    class: 0,
                    name: 7,
                    selected: 8,
                    tabs: 9,
                    layout: 1
                })
            }
        }
        const Oc = e => ({
            panel: 16 & e
        })
          , Bc = e => ({
            panel: e[4][0].id,
            panelIsActive: !0
        });
        function Nc(e, t, i) {
            const o = e.slice();
            return o[14] = t[i].id,
            o[15] = t[i].shouldDraw,
            o[16] = t[i].panelId,
            o[17] = t[i].tabindex,
            o[18] = t[i].labelledBy,
            o[19] = t[i].isActive,
            o[20] = t[i].hidden,
            o[3] = t[i].visible,
            o
        }
        const Wc = e => ({
            panel: 16 & e,
            panelIsActive: 16 & e
        })
          , Hc = e => ({
            panel: e[14],
            panelIsActive: e[19]
        });
        function jc(e) {
            let t, i, o, n, r, a;
            const s = e[11].default
              , l = ur(s, e, e[10], Bc);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    l && l.c(),
                    Or(i, "class", o = Pc([e[1]])),
                    Or(t, "class", e[0]),
                    Or(t, "style", e[2])
                },
                m(o, s) {
                    Mr(o, t, s),
                    kr(t, i),
                    l && l.m(i, null),
                    n = !0,
                    r || (a = [Dr(t, "measure", e[13]), $r($c.call(null, t))],
                    r = !0)
                },
                p(e, r) {
                    l && l.p && (!n || 1040 & r) && hr(l, s, e, e[10], n ? pr(s, e[10], r, Oc) : mr(e[10]), Bc),
                    (!n || 2 & r && o !== (o = Pc([e[1]]))) && Or(i, "class", o),
                    (!n || 1 & r) && Or(t, "class", e[0]),
                    (!n || 4 & r) && Or(t, "style", e[2])
                },
                i(e) {
                    n || (ka(l, e),
                    n = !0)
                },
                o(e) {
                    Ca(l, e),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    l && l.d(e),
                    r = !1,
                    nr(a)
                }
            }
        }
        function Uc(e) {
            let t, i, o, n, r, a = [], s = new Map, l = e[4];
            const c = e => e[14];
            for (let t = 0; t < l.length; t += 1) {
                let i = Nc(e, l, t)
                  , o = c(i);
                s.set(o, a[t] = qc(o, i))
            }
            return {
                c() {
                    t = Er("div");
                    for (let e = 0; e < a.length; e += 1)
                        a[e].c();
                    Or(t, "class", i = Pc(["PinturaTabPanels", e[0]])),
                    Or(t, "style", e[2])
                },
                m(i, s) {
                    Mr(i, t, s);
                    for (let e = 0; e < a.length; e += 1)
                        a[e].m(t, null);
                    o = !0,
                    n || (r = [Dr(t, "measure", e[12]), $r($c.call(null, t, {
                        observePosition: !0
                    }))],
                    n = !0)
                },
                p(e, n) {
                    1042 & n && (l = e[4],
                    Sa(),
                    a = Aa(a, n, c, 1, e, l, s, t, Ra, qc, null, Nc),
                    _a()),
                    (!o || 1 & n && i !== (i = Pc(["PinturaTabPanels", e[0]]))) && Or(t, "class", i),
                    (!o || 4 & n) && Or(t, "style", e[2])
                },
                i(e) {
                    if (!o) {
                        for (let e = 0; e < l.length; e += 1)
                            ka(a[e]);
                        o = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < a.length; e += 1)
                        Ca(a[e]);
                    o = !1
                },
                d(e) {
                    e && Pr(t);
                    for (let e = 0; e < a.length; e += 1)
                        a[e].d();
                    n = !1,
                    nr(r)
                }
            }
        }
        function Vc(e) {
            let t;
            const i = e[11].default
              , o = ur(i, e, e[10], Hc);
            return {
                c() {
                    o && o.c()
                },
                m(e, i) {
                    o && o.m(e, i),
                    t = !0
                },
                p(e, n) {
                    o && o.p && (!t || 1040 & n) && hr(o, i, e, e[10], t ? pr(i, e[10], n, Wc) : mr(e[10]), Hc)
                },
                i(e) {
                    t || (ka(o, e),
                    t = !0)
                },
                o(e) {
                    Ca(o, e),
                    t = !1
                },
                d(e) {
                    o && o.d(e)
                }
            }
        }
        function qc(e, t) {
            let i, o, n, r, a, s, l, c, u, d = t[15] && Vc(t);
            return {
                key: e,
                first: null,
                c() {
                    i = Er("div"),
                    d && d.c(),
                    o = Ir(),
                    Or(i, "class", n = Pc(["PinturaTabPanel", t[1]])),
                    i.hidden = r = t[20],
                    Or(i, "id", a = t[16]),
                    Or(i, "tabindex", s = t[17]),
                    Or(i, "aria-labelledby", l = t[18]),
                    Or(i, "data-inert", c = !t[3]),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    d && d.m(i, null),
                    kr(i, o),
                    u = !0
                },
                p(e, p) {
                    (t = e)[15] ? d ? (d.p(t, p),
                    16 & p && ka(d, 1)) : (d = Vc(t),
                    d.c(),
                    ka(d, 1),
                    d.m(i, o)) : d && (Sa(),
                    Ca(d, 1, 1, ( () => {
                        d = null
                    }
                    )),
                    _a()),
                    (!u || 2 & p && n !== (n = Pc(["PinturaTabPanel", t[1]]))) && Or(i, "class", n),
                    (!u || 16 & p && r !== (r = t[20])) && (i.hidden = r),
                    (!u || 16 & p && a !== (a = t[16])) && Or(i, "id", a),
                    (!u || 16 & p && s !== (s = t[17])) && Or(i, "tabindex", s),
                    (!u || 16 & p && l !== (l = t[18])) && Or(i, "aria-labelledby", l),
                    (!u || 16 & p && c !== (c = !t[3])) && Or(i, "data-inert", c)
                },
                i(e) {
                    u || (ka(d),
                    u = !0)
                },
                o(e) {
                    Ca(d),
                    u = !1
                },
                d(e) {
                    e && Pr(i),
                    d && d.d()
                }
            }
        }
        function Gc(e) {
            let t, i, o, n;
            const r = [Uc, jc]
              , a = [];
            function s(e, t) {
                return e[5] ? 0 : 1
            }
            return t = s(e),
            i = a[t] = r[t](e),
            {
                c() {
                    i.c(),
                    o = Lr()
                },
                m(e, i) {
                    a[t].m(e, i),
                    Mr(e, o, i),
                    n = !0
                },
                p(e, [n]) {
                    let l = t;
                    t = s(e),
                    t === l ? a[t].p(e, n) : (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a(),
                    i = a[t],
                    i ? i.p(e, n) : (i = a[t] = r[t](e),
                    i.c()),
                    ka(i, 1),
                    i.m(o.parentNode, o))
                },
                i(e) {
                    n || (ka(i),
                    n = !0)
                },
                o(e) {
                    Ca(i),
                    n = !1
                },
                d(e) {
                    a[t].d(e),
                    e && Pr(o)
                }
            }
        }
        function Kc(e, t, i) {
            let o, n, {$$slots: r={}, $$scope: a} = t, {class: s} = t, {name: l} = t, {selected: c} = t, {panelClass: u} = t, {panels: d=[]} = t, {visible: p} = t, {style: h} = t;
            const m = {};
            return e.$$set = e => {
                "class"in e && i(0, s = e.class),
                "name"in e && i(6, l = e.name),
                "selected"in e && i(7, c = e.selected),
                "panelClass"in e && i(1, u = e.panelClass),
                "panels"in e && i(8, d = e.panels),
                "visible"in e && i(3, p = e.visible),
                "style"in e && i(2, h = e.style),
                "$$scope"in e && i(10, a = e.$$scope)
            }
            ,
            e.$$.update = () => {
                968 & e.$$.dirty && i(4, o = d.map((e => {
                    const t = e === c;
                    t && i(9, m[e] = !0, m);
                    const o = p ? -1 !== p.indexOf(e) : t;
                    return {
                        id: e,
                        panelId: `panel-${l}-${e}`,
                        labelledBy: `tab-${l}-${e}`,
                        isActive: t,
                        hidden: !t,
                        visible: o,
                        tabindex: t ? 0 : -1,
                        shouldDraw: t || m[e]
                    }
                }
                ))),
                16 & e.$$.dirty && i(5, n = o.length > 1)
            }
            ,
            [s, u, h, p, o, n, l, c, d, m, a, r, function(t) {
                na.call(this, e, t)
            }
            , function(t) {
                na.call(this, e, t)
            }
            ]
        }
        class Xc extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Kc, Gc, ar, {
                    class: 0,
                    name: 6,
                    selected: 7,
                    panelClass: 1,
                    panels: 8,
                    visible: 3,
                    style: 2
                })
            }
        }
        var Zc = e => {
            const t = Object.getOwnPropertyDescriptors(e.prototype);
            return Object.keys(t).filter((e => !!t[e].get))
        }
        ;
        function Yc(e) {
            let t, i, o, n;
            const r = [e[5], {
                locale: e[1]
            }];
            function a(t) {
                e[22](t)
            }
            var s = e[10];
            function l(e) {
                let t = {};
                for (let e = 0; e < r.length; e += 1)
                    t = tr(t, r[e]);
                return void 0 !== e[3] && (t.name = e[3]),
                {
                    props: t
                }
            }
            return s && (t = Vr(s, l(e)),
            aa.push(( () => Da(t, "name", a))),
            e[23](t),
            t.$on("measure", e[11])),
            {
                c() {
                    t && za(t.$$.fragment),
                    o = Lr()
                },
                m(e, i) {
                    t && Fa(t, e, i),
                    Mr(e, o, i),
                    n = !0
                },
                p(e, n) {
                    const c = 34 & n[0] ? Ia(r, [32 & n[0] && La(e[5]), 2 & n[0] && {
                        locale: e[1]
                    }]) : {};
                    if (!i && 8 & n[0] && (i = !0,
                    c.name = e[3],
                    ma(( () => i = !1))),
                    s !== (s = e[10])) {
                        if (t) {
                            Sa();
                            const e = t;
                            Ca(e.$$.fragment, 1, 0, ( () => {
                                Oa(e, 1)
                            }
                            )),
                            _a()
                        }
                        s ? (t = Vr(s, l(e)),
                        aa.push(( () => Da(t, "name", a))),
                        e[23](t),
                        t.$on("measure", e[11]),
                        za(t.$$.fragment),
                        ka(t.$$.fragment, 1),
                        Fa(t, o.parentNode, o)) : t = null
                    } else
                        s && t.$set(c)
                },
                i(e) {
                    n || (t && ka(t.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    t && Ca(t.$$.fragment, e),
                    n = !1
                },
                d(i) {
                    e[23](null),
                    i && Pr(o),
                    t && Oa(t, i)
                }
            }
        }
        function Qc(e) {
            let t, i, o, n = e[6] && Yc(e);
            return {
                c() {
                    t = Er("div"),
                    n && n.c(),
                    Or(t, "data-util", e[3]),
                    Or(t, "class", i = Pc(["PinturaUtilPanel", e[2]])),
                    Or(t, "style", e[7])
                },
                m(i, r) {
                    Mr(i, t, r),
                    n && n.m(t, null),
                    e[24](t),
                    o = !0
                },
                p(e, r) {
                    e[6] ? n ? (n.p(e, r),
                    64 & r[0] && ka(n, 1)) : (n = Yc(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t, null)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    (!o || 8 & r[0]) && Or(t, "data-util", e[3]),
                    (!o || 4 & r[0] && i !== (i = Pc(["PinturaUtilPanel", e[2]]))) && Or(t, "class", i),
                    (!o || 128 & r[0]) && Or(t, "style", e[7])
                },
                i(e) {
                    o || (ka(n),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    o = !1
                },
                d(i) {
                    i && Pr(t),
                    n && n.d(),
                    e[24](null)
                }
            }
        }
        function Jc(e, t, i) {
            let o, n, r, a, s;
            const l = ta();
            let {isActive: c=!0} = t
              , {stores: u} = t
              , {view: d} = t
              , {props: p} = t
              , {component: h} = t
              , {locale: m} = t
              , {class: f} = t;
            const g = oa("isAnimated");
            let y;
            cr(e, g, (e => i(21, s = e)));
            const $ = ic(0)
              , b = Ua($, (e => cs(e, 0, 1)));
            cr(e, b, (e => i(20, a = e)));
            let v = !c;
            const x = ja(c)
              , w = Ua(x, (async (e, t) => {
                if (!e)
                    return t(e);
                await pa(),
                t(e)
            }
            ), !1)
              , S = Ua(b, (e => e))
              , _ = Ua(b, (e => e > 0))
              , k = {
                isActive: w,
                isActiveFraction: S,
                isVisible: _
            }
              , C = d
              , T = Zc(C)
              , M = Object.keys(p || {}).reduce(( (e, t) => T.includes(t) ? (e[t] = p[t],
            e) : e), {})
              , P = Object.keys(k).reduce(( (e, t) => T.includes(t) ? (e[t] = k[t],
            e) : e), {});
            let E, R;
            const A = e => {
                i(17, y = {
                    ...e.detail
                }),
                L && c && l("measure", {
                    ...y
                })
            }
            ;
            ia("measurable", $c);
            const I = Yr().$$.context;
            let L = !1;
            return Qr(( () => {
                if (i(19, L = !0),
                r)
                    return;
                i(0, h = new C({
                    target: R,
                    props: {
                        ...n,
                        locale: m
                    },
                    context: I
                })),
                i(3, E = h.name);
                const e = h.$on("measure", A);
                return () => {
                    e(),
                    h.$destroy()
                }
            }
            )),
            e.$$set = e => {
                "isActive"in e && i(12, c = e.isActive),
                "stores"in e && i(13, u = e.stores),
                "view"in e && i(14, d = e.view),
                "props"in e && i(15, p = e.props),
                "component"in e && i(0, h = e.component),
                "locale"in e && i(1, m = e.locale),
                "class"in e && i(2, f = e.class)
            }
            ,
            e.$$.update = () => {
                135169 & e.$$.dirty[0] && y && c && h && l("measure", y),
                2101248 & e.$$.dirty[0] && $.set(c ? 1 : 0, {
                    hard: !1 === s
                }),
                1310720 & e.$$.dirty[0] && (a <= 0 && !v ? i(18, v = !0) : a > 0 && v && i(18, v = !1)),
                786432 & e.$$.dirty[0] && L && l(v ? "hide" : "show"),
                1048576 & e.$$.dirty[0] && l("fade", a),
                1048576 & e.$$.dirty[0] && i(7, o = a < 1 ? `opacity: ${a}` : void 0),
                4096 & e.$$.dirty[0] && x.set(c),
                8192 & e.$$.dirty[0] && i(5, n = {
                    ...M,
                    ...P,
                    stores: u
                })
            }
            ,
            i(6, r = !T.includes("external")),
            [h, m, f, E, R, n, r, o, g, b, C, A, c, u, d, p, $, y, v, L, a, s, function(e) {
                E = e,
                i(3, E)
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    h = e,
                    i(0, h)
                }
                ))
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    R = e,
                    i(4, R)
                }
                ))
            }
            ]
        }
        class eu extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Jc, Qc, ar, {
                    isActive: 12,
                    stores: 13,
                    view: 14,
                    props: 15,
                    component: 0,
                    locale: 1,
                    class: 2,
                    opacity: 16
                }, null, [-1, -1])
            }
            get opacity() {
                return this.$$.ctx[16]
            }
        }
        function tu(e) {
            let t, i, o;
            const n = e[5].default
              , r = ur(n, e, e[4], null);
            return {
                c() {
                    t = Rr("svg"),
                    r && r.c(),
                    Or(t, "class", e[3]),
                    Or(t, "style", e[2]),
                    Or(t, "width", e[0]),
                    Or(t, "height", e[1]),
                    Or(t, "viewBox", i = "0 0 " + e[0] + "\n    " + e[1]),
                    Or(t, "xmlns", "http://www.w3.org/2000/svg"),
                    Or(t, "aria-hidden", "true"),
                    Or(t, "focusable", "false"),
                    Or(t, "stroke-linecap", "round"),
                    Or(t, "stroke-linejoin", "round")
                },
                m(e, i) {
                    Mr(e, t, i),
                    r && r.m(t, null),
                    o = !0
                },
                p(e, [a]) {
                    r && r.p && (!o || 16 & a) && hr(r, n, e, e[4], o ? pr(n, e[4], a, null) : mr(e[4]), null),
                    (!o || 8 & a) && Or(t, "class", e[3]),
                    (!o || 4 & a) && Or(t, "style", e[2]),
                    (!o || 1 & a) && Or(t, "width", e[0]),
                    (!o || 2 & a) && Or(t, "height", e[1]),
                    (!o || 3 & a && i !== (i = "0 0 " + e[0] + "\n    " + e[1])) && Or(t, "viewBox", i)
                },
                i(e) {
                    o || (ka(r, e),
                    o = !0)
                },
                o(e) {
                    Ca(r, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    r && r.d(e)
                }
            }
        }
        function iu(e, t, i) {
            let {$$slots: o={}, $$scope: n} = t
              , {width: r=24} = t
              , {height: a=24} = t
              , {style: s} = t
              , {class: l} = t;
            return e.$$set = e => {
                "width"in e && i(0, r = e.width),
                "height"in e && i(1, a = e.height),
                "style"in e && i(2, s = e.style),
                "class"in e && i(3, l = e.class),
                "$$scope"in e && i(4, n = e.$$scope)
            }
            ,
            [r, a, s, l, n, o]
        }
        class ou extends Na {
            constructor(e) {
                super(),
                Ba(this, e, iu, tu, ar, {
                    width: 0,
                    height: 1,
                    style: 2,
                    class: 3
                })
            }
        }
        var nu = (e, t) => t === e.target || t.contains(e.target)
          , ru = (e, t, i) => {
            const o = W(t) ? t : e;
            return i ? `${o} (${n = i,
            n.map((e => "CMD" === e ? Si() ? "⌘" : "Ctrl" : e)).join("+")})` : o;
            var n
        }
        ;
        function au(e) {
            let t, i;
            return t = new ou({
                props: {
                    class: "PinturaButtonIcon",
                    $$slots: {
                        default: [su]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    536870920 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function su(e) {
            let t;
            return {
                c() {
                    t = Rr("g")
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[3]
                },
                p(e, i) {
                    8 & i && (t.innerHTML = e[3])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function lu(e) {
            let t;
            return {
                c() {
                    t = Er("span"),
                    Or(t, "class", e[11])
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[0]
                },
                p(e, i) {
                    1 & i && (t.innerHTML = e[0]),
                    2048 & i && Or(t, "class", e[11])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function cu(e) {
            let t, i, o, n, r;
            const a = e[27].default
              , s = ur(a, e, e[29], null)
              , l = s || function(e) {
                let t, i, o, n = e[3] && au(e), r = e[0] && lu(e);
                return {
                    c() {
                        t = Er("span"),
                        n && n.c(),
                        i = Ir(),
                        r && r.c(),
                        Or(t, "class", e[13])
                    },
                    m(e, a) {
                        Mr(e, t, a),
                        n && n.m(t, null),
                        kr(t, i),
                        r && r.m(t, null),
                        o = !0
                    },
                    p(e, a) {
                        e[3] ? n ? (n.p(e, a),
                        8 & a && ka(n, 1)) : (n = au(e),
                        n.c(),
                        ka(n, 1),
                        n.m(t, i)) : n && (Sa(),
                        Ca(n, 1, 1, ( () => {
                            n = null
                        }
                        )),
                        _a()),
                        e[0] ? r ? r.p(e, a) : (r = lu(e),
                        r.c(),
                        r.m(t, null)) : r && (r.d(1),
                        r = null),
                        (!o || 8192 & a) && Or(t, "class", e[13])
                    },
                    i(e) {
                        o || (ka(n),
                        o = !0)
                    },
                    o(e) {
                        Ca(n),
                        o = !1
                    },
                    d(e) {
                        e && Pr(t),
                        n && n.d(),
                        r && r.d()
                    }
                }
            }(e);
            return {
                c() {
                    t = Er("button"),
                    l && l.c(),
                    Or(t, "type", e[6]),
                    Or(t, "style", e[4]),
                    t.disabled = e[5],
                    Or(t, "class", e[12]),
                    Or(t, "title", i = ru(e[0], e[1], e[2]))
                },
                m(i, a) {
                    Mr(i, t, a),
                    l && l.m(t, null),
                    e[28](t),
                    o = !0,
                    n || (r = [Dr(t, "keydown", (function() {
                        rr(e[8]) && e[8].apply(this, arguments)
                    }
                    )), Dr(t, "click", (function() {
                        rr(e[7]) && e[7].apply(this, arguments)
                    }
                    )), Dr(t, "pointerdown", (function() {
                        rr(e[14]) && e[14].apply(this, arguments)
                    }
                    )), $r(e[9].call(null, t))],
                    n = !0)
                },
                p(n, [r]) {
                    e = n,
                    s ? s.p && (!o || 536870912 & r) && hr(s, a, e, e[29], o ? pr(a, e[29], r, null) : mr(e[29]), null) : l && l.p && (!o || 10249 & r) && l.p(e, o ? r : -1),
                    (!o || 64 & r) && Or(t, "type", e[6]),
                    (!o || 16 & r) && Or(t, "style", e[4]),
                    (!o || 32 & r) && (t.disabled = e[5]),
                    (!o || 4096 & r) && Or(t, "class", e[12]),
                    (!o || 7 & r && i !== (i = ru(e[0], e[1], e[2]))) && Or(t, "title", i)
                },
                i(e) {
                    o || (ka(l, e),
                    o = !0)
                },
                o(e) {
                    Ca(l, e),
                    o = !1
                },
                d(i) {
                    i && Pr(t),
                    l && l.d(i),
                    e[28](null),
                    n = !1,
                    nr(r)
                }
            }
        }
        function uu(e, t, i) {
            let o, n, r, a, s, l, {$$slots: c={}, $$scope: u} = t, {class: d} = t, {label: p} = t, {title: h} = t, {shortcut: m} = t, {labelClass: f} = t, {innerClass: g} = t, {hideLabel: y=!1} = t, {icon: b} = t, {style: v} = t, {disabled: x} = t, {type: w="button"} = t, {onclick: S} = t, {onkeydown: _} = t, {onhold: k} = t, {action: C=( () => {}
            )} = t, {holdThreshold: T=500} = t, {holdSpeedUpFactor: M=.5} = t, {holdSpeedMin: P=20} = t;
            const E = e => {
                i(25, l = setTimeout(( () => {
                    k(),
                    E(Math.max(e * M, P))
                }
                ), e))
            }
            ;
            let R;
            return e.$$set = e => {
                "class"in e && i(15, d = e.class),
                "label"in e && i(0, p = e.label),
                "title"in e && i(1, h = e.title),
                "shortcut"in e && i(2, m = e.shortcut),
                "labelClass"in e && i(16, f = e.labelClass),
                "innerClass"in e && i(17, g = e.innerClass),
                "hideLabel"in e && i(18, y = e.hideLabel),
                "icon"in e && i(3, b = e.icon),
                "style"in e && i(4, v = e.style),
                "disabled"in e && i(5, x = e.disabled),
                "type"in e && i(6, w = e.type),
                "onclick"in e && i(7, S = e.onclick),
                "onkeydown"in e && i(8, _ = e.onkeydown),
                "onhold"in e && i(19, k = e.onhold),
                "action"in e && i(9, C = e.action),
                "holdThreshold"in e && i(20, T = e.holdThreshold),
                "holdSpeedUpFactor"in e && i(21, M = e.holdSpeedUpFactor),
                "holdSpeedMin"in e && i(22, P = e.holdSpeedMin),
                "$$scope"in e && i(29, u = e.$$scope)
            }
            ,
            e.$$.update = () => {
                101187584 & e.$$.dirty && i(26, n = k ? () => {
                    l && (clearTimeout(l),
                    i(25, l = void 0),
                    document.documentElement.removeEventListener("pointerup", n))
                }
                : $),
                68681728 & e.$$.dirty && i(14, o = k ? () => {
                    document.documentElement.addEventListener("pointerup", n),
                    E(T)
                }
                : $),
                131072 & e.$$.dirty && i(13, r = Pc(["PinturaButtonInner", g])),
                294912 & e.$$.dirty && i(12, a = Pc(["PinturaButton", y && "PinturaButtonIconOnly", d])),
                327680 & e.$$.dirty && i(11, s = Pc([y ? "implicit" : "PinturaButtonLabel", f]))
            }
            ,
            [p, h, m, b, v, x, w, S, _, C, R, s, a, r, o, d, f, g, y, k, T, M, P, e => nu(e, R), () => R, l, n, c, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    R = e,
                    i(10, R)
                }
                ))
            }
            , u]
        }
        class du extends Na {
            constructor(e) {
                super(),
                Ba(this, e, uu, cu, ar, {
                    class: 15,
                    label: 0,
                    title: 1,
                    shortcut: 2,
                    labelClass: 16,
                    innerClass: 17,
                    hideLabel: 18,
                    icon: 3,
                    style: 4,
                    disabled: 5,
                    type: 6,
                    onclick: 7,
                    onkeydown: 8,
                    onhold: 19,
                    action: 9,
                    holdThreshold: 20,
                    holdSpeedUpFactor: 21,
                    holdSpeedMin: 22,
                    isEventTarget: 23,
                    getElement: 24
                })
            }
            get isEventTarget() {
                return this.$$.ctx[23]
            }
            get getElement() {
                return this.$$.ctx[24]
            }
        }
        var pu = (e, t) => {
            const i = e.findIndex(t);
            if (i >= 0)
                return e.splice(i, 1)
        }
        ;
        const hu = 80;
        var mu = (e, t={}) => {
            const {inertia: i=!1, inertiaDurationMultiplier: o=hu, shouldStartInteraction: n=( () => !0), pinch: r=!1, multiTouch: a, getEventPosition: s=(e => Ce(e.clientX, e.clientY)), observeKeys: l=!1} = t;
            function c(t, i) {
                e.dispatchEvent(new CustomEvent(t,{
                    detail: i
                }))
            }
            function u() {
                _ && _(),
                _ = void 0
            }
            const d = []
              , p = e => 0 === e.timeStamp ? Date.now() : e.timeStamp
              , h = e => {
                const t = pu(d, (t => t.event.pointerId === e.pointerId));
                if (t)
                    return t[0]
            }
              , m = () => {
                const e = Me(d[0].position);
                if (d[1]) {
                    const t = .5 * (d[1].position.x - e.x)
                      , i = .5 * (d[1].position.y - e.y);
                    e.x += t,
                    e.y += i
                }
                return e
            }
              , f = e => {
                e.origin.x = e.position.x,
                e.origin.y = e.position.y,
                e.translation.x = 0,
                e.translation.y = 0
            }
              , g = e => {
                const t = y(e);
                if (!t)
                    return;
                const i = p(e)
                  , o = s(e)
                  , n = Math.max(1, i - t.timeStamp);
                t.velocity.x = (o.x - t.position.x) / n,
                t.velocity.y = (o.y - t.position.y) / n,
                t.velocityHistory.push(Me(t.velocity)),
                t.velocityHistory = t.velocityHistory.slice(-3),
                t.velocityAverage = t.velocityHistory.reduce(( (e, t, i, o) => (e.x += t.x / o.length,
                e.y += t.y / o.length,
                e)), ke()),
                t.translation.x = o.x - t.origin.x,
                t.translation.y = o.y - t.origin.y,
                t.timeStamp = i,
                t.position.x = o.x,
                t.position.y = o.y,
                t.event = e
            }
              , y = e => {
                const t = (e => d.findIndex((t => t.event.pointerId === e.pointerId)))(e);
                if (!(t < 0))
                    return d[t]
            }
              , $ = () => 1 === d.length
              , b = () => 2 === d.length
              , v = e => {
                const t = Ve(e.map((e => e.position)))
                  , i = ( (e, t) => e.reduce(( (e, i) => e + je(t, i.position)), 0) / e.length)(e, t);
                return {
                    center: t,
                    distance: i,
                    velocity: Ve(e.map((e => e.velocity))),
                    translation: Ve(e.map((e => e.translation)))
                }
            }
            ;
            let x, w, S, _, k, C, T, M, P, E = 0;
            e.addEventListener("pointerdown", D);
            const R = ["Meta", "Control", "Alt", "Shift"];
            function A(e) {
                if (!R.includes(e.key))
                    return;
                const {metaKey: t, ctrlKey: i, altKey: o, shiftKey: n} = e;
                L({
                    metaKey: t,
                    ctrlKey: i,
                    altKey: o,
                    shiftKey: n
                })
            }
            let I = Date.now();
            const L = e => {
                const t = Me(d[0].translation);
                let i = T;
                r && b() && (i *= je(d[0].position, d[1].position) / k,
                ze(t, d[1].translation)),
                ze(t, C);
                const o = Date.now();
                o - I < 16 || (I = o,
                c("interactionupdate", {
                    position: m(),
                    translation: t,
                    scalar: r ? i : void 0,
                    isMultiTouching: b(),
                    ...e
                }))
            }
            ;
            function D(t) {
                if (!b() && !(e => Wi(e.button) && 0 !== e.button)(t) && n(t, e))
                    if (u(),
                    (e => {
                        const t = p(e)
                          , i = {
                            timeStamp: t,
                            timeStampInitial: t,
                            position: s(e),
                            origin: s(e),
                            velocity: ke(),
                            velocityHistory: [],
                            velocityAverage: ke(),
                            translation: ke(),
                            interactionState: void 0,
                            event: e
                        };
                        d.push(i),
                        i.interactionState = v(d)
                    }
                    )(t),
                    l && (window.addEventListener("keydown", A),
                    window.addEventListener("keyup", A)),
                    $())
                        document.documentElement.addEventListener("pointermove", z),
                        document.documentElement.addEventListener("pointerup", F),
                        document.documentElement.addEventListener("pointercancel", F),
                        document.addEventListener("visibilitychange", B),
                        M = !1,
                        T = 1,
                        C = ke(),
                        k = void 0,
                        c("interactionstart", {
                            origin: Me(y(t).origin)
                        });
                    else if (r)
                        M = !0,
                        k = je(d[0].position, d[1].position),
                        C.x += d[0].translation.x,
                        C.y += d[0].translation.y,
                        f(d[0]);
                    else if (!1 === a)
                        return d.length = 0,
                        W(),
                        c("interactioncancel")
            }
            function z(e) {
                e.preventDefault(),
                g(e);
                const {metaKey: t=!1, ctrlKey: i=!1, altKey: o=!1, shiftKey: n=!1} = l ? e : {};
                L({
                    metaKey: t,
                    ctrlKey: i,
                    altKey: o,
                    shiftKey: n
                })
            }
            function F(e) {
                if (!y(e))
                    return;
                const t = m()
                  , n = h(e);
                if (r && $()) {
                    const e = je(d[0].position, n.position);
                    T *= e / k,
                    C.x += d[0].translation.x + n.translation.x,
                    C.y += d[0].translation.y + n.translation.y,
                    f(d[0])
                }
                let a = !1
                  , s = !1;
                if (!M && n) {
                    const e = performance.now()
                      , t = e - n.timeStampInitial
                      , i = He(n.translation);
                    a = i < 64 && t < 300,
                    s = !!(P && a && e - E < 700 && He(P, n.position) < 128),
                    a && (P = Me(n.position),
                    E = e)
                }
                if (d.length > 0)
                    return;
                W();
                const l = Me(n.translation)
                  , u = Me(n.velocityAverage);
                let p = !1;
                c("interactionrelease", {
                    isTap: a,
                    isDoubleTap: s,
                    position: t,
                    translation: l,
                    scalar: T,
                    preventInertia: () => p = !0
                });
                const g = je(u);
                if (p || !i || g < .25)
                    return N(l, {
                        isTap: a,
                        isDoubleTap: s
                    });
                w = Me(t),
                S = Me(l),
                x = ec(Me(l), {
                    easing: Yl,
                    duration: g * o
                }),
                x.set({
                    x: l.x + 50 * u.x,
                    y: l.y + 50 * u.y
                }).then(( () => {
                    _ && N(lr(x), {
                        isTap: a,
                        isDoubleTap: s
                    })
                }
                )),
                _ = x.subscribe(O)
            }
            function O(e) {
                e && c("interactionupdate", {
                    position: Ce(w.x + (e.x - S.x), w.y + (e.y - S.y)),
                    translation: e,
                    scalar: r ? T : void 0
                })
            }
            function B(e) {
                if ("visible" === document.visibilityState || !d.length)
                    return;
                const t = v(d);
                u(),
                c("interactionend", {
                    ...t
                }),
                d.length = 0,
                W()
            }
            function N(e, t) {
                u(),
                c("interactionend", {
                    ...t,
                    translation: e,
                    scalar: r ? T : void 0
                })
            }
            function W() {
                l && window.removeEventListener("keydown", A),
                l && window.removeEventListener("keyup", A),
                document.documentElement.removeEventListener("pointermove", z),
                document.documentElement.removeEventListener("pointerup", F),
                document.documentElement.removeEventListener("pointercancel", F),
                document.addEventListener("visibilitychange", B)
            }
            return {
                destroy() {
                    u(),
                    e.removeEventListener("pointerdown", D)
                }
            }
        }
          , fu = (e, t={}) => {
            const {direction: i, shiftMultiplier: o=10, bubbles: n=!1, preventDefault: r=!1, stopKeydownPropagation: a=!0} = t
              , s = "horizontal" === i
              , l = "vertical" === i
              , c = t => {
                const {key: i} = t
                  , c = t.shiftKey
                  , u = /up|down/i.test(i)
                  , d = /left|right/i.test(i);
                if (!d && !u)
                    return;
                if (s && u)
                    return;
                if (l && d)
                    return;
                const p = c ? o : 1;
                a && t.stopPropagation(),
                r && t.preventDefault(),
                e.dispatchEvent(new CustomEvent("nudge",{
                    bubbles: n,
                    detail: Ce((/left/i.test(i) ? -1 : /right/i.test(i) ? 1 : 0) * p, (/up/i.test(i) ? -1 : /down/i.test(i) ? 1 : 0) * p)
                }))
            }
            ;
            return e.addEventListener("keydown", c),
            {
                destroy() {
                    e.removeEventListener("keydown", c)
                }
            }
        }
        ;
        function gu(e, t) {
            return t ? t * Math.sign(e) * Math.log10(1 + Math.abs(e) / t) : e
        }
        const yu = (e, t, i) => {
            if (!t || !i)
                return {
                    ...e
                };
            const o = e.x + gu(t.x - e.x, i)
              , n = e.x + e.width + gu(t.x + t.width - (e.x + e.width), i)
              , r = e.y + gu(t.y - e.y, i);
            return {
                x: o,
                y: r,
                width: n - o,
                height: e.y + e.height + gu(t.y + t.height - (e.y + e.height), i) - r
            }
        }
          , $u = (e, t, i) => t && i ? Ce(e.x + gu(t.x - e.x, i), e.y + gu(t.y - e.y, i)) : {
            ...e
        };
        var bu = (e, t) => {
            if (e)
                return /em/.test(e) ? 16 * parseInt(e, 10) : /px/.test(e) ? parseInt(e, 10) : void 0
        }
          , vu = (e, t) => {
            let i = e.detail || 0;
            const {deltaX: o, deltaY: n, wheelDelta: r, wheelDeltaX: a, wheelDeltaY: s} = e
              , {fixScrollDirection: l=!1} = t || {};
            return Wi(a) && Math.abs(a) > Math.abs(s) ? i = a / -120 : Wi(o) && Math.abs(o) > Math.abs(n) ? i = o / 20 : (r || s) && (i = (r || s) / -120),
            i || (i = n / 20),
            (X() || si()) && (i *= 2),
            l && Si() && (i *= -1),
            i
        }
        ;
        function xu(e) {
            let t, i, o, n, r, a, s;
            const l = e[37].default
              , c = ur(l, e, e[36], null);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    c && c.c(),
                    Or(i, "style", e[5]),
                    Or(t, "class", o = Pc(["PinturaScrollable", e[0]])),
                    Or(t, "style", e[4]),
                    Or(t, "data-direction", e[1]),
                    Or(t, "data-state", e[6])
                },
                m(o, l) {
                    Mr(o, t, l),
                    kr(t, i),
                    c && c.m(i, null),
                    e[39](t),
                    r = !0,
                    a || (s = [Dr(i, "interactionstart", e[9]), Dr(i, "interactionupdate", e[11]), Dr(i, "interactionend", e[12]), Dr(i, "interactionrelease", e[10]), $r(mu.call(null, i, {
                        inertia: !0
                    })), Dr(i, "measure", e[38]), $r($c.call(null, i)), Dr(t, "wheel", e[14], {
                        passive: !1
                    }), Dr(t, "scroll", e[16]), Dr(t, "focusin", e[15]), Dr(t, "nudge", e[17]), Dr(t, "measure", e[13]), $r($c.call(null, t, {
                        observePosition: !0
                    })), $r(n = fu.call(null, t, {
                        direction: "x" === e[1] ? "horizontal" : "vertical",
                        stopKeydownPropagation: !1
                    }))],
                    a = !0)
                },
                p(e, a) {
                    c && c.p && (!r || 32 & a[1]) && hr(c, l, e, e[36], r ? pr(l, e[36], a, null) : mr(e[36]), null),
                    (!r || 32 & a[0]) && Or(i, "style", e[5]),
                    (!r || 1 & a[0] && o !== (o = Pc(["PinturaScrollable", e[0]]))) && Or(t, "class", o),
                    (!r || 16 & a[0]) && Or(t, "style", e[4]),
                    (!r || 2 & a[0]) && Or(t, "data-direction", e[1]),
                    (!r || 64 & a[0]) && Or(t, "data-state", e[6]),
                    n && rr(n.update) && 2 & a[0] && n.update.call(null, {
                        direction: "x" === e[1] ? "horizontal" : "vertical",
                        stopKeydownPropagation: !1
                    })
                },
                i(e) {
                    r || (ka(c, e),
                    r = !0)
                },
                o(e) {
                    Ca(c, e),
                    r = !1
                },
                d(i) {
                    i && Pr(t),
                    c && c.d(i),
                    e[39](null),
                    a = !1,
                    nr(s)
                }
            }
        }
        function wu(e, t, i) {
            let o, n, r, a, s, l, c, u, d, {$$slots: p={}, $$scope: h} = t;
            const m = ta();
            let f, g, y, b, v = "idle", x = ic(0);
            cr(e, x, (e => i(35, u = e)));
            let {class: w} = t
              , {scrollBlockInteractionDist: S=5} = t
              , {scrollStep: _=10} = t
              , {scrollFocusMargin: k=64} = t
              , {scrollDirection: C="x"} = t
              , {scrollAutoCancel: T=!1} = t
              , {elasticity: M=0} = t
              , {onscroll: P=$} = t
              , {maskFeatherSize: E} = t
              , {maskFeatherStartOpacity: R} = t
              , {maskFeatherEndOpacity: A} = t
              , {scroll: I} = t;
            const L = oa("fixScrollDirection");
            let D;
            cr(e, L, (e => i(46, d = e)));
            let z = ""
              , F = !0;
            const O = x.subscribe((e => {
                const t = ke();
                t[C] = e,
                P(t)
            }
            ))
              , B = e => Math.max(Math.min(0, e), y[o] - g[o]);
            let N, W, H;
            const j = (e, t={}) => {
                const {elastic: o=!1, animate: n=!1, preventScrollState: r=!1} = t;
                Math.abs(e - f) > S && "idle" === v && !b && !r && i(28, v = "scrolling");
                const a = B(e)
                  , s = o && M && !b ? a + gu(e - a, M) : a;
                let l = !0;
                n ? l = !1 : F || (l = !b),
                F = !1,
                x.set(s, {
                    hard: l
                }).then((e => {
                    b && (F = !0)
                }
                ))
            }
            ;
            return ea(( () => {
                O()
            }
            )),
            e.$$set = e => {
                "class"in e && i(0, w = e.class),
                "scrollBlockInteractionDist"in e && i(21, S = e.scrollBlockInteractionDist),
                "scrollStep"in e && i(22, _ = e.scrollStep),
                "scrollFocusMargin"in e && i(23, k = e.scrollFocusMargin),
                "scrollDirection"in e && i(1, C = e.scrollDirection),
                "scrollAutoCancel"in e && i(24, T = e.scrollAutoCancel),
                "elasticity"in e && i(25, M = e.elasticity),
                "onscroll"in e && i(26, P = e.onscroll),
                "maskFeatherSize"in e && i(20, E = e.maskFeatherSize),
                "maskFeatherStartOpacity"in e && i(18, R = e.maskFeatherStartOpacity),
                "maskFeatherEndOpacity"in e && i(19, A = e.maskFeatherEndOpacity),
                "scroll"in e && i(27, I = e.scroll),
                "$$scope"in e && i(36, h = e.$$scope)
            }
            ,
            e.$$.update = () => {
                if (2 & e.$$.dirty[0] && i(32, o = "x" === C ? "width" : "height"),
                2 & e.$$.dirty[0] && i(30, n = C.toUpperCase()),
                8 & e.$$.dirty[0] && i(34, r = D && getComputedStyle(D)),
                8 & e.$$.dirty[0] | 8 & e.$$.dirty[1] && i(33, a = r && bu(r.getPropertyValue("--scrollable-feather-size"))),
                537657348 & e.$$.dirty[0] | 22 & e.$$.dirty[1] && null != u && y && null != a && g) {
                    const e = -1 * u / a
                      , t = -(y[o] - g[o] - u) / a;
                    i(18, R = cs(1 - e, 0, 1)),
                    i(19, A = cs(1 - t, 0, 1)),
                    i(20, E = a),
                    i(4, z = `--scrollable-feather-start-opacity: ${R};--scrollable-feather-end-opacity: ${A}`)
                }
                134217736 & e.$$.dirty[0] && D && void 0 !== I && (Wi(I) ? j(I) : j(I.scrollOffset, I)),
                536870916 & e.$$.dirty[0] | 2 & e.$$.dirty[1] && i(31, s = y && g ? g[o] > y[o] : void 0),
                268435456 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && i(6, l = Pc([v, s ? "overflows" : void 0])),
                1073741824 & e.$$.dirty[0] | 17 & e.$$.dirty[1] && i(5, c = s ? `transform: translate${n}(${u}px)` : void 0)
            }
            ,
            [w, C, g, D, z, c, l, x, L, () => {
                s && (W = !1,
                N = !0,
                H = Ce(0, 0),
                b = !1,
                i(28, v = "idle"),
                f = lr(x))
            }
            , ({detail: e}) => {
                s && (b = !0,
                i(28, v = "idle"))
            }
            , ({detail: e}) => {
                s && (W || N && (N = !1,
                He(e.translation) < .1) || (!T || "x" !== C || (e => {
                    const t = De(Ce(e.x - H.x, e.y - H.y), Math.abs);
                    H = Me(e);
                    const i = He(t)
                      , o = t.x - t.y;
                    return !(i > 1 && o < -.5)
                }
                )(e.translation) ? j(f + e.translation[C], {
                    elastic: !0
                }) : W = !0))
            }
            , ({detail: e}) => {
                if (!s)
                    return;
                if (W)
                    return;
                const t = f + e.translation[C]
                  , i = B(t);
                F = !1,
                x.set(i).then((e => {
                    b && (F = !0)
                }
                ))
            }
            , ({detail: e}) => {
                i(29, y = e),
                m("measure", {
                    x: e.x,
                    y: e.y,
                    width: e.width,
                    height: e.height
                })
            }
            , e => {
                if (!s)
                    return;
                e.preventDefault(),
                e.stopPropagation();
                const t = e.shiftKey
                  , i = vu(e, {
                    fixScrollDirection: d
                }) * (t ? -1 : 1)
                  , o = lr(x);
                j(o + i * _, {
                    animate: !0
                })
            }
            , e => {
                if (!s)
                    return;
                if (!b)
                    return;
                let t = e.target;
                e.target.classList.contains("implicit") && (t = t.parentNode);
                const i = t["x" === C ? "offsetLeft" : "offsetTop"]
                  , n = i + t["x" === C ? "offsetWidth" : "offsetHeight"]
                  , r = lr(x)
                  , a = k + E;
                r + i < a ? j(-i + a) : r + n > y[o] - a && j(y[o] - n - a, {
                    animate: !0
                })
            }
            , () => {
                i(3, D["x" === C ? "scrollLeft" : "scrollTop"] = 0, D)
            }
            , ({detail: e}) => {
                if (D.querySelector("[data-focus-visible]"))
                    return;
                const t = -2 * e[C]
                  , i = lr(x);
                j(i + t * _, {
                    animate: !0,
                    preventScrollState: !0
                })
            }
            , R, A, E, S, _, k, T, M, P, I, v, y, n, s, o, a, r, u, h, p, e => i(2, g = e.detail), function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    D = e,
                    i(3, D)
                }
                ))
            }
            ]
        }
        class Su extends Na {
            constructor(e) {
                super(),
                Ba(this, e, wu, xu, ar, {
                    class: 0,
                    scrollBlockInteractionDist: 21,
                    scrollStep: 22,
                    scrollFocusMargin: 23,
                    scrollDirection: 1,
                    scrollAutoCancel: 24,
                    elasticity: 25,
                    onscroll: 26,
                    maskFeatherSize: 20,
                    maskFeatherStartOpacity: 18,
                    maskFeatherEndOpacity: 19,
                    scroll: 27
                }, null, [-1, -1])
            }
        }
        function _u(e) {
            let t, i, o, n, r;
            return {
                c() {
                    t = Er("span"),
                    Or(t, "class", "PinturaStatusMessage")
                },
                m(i, a) {
                    Mr(i, t, a),
                    t.innerHTML = e[0],
                    o = !0,
                    n || (r = [Dr(t, "measure", (function() {
                        rr(e[1]) && e[1].apply(this, arguments)
                    }
                    )), $r($c.call(null, t))],
                    n = !0)
                },
                p(i, [n]) {
                    e = i,
                    (!o || 1 & n) && (t.innerHTML = e[0])
                },
                i(n) {
                    o || (ha(( () => {
                        i || (i = Ma(t, e[4], {
                            duration: e[2]
                        }, !0)),
                        i.run(1)
                    }
                    )),
                    o = !0)
                },
                o(n) {
                    i || (i = Ma(t, e[4], {
                        duration: e[2]
                    }, !1)),
                    i.run(0),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    e && i && i.end(),
                    n = !1,
                    nr(r)
                }
            }
        }
        function ku(e, t, i) {
            let o, n, {text: r} = t, {onmeasure: a=$} = t;
            const s = oa("isAnimated");
            return cr(e, s, (e => i(5, n = e))),
            e.$$set = e => {
                "text"in e && i(0, r = e.text),
                "onmeasure"in e && i(1, a = e.onmeasure)
            }
            ,
            e.$$.update = () => {
                32 & e.$$.dirty && i(2, o = n ? 500 : 0)
            }
            ,
            [r, a, o, s, function(e, {duration: t}) {
                return {
                    duration: t,
                    tick: t => {
                        e.style.opacity = t
                    }
                }
            }
            , n]
        }
        class Cu extends Na {
            constructor(e) {
                super(),
                Ba(this, e, ku, _u, ar, {
                    text: 0,
                    onmeasure: 1
                })
            }
        }
        function Tu(e) {
            let t, i, o, n, r, a, s, l, c;
            return {
                c() {
                    t = Er("span"),
                    i = Rr("svg"),
                    o = Rr("g"),
                    n = Rr("circle"),
                    r = Rr("circle"),
                    a = Ir(),
                    s = Er("span"),
                    l = Ar(e[3]),
                    Or(n, "class", "PinturaProgressIndicatorBar"),
                    Or(n, "r", "8.5"),
                    Or(n, "cx", "10"),
                    Or(n, "cy", "10"),
                    Or(n, "stroke-linecap", "round"),
                    Or(n, "opacity", ".25"),
                    Or(r, "class", "PinturaProgressIndicatorFill"),
                    Or(r, "r", "8.5"),
                    Or(r, "stroke-dasharray", e[2]),
                    Or(r, "cx", "10"),
                    Or(r, "cy", "10"),
                    Or(r, "transform", "rotate(-90) translate(-20)"),
                    Or(o, "fill", "none"),
                    Or(o, "stroke", "currentColor"),
                    Or(o, "stroke-width", "2.5"),
                    Or(o, "stroke-linecap", "round"),
                    Or(o, "opacity", e[1]),
                    Or(i, "width", "20"),
                    Or(i, "height", "20"),
                    Or(i, "viewBox", "0 0 20 20"),
                    Or(i, "xmlns", "http://www.w3.org/2000/svg"),
                    Or(i, "aria-hidden", "true"),
                    Or(i, "focusable", "false"),
                    Or(s, "class", "implicit"),
                    Or(t, "class", "PinturaProgressIndicator"),
                    Or(t, "data-status", e[0]),
                    Or(t, "style", c = `opacity:${e[4]}`)
                },
                m(e, c) {
                    Mr(e, t, c),
                    kr(t, i),
                    kr(i, o),
                    kr(o, n),
                    kr(o, r),
                    kr(t, a),
                    kr(t, s),
                    kr(s, l)
                },
                p(e, [i]) {
                    4 & i && Or(r, "stroke-dasharray", e[2]),
                    2 & i && Or(o, "opacity", e[1]),
                    8 & i && Wr(l, e[3]),
                    1 & i && Or(t, "data-status", e[0]),
                    16 & i && c !== (c = `opacity:${e[4]}`) && Or(t, "style", c)
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Mu(e, t, i) {
            let o, n, r, a, s, l, c, u;
            const d = ta();
            let {progress: p} = t
              , {min: h=0} = t
              , {max: m=100} = t
              , {labelBusy: f="Busy"} = t
              , {opacity: g} = t;
            const y = oa("isAnimated");
            cr(e, y, (e => i(14, s = e)));
            const $ = ic(g, {
                precision: .01
            });
            cr(e, $, (e => i(4, u = e)));
            const b = ic(0, {
                precision: .01
            })
              , v = ic(0, {
                precision: .01
            });
            cr(e, v, (e => i(15, l = e)));
            const x = Ua([b], (e => cs(e, h, m)));
            cr(e, x, (e => i(16, c = e)));
            const w = x.subscribe((e => {
                1 === p && Math.round(e) >= 100 && d("complete")
            }
            ));
            return Qr(( () => {
                v.set(1, {
                    hard: !s
                })
            }
            )),
            ea(( () => {
                w()
            }
            )),
            e.$$set = e => {
                "progress"in e && i(9, p = e.progress),
                "min"in e && i(10, h = e.min),
                "max"in e && i(11, m = e.max),
                "labelBusy"in e && i(12, f = e.labelBusy),
                "opacity"in e && i(13, g = e.opacity)
            }
            ,
            e.$$.update = () => {
                24576 & e.$$.dirty && Wi(g) && $.set(g, {
                    hard: !s
                }),
                16896 & e.$$.dirty && p && p !== 1 / 0 && b.set(100 * p, {
                    hard: !s
                }),
                70144 & e.$$.dirty && i(3, o = p === 1 / 0 ? f : `${Math.round(c)}%`),
                66048 & e.$$.dirty && i(2, n = p === 1 / 0 ? "26.5 53" : c / 100 * 53 + " 53"),
                32768 & e.$$.dirty && i(1, r = l),
                512 & e.$$.dirty && i(0, a = p === 1 / 0 ? "busy" : "loading")
            }
            ,
            [a, r, n, o, u, y, $, v, x, p, h, m, f, g, s, l, c]
        }
        class Pu extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Mu, Tu, ar, {
                    progress: 9,
                    min: 10,
                    max: 11,
                    labelBusy: 12,
                    opacity: 13
                })
            }
        }
        function Eu(e) {
            let t, i, o;
            const n = e[5].default
              , r = ur(n, e, e[4], null);
            return {
                c() {
                    t = Er("span"),
                    r && r.c(),
                    Or(t, "class", i = `PinturaStatusAside ${e[0]}`),
                    Or(t, "style", e[1])
                },
                m(e, i) {
                    Mr(e, t, i),
                    r && r.m(t, null),
                    o = !0
                },
                p(e, [a]) {
                    r && r.p && (!o || 16 & a) && hr(r, n, e, e[4], o ? pr(n, e[4], a, null) : mr(e[4]), null),
                    (!o || 1 & a && i !== (i = `PinturaStatusAside ${e[0]}`)) && Or(t, "class", i),
                    (!o || 2 & a) && Or(t, "style", e[1])
                },
                i(e) {
                    o || (ka(r, e),
                    o = !0)
                },
                o(e) {
                    Ca(r, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    r && r.d(e)
                }
            }
        }
        function Ru(e, t, i) {
            let o, {$$slots: n={}, $$scope: r} = t, {offset: a=0} = t, {opacity: s=0} = t, {class: l} = t;
            return e.$$set = e => {
                "offset"in e && i(2, a = e.offset),
                "opacity"in e && i(3, s = e.opacity),
                "class"in e && i(0, l = e.class),
                "$$scope"in e && i(4, r = e.$$scope)
            }
            ,
            e.$$.update = () => {
                12 & e.$$.dirty && i(1, o = `transform:translateX(${a}px);opacity:${s}`)
            }
            ,
            [l, o, a, s, r, n]
        }
        class Au extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Ru, Eu, ar, {
                    offset: 2,
                    opacity: 3,
                    class: 0
                })
            }
        }
        const {document: Iu} = Pa;
        function Lu(e) {
            let t, i, o, n;
            return {
                c() {
                    t = Ir(),
                    i = Er("button"),
                    Or(i, "class", "PinturaImageButton"),
                    Or(i, "type", "button"),
                    Or(i, "title", e[1]),
                    i.disabled = e[2]
                },
                m(r, a) {
                    Mr(r, t, a),
                    Mr(r, i, a),
                    i.innerHTML = e[0],
                    e[11](i),
                    o || (n = [Dr(Iu.body, "load", e[5], !0), Dr(Iu.body, "error", e[6], !0), Dr(i, "pointerdown", e[4])],
                    o = !0)
                },
                p(e, [t]) {
                    1 & t && (i.innerHTML = e[0]),
                    2 & t && Or(i, "title", e[1]),
                    4 & t && (i.disabled = e[2])
                },
                i: Jn,
                o: Jn,
                d(r) {
                    r && Pr(t),
                    r && Pr(i),
                    e[11](null),
                    o = !1,
                    nr(n)
                }
            }
        }
        function Du(e, t, i) {
            let o, {html: n} = t, {title: r} = t, {onclick: a} = t, {disabled: s=!1} = t, {ongrab: l=$} = t, {ondrag: c=$} = t, {ondrop: u=$} = t;
            const d = e => He(p, Ce(e.pageX, e.pageY)) < 256;
            let p;
            const h = e => {
                document.documentElement.removeEventListener("pointermove", m),
                document.documentElement.removeEventListener("pointerup", h);
                const t = Ce(e.pageX, e.pageY);
                if (He(p, t) < 32)
                    return a(e);
                d(e) || u(e)
            }
              , m = e => {
                d(e) || c(e)
            }
              , f = e => o && o.contains(e) && "IMG" === e.nodeName;
            return e.$$set = e => {
                "html"in e && i(0, n = e.html),
                "title"in e && i(1, r = e.title),
                "onclick"in e && i(7, a = e.onclick),
                "disabled"in e && i(2, s = e.disabled),
                "ongrab"in e && i(8, l = e.ongrab),
                "ondrag"in e && i(9, c = e.ondrag),
                "ondrop"in e && i(10, u = e.ondrop)
            }
            ,
            e.$$.update = () => {
                8 & e.$$.dirty && o && o.querySelector("img") && i(3, o.dataset.loader = !0, o)
            }
            ,
            [n, r, s, o, e => {
                p = Ce(e.pageX, e.pageY),
                l(e),
                document.documentElement.addEventListener("pointermove", m),
                document.documentElement.addEventListener("pointerup", h)
            }
            , ({target: e}) => {
                f(e) && i(3, o.dataset.load = !0, o)
            }
            , ({target: e}) => {
                f(e) && i(3, o.dataset.error = !0, o)
            }
            , a, l, c, u, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    o = e,
                    i(3, o)
                }
                ))
            }
            ]
        }
        class zu extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Du, Lu, ar, {
                    html: 0,
                    title: 1,
                    onclick: 7,
                    disabled: 2,
                    ongrab: 8,
                    ondrag: 9,
                    ondrop: 10
                })
            }
        }
        function Fu(e, t, i) {
            const o = e.slice();
            return o[14] = t[i],
            o
        }
        function Ou(e, t) {
            let i, o, n, r, a, s, l;
            function c() {
                return t[10](t[14])
            }
            function u(...e) {
                return t[11](t[14], ...e)
            }
            function d(...e) {
                return t[12](t[14], ...e)
            }
            function p(...e) {
                return t[13](t[14], ...e)
            }
            return o = new zu({
                props: {
                    onclick: c,
                    ongrab: u,
                    ondrag: d,
                    ondrop: p,
                    disabled: t[1] || t[14].disabled,
                    title: t[14].title,
                    html: t[14].thumb
                }
            }),
            {
                key: e,
                first: null,
                c() {
                    i = Er("li"),
                    za(o.$$.fragment),
                    n = Ir(),
                    Or(i, "style", t[6]),
                    this.first = i
                },
                m(e, c) {
                    Mr(e, i, c),
                    Fa(o, i, null),
                    kr(i, n),
                    a = !0,
                    s || (l = $r(r = t[8].call(null, i, t[14])),
                    s = !0)
                },
                p(e, n) {
                    t = e;
                    const s = {};
                    5 & n && (s.onclick = c),
                    9 & n && (s.ongrab = u),
                    17 & n && (s.ondrag = d),
                    33 & n && (s.ondrop = p),
                    3 & n && (s.disabled = t[1] || t[14].disabled),
                    1 & n && (s.title = t[14].title),
                    1 & n && (s.html = t[14].thumb),
                    o.$set(s),
                    (!a || 64 & n) && Or(i, "style", t[6]),
                    r && rr(r.update) && 1 & n && r.update.call(null, t[14])
                },
                i(e) {
                    a || (ka(o.$$.fragment, e),
                    a = !0)
                },
                o(e) {
                    Ca(o.$$.fragment, e),
                    a = !1
                },
                d(e) {
                    e && Pr(i),
                    Oa(o),
                    s = !1,
                    l()
                }
            }
        }
        function Bu(e) {
            let t, i, o = [], n = new Map, r = e[0];
            const a = e => e[14].id;
            for (let t = 0; t < r.length; t += 1) {
                let i = Fu(e, r, t)
                  , s = a(i);
                n.set(s, o[t] = Ou(s, i))
            }
            return {
                c() {
                    t = Er("ul");
                    for (let e = 0; e < o.length; e += 1)
                        o[e].c();
                    Or(t, "class", "PinturaImageButtonList")
                },
                m(e, n) {
                    Mr(e, t, n);
                    for (let e = 0; e < o.length; e += 1)
                        o[e].m(t, null);
                    i = !0
                },
                p(e, [i]) {
                    127 & i && (r = e[0],
                    Sa(),
                    o = Aa(o, i, a, 1, e, r, n, t, Ra, Ou, null, Fu),
                    _a())
                },
                i(e) {
                    if (!i) {
                        for (let e = 0; e < r.length; e += 1)
                            ka(o[e]);
                        i = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < o.length; e += 1)
                        Ca(o[e]);
                    i = !1
                },
                d(e) {
                    e && Pr(t);
                    for (let e = 0; e < o.length; e += 1)
                        o[e].d()
                }
            }
        }
        function Nu(e, t, i) {
            let o, n, {items: r} = t, {disabled: a} = t, {onclickitem: s} = t, {ongrabitem: l} = t, {ondragitem: c} = t, {ondropitem: u} = t;
            const d = ic(0, {
                stiffness: .25,
                damping: .9
            });
            return cr(e, d, (e => i(9, n = e))),
            Qr(( () => d.set(1))),
            e.$$set = e => {
                "items"in e && i(0, r = e.items),
                "disabled"in e && i(1, a = e.disabled),
                "onclickitem"in e && i(2, s = e.onclickitem),
                "ongrabitem"in e && i(3, l = e.ongrabitem),
                "ondragitem"in e && i(4, c = e.ondragitem),
                "ondropitem"in e && i(5, u = e.ondropitem)
            }
            ,
            e.$$.update = () => {
                512 & e.$$.dirty && i(6, o = `opacity:${n}`)
            }
            ,
            [r, a, s, l, c, u, o, d, (e, t) => t.mount && t.mount(e.firstChild, t), n, e => s(e.id), (e, t) => l && l(e.id, t), (e, t) => c && c(e.id, t), (e, t) => u && u(e.id, t)]
        }
        class Wu extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Nu, Bu, ar, {
                    items: 0,
                    disabled: 1,
                    onclickitem: 2,
                    ongrabitem: 3,
                    ondragitem: 4,
                    ondropitem: 5
                })
            }
        }
        var Hu = () => _() && window.devicePixelRatio || 1;
        let ju = null;
        var Uu = e => (null === ju && (ju = 1 === Hu() ? Math.round : e => e),
        ju(e))
          , Vu = (e, t={}) => {
            if (e) {
                if (t.preventScroll && si()) {
                    const t = document.body.scrollTop;
                    return e.focus(),
                    void (document.body.scrollTop = t)
                }
                e.focus(t)
            }
        }
          , qu = e => /date|email|number|search|text|url/.test(e.type)
          , Gu = e => /textarea/i.test(e.nodeName) || qu(e) || e.isContentEditable;
        const Ku = e => ({})
          , Xu = e => ({})
          , Zu = e => ({})
          , Yu = e => ({});
        function Qu(e) {
            let t, i;
            const o = [e[7]];
            let n = {
                $$slots: {
                    default: [ed]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new du({
                props: n
            }),
            e[46](t),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 128 & i[0] ? Ia(o, [La(e[7])]) : {};
                    524288 & i[1] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(i) {
                    e[46](null),
                    Oa(t, i)
                }
            }
        }
        function Ju(e) {
            let t, i;
            const o = [e[7]];
            let n = {};
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new du({
                props: n
            }),
            e[45](t),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 128 & i[0] ? Ia(o, [La(e[7])]) : {};
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(i) {
                    e[45](null),
                    Oa(t, i)
                }
            }
        }
        function ed(e) {
            let t;
            const i = e[44].label
              , o = ur(i, e, e[50], Yu);
            return {
                c() {
                    o && o.c()
                },
                m(e, i) {
                    o && o.m(e, i),
                    t = !0
                },
                p(e, n) {
                    o && o.p && (!t || 524288 & n[1]) && hr(o, i, e, e[50], t ? pr(i, e[50], n, Zu) : mr(e[50]), Yu)
                },
                i(e) {
                    t || (ka(o, e),
                    t = !0)
                },
                o(e) {
                    Ca(o, e),
                    t = !1
                },
                d(e) {
                    o && o.d(e)
                }
            }
        }
        function td(e) {
            let t, i, o, n, r, a, s;
            const l = e[44].details
              , c = ur(l, e, e[50], Xu);
            return {
                c() {
                    t = Er("div"),
                    c && c.c(),
                    i = Ir(),
                    o = Er("span"),
                    Or(o, "class", "PinturaPanelTip"),
                    Or(o, "style", e[10]),
                    Or(t, "class", n = Pc(["PinturaPanel", "pintura-editor-panel", e[2]])),
                    Or(t, "tabindex", "-1"),
                    Or(t, "style", e[11])
                },
                m(n, l) {
                    Mr(n, t, l),
                    c && c.m(t, null),
                    kr(t, i),
                    kr(t, o),
                    e[47](t),
                    r = !0,
                    a || (s = [Dr(t, "close", e[48]), Dr(t, "keydown", e[18]), Dr(t, "measure", e[49]), $r($c.call(null, t))],
                    a = !0)
                },
                p(e, i) {
                    c && c.p && (!r || 524288 & i[1]) && hr(c, l, e, e[50], r ? pr(l, e[50], i, Ku) : mr(e[50]), Xu),
                    (!r || 1024 & i[0]) && Or(o, "style", e[10]),
                    (!r || 4 & i[0] && n !== (n = Pc(["PinturaPanel", "pintura-editor-panel", e[2]]))) && Or(t, "class", n),
                    (!r || 2048 & i[0]) && Or(t, "style", e[11])
                },
                i(e) {
                    r || (ka(c, e),
                    r = !0)
                },
                o(e) {
                    Ca(c, e),
                    r = !1
                },
                d(i) {
                    i && Pr(t),
                    c && c.d(i),
                    e[47](null),
                    a = !1,
                    nr(s)
                }
            }
        }
        function id(e) {
            let t, i, o, n, r, a, s, l, c;
            const u = [Ju, Qu]
              , d = [];
            function p(e, t) {
                return e[1] ? 0 : 1
            }
            i = p(e),
            o = d[i] = u[i](e);
            let h = e[6] && td(e);
            return {
                c() {
                    t = Ir(),
                    o.c(),
                    n = Ir(),
                    h && h.c(),
                    r = Ir(),
                    a = Lr()
                },
                m(o, u) {
                    Mr(o, t, u),
                    d[i].m(o, u),
                    Mr(o, n, u),
                    h && h.m(o, u),
                    Mr(o, r, u),
                    Mr(o, a, u),
                    s = !0,
                    l || (c = [Dr(document.body, "pointerdown", (function() {
                        rr(e[9]) && e[9].apply(this, arguments)
                    }
                    )), Dr(document.body, "pointerup", (function() {
                        rr(e[8]) && e[8].apply(this, arguments)
                    }
                    ))],
                    l = !0)
                },
                p(t, a) {
                    let s = i;
                    i = p(e = t),
                    i === s ? d[i].p(e, a) : (Sa(),
                    Ca(d[s], 1, 1, ( () => {
                        d[s] = null
                    }
                    )),
                    _a(),
                    o = d[i],
                    o ? o.p(e, a) : (o = d[i] = u[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(n.parentNode, n)),
                    e[6] ? h ? (h.p(e, a),
                    64 & a[0] && ka(h, 1)) : (h = td(e),
                    h.c(),
                    ka(h, 1),
                    h.m(r.parentNode, r)) : h && (Sa(),
                    Ca(h, 1, 1, ( () => {
                        h = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    s || (ka(o),
                    ka(h),
                    ka(!1),
                    s = !0)
                },
                o(e) {
                    Ca(o),
                    Ca(h),
                    Ca(!1),
                    s = !1
                },
                d(e) {
                    e && Pr(t),
                    d[i].d(e),
                    e && Pr(n),
                    h && h.d(e),
                    e && Pr(r),
                    e && Pr(a),
                    l = !1,
                    nr(c)
                }
            }
        }
        let od = 12;
        function nd(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, b, v, x, w, {$$slots: S={}, $$scope: _} = t, {buttonClass: k} = t, {buttonLabel: C} = t, {buttonLabelClass: T} = t, {buttonHideLabel: M} = t, {buttonIcon: P} = t, {buttonTitle: E} = t, {panelClass: R} = t, {isActive: A=!1} = t, {onshow: I=( ({panel: e}) => Vu(e, {
                preventScroll: !0
            }))} = t, {onhide: L=$} = t;
            const D = oa("isAnimated");
            cr(e, D, (e => i(43, w = e)));
            const z = oa("rootPortal");
            cr(e, z, (e => i(38, g = e)));
            const F = oa("rootRect");
            let O, B, N;
            cr(e, F, (e => i(41, v = e)));
            const W = () => i(26, N = o && o.getBoundingClientRect());
            let H = ke()
              , j = ic(0);
            cr(e, j, (e => i(40, b = e)));
            let U = ke();
            const V = ja({
                x: 0,
                y: 0
            });
            cr(e, V, (e => i(39, y = e)));
            const q = ic(-5, {
                stiffness: .1,
                damping: .35,
                precision: .001
            });
            cr(e, q, (e => i(42, x = e)));
            let G = !0;
            const K = e => nu(e, g) || B.isEventTarget(e);
            let X, Z, Y = !1;
            const Q = e => {
                Gu(e.target) || (A || W(),
                i(31, Z = e),
                i(0, A = !A))
            }
              , J = e => {
                /down/i.test(e.key) && (i(0, A = !0),
                i(31, Z = e))
            }
            ;
            return ea(( () => {
                if (!g)
                    return;
                if (!X)
                    return;
                const e = X;
                pa().then(( () => {
                    e.parentNode && e.remove()
                }
                ))
            }
            )),
            e.$$set = e => {
                "buttonClass"in e && i(19, k = e.buttonClass),
                "buttonLabel"in e && i(1, C = e.buttonLabel),
                "buttonLabelClass"in e && i(20, T = e.buttonLabelClass),
                "buttonHideLabel"in e && i(21, M = e.buttonHideLabel),
                "buttonIcon"in e && i(22, P = e.buttonIcon),
                "buttonTitle"in e && i(23, E = e.buttonTitle),
                "panelClass"in e && i(2, R = e.panelClass),
                "isActive"in e && i(0, A = e.isActive),
                "onshow"in e && i(24, I = e.onshow),
                "onhide"in e && i(25, L = e.onhide),
                "$$scope"in e && i(50, _ = e.$$scope)
            }
            ,
            e.$$.update = () => {
                if (16 & e.$$.dirty[0] && (o = B && B.getElement()),
                1073741825 & e.$$.dirty[0] && i(8, m = A ? e => {
                    Y && (i(30, Y = !1),
                    K(e) || i(0, A = !1))
                }
                : void 0),
                1 & e.$$.dirty[0] | 4096 & e.$$.dirty[1] && j.set(A ? 1 : 0, {
                    hard: !1 === w
                }),
                1 & e.$$.dirty[0] | 4096 & e.$$.dirty[1] && q.set(A ? 0 : -5, {
                    hard: !1 === w
                }),
                2048 & e.$$.dirty[1] && i(34, n = 1 - x / -5),
                1 & e.$$.dirty[0] | 1024 & e.$$.dirty[1] && v && A && W(),
                67108873 & e.$$.dirty[0] | 1024 & e.$$.dirty[1] && v && O && N && A) {
                    i(29, G = !0);
                    let e = N.x - v.x + .5 * N.width - .5 * O.width
                      , t = N.y - v.y + N.height;
                    const o = od
                      , n = od
                      , r = v.width - od
                      , a = v.height - od
                      , s = e
                      , l = t
                      , c = s + O.width
                      , u = l + O.height;
                    s < o && (i(28, U.x = s - o, U),
                    e = o),
                    c > r && (i(28, U.x = c - r, U),
                    e = r - O.width),
                    u > a ? (i(27, H.y = -1, H),
                    n < t - O.height - N.height ? (i(28, U.y = 0, U),
                    t -= O.height + N.height) : (i(28, U.y = t - (u - a), U),
                    t -= u - a - od,
                    i(29, G = !1))) : i(27, H.y = 1, H),
                    yr(V, y = De(Ce(e, t), Uu), y)
                }
                512 & e.$$.dirty[1] && i(6, r = b > 0),
                512 & e.$$.dirty[1] && i(37, a = b < 1),
                134217728 & e.$$.dirty[0] | 2304 & e.$$.dirty[1] && i(36, s = `translateX(${Math.round(y.x) + H.x * od}px) translateY(${Math.round(y.y) + H.y * od + H.y * x}px)`),
                1024 & e.$$.dirty[1] && i(35, l = `--panel-max-height:${v.height - 24}px`),
                624 & e.$$.dirty[1] && i(11, c = a ? `opacity: ${b}; pointer-events: ${b < 1 ? "none" : "all"}; transform: ${s};${l}` : `transform: ${s};${l}`),
                8 & e.$$.dirty[1] && i(32, u = .5 + .5 * n),
                8 & e.$$.dirty[1] && i(33, d = n),
                939524104 & e.$$.dirty[0] | 262 & e.$$.dirty[1] && i(10, p = y && O && `opacity:${G ? d : 0};transform:scaleX(${u})rotate(45deg);top:${H.y < 0 ? U.y + O.height : 0}px;left:${U.x + .5 * O.width}px`),
                1 & e.$$.dirty[0] && i(9, h = A ? e => {
                    K(e) || i(30, Y = !0)
                }
                : void 0),
                96 & e.$$.dirty[0] | 128 & e.$$.dirty[1] && r && g && X && X.parentNode !== g && g.append(X),
                1 & e.$$.dirty[0] && (A || i(31, Z = void 0)),
                16777313 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && A && r && X && I({
                    e: Z,
                    panel: X
                }),
                33554497 & e.$$.dirty[0] && r && !A && L(),
                16252930 & e.$$.dirty[0] && i(7, f = {
                    label: C,
                    icon: P,
                    class: Pc(["PinturaPanelButton", k]),
                    onkeydown: J,
                    onclick: Q,
                    hideLabel: M,
                    labelClass: T,
                    title: E
                })
            }
            ,
            [A, C, R, O, B, X, r, f, m, h, p, c, D, z, F, j, V, q, e => {
                /esc/i.test(e.key) && (i(0, A = !1),
                o.focus())
            }
            , k, T, M, P, E, I, L, N, H, U, G, Y, Z, u, d, n, l, s, a, g, y, b, v, x, w, S, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    B = e,
                    i(4, B)
                }
                ))
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    B = e,
                    i(4, B)
                }
                ))
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    X = e,
                    i(5, X)
                }
                ))
            }
            , e => {
                e.stopPropagation(),
                i(0, A = !1)
            }
            , e => i(3, O = Ze(e.detail)), _]
        }
        class rd extends Na {
            constructor(e) {
                super(),
                Ba(this, e, nd, id, ar, {
                    buttonClass: 19,
                    buttonLabel: 1,
                    buttonLabelClass: 20,
                    buttonHideLabel: 21,
                    buttonIcon: 22,
                    buttonTitle: 23,
                    panelClass: 2,
                    isActive: 0,
                    onshow: 24,
                    onhide: 25
                }, null, [-1, -1])
            }
        }
        var ad = {
            Up: 38,
            Down: 40,
            Left: 37,
            Right: 39
        };
        function sd(e) {
            let t, i, o, n, r, a, s, l;
            const c = e[15].default
              , u = ur(c, e, e[14], null);
            return {
                c() {
                    t = Er("li"),
                    i = Er("input"),
                    o = Ir(),
                    n = Er("label"),
                    u && u.c(),
                    Or(i, "type", "radio"),
                    Or(i, "class", "implicit"),
                    Or(i, "id", e[7]),
                    Or(i, "name", e[0]),
                    i.value = e[3],
                    i.disabled = e[6],
                    i.hidden = e[5],
                    i.checked = e[4],
                    Or(n, "for", e[7]),
                    Or(n, "title", e[2]),
                    Or(t, "class", r = Pc(["PinturaRadioGroupOption", e[1]])),
                    Or(t, "data-hidden", e[5]),
                    Or(t, "data-disabled", e[6]),
                    Or(t, "data-selected", e[4])
                },
                m(r, c) {
                    Mr(r, t, c),
                    kr(t, i),
                    kr(t, o),
                    kr(t, n),
                    u && u.m(n, null),
                    a = !0,
                    s || (l = [Dr(i, "change", Fr(e[16])), Dr(i, "keydown", e[9]), Dr(i, "click", e[10])],
                    s = !0)
                },
                p(e, [o]) {
                    (!a || 128 & o) && Or(i, "id", e[7]),
                    (!a || 1 & o) && Or(i, "name", e[0]),
                    (!a || 8 & o) && (i.value = e[3]),
                    (!a || 64 & o) && (i.disabled = e[6]),
                    (!a || 32 & o) && (i.hidden = e[5]),
                    (!a || 16 & o) && (i.checked = e[4]),
                    u && u.p && (!a || 16384 & o) && hr(u, c, e, e[14], a ? pr(c, e[14], o, null) : mr(e[14]), null),
                    (!a || 128 & o) && Or(n, "for", e[7]),
                    (!a || 4 & o) && Or(n, "title", e[2]),
                    (!a || 2 & o && r !== (r = Pc(["PinturaRadioGroupOption", e[1]]))) && Or(t, "class", r),
                    (!a || 32 & o) && Or(t, "data-hidden", e[5]),
                    (!a || 64 & o) && Or(t, "data-disabled", e[6]),
                    (!a || 16 & o) && Or(t, "data-selected", e[4])
                },
                i(e) {
                    a || (ka(u, e),
                    a = !0)
                },
                o(e) {
                    Ca(u, e),
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    u && u.d(e),
                    s = !1,
                    nr(l)
                }
            }
        }
        function ld(e, t, i) {
            let o, n, {$$slots: r={}, $$scope: a} = t, {name: s} = t, {class: l} = t, {label: c} = t, {id: u} = t, {value: d} = t, {checked: p} = t, {onkeydown: h} = t, {onclick: m} = t, {hidden: f=!1} = t, {disabled: g=!1} = t;
            const y = Object.values(ad)
              , $ = oa("keysPressed");
            return cr(e, $, (e => i(17, n = e))),
            e.$$set = e => {
                "name"in e && i(0, s = e.name),
                "class"in e && i(1, l = e.class),
                "label"in e && i(2, c = e.label),
                "id"in e && i(11, u = e.id),
                "value"in e && i(3, d = e.value),
                "checked"in e && i(4, p = e.checked),
                "onkeydown"in e && i(12, h = e.onkeydown),
                "onclick"in e && i(13, m = e.onclick),
                "hidden"in e && i(5, f = e.hidden),
                "disabled"in e && i(6, g = e.disabled),
                "$$scope"in e && i(14, a = e.$$scope)
            }
            ,
            e.$$.update = () => {
                2049 & e.$$.dirty && i(7, o = `${s}-${u}`)
            }
            ,
            [s, l, c, d, p, f, g, o, $, e => {
                h(e)
            }
            , e => {
                n.some((e => y.includes(e))) || m(e)
            }
            , u, h, m, a, r, function(t) {
                na.call(this, e, t)
            }
            ]
        }
        class cd extends Na {
            constructor(e) {
                super(),
                Ba(this, e, ld, sd, ar, {
                    name: 0,
                    class: 1,
                    label: 2,
                    id: 11,
                    value: 3,
                    checked: 4,
                    onkeydown: 12,
                    onclick: 13,
                    hidden: 5,
                    disabled: 6
                })
            }
        }
        var ud = (e=[]) => e.reduce(( (e, t) => (Ui(t) ? Ui(t[1]) : t.options) ? e.concat(Ui(t) ? t[1] : t.options) : (e.push(t),
        e)), []);
        const dd = (e, t, i) => {
            let o;
            return Ui(e) ? o = {
                id: t,
                value: e[0],
                label: e[1],
                ...e[2] || {}
            } : (o = e,
            o.id = null != o.id ? o.id : t),
            i ? i(o) : o
        }
        ;
        var pd = (e, t, i) => H(e) ? e(t, i) : e;
        const hd = (e, t) => e.map(( ([e,i,o]) => {
            if (Ui(i))
                return [pd(e, t), hd(i, t)];
            {
                const n = [e, pd(i, t)];
                if (o) {
                    let e = {
                        ...o
                    };
                    o.icon && (e.icon = pd(o.icon, t)),
                    n.push(e)
                }
                return n
            }
        }
        ));
        var md = (e, t) => hd(e, t)
          , fd = (e, t) => Array.isArray(e) && Array.isArray(t) ? ms(e, t) : e === t;
        function gd(e, t, i) {
            const o = e.slice();
            return o[27] = t[i],
            o
        }
        const yd = e => ({
            option: 1024 & e[0]
        })
          , $d = e => ({
            option: e[27]
        });
        function bd(e, t, i) {
            const o = e.slice();
            return o[27] = t[i],
            o
        }
        const vd = e => ({
            option: 1024 & e[0]
        })
          , xd = e => ({
            option: e[27]
        })
          , wd = e => ({
            option: 1024 & e[0]
        })
          , Sd = e => ({
            option: e[27]
        });
        function _d(e) {
            let t, i, o, n, r, a = [], s = new Map, l = e[1] && kd(e), c = e[10];
            const u = e => e[27].id;
            for (let t = 0; t < c.length; t += 1) {
                let i = gd(e, c, t)
                  , o = u(i);
                s.set(o, a[t] = Fd(o, i))
            }
            return {
                c() {
                    t = Er("fieldset"),
                    l && l.c(),
                    i = Ir(),
                    o = Er("ul");
                    for (let e = 0; e < a.length; e += 1)
                        a[e].c();
                    Or(o, "class", "PinturaRadioGroupOptions"),
                    Or(t, "class", n = Pc(["PinturaRadioGroup", e[3]])),
                    Or(t, "data-layout", e[5]),
                    Or(t, "title", e[7])
                },
                m(e, n) {
                    Mr(e, t, n),
                    l && l.m(t, null),
                    kr(t, i),
                    kr(t, o);
                    for (let e = 0; e < a.length; e += 1)
                        a[e].m(o, null);
                    r = !0
                },
                p(e, d) {
                    e[1] ? l ? l.p(e, d) : (l = kd(e),
                    l.c(),
                    l.m(t, i)) : l && (l.d(1),
                    l = null),
                    8419153 & d[0] && (c = e[10],
                    Sa(),
                    a = Aa(a, d, u, 1, e, c, s, o, Ra, Fd, null, gd),
                    _a()),
                    (!r || 8 & d[0] && n !== (n = Pc(["PinturaRadioGroup", e[3]]))) && Or(t, "class", n),
                    (!r || 32 & d[0]) && Or(t, "data-layout", e[5]),
                    (!r || 128 & d[0]) && Or(t, "title", e[7])
                },
                i(e) {
                    if (!r) {
                        for (let e = 0; e < c.length; e += 1)
                            ka(a[e]);
                        r = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < a.length; e += 1)
                        Ca(a[e]);
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    l && l.d();
                    for (let e = 0; e < a.length; e += 1)
                        a[e].d()
                }
            }
        }
        function kd(e) {
            let t, i, o;
            return {
                c() {
                    t = Er("legend"),
                    i = Ar(e[1]),
                    Or(t, "class", o = e[2] && "implicit")
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, n) {
                    2 & n[0] && Wr(i, e[1]),
                    4 & n[0] && o !== (o = e[2] && "implicit") && Or(t, "class", o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Cd(e) {
            let t, i;
            return t = new cd({
                props: {
                    name: e[4],
                    label: e[27].label,
                    id: e[27].id,
                    value: e[27].value,
                    disabled: e[27].disabled,
                    hidden: e[27].hidden,
                    class: e[8],
                    checked: e[12](e[27]) === e[0],
                    onkeydown: e[13](e[27]),
                    onclick: e[14](e[27]),
                    $$slots: {
                        default: [Rd]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] && (o.name = e[4]),
                    1024 & i[0] && (o.label = e[27].label),
                    1024 & i[0] && (o.id = e[27].id),
                    1024 & i[0] && (o.value = e[27].value),
                    1024 & i[0] && (o.disabled = e[27].disabled),
                    1024 & i[0] && (o.hidden = e[27].hidden),
                    256 & i[0] && (o.class = e[8]),
                    1025 & i[0] && (o.checked = e[12](e[27]) === e[0]),
                    1024 & i[0] && (o.onkeydown = e[13](e[27])),
                    1024 & i[0] && (o.onclick = e[14](e[27])),
                    8389696 & i[0] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Td(e) {
            let t, i, o, n, r, a, s = [], l = new Map;
            const c = e[22].group
              , u = ur(c, e, e[23], Sd)
              , d = u || function(e) {
                let t, i, o = e[27].label + "";
                return {
                    c() {
                        t = Er("span"),
                        i = Ar(o),
                        Or(t, "class", "PinturaRadioGroupOptionGroupLabel")
                    },
                    m(e, o) {
                        Mr(e, t, o),
                        kr(t, i)
                    },
                    p(e, t) {
                        1024 & t[0] && o !== (o = e[27].label + "") && Wr(i, o)
                    },
                    d(e) {
                        e && Pr(t)
                    }
                }
            }(e);
            let p = e[27].options;
            const h = e => e[27].id;
            for (let t = 0; t < p.length; t += 1) {
                let i = bd(e, p, t)
                  , o = h(i);
                l.set(o, s[t] = zd(o, i))
            }
            return {
                c() {
                    t = Er("li"),
                    d && d.c(),
                    i = Ir(),
                    o = Er("ul");
                    for (let e = 0; e < s.length; e += 1)
                        s[e].c();
                    n = Ir(),
                    Or(o, "class", "PinturaRadioGroupOptions"),
                    Or(t, "class", r = Pc(["PinturaRadioGroupOptionGroup", e[9]]))
                },
                m(e, r) {
                    Mr(e, t, r),
                    d && d.m(t, null),
                    kr(t, i),
                    kr(t, o);
                    for (let e = 0; e < s.length; e += 1)
                        s[e].m(o, null);
                    kr(t, n),
                    a = !0
                },
                p(e, i) {
                    u ? u.p && (!a || 8389632 & i[0]) && hr(u, c, e, e[23], a ? pr(c, e[23], i, wd) : mr(e[23]), Sd) : d && d.p && (!a || 1024 & i[0]) && d.p(e, a ? i : [-1, -1]),
                    8418641 & i[0] && (p = e[27].options,
                    Sa(),
                    s = Aa(s, i, h, 1, e, p, l, o, Ra, zd, null, bd),
                    _a()),
                    (!a || 512 & i[0] && r !== (r = Pc(["PinturaRadioGroupOptionGroup", e[9]]))) && Or(t, "class", r)
                },
                i(e) {
                    if (!a) {
                        ka(d, e);
                        for (let e = 0; e < p.length; e += 1)
                            ka(s[e]);
                        a = !0
                    }
                },
                o(e) {
                    Ca(d, e);
                    for (let e = 0; e < s.length; e += 1)
                        Ca(s[e]);
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    d && d.d(e);
                    for (let e = 0; e < s.length; e += 1)
                        s[e].d()
                }
            }
        }
        function Md(e) {
            let t, i;
            return t = new ou({
                props: {
                    $$slots: {
                        default: [Pd]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8389632 & i[0] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Pd(e) {
            let t, i = e[27].icon + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    1024 & o[0] && i !== (i = e[27].icon + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Ed(e) {
            let t, i, o = e[27].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "class", e[6])
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, n) {
                    1024 & n[0] && o !== (o = e[27].label + "") && Wr(i, o),
                    64 & n[0] && Or(t, "class", e[6])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Rd(e) {
            let t;
            const i = e[22].option
              , o = ur(i, e, e[23], $d)
              , n = o || function(e) {
                let t, i, o, n = e[27].icon && Md(e), r = !e[27].hideLabel && Ed(e);
                return {
                    c() {
                        n && n.c(),
                        t = Ir(),
                        r && r.c(),
                        i = Ir()
                    },
                    m(e, a) {
                        n && n.m(e, a),
                        Mr(e, t, a),
                        r && r.m(e, a),
                        Mr(e, i, a),
                        o = !0
                    },
                    p(e, o) {
                        e[27].icon ? n ? (n.p(e, o),
                        1024 & o[0] && ka(n, 1)) : (n = Md(e),
                        n.c(),
                        ka(n, 1),
                        n.m(t.parentNode, t)) : n && (Sa(),
                        Ca(n, 1, 1, ( () => {
                            n = null
                        }
                        )),
                        _a()),
                        e[27].hideLabel ? r && (r.d(1),
                        r = null) : r ? r.p(e, o) : (r = Ed(e),
                        r.c(),
                        r.m(i.parentNode, i))
                    },
                    i(e) {
                        o || (ka(n),
                        o = !0)
                    },
                    o(e) {
                        Ca(n),
                        o = !1
                    },
                    d(e) {
                        n && n.d(e),
                        e && Pr(t),
                        r && r.d(e),
                        e && Pr(i)
                    }
                }
            }(e);
            return {
                c() {
                    n && n.c()
                },
                m(e, i) {
                    n && n.m(e, i),
                    t = !0
                },
                p(e, r) {
                    o ? o.p && (!t || 8389632 & r[0]) && hr(o, i, e, e[23], t ? pr(i, e[23], r, yd) : mr(e[23]), $d) : n && n.p && (!t || 1088 & r[0]) && n.p(e, t ? r : [-1, -1])
                },
                i(e) {
                    t || (ka(n, e),
                    t = !0)
                },
                o(e) {
                    Ca(n, e),
                    t = !1
                },
                d(e) {
                    n && n.d(e)
                }
            }
        }
        function Ad(e) {
            let t, i;
            return t = new ou({
                props: {
                    $$slots: {
                        default: [Id]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8389632 & i[0] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Id(e) {
            let t, i = e[27].icon + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    1024 & o[0] && i !== (i = e[27].icon + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Ld(e) {
            let t, i, o = e[27].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "class", e[6])
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, n) {
                    1024 & n[0] && o !== (o = e[27].label + "") && Wr(i, o),
                    64 & n[0] && Or(t, "class", e[6])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Dd(e) {
            let t;
            const i = e[22].option
              , o = ur(i, e, e[23], xd)
              , n = o || function(e) {
                let t, i, o, n = e[27].icon && Ad(e), r = !e[27].hideLabel && Ld(e);
                return {
                    c() {
                        n && n.c(),
                        t = Ir(),
                        r && r.c(),
                        i = Ir()
                    },
                    m(e, a) {
                        n && n.m(e, a),
                        Mr(e, t, a),
                        r && r.m(e, a),
                        Mr(e, i, a),
                        o = !0
                    },
                    p(e, o) {
                        e[27].icon ? n ? (n.p(e, o),
                        1024 & o[0] && ka(n, 1)) : (n = Ad(e),
                        n.c(),
                        ka(n, 1),
                        n.m(t.parentNode, t)) : n && (Sa(),
                        Ca(n, 1, 1, ( () => {
                            n = null
                        }
                        )),
                        _a()),
                        e[27].hideLabel ? r && (r.d(1),
                        r = null) : r ? r.p(e, o) : (r = Ld(e),
                        r.c(),
                        r.m(i.parentNode, i))
                    },
                    i(e) {
                        o || (ka(n),
                        o = !0)
                    },
                    o(e) {
                        Ca(n),
                        o = !1
                    },
                    d(e) {
                        n && n.d(e),
                        e && Pr(t),
                        r && r.d(e),
                        e && Pr(i)
                    }
                }
            }(e);
            return {
                c() {
                    n && n.c()
                },
                m(e, i) {
                    n && n.m(e, i),
                    t = !0
                },
                p(e, r) {
                    o ? o.p && (!t || 8389632 & r[0]) && hr(o, i, e, e[23], t ? pr(i, e[23], r, vd) : mr(e[23]), xd) : n && n.p && (!t || 1088 & r[0]) && n.p(e, t ? r : [-1, -1])
                },
                i(e) {
                    t || (ka(n, e),
                    t = !0)
                },
                o(e) {
                    Ca(n, e),
                    t = !1
                },
                d(e) {
                    n && n.d(e)
                }
            }
        }
        function zd(e, t) {
            let i, o, n;
            return o = new cd({
                props: {
                    name: t[4],
                    label: t[27].label,
                    id: t[27].id,
                    value: t[27].value,
                    disabled: t[27].disabled,
                    hidden: t[27].hidden,
                    class: t[8],
                    checked: t[12](t[27]) === t[0],
                    onkeydown: t[13](t[27]),
                    onclick: t[14](t[27]),
                    $$slots: {
                        default: [Dd]
                    },
                    $$scope: {
                        ctx: t
                    }
                }
            }),
            {
                key: e,
                first: null,
                c() {
                    i = Lr(),
                    za(o.$$.fragment),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    Fa(o, e, t),
                    n = !0
                },
                p(e, i) {
                    t = e;
                    const n = {};
                    16 & i[0] && (n.name = t[4]),
                    1024 & i[0] && (n.label = t[27].label),
                    1024 & i[0] && (n.id = t[27].id),
                    1024 & i[0] && (n.value = t[27].value),
                    1024 & i[0] && (n.disabled = t[27].disabled),
                    1024 & i[0] && (n.hidden = t[27].hidden),
                    256 & i[0] && (n.class = t[8]),
                    1025 & i[0] && (n.checked = t[12](t[27]) === t[0]),
                    1024 & i[0] && (n.onkeydown = t[13](t[27])),
                    1024 & i[0] && (n.onclick = t[14](t[27])),
                    8389696 & i[0] && (n.$$scope = {
                        dirty: i,
                        ctx: t
                    }),
                    o.$set(n)
                },
                i(e) {
                    n || (ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(i),
                    Oa(o, e)
                }
            }
        }
        function Fd(e, t) {
            let i, o, n, r, a;
            const s = [Td, Cd]
              , l = [];
            function c(e, t) {
                return e[27].options ? 0 : 1
            }
            return o = c(t),
            n = l[o] = s[o](t),
            {
                key: e,
                first: null,
                c() {
                    i = Lr(),
                    n.c(),
                    r = Lr(),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    l[o].m(e, t),
                    Mr(e, r, t),
                    a = !0
                },
                p(e, i) {
                    let a = o;
                    o = c(t = e),
                    o === a ? l[o].p(t, i) : (Sa(),
                    Ca(l[a], 1, 1, ( () => {
                        l[a] = null
                    }
                    )),
                    _a(),
                    n = l[o],
                    n ? n.p(t, i) : (n = l[o] = s[o](t),
                    n.c()),
                    ka(n, 1),
                    n.m(r.parentNode, r))
                },
                i(e) {
                    a || (ka(n),
                    a = !0)
                },
                o(e) {
                    Ca(n),
                    a = !1
                },
                d(e) {
                    e && Pr(i),
                    l[o].d(e),
                    e && Pr(r)
                }
            }
        }
        function Od(e) {
            let t, i, o, n = e[11].length && _d(e);
            return {
                c() {
                    n && n.c(),
                    t = Ir(),
                    i = Lr()
                },
                m(e, r) {
                    n && n.m(e, r),
                    Mr(e, t, r),
                    Mr(e, i, r),
                    o = !0
                },
                p(e, i) {
                    e[11].length ? n ? (n.p(e, i),
                    2048 & i[0] && ka(n, 1)) : (n = _d(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    o || (ka(n),
                    ka(!1),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(!1),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    e && Pr(i)
                }
            }
        }
        function Bd(e, t, i) {
            let o, n, r, {$$slots: a={}, $$scope: s} = t;
            const l = ta();
            let {label: c} = t
              , {hideLabel: u=!0} = t
              , {class: d} = t
              , {name: p=`radio-group-${V()}`} = t
              , {selectedIndex: h=-1} = t
              , {options: m=[]} = t
              , {onchange: f} = t
              , {layout: g} = t
              , {optionMapper: y} = t
              , {optionFilter: $} = t
              , {value: b} = t
              , {optionLabelClass: v} = t
              , {title: x} = t
              , {locale: w} = t
              , {optionClass: S} = t
              , {optionGroupClass: _} = t;
            const k = e => r.findIndex((t => t.id === e.id))
              , C = (e, t) => {
                i(0, h = k(e));
                const o = {
                    index: h,
                    ...e
                };
                ( (e, ...t) => {
                    e && e(...t)
                }
                )(f, o, t),
                l("change", o)
            }
            ;
            return e.$$set = e => {
                "label"in e && i(1, c = e.label),
                "hideLabel"in e && i(2, u = e.hideLabel),
                "class"in e && i(3, d = e.class),
                "name"in e && i(4, p = e.name),
                "selectedIndex"in e && i(0, h = e.selectedIndex),
                "options"in e && i(15, m = e.options),
                "onchange"in e && i(16, f = e.onchange),
                "layout"in e && i(5, g = e.layout),
                "optionMapper"in e && i(17, y = e.optionMapper),
                "optionFilter"in e && i(18, $ = e.optionFilter),
                "value"in e && i(19, b = e.value),
                "optionLabelClass"in e && i(6, v = e.optionLabelClass),
                "title"in e && i(7, x = e.title),
                "locale"in e && i(20, w = e.locale),
                "optionClass"in e && i(8, S = e.optionClass),
                "optionGroupClass"in e && i(9, _ = e.optionGroupClass),
                "$$scope"in e && i(23, s = e.$$scope)
            }
            ,
            e.$$.update = () => {
                1343488 & e.$$.dirty[0] && i(11, o = md($ ? m.filter($) : m, w)),
                133120 & e.$$.dirty[0] && i(10, n = ( (e=[], t) => {
                    let i = 0;
                    return e.map((e => (i++,
                    Ui(e) ? Ui(e[1]) ? {
                        id: i,
                        label: e[0],
                        options: e[1].map((e => dd(e, ++i, t)))
                    } : dd(e, i, t) : e.options ? {
                        id: e.id || i,
                        label: e.label,
                        options: e.options.map((e => dd(e, ++i, t)))
                    } : dd(e, i, t))))
                }
                )(o, y)),
                1024 & e.$$.dirty[0] && i(21, r = ud(n)),
                2654209 & e.$$.dirty[0] && h < 0 && (i(0, h = r.findIndex((e => fd(e.value, b)))),
                h < 0 && i(0, h = (e => e.findIndex((e => void 0 === e[0])))(m)))
            }
            ,
            [h, c, u, d, p, g, v, x, S, _, n, o, k, e => t => {
                var i;
                i = t.key,
                /enter| /i.test(i) && C(e, t)
            }
            , e => t => {
                C(e, t)
            }
            , m, f, y, $, b, w, r, a, s]
        }
        class Nd extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Bd, Od, ar, {
                    label: 1,
                    hideLabel: 2,
                    class: 3,
                    name: 4,
                    selectedIndex: 0,
                    options: 15,
                    onchange: 16,
                    layout: 5,
                    optionMapper: 17,
                    optionFilter: 18,
                    value: 19,
                    optionLabelClass: 6,
                    title: 7,
                    locale: 20,
                    optionClass: 8,
                    optionGroupClass: 9
                }, null, [-1, -1])
            }
        }
        function Wd(e) {
            let t, i, o, n, r, a, s, l, c, u;
            return {
                c() {
                    t = Er("div"),
                    i = Er("button"),
                    o = Ar("▲"),
                    r = Ir(),
                    a = Er("button"),
                    s = Ar("▼"),
                    Or(i, "type", "button"),
                    Or(i, "tabindex", "-1"),
                    Or(i, "aria-label", n = `increase ${e[7]}`),
                    Or(a, "type", "button"),
                    Or(a, "tabindex", "-1"),
                    Or(a, "aria-label", l = `decrease ${e[7]}`),
                    Or(t, "class", "PinturaInputSpinners")
                },
                m(n, l) {
                    Mr(n, t, l),
                    kr(t, i),
                    kr(i, o),
                    kr(t, r),
                    kr(t, a),
                    kr(a, s),
                    c || (u = [Dr(i, "click", e[17]), Dr(a, "click", e[18])],
                    c = !0)
                },
                p(e, t) {
                    128 & t && n !== (n = `increase ${e[7]}`) && Or(i, "aria-label", n),
                    128 & t && l !== (l = `decrease ${e[7]}`) && Or(a, "aria-label", l)
                },
                d(e) {
                    e && Pr(t),
                    c = !1,
                    nr(u)
                }
            }
        }
        function Hd(e) {
            let t, i, o, n, r, a, s = "number" === e[1] && e[9] && Wd(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("input"),
                    n = Ir(),
                    s && s.c(),
                    Or(i, "class", "PinturaInputField"),
                    Or(i, "title", e[7]),
                    Or(i, "type", e[1]),
                    Or(i, "min", e[4]),
                    Or(i, "max", e[5]),
                    Or(i, "step", e[6]),
                    Or(i, "inputmode", e[3]),
                    i.value = o = e[14] ? e[13] : e[0],
                    Or(i, "style", e[11]),
                    Or(i, "placeholder", e[8]),
                    Or(i, "maxlength", e[12]),
                    i.disabled = e[2],
                    Or(i, "spellcheck", "false"),
                    Or(i, "autocorrect", "off"),
                    Or(i, "autocapitalize", "off"),
                    Or(t, "class", "PinturaInput")
                },
                m(o, l) {
                    Mr(o, t, l),
                    kr(t, i),
                    e[27](i),
                    kr(t, n),
                    s && s.m(t, null),
                    r || (a = [Dr(i, "input", e[16]), Dr(i, "blur", (function() {
                        rr(e[14] && e[15]) && (e[14] && e[15]).apply(this, arguments)
                    }
                    )), Dr(i, "keydown", e[19]), Dr(i, "keyup", e[20])],
                    r = !0)
                },
                p(n, [r]) {
                    e = n,
                    128 & r && Or(i, "title", e[7]),
                    2 & r && Or(i, "type", e[1]),
                    16 & r && Or(i, "min", e[4]),
                    32 & r && Or(i, "max", e[5]),
                    64 & r && Or(i, "step", e[6]),
                    8 & r && Or(i, "inputmode", e[3]),
                    24577 & r && o !== (o = e[14] ? e[13] : e[0]) && i.value !== o && (i.value = o),
                    2048 & r && Or(i, "style", e[11]),
                    256 & r && Or(i, "placeholder", e[8]),
                    4096 & r && Or(i, "maxlength", e[12]),
                    4 & r && (i.disabled = e[2]),
                    "number" === e[1] && e[9] ? s ? s.p(e, r) : (s = Wd(e),
                    s.c(),
                    s.m(t, null)) : s && (s.d(1),
                    s = null)
                },
                i: Jn,
                o: Jn,
                d(i) {
                    i && Pr(t),
                    e[27](null),
                    s && s.d(),
                    r = !1,
                    nr(a)
                }
            }
        }
        function jd(e, t, i) {
            let o, n, r, a, s, l, c, {value: u} = t, {type: d="text"} = t, {disabled: p=!1} = t, {inputmode: h} = t, {min: m} = t, {max: f} = t, {step: g} = t, {onchange: y=$} = t, {onkeydown: b=$} = t, {title: v} = t, {stepMultiplier: x=10} = t, {placeholder: w} = t, {enableSpinButtons: S=!0} = t, {enableStopPropagation: _=!1} = t;
            const k = () => {
                let e = l.value;
                return "number" === d && (e = "numeric" === h ? parseInt(e, 10) : parseFloat(e),
                !Wi(e) || Number.isNaN(e) ? e = m || 0 : o && (e = cs(e, m, f))),
                e
            }
            ;
            let C = u;
            const T = () => {
                const e = cs(k() + (c ? g * x : g), m, f);
                e !== u && (i(25, C = e),
                i(0, u = e),
                y(u))
            }
              , M = () => {
                const e = cs(k() - (c ? g * x : g), m, f);
                e !== u && (i(25, C = e),
                i(0, u = e),
                y(u))
            }
            ;
            return e.$$set = e => {
                "value"in e && i(0, u = e.value),
                "type"in e && i(1, d = e.type),
                "disabled"in e && i(2, p = e.disabled),
                "inputmode"in e && i(3, h = e.inputmode),
                "min"in e && i(4, m = e.min),
                "max"in e && i(5, f = e.max),
                "step"in e && i(6, g = e.step),
                "onchange"in e && i(21, y = e.onchange),
                "onkeydown"in e && i(22, b = e.onkeydown),
                "title"in e && i(7, v = e.title),
                "stepMultiplier"in e && i(23, x = e.stepMultiplier),
                "placeholder"in e && i(8, w = e.placeholder),
                "enableSpinButtons"in e && i(9, S = e.enableSpinButtons),
                "enableStopPropagation"in e && i(24, _ = e.enableStopPropagation)
            }
            ,
            e.$$.update = () => {
                48 & e.$$.dirty && i(14, o = Wi(m) && Wi(f)),
                33555457 & e.$$.dirty && i(13, n = l === document.activeElement ? C : u),
                32 & e.$$.dirty && i(26, r = f ? (f + "").length : void 0),
                67108872 & e.$$.dirty && i(12, a = "numeric" === h && r ? r : void 0),
                67108864 & e.$$.dirty && i(11, s = r ? `min-width:${r}em` : void 0)
            }
            ,
            [u, d, p, h, m, f, g, v, w, S, l, s, a, n, o, () => {
                i(25, C = k()),
                y(u)
            }
            , () => {
                i(25, C = l.value),
                y(k())
            }
            , T, M, e => {
                c = e.shiftKey,
                b(e);
                const {key: t} = e;
                _ && e.stopPropagation(),
                /up|down/i.test(t) && (/up/i.test(t) && T(),
                /down/i.test(t) && M(),
                e.preventDefault(),
                e.stopPropagation())
            }
            , e => {
                const {key: t} = e;
                /up|down/i.test(t) && (e.preventDefault(),
                e.stopPropagation())
            }
            , y, b, x, _, C, r, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    l = e,
                    i(10, l)
                }
                ))
            }
            ]
        }
        class Ud extends Na {
            constructor(e) {
                super(),
                Ba(this, e, jd, Hd, ar, {
                    value: 0,
                    type: 1,
                    disabled: 2,
                    inputmode: 3,
                    min: 4,
                    max: 5,
                    step: 6,
                    onchange: 21,
                    onkeydown: 22,
                    title: 7,
                    stepMultiplier: 23,
                    placeholder: 8,
                    enableSpinButtons: 9,
                    enableStopPropagation: 24
                })
            }
        }
        const Vd = e => ({})
          , qd = e => ({});
        function Gd(e) {
            let t, i, o, n, r = (e[2] || e[21]) + "", a = e[6] && Xd(e);
            return {
                c() {
                    a && a.c(),
                    t = Ir(),
                    i = Er("span"),
                    Or(i, "class", o = Pc(["PinturaButtonLabel", e[3], e[5] && "implicit"]))
                },
                m(e, o) {
                    a && a.m(e, o),
                    Mr(e, t, o),
                    Mr(e, i, o),
                    i.innerHTML = r,
                    n = !0
                },
                p(e, s) {
                    e[6] ? a ? (a.p(e, s),
                    64 & s[0] && ka(a, 1)) : (a = Xd(e),
                    a.c(),
                    ka(a, 1),
                    a.m(t.parentNode, t)) : a && (Sa(),
                    Ca(a, 1, 1, ( () => {
                        a = null
                    }
                    )),
                    _a()),
                    (!n || 2097156 & s[0]) && r !== (r = (e[2] || e[21]) + "") && (i.innerHTML = r),
                    (!n || 40 & s[0] && o !== (o = Pc(["PinturaButtonLabel", e[3], e[5] && "implicit"]))) && Or(i, "class", o)
                },
                i(e) {
                    n || (ka(a),
                    n = !0)
                },
                o(e) {
                    Ca(a),
                    n = !1
                },
                d(e) {
                    a && a.d(e),
                    e && Pr(t),
                    e && Pr(i)
                }
            }
        }
        function Kd(e) {
            let t, i;
            return t = new Ud({
                props: {
                    value: e[10],
                    onchange: e[17],
                    enableStopPropagation: !0,
                    type: "number",
                    inputmode: "numeric",
                    min: e[8].reduce(ap, 1 / 0),
                    max: e[8].reduce(sp, -1 / 0),
                    enableSpinButtons: !1
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1024 & i[0] && (o.value = e[10]),
                    131072 & i[0] && (o.onchange = e[17]),
                    256 & i[0] && (o.min = e[8].reduce(ap, 1 / 0)),
                    256 & i[0] && (o.max = e[8].reduce(sp, -1 / 0)),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Xd(e) {
            let t, i;
            return t = new ou({
                props: {
                    class: "PinturaButtonIcon",
                    $$slots: {
                        default: [Zd]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    536870976 & i[0] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Zd(e) {
            let t;
            return {
                c() {
                    t = Rr("g")
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[6]
                },
                p(e, i) {
                    64 & i[0] && (t.innerHTML = e[6])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Yd(e) {
            let t, i, o, n, r, a;
            const s = [Kd, Gd]
              , l = [];
            function c(e, t) {
                return e[18] ? 0 : 1
            }
            return i = c(e),
            o = l[i] = s[i](e),
            {
                c() {
                    t = Er("span"),
                    o.c(),
                    Or(t, "slot", "label"),
                    Or(t, "title", n = pd(e[1], e[16])),
                    Or(t, "class", r = Pc(["PinturaButtonInner", e[18] && "PinturaComboBox", e[4]]))
                },
                m(e, o) {
                    Mr(e, t, o),
                    l[i].m(t, null),
                    a = !0
                },
                p(e, u) {
                    let d = i;
                    i = c(e),
                    i === d ? l[i].p(e, u) : (Sa(),
                    Ca(l[d], 1, 1, ( () => {
                        l[d] = null
                    }
                    )),
                    _a(),
                    o = l[i],
                    o ? o.p(e, u) : (o = l[i] = s[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(t, null)),
                    (!a || 65538 & u[0] && n !== (n = pd(e[1], e[16]))) && Or(t, "title", n),
                    (!a || 262160 & u[0] && r !== (r = Pc(["PinturaButtonInner", e[18] && "PinturaComboBox", e[4]]))) && Or(t, "class", r)
                },
                i(e) {
                    a || (ka(o),
                    a = !0)
                },
                o(e) {
                    Ca(o),
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    l[i].d()
                }
            }
        }
        function Qd(e) {
            let t, i, o = e[31].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "slot", "group")
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    1 & t[1] && o !== (o = e[31].label + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Jd(e) {
            let t, i;
            return t = new ou({
                props: {
                    style: H(e[14]) ? e[14](e[31].value) : e[14],
                    $$slots: {
                        default: [ep]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16384 & i[0] | 1 & i[1] && (o.style = H(e[14]) ? e[14](e[31].value) : e[14]),
                    536870912 & i[0] | 1 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function ep(e) {
            let t, i = e[31].icon + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    1 & o[1] && i !== (i = e[31].icon + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function tp(e) {
            let t, i, o, n, r, a = e[31].label + "", s = e[31].sublabel && ip(e);
            return {
                c() {
                    t = Er("span"),
                    i = new Ur(!1),
                    o = Ir(),
                    s && s.c(),
                    i.a = o,
                    Or(t, "style", n = H(e[15]) ? e[15](e[31].value) : e[15]),
                    Or(t, "class", r = Pc(["PinturaDropdownOptionLabel", e[11]]))
                },
                m(e, n) {
                    Mr(e, t, n),
                    i.m(a, t),
                    kr(t, o),
                    s && s.m(t, null)
                },
                p(e, o) {
                    1 & o[1] && a !== (a = e[31].label + "") && i.p(a),
                    e[31].sublabel ? s ? s.p(e, o) : (s = ip(e),
                    s.c(),
                    s.m(t, null)) : s && (s.d(1),
                    s = null),
                    32768 & o[0] | 1 & o[1] && n !== (n = H(e[15]) ? e[15](e[31].value) : e[15]) && Or(t, "style", n),
                    2048 & o[0] && r !== (r = Pc(["PinturaDropdownOptionLabel", e[11]])) && Or(t, "class", r)
                },
                d(e) {
                    e && Pr(t),
                    s && s.d()
                }
            }
        }
        function ip(e) {
            let t, i = e[31].sublabel + "";
            return {
                c() {
                    t = Er("span"),
                    Or(t, "class", "PinturaDropdownOptionSublabel")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    1 & o[1] && i !== (i = e[31].sublabel + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function op(e) {
            let t, i, o, n = e[31].icon && Jd(e), r = !e[31].hideLabel && tp(e);
            return {
                c() {
                    t = Er("span"),
                    n && n.c(),
                    i = Ir(),
                    r && r.c(),
                    Or(t, "slot", "option")
                },
                m(e, a) {
                    Mr(e, t, a),
                    n && n.m(t, null),
                    kr(t, i),
                    r && r.m(t, null),
                    o = !0
                },
                p(e, o) {
                    e[31].icon ? n ? (n.p(e, o),
                    1 & o[1] && ka(n, 1)) : (n = Jd(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t, i)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[31].hideLabel ? r && (r.d(1),
                    r = null) : r ? r.p(e, o) : (r = tp(e),
                    r.c(),
                    r.m(t, null))
                },
                i(e) {
                    o || (ka(n),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    n && n.d(),
                    r && r.d()
                }
            }
        }
        function np(e) {
            let t, i, o, n, r, a;
            const s = e[27].controls
              , l = ur(s, e, e[29], qd);
            return o = new Nd({
                props: {
                    class: "PinturaOptionsList PinturaScrollableContent",
                    name: e[7],
                    value: e[10],
                    selectedIndex: e[9],
                    optionFilter: e[12],
                    optionMapper: e[13],
                    optionLabelClass: Pc(["PinturaDropdownOptionLabel", e[11]]),
                    optionGroupClass: "PinturaListOptionGroup",
                    optionClass: "PinturaListOption",
                    options: e[19],
                    onchange: e[22],
                    $$slots: {
                        option: [op, ({option: e}) => ({
                            31: e
                        }), ({option: e}) => [0, e ? 1 : 0]],
                        group: [Qd, ({option: e}) => ({
                            31: e
                        }), ({option: e}) => [0, e ? 1 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    l && l.c(),
                    i = Ir(),
                    za(o.$$.fragment),
                    Or(t, "slot", "details"),
                    Or(t, "class", "PinturaOptionsListWrapper")
                },
                m(s, c) {
                    Mr(s, t, c),
                    l && l.m(t, null),
                    kr(t, i),
                    Fa(o, t, null),
                    n = !0,
                    r || (a = Dr(t, "keydown", e[24]),
                    r = !0)
                },
                p(e, t) {
                    l && l.p && (!n || 536870912 & t[0]) && hr(l, s, e, e[29], n ? pr(s, e[29], t, Vd) : mr(e[29]), qd);
                    const i = {};
                    128 & t[0] && (i.name = e[7]),
                    1024 & t[0] && (i.value = e[10]),
                    512 & t[0] && (i.selectedIndex = e[9]),
                    4096 & t[0] && (i.optionFilter = e[12]),
                    8192 & t[0] && (i.optionMapper = e[13]),
                    2048 & t[0] && (i.optionLabelClass = Pc(["PinturaDropdownOptionLabel", e[11]])),
                    524288 & t[0] && (i.options = e[19]),
                    536922112 & t[0] | 1 & t[1] && (i.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    o.$set(i)
                },
                i(e) {
                    n || (ka(l, e),
                    ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(l, e),
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    l && l.d(e),
                    Oa(o),
                    r = !1,
                    a()
                }
            }
        }
        function rp(e) {
            let t, i, o;
            function n(t) {
                e[28](t)
            }
            let r = {
                onshow: e[23],
                buttonClass: Pc(["PinturaDropdownButton", e[0], e[5] && "PinturaDropdownIconOnly"]),
                $$slots: {
                    details: [np],
                    label: [Yd]
                },
                $$scope: {
                    ctx: e
                }
            };
            return void 0 !== e[20] && (r.isActive = e[20]),
            t = new rd({
                props: r
            }),
            aa.push(( () => Da(t, "isActive", n))),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(e, o) {
                    const n = {};
                    33 & o[0] && (n.buttonClass = Pc(["PinturaDropdownButton", e[0], e[5] && "PinturaDropdownIconOnly"])),
                    540016638 & o[0] && (n.$$scope = {
                        dirty: o,
                        ctx: e
                    }),
                    !i && 1048576 & o[0] && (i = !0,
                    n.isActive = e[20],
                    ma(( () => i = !1))),
                    t.$set(n)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        const ap = (e, [t]) => t < e ? t : e
          , sp = (e, [t]) => t > e ? t : e;
        function lp(e, t, i) {
            let o, n, r, {$$slots: a={}, $$scope: s} = t, {class: l} = t, {title: c} = t, {label: u} = t, {labelClass: d} = t, {innerClass: p} = t, {hideLabel: h=!1} = t, {icon: m} = t, {name: f} = t, {options: g=[]} = t, {selectedIndex: y=-1} = t, {value: b} = t, {optionLabelClass: v} = t, {optionFilter: x} = t, {optionMapper: w} = t, {optionIconStyle: S} = t, {optionLabelStyle: _} = t, {locale: k} = t, {onchange: C=$} = t, {onload: T=$} = t, {ondestroy: M=$} = t, {enableInput: P=!1} = t;
            return Qr(( () => T({
                options: g
            }))),
            ea(( () => M({
                options: g
            }))),
            e.$$set = e => {
                "class"in e && i(0, l = e.class),
                "title"in e && i(1, c = e.title),
                "label"in e && i(2, u = e.label),
                "labelClass"in e && i(3, d = e.labelClass),
                "innerClass"in e && i(4, p = e.innerClass),
                "hideLabel"in e && i(5, h = e.hideLabel),
                "icon"in e && i(6, m = e.icon),
                "name"in e && i(7, f = e.name),
                "options"in e && i(8, g = e.options),
                "selectedIndex"in e && i(9, y = e.selectedIndex),
                "value"in e && i(10, b = e.value),
                "optionLabelClass"in e && i(11, v = e.optionLabelClass),
                "optionFilter"in e && i(12, x = e.optionFilter),
                "optionMapper"in e && i(13, w = e.optionMapper),
                "optionIconStyle"in e && i(14, S = e.optionIconStyle),
                "optionLabelStyle"in e && i(15, _ = e.optionLabelStyle),
                "locale"in e && i(16, k = e.locale),
                "onchange"in e && i(17, C = e.onchange),
                "onload"in e && i(25, T = e.onload),
                "ondestroy"in e && i(26, M = e.ondestroy),
                "enableInput"in e && i(18, P = e.enableInput),
                "$$scope"in e && i(29, s = e.$$scope)
            }
            ,
            e.$$.update = () => {
                65792 & e.$$.dirty[0] && i(19, o = k ? md(g, k) : g),
                525312 & e.$$.dirty[0] && i(21, n = o.reduce(( (e, t) => {
                    if (e)
                        return e;
                    const i = Array.isArray(t) ? t : [t, t]
                      , [o,n] = i;
                    return fd(o, b) ? n : void 0
                }
                ), void 0) || (e => {
                    const t = e.find((e => void 0 === e[0]));
                    if (t)
                        return t[1]
                }
                )(o) || b)
            }
            ,
            [l, c, u, d, p, h, m, f, g, y, b, v, x, w, S, _, k, C, P, o, r, n, e => {
                i(21, n = e.value),
                C(e),
                i(20, r = !1)
            }
            , ({e, panel: t}) => {
                if (e && e.key && /up|down/i.test(e.key))
                    return Vu(t.querySelector("input:not([disabled])"));
                Vu(t.querySelector("fieldset"))
            }
            , e => {
                /tab/i.test(e.key) && e.preventDefault()
            }
            , T, M, a, function(e) {
                r = e,
                i(20, r)
            }
            , s]
        }
        class cp extends Na {
            constructor(e) {
                super(),
                Ba(this, e, lp, rp, ar, {
                    class: 0,
                    title: 1,
                    label: 2,
                    labelClass: 3,
                    innerClass: 4,
                    hideLabel: 5,
                    icon: 6,
                    name: 7,
                    options: 8,
                    selectedIndex: 9,
                    value: 10,
                    optionLabelClass: 11,
                    optionFilter: 12,
                    optionMapper: 13,
                    optionIconStyle: 14,
                    optionLabelStyle: 15,
                    locale: 16,
                    onchange: 17,
                    onload: 25,
                    ondestroy: 26,
                    enableInput: 18
                }, null, [-1, -1])
            }
        }
        function up(e) {
            let t;
            return {
                c() {
                    t = Er("div"),
                    Or(t, "slot", "details")
                },
                m(i, o) {
                    Mr(i, t, o),
                    e[14](t)
                },
                p: Jn,
                d(i) {
                    i && Pr(t),
                    e[14](null)
                }
            }
        }
        function dp(e) {
            let t, i, o;
            function n(t) {
                e[15](t)
            }
            let r = {
                buttonLabel: e[0],
                buttonClass: e[1],
                buttonIcon: e[2],
                buttonHideLabel: e[3],
                buttonTitle: e[4],
                buttonLabelClass: e[5],
                onshow: e[6],
                onhide: e[7],
                $$slots: {
                    details: [up]
                },
                $$scope: {
                    ctx: e
                }
            };
            return void 0 !== e[9] && (r.isActive = e[9]),
            t = new rd({
                props: r
            }),
            aa.push(( () => Da(t, "isActive", n))),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(e, [o]) {
                    const n = {};
                    1 & o && (n.buttonLabel = e[0]),
                    2 & o && (n.buttonClass = e[1]),
                    4 & o && (n.buttonIcon = e[2]),
                    8 & o && (n.buttonHideLabel = e[3]),
                    16 & o && (n.buttonTitle = e[4]),
                    32 & o && (n.buttonLabelClass = e[5]),
                    64 & o && (n.onshow = e[6]),
                    128 & o && (n.onhide = e[7]),
                    65792 & o && (n.$$scope = {
                        dirty: o,
                        ctx: e
                    }),
                    !i && 512 & o && (i = !0,
                    n.isActive = e[9],
                    ma(( () => i = !1))),
                    t.$set(n)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function pp(e, t, i) {
            let o, {buttonLabel: n} = t, {buttonClass: r} = t, {buttonIcon: a} = t, {buttonHideLabel: s} = t, {buttonTitle: l} = t, {buttonLabelClass: c} = t, {root: u} = t, {ondestroy: d=$} = t, {onshow: p=$} = t, {onhide: h=$} = t, m = !1;
            return ea(d),
            e.$$set = e => {
                "buttonLabel"in e && i(0, n = e.buttonLabel),
                "buttonClass"in e && i(1, r = e.buttonClass),
                "buttonIcon"in e && i(2, a = e.buttonIcon),
                "buttonHideLabel"in e && i(3, s = e.buttonHideLabel),
                "buttonTitle"in e && i(4, l = e.buttonTitle),
                "buttonLabelClass"in e && i(5, c = e.buttonLabelClass),
                "root"in e && i(10, u = e.root),
                "ondestroy"in e && i(11, d = e.ondestroy),
                "onshow"in e && i(6, p = e.onshow),
                "onhide"in e && i(7, h = e.onhide)
            }
            ,
            e.$$.update = () => {
                1280 & e.$$.dirty && o && u && o.firstChild !== u && (o.hasChildNodes() ? o.replaceChild(u, o.firstChild) : o.append(u))
            }
            ,
            [n, r, a, s, l, c, p, h, o, m, u, d, () => i(9, m = !1), () => i(9, m = !0), function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    o = e,
                    i(8, o)
                }
                ))
            }
            , function(e) {
                m = e,
                i(9, m)
            }
            ]
        }
        class hp extends Na {
            constructor(e) {
                super(),
                Ba(this, e, pp, dp, ar, {
                    buttonLabel: 0,
                    buttonClass: 1,
                    buttonIcon: 2,
                    buttonHideLabel: 3,
                    buttonTitle: 4,
                    buttonLabelClass: 5,
                    root: 10,
                    ondestroy: 11,
                    onshow: 6,
                    onhide: 7,
                    hide: 12,
                    show: 13
                })
            }
            get hide() {
                return this.$$.ctx[12]
            }
            get show() {
                return this.$$.ctx[13]
            }
        }
        var mp = (e, t, i) => (e - t) / (i - t);
        const fp = e => ({})
          , gp = e => ({});
        function yp(e) {
            let t, i, o, n, r, a, s, l;
            return i = new ou({
                props: {
                    $$slots: {
                        default: [$p]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            r = new ou({
                props: {
                    $$slots: {
                        default: [bp]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("button"),
                    za(i.$$.fragment),
                    o = Ir(),
                    n = Er("button"),
                    za(r.$$.fragment),
                    Or(t, "type", "button"),
                    Or(t, "aria-label", "Increase"),
                    Or(n, "type", "button"),
                    Or(n, "aria-label", "Decrease")
                },
                m(c, u) {
                    Mr(c, t, u),
                    Fa(i, t, null),
                    Mr(c, o, u),
                    Mr(c, n, u),
                    Fa(r, n, null),
                    a = !0,
                    s || (l = [Dr(t, "pointerdown", e[20](1)), Dr(n, "pointerdown", e[20](-1))],
                    s = !0)
                },
                p(e, t) {
                    const o = {};
                    128 & t[1] && (o.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    i.$set(o);
                    const n = {};
                    128 & t[1] && (n.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    r.$set(n)
                },
                i(e) {
                    a || (ka(i.$$.fragment, e),
                    ka(r.$$.fragment, e),
                    a = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    Ca(r.$$.fragment, e),
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    e && Pr(o),
                    e && Pr(n),
                    Oa(r),
                    s = !1,
                    nr(l)
                }
            }
        }
        function $p(e) {
            let t;
            return {
                c() {
                    t = Rr("path"),
                    Or(t, "d", "M8 12 h8 M12 8 v8")
                },
                m(e, i) {
                    Mr(e, t, i)
                },
                p: Jn,
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function bp(e) {
            let t;
            return {
                c() {
                    t = Rr("path"),
                    Or(t, "d", "M9 12 h6")
                },
                m(e, i) {
                    Mr(e, t, i)
                },
                p: Jn,
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function vp(e) {
            let t, i, o, n, r, a, s, l, c, u, d, p, h, m, f, g, y;
            const $ = e[36].default
              , b = ur($, e, e[38], null)
              , v = e[36].knob
              , x = ur(v, e, e[38], gp);
            let w = e[9] && yp(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    o = Er("input"),
                    r = Ir(),
                    a = Er("div"),
                    b && b.c(),
                    l = Ir(),
                    c = Er("div"),
                    u = Er("div"),
                    x && x.c(),
                    h = Ir(),
                    w && w.c(),
                    Or(o, "type", "range"),
                    Or(o, "id", e[3]),
                    Or(o, "min", e[0]),
                    Or(o, "max", e[1]),
                    Or(o, "step", e[2]),
                    o.value = e[14],
                    Or(o, "style", n = e[10] ? "pointer-events:none" : ""),
                    Or(a, "class", s = Pc(["PinturaSliderTrack", e[5]])),
                    Or(a, "style", e[4]),
                    Or(u, "class", d = Pc(["PinturaSliderKnob", e[7]])),
                    Or(u, "style", e[6]),
                    Or(c, "class", "PinturaSliderKnobController"),
                    Or(c, "style", e[17]),
                    Or(i, "class", "PinturaSliderControl"),
                    Or(i, "style", p = `--slider-position:${Math.round(e[15])}`),
                    Or(t, "class", m = Pc(["PinturaSlider", e[12]])),
                    Or(t, "data-direction", e[8])
                },
                m(n, s) {
                    Mr(n, t, s),
                    kr(t, i),
                    kr(i, o),
                    e[37](o),
                    kr(i, r),
                    kr(i, a),
                    b && b.m(a, null),
                    kr(i, l),
                    kr(i, c),
                    kr(c, u),
                    x && x.m(u, null),
                    kr(t, h),
                    w && w.m(t, null),
                    f = !0,
                    g || (y = [Dr(o, "input", e[18]), Dr(o, "nudge", e[19]), $r(fu.call(null, o)), Dr(i, "pointerdown", (function() {
                        rr(e[11] && e[13]) && (e[11] && e[13]).apply(this, arguments)
                    }
                    ))],
                    g = !0)
                },
                p(r, l) {
                    e = r,
                    (!f || 8 & l[0]) && Or(o, "id", e[3]),
                    (!f || 1 & l[0]) && Or(o, "min", e[0]),
                    (!f || 2 & l[0]) && Or(o, "max", e[1]),
                    (!f || 4 & l[0]) && Or(o, "step", e[2]),
                    (!f || 16384 & l[0]) && (o.value = e[14]),
                    (!f || 1024 & l[0] && n !== (n = e[10] ? "pointer-events:none" : "")) && Or(o, "style", n),
                    b && b.p && (!f || 128 & l[1]) && hr(b, $, e, e[38], f ? pr($, e[38], l, null) : mr(e[38]), null),
                    (!f || 32 & l[0] && s !== (s = Pc(["PinturaSliderTrack", e[5]]))) && Or(a, "class", s),
                    (!f || 16 & l[0]) && Or(a, "style", e[4]),
                    x && x.p && (!f || 128 & l[1]) && hr(x, v, e, e[38], f ? pr(v, e[38], l, fp) : mr(e[38]), gp),
                    (!f || 128 & l[0] && d !== (d = Pc(["PinturaSliderKnob", e[7]]))) && Or(u, "class", d),
                    (!f || 64 & l[0]) && Or(u, "style", e[6]),
                    (!f || 131072 & l[0]) && Or(c, "style", e[17]),
                    (!f || 32768 & l[0] && p !== (p = `--slider-position:${Math.round(e[15])}`)) && Or(i, "style", p),
                    e[9] ? w ? (w.p(e, l),
                    512 & l[0] && ka(w, 1)) : (w = yp(e),
                    w.c(),
                    ka(w, 1),
                    w.m(t, null)) : w && (Sa(),
                    Ca(w, 1, 1, ( () => {
                        w = null
                    }
                    )),
                    _a()),
                    (!f || 4096 & l[0] && m !== (m = Pc(["PinturaSlider", e[12]]))) && Or(t, "class", m),
                    (!f || 256 & l[0]) && Or(t, "data-direction", e[8])
                },
                i(e) {
                    f || (ka(b, e),
                    ka(x, e),
                    ka(w),
                    f = !0)
                },
                o(e) {
                    Ca(b, e),
                    Ca(x, e),
                    Ca(w),
                    f = !1
                },
                d(i) {
                    i && Pr(t),
                    e[37](null),
                    b && b.d(i),
                    x && x.d(i),
                    w && w.d(),
                    g = !1,
                    nr(y)
                }
            }
        }
        function xp(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, {$$slots: b={}, $$scope: v} = t, {min: x=0} = t, {max: w=100} = t, {step: S=1} = t, {id: _} = t, {value: k=0} = t, {valueMin: C} = t, {valueMax: T} = t, {trackStyle: M} = t, {trackClass: P} = t, {knobStyle: E} = t, {knobClass: R} = t, {ongrab: A=$} = t, {onchange: I=$} = t, {onrelease: L=$} = t, {onexceed: D=$} = t, {direction: z="x"} = t, {getValue: F=se} = t, {setValue: O=se} = t, {enableSpinButtons: B=!0} = t, {enableForceUseKnob: N=!1} = t, {enableStopPropagation: H=!0} = t, {enablePointerdownListener: j=!0} = t, {maxInteractionDistance: U=6} = t, {class: V} = t;
            const q = e => O(( (e, t) => (t = 1 / t,
            Math.round(e * t) / t))(cs(e, x, w), S), k)
              , G = (e, t, o={}) => {
                const {grabbed: r=!1, released: a=!1} = o
                  , s = q(x + e / t * n)
                  , l = C || x
                  , c = T || w;
                i(21, k = W(s) ? s : cs(s, l, c)),
                y !== s && (y = s,
                !W(s) && (s < l || s > c) && D(k, s),
                k !== g && (g = k,
                r && A(k),
                I(k),
                a && L(k)))
            }
            ;
            let K, X;
            const Z = e => {
                const t = e[u] - f;
                G(m + t, h)
            }
              , Y = e => {
                X = setTimeout(( () => {
                    h = void 0
                }
                ), 50),
                document.documentElement.removeEventListener("pointermove", Z),
                document.documentElement.removeEventListener("pointerup", Y),
                I(k),
                L(k)
            }
              , Q = () => {
                i(21, k = q(o + ee * S)),
                I(k)
            }
            ;
            let J, ee = 1, te = !1;
            const ie = e => {
                clearTimeout(J),
                te || Q(),
                L(k),
                document.removeEventListener("pointerup", ie)
            }
            ;
            return e.$$set = e => {
                "min"in e && i(0, x = e.min),
                "max"in e && i(1, w = e.max),
                "step"in e && i(2, S = e.step),
                "id"in e && i(3, _ = e.id),
                "value"in e && i(21, k = e.value),
                "valueMin"in e && i(22, C = e.valueMin),
                "valueMax"in e && i(23, T = e.valueMax),
                "trackStyle"in e && i(4, M = e.trackStyle),
                "trackClass"in e && i(5, P = e.trackClass),
                "knobStyle"in e && i(6, E = e.knobStyle),
                "knobClass"in e && i(7, R = e.knobClass),
                "ongrab"in e && i(24, A = e.ongrab),
                "onchange"in e && i(25, I = e.onchange),
                "onrelease"in e && i(26, L = e.onrelease),
                "onexceed"in e && i(27, D = e.onexceed),
                "direction"in e && i(8, z = e.direction),
                "getValue"in e && i(28, F = e.getValue),
                "setValue"in e && i(29, O = e.setValue),
                "enableSpinButtons"in e && i(9, B = e.enableSpinButtons),
                "enableForceUseKnob"in e && i(10, N = e.enableForceUseKnob),
                "enableStopPropagation"in e && i(30, H = e.enableStopPropagation),
                "enablePointerdownListener"in e && i(11, j = e.enablePointerdownListener),
                "maxInteractionDistance"in e && i(31, U = e.maxInteractionDistance),
                "class"in e && i(12, V = e.class),
                "$$scope"in e && i(38, v = e.$$scope)
            }
            ,
            e.$$.update = () => {
                270532608 & e.$$.dirty[0] && i(14, o = void 0 !== k ? F(k) : 0),
                3 & e.$$.dirty[0] && (n = w - x),
                16387 & e.$$.dirty[0] && i(33, r = mp(o, x, w)),
                4 & e.$$.dirty[1] && i(15, a = 100 * r),
                256 & e.$$.dirty[0] && i(34, s = z.toUpperCase()),
                256 & e.$$.dirty[0] && i(35, l = "x" === z ? "Width" : "Height"),
                16 & e.$$.dirty[1] && (c = `offset${l}`),
                e.$$.dirty[1],
                8 & e.$$.dirty[1] && (u = `page${s}`),
                32768 & e.$$.dirty[0] | 8 & e.$$.dirty[1] && i(17, d = `transform: translate${s}(${a}%)`)
            }
            ,
            [x, w, S, _, M, P, E, R, z, B, N, j, V, e => {
                clearTimeout(X);
                let t = !1;
                H && e.stopPropagation(),
                clearTimeout(K);
                const i = p.getBoundingClientRect();
                if (h = p[c],
                f = e[u],
                m = f - i[z],
                N) {
                    if (Math.abs(m - r * h) > U)
                        return;
                    t = !0,
                    e.stopPropagation()
                }
                return document.activeElement !== p && p.focus(),
                G(m, h, {
                    grabbed: !0
                }),
                document.documentElement.addEventListener("pointermove", Z),
                document.documentElement.addEventListener("pointerup", Y),
                t
            }
            , o, a, p, d, e => {
                h || (i(21, k = O(parseFloat(e.target.value))),
                k !== g && (g = k,
                I(k)))
            }
            , e => {
                const t = p[c];
                G(o / n * t + e.detail[z], t),
                clearTimeout(K),
                K = setTimeout(( () => {
                    L(k)
                }
                ), 250)
            }
            , e => t => {
                clearTimeout(K),
                ee = e,
                te = !1,
                J = setInterval(( () => {
                    te = !0,
                    Q()
                }
                ), 100),
                document.addEventListener("pointercancel", ie),
                document.addEventListener("pointerup", ie)
            }
            , k, C, T, A, I, L, D, F, O, H, U, e => {
                const t = p.getBoundingClientRect()
                  , i = e[u] - t[z]
                  , o = p[c];
                return Math.abs(i - r * o)
            }
            , r, s, l, b, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    p = e,
                    i(16, p)
                }
                ))
            }
            , v]
        }
        class wp extends Na {
            constructor(e) {
                super(),
                Ba(this, e, xp, vp, ar, {
                    min: 0,
                    max: 1,
                    step: 2,
                    id: 3,
                    value: 21,
                    valueMin: 22,
                    valueMax: 23,
                    trackStyle: 4,
                    trackClass: 5,
                    knobStyle: 6,
                    knobClass: 7,
                    ongrab: 24,
                    onchange: 25,
                    onrelease: 26,
                    onexceed: 27,
                    direction: 8,
                    getValue: 28,
                    setValue: 29,
                    enableSpinButtons: 9,
                    enableForceUseKnob: 10,
                    enableStopPropagation: 30,
                    enablePointerdownListener: 11,
                    maxInteractionDistance: 31,
                    class: 12,
                    eventDistanceToKnob: 32,
                    handlePointerDown: 13
                }, null, [-1, -1])
            }
            get eventDistanceToKnob() {
                return this.$$.ctx[32]
            }
            get handlePointerDown() {
                return this.$$.ctx[13]
            }
        }
        function Sp(e) {
            let t, i;
            return t = new ou({
                props: {
                    class: "PinturaButtonIcon",
                    $$slots: {
                        default: [_p]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1048580 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function _p(e) {
            let t;
            return {
                c() {
                    t = Rr("g")
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[2]
                },
                p(e, i) {
                    4 & i && (t.innerHTML = e[2])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function kp(e) {
            let t, i, o = pd(e[8], e[6]) + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "class", "PinturaButtonLabelPrefix")
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    320 & t && o !== (o = pd(e[8], e[6]) + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Cp(e) {
            let t, i, o, n, r, a, s, l, c, u = e[2] && Sp(e), d = e[8] && kp(e);
            return {
                c() {
                    t = Er("span"),
                    u && u.c(),
                    i = Ir(),
                    d && d.c(),
                    o = Ir(),
                    n = Er("span"),
                    r = Ar(e[9]),
                    Or(n, "class", a = Pc(["PinturaButtonLabel", e[3], e[5] && "implicit"])),
                    Or(t, "slot", "label"),
                    Or(t, "title", s = pd(e[1], e[6])),
                    Or(t, "class", l = Pc(["PinturaButtonInner", e[4]]))
                },
                m(e, a) {
                    Mr(e, t, a),
                    u && u.m(t, null),
                    kr(t, i),
                    d && d.m(t, null),
                    kr(t, o),
                    kr(t, n),
                    kr(n, r),
                    c = !0
                },
                p(e, p) {
                    e[2] ? u ? (u.p(e, p),
                    4 & p && ka(u, 1)) : (u = Sp(e),
                    u.c(),
                    ka(u, 1),
                    u.m(t, i)) : u && (Sa(),
                    Ca(u, 1, 1, ( () => {
                        u = null
                    }
                    )),
                    _a()),
                    e[8] ? d ? d.p(e, p) : (d = kp(e),
                    d.c(),
                    d.m(t, o)) : d && (d.d(1),
                    d = null),
                    (!c || 512 & p) && Wr(r, e[9]),
                    (!c || 40 & p && a !== (a = Pc(["PinturaButtonLabel", e[3], e[5] && "implicit"]))) && Or(n, "class", a),
                    (!c || 66 & p && s !== (s = pd(e[1], e[6]))) && Or(t, "title", s),
                    (!c || 16 & p && l !== (l = Pc(["PinturaButtonInner", e[4]]))) && Or(t, "class", l)
                },
                i(e) {
                    c || (ka(u),
                    c = !0)
                },
                o(e) {
                    Ca(u),
                    c = !1
                },
                d(e) {
                    e && Pr(t),
                    u && u.d(),
                    d && d.d()
                }
            }
        }
        function Tp(e) {
            let t, i, o, n, r;
            const a = [e[12], {
                value: e[7]
            }, {
                onchange: e[11]
            }];
            let s = {};
            for (let e = 0; e < a.length; e += 1)
                s = tr(s, a[e]);
            return i = new wp({
                props: s
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "slot", "details")
                },
                m(a, s) {
                    Mr(a, t, s),
                    Fa(i, t, null),
                    o = !0,
                    n || (r = Dr(t, "keydown", e[10]),
                    n = !0)
                },
                p(e, t) {
                    const o = 6272 & t ? Ia(a, [4096 & t && La(e[12]), 128 & t && {
                        value: e[7]
                    }, 2048 & t && {
                        onchange: e[11]
                    }]) : {};
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    n = !1,
                    r()
                }
            }
        }
        function Mp(e) {
            let t, i;
            return t = new rd({
                props: {
                    panelClass: "PinturaSliderPanel",
                    buttonClass: Pc(["PinturaSliderButton", e[0], e[5] && "PinturaSliderIconOnly"]),
                    $$slots: {
                        details: [Tp],
                        label: [Cp]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, [i]) {
                    const o = {};
                    33 & i && (o.buttonClass = Pc(["PinturaSliderButton", e[0], e[5] && "PinturaSliderIconOnly"])),
                    1053694 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Pp(e, t, i) {
            const o = ["class", "title", "label", "icon", "labelClass", "innerClass", "hideLabel", "locale", "value", "onchange", "labelPrefix"];
            let n = gr(t, o)
              , {class: r} = t
              , {title: a} = t
              , {label: s=Math.round} = t
              , {icon: l} = t
              , {labelClass: c} = t
              , {innerClass: u} = t
              , {hideLabel: d=!1} = t
              , {locale: p} = t
              , {value: h} = t
              , {onchange: m=$} = t
              , {labelPrefix: f} = t;
            const {min: g, max: y, getValue: b=se} = n;
            let v;
            const x = e => i(9, v = (e => H(s) ? s(b(e), g, y, e) : s)(e));
            return e.$$set = e => {
                t = tr(tr({}, t), fr(e)),
                i(12, n = gr(t, o)),
                "class"in e && i(0, r = e.class),
                "title"in e && i(1, a = e.title),
                "label"in e && i(13, s = e.label),
                "icon"in e && i(2, l = e.icon),
                "labelClass"in e && i(3, c = e.labelClass),
                "innerClass"in e && i(4, u = e.innerClass),
                "hideLabel"in e && i(5, d = e.hideLabel),
                "locale"in e && i(6, p = e.locale),
                "value"in e && i(7, h = e.value),
                "onchange"in e && i(14, m = e.onchange),
                "labelPrefix"in e && i(8, f = e.labelPrefix)
            }
            ,
            e.$$.update = () => {
                8320 & e.$$.dirty && x(h)
            }
            ,
            [r, a, l, c, u, d, p, h, f, v, e => {
                /tab/i.test(e.key) && e.preventDefault()
            }
            , e => {
                x(e),
                m(e)
            }
            , n, s, m]
        }
        class Ep extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Pp, Mp, ar, {
                    class: 0,
                    title: 1,
                    label: 13,
                    icon: 2,
                    labelClass: 3,
                    innerClass: 4,
                    hideLabel: 5,
                    locale: 6,
                    value: 7,
                    onchange: 14,
                    labelPrefix: 8
                })
            }
        }
        function Rp(e) {
            let t, i, o = pd(e[0], e[1]) + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "class", e[3])
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, n) {
                    3 & n && o !== (o = pd(e[0], e[1]) + "") && Wr(i, o),
                    8 & n && Or(t, "class", e[3])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Ap(e) {
            let t, i, o, n, r = e[0] && Rp(e);
            return o = new yh({
                props: {
                    items: e[2]
                }
            }),
            {
                c() {
                    t = Er("li"),
                    r && r.c(),
                    i = Ir(),
                    za(o.$$.fragment),
                    Or(t, "class", "PinturaShapeStyle")
                },
                m(e, a) {
                    Mr(e, t, a),
                    r && r.m(t, null),
                    kr(t, i),
                    Fa(o, t, null),
                    n = !0
                },
                p(e, [n]) {
                    e[0] ? r ? r.p(e, n) : (r = Rp(e),
                    r.c(),
                    r.m(t, i)) : r && (r.d(1),
                    r = null);
                    const a = {};
                    4 & n && (a.items = e[2]),
                    o.$set(a)
                },
                i(e) {
                    n || (ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    r && r.d(),
                    Oa(o)
                }
            }
        }
        function Ip(e, t, i) {
            let o, {title: n} = t, {locale: r} = t, {items: a} = t, {hideTitle: s=!1} = t;
            return e.$$set = e => {
                "title"in e && i(0, n = e.title),
                "locale"in e && i(1, r = e.locale),
                "items"in e && i(2, a = e.items),
                "hideTitle"in e && i(4, s = e.hideTitle)
            }
            ,
            e.$$.update = () => {
                16 & e.$$.dirty && i(3, o = "PinturaShapeStyleLabel" + (s ? " implicit" : ""))
            }
            ,
            [n, r, a, o, s]
        }
        class Lp extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Ip, Ap, ar, {
                    title: 0,
                    locale: 1,
                    items: 2,
                    hideTitle: 4
                })
            }
        }
        var Dp = (e, t, i) => {
            let o, n, r;
            const a = Math.floor(6 * e)
              , s = 6 * e - a
              , l = i * (1 - t)
              , c = i * (1 - s * t)
              , u = i * (1 - (1 - s) * t);
            switch (a % 6) {
            case 0:
                o = i,
                n = u,
                r = l;
                break;
            case 1:
                o = c,
                n = i,
                r = l;
                break;
            case 2:
                o = l,
                n = i,
                r = u;
                break;
            case 3:
                o = l,
                n = c,
                r = i;
                break;
            case 4:
                o = u,
                n = l,
                r = i;
                break;
            case 5:
                o = i,
                n = l,
                r = c
            }
            return [o, n, r]
        }
        ;
        function zp(e) {
            let t, i, o;
            return {
                c() {
                    t = Er("div"),
                    i = Er("span"),
                    Or(t, "class", "PinturaColorPreview"),
                    Or(t, "title", e[0]),
                    Or(t, "style", o = `--color:${e[1]}`)
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, [i]) {
                    1 & i && Or(t, "title", e[0]),
                    2 & i && o !== (o = `--color:${e[1]}`) && Or(t, "style", o)
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Fp(e, t, i) {
            let o, {color: n} = t, {title: r} = t;
            return e.$$set = e => {
                "color"in e && i(2, n = e.color),
                "title"in e && i(0, r = e.title)
            }
            ,
            e.$$.update = () => {
                4 & e.$$.dirty && i(1, o = n ? Qi(n) : "transparent")
            }
            ,
            [r, o, n]
        }
        class Op extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Fp, zp, ar, {
                    color: 2,
                    title: 0
                })
            }
        }
        var Bp = e => (e = e.trim(),
        /^rgba/.test(e) ? e.substring(5).split(",").map(parseFloat).map(( (e, t) => e / (3 === t ? 1 : 255))) : /^rgb/.test(e) ? e.substring(4).split(",").map(parseFloat).map((e => e / 255)) : /^#/.test(e) ? (e => {
            const [,t,i,o,n] = e.split("");
            e = e.length >= 4 && e.length <= 5 ? `#${t}${t}${i}${i}${o}${o}${n ? `${n}${n}` : ""}` : e;
            const [r,a,s,l,c] = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(e) || [];
            if (r)
                return [a, s, l, c].filter((e => void 0 !== e)).map((e => parseInt(e, 16) / 255))
        }
        )(e) : /[0-9]{1,3}\s?,\s?[0-9]{1,3}\s?,\s?[0-9]{1,3}/.test(e) ? e.split(",").map((e => parseInt(e, 10))).map((e => e / 255)) : void 0);
        let Np = null;
        function Wp(e) {
            let t, i;
            return {
                c() {
                    t = Er("span"),
                    i = Ar(e[0])
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    1 & t[0] && Wr(i, e[0])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Hp(e) {
            let t, i, o, n;
            i = new Op({
                props: {
                    color: e[4],
                    title: pd(e[8], e[10])
                }
            });
            let r = !e[9] && Wp(e);
            return {
                c() {
                    t = Er("span"),
                    za(i.$$.fragment),
                    o = Ir(),
                    r && r.c(),
                    Or(t, "slot", "label"),
                    Or(t, "class", "PinturaButtonLabel")
                },
                m(e, a) {
                    Mr(e, t, a),
                    Fa(i, t, null),
                    kr(t, o),
                    r && r.m(t, null),
                    n = !0
                },
                p(e, o) {
                    const n = {};
                    16 & o[0] && (n.color = e[4]),
                    1280 & o[0] && (n.title = pd(e[8], e[10])),
                    i.$set(n),
                    e[9] ? r && (r.d(1),
                    r = null) : r ? r.p(e, o) : (r = Wp(e),
                    r.c(),
                    r.m(t, null))
                },
                i(e) {
                    n || (ka(i.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    r && r.d()
                }
            }
        }
        function jp(e) {
            let t, i, o, n, r, a, s, l, c, u, d, p, h, m;
            c = new wp({
                props: {
                    class: "PinturaHuePicker",
                    knobStyle: `background-color:${e[21]}`,
                    onchange: e[27],
                    value: e[16],
                    min: 0,
                    max: 1,
                    step: .01
                }
            });
            let f = e[11] && Up(e)
              , g = (e[14] || e[15]) && Vp(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    o = Er("div"),
                    n = Er("div"),
                    l = Ir(),
                    za(c.$$.fragment),
                    u = Ir(),
                    f && f.c(),
                    d = Ir(),
                    g && g.c(),
                    Or(n, "role", "button"),
                    Or(n, "aria-label", "Saturation slider"),
                    Or(n, "class", "PinturaPickerKnob"),
                    Or(n, "tabindex", "0"),
                    Or(n, "style", r = `background-color:${e[20]};`),
                    Or(o, "class", "PinturaPickerKnobController"),
                    Or(o, "style", a = `transform:translate(${e[25]}%,${e[24]}%)`),
                    Or(i, "class", "PinturaSaturationPicker"),
                    Or(i, "style", s = `background-color: ${e[21]}`),
                    Or(t, "class", "PinturaPicker")
                },
                m(r, a) {
                    Mr(r, t, a),
                    kr(t, i),
                    kr(i, o),
                    kr(o, n),
                    e[41](i),
                    kr(t, l),
                    Fa(c, t, null),
                    kr(t, u),
                    f && f.m(t, null),
                    kr(t, d),
                    g && g.m(t, null),
                    p = !0,
                    h || (m = [Dr(n, "nudge", e[30]), $r(fu.call(null, n, {
                        preventDefault: !0
                    })), Dr(i, "pointerdown", e[29])],
                    h = !0)
                },
                p(e, l) {
                    (!p || 1048576 & l[0] && r !== (r = `background-color:${e[20]};`)) && Or(n, "style", r),
                    (!p || 50331648 & l[0] && a !== (a = `transform:translate(${e[25]}%,${e[24]}%)`)) && Or(o, "style", a),
                    (!p || 2097152 & l[0] && s !== (s = `background-color: ${e[21]}`)) && Or(i, "style", s);
                    const u = {};
                    2097152 & l[0] && (u.knobStyle = `background-color:${e[21]}`),
                    65536 & l[0] && (u.value = e[16]),
                    c.$set(u),
                    e[11] ? f ? (f.p(e, l),
                    2048 & l[0] && ka(f, 1)) : (f = Up(e),
                    f.c(),
                    ka(f, 1),
                    f.m(t, d)) : f && (Sa(),
                    Ca(f, 1, 1, ( () => {
                        f = null
                    }
                    )),
                    _a()),
                    e[14] || e[15] ? g ? (g.p(e, l),
                    49152 & l[0] && ka(g, 1)) : (g = Vp(e),
                    g.c(),
                    ka(g, 1),
                    g.m(t, null)) : g && (Sa(),
                    Ca(g, 1, 1, ( () => {
                        g = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    p || (ka(c.$$.fragment, e),
                    ka(f),
                    ka(g),
                    p = !0)
                },
                o(e) {
                    Ca(c.$$.fragment, e),
                    Ca(f),
                    Ca(g),
                    p = !1
                },
                d(i) {
                    i && Pr(t),
                    e[41](null),
                    Oa(c),
                    f && f.d(),
                    g && g.d(),
                    h = !1,
                    nr(m)
                }
            }
        }
        function Up(e) {
            let t, i;
            return t = new wp({
                props: {
                    class: "PinturaOpacityPicker",
                    knobStyle: `background-color:${e[18]}`,
                    trackStyle: `background-image:linear-gradient(to right,${e[19]},${e[20]})`,
                    onchange: e[28],
                    value: e[17],
                    min: 0,
                    max: 1,
                    step: .01
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    262144 & i[0] && (o.knobStyle = `background-color:${e[18]}`),
                    1572864 & i[0] && (o.trackStyle = `background-image:linear-gradient(to right,${e[19]},${e[20]})`),
                    131072 & i[0] && (o.value = e[17]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Vp(e) {
            let t, i, o, n, r, a, s, l = e[15] && qp(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("input"),
                    n = Ir(),
                    l && l.c(),
                    Or(i, "class", "PinturaColorPickerInput"),
                    Or(i, "type", "text"),
                    i.disabled = o = !e[14],
                    i.value = e[23],
                    Or(t, "class", "PinturColorPickerInputGroup")
                },
                m(o, c) {
                    Mr(o, t, c),
                    kr(t, i),
                    kr(t, n),
                    l && l.m(t, null),
                    r = !0,
                    a || (s = [Dr(i, "keydown", e[32]), Dr(i, "input", e[31])],
                    a = !0)
                },
                p(e, n) {
                    (!r || 16384 & n[0] && o !== (o = !e[14])) && (i.disabled = o),
                    (!r || 8388608 & n[0] && i.value !== e[23]) && (i.value = e[23]),
                    e[15] ? l ? (l.p(e, n),
                    32768 & n[0] && ka(l, 1)) : (l = qp(e),
                    l.c(),
                    ka(l, 1),
                    l.m(t, null)) : l && (Sa(),
                    Ca(l, 1, 1, ( () => {
                        l = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    r || (ka(l),
                    r = !0)
                },
                o(e) {
                    Ca(l),
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    l && l.d(),
                    a = !1,
                    nr(s)
                }
            }
        }
        function qp(e) {
            let t, i;
            return t = new du({
                props: {
                    icon: '<path stroke="currentColor" stroke-linecap="square" d="m13 14-7 7a2.704 2.704 0 0 1-3 0 2.704 2.704 0 0 1 0-3l7-7"/><path fill="currentColor" d="M9.475 9.475 14.5 14.5c.263.263.69.265.955.005l.783-.767a4.209 4.209 0 0 0 1.262-3.006V10l4-4c.5-.5.375-2.125-.5-3s-2.5-1-3-.5l-4 4h-.732a4.329 4.329 0 0 0-3.03 1.238l-.758.742a.7.7 0 0 0-.005.995Z"/>',
                    hideLabel: !0,
                    label: "Pick a color",
                    class: "PinturaEyeDropper",
                    onclick: e[33]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p: Jn,
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Gp(e) {
            let t, i;
            return t = new Nd({
                props: {
                    label: pd(e[10].labelColorPalette, e[10]),
                    class: Pc(["PinturaColorPresets", e[9] ? "PinturaColorPresetsGrid" : "PinturaColorPresetsList"]),
                    hideLabel: !1,
                    name: e[1],
                    value: e[4],
                    optionGroupClass: "PinturaListOptionGroup",
                    optionClass: "PinturaListOption",
                    options: e[2].map(e[42]),
                    selectedIndex: e[3],
                    optionMapper: e[7],
                    optionLabelClass: e[6],
                    onchange: e[43],
                    $$slots: {
                        option: [Zp, ({option: e}) => ({
                            59: e
                        }), ({option: e}) => [0, e ? 268435456 : 0]],
                        group: [Kp, ({option: e}) => ({
                            59: e
                        }), ({option: e}) => [0, e ? 268435456 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1024 & i[0] && (o.label = pd(e[10].labelColorPalette, e[10])),
                    512 & i[0] && (o.class = Pc(["PinturaColorPresets", e[9] ? "PinturaColorPresetsGrid" : "PinturaColorPresetsList"])),
                    2 & i[0] && (o.name = e[1]),
                    16 & i[0] && (o.value = e[4]),
                    1028 & i[0] && (o.options = e[2].map(e[42])),
                    8 & i[0] && (o.selectedIndex = e[3]),
                    128 & i[0] && (o.optionMapper = e[7]),
                    64 & i[0] && (o.optionLabelClass = e[6]),
                    512 & i[0] | 805306368 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Kp(e) {
            let t, i, o = e[59].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "slot", "group")
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    268435456 & t[1] && o !== (o = e[59].label + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Xp(e) {
            let t, i, o = e[59].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o),
                    Or(t, "class", "PinturaButtonLabel")
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    268435456 & t[1] && o !== (o = e[59].label + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Zp(e) {
            let t, i, o, n;
            i = new Op({
                props: {
                    title: e[59].label,
                    color: e[59].value
                }
            });
            let r = !e[9] && Xp(e);
            return {
                c() {
                    t = Er("span"),
                    za(i.$$.fragment),
                    o = Ir(),
                    r && r.c(),
                    Or(t, "slot", "option")
                },
                m(e, a) {
                    Mr(e, t, a),
                    Fa(i, t, null),
                    kr(t, o),
                    r && r.m(t, null),
                    n = !0
                },
                p(e, o) {
                    const n = {};
                    268435456 & o[1] && (n.title = e[59].label),
                    268435456 & o[1] && (n.color = e[59].value),
                    i.$set(n),
                    e[9] ? r && (r.d(1),
                    r = null) : r ? r.p(e, o) : (r = Xp(e),
                    r.c(),
                    r.m(t, null))
                },
                i(e) {
                    n || (ka(i.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    r && r.d()
                }
            }
        }
        function Yp(e) {
            let t, i, o, n = e[13] && jp(e), r = e[12] && Gp(e);
            return {
                c() {
                    t = Er("div"),
                    n && n.c(),
                    i = Ir(),
                    r && r.c(),
                    Or(t, "slot", "details"),
                    Or(t, "class", "PinturaColorPickerPanel")
                },
                m(e, a) {
                    Mr(e, t, a),
                    n && n.m(t, null),
                    kr(t, i),
                    r && r.m(t, null),
                    o = !0
                },
                p(e, o) {
                    e[13] ? n ? (n.p(e, o),
                    8192 & o[0] && ka(n, 1)) : (n = jp(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t, i)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[12] ? r ? (r.p(e, o),
                    4096 & o[0] && ka(r, 1)) : (r = Gp(e),
                    r.c(),
                    ka(r, 1),
                    r.m(t, null)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    o || (ka(n),
                    ka(r),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(r),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    n && n.d(),
                    r && r.d()
                }
            }
        }
        function Qp(e) {
            let t, i;
            return t = new rd({
                props: {
                    buttonClass: Pc(["PinturaColorPickerButton", e[5]]),
                    $$slots: {
                        details: [Yp],
                        label: [Hp]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    32 & i[0] && (o.buttonClass = Pc(["PinturaColorPickerButton", e[5]])),
                    67108831 & i[0] | 536870912 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Jp(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, {label: $} = t, {name: b} = t, {options: v=[]} = t, {selectedIndex: x=-1} = t, {value: w} = t, {buttonClass: S} = t, {optionLabelClass: k} = t, {optionMapper: C} = t, {onchange: T} = t, {title: M} = t, {hidePresetLabel: P=!0} = t, {locale: E} = t, {enableOpacity: R=!0} = t, {enablePresets: A=!0} = t, {enablePicker: I=!0} = t, {enableInput: L=!1} = t, {enableEyeDropper: D=!1} = t;
            const z = (e, t) => {
                if (p = [e[0], e[1], e[2]],
                t) {
                    let t = ( (e, t, i) => {
                        let o = Math.max(e, t, i)
                          , n = o - Math.min(e, t, i)
                          , r = n && (o == e ? (t - i) / n : o == t ? 2 + (i - e) / n : 4 + (e - t) / n);
                        return [60 * (r < 0 ? r + 6 : r) / 360, o && n / o, o]
                    }
                    )(...p)
                      , o = t[0]
                      , n = t[1]
                      , r = t[2];
                    Wi(j) && (o = j),
                    Wi(N) && (n = N),
                    Wi(W) && (r = W),
                    i(16, l = o),
                    i(36, c = n),
                    i(37, u = r),
                    i(17, d = Wi(e[3]) ? e[3] : 1)
                }
                i(18, h = Qi(e)),
                i(19, m = Qi([...p, 0])),
                i(20, f = Qi([...p, 1])),
                i(21, g = Qi(Dp(l, 1, 1)))
            }
              , F = () => {
                const e = [...Dp(l, c, u), d];
                z(e),
                T(e)
            }
              , O = e => {
                const t = 3 === e.length ? [...e, 1] : e;
                B(),
                z(t, !0),
                T(t)
            }
              , B = () => {
                N = void 0,
                W = void 0,
                j = void 0
            }
            ;
            let N, W, j;
            const U = (e, t) => {
                const o = cs(e.x / t.width, 0, 1);
                var n, r;
                r = 1 - cs(e.y / t.height, 0, 1),
                i(36, c = n = o),
                i(37, u = r),
                N = n,
                W = r,
                F()
            }
            ;
            let V, q, G, K;
            const X = e => {
                const t = Fe(Te(e), K);
                U(ze(Me(G), t), q)
            }
              , Z = e => {
                q = void 0,
                document.documentElement.removeEventListener("pointermove", X),
                document.documentElement.removeEventListener("pointerup", Z)
            }
            ;
            let Y;
            return e.$$set = e => {
                "label"in e && i(0, $ = e.label),
                "name"in e && i(1, b = e.name),
                "options"in e && i(2, v = e.options),
                "selectedIndex"in e && i(3, x = e.selectedIndex),
                "value"in e && i(4, w = e.value),
                "buttonClass"in e && i(5, S = e.buttonClass),
                "optionLabelClass"in e && i(6, k = e.optionLabelClass),
                "optionMapper"in e && i(7, C = e.optionMapper),
                "onchange"in e && i(34, T = e.onchange),
                "title"in e && i(8, M = e.title),
                "hidePresetLabel"in e && i(9, P = e.hidePresetLabel),
                "locale"in e && i(10, E = e.locale),
                "enableOpacity"in e && i(11, R = e.enableOpacity),
                "enablePresets"in e && i(12, A = e.enablePresets),
                "enablePicker"in e && i(13, I = e.enablePicker),
                "enableInput"in e && i(14, L = e.enableInput),
                "enableEyeDropper"in e && i(35, D = e.enableEyeDropper)
            }
            ,
            e.$$.update = () => {
                16 & e.$$.dirty[1] && i(15, o = D && (null === Np && (Np = _() && "EyeDropper"in window),
                Np)),
                16 & e.$$.dirty[0] | 128 & e.$$.dirty[1] && (!w || y && ms(w, y) || (i(38, y = [...w]),
                z(w, !0))),
                32 & e.$$.dirty[1] && i(25, n = 100 * c),
                64 & e.$$.dirty[1] && i(24, r = 100 - 100 * u),
                256 & e.$$.dirty[1] && i(40, a = !!Y && Y.length >= 4 && Y.length <= 5),
                51216 & e.$$.dirty[0] | 512 & e.$$.dirty[1] && i(23, s = (L || o) && w ? ( (e, t, i) => {
                    let o = e.map((e => Math.round(255 * e).toString(16).toLowerCase().padStart(2, "0")));
                    return (!t && o.length > 3 || "ff" === o[3]) && o.pop(),
                    i && (o = o.map((e => e.substring(0, 1)))),
                    `#${o.join("")}`
                }
                )(w, R, a) : void 0)
            }
            ,
            [$, b, v, x, w, S, k, C, M, P, E, R, A, I, L, o, l, d, h, m, f, g, V, s, r, n, O, e => {
                i(16, l = e),
                j = e,
                F()
            }
            , e => {
                i(17, d = e),
                F()
            }
            , e => {
                e.stopPropagation(),
                q = et(V.offsetWidth, V.offsetHeight),
                G = (e => Ce(e.offsetX, e.offsetY))(e),
                K = Te(e),
                U(G, q),
                document.documentElement.addEventListener("pointermove", X),
                document.documentElement.addEventListener("pointerup", Z)
            }
            , e => {
                q = et(V.offsetWidth, V.offsetHeight);
                const t = n / 100 * q.width
                  , i = r / 100 * q.height;
                U({
                    x: t + e.detail.x,
                    y: i + e.detail.y
                }, q)
            }
            , e => {
                const {value: t} = e.target
                  , o = t.length;
                if (!t.startsWith("#") || o < 4 || 6 === o || 8 === o || o > 9)
                    return;
                if (!R && o > 7)
                    return;
                const n = Bp(t);
                n && (i(39, Y = t),
                B(),
                z(n),
                T(n))
            }
            , e => {
                e.stopPropagation()
            }
            , e => {
                (new EyeDropper).open().then(( ({sRGBHex: e}) => {
                    const t = Bp(e);
                    t && (t[3] = 1,
                    i(39, Y = w),
                    B(),
                    z(t),
                    T(t))
                }
                )).catch((e => {}
                ))
            }
            , T, D, c, u, y, Y, a, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    V = e,
                    i(22, V)
                }
                ))
            }
            , ([e,t]) => [e, H(t) ? t(E) : t], e => O(e.value)]
        }
        class eh extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Jp, Qp, ar, {
                    label: 0,
                    name: 1,
                    options: 2,
                    selectedIndex: 3,
                    value: 4,
                    buttonClass: 5,
                    optionLabelClass: 6,
                    optionMapper: 7,
                    onchange: 34,
                    title: 8,
                    hidePresetLabel: 9,
                    locale: 10,
                    enableOpacity: 11,
                    enablePresets: 12,
                    enablePicker: 13,
                    enableInput: 14,
                    enableEyeDropper: 35
                }, null, [-1, -1])
            }
        }
        function th(e) {
            let t, i, o;
            return i = new yh({
                props: {
                    items: e[0]
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaShorthandControl PinturaShapeStyle")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, [t]) {
                    const o = {};
                    1 & t && (o.items = e[0]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function ih(e, t, i) {
            let o, n, {value: r} = t, {onchange: a} = t, {controls: s=[]} = t;
            return e.$$set = e => {
                i(6, t = tr(tr({}, t), fr(e))),
                "value"in e && i(1, r = e.value),
                "onchange"in e && i(2, a = e.onchange),
                "controls"in e && i(3, s = e.controls)
            }
            ,
            e.$$.update = () => {
                i(4, o = (e => {
                    const {controls: t, ...i} = e;
                    return i
                }
                )(t)),
                30 & e.$$.dirty && i(0, n = s.map(( (e, t) => {
                    const [i,n,s] = e;
                    return [i, n, {
                        ...o,
                        ...s,
                        value: r[t],
                        onchange: e => {
                            const i = [...r];
                            i[t] = e,
                            a(i)
                        }
                    }]
                }
                )))
            }
            ,
            t = fr(t),
            [n, r, a, s, o]
        }
        class oh extends Na {
            constructor(e) {
                super(),
                Ba(this, e, ih, th, ar, {
                    value: 1,
                    onchange: 2,
                    controls: 3
                })
            }
        }
        function nh(e) {
            let t, i;
            return t = new cp({
                props: {
                    label: e[4],
                    options: e[1],
                    title: e[2],
                    selectedIndex: e[5],
                    onchange: e[10]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, [i]) {
                    const o = {};
                    16 & i && (o.label = e[4]),
                    2 & i && (o.options = e[1]),
                    4 & i && (o.title = e[2]),
                    32 & i && (o.selectedIndex = e[5]),
                    9 & i && (o.onchange = e[10]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function rh(e, t, i) {
            let o, n, r, a, {options: s} = t, {title: l} = t, {onchange: c} = t, {selectedIndex: u=-1} = t, {value: d} = t, {label: p} = t;
            return e.$$set = e => {
                "options"in e && i(1, s = e.options),
                "title"in e && i(2, l = e.title),
                "onchange"in e && i(3, c = e.onchange),
                "selectedIndex"in e && i(0, u = e.selectedIndex),
                "value"in e && i(6, d = e.value),
                "label"in e && i(7, p = e.label)
            }
            ,
            e.$$.update = () => {
                67 & e.$$.dirty && i(9, o = ( (e, t, i) => {
                    if (e)
                        return t > -1 ? e[t] : void 0 !== i ? e.find((e => e[0] === i)) : e[0]
                }
                )(s, u, d)),
                514 & e.$$.dirty && i(5, n = s && s.findIndex((e => e === o))),
                512 & e.$$.dirty && i(8, r = o && o[1]),
                384 & e.$$.dirty && i(4, a = p || r)
            }
            ,
            [u, s, l, c, a, n, d, p, r, o, e => {
                i(0, u = e.index),
                c && c(e)
            }
            ]
        }
        class ah extends Na {
            constructor(e) {
                super(),
                Ba(this, e, rh, nh, ar, {
                    options: 1,
                    title: 2,
                    onchange: 3,
                    selectedIndex: 0,
                    value: 6,
                    label: 7
                })
            }
        }
        function sh(e, t, i) {
            const o = e.slice();
            return o[9] = t[i][0],
            o[0] = t[i][1],
            o[10] = t[i][2],
            o[2] = t[i][3],
            o
        }
        function lh(e) {
            let t, i, o;
            const n = [e[10]];
            var r = e[3][e[9]] || e[9];
            function a(e) {
                let t = {};
                for (let e = 0; e < n.length; e += 1)
                    t = tr(t, n[e]);
                return {
                    props: t
                }
            }
            return r && (t = Vr(r, a())),
            {
                c() {
                    t && za(t.$$.fragment),
                    i = Lr()
                },
                m(e, n) {
                    t && Fa(t, e, n),
                    Mr(e, i, n),
                    o = !0
                },
                p(e, o) {
                    const s = 4 & o ? Ia(n, [La(e[10])]) : {};
                    if (r !== (r = e[3][e[9]] || e[9])) {
                        if (t) {
                            Sa();
                            const e = t;
                            Ca(e.$$.fragment, 1, 0, ( () => {
                                Oa(e, 1)
                            }
                            )),
                            _a()
                        }
                        r ? (t = Vr(r, a()),
                        za(t.$$.fragment),
                        ka(t.$$.fragment, 1),
                        Fa(t, i.parentNode, i)) : t = null
                    } else
                        r && t.$set(s)
                },
                i(e) {
                    o || (t && ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    t && Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(i),
                    t && Oa(t, e)
                }
            }
        }
        function ch(e) {
            let t, i = e[9], o = e[9] && hh(e);
            return {
                c() {
                    o && o.c(),
                    t = Lr()
                },
                m(e, i) {
                    o && o.m(e, i),
                    Mr(e, t, i)
                },
                p(e, n) {
                    e[9] ? i ? ar(i, e[9]) ? (o.d(1),
                    o = hh(e),
                    o.c(),
                    o.m(t.parentNode, t)) : o.p(e, n) : (o = hh(e),
                    o.c(),
                    o.m(t.parentNode, t)) : i && (o.d(1),
                    o = null),
                    i = e[9]
                },
                i: Jn,
                o(e) {
                    Ca(o)
                },
                d(e) {
                    e && Pr(t),
                    o && o.d(e)
                }
            }
        }
        function uh(e) {
            let t, i, o = e[10].innerHTML + "";
            return {
                c() {
                    t = new Ur(!1),
                    i = Lr(),
                    t.a = i
                },
                m(e, n) {
                    t.m(o, e, n),
                    Mr(e, i, n)
                },
                p(e, i) {
                    4 & i && o !== (o = e[10].innerHTML + "") && t.p(o)
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(i),
                    e && t.d()
                }
            }
        }
        function dh(e) {
            let t, i = e[10].textContent + "";
            return {
                c() {
                    t = Ar(i)
                },
                m(e, i) {
                    Mr(e, t, i)
                },
                p(e, o) {
                    4 & o && i !== (i = e[10].textContent + "") && Wr(t, i)
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function ph(e) {
            let t, i;
            return t = new yh({
                props: {
                    items: e[2],
                    discardEmptyItems: !0
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    4 & i && (o.items = e[2]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function hh(e) {
            let t, i, o, n, r;
            const a = [ph, dh, uh]
              , s = [];
            function l(e, t) {
                return e[2] && e[2].length ? 0 : e[10].textContent ? 1 : e[10].innerHTML ? 2 : -1
            }
            ~(i = l(e)) && (o = s[i] = a[i](e));
            let c = [e[4](e[10])]
              , u = {};
            for (let e = 0; e < c.length; e += 1)
                u = tr(u, c[e]);
            return {
                c() {
                    t = Er(e[9]),
                    o && o.c(),
                    n = Ir(),
                    /-/.test(e[9]) ? Nr(t, u) : Br(t, u)
                },
                m(e, o) {
                    Mr(e, t, o),
                    ~i && s[i].m(t, null),
                    kr(t, n),
                    r = !0
                },
                p(e, r) {
                    let d = i;
                    i = l(e),
                    i === d ? ~i && s[i].p(e, r) : (o && (Sa(),
                    Ca(s[d], 1, 1, ( () => {
                        s[d] = null
                    }
                    )),
                    _a()),
                    ~i ? (o = s[i],
                    o ? o.p(e, r) : (o = s[i] = a[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(t, n)) : o = null),
                    u = Ia(c, [4 & r && e[4](e[10])]),
                    /-/.test(e[9]) ? Nr(t, u) : Br(t, u)
                },
                i(e) {
                    r || (ka(o),
                    r = !0)
                },
                o(e) {
                    Ca(o),
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    ~i && s[i].d()
                }
            }
        }
        function mh(e, t) {
            let i, o, n, r, a, s;
            const l = [ch, lh]
              , c = [];
            function u(e, t) {
                return 4 & t && (o = null),
                null == o && (o = !e[5](e[9])),
                o ? 0 : 1
            }
            return n = u(t, -1),
            r = c[n] = l[n](t),
            {
                key: e,
                first: null,
                c() {
                    i = Lr(),
                    r.c(),
                    a = Lr(),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    c[n].m(e, t),
                    Mr(e, a, t),
                    s = !0
                },
                p(e, i) {
                    let o = n;
                    n = u(t = e, i),
                    n === o ? c[n].p(t, i) : (Sa(),
                    Ca(c[o], 1, 1, ( () => {
                        c[o] = null
                    }
                    )),
                    _a(),
                    r = c[n],
                    r ? r.p(t, i) : (r = c[n] = l[n](t),
                    r.c()),
                    ka(r, 1),
                    r.m(a.parentNode, a))
                },
                i(e) {
                    s || (ka(r),
                    s = !0)
                },
                o(e) {
                    Ca(r),
                    s = !1
                },
                d(e) {
                    e && Pr(i),
                    c[n].d(e),
                    e && Pr(a)
                }
            }
        }
        function fh(e) {
            let t, i, o = [], n = new Map, r = e[2];
            const a = e => e[0] + e[1];
            for (let t = 0; t < r.length; t += 1) {
                let i = sh(e, r, t)
                  , s = a(i);
                n.set(s, o[t] = mh(s, i))
            }
            return {
                c() {
                    for (let e = 0; e < o.length; e += 1)
                        o[e].c();
                    t = Lr()
                },
                m(e, n) {
                    for (let t = 0; t < o.length; t += 1)
                        o[t].m(e, n);
                    Mr(e, t, n),
                    i = !0
                },
                p(e, [i]) {
                    62 & i && (r = e[2],
                    Sa(),
                    o = Aa(o, i, a, 1, e, r, n, t.parentNode, Ra, mh, t, sh),
                    _a())
                },
                i(e) {
                    if (!i) {
                        for (let e = 0; e < r.length; e += 1)
                            ka(o[e]);
                        i = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < o.length; e += 1)
                        Ca(o[e]);
                    i = !1
                },
                d(e) {
                    for (let t = 0; t < o.length; t += 1)
                        o[t].d(e);
                    e && Pr(t)
                }
            }
        }
        function gh(e, t, i) {
            let o, n, {items: r} = t, {discardEmptyItems: a=!0} = t, {key: s=""} = t;
            const l = {
                Button: du,
                ImageButton: zu,
                ImageButtonList: Wu,
                Dropdown: cp,
                Select: ah,
                RadioGroup: Nd,
                Input: Ud,
                Panel: hp,
                ProgressIndicator: Pu,
                ShapeStyle: Lp,
                ToggleSlider: Ep,
                ColorPicker: eh,
                ShorthandControl: oh
            }
              , c = e => !W(e) || !!l[e]
              , u = e => {
                if (!e)
                    return !1;
                const [t,,i,o=[]] = e;
                return !!c(t) || o.some(u) || i.textContent || i.innerHTML
            }
            ;
            return e.$$set = e => {
                "items"in e && i(6, r = e.items),
                "discardEmptyItems"in e && i(7, a = e.discardEmptyItems),
                "key"in e && i(0, s = e.key)
            }
            ,
            e.$$.update = () => {
                1 & e.$$.dirty && i(1, o = s),
                192 & e.$$.dirty && i(2, n = (r && a ? r.filter(u) : r) || [])
            }
            ,
            [s, o, n, l, (e={}) => {
                const {textContent: t, innerHTML: i, ...o} = e;
                return o
            }
            , c, r, a]
        }
        class yh extends Na {
            constructor(e) {
                super(),
                Ba(this, e, gh, fh, ar, {
                    items: 6,
                    discardEmptyItems: 7,
                    key: 0
                })
            }
            get items() {
                return this.$$.ctx[6]
            }
            set items(e) {
                this.$$set({
                    items: e
                }),
                $a()
            }
            get discardEmptyItems() {
                return this.$$.ctx[7]
            }
            set discardEmptyItems(e) {
                this.$$set({
                    discardEmptyItems: e
                }),
                $a()
            }
            get key() {
                return this.$$.ctx[0]
            }
            set key(e) {
                this.$$set({
                    key: e
                }),
                $a()
            }
        }
        let $h = null;
        function bh(e) {
            let t, i;
            const o = [{
                onclick: e[1]
            }, e[3]];
            let n = {};
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new du({
                props: n
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 10 & i[0] ? Ia(o, [2 & i[0] && {
                        onclick: e[1]
                    }, 8 & i[0] && La(e[3])]) : {};
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function vh(e) {
            let t, i;
            const o = [{
                onclick: e[0]
            }, {
                class: "PinturaInputFormButtonConfirm"
            }, e[2]];
            let n = {};
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new du({
                props: n
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 5 & i[0] ? Ia(o, [1 & i[0] && {
                        onclick: e[0]
                    }, o[1], 4 & i[0] && La(e[2])]) : {};
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function xh(e) {
            let t, i, o, n, r, a, s, l, c = e[3] && bh(e);
            const u = e[24].default
              , d = ur(u, e, e[23], null);
            let p = e[2] && vh(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    c && c.c(),
                    o = Ir(),
                    n = Er("div"),
                    d && d.c(),
                    r = Ir(),
                    p && p.c(),
                    Or(n, "class", "PinturaInputFormFields"),
                    Or(i, "class", "PinturaInputFormInner"),
                    Or(t, "class", "PinturaInputForm"),
                    Or(t, "data-layout", e[4]),
                    Or(t, "style", e[6])
                },
                m(u, h) {
                    Mr(u, t, h),
                    kr(t, i),
                    c && c.m(i, null),
                    kr(i, o),
                    kr(i, n),
                    d && d.m(n, null),
                    kr(i, r),
                    p && p.m(i, null),
                    e[25](t),
                    a = !0,
                    s || (l = [Dr(n, "keydown", e[10]), Dr(t, "focusin", e[7]), Dr(t, "focusout", e[8]), Dr(t, "measure", e[9]), $r($c.call(null, t))],
                    s = !0)
                },
                p(e, n) {
                    e[3] ? c ? (c.p(e, n),
                    8 & n[0] && ka(c, 1)) : (c = bh(e),
                    c.c(),
                    ka(c, 1),
                    c.m(i, o)) : c && (Sa(),
                    Ca(c, 1, 1, ( () => {
                        c = null
                    }
                    )),
                    _a()),
                    d && d.p && (!a || 8388608 & n[0]) && hr(d, u, e, e[23], a ? pr(u, e[23], n, null) : mr(e[23]), null),
                    e[2] ? p ? (p.p(e, n),
                    4 & n[0] && ka(p, 1)) : (p = vh(e),
                    p.c(),
                    ka(p, 1),
                    p.m(i, null)) : p && (Sa(),
                    Ca(p, 1, 1, ( () => {
                        p = null
                    }
                    )),
                    _a()),
                    (!a || 16 & n[0]) && Or(t, "data-layout", e[4]),
                    (!a || 64 & n[0]) && Or(t, "style", e[6])
                },
                i(e) {
                    a || (ka(c),
                    ka(d, e),
                    ka(p),
                    a = !0)
                },
                o(e) {
                    Ca(c),
                    Ca(d, e),
                    Ca(p),
                    a = !1
                },
                d(i) {
                    i && Pr(t),
                    c && c.d(),
                    d && d.d(i),
                    p && p.d(),
                    e[25](null),
                    s = !1,
                    nr(l)
                }
            }
        }
        function wh(e, t, i) {
            let o, n, r, a, s, l, c, {$$slots: u={}, $$scope: d} = t, {onconfirm: p} = t, {oncancel: h} = t, {autoFocus: m=!0} = t, {autoPositionCursor: f=!0} = t, {buttonConfirm: g} = t, {buttonCancel: y} = t, {layout: $="stack"} = t, {parentRect: b} = t, {align: v} = t, {justify: x} = t, {parentMargin: w=16} = t, {panelOffset: S=ke()} = t, k = !1, C = "", T = 0;
            const M = () => {
                const e = c.querySelector("input, textarea");
                e.focus(),
                T >= 1 || e.select()
            }
              , P = () => {
                k = !0,
                R || !ki() && !L() || i(19, C = "top:1em;bottom:auto;"),
                ki() && (e => {
                    let t;
                    e.addEventListener("touchstart", (e => t = e.touches[0].screenY)),
                    e.addEventListener("touchmove", (e => {
                        const i = e.touches[0].screenY
                          , o = e.target;
                        /textarea/i.test(o.nodeName) ? (i > t ? 0 == o.scrollTop && e.preventDefault() : i < t ? o.scrollTop + o.offsetHeight == o.scrollHeight && e.preventDefault() : e.preventDefault(),
                        t = i) : e.preventDefault()
                    }
                    ))
                }
                )(c),
                i(20, T = 1)
            }
            ;
            let E;
            const R = (e => {
                if (null === $h && ($h = _() && "visualViewport"in window),
                !$h)
                    return !1;
                const t = visualViewport.height
                  , i = () => {
                    e(visualViewport.height < t ? "visible" : "hidden")
                }
                ;
                return visualViewport.addEventListener("resize", i),
                () => visualViewport.removeEventListener("resize", i)
            }
            )((e => {
                r ? "hidden" !== e || k ? (clearTimeout(l),
                l = void 0,
                i(19, C = `top:${visualViewport.height - s.height - S.y}px`),
                "visible" === e ? (i(5, c.dataset.stick = !0, c),
                M(),
                P()) : (k = !1,
                i(20, T = 0))) : M() : i(19, C = "top: 4.5em; bottom: auto")
            }
            ));
            return Qr(( () => {
                m && M()
            }
            )),
            ea(( () => {
                R && R()
            }
            )),
            e.$$set = e => {
                "onconfirm"in e && i(0, p = e.onconfirm),
                "oncancel"in e && i(1, h = e.oncancel),
                "autoFocus"in e && i(11, m = e.autoFocus),
                "autoPositionCursor"in e && i(12, f = e.autoPositionCursor),
                "buttonConfirm"in e && i(2, g = e.buttonConfirm),
                "buttonCancel"in e && i(3, y = e.buttonCancel),
                "layout"in e && i(4, $ = e.layout),
                "parentRect"in e && i(13, b = e.parentRect),
                "align"in e && i(14, v = e.align),
                "justify"in e && i(15, x = e.justify),
                "parentMargin"in e && i(16, w = e.parentMargin),
                "panelOffset"in e && i(17, S = e.panelOffset),
                "$$scope"in e && i(23, d = e.$$scope)
            }
            ,
            e.$$.update = () => {
                385024 & e.$$.dirty[0] && i(21, o = b && s ? ( (e, t, i, o, n) => {
                    let r, a;
                    return r = "center" === o ? e.x + .5 * e.width - .5 * t.width : "right" === o ? e.x + e.width - t.width - n : e.x + n,
                    a = "center" === i ? e.y + .5 * e.height - .5 * t.height : "bottom" === i ? e.y + e.height - t.height - n : e.y + n,
                    `left:${r}px;top:${a}px;right:auto;bottom:auto;`
                }
                )(b, s, v, x, w) : void 0),
                32 & e.$$.dirty[0] && i(22, n = c && getComputedStyle(c)),
                4194304 & e.$$.dirty[0] && (r = n && "1" === n.getPropertyValue("--editor-modal")),
                3670016 & e.$$.dirty[0] && i(6, a = `opacity:${T};${o || C}`)
            }
            ,
            [p, h, g, y, $, c, a, e => {
                var t, i;
                t = e.target,
                (/textarea/i.test(t) || qu(e.target)) && (E = Date.now(),
                f && ((i = e.target).selectionStart = i.selectionEnd = i.value.length),
                clearTimeout(l),
                l = setTimeout(P, 200))
            }
            , e => {
                Date.now() - E > 50 || (e.stopPropagation(),
                M())
            }
            , ({detail: e}) => {
                i(18, s = {
                    width: e.width,
                    height: e.height
                })
            }
            , e => "Enter" === e.key ? p() : "Escape" === e.key ? h() : void 0, m, f, b, v, x, w, S, s, C, T, o, n, d, u, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    c = e,
                    i(5, c)
                }
                ))
            }
            ]
        }
        class Sh extends Na {
            constructor(e) {
                super(),
                Ba(this, e, wh, xh, ar, {
                    onconfirm: 0,
                    oncancel: 1,
                    autoFocus: 11,
                    autoPositionCursor: 12,
                    buttonConfirm: 2,
                    buttonCancel: 3,
                    layout: 4,
                    parentRect: 13,
                    align: 14,
                    justify: 15,
                    parentMargin: 16,
                    panelOffset: 17
                }, null, [-1, -1])
            }
        }
        var _h = (e, t) => {
            e.fastSeek && e.fastSeek(t),
            e.currentTime = t
        }
        ;
        const kh = ["aspectRatio", "isRotatedSideways", "flip", "cropSize"]
          , Ch = $s.map(( ([e]) => e)).filter((e => !kh.includes(e)));
        var Th = (e, t) => new CustomEvent("ping",{
            detail: {
                type: e,
                data: t
            },
            cancelable: !0,
            bubbles: !0
        })
          , Mh = (e, t) => (t ? gl(e, t) : e).replace(/([a-z])([A-Z])/g, "$1-$2").replace(/\s+/g, "-").toLowerCase()
          , Ph = (e, t=se) => {
            const {subscribe: i, set: o} = ja(void 0)
              , n = ( (e, t) => {
                const i = matchMedia(e);
                return i.addListener(t),
                t(i),
                {
                    get matches() {
                        return i.matches
                    },
                    destroy: () => i.removeListener(t)
                }
            }
            )(e, ( ({matches: e}) => o(t(e))));
            return {
                subscribe: i,
                destroy: n.destroy
            }
        }
          , Eh = (e, t, i) => new Promise(( (o, n) => {
            (async () => {
                Ls(e) && o(await Is(e));
                const r = await t.read(e)
                  , a = e => Y(e, i).then((e => t.apply(e, r))).then(o).catch(n);
                if (U(e) || !j() || si() || ki())
                    return a(e);
                let s;
                try {
                    s = await G(( (e, t) => createImageBitmap(e).then((e => t(null, e))).catch(t)), [e])
                } catch (e) {}
                s && s.width ? await C() ? Bl() && r > 1 ? o(await (async e => T(await z(e)))(s)) : o(s) : o(t.apply(s, r)) : a(e)
            }
            )()
        }
        ))
          , Rh = (e, t) => new Promise((async i => {
            if (e.width < t.width && e.height < t.height)
                return i(e);
            const o = Math.min(t.width / e.width, t.height / e.height)
              , n = o * e.width
              , r = o * e.height
              , a = M("canvas", {
                width: n,
                height: r
            })
              , s = a.getContext("2d", {
                willReadFrequently: !0
            })
              , l = R(e) ? await z(e) : e;
            s.drawImage(l, 0, 0, n, r),
            i(T(a))
        }
        ));
        let Ah = null;
        var Ih = () => {
            if (null === Ah) {
                let e = M("canvas");
                Ah = !!El(e),
                E(e),
                e = void 0
            }
            return Ah
        }
        ;
        const Lh = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
          , Dh = {
            precision: 1e-4
        }
          , zh = {
            precision: .01 * Dh.precision
        };
        var Fh = e => e[0] < .25 && e[1] < .25 && e[2] < .25
          , Oh = (e={}) => new Promise((t => {
            const {accept: i="image/*"} = e
              , o = M("input", {
                style: "position:absolute;visibility:hidden;width:0;height:0;",
                type: "file",
                accept: i
            })
              , n = () => {
                const [e] = o.files;
                o.parentNode && o.remove(),
                o.removeEventListener("change", n),
                t(e)
            }
            ;
            o.addEventListener("change", n),
            ki() && document.body.append(o),
            o.click()
        }
        ))
          , Bh = e => {
            try {
                return e()
            } catch (e) {
                console.error(e)
            }
        }
          , Nh = ([e,t]) => e + .5 * (t - e)
          , Wh = e => Math.round(100 * e)
          , Hh = e => Ce(e.clientX, e.clientY)
          , jh = (e, t, i) => {
            const o = Hh(e);
            return Fe(Fe(o, t), i)
        }
        ;
        function Uh(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, $, b, v, x, w, S, {root: _} = t, {locale: k} = t, {stores: C} = t, {allowPan: T=!0} = t, {allowZoom: M=!0} = t, {enablePan: P=!0} = t, {enableZoom: E=!0} = t, {enableZoomControls: R=E} = t, {enableZoomInput: A=!0} = t, {enablePanInput: I=!0} = t, {enablePanLimit: L=!0} = t, {panLimitGutterScalar: D=0} = t, {zoomOptions: z=[.25, .5, 1, 1.25, 1.5, 2, 3, 4, 6, 8, 16]} = t, {zoomAdjustStep: F=.25} = t, {zoomAdjustFactor: O=.1} = t, {zoomAdjustWheelFactor: B=1} = t, {elasticity: N=5} = t, {imageSelectionRectCentered: W} = t, {imageSelectionRectScalar: H} = t, {zoomLevel: j=null} = t, {zoomControls: U} = t, {zoomMultiTouching: V=!1} = t;
            const {isAnimated: q, isInteracting: G, rootRect: K, stageRect: X, stageScalar: Z, imageSelectionPan: Y, imageSelectionZoom: Q, imageSelectionStageFitScalar: J, imageSelectionRect: ee, imageSelectionStoredState: te, imagePreviewUpscale: ie} = C;
            cr(e, q, (e => i(70, w = e))),
            cr(e, G, (e => i(69, v = e))),
            cr(e, K, (e => i(66, y = e))),
            cr(e, X, (e => i(65, g = e))),
            cr(e, Z, (e => i(46, x = e))),
            cr(e, Y, (e => i(64, h = e))),
            cr(e, Q, (e => i(43, p = e))),
            cr(e, J, (e => i(44, m = e))),
            cr(e, ee, (e => i(67, $ = e))),
            cr(e, te, (e => i(71, S = e))),
            cr(e, ie, (e => i(45, f = e)));
            const oe = oa("fixScrollDirection");
            cr(e, oe, (e => i(68, b = e)));
            let ne, re, ae, se, le = !1;
            const ce = e => {
                const t = _.querySelector(".PinturaMain > .PinturaUtilMain") || _.querySelector('div[tabindex="0"] .PinturaUtilMain');
                return !!t && !!t.contains(e.target) && !Gu(e.target)
            }
              , ue = (e={}) => {
                const {pan: t=h, zoom: i=p} = e;
                yr(te, S = {
                    translation: t,
                    zoom: i
                }, S)
            }
              , de = () => h && 0 === h.x && 0 === h.y
              , pe = () => {
                yr(Q, p = void 0, p),
                de() || yr(Y, h = ke(), h),
                me.set(void 0, {
                    hard: !0
                })
            }
              , he = () => {
                pe(),
                ue()
            }
              , me = ic(void 0, {
                precision: .01
            });
            me.subscribe((e => {
                if (void 0 === e)
                    return yr(Q, p = void 0, p),
                    void (de() || yr(Y, h = ke(), h));
                const t = p;
                e <= 1 ? de() || yr(Y, h = ke(), h) : e <= t && yr(Y, h = Be(h, .8), h),
                yr(Q, p = e, p)
            }
            ));
            const fe = e => {
                me.update((t => {
                    const i = e(t || m);
                    return ue({
                        zoom: i
                    }),
                    i
                }
                ))
            }
              , ge = e => {
                e ? me.set(e, {
                    hard: !1 === w
                }) : (e = void 0,
                me.set(void 0, {
                    hard: !0
                })),
                yr(Q, p = e, p),
                ue({
                    zoom: e
                })
            }
              , ye = (e, t) => {
                const i = H * t
                  , o = {
                    ...W
                }
                  , n = 1 - cs(D, 0, 1);
                wt(o, i < n ? i : n);
                const r = {
                    ...W
                };
                wt(r, i),
                xt(r, e);
                const a = {
                    ...r
                };
                return r.x > o.x && (a.x = o.x),
                r.y > o.y && (a.y = o.y),
                r.x + r.width < o.x + o.width && (a.x = o.x + o.width - r.width),
                r.y + r.height < o.y + o.height && (a.y = o.y + o.height - r.height),
                Fe(vt(a), vt(o))
            }
              , $e = ({translation: e, zoom: t=1, elastify: i=!0}) => {
                if (!ne)
                    return;
                let o = e;
                const n = Ce(ne.x + o.x, ne.y + o.y);
                if (!L)
                    return n;
                const r = ye(n, t);
                return i ? $u(r, n, N) : r
            }
            ;
            let be, ve;
            const xe = () => {
                ve = void 0,
                yr(G, v = !0, v),
                i(34, le = I),
                be = !1,
                ae = !1,
                ne = {
                    ...h
                },
                re = f ? p || m : r ? p || 1 : p || m
            }
              , we = e => {
                const {scalar: t, translation: n, isMultiTouching: r} = e.detail;
                if (!ne || !r && !I)
                    return;
                r && Be(n, .5),
                (I || r) && (be = !0),
                V || i(13, V = r);
                const a = o ? cs(re * t, s, l) : 1
                  , c = $e({
                    translation: n,
                    zoom: a,
                    elastify: !0
                })
                  , u = Re(c);
                se = Re(h),
                ae = u < se,
                o && Q.set(a),
                Y.set(c),
                ve = V && {
                    translation: e.detail.translation,
                    scalar: t
                }
            }
              , Se = e => {
                yr(G, v = !1, v),
                i(34, le = !1),
                i(13, V = !1),
                ae && se < 50 && (ne = void 0,
                re = void 0,
                Y.set(ke()))
            }
              , _e = e => {
                yr(G, v = !1, v),
                i(34, le = !1),
                i(13, V = !1),
                Promise.resolve().then(( () => {
                    if (be && ne) {
                        const t = ve || e.detail
                          , i = o ? cs(re * t.scalar, s, l) : 1
                          , n = $e({
                            elastify: !1,
                            translation: t.translation,
                            zoom: i
                        });
                        Y.set(n)
                    }
                    ne = void 0,
                    re = void 0,
                    I && e.detail.isDoubleTap && he(),
                    ue()
                }
                ))
            }
            ;
            let Te, Pe = Date.now(), Ee = 0, Ae = !1, Ie = !1;
            const Le = e => {
                if (!ce(e))
                    return;
                if (e.preventDefault(),
                e.stopPropagation(),
                Ie)
                    return;
                clearTimeout(Te);
                const t = vu(e, {
                    fixScrollDirection: b
                })
                  , i = Date.now()
                  , o = i - Pe;
                Pe = i;
                const n = Math.abs(t / o) > .2;
                Ee = n ? Ee + 1 : 0;
                const r = 1 + -1 * t * B / (n ? 50 : 100)
                  , a = jh(e, y, g);
                De(a, r, {
                    isZoomingFast: n
                })
            }
              , De = (e, t, {isZoomingFast: i}) => {
                const o = f ? p || m : r ? p || 1 : p || m
                  , n = o * t
                  , a = ke()
                  , c = h
                  , u = f ? m : r ? 1 : m
                  , d = Math.abs(n - u)
                  , g = n < o
                  , y = o > u && g || o < u && n > o
                  , b = Ee >= 5;
                if (i || (Ae = !1),
                Ee > 0 && !Ae && (Ae = y),
                b && Ae)
                    return he(),
                    Ie = !0,
                    void setTimeout(( () => {
                        Ie = !1
                    }
                    ), 100);
                if (b)
                    return;
                !i && y && d <= .05 && (Te = setTimeout(( () => {
                    he()
                }
                ), 250)),
                yr(Q, p = cs(n, s, l), p);
                const v = pt($);
                wt(v, o),
                xt(v, c);
                const x = vt(v)
                  , w = pt(v);
                wt(w, p - o + 1, e);
                const S = vt(w)
                  , _ = Oe(Fe(S, x), o);
                ( (e, t, i) => {
                    e.x = t,
                    e.y = i
                }
                )(a, c.x + _.x, c.y + _.y),
                yr(Y, h = g && i ? Be(Me(h), .85) : ye(a, o), h),
                ue()
            }
              , ze = e => (e ? "add" : "remove") + "EventListener";
            let Ne, We, He, je;
            const Ue = e => {
                e.preventDefault(),
                We = {
                    ...h
                },
                je = pt($),
                He = jh(e, y, g),
                Ne = f ? p || m : r ? p || 1 : p || m
            }
              , Ve = e => {
                e.preventDefault(),
                yr(Q, p = cs(e.scale * Ne, s, l), p);
                const t = pt(je);
                wt(t, Ne),
                xt(t, We);
                const i = vt(t)
                  , o = pt(t);
                wt(o, p - Ne + 1, He);
                const n = vt(o)
                  , r = Oe(Fe(n, i), Ne)
                  , a = {
                    x: We.x + r.x,
                    y: We.y + r.y
                };
                yr(Y, h = ye(a, p), h)
            }
              , qe = e => {
                e.preventDefault()
            }
              , Ge = e => {
                _[ze(e)]("wheel", Le),
                ki() || (_[ze(e)]("gesturestart", Ue),
                _[ze(e)]("gesturechange", Ve),
                _[ze(e)]("gestureend", qe))
            }
              , Ke = e => {
                const t = ze(e);
                _[t]("interactionstart", xe),
                _[t]("interactionupdate", we),
                _[t]("interactionrelease", Se),
                _[t]("interactionend", _e)
            }
            ;
            let Xe;
            return Qr(( () => {
                Xe = mu(_, {
                    drag: !0,
                    pinch: !0,
                    inertia: !0,
                    inertiaDurationMultiplier: 10,
                    shouldStartInteraction: ce
                })
            }
            )),
            ea(( () => {
                Ge(!1),
                Ke(!1),
                Xe.destroy(),
                Xe = void 0
            }
            )),
            e.$$set = e => {
                "root"in e && i(14, _ = e.root),
                "locale"in e && i(15, k = e.locale),
                "stores"in e && i(16, C = e.stores),
                "allowPan"in e && i(17, T = e.allowPan),
                "allowZoom"in e && i(18, M = e.allowZoom),
                "enablePan"in e && i(19, P = e.enablePan),
                "enableZoom"in e && i(20, E = e.enableZoom),
                "enableZoomControls"in e && i(21, R = e.enableZoomControls),
                "enableZoomInput"in e && i(22, A = e.enableZoomInput),
                "enablePanInput"in e && i(23, I = e.enablePanInput),
                "enablePanLimit"in e && i(24, L = e.enablePanLimit),
                "panLimitGutterScalar"in e && i(25, D = e.panLimitGutterScalar),
                "zoomOptions"in e && i(26, z = e.zoomOptions),
                "zoomAdjustStep"in e && i(27, F = e.zoomAdjustStep),
                "zoomAdjustFactor"in e && i(28, O = e.zoomAdjustFactor),
                "zoomAdjustWheelFactor"in e && i(29, B = e.zoomAdjustWheelFactor),
                "elasticity"in e && i(30, N = e.elasticity),
                "imageSelectionRectCentered"in e && i(31, W = e.imageSelectionRectCentered),
                "imageSelectionRectScalar"in e && i(32, H = e.imageSelectionRectScalar),
                "zoomLevel"in e && i(33, j = e.zoomLevel),
                "zoomControls"in e && i(12, U = e.zoomControls),
                "zoomMultiTouching"in e && i(13, V = e.zoomMultiTouching)
            }
            ,
            e.$$.update = () => {
                var t, g;
                5505024 & e.$$.dirty[0] && i(36, o = M && E && A),
                655360 & e.$$.dirty[0] && i(35, n = T && P),
                393216 & e.$$.dirty[0] && (T || M ? (yr(Q, p = E ? S.zoom : void 0, p),
                yr(Y, h = P ? Me(S.translation) : de() ? h : ke(), h),
                me.set(p)) : pe()),
                32768 & e.$$.dirty[1] && (r = x >= 1),
                67141632 & e.$$.dirty[0] | 57344 & e.$$.dirty[1] && i(40, a = [(f || x < 1) && [m, Wh(m) + "%", {
                    sublabel: k.labelZoomFit
                }], ...z.map((e => [e, Wh(e) + "%"]))].filter(Boolean).map((e => (1 === e[0] && (e[2] = {
                    sublabel: k.labelZoomActual
                }),
                e))).sort(( (e, t) => {
                    const i = e[0] || m
                      , o = t[0] || m;
                    return i < o ? -1 : o < i ? 1 : 0
                }
                ))),
                8704 & e.$$.dirty[1] && i(38, s = Math.min(a.reduce(( (e, [t]) => t < e ? t : e), Number.MAX_SAFE_INTEGER), m)),
                512 & e.$$.dirty[1] && i(37, l = a.reduce(( (e, [t]) => t > e ? t : e), Number.MIN_SAFE_INTEGER)),
                4 & e.$$.dirty[1] && null !== j && ge(j),
                61440 & e.$$.dirty[1] && i(42, u = p || (f || x < 1 ? m : 1)),
                2560 & e.$$.dirty[1] && i(39, (t = a.map(( ([e]) => e)),
                g = u,
                c = t.findIndex((e => e === g)))),
                2048 & e.$$.dirty[1] && i(41, d = Wh(u) + "%"),
                405045248 & e.$$.dirty[0] | 6080 & e.$$.dirty[1] && i(12, U = (M || M) && R ? [["Button", "zoom-out", {
                    hideLabel: !0,
                    label: k.labelZoomOut,
                    icon: k.iconZoomOut,
                    disabled: p === s,
                    onclick: () => fe((e => Math.max(s, e - F))),
                    onhold: () => fe((e => Math.max(s, e * (1 - O))))
                }], ["Dropdown", "zoom-level", {
                    label: d,
                    labelClass: "PinturaFixedWidthCharacters",
                    options: a,
                    selectedIndex: c,
                    onchange: e => ge(e.value)
                }], ["Button", "zoom-in", {
                    hideLabel: !0,
                    label: k.labelZoomIn,
                    icon: k.iconZoomIn,
                    disabled: p === l,
                    onclick: () => fe((e => Math.min(l, e + F))),
                    onhold: () => fe((e => Math.min(l, e * (1 + O))))
                }]] : []),
                16384 & e.$$.dirty[0] | 32 & e.$$.dirty[1] && _ && Ge(o),
                16384 & e.$$.dirty[0] | 16 & e.$$.dirty[1] && _ && Ke(n),
                8404992 & e.$$.dirty[0] | 24 & e.$$.dirty[1] && _ && _.style.setProperty("--cursor", n && I ? le ? "grabbing" : "grab" : "")
            }
            ,
            [q, G, K, X, Z, Y, Q, J, ee, te, ie, oe, U, V, _, k, C, T, M, P, E, R, A, I, L, D, z, F, O, B, N, W, H, j, le, n, o, l, s, c, a, d, u, p, m, f, x]
        }
        class Vh extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Uh, null, ar, {
                    root: 14,
                    locale: 15,
                    stores: 16,
                    allowPan: 17,
                    allowZoom: 18,
                    enablePan: 19,
                    enableZoom: 20,
                    enableZoomControls: 21,
                    enableZoomInput: 22,
                    enablePanInput: 23,
                    enablePanLimit: 24,
                    panLimitGutterScalar: 25,
                    zoomOptions: 26,
                    zoomAdjustStep: 27,
                    zoomAdjustFactor: 28,
                    zoomAdjustWheelFactor: 29,
                    elasticity: 30,
                    imageSelectionRectCentered: 31,
                    imageSelectionRectScalar: 32,
                    zoomLevel: 33,
                    zoomControls: 12,
                    zoomMultiTouching: 13
                }, null, [-1, -1, -1, -1])
            }
        }
        const {window: qh} = Pa;
        function Gh(e) {
            let t, i, o, n = e[41] && Kh(e), r = e[38] && om(e);
            return {
                c() {
                    n && n.c(),
                    t = Ir(),
                    r && r.c(),
                    i = Lr()
                },
                m(e, a) {
                    n && n.m(e, a),
                    Mr(e, t, a),
                    r && r.m(e, a),
                    Mr(e, i, a),
                    o = !0
                },
                p(e, o) {
                    e[41] ? n ? (n.p(e, o),
                    1024 & o[1] && ka(n, 1)) : (n = Kh(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[38] ? r ? (r.p(e, o),
                    128 & o[1] && ka(r, 1)) : (r = om(e),
                    r.c(),
                    ka(r, 1),
                    r.m(i.parentNode, i)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    o || (ka(n),
                    ka(r),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(r),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    r && r.d(e),
                    e && Pr(i)
                }
            }
        }
        function Kh(e) {
            let t, i, o, n, r, a;
            const s = [Zh, Xh]
              , l = [];
            function c(e, t) {
                return e[39] ? 0 : e[35] ? 1 : -1
            }
            return ~(o = c(e)) && (n = l[o] = s[o](e)),
            {
                c() {
                    t = Er("div"),
                    i = Er("p"),
                    n && n.c(),
                    Or(i, "style", e[72]),
                    Or(t, "class", "PinturaStatus"),
                    Or(t, "style", r = `opacity: ${e[54]}`)
                },
                m(e, n) {
                    Mr(e, t, n),
                    kr(t, i),
                    ~o && l[o].m(i, null),
                    a = !0
                },
                p(e, u) {
                    let d = o;
                    o = c(e),
                    o === d ? ~o && l[o].p(e, u) : (n && (Sa(),
                    Ca(l[d], 1, 1, ( () => {
                        l[d] = null
                    }
                    )),
                    _a()),
                    ~o ? (n = l[o],
                    n ? n.p(e, u) : (n = l[o] = s[o](e),
                    n.c()),
                    ka(n, 1),
                    n.m(i, null)) : n = null),
                    (!a || 1024 & u[2]) && Or(i, "style", e[72]),
                    (!a || 8388608 & u[1] && r !== (r = `opacity: ${e[54]}`)) && Or(t, "style", r)
                },
                i(e) {
                    a || (ka(n),
                    a = !0)
                },
                o(e) {
                    Ca(n),
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    ~o && l[o].d()
                }
            }
        }
        function Xh(e) {
            let t, i, o, n;
            t = new Cu({
                props: {
                    text: e[35].text || "",
                    onmeasure: e[221]
                }
            });
            let r = e[35].aside && Yh(e);
            return {
                c() {
                    za(t.$$.fragment),
                    i = Ir(),
                    r && r.c(),
                    o = Lr()
                },
                m(e, a) {
                    Fa(t, e, a),
                    Mr(e, i, a),
                    r && r.m(e, a),
                    Mr(e, o, a),
                    n = !0
                },
                p(e, i) {
                    const n = {};
                    16 & i[1] && (n.text = e[35].text || ""),
                    t.$set(n),
                    e[35].aside ? r ? (r.p(e, i),
                    16 & i[1] && ka(r, 1)) : (r = Yh(e),
                    r.c(),
                    ka(r, 1),
                    r.m(o.parentNode, o)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    n || (ka(t.$$.fragment, e),
                    ka(r),
                    n = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    Ca(r),
                    n = !1
                },
                d(e) {
                    Oa(t, e),
                    e && Pr(i),
                    r && r.d(e),
                    e && Pr(o)
                }
            }
        }
        function Zh(e) {
            let t, i, o, n;
            return t = new Cu({
                props: {
                    text: e[39],
                    onmeasure: e[221]
                }
            }),
            o = new Au({
                props: {
                    class: "PinturaStatusIcon",
                    offset: e[82],
                    opacity: e[83],
                    $$slots: {
                        default: [im]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment),
                    i = Ir(),
                    za(o.$$.fragment)
                },
                m(e, r) {
                    Fa(t, e, r),
                    Mr(e, i, r),
                    Fa(o, e, r),
                    n = !0
                },
                p(e, i) {
                    const n = {};
                    256 & i[1] && (n.text = e[39]),
                    t.$set(n);
                    const r = {};
                    1048576 & i[2] && (r.offset = e[82]),
                    2097152 & i[2] && (r.opacity = e[83]),
                    8 & i[0] | 32768 & i[19] && (r.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    o.$set(r)
                },
                i(e) {
                    n || (ka(t.$$.fragment, e),
                    ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    Oa(t, e),
                    e && Pr(i),
                    Oa(o, e)
                }
            }
        }
        function Yh(e) {
            let t, i;
            return t = new Au({
                props: {
                    class: "PinturaStatusButton",
                    offset: e[82],
                    opacity: e[83],
                    $$slots: {
                        default: [em]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1048576 & i[2] && (o.offset = e[82]),
                    2097152 & i[2] && (o.opacity = e[83]),
                    16 & i[1] | 32768 & i[19] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Qh(e) {
            let t, i;
            return t = new Pu({
                props: {
                    progress: e[35].progressIndicator.progress
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[1] && (o.progress = e[35].progressIndicator.progress),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Jh(e) {
            let t, i;
            const o = [e[35].closeButton, {
                hideLabel: !0
            }];
            let n = {};
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new du({
                props: n
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 16 & i[1] ? Ia(o, [La(e[35].closeButton), o[1]]) : {};
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function em(e) {
            let t, i, o, n = e[35].progressIndicator.visible && Qh(e), r = e[35].closeButton && e[35].text && Jh(e);
            return {
                c() {
                    n && n.c(),
                    t = Ir(),
                    r && r.c(),
                    i = Lr()
                },
                m(e, a) {
                    n && n.m(e, a),
                    Mr(e, t, a),
                    r && r.m(e, a),
                    Mr(e, i, a),
                    o = !0
                },
                p(e, o) {
                    e[35].progressIndicator.visible ? n ? (n.p(e, o),
                    16 & o[1] && ka(n, 1)) : (n = Qh(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[35].closeButton && e[35].text ? r ? (r.p(e, o),
                    16 & o[1] && ka(r, 1)) : (r = Jh(e),
                    r.c(),
                    ka(r, 1),
                    r.m(i.parentNode, i)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    o || (ka(n),
                    ka(r),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(r),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    r && r.d(e),
                    e && Pr(i)
                }
            }
        }
        function tm(e) {
            let t, i = e[3].iconSupportError + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    8 & o[0] && i !== (i = e[3].iconSupportError + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function im(e) {
            let t, i;
            return t = new ou({
                props: {
                    $$slots: {
                        default: [tm]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8 & i[0] | 32768 & i[19] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function om(e) {
            let t, i, o, n, r, a, s, l, c, u, d, p, h, m, f = e[10] && nm(e), g = e[46] && e[45] && rm(e);
            const y = [pm, dm]
              , $ = [];
            function b(e, t) {
                return e[46] ? 0 : 1
            }
            function v(t) {
                e[439](t)
            }
            function x(t) {
                e[440](t)
            }
            function w(t) {
                e[441](t)
            }
            o = b(e),
            n = $[o] = y[o](e),
            a = new Mc({
                props: {
                    isAnimated: e[53],
                    isTransparent: e[20],
                    pixelRatio: e[57],
                    textPixelRatio: e[6],
                    backgroundColor: e[56],
                    maskRect: e[58],
                    maskOpacity: e[73] ? e[73].maskOpacity : 1,
                    maskMarkupOpacity: e[7],
                    maskFrameOpacity: e[5],
                    clipAnnotationsToImage: e[85],
                    images: e[55],
                    interfaceImages: e[86],
                    loadImageData: e[28],
                    enableGrid: e[11],
                    gridSize: e[87],
                    gridColors: [e[88], e[89]],
                    gridOpacity: e[90],
                    selectionColor: e[91],
                    csp: e[92] || {},
                    willRequest: e[81] || e[93],
                    willRender: e[436],
                    didRender: e[437]
                }
            });
            let S = {
                root: e[2],
                locale: e[3],
                stores: e[202],
                allowPan: e[95],
                enablePan: e[17],
                enablePanLimit: e[21],
                panLimitGutterScalar: e[22],
                enablePanInput: e[96],
                allowZoom: e[97],
                enableZoom: e[18],
                enableZoomInput: void 0 !== e[19] ? e[19] : e[98],
                enableZoomControls: e[99],
                zoomOptions: e[13] || e[23],
                zoomAdjustStep: e[14] || e[24],
                zoomAdjustFactor: e[15] || e[25],
                zoomAdjustWheelFactor: e[16] || e[26],
                imageSelectionRectCentered: e[100],
                imageSelectionRectScalar: e[101],
                elasticity: $m * e[8]
            };
            return void 0 !== e[0] && (S.zoomLevel = e[0]),
            void 0 !== e[33] && (S.zoomControls = e[33]),
            void 0 !== e[34] && (S.zoomMultiTouching = e[34]),
            u = new Vh({
                props: S
            }),
            aa.push(( () => Da(u, "zoomLevel", v))),
            aa.push(( () => Da(u, "zoomControls", x))),
            aa.push(( () => Da(u, "zoomMultiTouching", w))),
            {
                c() {
                    f && f.c(),
                    t = Ir(),
                    g && g.c(),
                    i = Ir(),
                    n.c(),
                    r = Ir(),
                    za(a.$$.fragment),
                    s = Ir(),
                    l = Er("div"),
                    c = Ir(),
                    za(u.$$.fragment),
                    Or(l, "class", "PinturaRootPortal")
                },
                m(n, d) {
                    f && f.m(n, d),
                    Mr(n, t, d),
                    g && g.m(n, d),
                    Mr(n, i, d),
                    $[o].m(n, d),
                    Mr(n, r, d),
                    Fa(a, n, d),
                    Mr(n, s, d),
                    Mr(n, l, d),
                    e[438](l),
                    Mr(n, c, d),
                    Fa(u, n, d),
                    m = !0
                },
                p(e, s) {
                    e[10] ? f ? (f.p(e, s),
                    1024 & s[0] && ka(f, 1)) : (f = nm(e),
                    f.c(),
                    ka(f, 1),
                    f.m(t.parentNode, t)) : f && (Sa(),
                    Ca(f, 1, 1, ( () => {
                        f = null
                    }
                    )),
                    _a()),
                    e[46] && e[45] ? g ? (g.p(e, s),
                    49152 & s[1] && ka(g, 1)) : (g = rm(e),
                    g.c(),
                    ka(g, 1),
                    g.m(i.parentNode, i)) : g && (Sa(),
                    Ca(g, 1, 1, ( () => {
                        g = null
                    }
                    )),
                    _a());
                    let l = o;
                    o = b(e),
                    o === l ? $[o].p(e, s) : (Sa(),
                    Ca($[l], 1, 1, ( () => {
                        $[l] = null
                    }
                    )),
                    _a(),
                    n = $[o],
                    n ? n.p(e, s) : (n = $[o] = y[o](e),
                    n.c()),
                    ka(n, 1),
                    n.m(r.parentNode, r));
                    const c = {};
                    4194304 & s[1] && (c.isAnimated = e[53]),
                    1048576 & s[0] && (c.isTransparent = e[20]),
                    67108864 & s[1] && (c.pixelRatio = e[57]),
                    64 & s[0] && (c.textPixelRatio = e[6]),
                    33554432 & s[1] && (c.backgroundColor = e[56]),
                    134217728 & s[1] && (c.maskRect = e[58]),
                    2048 & s[2] && (c.maskOpacity = e[73] ? e[73].maskOpacity : 1),
                    128 & s[0] && (c.maskMarkupOpacity = e[7]),
                    32 & s[0] && (c.maskFrameOpacity = e[5]),
                    8388608 & s[2] && (c.clipAnnotationsToImage = e[85]),
                    16777216 & s[1] && (c.images = e[55]),
                    16777216 & s[2] && (c.interfaceImages = e[86]),
                    268435456 & s[0] && (c.loadImageData = e[28]),
                    2048 & s[0] && (c.enableGrid = e[11]),
                    33554432 & s[2] && (c.gridSize = e[87]),
                    201326592 & s[2] && (c.gridColors = [e[88], e[89]]),
                    268435456 & s[2] && (c.gridOpacity = e[90]),
                    536870912 & s[2] && (c.selectionColor = e[91]),
                    1073741824 & s[2] && (c.csp = e[92] || {}),
                    524288 & s[2] | 1 & s[3] && (c.willRequest = e[81] || e[93]),
                    512 & s[0] | 270991424 & s[1] | 2 & s[3] && (c.willRender = e[436]),
                    62 & s[2] && (c.didRender = e[437]),
                    a.$set(c);
                    const m = {};
                    4 & s[0] && (m.root = e[2]),
                    8 & s[0] && (m.locale = e[3]),
                    4 & s[3] && (m.allowPan = e[95]),
                    131072 & s[0] && (m.enablePan = e[17]),
                    2097152 & s[0] && (m.enablePanLimit = e[21]),
                    4194304 & s[0] && (m.panLimitGutterScalar = e[22]),
                    8 & s[3] && (m.enablePanInput = e[96]),
                    16 & s[3] && (m.allowZoom = e[97]),
                    262144 & s[0] && (m.enableZoom = e[18]),
                    524288 & s[0] | 32 & s[3] && (m.enableZoomInput = void 0 !== e[19] ? e[19] : e[98]),
                    64 & s[3] && (m.enableZoomControls = e[99]),
                    8396800 & s[0] && (m.zoomOptions = e[13] || e[23]),
                    16793600 & s[0] && (m.zoomAdjustStep = e[14] || e[24]),
                    33587200 & s[0] && (m.zoomAdjustFactor = e[15] || e[25]),
                    67174400 & s[0] && (m.zoomAdjustWheelFactor = e[16] || e[26]),
                    128 & s[3] && (m.imageSelectionRectCentered = e[100]),
                    256 & s[3] && (m.imageSelectionRectScalar = e[101]),
                    256 & s[0] && (m.elasticity = $m * e[8]),
                    !d && 1 & s[0] && (d = !0,
                    m.zoomLevel = e[0],
                    ma(( () => d = !1))),
                    !p && 4 & s[1] && (p = !0,
                    m.zoomControls = e[33],
                    ma(( () => p = !1))),
                    !h && 8 & s[1] && (h = !0,
                    m.zoomMultiTouching = e[34],
                    ma(( () => h = !1))),
                    u.$set(m)
                },
                i(e) {
                    m || (ka(f),
                    ka(g),
                    ka(n),
                    ka(a.$$.fragment, e),
                    ka(u.$$.fragment, e),
                    m = !0)
                },
                o(e) {
                    Ca(f),
                    Ca(g),
                    Ca(n),
                    Ca(a.$$.fragment, e),
                    Ca(u.$$.fragment, e),
                    m = !1
                },
                d(n) {
                    f && f.d(n),
                    n && Pr(t),
                    g && g.d(n),
                    n && Pr(i),
                    $[o].d(n),
                    n && Pr(r),
                    Oa(a, n),
                    n && Pr(s),
                    n && Pr(l),
                    e[438](null),
                    n && Pr(c),
                    Oa(u, n)
                }
            }
        }
        function nm(e) {
            let t, i, o, n, r;
            return i = new yh({
                props: {
                    items: e[69]
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaNav PinturaNavTools")
                },
                m(a, s) {
                    Mr(a, t, s),
                    Fa(i, t, null),
                    o = !0,
                    n || (r = [Dr(t, "measure", e[425]), $r($c.call(null, t))],
                    n = !0)
                },
                p(e, t) {
                    const o = {};
                    128 & t[2] && (o.items = e[69]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    n = !1,
                    nr(r)
                }
            }
        }
        function rm(e) {
            let t, i, o;
            return i = new Su({
                props: {
                    elasticity: e[8] * vm,
                    scrollDirection: e[76] ? "y" : "x",
                    $$slots: {
                        default: [um]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaNav PinturaNavMain")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    256 & t[0] && (o.elasticity = e[8] * vm),
                    16384 & t[2] && (o.scrollDirection = e[76] ? "y" : "x"),
                    12288 & t[1] | 135168 & t[2] | 32768 & t[19] && (o.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function am(e) {
            let t, i;
            const o = [e[79], {
                tabs: e[44]
            }];
            let n = {
                $$slots: {
                    default: [cm, ({tab: e}) => ({
                        603: e
                    }), ({tab: e}) => [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, e ? 16384 : 0]]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new Fc({
                props: n
            }),
            t.$on("select", e[426]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 8192 & i[1] | 131072 & i[2] ? Ia(o, [131072 & i[2] && La(e[79]), 8192 & i[1] && {
                        tabs: e[44]
                    }]) : {};
                    49152 & i[19] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function sm(e) {
            let t, i;
            return t = new yh({
                props: {
                    items: e[44]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8192 & i[1] && (o.items = e[44]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function lm(e) {
            let t, i = e[603].icon + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    16384 & o[19] && i !== (i = e[603].icon + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function cm(e) {
            let t, i, o, n, r, a = e[603].label + "";
            return t = new ou({
                props: {
                    $$slots: {
                        default: [lm]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment),
                    i = Ir(),
                    o = Er("span"),
                    n = Ar(a)
                },
                m(e, a) {
                    Fa(t, e, a),
                    Mr(e, i, a),
                    Mr(e, o, a),
                    kr(o, n),
                    r = !0
                },
                p(e, i) {
                    const o = {};
                    49152 & i[19] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o),
                    (!r || 16384 & i[19]) && a !== (a = e[603].label + "") && Wr(n, a)
                },
                i(e) {
                    r || (ka(t.$$.fragment, e),
                    r = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    r = !1
                },
                d(e) {
                    Oa(t, e),
                    e && Pr(i),
                    e && Pr(o)
                }
            }
        }
        function um(e) {
            let t, i, o, n;
            const r = [sm, am]
              , a = [];
            function s(e, t) {
                return e[74] ? 0 : 1
            }
            return t = s(e),
            i = a[t] = r[t](e),
            {
                c() {
                    i.c(),
                    o = Lr()
                },
                m(e, i) {
                    a[t].m(e, i),
                    Mr(e, o, i),
                    n = !0
                },
                p(e, n) {
                    let l = t;
                    t = s(e),
                    t === l ? a[t].p(e, n) : (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a(),
                    i = a[t],
                    i ? i.p(e, n) : (i = a[t] = r[t](e),
                    i.c()),
                    ka(i, 1),
                    i.m(o.parentNode, o))
                },
                i(e) {
                    n || (ka(i),
                    n = !0)
                },
                o(e) {
                    Ca(i),
                    n = !1
                },
                d(e) {
                    a[t].d(e),
                    e && Pr(o)
                }
            }
        }
        function dm(e) {
            let t, i, o;
            function n(t) {
                e[432](t)
            }
            let r = {
                locale: e[3],
                class: "PinturaMain",
                view: e[207](e[43]),
                props: e[206](e[43], e[27]),
                stores: e[202]
            };
            return void 0 !== e[1][e[43]] && (r.component = e[1][e[43]]),
            t = new eu({
                props: r
            }),
            aa.push(( () => Da(t, "component", n))),
            t.$on("measure", e[233]),
            t.$on("show", e[433]),
            t.$on("hide", e[434]),
            t.$on("fade", e[435]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(e, o) {
                    const n = {};
                    8 & o[0] && (n.locale = e[3]),
                    4096 & o[1] && (n.view = e[207](e[43])),
                    134217728 & o[0] | 4096 & o[1] && (n.props = e[206](e[43], e[27])),
                    !i && 2 & o[0] | 4096 & o[1] && (i = !0,
                    n.component = e[1][e[43]],
                    ma(( () => i = !1))),
                    t.$set(n)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function pm(e) {
            let t, i;
            const o = [{
                class: "PinturaMain"
            }, {
                visible: e[62]
            }, e[79], {
                panels: e[78]
            }];
            let n = {
                $$slots: {
                    default: [hm, ({panel: e, panelIsActive: t}) => ({
                        601: e,
                        602: t
                    }), ({panel: e, panelIsActive: t}) => [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, (e ? 4096 : 0) | (t ? 8192 : 0)]]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new Xc({
                props: n
            }),
            t.$on("measure", e[431]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 196609 & i[2] ? Ia(o, [o[0], 1 & i[2] && {
                        visible: e[62]
                    }, 131072 & i[2] && La(e[79]), 65536 & i[2] && {
                        panels: e[78]
                    }]) : {};
                    134217738 & i[0] | 45056 & i[19] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function hm(e) {
            let t, i, o;
            function n(t) {
                e[427](t, e[601])
            }
            let r = {
                locale: e[3],
                view: e[207](e[601]),
                props: e[206](e[601], e[27]),
                isActive: e[602],
                stores: e[202]
            };
            return void 0 !== e[1][e[601]] && (r.component = e[1][e[601]]),
            t = new eu({
                props: r
            }),
            aa.push(( () => Da(t, "component", n))),
            t.$on("measure", e[233]),
            t.$on("show", (function() {
                return e[428](e[601])
            }
            )),
            t.$on("hide", (function() {
                return e[429](e[601])
            }
            )),
            t.$on("fade", (function(...t) {
                return e[430](e[601], ...t)
            }
            )),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(o, n) {
                    e = o;
                    const r = {};
                    8 & n[0] && (r.locale = e[3]),
                    4096 & n[19] && (r.view = e[207](e[601])),
                    134217728 & n[0] | 4096 & n[19] && (r.props = e[206](e[601], e[27])),
                    8192 & n[19] && (r.isActive = e[602]),
                    !i && 2 & n[0] | 4096 & n[19] && (i = !0,
                    r.component = e[1][e[601]],
                    ma(( () => i = !1))),
                    t.$set(r)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function mm(e) {
            let t, i;
            return {
                c() {
                    t = Er("span"),
                    Or(t, "class", "PinturaEditorOverlay"),
                    Or(t, "style", i = `opacity:${e[102]}`)
                },
                m(e, i) {
                    Mr(e, t, i)
                },
                p(e, o) {
                    512 & o[3] && i !== (i = `opacity:${e[102]}`) && Or(t, "style", i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function fm(e) {
            let t, i;
            const o = [{
                layout: "row"
            }, {
                parentRect: e[50]
            }, e[60]];
            let n = {
                $$slots: {
                    default: [gm]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new Sh({
                props: n
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 537395200 & i[1] ? Ia(o, [o[0], 524288 & i[1] && {
                        parentRect: e[50]
                    }, 536870912 & i[1] && La(e[60])]) : {};
                    1610612736 & i[1] | 32768 & i[19] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function gm(e) {
            let t, i, o;
            return {
                c() {
                    t = Er("input"),
                    t.value = i = e[60].text,
                    Or(t, "placeholder", o = e[60].placeholder),
                    Or(t, "type", "text"),
                    Or(t, "spellcheck", "false"),
                    Or(t, "autocorrect", "off"),
                    Or(t, "autocapitalize", "off")
                },
                m(i, o) {
                    Mr(i, t, o),
                    e[442](t)
                },
                p(e, n) {
                    536870912 & n[1] && i !== (i = e[60].text) && t.value !== i && (t.value = i),
                    536870912 & n[1] && o !== (o = e[60].placeholder) && Or(t, "placeholder", o)
                },
                d(i) {
                    i && Pr(t),
                    e[442](null)
                }
            }
        }
        function ym(e) {
            let t, i, o, n, r, a;
            ha(e[424]);
            let s = e[40] && Gh(e)
              , l = e[102] > 0 && mm(e)
              , c = e[60] && fm(e);
            return {
                c() {
                    t = Er("div"),
                    s && s.c(),
                    i = Ir(),
                    l && l.c(),
                    o = Ir(),
                    c && c.c(),
                    Or(t, "id", e[4]),
                    Or(t, "class", e[77]),
                    Or(t, "data-env", e[75]),
                    Or(t, "dir", e[12])
                },
                m(u, d) {
                    Mr(u, t, d),
                    s && s.m(t, null),
                    kr(t, i),
                    l && l.m(t, null),
                    kr(t, o),
                    c && c.m(t, null),
                    e[443](t),
                    n = !0,
                    r || (a = [Dr(qh, "keydown", e[224]), Dr(qh, "keyup", e[225]), Dr(qh, "blur", e[226]), Dr(qh, "paste", e[230]), Dr(qh, "resize", e[424]), Dr(t, "ping", (function() {
                        rr(e[68]) && e[68].apply(this, arguments)
                    }
                    )), Dr(t, "contextmenu", e[227]), Dr(t, "touchstart", e[222], {
                        passive: !1
                    }), Dr(t, "touchmove", (function() {
                        rr(e[71]) && e[71].apply(this, arguments)
                    }
                    )), Dr(t, "pointermove", (function() {
                        rr(e[70]) && e[70].apply(this, arguments)
                    }
                    )), Dr(t, "transitionend", e[212]), Dr(t, "dropfiles", e[228]), Dr(t, "measure", e[444]), Dr(t, "click", (function() {
                        rr(e[42] ? e[229] : $) && (e[42] ? e[229] : $).apply(this, arguments)
                    }
                    )), $r($c.call(null, t, {
                        observeViewRect: !0,
                        isMeasureRoot: !0
                    })), $r(bc.call(null, t)), $r(xc.call(null, t))],
                    r = !0)
                },
                p(r, a) {
                    (e = r)[40] ? s ? (s.p(e, a),
                    512 & a[1] && ka(s, 1)) : (s = Gh(e),
                    s.c(),
                    ka(s, 1),
                    s.m(t, i)) : s && (Sa(),
                    Ca(s, 1, 1, ( () => {
                        s = null
                    }
                    )),
                    _a()),
                    e[102] > 0 ? l ? l.p(e, a) : (l = mm(e),
                    l.c(),
                    l.m(t, o)) : l && (l.d(1),
                    l = null),
                    e[60] ? c ? (c.p(e, a),
                    536870912 & a[1] && ka(c, 1)) : (c = fm(e),
                    c.c(),
                    ka(c, 1),
                    c.m(t, null)) : c && (Sa(),
                    Ca(c, 1, 1, ( () => {
                        c = null
                    }
                    )),
                    _a()),
                    (!n || 16 & a[0]) && Or(t, "id", e[4]),
                    (!n || 32768 & a[2]) && Or(t, "class", e[77]),
                    (!n || 8192 & a[2]) && Or(t, "data-env", e[75]),
                    (!n || 4096 & a[0]) && Or(t, "dir", e[12])
                },
                i(e) {
                    n || (ka(s),
                    ka(c),
                    n = !0)
                },
                o(e) {
                    Ca(s),
                    Ca(c),
                    n = !1
                },
                d(i) {
                    i && Pr(t),
                    s && s.d(),
                    l && l.d(),
                    c && c.d(),
                    e[443](null),
                    r = !1,
                    nr(a)
                }
            }
        }
        const $m = 1
          , bm = "stage-overlay"
          , vm = 10;
        function xm(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, b, v, x, w, S, _, k, C, M, P, R, A, I, z, F, O, B, N, H, j, U, q, G, K, Z, Y, Q, J, ee, te, ie, oe, ne, re, ae, le, ce, ue, de, pe, he, me, fe, ge, ye, $e, be, ve, xe, Se, _e, Te, Ee, Re, Ae, Ie, Le, Oe, Be, Ne, We, He, je, Ue, Ve, qe, Ge, Ke, Xe, Ze, Ye, Qe, Je, tt, it, ot, nt, rt, at, st, lt, ct, ut, dt, ft, yt, $t, St, _t, Mt, Pt, At, It, zt, Ot, Nt, Wt, Ht, jt, Ut, Vt, qt, Gt, Kt, Xt, Zt, Yt, ei, ti, ii, oi, ni, ri, ai, li, ci, ui, di, pi, hi, mi, fi, gi, yi, $i, vi, xi, wi, Si, _i, Ci, Ti, Mi, Pi, Ei, Ri, Ai, Ii, Li, Di, zi, Fi, Oi, Bi, Ni, Hi, ji, Ui, Vi, qi, Gi, Ki, Xi, Yi, Qi, Ji, eo, to, io, no, ro, ao, so, lo, co, uo, po, ho, mo, fo, go, yo, $o, bo, vo, xo, wo, _o, ko, Co, To, Mo, Po, Ao, Io, Lo, zo, Fo, Bo, No, Ho, jo, Uo, Vo, qo, Go, Ko, Xo, Zo, Yo = Jn, Qo = Jn;
            cr(e, oc, (e => i(412, no = e))),
            e.$$.on_destroy.push(( () => Yo())),
            e.$$.on_destroy.push(( () => Qo()));
            const Jo = oo()
              , en = ta();
            let {class: tn} = t
              , {layout: on} = t
              , {stores: nn} = t
              , {locale: rn} = t
              , {id: an} = t
              , {util: sn} = t
              , {utils: ln} = t
              , {animations: cn="auto"} = t
              , {disabled: un=!1} = t
              , {status: dn} = t
              , {previewUpscale: pn=!1} = t
              , {previewPad: hn=!1} = t
              , {previewMaskOpacity: mn=.95} = t
              , {previewImageDataMaxSize: fn} = t
              , {previewImageTextPixelRatio: gn} = t
              , {markupMaskOpacity: yn=1} = t
              , {zoomMaskOpacity: $n=.85} = t
              , {elasticityMultiplier: bn=10} = t
              , {willRevert: vn=( () => Promise.resolve(!0))} = t
              , {willProcessImage: wn=( () => Promise.resolve(!0))} = t
              , {willRenderCanvas: Sn=se} = t
              , {willRenderToolbar: _n=se} = t
              , {willRenderUtilTabs: kn=se} = t
              , {willSetHistoryInitialState: Mn=se} = t
              , {enableButtonExport: Pn=!0} = t
              , {enableButtonRevert: En=!0} = t
              , {enableNavigateHistory: An=!0} = t
              , {enableToolbar: In=!0} = t
              , {enableUtils: Ln=!0} = t
              , {enableButtonClose: Dn=!1} = t
              , {enableDropImage: zn=!1} = t
              , {enablePasteImage: Fn=!1} = t
              , {enableBrowseImage: On=!1} = t
              , {enableTransparencyGrid: Bn=!1} = t
              , {layoutDirectionPreference: Nn="auto"} = t
              , {layoutHorizontalUtilsPreference: Wn="left"} = t
              , {layoutVerticalUtilsPreference: Hn="bottom"} = t
              , {layoutVerticalToolbarPreference: jn="top"} = t
              , {layoutVerticalControlGroupsPreference: Un="bottom"} = t
              , {layoutVerticalControlTabsPreference: Vn="bottom"} = t
              , {textDirection: qn} = t
              , {markupEditorZoomLevel: Gn=null} = t
              , {markupEditorZoomLevels: Kn} = t
              , {markupEditorZoomAdjustStep: Xn} = t
              , {markupEditorZoomAdjustFactor: Zn} = t
              , {markupEditorZoomAdjustWheelFactor: er} = t
              , {markupEditorInteractionMode: tr=!1} = t
              , {muteAudio: ir=!0} = t
              , {willSetMediaInitialTimeOffset: or=( (e, t) => e * Nh(t[0]))} = t
              , {enablePan: nr=!0} = t
              , {enableZoom: rr=!0} = t
              , {enableZoomControls: ar=!0} = t
              , {enableZoomInput: ur} = t
              , {enablePanInput: dr} = t
              , {enableCanvasAlpha: pr=!1} = t
              , {enablePanLimit: hr} = t
              , {panLimitGutterScalar: mr} = t
              , {pan: fr=null} = t
              , {zoomPresetOptions: gr=[.25, .5, 1, 1.25, 1.5, 2, 3, 4, 6, 8, 16]} = t
              , {zoomAdjustStep: $r=.25} = t
              , {zoomAdjustFactor: br=.1} = t
              , {zoomAdjustWheelFactor: vr=1} = t
              , {zoomLevel: xr=null} = t
              , {fixScrollDirection: wr=!1} = t;
            const Sr = ja(wr);
            let _r, kr;
            ia("fixScrollDirection", Sr);
            let {imagePreviewSrc: Cr} = t
              , {imageOrienter: Tr={
                read: () => 1,
                apply: e => e
            }} = t
              , {pluginComponents: Mr} = t
              , {pluginOptions: Pr={}} = t;
            const Er = Jo.sub
              , Rr = {};
            let {root: Ar} = t;
            const Ir = () => {
                yt.setAttribute("data-redraw", "true"),
                na.set({})
            }
              , Lr = ja(!0);
            cr(e, Lr, (e => i(477, Zt = e)));
            const Dr = ja(void 0);
            cr(e, Dr, (e => i(422, wo = e)));
            const zr = ja(0);
            cr(e, zr, (e => i(419, bo = e)));
            const Fr = ja(!1)
              , Or = e => {
                Fr.set("play" === e.type),
                Jo.pub(e.type)
            }
            ;
            let Br, Nr, Wr, Hr, jr = !1;
            const Ur = () => {
                if (!r || !qr())
                    return;
                Hr = d,
                yr(Dr, wo = void 0, wo);
                const e = yt;
                jr = !1;
                const t = 1 / 24
                  , i = Qr();
                (Math.abs(c * i - bo * i) <= t || i - i * bo <= t) && yr(zr, bo = l, bo),
                oa(bo * Qr()),
                e.play().catch(( () => {}
                ));
                let o = Jr();
                const n = () => {
                    if (qr())
                        return;
                    Wr = requestAnimationFrame(n);
                    let e = Jr();
                    e - o <= 0 && (e = o + .01),
                    o = e,
                    yr(zr, bo = e / Qr(), bo),
                    Hr >= 0 && bo >= c && (yr(zr, bo = c, bo),
                    Vr()),
                    d > -1 && (jr = !0),
                    jr && -1 === d && p > 0 && (yr(zr, bo = s[p][0], bo),
                    oa(bo * Qr())),
                    yr($a, fo = bo * Qr(), fo),
                    Ir()
                }
                ;
                n()
            }
              , Vr = () => {
                r && !qr() && (yr(Dr, wo = void 0, wo),
                Hr = void 0,
                yt.pause(),
                cancelAnimationFrame(Wr),
                Ir())
            }
              , qr = () => yt && yt.paused
              , Gr = () => {
                if (r)
                    return qr() ? Ur() : Vr()
            }
              , Kr = () => {
                r && (yt.muted = !0)
            }
              , Xr = () => {
                r && (yt.muted = !1)
            }
              , Zr = () => {
                r && yr(Yr, xo = !xo, xo)
            }
              , Yr = ja(ir);
            cr(e, Yr, (e => i(421, xo = e)));
            const Qr = () => {
                if (r)
                    return yt.duration
            }
              , Jr = () => {
                if (r)
                    return yt.currentTime
            }
              , oa = e => {
                r && (_h(yt, e),
                yr(zr, bo = e / vo, bo))
            }
              , na = ja({});
            cr(e, na, (e => i(52, ti = e))),
            ia("redrawTrigger", na);
            const ra = ja(bn);
            cr(e, ra, (e => i(494, yo = e))),
            ia("elasticityMultiplier", ra);
            let sa = [];
            const la = ic();
            cr(e, la, (e => i(102, Zo = e)));
            const ca = Ol() || 1024
              , ua = et(ca, ca)
              , da = Cs()
              , pa = e => Promise.resolve(go && go(e, {
                resourceType: "image"
            })).then((t => {
                if (!1 === t)
                    return;
                const {headers: i, credentials: o} = t || {};
                return fetch(e, {
                    headers: i,
                    credentials: o
                }).then((e => {
                    if (200 !== e.status)
                        throw `${e.status} (${e.statusText})`;
                    return e.blob()
                }
                )).then((e => Eh(e, Tr, da))).then((e => Rh(e, f)))
            }
            ));
            let {imageSourceToImageData: ha=(e => W(e) ? pa(e) : Qt(e) ? new Promise((t => t(T(e)))) : bi(e) || Jt(e) ? Eh(e, Tr, da).then((e => Rh(e, f))) : void 0)} = t;
            const ma = ( () => {
                let e, t;
                const i = Ch.reduce(( (e, i) => (e[i] = function(e, o, n) {
                    let r = [];
                    return {
                        set: e => {
                            t && t.stores[i].set(e)
                        }
                        ,
                        update: e => {
                            t && t.stores[i].update(e)
                        }
                        ,
                        publish: e => {
                            r.forEach((t => t(e)))
                        }
                        ,
                        subscribe: e => (r.push(e),
                        (e => {
                            if (!t)
                                return e();
                            t.stores[i].subscribe(e)()
                        }
                        )(e),
                        () => {
                            r = r.filter((t => t !== e))
                        }
                        )
                    }
                }(),
                e)), {});
                return {
                    update: o => {
                        if (t = o,
                        e && (e.forEach((e => e())),
                        e = void 0),
                        !o)
                            return i.file.publish(void 0),
                            void i.loadState.publish(void 0);
                        e = Ch.map((e => o.stores[e].subscribe((t => {
                            i[e].publish(t)
                        }
                        ))))
                    }
                    ,
                    stores: i,
                    destroy: () => {
                        e && e.forEach((e => e()))
                    }
                }
            }
            )()
              , {file: fa, size: ga, duration: ya, currentTime: $a, trim: ba, volume: va, minDuration: xa, maxDuration: wa, loadState: Sa, processState: _a, cropAspectRatio: ka, cropLimitToImage: Ca, crop: Ta, cropMinSize: Ma, cropMaxSize: Pa, cropRange: Ea, cropOrigin: Ra, cropRectAspectRatio: Aa, rotation: Ia, rotationRange: La, targetSize: Da, flipX: za, flipY: Fa, backgroundColor: Oa, backgroundImage: Ba, colorMatrix: Na, convolutionMatrix: Wa, gamma: Va, vignette: qa, noise: Ga, decoration: Ka, annotation: Xa, manipulation: Za, redaction: Ya, frame: Qa, selection: Ja, state: es} = ma.stores;
            cr(e, fa, (e => i(396, Si = e))),
            cr(e, ga, (e => i(369, _t = e))),
            cr(e, ya, (e => i(420, vo = e))),
            cr(e, $a, (e => i(493, fo = e))),
            cr(e, ba, (e => i(417, mo = e))),
            cr(e, va, (e => i(418, $o = e))),
            cr(e, wa, (e => i(423, _o = e))),
            cr(e, Sa, (e => i(388, pi = e))),
            cr(e, _a, (e => i(387, di = e))),
            cr(e, ka, (e => i(490, ao = e))),
            cr(e, Ca, (e => i(85, Mo = e))),
            cr(e, Ta, (e => i(407, ji = e))),
            cr(e, Ia, (e => i(372, At = e))),
            cr(e, za, (e => i(371, Pt = e))),
            cr(e, Fa, (e => i(370, Mt = e))),
            cr(e, Oa, (e => i(378, Gt = e))),
            cr(e, Ka, (e => i(48, St = e))),
            cr(e, Xa, (e => i(49, It = e))),
            cr(e, Za, (e => i(375, Ut = e))),
            cr(e, Ya, (e => i(376, Vt = e))),
            cr(e, Qa, (e => i(47, $t = e))),
            cr(e, Ja, (e => i(59, uo = e))),
            cr(e, es, (e => i(479, Ti = e))),
            ia("components", {
                DynamicComponentTree: yh
            }),
            ia("previewcontrols", {
                play: Ur,
                pause: Vr,
                togglePlayPause: Gr,
                mute: Kr,
                unmute: Xr,
                toggleMute: Zr,
                setCurrentTime: oa,
                getCurrentTime: Jr,
                getDuration: Qr,
                frameOffset: zr,
                framePeekOffset: Dr,
                isPlaying: Fr,
                isMuted: Yr
            });
            const ts = (e, t, i=0) => new Promise(( (o, n) => {
                if (Ls(e))
                    return void Rs(e).then((e => {
                        const t = Wi(fo) ? fo : or(e.duration, mo || [[0, 1]]);
                        As(e, t).then(o)
                    }
                    ));
                let r, a = !1;
                t.cancel = () => a = !0;
                const s = Date.now();
                ha(e).then((e => {
                    const t = Date.now() - s;
                    clearTimeout(r),
                    r = setTimeout(( () => {
                        a || o(e)
                    }
                    ), Math.max(0, i - t))
                }
                )).catch(n)
            }
            ))
              , {images: is, shapePreprocessor: os, imageScrambler: ns, imageRedactionRendering: rs, willRequest: as, willRequestResource: ss, csp: us} = nn;
            let ds;
            cr(e, is, (e => i(416, ho = e))),
            cr(e, os, (e => i(415, po = e))),
            cr(e, ns, (e => i(379, Kt = e))),
            cr(e, rs, (e => i(377, qt = e))),
            cr(e, as, (e => i(81, go = e))),
            cr(e, ss, (e => i(93, No = e))),
            cr(e, us, (e => i(92, Bo = e)));
            const ps = Ua(Ba, ( (e, t) => {
                if (!e)
                    return t(void 0);
                ds && (ds.cancel(),
                ds = void 0),
                ds = {
                    cancel: $
                },
                ts(e, ds).then(t).catch((e => {}
                ))
            }
            ))
              , hs = es.subscribe((e => Jo.pub("update", e)))
              , fs = ja();
            ia("ui", ja({})),
            ia("selection", Ja);
            const gs = ja(!0);
            cr(e, gs, (e => i(95, jo = e)));
            const ys = ja(!0);
            cr(e, ys, (e => i(97, Vo = e)));
            const $s = ja(!0);
            cr(e, $s, (e => i(414, co = e)));
            const bs = ja(!0);
            cr(e, bs, (e => i(491, so = e)));
            const vs = ja(!0);
            cr(e, vs, (e => i(98, qo = e)));
            const xs = ja();
            cr(e, xs, (e => i(99, Go = e)));
            const ws = ja();
            cr(e, ws, (e => i(492, lo = e)));
            const Ss = Ua([ws, bs], ( () => void 0 !== lo ? lo : so));
            cr(e, Ss, (e => i(96, Uo = e)));
            const _s = ja([0, 0, 0]);
            cr(e, _s, (e => i(56, Ai = e)));
            const ks = ja([1, 1, 1]);
            cr(e, ks, (e => i(475, jt = e)));
            const Ts = ic([1, 1, 1]);
            cr(e, Ts, (e => i(474, Ht = e)));
            const Ms = ja();
            cr(e, Ms, (e => i(91, Fo = e)));
            const Ps = ja()
              , Es = ja();
            cr(e, Es, (e => i(51, Yt = e)));
            const Is = ja();
            cr(e, Is, (e => i(373, Ot = e)));
            const Ds = ja(ht());
            cr(e, Ds, (e => i(80, Mi = e)));
            const zs = ja(0);
            cr(e, zs, (e => i(413, ro = e)));
            const Fs = ja(ht());
            cr(e, Fs, (e => i(84, To = e)));
            const Os = ja();
            cr(e, Os, (e => i(472, ft = e)));
            const Bs = Ph("(pointer: fine)", (e => e ? "pointer-fine" : "pointer-coarse"));
            cr(e, Bs, (e => i(394, xi = e)));
            const Ns = Ph("(hover: hover)", (e => e ? "pointer-hover" : "pointer-no-hover"));
            cr(e, Ns, (e => i(393, vi = e)));
            const Ws = ja(!1)
              , Hs = ja(!1);
            cr(e, Hs, (e => i(374, Wt = e)));
            const js = Ha(void 0, (e => {
                const t = ic(0)
                  , i = [Hs.subscribe((e => {
                    t.set(e ? 1 : 0, {
                        hard: !oi
                    })
                }
                )), t.subscribe(e)];
                return () => i.forEach((e => e()))
            }
            ));
            cr(e, js, (e => i(473, Nt = e)));
            const Us = ja();
            cr(e, Us, (e => i(478, gi = e)));
            const Vs = ja();
            let qs;
            cr(e, Vs, (e => i(53, oi = e))),
            ia("isAnimated", Vs);
            const Gs = ja(pn);
            cr(e, Gs, (e => i(397, _i = e)));
            const Ks = ja(!1);
            cr(e, Ks, (e => i(484, qi = e))),
            ia("imageIsStatic", Ks);
            const Xs = ja();
            cr(e, Xs, (e => i(485, Gi = e)));
            const Zs = ja();
            cr(e, Zs, (e => i(482, Ui = e)));
            const Ys = Ha(void 0, (e => {
                const t = ja(void 0)
                  , i = [Ta.subscribe(( () => {
                    if (!ji)
                        return;
                    if (qi)
                        return t.set(pt(ji));
                    const e = yu(ji, Ui, 5 * bn);
                    t.set(e)
                }
                )), t.subscribe(e)];
                return () => i.forEach((e => e()))
            }
            ))
              , Qs = ja();
            cr(e, Qs, (e => i(481, Hi = e)));
            const Js = ja();
            cr(e, Js, (e => i(483, Vi = e)));
            const el = ja(void 0);
            cr(e, el, (e => i(488, eo = e)));
            const tl = ja(ke());
            cr(e, tl, (e => i(489, to = e)));
            const il = (e, t) => {
                if (!t || !e)
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };
                const i = Tn(t, e, g)
                  , o = Cn(i, e);
                return {
                    top: Math.abs(o.top),
                    right: Math.abs(o.right),
                    bottom: Math.abs(o.bottom),
                    left: Math.abs(o.left)
                }
            }
              , ol = ja({})
              , nl = Ua([Os, Ds, Fs, ol], ( ([e,t,i,o], n) => {
                if (!e)
                    return n(void 0);
                let r = 0;
                1 !== F.length || h || "bottom" === jn || (r = i.y + i.height),
                n(bt(e.x + t.x, e.y + t.y + r, e.width, e.height))
            }
            ));
            let rl = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            };
            const al = ja(!1)
              , sl = Ua([al, Qa, nl, Hs], ( ([e,t,i,o], n) => {
                if (!i)
                    return n({
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    });
                if (!e)
                    return;
                const r = Math.min(i.width, i.height)
                  , a = il({
                    width: r,
                    height: r
                }, t);
                we(rl.top, 4) === we(a.top, 4) && we(rl.bottom, 4) === we(a.bottom, 4) && we(rl.right, 4) === we(a.right, 4) && we(rl.left, 4) === we(a.left, 4) || (rl = a,
                n(a))
            }
            ));
            cr(e, sl, (e => i(405, Oi = e)));
            const ll = Ua([al, sl], ( ([e,t], i) => {
                if (!e)
                    return i(!1);
                i(Object.values(t).some((e => e > 0)))
            }
            ));
            cr(e, ll, (e => i(406, Bi = e)));
            const cl = Ua([al, Os, ll, sl], ( ([e,t,i,o], n) => {
                if (t)
                    return e && i ? void n(bt(t.x + o.left, t.y + o.top, t.width - o.left - o.right, t.height - o.top - o.bottom)) : n({
                        ...t
                    })
            }
            ))
              , ul = Ua([nl, ll, sl], ( ([e,t,i], o) => e ? t ? void o(bt(e.x + i.left, e.y + i.top, e.width - i.left - i.right, e.height - i.top - i.bottom)) : o(e) : o(void 0)));
            cr(e, ul, (e => i(50, zt = e)));
            const dl = Ua([Ks, ga, Ia], ( ([e,t,i], o) => {
                if (!e || !t)
                    return o(void 0);
                const n = mt(t);
                o(Et(n, i))
            }
            ))
              , pl = Ua([dl], ( ([e], t) => {
                if (!e)
                    return t(void 0);
                const i = gt(e);
                t(Bt(i))
            }
            ));
            cr(e, pl, (e => i(409, Yi = e)));
            const hl = Ua([ul, Ta, pl, Gs], ( ([e,t,i,o], n) => {
                if (!e || !t || Gi || Ui)
                    return;
                const {width: r, height: a} = i || t
                  , s = Math.min(e.width / r, e.height / a);
                n(o ? s : Math.min(1, s))
            }
            ));
            cr(e, hl, (e => i(408, Xi = e)));
            const ml = Ua([Ks, ga, Ia, ul, Os, hl], ( ([e,t,i,o,n,r], a) => {
                if (!(e && o && n && t))
                    return a(void 0);
                const s = mt(t)
                  , l = Bt(wt(s, r))
                  , c = Rt(o, l);
                l.x = c.x,
                l.y = c.y,
                a(Et(l, i))
            }
            ));
            ia("imageStaticVisualCorners", ml);
            const fl = ja(void 0);
            cr(e, fl, (e => i(411, io = e)));
            const yl = Ua([Ta, ul], ( ([e,t]) => {
                if (t && e)
                    return Math.min(t.width / e.width, t.height / e.height)
            }
            ))
              , $l = Ua([Ta, Qs], ( ([e,t]) => e && t ? Math.min(e.width / t.width, e.height / t.height) : 1));
            cr(e, $l, (e => i(101, Xo = e)));
            const bl = Ua([fl, $l], ( ([e,t]) => e && t ? t * e : 1));
            cr(e, bl, (e => i(487, Qi = e)));
            const vl = ja(ke());
            cr(e, vl, (e => i(410, Ji = e)));
            const xl = ja({
                scalar: Qi,
                translation: Ji
            })
              , wl = () => {
                xl.set({
                    scalar: void 0,
                    translation: ke()
                })
            }
              , Sl = Ha(void 0, (e => {
                const t = ic(void 0, {
                    precision: 1e-4
                })
                  , i = 1 === Hu() ? e => Ft(e, Math.round) : se
                  , o = () => {
                    if (!Hi)
                        return;
                    const e = Wt || !gi;
                    if (qi) {
                        const i = pt(Hi);
                        return xt(i, to),
                        xt(i, zt),
                        t.set(i, {
                            hard: e
                        })
                    }
                    const o = yu(Hi, eo, $m * bn);
                    o.width < 0 && (o.width = 0,
                    o.x = Hi.x),
                    o.height < 0 && (o.height = 0,
                    o.y = Hi.y),
                    xt(o, zt),
                    xt(o, Ji),
                    wt(o, Qi),
                    !e && i(o),
                    t.set(o, {
                        hard: e
                    })
                }
                  , n = [ul.subscribe(o), Qs.subscribe(o), bl.subscribe(o), vl.subscribe(o), Qa.subscribe(o), t.subscribe(e)];
                return () => n.forEach((e => e()))
            }
            ));
            cr(e, Sl, (e => i(58, Fi = e)));
            const _l = ja(1);
            cr(e, _l, (e => i(480, Ni = e)));
            const kl = () => {
                if (!ji || !zt)
                    return;
                let e = kt(pt(ji), Xi || 1);
                const t = Rt(zt, kt(pt(Yi), Xi));
                xt(e, t);
                const i = ft.width / e.width
                  , o = ft.height / e.height
                  , n = Math.min(1, i, o);
                _l.set(n),
                wt(e, n),
                ( (e, t) => {
                    const [i,o,n,r] = Dt(e);
                    i < t.y && (e.y = Math.max(t.y, e.y)),
                    o > t.width && (e.x = t.width - e.width),
                    n > t.height && (e.y = t.height - e.height),
                    r < t.x && (e.x = Math.max(t.x, e.x))
                }
                )(e, {
                    ...ft,
                    x: 0,
                    y: 0
                }),
                Qs.set(e)
            }
              , Cl = Ua([ul, hl, Ta, ga], ( ([e,t,i,o], n) => {
                e && (i || o) && n(Tl(e, t || 1, i || o))
            }
            ));
            cr(e, Cl, (e => i(100, Ko = e)));
            const Tl = (e, t, i) => i.width <= e.width && i.height <= e.height ? Rt(e, kt(pt(i), t)) : Lt(e, Tt(i));
            let Ml, Pl;
            const El = e => {
                if (h && Ml && Ct(Ml, e) && Pl === Xi)
                    return;
                if (qi)
                    return kl();
                Ml = e,
                Pl = Xi;
                const t = Tl(e, Xi, ji || _t);
                Qs.set(t)
            }
            ;
            let Rl = !1;
            const Al = hl.subscribe((e => {
                !Rl && void 0 !== e && ji && (El(zt),
                Rl = !0)
            }
            ))
              , Il = ul.subscribe((e => {
                e && void 0 !== Xi && ji && El(e)
            }
            ))
              , Ll = Ks.subscribe((e => {
                !e && zt && El(zt)
            }
            ));
            let Dl;
            const zl = Js.subscribe((e => {
                if (!e)
                    return Dl = void 0,
                    void yr(Xs, Gi = void 0, Gi);
                Dl = Ki;
                const t = pt(ji);
                Xs.set(t)
            }
            ))
              , Fl = Qs.subscribe((e => {
                if (!e || !Vi)
                    return;
                const t = (i = pt(e),
                o = Vi,
                i.x -= o.x,
                i.y -= o.y,
                i.width -= o.width,
                i.height -= o.height,
                i);
                var i, o;
                ( (e, t) => {
                    e.x /= t,
                    e.y /= t,
                    e.width /= t,
                    e.height /= t
                }
                )(t, Dl);
                const n = ( (e, t) => (e.x += t.x,
                e.y += t.y,
                e.width += t.width,
                e.height += t.height,
                e))(pt(Gi), t);
                Ta.set(n)
            }
            ))
              , Nl = Ta.subscribe((e => {
                if (!e || !Hi)
                    return;
                if (qi)
                    return void (Vi || kl());
                if (Wt || Vi || Ui)
                    return;
                const t = Tt(Hi)
                  , i = Tt(e);
                if (we(t, 6) === we(i, 6))
                    return;
                const {width: o, height: n} = ji
                  , r = Math.min(zt.width / o, zt.height / n)
                  , a = et(e.width * r, e.height * r)
                  , s = .5 * (Hi.width - a.width)
                  , l = .5 * (Hi.height - a.height)
                  , c = bt(Math.max(0, Math.min(zt.width - a.width, Hi.x + s)), Math.max(0, Math.min(zt.height - a.height, Hi.y + l)), a.width, a.height);
                Qs.set(c)
            }
            ))
              , Wl = Ua([hl, Ta, Qs, Ks], ( ([e,t,i,o], n) => {
                if (!e || !t || !i)
                    return;
                if (o)
                    return n(Ni);
                const r = i.width / t.width
                  , a = i.height / t.height;
                n(Math.max(r, a) / e)
            }
            ))
              , Hl = Ua([hl, Wl], ( ([e,t], i) => {
                t && i(e * t)
            }
            ));
            cr(e, Hl, (e => i(486, Ki = e)));
            let jl = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            };
            const Ul = Ua([Qa, Qs], ( ([e,t], i) => {
                if (!t)
                    return i(jl);
                const o = il(t, e);
                we(jl.top, 4) === we(o.top, 4) && we(jl.bottom, 4) === we(o.bottom, 4) && we(jl.right, 4) === we(o.right, 4) && we(jl.left, 4) === we(o.left, 4) || (jl = o,
                i(o))
            }
            ))
              , Vl = Ua([Ul], ( ([e], t) => {
                t(Object.values(e).some((e => e > 0)))
            }
            ))
              , ql = ic(.075, {
                stiffness: .03,
                damping: .4,
                precision: .001
            })
              , Gl = Ua([Ts, _s, ql, Sl, bl, Qa, Vl, Ul, ll], ( ([e,t,i,o,n,r,a,s,l], c) => {
                if (!o || h)
                    return c([]);
                let {x: u, y: d, width: p, height: m} = o;
                u += .5,
                d += .5,
                p -= .5,
                m -= .5;
                const f = [];
                if (r) {
                    if (a) {
                        let {left: e, right: i, top: o, bottom: r} = s;
                        e *= n,
                        i *= n,
                        o *= n,
                        r *= n;
                        const a = Fh(t) ? [1, 1, 1, .125] : [0, 0, 0, .075];
                        f.push({
                            x: u - e - .5,
                            y: d - o - .5,
                            width: p + e + i + 1,
                            height: m + o + r + 1,
                            strokeWidth: 1,
                            strokeColor: a,
                            opacity: l ? 1 : .5
                        })
                    }
                    const o = Fh(e);
                    r && r.frameColor && Fh(r.frameColor) || o || (f.push({
                        x: u - 1,
                        y: d - 1,
                        width: p + 2,
                        height: m + 2,
                        strokeWidth: 2,
                        strokeColor: [0, 0, 0, .1],
                        opacity: i
                    }),
                    f.push({
                        x: u + 1,
                        y: d + 1,
                        width: p - 2,
                        height: m - 2,
                        strokeWidth: 2,
                        strokeColor: [0, 0, 0, .1],
                        opacity: i
                    }))
                }
                c([...f, {
                    x: u,
                    y: d,
                    width: p,
                    height: m,
                    strokeWidth: 1,
                    strokeColor: e,
                    opacity: i
                }])
            }
            ))
              , Kl = ja([]);
            cr(e, Kl, (e => i(399, Pi = e)));
            const Xl = Ua([Gl, Kl], ( ([e,t], i) => {
                i([...e, ...t])
            }
            ));
            cr(e, Xl, (e => i(94, Ho = e)));
            const Zl = ic(0, {
                precision: .001
            });
            cr(e, Zl, (e => i(401, Ri = e)));
            const Yl = ic();
            cr(e, Yl, (e => i(404, Di = e)));
            const Ql = ic();
            cr(e, Ql, (e => i(403, Li = e)));
            const Jl = ic();
            cr(e, Jl, (e => i(402, Ii = e)));
            const tc = ic();
            cr(e, tc, (e => i(400, Ei = e)));
            const nc = ja(!1);
            cr(e, nc, (e => i(386, ui = e)));
            const rc = ja();
            let ac;
            cr(e, rc, (e => i(389, hi = e)));
            const sc = Ua([nc, rc], ( ([e,t], o) => {
                if (!e || !t)
                    return void o(void 0);
                if (ac && (ac.cancel(),
                i(292, ac = void 0)),
                Rn(t))
                    return o(D(t));
                const n = Rc.length ? 0 : oi ? 250 : 0;
                i(292, ac = {
                    cancel: $
                }),
                ts(t, ac, n).then(o).catch((e => {
                    yr(Sa, pi.error = e, pi)
                }
                )).finally(( () => {
                    i(292, ac = void 0)
                }
                ))
            }
            ));
            Yo(),
            Yo = sr(sc, (e => i(368, yt = e)));
            let {imagePreviewCurrent: lc} = t;
            const cc = ja({});
            cr(e, cc, (e => i(391, yi = e)));
            const uc = ja([]);
            cr(e, uc, (e => i(86, Po = e)));
            const dc = Ua([ul, Is, ga, Ys, Qs, Hl, Ia, za, Fa, bl, vl, Ws], ( ([e,t,i,o,n,r,a,s,l,c,u,d], p) => {
                if (!e || !n)
                    return;
                const h = ( (e, t, i, o, n, r, a, s, l, c, u) => {
                    if (!(e && t && i && o && s))
                        return;
                    s *= r;
                    const d = Bt(pt(t))
                      , p = vt(d)
                      , h = vt(e)
                      , m = mt(i)
                      , f = vt(m)
                      , g = ls(i, o, l)
                      , y = vt(g)
                      , $ = Fe(Me(f), y)
                      , b = Fe(Me(h), p);
                    $.x += b.x,
                    $.y += b.y;
                    const v = Pe(Me($));
                    v.x += b.x,
                    v.y += b.y;
                    const x = vt(xt(xt(pt(n), a), e))
                      , w = Fe(x, h);
                    return ze($, w),
                    {
                        origin: v,
                        translation: $,
                        rotation: {
                            x: u ? Math.PI : 0,
                            y: c ? Math.PI : 0,
                            z: l
                        },
                        scale: s
                    }
                }
                )(e, t, i, o, n, c, u, r, a, s, l);
                !d && R(h),
                p(h)
            }
            ));
            cr(e, dc, (e => i(392, $i = e)));
            const pc = Ua([Na, Wa, Va, qa, Ga], ( ([e,t,i,o,n], r) => {
                const a = e && Object.keys(e).map((t => e[t])).filter(Boolean);
                r({
                    gamma: i || void 0,
                    vignette: o || void 0,
                    noise: n || void 0,
                    convolutionMatrix: t || void 0,
                    colorMatrix: a && a.length && Yn(a)
                })
            }
            ));
            let hc, mc;
            const fc = ( () => {
                if (!ki())
                    return !1;
                const e = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/i) || []
                  , [,t,i] = e.map((e => parseInt(e, 10) || 0));
                return t > 13 || 13 === t && i >= 4
            }
            )()
              , gc = ja({});
            cr(e, gc, (e => i(380, ei = e))),
            ia("env", gc);
            const yc = Hu()
              , $c = Ha(yc, (e => {
                const t = () => e(Hu())
                  , i = matchMedia(`(resolution: ${yc}dppx)`);
                return i.addListener(t),
                () => i.removeListener(t)
            }
            ));
            cr(e, $c, (e => i(57, zi = e)));
            const bc = ( (e, t, i) => {
                const {sub: o, pub: n} = oo()
                  , {willUndo: r=( () => !0)} = i || {}
                  , a = []
                  , s = ja(0)
                  , l = []
                  , c = () => l.forEach((e => e({
                    index: lr(s),
                    length: a.length
                })))
                  , u = {
                    get index() {
                        return lr(s)
                    },
                    set index(e) {
                        e = Number.isInteger(e) ? e : 0,
                        e = cs(e, 0, a.length - 1),
                        s.set(e),
                        t(a[u.index]),
                        c()
                    },
                    get state() {
                        return a[a.length - 1]
                    },
                    length: () => a.length,
                    undo() {
                        if (!1 === r())
                            return;
                        const e = u.index--;
                        return n("undo", e),
                        e
                    },
                    redo() {
                        const e = u.index++;
                        return n("redo", u.index),
                        e
                    },
                    revert() {
                        a.length = 1,
                        u.index = 0,
                        n("revert")
                    },
                    write(i) {
                        i && t({
                            ...e(),
                            ...i
                        });
                        const o = e()
                          , r = a[a.length - 1];
                        JSON.stringify(o) !== JSON.stringify(r) && (a.length = u.index + 1,
                        a.push(o),
                        s.set(a.length - 1),
                        c(),
                        n("writehistory"))
                    },
                    set(e={}) {
                        a.length = 0,
                        u.index = 0;
                        const t = Array.isArray(e) ? e : [e];
                        a.push(...t),
                        u.index = a.length - 1
                    },
                    get: () => [...a],
                    subscribe: e => (l.push(e),
                    e({
                        index: u.index,
                        length: a.length
                    }),
                    () => l.splice(l.indexOf(e), 1)),
                    on: o
                };
                return u
            }
            )(( () => Ti), (e => {
                yr(es, Ti = e, Ti),
                Ds.set(Mi)
            }
            ), {
                willUndo: () => !Cc() || (kc(),
                !1)
            });
            Qo(),
            Qo = sr(bc, (e => i(398, Ci = e)));
            const vc = () => {
                const e = {
                    x: 0,
                    y: 0,
                    ..._t
                }
                  , t = Ft(Lt(e, Ti.cropAspectRatio), Math.round)
                  , i = Mn({
                    ...Ti,
                    rotation: 0,
                    crop: t
                }, Ti)
                  , o = [i];
                JSON.stringify(i) !== JSON.stringify(Ti) && o.push({
                    ...Ti
                }),
                bc.set(o)
            }
              , xc = Sa.subscribe((e => {
                e && e.complete && vc()
            }
            ))
              , wc = () => vn().then((e => e && bc.revert()))
              , _c = [Xa, Ka, Ya, Za]
              , kc = () => {
                _c.forEach((e => {
                    e.update((e => e.length && Wo(e[e.length - 1]) ? e.slice(0, -1) : e))
                }
                ))
            }
              , Cc = () => z.filter((e => e.length)).some((e => Wo(e[e.length - 1])))
              , Tc = ja(!1);
            cr(e, Tc, (e => i(381, ii = e)));
            const Mc = () => {
                yr(Tc, ii = !0, ii),
                wn().then((e => {
                    if (!e)
                        return void yr(Tc, ii = !1, ii);
                    let t;
                    t = nu.subscribe((e => {
                        1 === e && (t && t(),
                        en("processImage"))
                    }
                    ))
                }
                ))
            }
              , Ec = _a.subscribe((e => {
                if (!e)
                    return void yr(Tc, ii = !1, ii);
                yr(Tc, ii = !0, ii);
                const {complete: t, abort: i} = e;
                (t || i) && yr(Tc, ii = !1, ii)
            }
            ))
              , Rc = ( () => {
                const e = []
                  , t = []
                  , i = []
                  , o = () => {
                    t.forEach((e => e(i)))
                }
                  , n = t => {
                    t.unsub = t.subscribe((n => ( (t, n) => {
                        const r = e.indexOf(t);
                        r < 0 || (i[r] = n,
                        o())
                    }
                    )(t, n))),
                    o()
                }
                ;
                return {
                    get length() {
                        return e.length
                    },
                    clear: () => {
                        e.forEach((e => e.unsub())),
                        e.length = 0,
                        i.length = 0
                    }
                    ,
                    unshift: t => {
                        e.unshift(t),
                        n(t)
                    }
                    ,
                    get: t => e[t],
                    push: t => {
                        e.push(t),
                        n(t)
                    }
                    ,
                    remove: t => {
                        t.unsub();
                        const o = e.indexOf(t);
                        e.splice(o, 1),
                        i.splice(o, 1)
                    }
                    ,
                    forEach: t => e.forEach(t),
                    filter: t => e.filter(t),
                    subscribe: e => (t.push(e),
                    e(i),
                    () => {
                        t.splice(t.indexOf(e), 1)
                    }
                    )
                }
            }
            )();
            cr(e, Rc, (e => i(55, mi = e)));
            const Ac = Ua([Rc], ( ([e], t) => {
                if (!e.length)
                    return t();
                const {origin: i, translation: o, rotation: n, scale: r} = e[0];
                t({
                    origin: i,
                    translation: o,
                    rotation: n,
                    scale: r
                })
            }
            ))
              , Ic = ja();
            cr(e, Ic, (e => i(395, wi = e)));
            let Lc, Dc = [];
            const zc = ja()
              , Fc = ja()
              , Oc = Ua([fl, Fc, hl, yl], ( ([e,t,i,o]) => e || (t || i < 1 ? o : 1)))
              , Bc = {
                ...nn,
                imageFile: fa,
                imageSize: ga,
                mediaDuration: ya,
                mediaMinDuration: xa,
                mediaMaxDuration: wa,
                mediaTrim: ba,
                imageBackgroundColor: Oa,
                imageBackgroundImage: Ba,
                imageCropAspectRatio: ka,
                imageCropMinSize: Ma,
                imageCropMaxSize: Pa,
                imageCropLimitToImage: Ca,
                imageCropRect: Ta,
                imageCropRectOrigin: Ra,
                imageCropRectSnapshot: Xs,
                imageCropRectAspectRatio: Aa,
                imageCropRange: Ea,
                imageRotation: Ia,
                imageRotationRange: La,
                imageFlipX: za,
                imageFlipY: Fa,
                imageOutputSize: Da,
                imageColorMatrix: Na,
                imageConvolutionMatrix: Wa,
                imageGamma: Va,
                imageVignette: qa,
                imageNoise: Ga,
                imageManipulation: Za,
                imageDecoration: Ka,
                imageAnnotation: Xa,
                imageRedaction: Ya,
                imageFrame: Qa,
                imagePreview: sc,
                imagePreviewSource: rc,
                imageTransforms: dc,
                imagePreviewModifiers: cc,
                history: bc,
                animation: Us,
                pixelRatio: $c,
                elasticityMultiplier: bn,
                scrollElasticity: vm,
                rangeInputElasticity: 5,
                redrawTrigger: na,
                pointerAccuracy: Bs,
                pointerHoverable: Ns,
                env: gc,
                rootRect: Is,
                stageRect: ul,
                stageRectBase: nl,
                stageRecenter: ol,
                stageScalar: hl,
                stagePadding: sl,
                stagePadded: ll,
                presentationScalar: Hl,
                imagePreviewUpscale: Fc,
                utilRect: Os,
                utilRectPadded: cl,
                allowPlayPause: Lr,
                allowPan: gs,
                allowZoom: ys,
                allowZoomControls: $s,
                enableZoomInput: vs,
                enablePanInput: bs,
                enablePanInputStatus: Ss,
                imageSelectionMultiTouching: zc,
                rootBackgroundColor: _s,
                rootForegroundColor: ks,
                rootLineColor: Ts,
                rootColorSecondary: Ps,
                imageOutlineOpacity: ql,
                utilTools: Ic,
                imageSelectionPan: vl,
                imageSelectionZoom: fl,
                imageSelectionZoomCurrent: Oc,
                imageSelectionStageFitScalar: yl,
                imageSelectionStoredState: xl,
                imageOverlayMarkup: Kl,
                interfaceImages: uc,
                isInteracting: Hs,
                isTransformingImage: Ws,
                isInteractingFraction: js,
                imageCropRectIntent: Zs,
                imageCropRectPresentation: Ys,
                imageSelectionRect: Qs,
                imageSelectionRectIntent: el,
                imageSelectionRectPresentation: Sl,
                imageSelectionRectSnapshot: Js,
                imageScalar: Wl,
                imageTransformsInterpolated: Ac,
                imageEffects: pc
            };
            delete Bc.image;
            const Nc = `util-${V()}`;
            let Wc = [];
            const Hc = e => O.find(( ([t]) => e === t));
            let jc = [];
            const Uc = e => {
                i(62, jc = jc.concat(e))
            }
              , Vc = e => {
                i(62, jc = jc.filter((t => t !== e)))
            }
              , qc = (e, t) => {
                i(298, j[e] = t, j)
            }
            ;
            let Gc = ki();
            const Kc = (e, t, i) => {
                let o = $e.getPropertyValue(e);
                o = i ? i(o) : /^[0-9]+$/.test(o) ? parseFloat(o) : void 0,
                t.set(o, {
                    hard: !oi
                })
            }
              , Xc = (e, t, i=!1) => {
                const o = (e => {
                    const t = $e.getPropertyValue(e);
                    return Bp(t)
                }
                )(e);
                o && 0 !== o[3] && (i || (o.length = 3),
                t.set(o, {
                    hard: !oi
                }))
            }
              , Zc = ja();
            cr(e, Zc, (e => i(87, Ao = e)));
            const Yc = ja();
            cr(e, Yc, (e => i(88, Io = e)));
            const Qc = ja();
            cr(e, Qc, (e => i(89, Lo = e)));
            const Jc = ic(0, {
                damping: .9
            });
            cr(e, Jc, (e => i(90, zo = e)));
            const eu = () => {
                Xc("color", ks),
                Xc(pr ? "--color-background" : "background-color", _s),
                Xc("outline-color", Ts),
                Xc("--color-primary", Ms),
                Xc("--color-secondary", Ps),
                Xc("--grid-color-even", Yc, !0),
                Xc("--grid-color-odd", Qc, !0),
                Kc("--grid-size", Zc),
                Kc("--editor-inset-top", zs, (e => parseInt(e, 10)))
            }
              , tu = Ua([dc, pc, Oa, ps], ( ([e,t,i,o]) => e && {
                ...e,
                ...t,
                backgroundColor: i,
                backgroundImage: o
            }));
            cr(e, tu, (e => i(390, fi = e)));
            const iu = e => {
                Rc.forEach(( (t, i) => {
                    const o = 0 === i ? 1 : 0;
                    t.set({
                        ...e,
                        opacity: o,
                        resize: 1
                    }, gi)
                }
                ))
            }
            ;
            let ou;
            const nu = ec(void 0, {
                duration: 500
            });
            let ru;
            cr(e, nu, (e => i(54, li = e)));
            const au = ja(!1);
            let su;
            cr(e, au, (e => i(385, ci = e)));
            const lu = ic(void 0, {
                stiffness: .1,
                damping: .7,
                precision: .25
            });
            cr(e, lu, (e => i(82, ko = e)));
            const cu = ic(0, {
                stiffness: .1,
                precision: .05
            });
            cr(e, cu, (e => i(83, Co = e)));
            const uu = ic(0, {
                stiffness: .02,
                damping: .5,
                precision: .25
            });
            cr(e, uu, (e => i(383, ri = e)));
            const du = ic(void 0, {
                stiffness: .02,
                damping: .5,
                precision: .25
            });
            cr(e, du, (e => i(384, ai = e)));
            const pu = ic(void 0, {
                stiffness: .02,
                damping: .5,
                precision: .25
            });
            let hu;
            cr(e, pu, (e => i(382, ni = e)));
            const mu = () => {
                en("abortLoadImage")
            }
              , fu = () => {
                en("abortProcessImage"),
                yr(Tc, ii = !1, ii)
            }
              , gu = e => {
                e.target && "true" === e.target.dataset.touchScroll || e.preventDefault()
            }
              , $u = fc ? e => {
                const t = e.touches ? e.touches[0] : e;
                t.pageX > 20 && t.pageX < window.innerWidth - 20 || gu(e)
            }
            : $
              , bu = ja([]);
            cr(e, bu, (e => i(476, Xt = e))),
            ia("keysPressed", bu);
            const vu = e => {
                !e || Zi(e) && !(e => /^image/.test(e.type) && !/svg/.test(e.type))(e) || !Zi(e) && !/^http/.test(e) || en("loadImage", e)
            }
              , xu = e => {
                e && vu(e)
            }
            ;
            let wu, Su, _u = [];
            const ku = ja();
            ia("rootPortal", ku),
            ia("rootRect", Is);
            const Cu = () => ({
                foregroundColor: [...jt],
                lineColor: [...Ht],
                utilVisibility: {
                    ...j
                },
                isInteracting: Wt,
                isInteractingFraction: Nt,
                rootRect: pt(Ot),
                stageRect: pt(zt),
                manipulationShapesDirty: Uu,
                annotationShapesDirty: Bu,
                decorationShapesDirty: Wu,
                frameShapesDirty: ju
            })
              , Tu = (e, t, i) => xn(e, et(Math.round(t.width / i), Math.round(t.height / i)))
              , Mu = (e, t, i) => {
                var o;
                return e._translate = Ce((o = t).x, o.y),
                e._scale = i,
                e
            }
              , Pu = e => {
                const t = [];
                return e.forEach((e => t.push(Eu(e)))),
                t.filter(Boolean)
            }
              , Eu = e => Do(e) ? (e.points = [Ce(e.x1, e.y1), Ce(e.x2, e.y2)],
            e) : (!(e => Eo(e) && !e.text.length)(e) || e.backgroundColor && 0 !== e.backgroundColor[3] || (Ro(e) && (e.width = 5,
            e.height = e.lineHeight),
            e.strokeWidth = 1,
            e.strokeColor = [1, 1, 1, .5],
            e.backgroundColor = [0, 0, 0, .1]),
            e);
            let Ru, Au = [], Iu = [], Lu = [], Du = [], zu = [], Fu = {};
            const Ou = (e, t, i, o, n, r, a) => {
                const {manipulationShapesDirty: s, annotationShapesDirty: l, decorationShapesDirty: c, frameShapesDirty: u, selectionRect: d, scale: p} = e
                  , h = Ru !== p
                  , m = h || !Ct(Fu, d);
                m && (Ru = p,
                Fu = d),
                s && (Lu = t.filter(Oo).map(So).map((e => xn(e, _t)))),
                (l || i !== It) && (Au = i.filter(Oo).map(So).sort(( (e, t) => e.alwaysOnTop ? 1 : t.alwaysOnTop ? -1 : 0)).map((e => xn(e, _t)))),
                (h || Nu || l || i !== It) && (Iu = Pu(Au.map((e => g(e, {
                    flipX: Pt,
                    flipY: Mt,
                    rotation: At,
                    scale: p,
                    context: mt(_t)
                }))).flat())),
                (c || o !== St || m) && (Du = Pu(o.filter(Oo).map(So).sort(( (e, t) => e.alwaysOnTop ? 1 : t.alwaysOnTop ? -1 : 0)).map((e => Tu(e, d, p))).map((e => g(e, {
                    context: d
                }))).flat().map((e => Mu(e, d, p))))),
                (u || r !== $t || m) && (zu = r ? Pu([r].map(So).map((e => Tu(e, d, p))).map(g).flat().map((e => Mu(e, d, p)))) : []);
                let f = Pu(n.filter(Oo));
                return {
                    manipulationShapesDirty: s,
                    manipulationShapes: Lu,
                    annotationShapesDirty: l,
                    annotationShapes: Iu,
                    decorationShapesDirty: c,
                    decorationShapes: Du,
                    frameShapesDirty: u,
                    frameShapes: zu,
                    interfaceShapes: f,
                    selectionShapes: a.map(So).map((e => xn(e, _t)))
                }
            }
            ;
            let Bu = !0
              , Nu = !0
              , Wu = !0
              , ju = !0
              , Uu = !0;
            return ea(( () => {
                Vr(),
                yt && W(yt.src) && /^blob:/.test(yt.src) && URL.revokeObjectURL(yt.src),
                hs(),
                Il(),
                Al(),
                Ll(),
                zl(),
                Fl(),
                Nl(),
                xc(),
                Ec(),
                Bs.destroy(),
                Ns.destroy(),
                ma.destroy(),
                Rc.clear(),
                Au.length = 0,
                Iu.length = 0,
                Lu.length = 0,
                Du.length = 0,
                zu.length = 0;
                try {
                    i(235, lc = void 0),
                    i(293, ou = void 0)
                } catch (e) {}
            }
            )),
            e.$$set = e => {
                "class"in e && i(236, tn = e.class),
                "layout"in e && i(237, on = e.layout),
                "stores"in e && i(238, nn = e.stores),
                "locale"in e && i(3, rn = e.locale),
                "id"in e && i(4, an = e.id),
                "util"in e && i(239, sn = e.util),
                "utils"in e && i(240, ln = e.utils),
                "animations"in e && i(241, cn = e.animations),
                "disabled"in e && i(242, un = e.disabled),
                "status"in e && i(234, dn = e.status),
                "previewUpscale"in e && i(243, pn = e.previewUpscale),
                "previewPad"in e && i(244, hn = e.previewPad),
                "previewMaskOpacity"in e && i(5, mn = e.previewMaskOpacity),
                "previewImageDataMaxSize"in e && i(245, fn = e.previewImageDataMaxSize),
                "previewImageTextPixelRatio"in e && i(6, gn = e.previewImageTextPixelRatio),
                "markupMaskOpacity"in e && i(7, yn = e.markupMaskOpacity),
                "zoomMaskOpacity"in e && i(246, $n = e.zoomMaskOpacity),
                "elasticityMultiplier"in e && i(8, bn = e.elasticityMultiplier),
                "willRevert"in e && i(247, vn = e.willRevert),
                "willProcessImage"in e && i(248, wn = e.willProcessImage),
                "willRenderCanvas"in e && i(9, Sn = e.willRenderCanvas),
                "willRenderToolbar"in e && i(249, _n = e.willRenderToolbar),
                "willRenderUtilTabs"in e && i(250, kn = e.willRenderUtilTabs),
                "willSetHistoryInitialState"in e && i(251, Mn = e.willSetHistoryInitialState),
                "enableButtonExport"in e && i(252, Pn = e.enableButtonExport),
                "enableButtonRevert"in e && i(253, En = e.enableButtonRevert),
                "enableNavigateHistory"in e && i(254, An = e.enableNavigateHistory),
                "enableToolbar"in e && i(10, In = e.enableToolbar),
                "enableUtils"in e && i(255, Ln = e.enableUtils),
                "enableButtonClose"in e && i(256, Dn = e.enableButtonClose),
                "enableDropImage"in e && i(257, zn = e.enableDropImage),
                "enablePasteImage"in e && i(258, Fn = e.enablePasteImage),
                "enableBrowseImage"in e && i(259, On = e.enableBrowseImage),
                "enableTransparencyGrid"in e && i(11, Bn = e.enableTransparencyGrid),
                "layoutDirectionPreference"in e && i(260, Nn = e.layoutDirectionPreference),
                "layoutHorizontalUtilsPreference"in e && i(261, Wn = e.layoutHorizontalUtilsPreference),
                "layoutVerticalUtilsPreference"in e && i(262, Hn = e.layoutVerticalUtilsPreference),
                "layoutVerticalToolbarPreference"in e && i(263, jn = e.layoutVerticalToolbarPreference),
                "layoutVerticalControlGroupsPreference"in e && i(264, Un = e.layoutVerticalControlGroupsPreference),
                "layoutVerticalControlTabsPreference"in e && i(265, Vn = e.layoutVerticalControlTabsPreference),
                "textDirection"in e && i(12, qn = e.textDirection),
                "markupEditorZoomLevel"in e && i(266, Gn = e.markupEditorZoomLevel),
                "markupEditorZoomLevels"in e && i(13, Kn = e.markupEditorZoomLevels),
                "markupEditorZoomAdjustStep"in e && i(14, Xn = e.markupEditorZoomAdjustStep),
                "markupEditorZoomAdjustFactor"in e && i(15, Zn = e.markupEditorZoomAdjustFactor),
                "markupEditorZoomAdjustWheelFactor"in e && i(16, er = e.markupEditorZoomAdjustWheelFactor),
                "markupEditorInteractionMode"in e && i(267, tr = e.markupEditorInteractionMode),
                "muteAudio"in e && i(268, ir = e.muteAudio),
                "willSetMediaInitialTimeOffset"in e && i(269, or = e.willSetMediaInitialTimeOffset),
                "enablePan"in e && i(17, nr = e.enablePan),
                "enableZoom"in e && i(18, rr = e.enableZoom),
                "enableZoomControls"in e && i(270, ar = e.enableZoomControls),
                "enableZoomInput"in e && i(19, ur = e.enableZoomInput),
                "enablePanInput"in e && i(271, dr = e.enablePanInput),
                "enableCanvasAlpha"in e && i(20, pr = e.enableCanvasAlpha),
                "enablePanLimit"in e && i(21, hr = e.enablePanLimit),
                "panLimitGutterScalar"in e && i(22, mr = e.panLimitGutterScalar),
                "pan"in e && i(272, fr = e.pan),
                "zoomPresetOptions"in e && i(23, gr = e.zoomPresetOptions),
                "zoomAdjustStep"in e && i(24, $r = e.zoomAdjustStep),
                "zoomAdjustFactor"in e && i(25, br = e.zoomAdjustFactor),
                "zoomAdjustWheelFactor"in e && i(26, vr = e.zoomAdjustWheelFactor),
                "zoomLevel"in e && i(0, xr = e.zoomLevel),
                "fixScrollDirection"in e && i(273, wr = e.fixScrollDirection),
                "imagePreviewSrc"in e && i(276, Cr = e.imagePreviewSrc),
                "imageOrienter"in e && i(277, Tr = e.imageOrienter),
                "pluginComponents"in e && i(278, Mr = e.pluginComponents),
                "pluginOptions"in e && i(27, Pr = e.pluginOptions),
                "root"in e && i(2, Ar = e.root),
                "imageSourceToImageData"in e && i(28, ha = e.imageSourceToImageData),
                "imagePreviewCurrent"in e && i(235, lc = e.imagePreviewCurrent)
            }
            ,
            e.$$.update = () => {
                if (33554432 & e.$$.dirty[8] && Sr.set(wr),
                8 & e.$$.dirty[0] && i(350, o = !!rn),
                1 & e.$$.dirty[0] | 262144 & e.$$.dirty[8] && i(0, xr = null === xr ? Gn : xr),
                2 & e.$$.dirty[0] | 1073741824 & e.$$.dirty[8]) {
                    let e = !1;
                    Mr.forEach(( ([t]) => {
                        Rr[t] || (i(1, Rr[t] = {}, Rr),
                        e = !0)
                    }
                    )),
                    e && i(290, sa = [...Mr])
                }
                var t, T, R, L, D;
                if (8388608 & e.$$.dirty[7] | 2048 & e.$$.dirty[9] | 512 & e.$$.dirty[11] && i(348, F = o && sa.length ? ln || sa.map(( ([e]) => e)) : []),
                134217728 & e.$$.dirty[0] | 2048 & e.$$.dirty[9] | 128 & e.$$.dirty[11] | 16777216 & e.$$.dirty[12] && i(349, O = ( (e, t, i, o) => {
                    const n = t.filter(( ([t]) => e.includes(t))).filter(( ([e,{isSupported: t}]) => t({
                        ...o,
                        ...i[e]
                    }))).map(( ([e,t]) => [e, t.Component]));
                    return ms(n, Wc, ( (e, t) => e[0] === t[0] && e[1] === t[1])) ? Wc : (Wc = n,
                    n)
                }
                )(F, sa, Pr, {
                    src: Si
                })),
                256 & e.$$.dirty[11] && i(302, B = O.length),
                8 & e.$$.dirty[0] | 8388608 & e.$$.dirty[9] | 128 & e.$$.dirty[11] && i(347, N = B && F.map((e => {
                    const t = Hc(e);
                    if (t)
                        return {
                            id: e,
                            view: t[1],
                            tabIcon: rn[`${e}Icon`],
                            tabLabel: rn[`${e}Label`]
                        }
                }
                )).filter(Boolean) || []),
                64 & e.$$.dirty[11] && i(367, n = !!N.find((e => "trim" === e.id))),
                201326592 & e.$$.dirty[11] | 131072 & e.$$.dirty[13] && i(301, r = !!(vo && yt && n)),
                4194304 & e.$$.dirty[7] | 8388608 & e.$$.dirty[9] && i(43, H = B && sn && "string" == typeof sn && Hc(sn) ? sn : B > 0 ? O[0][0] : void 0),
                4096 & e.$$.dirty[1] | 4194304 & e.$$.dirty[9] && r && H && Vr(),
                4194304 & e.$$.dirty[9] | 134217728 & e.$$.dirty[11] && (r ? (yt.addEventListener("play", Or),
                yt.addEventListener("pause", Or)) : yt && "video" === yt.nodeName && (yt.removeEventListener("play", Or),
                yt.removeEventListener("pause", Or))),
                4194304 & e.$$.dirty[9] && r && zr.set(Jr() / Qr()),
                589824 & e.$$.dirty[13] && (e => {
                    if (!qr())
                        return;
                    const t = Date.now();
                    if (Nr && t - Nr < 16)
                        return;
                    Nr = t;
                    const i = vo * e;
                    if (i.toFixed(1) === Br)
                        return;
                    Br = i.toFixed(1);
                    const o = yt
                      , n = () => {
                        o.removeEventListener("seeked", n),
                        Ir()
                    }
                    ;
                    o.addEventListener("seeked", n),
                    _h(o, i)
                }
                )(wo || bo),
                65536 & e.$$.dirty[13] && i(365, a = bo && we(bo, 6)),
                1196032 & e.$$.dirty[13] && i(363, s = mo || [[0, Math.min(vo, _o) / vo]]),
                4194304 & e.$$.dirty[11] && (l = s[0][0]),
                4194304 & e.$$.dirty[11] && (c = s[s.length - 1][1]),
                4194304 & e.$$.dirty[11] && i(366, u = s.map(( ([e,t]) => [we(e, 6), we(t, 6)]))),
                50331648 & e.$$.dirty[11] && i(364, d = u.findIndex(( ([e,t]) => a >= e && a <= t))),
                58720256 & e.$$.dirty[11] && (p = -1 === d && u.findIndex(( (e, t, i) => {
                    const o = i[t - 1];
                    return o ? a <= e[0] && a >= o[1] : a <= e[0]
                }
                ))),
                1048576 & e.$$.dirty[8] && Yr.set(ir),
                134217728 & e.$$.dirty[11] | 262144 & e.$$.dirty[13] && (yt && xo ? Kr() : Xr()),
                4194304 & e.$$.dirty[9] | 65536 & e.$$.dirty[13] && r && $a.set(Qr() * bo),
                134217728 & e.$$.dirty[11] | 32768 & e.$$.dirty[13] && yt && (D = $o,
                r && (yt.volume = Math.min(1, D))),
                256 & e.$$.dirty[0] && yr(ra, yo = bn, yo),
                1048576 & e.$$.dirty[7] && i(359, h = "overlay" === on),
                128 & e.$$.dirty[8] | 262144 & e.$$.dirty[11] && i(45, m = Ln && !h),
                134217730 & e.$$.dirty[0] && Pr && Object.entries(Pr).forEach(( ([e,t]) => {
                    Object.entries(t).forEach(( ([t,o]) => {
                        Rr[e] && i(1, Rr[e][t] = o, Rr)
                    }
                    ))
                }
                )),
                512 & e.$$.dirty[13] && i(360, v = !no),
                16777216 & e.$$.dirty[7] | 1572864 & e.$$.dirty[11] && yr(Vs, oi = "always" === cn ? y : "never" !== cn && y && v, oi),
                4194304 & e.$$.dirty[1] | 33554432 & e.$$.dirty[7] && la.set(un ? 1 : 0, {
                    hard: !oi
                }),
                268435456 & e.$$.dirty[7] && (f = fn ? (t = fn,
                T = ua,
                et(Math.min(t.width, T.width), Math.min(t.height, T.height))) : ua),
                8192 & e.$$.dirty[13] && ma.update(ho[0]),
                4096 & e.$$.dirty[13] && (g = po ? (e, t) => po(e, {
                    flipX: void 0,
                    flipY: void 0,
                    rotation: void 0,
                    ...t,
                    isPreview: !0
                }) : se),
                268435456 & e.$$.dirty[1] && Array.isArray(uo) && en("selectionchange", [...uo]),
                4194304 & e.$$.dirty[8] | 2048 & e.$$.dirty[13] && xs.set(co && ar),
                8912896 & e.$$.dirty[8] && ws.set("pan" === tr || dr),
                1048576 & e.$$.dirty[1] && Yt && Is.set(bt(Yt.x, Yt.y, Yt.width, Yt.height)),
                262144 & e.$$.dirty[11] | 65538 & e.$$.dirty[12] && Ot && h && pi && pi.complete && ( () => {
                    const e = ao
                      , t = Tt(Ot);
                    e && e === t || (ka.set(Tt(Ot)),
                    vc())
                }
                )(),
                128 & e.$$.dirty[11] && i(46, K = F.length > 1),
                32768 & e.$$.dirty[1] && (K || Ds.set(ht())),
                1024 & e.$$.dirty[0] | 1024 & e.$$.dirty[13] && (In || Fs.set(bt(0, ro, 0, 0))),
                1048576 & e.$$.dirty[11] | 4 & e.$$.dirty[12] && i(362, b = !Wt && y),
                1048576 & e.$$.dirty[1] && i(303, rt = Yt && Yt.width > 0 && Yt.height > 0),
                8 & e.$$.dirty[0] | 25165824 & e.$$.dirty[9] && i(40, at = rt && rn && !!B),
                512 & e.$$.dirty[1] && setTimeout(( () => i(291, qs = at)), 1),
                16777216 & e.$$.dirty[7] | 4096 & e.$$.dirty[9] | 2621440 & e.$$.dirty[11] && yr(Us, gi = "always" === cn ? b : "never" !== cn && b && qs && v, gi),
                67108864 & e.$$.dirty[7] | 262144 & e.$$.dirty[11] && Gs.set(pn || h),
                134217728 & e.$$.dirty[7] && al.set(hn),
                16777216 & e.$$.dirty[8] && fr && vl.set(fr),
                4 & e.$$.dirty[0] | 288 & e.$$.dirty[13] && Ar && (Ar.dispatchEvent(Th("markupzoom", io)),
                Ar.dispatchEvent(Th("zoom", Wi(io) ? io : Xi))),
                4 & e.$$.dirty[0] | 128 & e.$$.dirty[13] && Ar && (Ar.dispatchEvent(Th("markuppan", Ji)),
                Ar.dispatchEvent(Th("pan", Ji))),
                16 & e.$$.dirty[13] && ji && wl(),
                64 & e.$$.dirty[13] && Yi && kl(),
                4198400 & e.$$.dirty[1] && H && ql.set(.075, {
                    hard: !oi
                }),
                536870912 & e.$$.dirty[7] && i(357, x = $n),
                12 & e.$$.dirty[13] && i(358, w = Bi ? -Math.max(...Object.values(Oi)) : 0),
                138936320 & e.$$.dirty[1] | 196608 & e.$$.dirty[11] && Fi) {
                    let e = Fi.x - zt.x
                      , t = zt.x + zt.width - (Fi.x + Fi.width)
                      , i = Fi.y - zt.y
                      , o = zt.y + zt.height - (Fi.y + Fi.height)
                      , n = Math.min(e, i, t, o);
                    Zl.set(n > w ? 0 : Math.min(x, Math.abs(n / 64)), {
                        hard: !oi
                    })
                }
                if (67108864 & e.$$.dirty[1] && i(356, S = .55 / zi),
                4718592 & e.$$.dirty[1] | 32768 & e.$$.dirty[11] && zt && Yl.set({
                    x: 0,
                    y: zt.y,
                    width: zt.x < 64 ? 0 : zt.x,
                    height: zt.height + S
                }, {
                    hard: !oi
                }),
                4718592 & e.$$.dirty[1] | 32768 & e.$$.dirty[11] | 2 & e.$$.dirty[12] && zt && Ql.set({
                    x: 0,
                    y: 0,
                    width: Ot.width,
                    height: zt.y + S
                }, {
                    hard: !oi
                }),
                4718592 & e.$$.dirty[1] | 32768 & e.$$.dirty[11] | 2 & e.$$.dirty[12] && zt) {
                    let e = zt.x + zt.width
                      , t = Ot.width - (zt.x + zt.width);
                    t < 64 && (e += t,
                    t = 0),
                    Jl.set({
                        x: e,
                        y: zt.y,
                        width: t,
                        height: zt.height + S
                    }, {
                        hard: !oi
                    })
                }
                if (4718592 & e.$$.dirty[1] | 2 & e.$$.dirty[12] && zt && tc.set({
                    x: 0,
                    y: zt.y + zt.height,
                    width: Ot.width,
                    height: Ot.height - (zt.y + zt.height)
                }, {
                    hard: !oi
                }),
                33554432 & e.$$.dirty[1] | 536870912 & e.$$.dirty[12] | 2 & e.$$.dirty[13] && i(352, _ = Di && {
                    id: bm,
                    backgroundColor: Ai,
                    opacity: Ri,
                    ...Di
                }),
                33554432 & e.$$.dirty[1] | 536870912 & e.$$.dirty[12] | 1 & e.$$.dirty[13] && i(355, k = Li && {
                    id: bm,
                    backgroundColor: Ai,
                    opacity: Ri,
                    ...Li
                }),
                33554432 & e.$$.dirty[1] | 1610612736 & e.$$.dirty[12] && i(354, C = Ii && {
                    id: bm,
                    backgroundColor: Ai,
                    opacity: Ri,
                    ...Ii
                }),
                33554432 & e.$$.dirty[1] | 805306368 & e.$$.dirty[12] && i(353, M = Ei && {
                    id: bm,
                    backgroundColor: Ai,
                    opacity: Ri,
                    ...Ei
                }),
                30720 & e.$$.dirty[11] && i(351, P = [k, C, M, _].filter(Boolean)),
                1024 & e.$$.dirty[11] | 134217728 & e.$$.dirty[12] && P && Pi && Kl.update((e => [...e.filter((e => e.id !== bm)), ...P])),
                268435456 & e.$$.dirty[8] | 16777216 & e.$$.dirty[12] && rc.set(Cr || Si || void 0),
                4 & e.$$.dirty[0] | 262144 & e.$$.dirty[7] | 134217728 & e.$$.dirty[11] && (i(235, lc = yt),
                yt && Ar.dispatchEvent(Th("loadpreview", lc))),
                131072 & e.$$.dirty[12] && hi && (vl.set(ke()),
                fl.set(void 0),
                wl(),
                uc.set([])),
                67108864 & e.$$.dirty[12] && i(307, A = Ci.index > 0),
                67108864 & e.$$.dirty[12] && i(306, I = Ci.index < Ci.length - 1),
                393216 & e.$$.dirty[1] | 24 & e.$$.dirty[12] && (z = [It, St, Vt, Ut]),
                8 & e.$$.dirty[1] && zc.set(Lc),
                33554432 & e.$$.dirty[12] && Fc.set(_i),
                4096 & e.$$.dirty[1] && fs.set(H),
                524288 & e.$$.dirty[9] | 64 & e.$$.dirty[11] && i(298, j = N.reduce(( (e, t) => (e[t.id] = j && j[t.id] || 0,
                e)), {})),
                4096 & e.$$.dirty[1] && i(79, U = {
                    name: Nc,
                    selected: H
                }),
                64 & e.$$.dirty[11] && i(329, q = N.map((e => ({
                    id: e.id,
                    icon: e.tabIcon,
                    label: e.tabLabel
                })))),
                64 & e.$$.dirty[11] && i(78, G = N.map((e => e.id))),
                524288 & e.$$.dirty[7] && i(77, Z = Pc(["PinturaRoot", "PinturaRootComponent", tn])),
                2 & e.$$.dirty[12] && i(343, Y = Ot && (Ot.width > 1e3 ? "wide" : Ot.width < 600 ? "narrow" : void 0)),
                2 & e.$$.dirty[12] && i(330, Q = Ot && (Ot.width <= 320 || Ot.height <= 460)),
                2 & e.$$.dirty[12] && i(342, J = Ot && (Ot.height > 1e3 ? "tall" : Ot.height < 600 ? "short" : void 0)),
                4 & e.$$.dirty[0] && i(309, ee = Ar && Ar.parentNode && Ar.parentNode.classList.contains("PinturaModal")),
                1 & e.$$.dirty[1] | 1073741824 & e.$$.dirty[9] | 2 & e.$$.dirty[12] && i(335, te = ee && Ot && hc > Ot.width),
                2 & e.$$.dirty[1] | 1073741824 & e.$$.dirty[9] | 2 & e.$$.dirty[12] && i(334, ie = ee && Ot && mc > Ot.height),
                50331648 & e.$$.dirty[10] && i(336, oe = te && ie),
                1048576 & e.$$.dirty[0] && i(333, ne = pr),
                4 & e.$$.dirty[11] && i(304, re = "narrow" === Y),
                4096 & e.$$.dirty[8] | 2 & e.$$.dirty[12] && i(344, (R = Ot,
                L = Nn,
                ae = Ot ? "auto" === L ? R.width > R.height ? "landscape" : "portrait" : "horizontal" === L ? R.width < 500 ? "portrait" : "landscape" : "vertical" === L ? R.height < 400 ? "landscape" : "portrait" : void 0 : "landscape")),
                8 & e.$$.dirty[11] && i(76, le = "landscape" === ae),
                33554432 & e.$$.dirty[9] | 2 & e.$$.dirty[11] && i(332, ce = re || "short" === J),
                1 & e.$$.dirty[1] | 2 & e.$$.dirty[12] && i(331, ue = Gc && Ot && hc === Ot.width && !fc),
                4 & e.$$.dirty[1] | 8388608 & e.$$.dirty[12] && i(305, de = [...wi || [], ...Dc].filter(Boolean)),
                8192 & e.$$.dirty[8] && i(341, pe = `has-navigation-preference-${Wn}`),
                16384 & e.$$.dirty[8] && i(340, he = `has-navigation-preference-${Hn}`),
                32768 & e.$$.dirty[8] && i(337, me = `has-toolbar-preference-${jn}`),
                65536 & e.$$.dirty[8] && i(339, fe = `has-controlgroups-preference-${Un}`),
                131072 & e.$$.dirty[8] && i(338, ge = `has-controltabs-preference-${Vn}`),
                2 & e.$$.dirty[12] && i(346, ye = void 0 !== Ot && Ot.width > 0 && Ot.height > 0),
                4 & e.$$.dirty[0] | 32 & e.$$.dirty[11] && i(345, $e = ye && Ar && getComputedStyle(Ar)),
                16 & e.$$.dirty[11] && $e && eu(),
                1024 & e.$$.dirty[0] | 4243456 & e.$$.dirty[1] | 34603008 & e.$$.dirty[7] | 1073741824 & e.$$.dirty[9] | 2146435072 & e.$$.dirty[10] | 15 & e.$$.dirty[11] | 6291712 & e.$$.dirty[12] && gc.set({
                    ...ei,
                    layoutMode: on,
                    orientation: ae,
                    horizontalSpace: Y,
                    verticalSpace: J,
                    navigationHorizontalPreference: pe,
                    navigationVerticalPreference: he,
                    controlGroupsVerticalPreference: fe,
                    controlTabsVerticalpreference: ge,
                    toolbarVerticalPreference: me,
                    isModal: ee,
                    isDisabled: un,
                    isCentered: oe,
                    isCenteredHorizontally: te,
                    isCenteredVertically: ie,
                    isAnimated: oi,
                    isTransparent: ne,
                    pointerAccuracy: xi,
                    pointerHoverable: vi,
                    isCompact: ce,
                    hasSwipeNavigation: ue,
                    hasLimitedSpace: Q,
                    hasToolbar: In,
                    hasNavigation: K && m,
                    isIOS: Gc,
                    browserVersion: Bl() ? `chrome-${(navigator.userAgent.match(/Chrome\/([0-9]+)/) || [])[1]}` : void 0
                }),
                256 & e.$$.dirty[12] && i(75, be = Object.entries(ei).map(( ([e,t]) => /^is|has/.test(e) ? t ? Mh(e) : void 0 : t)).filter(Boolean).join(" ")),
                4096 & e.$$.dirty[1] && H && Ic.set([]),
                4096 & e.$$.dirty[1] | 4 & e.$$.dirty[8] | 524288 & e.$$.dirty[10] | 256 & e.$$.dirty[12] && i(44, ve = kn(q.map((e => ({
                    ...e,
                    selected: H === e.id
                }))), {
                    ...ei
                }, ( () => na.set({})))),
                8192 & e.$$.dirty[1] && i(74, xe = !!ve.find((e => Array.isArray(e)))),
                1572864 & e.$$.dirty[12] && i(73, Se = $i && Object.entries(yi).filter(( ([,e]) => null != e)).reduce(( (e, [,t]) => ({
                    ...e,
                    ...t
                })), {})),
                65536 & e.$$.dirty[12] && i(326, Re = pi && "any-to-file" === pi.task),
                65536 & e.$$.dirty[10] && Re && Rc && Rc.clear(),
                262144 & e.$$.dirty[12] && i(328, _e = !!fi && !!fi.translation),
                16384 & e.$$.dirty[9] | 262144 & e.$$.dirty[10] | 134217728 & e.$$.dirty[11] && _e && yt && yt !== ou && (i(293, ou = yt),
                ( () => {
                    const e = Rc.length ? void 0 : {
                        resize: 1.05
                    }
                      , t = ( (e, t, i={}) => {
                        const {resize: o=1, opacity: n=0} = i
                          , r = {
                            opacity: [ic(n, {
                                ...Dh,
                                stiffness: .1
                            }), se],
                            resize: [ic(o, {
                                ...Dh,
                                stiffness: .1
                            }), se],
                            translation: [ic(void 0, Dh), se],
                            rotation: [ic(void 0, zh), se],
                            origin: [ic(void 0, Dh), se],
                            scale: [ic(void 0, zh), se],
                            gamma: [ic(void 0, zh), e => e || 1],
                            vignette: [ic(void 0, zh), e => e || 0],
                            colorMatrix: [ic([...Lh], Dh), e => e || [...Lh]],
                            convolutionMatrix: [ja(void 0), e => e && e.clarity || void 0],
                            backgroundColor: [ic(void 0, Dh), (e, t, i) => {
                                if (Array.isArray(e)) {
                                    if (Array.isArray(t)) {
                                        const o = [...e];
                                        0 === t[3] ? (o[3] = 0,
                                        i(o)) : 0 === o[3] && ((e = [...t])[3] = 0)
                                    }
                                    return e
                                }
                            }
                            ],
                            backgroundImage: [ja(void 0), se]
                        }
                          , a = Object.entries(r).map(( ([e,t]) => [e, t[0]]))
                          , s = a.map(( ([,e]) => e))
                          , l = Object.entries(r).reduce(( (e, [t,i]) => {
                            const [o,n] = i;
                            return e[t] = (e, i) => o.set(n(e, c[t], (e => {
                                o.set(e, {
                                    hard: !0
                                })
                            }
                            )), i),
                            e
                        }
                        ), {});
                        let c;
                        const u = Ua(s, (i => (c = i.reduce(( (e, t, i) => (e[a[i][0]] = t,
                        e)), {}),
                        c.data = e,
                        c.size = t,
                        c.scale *= i[1],
                        c)));
                        return u.get = () => c,
                        u.set = (e, t) => {
                            const i = {
                                hard: !t
                            };
                            Object.entries(e).forEach(( ([e,t]) => {
                                l[e] && l[e](t, i)
                            }
                            ))
                        }
                        ,
                        u
                    }
                    )(yt, _t, e);
                    Rc.unshift(t),
                    iu(fi)
                }
                )()),
                262144 & e.$$.dirty[10] | 262144 & e.$$.dirty[12] && _e && iu(fi),
                16777216 & e.$$.dirty[1] && mi && mi.length > 1) {
                    let e = [];
                    Rc.forEach(( (t, i) => {
                        0 !== i && t.get().opacity <= 0 && e.push(t)
                    }
                    )),
                    e.forEach((e => Rc.remove(e)))
                }
                if (8 & e.$$.dirty[0] | 131072 & e.$$.dirty[10] && i(39, Ee = rn && Te.length && rn.labelSupportError(Te)),
                65536 & e.$$.dirty[12] && i(318, Ae = pi && !!pi.error),
                65536 & e.$$.dirty[12] && i(42, Ie = !pi || !pi.complete && void 0 === pi.task),
                65536 & e.$$.dirty[12] && i(319, Le = pi && (pi.taskLengthComputable ? pi.taskProgress : 1 / 0)),
                65536 & e.$$.dirty[10] && Re && yr(nc, ui = !1, ui),
                4194304 & e.$$.dirty[1] | 32768 & e.$$.dirty[9] | 65536 & e.$$.dirty[12] && pi && pi.complete) {
                    const e = oi ? 250 : 0;
                    clearTimeout(ru),
                    i(294, ru = setTimeout(( () => {
                        yr(nc, ui = !0, ui)
                    }
                    ), e))
                }
                if (2048 & e.$$.dirty[1] | 256 & e.$$.dirty[10] | 81920 & e.$$.dirty[12] && i(323, Oe = pi && !Ae && !Ie && !ui),
                8192 & e.$$.dirty[9] | 134217728 & e.$$.dirty[11] | 131072 & e.$$.dirty[12] && i(322, Be = !(!hi || yt && !ac)),
                4194304 & e.$$.dirty[1] | 16384 & e.$$.dirty[12] && (ui ? setTimeout(( () => Jc.set(1, {
                    hard: !oi
                })), oi ? 500 : 0) : Jc.set(0, {
                    hard: !oi
                })),
                33280 & e.$$.dirty[12] && i(317, Ne = !!(ii || di && void 0 !== di.progress && !di.complete)),
                128 & e.$$.dirty[10] && Ne && Vr(),
                2048 & e.$$.dirty[1] | 65536 & e.$$.dirty[12] && i(320, We = pi && !(pi.error || Ie)),
                8 & e.$$.dirty[0] | 65536 & e.$$.dirty[12] && i(321, He = rn && (pi ? !pi.complete || pi.error ? gl(rn.statusLabelLoadImage(pi), pi.error && pi.error.metadata, "{", "}") : rn.statusLabelLoadImage({
                    progress: 1 / 0,
                    task: "blob-to-bitmap"
                }) : rn.statusLabelLoadImage(pi))),
                8 & e.$$.dirty[0] | 32768 & e.$$.dirty[12] && i(316, je = di && rn && rn.statusLabelProcessImage(di)),
                32768 & e.$$.dirty[12] && i(314, Ue = di && (di.taskLengthComputable ? di.taskProgress : 1 / 0)),
                32768 & e.$$.dirty[12] && i(315, Ve = di && !di.error),
                32768 & e.$$.dirty[12] && i(313, qe = !(!di || !di.error)),
                8 & e.$$.dirty[0] | 2048 & e.$$.dirty[1] | 131072 & e.$$.dirty[7] | 16376 & e.$$.dirty[10])
                    if (dn) {
                        let e, t, o, n, r;
                        W(dn) && (e = dn),
                        Wi(dn) ? t = dn : Array.isArray(dn) && ([e,t,r] = dn,
                        !1 === t && (n = !0),
                        Wi(t) && (o = !0)),
                        i(35, su = (e || t) && {
                            text: e,
                            aside: n || o,
                            progressIndicator: {
                                visible: o,
                                progress: t
                            },
                            closeButton: n && {
                                label: rn.statusLabelButtonClose,
                                icon: rn.statusIconButtonClose,
                                onclick: r || ( () => i(234, dn = void 0))
                            }
                        })
                    } else
                        i(35, su = rn && Ie || Ae || Oe || Be ? {
                            text: He,
                            aside: Ae || We,
                            progressIndicator: {
                                visible: We,
                                progress: Le
                            },
                            closeButton: Ae && {
                                label: rn.statusLabelButtonClose,
                                icon: rn.statusIconButtonClose,
                                onclick: mu
                            }
                        } : rn && Ne && je ? {
                            text: je,
                            aside: qe || Ve,
                            progressIndicator: {
                                visible: Ve,
                                progress: Ue
                            },
                            closeButton: qe && {
                                label: rn.statusLabelButtonClose,
                                icon: rn.statusIconButtonClose,
                                onclick: fu
                            }
                        } : void 0);
                if (131072 & e.$$.dirty[7] && i(325, Ge = void 0 !== dn),
                4194304 & e.$$.dirty[1] | 1073741824 & e.$$.dirty[9] | 32768 & e.$$.dirty[12] && ee && di && di.complete && (au.set(!0),
                setTimeout(( () => au.set(!1)), oi ? 100 : 0)),
                4 & e.$$.dirty[0] | 4096 & e.$$.dirty[1] | 16384 & e.$$.dirty[12] && ui && Ar && Ar.dispatchEvent(Th("selectutil", H)),
                2304 & e.$$.dirty[1] | 45440 & e.$$.dirty[10] | 8192 & e.$$.dirty[12] && i(324, Ke = ci || Ee || Ie || Ae || Oe || Be || Ne || Ge),
                16384 & e.$$.dirty[10] && yr(nu, li = Ke ? 1 : 0, li),
                4194304 & e.$$.dirty[1] | 16384 & e.$$.dirty[10] && nu.set(Ke ? 1 : 0, {
                    duration: oi ? 500 : 1
                }),
                8388608 & e.$$.dirty[1] && i(41, Xe = li > 0),
                16 & e.$$.dirty[1] && i(312, Ze = !(!su || !su.aside)),
                4195344 & e.$$.dirty[1] | 65536 & e.$$.dirty[9] | 4 & e.$$.dirty[10] | 4096 & e.$$.dirty[12] && Xe && su) {
                    clearTimeout(hu);
                    const e = {
                        hard: !1 === oi
                    };
                    if (Ze) {
                        const t = !!su.error || !oi;
                        cu.set(1, e),
                        lu.set(ai, {
                            hard: t
                        }),
                        i(295, hu = setTimeout(( () => {
                            uu.set(16, e)
                        }
                        ), 1))
                    } else
                        cu.set(0, e),
                        i(295, hu = setTimeout(( () => {
                            uu.set(0, e)
                        }
                        ), 1))
                }
                if (1024 & e.$$.dirty[1] && (Xe || (pu.set(void 0, {
                    hard: !0
                }),
                lu.set(void 0, {
                    hard: !0
                }),
                uu.set(0, {
                    hard: !0
                }))),
                2048 & e.$$.dirty[12] && i(311, Ye = .5 * ri),
                2 & e.$$.dirty[10] | 1024 & e.$$.dirty[12] && i(72, Qe = `transform: translateX(${ni - Ye}px)`),
                256 & e.$$.dirty[1] | 402653184 & e.$$.dirty[11] && i(38, dt = yt && _t && !Ee),
                128 & e.$$.dirty[1] | 1073741824 & e.$$.dirty[9] | 1 & e.$$.dirty[10] && i(308, tt = Je && (dt || ee) ? gu : $),
                536870912 & e.$$.dirty[9] && i(71, it = tt),
                536870912 & e.$$.dirty[9] && i(70, ot = tt),
                8 & e.$$.dirty[0] | 2097152 & e.$$.dirty[1] | 370 & e.$$.dirty[8] | 503316480 & e.$$.dirty[9] | 256 & e.$$.dirty[12] && i(69, nt = rn && ti && Bh(( () => _n([["div", "alpha", {
                    class: "PinturaNavGroup"
                }, [["div", "alpha-set", {
                    class: "PinturaNavSet"
                }, [Dn && ["Button", "close", {
                    label: rn.labelClose,
                    icon: rn.iconButtonClose,
                    onclick: () => en("close"),
                    hideLabel: !0
                }], En && ["Button", "revert", {
                    label: rn.labelButtonRevert,
                    icon: rn.iconButtonRevert,
                    disabled: !A,
                    onclick: wc,
                    hideLabel: !0
                }]]]]], ["div", "beta", {
                    class: "PinturaNavGroup PinturaNavGroupFloat"
                }, [An && ["div", "history", {
                    class: "PinturaNavSet"
                }, [["Button", "undo", {
                    label: rn.labelButtonUndo,
                    icon: rn.iconButtonUndo,
                    disabled: !A,
                    onclick: bc.undo,
                    hideLabel: !0
                }], ["Button", "redo", {
                    label: rn.labelButtonRedo,
                    icon: rn.iconButtonRedo,
                    disabled: !I,
                    onclick: bc.redo,
                    hideLabel: !0
                }]]], de.length && ["div", "plugin-tools", {
                    class: "PinturaNavSet"
                }, de.filter(Boolean).map(( ([e,t,i]) => [e, t, {
                    ...i
                }]))]]], ["div", "gamma", {
                    class: "PinturaNavGroup"
                }, [Pn && ["Button", "export", {
                    label: rn.labelButtonExport,
                    icon: re && rn.iconButtonExport,
                    class: "PinturaButtonExport",
                    onclick: Mc,
                    hideLabel: re
                }]]]], {
                    ...ei
                }, ( () => na.set({})))))),
                16 & e.$$.dirty[12] && i(300, st = Vt && !!Vt.length),
                2097152 & e.$$.dirty[9] | 268435456 & e.$$.dirty[11] | 16 & e.$$.dirty[12] && i(299, lt = st && Qn(_t, Vt)),
                3145728 & e.$$.dirty[9] | 134217728 & e.$$.dirty[11] | 192 & e.$$.dirty[12] && st && ( (e, t, o, n) => {
                    if (!t)
                        return;
                    const r = {
                        dataSizeScalar: o
                    };
                    n && n[3] > 0 && (r.backgroundColor = [...n]),
                    t(e, r).then((e => {
                        wu && E(wu),
                        i(296, wu = e)
                    }
                    ))
                }
                )(yt, Kt, lt, Gt),
                131072 & e.$$.dirty[9] | 268435456 & e.$$.dirty[11] | 48 & e.$$.dirty[12] && Vt && wu && _t) {
                    const {width: e, height: t} = _t
                      , o = si() ? "pixelated" : "auto" === qt ? "auto" : "pixelated";
                    i(297, _u = Vt.map((i => {
                        const n = bt(i.x, i.y, i.width, i.height)
                          , r = Et(pt(n), i.rotation).map((i => Ce(i.x / e, i.y / t)));
                        return {
                            ...i,
                            id: "redaction",
                            flipX: !1,
                            flipY: !1,
                            cornerRadius: 0,
                            strokeWidth: 0,
                            strokeColor: void 0,
                            backgroundColor: [0, 0, 0, 0],
                            backgroundImage: wu,
                            backgroundImageRendering: o,
                            backgroundCorners: r
                        }
                    }
                    )))
                }
                262144 & e.$$.dirty[9] | 8 & e.$$.dirty[12] && i(37, ct = [..._u, ...Ut || []]),
                32 & e.$$.dirty[1] && Su && ku.set(Su),
                4 & e.$$.dirty[0] | 128 & e.$$.dirty[1] && dt && Ar && Ar.dispatchEvent(Th("ready")),
                262144 & e.$$.dirty[1] && i(63, Bu = !0),
                1879048192 & e.$$.dirty[11] | 1 & e.$$.dirty[12] && i(64, Nu = !0),
                131072 & e.$$.dirty[1] && i(65, Wu = !0),
                65536 & e.$$.dirty[1] && i(66, ju = !0),
                64 & e.$$.dirty[1] && i(67, Uu = !0)
            }
            ,
            i(361, y = !Sc()),
            R = 1 === Hu() ? e => {
                e && (De(e.origin, Math.round),
                De(e.translation, Math.round))
            }
            : se,
            i(327, Te = [!Ih() && "WebGL"].filter(Boolean)),
            i(310, Je = ki() || L() && X()),
            i(68, ut = ( (e, t=!0) => i => {
                "ping" === i.type && (t && i.stopPropagation(),
                e(i.detail.type, i.detail.data))
            }
            )(Jo.pub)),
            [xr, Rr, Ar, rn, an, mn, gn, yn, bn, Sn, In, Bn, qn, Kn, Xn, Zn, er, nr, rr, ur, pr, hr, mr, gr, $r, br, vr, Pr, ha, sc, bc, hc, mc, Dc, Lc, su, Su, ct, dt, Ee, at, Xe, Ie, H, ve, m, K, $t, St, It, zt, Yt, ti, oi, li, mi, Ai, zi, Fi, uo, _r, kr, jc, Bu, Nu, Wu, ju, Uu, ut, nt, ot, it, Qe, Se, xe, be, le, Z, G, U, Mi, go, ko, Co, To, Mo, Po, Ao, Io, Lo, zo, Fo, Bo, No, Ho, jo, Uo, Vo, qo, Go, Ko, Xo, Zo, Lr, Dr, zr, Yr, na, ra, la, fa, ga, ya, $a, ba, va, wa, Sa, _a, ka, Ca, Ta, Ia, za, Fa, Oa, Ka, Xa, Za, Ya, Qa, Ja, es, is, os, ns, rs, as, ss, us, gs, ys, $s, bs, vs, xs, ws, Ss, _s, ks, Ts, Ms, Es, Is, Ds, zs, Fs, Os, Bs, Ns, Hs, js, Us, Vs, Gs, Ks, Xs, Zs, Qs, Js, el, tl, sl, ll, ul, pl, hl, fl, $l, bl, vl, Sl, _l, Cl, Hl, Kl, Xl, Zl, Yl, Ql, Jl, tc, nc, rc, cc, uc, dc, gc, $c, Tc, Rc, Ic, Bc, Uc, Vc, qc, (e, t) => t[e], e => N.find((t => t.id === e)).view, Zc, Yc, Qc, Jc, ({target: e, propertyName: t}) => {
                e === Ar && /background|outline/.test(t) && $e && eu()
            }
            , tu, nu, au, lu, cu, uu, du, pu, e => {
                const t = !(!su || !su.closeButton) || !oi;
                du.set(e.detail.width, {
                    hard: t
                }),
                pu.set(Math.round(.5 * -e.detail.width), {
                    hard: t
                })
            }
            , $u, bu, e => {
                const {keyCode: t, metaKey: i, ctrlKey: o, shiftKey: n} = e;
                if (9 === t && un)
                    return void e.preventDefault();
                if (e.target && 32 === t && Ar.contains(e.target) && !Gu(e.target) && (Zt && r && Gr(),
                e.preventDefault()),
                90 === t && (i || o))
                    return void (n && i ? bc.redo() : bc.undo());
                if (89 === t && o)
                    return void bc.redo();
                if (229 === t)
                    return;
                const a = new Set([...Xt, t]);
                bu.set(Array.from(a))
            }
            , ({key: e, keyCode: t}) => {
                if ("Meta" === e)
                    return bu.set([]);
                bu.set(Xt.filter((e => e !== t)))
            }
            , () => {
                bu.set([])
            }
            , e => {
                Gu(e.target) || e.preventDefault()
            }
            , e => {
                zn && vu(e.detail.resources[0])
            }
            , () => {
                On && Oh().then(xu)
            }
            , e => {
                if (!Fn)
                    return;
                const t = cs((window.innerWidth - Math.abs(Ot.x)) / Ot.width, 0, 1)
                  , i = cs((window.innerHeight - Math.abs(Ot.y)) / Ot.height, 0, 1);
                t < .75 && i < .75 || vu((e.clipboardData || window.clipboardData).files[0])
            }
            , Cu, Ou, e => {
                ft && Ct(e.detail, ft) || yr(Os, ft = e.detail, ft)
            }
            , dn, lc, tn, on, nn, sn, ln, cn, un, pn, hn, fn, $n, vn, wn, _n, kn, Mn, Pn, En, An, Ln, Dn, zn, Fn, On, Nn, Wn, Hn, jn, Un, Vn, Gn, tr, ir, or, ar, dr, fr, wr, () => i(60, _r = void 0), (e, t, o) => {
                const {text: n="", placeholder: r="", autoClose: a=!0, align: s="top", justify: l="center", buttonConfirm: c, buttonCancel: u} = o;
                i(60, _r = {
                    align: s,
                    justify: l,
                    text: n,
                    placeholder: r,
                    buttonConfirm: c,
                    buttonCancel: u,
                    onconfirm: () => {
                        e(kr.value),
                        a && i(60, _r = void 0)
                    }
                    ,
                    oncancel: () => {
                        t(void 0),
                        i(60, _r = void 0)
                    }
                })
            }
            , Cr, Tr, Mr, Er, Ur, Vr, qr, Gr, Kr, Xr, Zr, Qr, Jr, oa, sa, qs, ac, ou, ru, hu, wu, _u, j, lt, st, r, B, rt, re, de, I, A, tt, ee, Je, Ye, Ze, qe, Ue, Ve, je, Ne, Ae, Le, We, He, Be, Oe, Ke, Ge, Re, Te, _e, q, Q, ue, ce, ne, ie, te, oe, me, ge, fe, he, pe, J, Y, ae, $e, ye, N, F, O, o, P, _, M, C, k, S, x, w, h, v, y, b, s, d, a, u, n, yt, _t, Mt, Pt, At, Ot, Wt, Ut, Vt, qt, Gt, Kt, ei, ii, ni, ri, ai, ci, ui, di, pi, hi, fi, yi, $i, vi, xi, wi, Si, _i, Ci, Pi, Ei, Ri, Ii, Li, Di, Oi, Bi, ji, Xi, Yi, Ji, io, no, ro, co, po, ho, mo, $o, bo, vo, xo, wo, _o, function() {
                i(31, hc = qh.innerWidth),
                i(32, mc = qh.innerHeight)
            }
            , e => yr(Fs, To = e.detail, To), ({detail: e}) => i(43, H = e), function(t, o) {
                e.$$.not_equal(Rr[o], t) && (Rr[o] = t,
                i(1, Rr),
                i(278, Mr),
                i(27, Pr))
            }
            , e => Uc(e), e => Vc(e), (e, {detail: t}) => qc(e, t), e => yr(Ds, Mi = e.detail, Mi), function(t) {
                e.$$.not_equal(Rr[H], t) && (Rr[H] = t,
                i(1, Rr),
                i(278, Mr),
                i(27, Pr))
            }
            , () => Uc(H), () => Vc(H), ({detail: e}) => qc(H, e), e => {
                const t = {
                    ...e,
                    ...Cu()
                }
                  , {annotationShapes: i, decorationShapes: o, interfaceShapes: n, frameShapes: r, selectionShapes: a} = Sn({
                    annotationShapes: It,
                    decorationShapes: St,
                    interfaceShapes: Ho,
                    frameShapes: $t,
                    selectionShapes: uo
                }, t);
                return Ou(t, ct, i, o, n, r, a)
            }
            , () => {
                i(63, Bu = !1),
                i(64, Nu = !1),
                i(65, Wu = !1),
                i(66, ju = !1),
                i(67, Uu = !1)
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    Su = e,
                    i(36, Su)
                }
                ))
            }
            , function(e) {
                xr = e,
                i(0, xr),
                i(266, Gn)
            }
            , function(e) {
                Dc = e,
                i(33, Dc)
            }
            , function(e) {
                Lc = e,
                i(34, Lc)
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    kr = e,
                    i(61, kr)
                }
                ))
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    Ar = e,
                    i(2, Ar)
                }
                ))
            }
            , e => yr(Es, Yt = e.detail, Yt)]
        }
        class wm extends Na {
            constructor(e) {
                super(),
                Ba(this, e, xm, ym, ar, {
                    class: 236,
                    layout: 237,
                    stores: 238,
                    locale: 3,
                    id: 4,
                    util: 239,
                    utils: 240,
                    animations: 241,
                    disabled: 242,
                    status: 234,
                    previewUpscale: 243,
                    previewPad: 244,
                    previewMaskOpacity: 5,
                    previewImageDataMaxSize: 245,
                    previewImageTextPixelRatio: 6,
                    markupMaskOpacity: 7,
                    zoomMaskOpacity: 246,
                    elasticityMultiplier: 8,
                    willRevert: 247,
                    willProcessImage: 248,
                    willRenderCanvas: 9,
                    willRenderToolbar: 249,
                    willRenderUtilTabs: 250,
                    willSetHistoryInitialState: 251,
                    enableButtonExport: 252,
                    enableButtonRevert: 253,
                    enableNavigateHistory: 254,
                    enableToolbar: 10,
                    enableUtils: 255,
                    enableButtonClose: 256,
                    enableDropImage: 257,
                    enablePasteImage: 258,
                    enableBrowseImage: 259,
                    enableTransparencyGrid: 11,
                    layoutDirectionPreference: 260,
                    layoutHorizontalUtilsPreference: 261,
                    layoutVerticalUtilsPreference: 262,
                    layoutVerticalToolbarPreference: 263,
                    layoutVerticalControlGroupsPreference: 264,
                    layoutVerticalControlTabsPreference: 265,
                    textDirection: 12,
                    markupEditorZoomLevel: 266,
                    markupEditorZoomLevels: 13,
                    markupEditorZoomAdjustStep: 14,
                    markupEditorZoomAdjustFactor: 15,
                    markupEditorZoomAdjustWheelFactor: 16,
                    markupEditorInteractionMode: 267,
                    muteAudio: 268,
                    willSetMediaInitialTimeOffset: 269,
                    enablePan: 17,
                    enableZoom: 18,
                    enableZoomControls: 270,
                    enableZoomInput: 19,
                    enablePanInput: 271,
                    enableCanvasAlpha: 20,
                    enablePanLimit: 21,
                    panLimitGutterScalar: 22,
                    pan: 272,
                    zoomPresetOptions: 23,
                    zoomAdjustStep: 24,
                    zoomAdjustFactor: 25,
                    zoomAdjustWheelFactor: 26,
                    zoomLevel: 0,
                    fixScrollDirection: 273,
                    hideTextInput: 274,
                    showTextInput: 275,
                    imagePreviewSrc: 276,
                    imageOrienter: 277,
                    pluginComponents: 278,
                    pluginOptions: 27,
                    sub: 279,
                    pluginInterface: 1,
                    root: 2,
                    play: 280,
                    pause: 281,
                    isPaused: 282,
                    togglePlayPause: 283,
                    mute: 284,
                    unmute: 285,
                    toggleMute: 286,
                    getDuration: 287,
                    getCurrentTime: 288,
                    setCurrentTime: 289,
                    imageSourceToImageData: 28,
                    imagePreview: 29,
                    imagePreviewCurrent: 235,
                    history: 30
                }, null, [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1])
            }
            get class() {
                return this.$$.ctx[236]
            }
            set class(e) {
                this.$$set({
                    class: e
                }),
                $a()
            }
            get layout() {
                return this.$$.ctx[237]
            }
            set layout(e) {
                this.$$set({
                    layout: e
                }),
                $a()
            }
            get stores() {
                return this.$$.ctx[238]
            }
            set stores(e) {
                this.$$set({
                    stores: e
                }),
                $a()
            }
            get locale() {
                return this.$$.ctx[3]
            }
            set locale(e) {
                this.$$set({
                    locale: e
                }),
                $a()
            }
            get id() {
                return this.$$.ctx[4]
            }
            set id(e) {
                this.$$set({
                    id: e
                }),
                $a()
            }
            get util() {
                return this.$$.ctx[239]
            }
            set util(e) {
                this.$$set({
                    util: e
                }),
                $a()
            }
            get utils() {
                return this.$$.ctx[240]
            }
            set utils(e) {
                this.$$set({
                    utils: e
                }),
                $a()
            }
            get animations() {
                return this.$$.ctx[241]
            }
            set animations(e) {
                this.$$set({
                    animations: e
                }),
                $a()
            }
            get disabled() {
                return this.$$.ctx[242]
            }
            set disabled(e) {
                this.$$set({
                    disabled: e
                }),
                $a()
            }
            get status() {
                return this.$$.ctx[234]
            }
            set status(e) {
                this.$$set({
                    status: e
                }),
                $a()
            }
            get previewUpscale() {
                return this.$$.ctx[243]
            }
            set previewUpscale(e) {
                this.$$set({
                    previewUpscale: e
                }),
                $a()
            }
            get previewPad() {
                return this.$$.ctx[244]
            }
            set previewPad(e) {
                this.$$set({
                    previewPad: e
                }),
                $a()
            }
            get previewMaskOpacity() {
                return this.$$.ctx[5]
            }
            set previewMaskOpacity(e) {
                this.$$set({
                    previewMaskOpacity: e
                }),
                $a()
            }
            get previewImageDataMaxSize() {
                return this.$$.ctx[245]
            }
            set previewImageDataMaxSize(e) {
                this.$$set({
                    previewImageDataMaxSize: e
                }),
                $a()
            }
            get previewImageTextPixelRatio() {
                return this.$$.ctx[6]
            }
            set previewImageTextPixelRatio(e) {
                this.$$set({
                    previewImageTextPixelRatio: e
                }),
                $a()
            }
            get markupMaskOpacity() {
                return this.$$.ctx[7]
            }
            set markupMaskOpacity(e) {
                this.$$set({
                    markupMaskOpacity: e
                }),
                $a()
            }
            get zoomMaskOpacity() {
                return this.$$.ctx[246]
            }
            set zoomMaskOpacity(e) {
                this.$$set({
                    zoomMaskOpacity: e
                }),
                $a()
            }
            get elasticityMultiplier() {
                return this.$$.ctx[8]
            }
            set elasticityMultiplier(e) {
                this.$$set({
                    elasticityMultiplier: e
                }),
                $a()
            }
            get willRevert() {
                return this.$$.ctx[247]
            }
            set willRevert(e) {
                this.$$set({
                    willRevert: e
                }),
                $a()
            }
            get willProcessImage() {
                return this.$$.ctx[248]
            }
            set willProcessImage(e) {
                this.$$set({
                    willProcessImage: e
                }),
                $a()
            }
            get willRenderCanvas() {
                return this.$$.ctx[9]
            }
            set willRenderCanvas(e) {
                this.$$set({
                    willRenderCanvas: e
                }),
                $a()
            }
            get willRenderToolbar() {
                return this.$$.ctx[249]
            }
            set willRenderToolbar(e) {
                this.$$set({
                    willRenderToolbar: e
                }),
                $a()
            }
            get willRenderUtilTabs() {
                return this.$$.ctx[250]
            }
            set willRenderUtilTabs(e) {
                this.$$set({
                    willRenderUtilTabs: e
                }),
                $a()
            }
            get willSetHistoryInitialState() {
                return this.$$.ctx[251]
            }
            set willSetHistoryInitialState(e) {
                this.$$set({
                    willSetHistoryInitialState: e
                }),
                $a()
            }
            get enableButtonExport() {
                return this.$$.ctx[252]
            }
            set enableButtonExport(e) {
                this.$$set({
                    enableButtonExport: e
                }),
                $a()
            }
            get enableButtonRevert() {
                return this.$$.ctx[253]
            }
            set enableButtonRevert(e) {
                this.$$set({
                    enableButtonRevert: e
                }),
                $a()
            }
            get enableNavigateHistory() {
                return this.$$.ctx[254]
            }
            set enableNavigateHistory(e) {
                this.$$set({
                    enableNavigateHistory: e
                }),
                $a()
            }
            get enableToolbar() {
                return this.$$.ctx[10]
            }
            set enableToolbar(e) {
                this.$$set({
                    enableToolbar: e
                }),
                $a()
            }
            get enableUtils() {
                return this.$$.ctx[255]
            }
            set enableUtils(e) {
                this.$$set({
                    enableUtils: e
                }),
                $a()
            }
            get enableButtonClose() {
                return this.$$.ctx[256]
            }
            set enableButtonClose(e) {
                this.$$set({
                    enableButtonClose: e
                }),
                $a()
            }
            get enableDropImage() {
                return this.$$.ctx[257]
            }
            set enableDropImage(e) {
                this.$$set({
                    enableDropImage: e
                }),
                $a()
            }
            get enablePasteImage() {
                return this.$$.ctx[258]
            }
            set enablePasteImage(e) {
                this.$$set({
                    enablePasteImage: e
                }),
                $a()
            }
            get enableBrowseImage() {
                return this.$$.ctx[259]
            }
            set enableBrowseImage(e) {
                this.$$set({
                    enableBrowseImage: e
                }),
                $a()
            }
            get enableTransparencyGrid() {
                return this.$$.ctx[11]
            }
            set enableTransparencyGrid(e) {
                this.$$set({
                    enableTransparencyGrid: e
                }),
                $a()
            }
            get layoutDirectionPreference() {
                return this.$$.ctx[260]
            }
            set layoutDirectionPreference(e) {
                this.$$set({
                    layoutDirectionPreference: e
                }),
                $a()
            }
            get layoutHorizontalUtilsPreference() {
                return this.$$.ctx[261]
            }
            set layoutHorizontalUtilsPreference(e) {
                this.$$set({
                    layoutHorizontalUtilsPreference: e
                }),
                $a()
            }
            get layoutVerticalUtilsPreference() {
                return this.$$.ctx[262]
            }
            set layoutVerticalUtilsPreference(e) {
                this.$$set({
                    layoutVerticalUtilsPreference: e
                }),
                $a()
            }
            get layoutVerticalToolbarPreference() {
                return this.$$.ctx[263]
            }
            set layoutVerticalToolbarPreference(e) {
                this.$$set({
                    layoutVerticalToolbarPreference: e
                }),
                $a()
            }
            get layoutVerticalControlGroupsPreference() {
                return this.$$.ctx[264]
            }
            set layoutVerticalControlGroupsPreference(e) {
                this.$$set({
                    layoutVerticalControlGroupsPreference: e
                }),
                $a()
            }
            get layoutVerticalControlTabsPreference() {
                return this.$$.ctx[265]
            }
            set layoutVerticalControlTabsPreference(e) {
                this.$$set({
                    layoutVerticalControlTabsPreference: e
                }),
                $a()
            }
            get textDirection() {
                return this.$$.ctx[12]
            }
            set textDirection(e) {
                this.$$set({
                    textDirection: e
                }),
                $a()
            }
            get markupEditorZoomLevel() {
                return this.$$.ctx[266]
            }
            set markupEditorZoomLevel(e) {
                this.$$set({
                    markupEditorZoomLevel: e
                }),
                $a()
            }
            get markupEditorZoomLevels() {
                return this.$$.ctx[13]
            }
            set markupEditorZoomLevels(e) {
                this.$$set({
                    markupEditorZoomLevels: e
                }),
                $a()
            }
            get markupEditorZoomAdjustStep() {
                return this.$$.ctx[14]
            }
            set markupEditorZoomAdjustStep(e) {
                this.$$set({
                    markupEditorZoomAdjustStep: e
                }),
                $a()
            }
            get markupEditorZoomAdjustFactor() {
                return this.$$.ctx[15]
            }
            set markupEditorZoomAdjustFactor(e) {
                this.$$set({
                    markupEditorZoomAdjustFactor: e
                }),
                $a()
            }
            get markupEditorZoomAdjustWheelFactor() {
                return this.$$.ctx[16]
            }
            set markupEditorZoomAdjustWheelFactor(e) {
                this.$$set({
                    markupEditorZoomAdjustWheelFactor: e
                }),
                $a()
            }
            get markupEditorInteractionMode() {
                return this.$$.ctx[267]
            }
            set markupEditorInteractionMode(e) {
                this.$$set({
                    markupEditorInteractionMode: e
                }),
                $a()
            }
            get muteAudio() {
                return this.$$.ctx[268]
            }
            set muteAudio(e) {
                this.$$set({
                    muteAudio: e
                }),
                $a()
            }
            get willSetMediaInitialTimeOffset() {
                return this.$$.ctx[269]
            }
            set willSetMediaInitialTimeOffset(e) {
                this.$$set({
                    willSetMediaInitialTimeOffset: e
                }),
                $a()
            }
            get enablePan() {
                return this.$$.ctx[17]
            }
            set enablePan(e) {
                this.$$set({
                    enablePan: e
                }),
                $a()
            }
            get enableZoom() {
                return this.$$.ctx[18]
            }
            set enableZoom(e) {
                this.$$set({
                    enableZoom: e
                }),
                $a()
            }
            get enableZoomControls() {
                return this.$$.ctx[270]
            }
            set enableZoomControls(e) {
                this.$$set({
                    enableZoomControls: e
                }),
                $a()
            }
            get enableZoomInput() {
                return this.$$.ctx[19]
            }
            set enableZoomInput(e) {
                this.$$set({
                    enableZoomInput: e
                }),
                $a()
            }
            get enablePanInput() {
                return this.$$.ctx[271]
            }
            set enablePanInput(e) {
                this.$$set({
                    enablePanInput: e
                }),
                $a()
            }
            get enableCanvasAlpha() {
                return this.$$.ctx[20]
            }
            set enableCanvasAlpha(e) {
                this.$$set({
                    enableCanvasAlpha: e
                }),
                $a()
            }
            get enablePanLimit() {
                return this.$$.ctx[21]
            }
            set enablePanLimit(e) {
                this.$$set({
                    enablePanLimit: e
                }),
                $a()
            }
            get panLimitGutterScalar() {
                return this.$$.ctx[22]
            }
            set panLimitGutterScalar(e) {
                this.$$set({
                    panLimitGutterScalar: e
                }),
                $a()
            }
            get pan() {
                return this.$$.ctx[272]
            }
            set pan(e) {
                this.$$set({
                    pan: e
                }),
                $a()
            }
            get zoomPresetOptions() {
                return this.$$.ctx[23]
            }
            set zoomPresetOptions(e) {
                this.$$set({
                    zoomPresetOptions: e
                }),
                $a()
            }
            get zoomAdjustStep() {
                return this.$$.ctx[24]
            }
            set zoomAdjustStep(e) {
                this.$$set({
                    zoomAdjustStep: e
                }),
                $a()
            }
            get zoomAdjustFactor() {
                return this.$$.ctx[25]
            }
            set zoomAdjustFactor(e) {
                this.$$set({
                    zoomAdjustFactor: e
                }),
                $a()
            }
            get zoomAdjustWheelFactor() {
                return this.$$.ctx[26]
            }
            set zoomAdjustWheelFactor(e) {
                this.$$set({
                    zoomAdjustWheelFactor: e
                }),
                $a()
            }
            get zoomLevel() {
                return this.$$.ctx[0]
            }
            set zoomLevel(e) {
                this.$$set({
                    zoomLevel: e
                }),
                $a()
            }
            get fixScrollDirection() {
                return this.$$.ctx[273]
            }
            set fixScrollDirection(e) {
                this.$$set({
                    fixScrollDirection: e
                }),
                $a()
            }
            get hideTextInput() {
                return this.$$.ctx[274]
            }
            get showTextInput() {
                return this.$$.ctx[275]
            }
            get imagePreviewSrc() {
                return this.$$.ctx[276]
            }
            set imagePreviewSrc(e) {
                this.$$set({
                    imagePreviewSrc: e
                }),
                $a()
            }
            get imageOrienter() {
                return this.$$.ctx[277]
            }
            set imageOrienter(e) {
                this.$$set({
                    imageOrienter: e
                }),
                $a()
            }
            get pluginComponents() {
                return this.$$.ctx[278]
            }
            set pluginComponents(e) {
                this.$$set({
                    pluginComponents: e
                }),
                $a()
            }
            get pluginOptions() {
                return this.$$.ctx[27]
            }
            set pluginOptions(e) {
                this.$$set({
                    pluginOptions: e
                }),
                $a()
            }
            get sub() {
                return this.$$.ctx[279]
            }
            get pluginInterface() {
                return this.$$.ctx[1]
            }
            get root() {
                return this.$$.ctx[2]
            }
            set root(e) {
                this.$$set({
                    root: e
                }),
                $a()
            }
            get play() {
                return this.$$.ctx[280]
            }
            get pause() {
                return this.$$.ctx[281]
            }
            get isPaused() {
                return this.$$.ctx[282]
            }
            get togglePlayPause() {
                return this.$$.ctx[283]
            }
            get mute() {
                return this.$$.ctx[284]
            }
            get unmute() {
                return this.$$.ctx[285]
            }
            get toggleMute() {
                return this.$$.ctx[286]
            }
            get getDuration() {
                return this.$$.ctx[287]
            }
            get getCurrentTime() {
                return this.$$.ctx[288]
            }
            get setCurrentTime() {
                return this.$$.ctx[289]
            }
            get imageSourceToImageData() {
                return this.$$.ctx[28]
            }
            set imageSourceToImageData(e) {
                this.$$set({
                    imageSourceToImageData: e
                }),
                $a()
            }
            get imagePreview() {
                return this.$$.ctx[29]
            }
            get imagePreviewCurrent() {
                return this.$$.ctx[235]
            }
            set imagePreviewCurrent(e) {
                this.$$set({
                    imagePreviewCurrent: e
                }),
                $a()
            }
            get history() {
                return this.$$.ctx[30]
            }
        }
        const Sm = ["klass", "stores", "isVisible", "isActive", "isActiveFraction", "locale"]
          , _m = ["history", "klass", "stores", "navButtons", "pluginComponents", "pluginInterface", "pluginOptions", "sub", "imagePreviewSrc", "imagePreview", "imagePreviewCurrent"]
          , km = ["locale"];
        let Cm;
        const Tm = new Set([])
          , Mm = {}
          , Pm = new Map;
        var Em = [...vs, "init", "update", "undo", "redo", "revert", "writehistory", "destroy", "show", "hide", "close", "ready", "zoom", "pan", "loadpreview", "selectshape", "blurshape", "updateshape", "addshape", "removeshape", "selectstyle", "markuptap", "markupzoom", "markuppan", "selectutil", "selectcontrol", "selectiondown", "selectionup", "selectionchange"];
        const Rm = e => !(e => W(e[0]))(e)
          , Am = e => e[1]
          , Im = e => e[3] || []
          , Lm = (e, t) => {
            if (Rm(t)) {
                if (t.find((t => Am(t) === e)))
                    return t;
                const i = t.find((t => Lm(e, Im(t))));
                return i && i[3]
            }
            return Lm(e, Im(t))
        }
        ;
        var Dm = {
            filterFunctions: {
                chrome: () => [1.398, -.316, .065, -.273, .201, -.051, 1.278, -.08, -.273, .201, -.051, .119, 1.151, -.29, .215, 0, 0, 0, 1, 0],
                fade: () => [1.073, -.015, .092, -.115, -.017, .107, .859, .184, -.115, -.017, .015, .077, 1.104, -.115, -.017, 0, 0, 0, 1, 0],
                pastel: () => [.75, .25, .25, 0, 0, .25, .75, .25, 0, 0, .25, .25, .75, 0, 0, 0, 0, 0, 1, 0],
                cold: () => [1.1, 0, 0, 0, -.1, 0, 1.1, 0, 0, -.1, 0, 0, 1.2, 0, -.1, 0, 0, 0, 1, 0],
                warm: () => [1.06, 0, 0, 0, 0, 0, 1.01, 0, 0, 0, 0, 0, .93, 0, 0, 0, 0, 0, 1, 0],
                monoDefault: () => [.212, .715, .114, 0, 0, .212, .715, .114, 0, 0, .212, .715, .114, 0, 0, 0, 0, 0, 1, 0],
                monoWash: () => [.163, .518, .084, -.01, .208, .163, .529, .082, -.02, .21, .171, .529, .084, 0, .214, 0, 0, 0, 1, 0],
                monoNoir: () => [.15, 1.3, -.25, .1, -.2, .15, 1.3, -.25, .1, -.2, .15, 1.3, -.25, .1, -.2, 0, 0, 0, 1, 0],
                monoStark: () => [.338, .991, .117, .093, -.196, .302, 1.049, .096, .078, -.196, .286, 1.016, .146, .101, -.196, 0, 0, 0, 1, 0],
                sepiaDefault: () => [.393, .768, .188, 0, 0, .349, .685, .167, 0, 0, .272, .533, .13, 0, 0, 0, 0, 0, 1, 0],
                sepiaRust: () => [.269, .764, .172, .05, .1, .239, .527, .152, 0, .176, .186, .4, .119, 0, .159, 0, 0, 0, 1, 0],
                sepiaBlues: () => [.289, .62, .185, 0, .077, .257, .566, .163, 0, .115, .2, .43, .128, 0, .188, 0, 0, 0, 1, 0],
                sepiaColor: () => [.547, .764, .134, 0, -.147, .281, .925, .12, 0, -.135, .225, .558, .33, 0, -.113, 0, 0, 0, 1, 0]
            },
            filterOptions: [["Default", [[void 0, e => e.labelDefault]]], ["Classic", [["chrome", e => e.filterLabelChrome], ["fade", e => e.filterLabelFade], ["cold", e => e.filterLabelCold], ["warm", e => e.filterLabelWarm], ["pastel", e => e.filterLabelPastel]]], ["Monochrome", [["monoDefault", e => e.filterLabelMonoDefault], ["monoNoir", e => e.filterLabelMonoNoir], ["monoStark", e => e.filterLabelMonoStark], ["monoWash", e => e.filterLabelMonoWash]]], ["Sepia", [["sepiaDefault", e => e.filterLabelSepiaDefault], ["sepiaRust", e => e.filterLabelSepiaRust], ["sepiaBlues", e => e.filterLabelSepiaBlues], ["sepiaColor", e => e.filterLabelSepiaColor]]]]
        }
          , zm = {
            finetuneControlConfiguration: {
                gamma: {
                    base: 1,
                    min: .15,
                    max: 4,
                    getLabel: e => Wh(e < 1 ? (e - .15) / .85 - 1 : (e - 1) / 3),
                    getStore: ({imageGamma: e}) => e
                },
                brightness: {
                    base: 0,
                    min: -.25,
                    max: .25,
                    getLabel: e => Wh(e / .25),
                    getStore: ({imageColorMatrix: e}) => e,
                    getValue: e => {
                        if (e.brightness)
                            return e.brightness[4]
                    }
                    ,
                    setValue: (e, t) => e.update((e => ({
                        ...e,
                        brightness: [1, 0, 0, 0, t, 0, 1, 0, 0, t, 0, 0, 1, 0, t, 0, 0, 0, 1, 0]
                    })))
                },
                contrast: {
                    base: 1,
                    min: .5,
                    max: 1.5,
                    getLabel: e => Wh(2 * (e - .5) - 1),
                    getStore: ({imageColorMatrix: e}) => e,
                    getValue: e => {
                        if (e.contrast)
                            return e.contrast[0]
                    }
                    ,
                    setValue: (e, t) => e.update((e => ({
                        ...e,
                        contrast: [t, 0, 0, 0, .5 * (1 - t), 0, t, 0, 0, .5 * (1 - t), 0, 0, t, 0, .5 * (1 - t), 0, 0, 0, 1, 0]
                    })))
                },
                saturation: {
                    base: 1,
                    min: 0,
                    max: 2,
                    getLabel: e => Wh(e - 1),
                    getStore: ({imageColorMatrix: e}) => e,
                    getValue: e => {
                        if (e.saturation)
                            return (e.saturation[0] - .213) / .787
                    }
                    ,
                    setValue: (e, t) => e.update((e => ({
                        ...e,
                        saturation: [.213 + .787 * t, .715 - .715 * t, .072 - .072 * t, 0, 0, .213 - .213 * t, .715 + .285 * t, .072 - .072 * t, 0, 0, .213 - .213 * t, .715 - .715 * t, .072 + .928 * t, 0, 0, 0, 0, 0, 1, 0]
                    })))
                },
                exposure: {
                    base: 1,
                    min: .5,
                    max: 1.5,
                    getLabel: e => Wh(2 * (e - .5) - 1),
                    getStore: ({imageColorMatrix: e}) => e,
                    getValue: e => {
                        if (e.exposure)
                            return e.exposure[0]
                    }
                    ,
                    setValue: (e, t) => e.update((e => ({
                        ...e,
                        exposure: [t, 0, 0, 0, 0, 0, t, 0, 0, 0, 0, 0, t, 0, 0, 0, 0, 0, 1, 0]
                    })))
                },
                temperature: {
                    base: 0,
                    min: -1,
                    max: 1,
                    getStore: ({imageColorMatrix: e}) => e,
                    getValue: e => {
                        if (!e.temperature)
                            return;
                        const t = e.temperature[0];
                        return t >= 1 ? (t - 1) / .1 : (1 - t) / -.15
                    }
                    ,
                    setValue: (e, t) => e.update((e => ({
                        ...e,
                        temperature: t > 0 ? [1 + .1 * t, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1 + .1 * -t, 0, 0, 0, 0, 0, 1, 0] : [1 + .15 * t, 0, 0, 0, 0, 0, 1 + .05 * t, 0, 0, 0, 0, 0, 1 + .15 * -t, 0, 0, 0, 0, 0, 1, 0]
                    })))
                },
                clarity: {
                    base: 0,
                    min: -1,
                    max: 1,
                    getStore: ({imageConvolutionMatrix: e}) => e,
                    getValue: e => {
                        if (e.clarity)
                            return 0 === e.clarity[0] ? e.clarity[1] / -1 : e.clarity[1] / -2
                    }
                    ,
                    setValue: (e, t) => {
                        e.update((e => ({
                            ...e,
                            clarity: t >= 0 ? [0, -1 * t, 0, -1 * t, 1 + 4 * t, -1 * t, 0, -1 * t, 0] : [-1 * t, -2 * t, -1 * t, -2 * t, 1 + -3 * t, -2 * t, -1 * t, -2 * t, -1 * t]
                        })))
                    }
                },
                vignette: {
                    base: 0,
                    min: -1,
                    max: 1,
                    getStore: ({imageVignette: e}) => e
                }
            },
            finetuneOptions: [["brightness", e => e.finetuneLabelBrightness], ["contrast", e => e.finetuneLabelContrast], ["saturation", e => e.finetuneLabelSaturation], ["exposure", e => e.finetuneLabelExposure], ["temperature", e => e.finetuneLabelTemperature], ["gamma", e => e.finetuneLabelGamma], !Sc() && ["clarity", e => e.finetuneLabelClarity], ["vignette", e => e.finetuneLabelVignette]].filter(Boolean)
        }
          , Fm = e => e.charAt(0).toUpperCase() + e.slice(1);
        let Om = null;
        var Bm = () => {
            if (null === Om)
                if (_())
                    try {
                        Om = !1 === document.fonts.check("16px TestNonExistingFont")
                    } catch (e) {
                        Om = !1
                    }
                else
                    Om = !1;
            return Om
        }
        ;
        const Nm = (e, t) => i => i[t ? `${t}${Fm(e)}` : e]
          , Wm = e => [e, `${e}`]
          , Hm = (e, t) => i => [e[i], Nm(i, t)]
          , jm = e => Array.isArray(e) && e.every(Wi) ? e.map(Wm) : e
          , Um = [1, .2549, .2118]
          , Vm = "0.5%"
          , qm = [1, 1, 1, 0]
          , Gm = {
            eraser: () => ({
                eraseRadius: 8,
                cursorStyle: "ellipse",
                cursorSize: "eraseRadius"
            }),
            path: () => ({
                points: [],
                disableAddPoints: !1
            }),
            line: () => ({
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 0,
                disableErase: !1
            }),
            rectangle: () => ({
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }),
            ellipse: () => ({
                x: 0,
                y: 0,
                rx: 0,
                ry: 0
            }),
            text: () => ({
                x: 0,
                y: 0,
                text: "Text"
            })
        }
          , Km = (e, t={}, i) => {
            if (!Gm[e])
                return;
            const {position: o="relative", inputMode: n="drag", isSelection: r=!1} = i || {};
            return [{
                ...Gm[e](),
                ...t
            }, {
                position: o,
                inputMode: n,
                isSelection: r
            }]
        }
          , Xm = (e, t, i) => [e, t || Nm(e, "shapeLabelTool"), {
            icon: Nm(e, "shapeIconTool"),
            ...i
        }]
          , Zm = e => Object.keys(e).map(Hm(e, "labelSize"))
          , Ym = (e, t) => {
            const {defaultKey: i, defaultValue: o, defaultOptions: n} = t || {}
              , r = [];
            return i && (r[0] = [o, e => e[i], {
                ...n
            }]),
            [...r, ...e]
        }
          , Qm = e => e.split(",").map((e => e.trim())).some((e => document.fonts.check(`16px ${e}`)))
          , Jm = (e={}) => ["ToggleSlider", {
            ...e
        }]
          , ef = "PinturaFontTest"
          , tf = (e, t={}) => ["ColorPicker", {
            options: Ym(e),
            ...t
        }]
          , of = e => (t, i={}) => tf(t, {
            title: t => t[e],
            ...i
        })
          , nf = of("shapeTitleBackgroundColor")
          , rf = of("shapeTitleTextColor")
          , af = (e, t) => {
            const {title: i, optionHideLabel: o=!1, layout: n, optionIcon: r=!1} = t || {}
              , a = jm(e)
              , s = e.map(( ([e]) => W(e) ? parseFloat(e) : e))
              , l = Math.max(...s)
              , c = Math.min(...s)
              , u = l - c;
            return ["radio" === n ? "RadioGroup" : "Dropdown", {
                title: !1 === i ? void 0 : i || (e => e.shapeTitleStrokeWidth),
                options: e => {
                    const i = t ? a.map((e => {
                        const [t,i,n={}] = e
                          , a = W(t) ? parseFloat(t) : t
                          , s = (a - c) / u;
                        let l;
                        return "line" === r ? l = `<path stroke="currentColor" stroke-linecap="square" stroke-width="${.1 + .875 * s}em" d="M3,12 H20"/>` : "dot" === r ? l = `<circle fill="currentColor" cx="12" cy="12" r="${2 + 8 * s}"/>` : W(r) ? l = r : H(r) && (l = r(a, s)),
                        [t, i, {
                            icon: l,
                            hideLabel: o,
                            ...n
                        }]
                    }
                    )) : a;
                    return ji(e, "backgroundColor") ? Ym(i, {
                        defaultKey: "shapeLabelStrokeNone"
                    }) : Ym(i)
                }
                ,
                onchange: (e, t) => {
                    if (!e)
                        return;
                    const i = t.strokeColor || [];
                    if (i[3])
                        return;
                    const o = [...i];
                    o[3] = 1,
                    t.strokeColor = o
                }
            }]
        }
          , sf = (e, t, i) => ["Dropdown", {
            title: e => e[t],
            options: Ym(e, {
                defaultKey: "labelNone",
                defaultOptions: {
                    icon: '<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H14"/></g>'
                }
            }),
            optionIconStyle: i
        }]
          , lf = e => ["ShorthandControl", e]
          , cf = (e, t, i, o) => {
            o || e.find(( ([e]) => e === i)) || (o = {
                defaultKey: "labelAuto",
                defaultValue: i
            });
            const n = jm(e);
            return ["Dropdown", {
                title: t,
                options: Ym(n, o),
                ...o
            }]
        }
          , uf = {
            colorOptions: () => {
                return e = {
                    transparent: [1, 1, 1, 0],
                    white: [1, 1, 1],
                    silver: [.8667, .8667, .8667],
                    gray: [.6667, .6667, .6667],
                    black: [0, 0, 0],
                    navy: [0, .1216, .2471],
                    blue: [0, .4549, .851],
                    aqua: [.498, .8588, 1],
                    teal: [.2235, .8, .8],
                    olive: [.2392, .6, .4392],
                    green: [.1804, .8, .251],
                    yellow: [1, .8627, 0],
                    orange: [1, .5216, .1059],
                    red: [1, .2549, .2118],
                    maroon: [.5216, .0784, .2941],
                    fuchsia: [.9412, .0706, .7451],
                    purple: [.6941, .051, .7882]
                },
                Object.keys(e).map(Hm(e, "shapeTitleColor"));
                var e
            }
            ,
            lineEndStyleOptions: () => ["bar", "arrow", "arrowSolid", "circle", "circleSolid", "square", "squareSolid"].map((e => [Mh(e), t => t[`shapeTitleLineDecoration${Fm(e)}`], {
                icon: t => t[`shapeIconLineDecoration${Fm(e)}`]
            }])),
            fontFamilyOptions: () => {
                return e = [["Helvetica, Arial, Verdana, 'Droid Sans', sans-serif", "Sans Serif"], ["'Arial Black', 'Avenir-Black', 'Arial Bold'", "Black"], ["'Arial Narrow', 'Futura-CondensedMedium'", "Narrow"], ["'Trebuchet MS'", "Humanist"], ["Georgia, 'Avenir-Black', 'Times New Roman', 'Droid Serif', serif", "Serif"], ["Palatino", "Old-Style"], ["'Times New Roman', 'TimesNewRomanPSMT'", "Transitional"], ["Menlo, Monaco, 'Lucida Console', monospace", "Monospaced"], ["'Courier New', monospace", "Slab Serif"]],
                [...e];
                var e
            }
            ,
            fontStyleOptions: () => [["normal", "bold"], ["italic", "normal"], ["italic", "bold"]].map((e => [e, t => t[`shapeLabelFontStyle${e.filter((e => "normal" !== e)).map(Fm).join("")}`]])),
            textAlignOptions: () => ["left", "center", "right"].map((e => [e, t => t[`shapeTitleTextAlign${Fm(e)}`], {
                hideLabel: !0,
                icon: t => t[`shapeIconTextAlign${Fm(e)}`]
            }])),
            strokeWidthOptions: () => Zm({
                extraSmall: "0.25%",
                small: "0.5%",
                mediumSmall: "1%",
                medium: "1.75%",
                mediumLarge: "2.5%",
                large: "3.5%",
                extraLarge: "5%"
            }),
            brushSizeOptions: () => Zm(Object.entries({
                extraSmall: "0.25%",
                small: "0.5%",
                mediumSmall: "1%",
                medium: "1.75%",
                mediumLarge: "2.5%",
                large: "3.5%",
                extraLarge: "5%"
            }).reduce(( (e, [t,i]) => (e[t] = 2 * parseFloat(i) + "%",
            e)), {})),
            fontSizeOptions: () => {
                return e = {
                    extraSmall: "2%",
                    small: "4%",
                    mediumSmall: "8%",
                    medium: "10%",
                    mediumLarge: "15%",
                    large: "20%",
                    extraLarge: "25%"
                },
                Object.keys(e).map(Hm(e, "labelSize"));
                var e
            }
            ,
            lineHeightOptions: () => {
                return e = {
                    extraSmall: "40%",
                    small: "60%",
                    mediumSmall: "100%",
                    medium: "120%",
                    mediumLarge: "140%",
                    large: "180%",
                    extraLarge: "220%"
                },
                Object.keys(e).map(Hm(e, "labelSize"));
                var e
            }
        }
          , df = new Intl.NumberFormat("default",{
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        })
          , pf = (e, t) => W(t) ? `${e}%` : e
          , hf = (e, t, i, o) => W(o) ? `${Math.round(e / i * 100)}%` : `${df.format(e)}`
          , mf = {
            getValue: e => parseFloat(e),
            setValue: pf,
            label: hf,
            step: .05,
            labelClass: "PinturaPercentageLabel"
        }
          , ff = {
            factory: lf,
            options: {
                title: "Text shadow",
                controls: [["ToggleSlider", "x", {
                    ...mf,
                    min: -100,
                    max: 100,
                    labelPrefix: "X"
                }], ["ToggleSlider", "y", {
                    ...mf,
                    min: -100,
                    max: 100,
                    labelPrefix: "Y"
                }], ["ToggleSlider", "blur", {
                    ...mf,
                    min: 0,
                    max: 25,
                    labelPrefix: e => e.shapeTitleTextShadowBlur
                }], ["ColorPicker", "color", {
                    enablePresets: !1
                }]]
            }
        }
          , gf = {
            defaultColor: {
                factory: (e, t={}) => tf(e, {
                    title: e => e.labelColor,
                    ...t
                }),
                items: "colorOptions"
            },
            defaultNumber: {
                factory: Jm
            },
            defaultPercentage: {
                factory: Jm,
                options: {
                    getValue: e => parseFloat(e),
                    setValue: e => `${e}%`,
                    step: .05,
                    label: (e, t, i) => `${Math.round(e / i * 100)}%`,
                    labelClass: "PinturaPercentageLabel"
                }
            },
            backgroundColor: {
                items: "colorOptions",
                factory: nf
            },
            strokeColor: {
                items: "colorOptions",
                factory: (e, t={}) => tf(e, {
                    title: e => e.shapeTitleStrokeColor,
                    options: Ym(e),
                    buttonClass: "PinturaColorPickerButtonStroke",
                    onchange: (e, i) => {
                        const o = i.strokeWidth;
                        (Wi(o) || W(o) ? parseFloat(o) : 0) > 0 || (i.strokeWidth = t && t.defaultStrokeWidth || "0.5%")
                    }
                    ,
                    ...t
                })
            },
            strokeWidth: {
                items: "strokeWidthOptions",
                factory: af
            },
            brushSize: {
                items: "brushSizeOptions",
                factory: e => af(e, {
                    title: e => e.shapeTitleBrushSize,
                    layout: "radio",
                    optionHideLabel: !0,
                    optionIcon: (e, t) => `<circle fill="currentColor" stroke-width=".05em" stroke="currentColor" fill-opacity=".25" cx="12" cy="12" r="${2 + 8 * t}"/>`
                })
            },
            drawMode: {
                factory: e => {
                    const {hideLabel: t=!0} = e || {};
                    return ( (e, t) => {
                        const {title: i, layout: o} = t || {};
                        return ["radio" === o ? "RadioGroup" : "Dropdown", {
                            title: i,
                            options: Ym(e)
                        }]
                    }
                    )(["new", "add", "subtract"].map((e => [e, Nm(e, "shapeLabelSelectionMode"), {
                        icon: Nm(e, "shapeIconSelectionMode"),
                        hideLabel: t
                    }])), {
                        title: e => e.shapeTitleSelectionMode,
                        layout: "radio"
                    })
                }
            },
            lineStart: {
                items: "lineEndStyleOptions",
                factory: e => sf(e, "shapeTitleLineStart", "transform: scaleX(-1)")
            },
            lineEnd: {
                items: "lineEndStyleOptions",
                factory: e => sf(e, "shapeTitleLineEnd")
            },
            color: {
                items: "colorOptions",
                factory: rf
            },
            fontFamily: {
                items: "fontFamilyOptions",
                factory: (e, t={
                    defaultKey: "labelDefault"
                }) => ["Dropdown", {
                    title: e => e.shapeTitleFontFamily,
                    onload: ({options: e=[]}) => {
                        Bm() && e.map(( ([e]) => e)).filter(Boolean).filter((e => !Qm(e))).forEach((e => {
                            const t = `${ef}-${e.replace(/[^a-zA-Z0-9]+/g, "").toLowerCase()}`;
                            document.getElementById(t) || document.body.append(M("span", {
                                textContent: " ",
                                id: t,
                                class: ef,
                                style: `font-family:${e};font-size:0;color:transparent;`
                            }))
                        }
                        ))
                    }
                    ,
                    ondestroy: () => {
                        Bm() && document.querySelectorAll(".PinturaFontTest").forEach((e => e.remove()))
                    }
                    ,
                    optionLabelStyle: e => `font-family: ${e}`,
                    options: Ym(e, t),
                    optionFilter: e => {
                        if (!Bm())
                            return !0;
                        const [t] = e;
                        return !t || Qm(t)
                    }
                }]
            },
            fontStyle_fontWeight: {
                items: "fontStyleOptions",
                factory: e => ["Dropdown", {
                    title: e => e.shapeTitleFontStyle,
                    optionLabelStyle: e => e && `font-style:${e[0]};font-weight:${e[1]}`,
                    options: Ym(e, {
                        defaultKey: "shapeLabelFontStyleNormal"
                    })
                }]
            },
            fontSize: {
                items: "fontSizeOptions",
                factory: (e, t) => cf(e, (e => e.shapeTitleFontSize), "4%", t)
            },
            lineHeight: {
                items: "lineHeightOptions",
                factory: (e, t) => cf(e, (e => e.shapeTitleLineHeight), "120%", t)
            },
            textAlign: {
                items: "textAlignOptions",
                factory: e => ["RadioGroup", {
                    title: e => e.shapeTitleTextAlign,
                    options: Ym(e)
                }]
            },
            textShadowX_textShadowY_textShadowBlur_textShadowColor: ff,
            textOutlineWidth_textOutlineColor: {
                factory: lf,
                options: {
                    title: "Text outline",
                    controls: [["ToggleSlider", "width", {
                        getValue: e => parseFloat(e),
                        setValue: pf,
                        label: hf,
                        min: 0,
                        max: 15,
                        step: .05,
                        labelClass: "PinturaPercentageLabel",
                        labelPrefix: e => e.shapeTitleTextOutlineWidth
                    }], ["ColorPicker", "color", {
                        enablePresets: !1
                    }]]
                }
            },
            cornerRadius: {
                factory: "defaultPercentage",
                options: {
                    min: 0,
                    max: 50,
                    title: e => e.shapeTitleCornerRadius
                }
            },
            frameColor: {
                factory: "defaultColor"
            },
            frameSize: {
                factory: "defaultPercentage",
                options: {
                    min: .2,
                    max: 10,
                    title: e => e.labelSize
                }
            },
            frameInset: {
                factory: "defaultPercentage",
                options: {
                    min: .5,
                    max: 10,
                    title: e => e.labelOffset
                }
            },
            frameOffset: {
                factory: "defaultPercentage",
                options: {
                    min: .5,
                    max: 10,
                    title: e => e.labelOffset
                }
            },
            frameRadius: {
                factory: "defaultPercentage",
                options: {
                    min: .5,
                    max: 10,
                    title: e => e.labelRadius
                }
            },
            frameAmount: {
                factory: "defaultNumber",
                options: {
                    min: 1,
                    max: 5,
                    step: 1,
                    title: e => e.labelAmount
                }
            }
        }
          , yf = (e={}) => {
            const t = {
                ...gf,
                ...e
            }
              , i = {};
            return Object.entries(t).forEach(( ([e,o]) => {
                if (!/Options$/.test(e))
                    if (gf[e] && O(o) && !Ui(o)) {
                        const {component: o, factory: n, items: r, options: a={}} = t[e];
                        if (W(n))
                            i[e] = [n, a];
                        else {
                            const s = gf[e].items;
                            let l = W(s) ? t[s] || uf[s]() : void 0;
                            W(r) && uf[r] ? l = t[r] ? t[r].every((e => !Array.isArray(e))) ? t[r].map((e => [e, e])) : t[r] : uf[r]() : (r || a.items) && (l = r || a.items);
                            let c = n || gf[e].factory;
                            H(c) ? i[e] = l ? c(l, a) : c(a) : o && (i[e] = [o, {
                                ...a,
                                items: r
                            }])
                        }
                    } else
                        i[e] = o
            }
            )),
            i
        }
        ;
        function $f(e) {
            let t, i, o, n, r;
            const a = e[7].default
              , s = ur(a, e, e[6], null);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    s && s.c(),
                    Or(i, "class", "PinturaToolbarInner"),
                    Or(t, "class", "PinturaToolbar"),
                    Or(t, "data-layout", e[1]),
                    Or(t, "data-overflow", e[0])
                },
                m(a, l) {
                    Mr(a, t, l),
                    kr(t, i),
                    s && s.m(i, null),
                    o = !0,
                    n || (r = [Dr(i, "measure", e[3]), $r($c.call(null, i)), Dr(t, "measure", e[2]), $r($c.call(null, t))],
                    n = !0)
                },
                p(e, [i]) {
                    s && s.p && (!o || 64 & i) && hr(s, a, e, e[6], o ? pr(a, e[6], i, null) : mr(e[6]), null),
                    (!o || 2 & i) && Or(t, "data-layout", e[1]),
                    (!o || 1 & i) && Or(t, "data-overflow", e[0])
                },
                i(e) {
                    o || (ka(s, e),
                    o = !0)
                },
                o(e) {
                    Ca(s, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    s && s.d(e),
                    n = !1,
                    nr(r)
                }
            }
        }
        function bf(e, t, i) {
            let o, n, {$$slots: r={}, $$scope: a} = t, s = 0, l = 0, c = 0;
            const u = () => {
                i(0, n = "compact" === o && s > c ? "overflow" : void 0)
            }
            ;
            return e.$$set = e => {
                "$$scope"in e && i(6, a = e.$$scope)
            }
            ,
            e.$$.update = () => {
                48 & e.$$.dirty && i(1, o = l > c ? "compact" : "default")
            }
            ,
            [n, o, ({detail: e}) => {
                const {width: t} = e;
                i(5, c = t),
                u()
            }
            , ({detail: e}) => {
                const {width: t} = e;
                t > l && i(4, l = t),
                s = t,
                n || u()
            }
            , l, c, a, r]
        }
        class vf extends Na {
            constructor(e) {
                super(),
                Ba(this, e, bf, $f, ar, {})
            }
        }
        function xf(e) {
            let t, i, o, n;
            const r = e[5].default
              , a = ur(r, e, e[4], null);
            return {
                c() {
                    t = Er("div"),
                    a && a.c(),
                    Or(t, "class", e[0])
                },
                m(r, s) {
                    Mr(r, t, s),
                    a && a.m(t, null),
                    i = !0,
                    o || (n = [Dr(t, "measure", (function() {
                        rr(e[1] && e[3]) && (e[1] && e[3]).apply(this, arguments)
                    }
                    )), $r(e[2].call(null, t))],
                    o = !0)
                },
                p(o, [n]) {
                    e = o,
                    a && a.p && (!i || 16 & n) && hr(a, r, e, e[4], i ? pr(r, e[4], n, null) : mr(e[4]), null),
                    (!i || 1 & n) && Or(t, "class", e[0])
                },
                i(e) {
                    i || (ka(a, e),
                    i = !0)
                },
                o(e) {
                    Ca(a, e),
                    i = !1
                },
                d(e) {
                    e && Pr(t),
                    a && a.d(e),
                    o = !1,
                    nr(n)
                }
            }
        }
        function wf(e, t, i) {
            let {$$slots: o={}, $$scope: n} = t;
            const r = ta();
            let {class: a=null} = t;
            const s = oa("measurable");
            let l = !1;
            return Qr(( () => i(1, l = !0))),
            e.$$set = e => {
                "class"in e && i(0, a = e.class),
                "$$scope"in e && i(4, n = e.$$scope)
            }
            ,
            [a, l, s, ({detail: e}) => r("measure", e), n, o]
        }
        class Sf extends Na {
            constructor(e) {
                super(),
                Ba(this, e, wf, xf, ar, {
                    class: 0
                })
            }
        }
        const _f = e => ({})
          , kf = e => ({})
          , Cf = e => ({})
          , Tf = e => ({})
          , Mf = e => ({})
          , Pf = e => ({});
        function Ef(e) {
            let t, i;
            const o = e[4].header
              , n = ur(o, e, e[3], Pf);
            return {
                c() {
                    t = Er("div"),
                    n && n.c(),
                    Or(t, "class", "PinturaUtilHeader")
                },
                m(e, o) {
                    Mr(e, t, o),
                    n && n.m(t, null),
                    i = !0
                },
                p(e, t) {
                    n && n.p && (!i || 8 & t) && hr(n, o, e, e[3], i ? pr(o, e[3], t, Mf) : mr(e[3]), Pf)
                },
                i(e) {
                    i || (ka(n, e),
                    i = !0)
                },
                o(e) {
                    Ca(n, e),
                    i = !1
                },
                d(e) {
                    e && Pr(t),
                    n && n.d(e)
                }
            }
        }
        function Rf(e) {
            let t, i;
            const o = e[4].footer
              , n = ur(o, e, e[3], kf);
            return {
                c() {
                    t = Er("div"),
                    n && n.c(),
                    Or(t, "class", "PinturaUtilFooter")
                },
                m(e, o) {
                    Mr(e, t, o),
                    n && n.m(t, null),
                    i = !0
                },
                p(e, t) {
                    n && n.p && (!i || 8 & t) && hr(n, o, e, e[3], i ? pr(o, e[3], t, _f) : mr(e[3]), kf)
                },
                i(e) {
                    i || (ka(n, e),
                    i = !0)
                },
                o(e) {
                    Ca(n, e),
                    i = !1
                },
                d(e) {
                    e && Pr(t),
                    n && n.d(e)
                }
            }
        }
        function Af(e) {
            let t, i, o, n, r, a, s = e[1] && Ef(e);
            const l = e[4].main
              , c = ur(l, e, e[3], Tf)
              , u = c || function(e) {
                let t, i;
                return t = new Sf({
                    props: {
                        class: "PinturaStage"
                    }
                }),
                t.$on("measure", e[5]),
                {
                    c() {
                        za(t.$$.fragment)
                    },
                    m(e, o) {
                        Fa(t, e, o),
                        i = !0
                    },
                    p: Jn,
                    i(e) {
                        i || (ka(t.$$.fragment, e),
                        i = !0)
                    },
                    o(e) {
                        Ca(t.$$.fragment, e),
                        i = !1
                    },
                    d(e) {
                        Oa(t, e)
                    }
                }
            }(e);
            let d = e[2] && Rf(e);
            return {
                c() {
                    s && s.c(),
                    t = Ir(),
                    i = Er("div"),
                    u && u.c(),
                    o = Ir(),
                    d && d.c(),
                    n = Ir(),
                    r = Lr(),
                    Or(i, "class", "PinturaUtilMain")
                },
                m(l, c) {
                    s && s.m(l, c),
                    Mr(l, t, c),
                    Mr(l, i, c),
                    u && u.m(i, null),
                    e[6](i),
                    Mr(l, o, c),
                    d && d.m(l, c),
                    Mr(l, n, c),
                    Mr(l, r, c),
                    a = !0
                },
                p(e, [i]) {
                    e[1] ? s ? (s.p(e, i),
                    2 & i && ka(s, 1)) : (s = Ef(e),
                    s.c(),
                    ka(s, 1),
                    s.m(t.parentNode, t)) : s && (Sa(),
                    Ca(s, 1, 1, ( () => {
                        s = null
                    }
                    )),
                    _a()),
                    c && c.p && (!a || 8 & i) && hr(c, l, e, e[3], a ? pr(l, e[3], i, Cf) : mr(e[3]), Tf),
                    e[2] ? d ? (d.p(e, i),
                    4 & i && ka(d, 1)) : (d = Rf(e),
                    d.c(),
                    ka(d, 1),
                    d.m(n.parentNode, n)) : d && (Sa(),
                    Ca(d, 1, 1, ( () => {
                        d = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    a || (ka(s),
                    ka(u, e),
                    ka(d),
                    ka(!1),
                    a = !0)
                },
                o(e) {
                    Ca(s),
                    Ca(u, e),
                    Ca(d),
                    Ca(!1),
                    a = !1
                },
                d(a) {
                    s && s.d(a),
                    a && Pr(t),
                    a && Pr(i),
                    u && u.d(a),
                    e[6](null),
                    a && Pr(o),
                    d && d.d(a),
                    a && Pr(n),
                    a && Pr(r)
                }
            }
        }
        function If(e, t, i) {
            let {$$slots: o={}, $$scope: n} = t
              , {hasHeader: r=!!t.$$slots.header} = t
              , {hasFooter: a=!!t.$$slots.footer} = t
              , {root: s} = t;
            return e.$$set = e => {
                i(7, t = tr(tr({}, t), fr(e))),
                "hasHeader"in e && i(1, r = e.hasHeader),
                "hasFooter"in e && i(2, a = e.hasFooter),
                "root"in e && i(0, s = e.root),
                "$$scope"in e && i(3, n = e.$$scope)
            }
            ,
            t = fr(t),
            [s, r, a, n, o, function(t) {
                na.call(this, e, t)
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    s = e,
                    i(0, s)
                }
                ))
            }
            ]
        }
        class Lf extends Na {
            constructor(e) {
                super(),
                Ba(this, e, If, Af, ar, {
                    hasHeader: 1,
                    hasFooter: 2,
                    root: 0
                })
            }
        }
        function Df(e) {
            let t, i;
            return {
                c() {
                    t = Er("div"),
                    Or(t, "class", "PinturaRangeInputMeter"),
                    Or(t, "style", i = `transform: translateX(${e[9].x - e[12].x}px) translateY(${e[9].y - e[12].y}px)`)
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[7]
                },
                p(e, o) {
                    128 & o[0] && (t.innerHTML = e[7]),
                    512 & o[0] && i !== (i = `transform: translateX(${e[9].x - e[12].x}px) translateY(${e[9].y - e[12].y}px)`) && Or(t, "style", i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function zf(e) {
            let t, i, o, n, r, a, s, l, c, u, d, p = e[9] && Df(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("span"),
                    o = Ir(),
                    n = Er("button"),
                    r = Ar(e[1]),
                    s = Ir(),
                    l = Er("div"),
                    p && p.c(),
                    Or(i, "class", "PinturaRangeInputValue"),
                    Or(n, "class", "PinturaRangeInputReset"),
                    Or(n, "type", "button"),
                    n.disabled = a = e[0] === e[2],
                    Or(l, "class", "PinturaRangeInputInner"),
                    Or(l, "style", e[8]),
                    Or(l, "data-value-limited", e[5]),
                    Or(t, "class", "PinturaRangeInput"),
                    Or(t, "tabindex", "0")
                },
                m(a, h) {
                    Mr(a, t, h),
                    kr(t, i),
                    i.innerHTML = e[3],
                    kr(t, o),
                    kr(t, n),
                    kr(n, r),
                    kr(t, s),
                    kr(t, l),
                    p && p.m(l, null),
                    u || (d = [Dr(n, "click", e[17]), Dr(l, "interactionstart", e[13]), Dr(l, "interactionupdate", e[15]), Dr(l, "interactionend", e[16]), Dr(l, "interactionrelease", e[14]), $r(c = mu.call(null, l, {
                        inertia: e[6]
                    })), Dr(l, "measure", e[37]), $r($c.call(null, l)), Dr(t, "wheel", e[19], {
                        passive: !1
                    }), Dr(t, "nudge", e[20]), $r(fu.call(null, t, {
                        direction: "horizontal",
                        preventDefault: !0
                    }))],
                    u = !0)
                },
                p(e, t) {
                    8 & t[0] && (i.innerHTML = e[3]),
                    2 & t[0] && Wr(r, e[1]),
                    5 & t[0] && a !== (a = e[0] === e[2]) && (n.disabled = a),
                    e[9] ? p ? p.p(e, t) : (p = Df(e),
                    p.c(),
                    p.m(l, null)) : p && (p.d(1),
                    p = null),
                    256 & t[0] && Or(l, "style", e[8]),
                    32 & t[0] && Or(l, "data-value-limited", e[5]),
                    c && rr(c.update) && 64 & t[0] && c.update.call(null, {
                        inertia: e[6]
                    })
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(t),
                    p && p.d(),
                    u = !1,
                    nr(d)
                }
            }
        }
        function Ff(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, {labelReset: h="Reset"} = t, {direction: m="x"} = t, {min: f=0} = t, {max: g=1} = t, {base: y=f} = t, {value: b=0} = t, {valueLabel: v=0} = t, {valueMin: x} = t, {valueMax: w} = t, {oninputstart: S=$} = t, {oninputmove: _=$} = t, {oninputend: k=$} = t, {elasticity: C=0} = t, {nudgeMultiplier: T} = t, {step: M=8} = t;
            const P = oa("isAnimated");
            cr(e, P, (e => i(6, u = e)));
            const E = oa("fixScrollDirection");
            cr(e, E, (e => i(43, d = e)));
            const R = (e, t, i) => Math.ceil((e - i) / t) * t + i;
            let A, I, L;
            const D = {
                x: 2,
                y: 0
            }
              , z = (e, t, i) => `M ${e - i} ${t} a ${i} ${i} 0 1 0 0 -1`;
            let F, O, B = !1, N = {
                snap: !1,
                elastic: !1
            };
            const W = (e, t, i) => {
                const o = e[m] + t[m]
                  , n = cs(o, O[1][m], O[0][m])
                  , r = C ? n + gu(o - n, C) : n
                  , a = i.elastic ? r : n
                  , s = Ce(0, 0);
                return s[m] = a,
                H.set(s, {
                    hard: i.snap
                }),
                cs(U(s, m), f, g)
            }
              , H = ic();
            cr(e, H, (e => i(9, p = e)));
            const j = (e, t) => {
                const i = .5 * (A[t] - a[t]) - (mp(e, f, g) * a[t] - .5 * a[t]);
                return {
                    x: "x" === t ? i : 0,
                    y: "y" === t ? i : 0
                }
            }
              , U = (e, t) => {
                const i = -(e[t] - .5 * A[t]) / a[t];
                return f + i * o
            }
              , V = H.subscribe((e => {
                e && F && _(cs(U(e, m), f, g))
            }
            ))
              , q = e => {
                const t = [j(null != x ? x : f, m), j(null != w ? w : g, m)]
                  , i = {
                    x: "x" === m ? p.x + e : 0,
                    y: "y" === m ? p.y + e : 0
                }
                  , o = cs(i[m], t[1][m], t[0][m])
                  , n = {
                    ...p,
                    [m]: o
                };
                yr(H, p = n, p);
                const r = cs(U(n, m), f, g);
                S(),
                _(r),
                k(r)
            }
            ;
            return ea(( () => {
                V()
            }
            )),
            e.$$set = e => {
                "labelReset"in e && i(1, h = e.labelReset),
                "direction"in e && i(21, m = e.direction),
                "min"in e && i(22, f = e.min),
                "max"in e && i(23, g = e.max),
                "base"in e && i(2, y = e.base),
                "value"in e && i(0, b = e.value),
                "valueLabel"in e && i(3, v = e.valueLabel),
                "valueMin"in e && i(24, x = e.valueMin),
                "valueMax"in e && i(25, w = e.valueMax),
                "oninputstart"in e && i(26, S = e.oninputstart),
                "oninputmove"in e && i(27, _ = e.oninputmove),
                "oninputend"in e && i(28, k = e.oninputend),
                "elasticity"in e && i(29, C = e.elasticity),
                "nudgeMultiplier"in e && i(30, T = e.nudgeMultiplier),
                "step"in e && i(31, M = e.step)
            }
            ,
            e.$$.update = () => {
                if (12582912 & e.$$.dirty[0] && i(33, o = g - f),
                20971520 & e.$$.dirty[0] && i(35, n = null != x ? Math.max(x, f) : f),
                41943040 & e.$$.dirty[0] && i(34, r = null != w ? Math.min(w, g) : g),
                12582916 & e.$$.dirty[0] && i(36, s = mp(y, f, g)),
                16 & e.$$.dirty[0] | 32 & e.$$.dirty[1] && A) {
                    const e = .5 * A.y;
                    let t, o = 40 * s, n = "", r = A.y, a = "";
                    for (let i = 0; i <= 40; i++) {
                        const r = D.x + 10 * i
                          , s = e;
                        n += z(r, s, i % 5 == 0 ? 2 : .75) + " ",
                        t = r + D.x,
                        i === o && (a = `<path d="M${r} ${s - 4} l2 3 l-2 -1 l-2 1 z"/>`)
                    }
                    i(7, I = `<svg width="${t}" height="${r}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${t} ${r}" aria-hidden="true" focusable="false">\n        ${a}\n        <rect rx="4" ry="4" y="${e - 4}"" height="8"/>\n        <path fill-rule="evenodd" d="${n.trim()}"/></svg>`),
                    i(32, L = {
                        x: t - 2 * D.x,
                        y: r
                    })
                }
                16 & e.$$.dirty[0] | 2 & e.$$.dirty[1] && (a = A && L),
                12582912 & e.$$.dirty[0] | 24 & e.$$.dirty[1] && i(5, l = n !== f || r !== g),
                32 & e.$$.dirty[0] | 24 & e.$$.dirty[1] && i(8, c = l ? function(e, t) {
                    const i = mp(e, f, g)
                      , o = mp(t, f, g);
                    return `--range-mask-from:${100 * we(R(i, .025, 0) - .0125)}%;--range-mask-to:${100 * we(R(o, .025, 0) - .0125)}%`
                }(n, r) : ""),
                2097233 & e.$$.dirty[0] | 4 & e.$$.dirty[1] && o && A && A.x && A.y && H.set(j(b, m), {
                    hard: !1 === u
                })
            }
            ,
            [b, h, y, v, A, l, u, I, c, p, P, E, D, () => {
                B = !1,
                F = lr(H),
                O = [j(null != x ? x : f, m), j(null != w ? w : g, m)],
                S()
            }
            , () => {
                B = !0
            }
            , ({detail: e}) => {
                N.snap = !B,
                N.elastic = !B,
                W(F, e.translation, N)
            }
            , ({detail: e}) => {
                N.snap = !1,
                N.elastic = !1;
                const t = W(F, e.translation, N);
                if (F = void 0,
                O = void 0,
                Math.abs(t - y) < .01)
                    return k(y);
                k(t)
            }
            , () => {
                i(0, b = cs(y, n, r)),
                S(),
                k(b)
            }
            , H, e => {
                e.preventDefault(),
                e.stopPropagation();
                const t = vu(e, {
                    fixScrollDirection: d
                }) * M;
                q(t)
            }
            , ({detail: e}) => {
                q(e[m] * Math.abs(T || 8))
            }
            , m, f, g, x, w, S, _, k, C, T, M, L, o, r, n, s, e => i(4, A = (e => Ce(e.width, e.height))(e.detail))]
        }
        class Of extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Ff, zf, ar, {
                    labelReset: 1,
                    direction: 21,
                    min: 22,
                    max: 23,
                    base: 2,
                    value: 0,
                    valueLabel: 3,
                    valueMin: 24,
                    valueMax: 25,
                    oninputstart: 26,
                    oninputmove: 27,
                    oninputend: 28,
                    elasticity: 29,
                    nudgeMultiplier: 30,
                    step: 31
                }, null, [-1, -1])
            }
        }
        var Bf = {
            [he]: e => ({
                x: e.x,
                y: e.y
            }),
            [$e]: e => ({
                x: e.x + e.width,
                y: e.y
            }),
            [me]: e => ({
                x: e.x + e.width,
                y: e.y
            }),
            [be]: e => ({
                x: e.x + e.width,
                y: e.y + e.height
            }),
            [fe]: e => ({
                x: e.x,
                y: e.y + e.height
            }),
            [ve]: e => ({
                x: e.x,
                y: e.y + e.height
            }),
            [ge]: e => ({
                x: e.x,
                y: e.y
            }),
            [ye]: e => ({
                x: e.x,
                y: e.y
            })
        };
        function Nf(e, t, i) {
            const o = e.slice();
            return o[14] = t[i].key,
            o[15] = t[i].translate,
            o[16] = t[i].scale,
            o[17] = t[i].type,
            o[18] = t[i].opacity,
            o
        }
        function Wf(e, t) {
            let i, o, n, r, a, s, l, c;
            return {
                key: e,
                first: null,
                c() {
                    i = Er("div"),
                    Or(i, "role", "button"),
                    Or(i, "aria-label", o = `Drag ${t[17]} ${t[14]}`),
                    Or(i, "tabindex", n = "edge" === t[17] ? -1 : 0),
                    Or(i, "class", "PinturaRectManipulator"),
                    Or(i, "data-direction", r = t[14]),
                    Or(i, "data-shape", a = "edge" === t[17] ? "edge" : `${t[0]}`),
                    Or(i, "style", s = `--tx:${t[15].x};--ty:${t[15].y};--sx:${t[16].x};--sy:${t[16].y};opacity:${t[18]}`),
                    this.first = i
                },
                m(e, o) {
                    Mr(e, i, o),
                    l || (c = [Dr(i, "nudge", (function() {
                        rr(t[6](t[14])) && t[6](t[14]).apply(this, arguments)
                    }
                    )), $r(fu.call(null, i, {
                        preventDefault: !0
                    })), Dr(i, "interactionstart", (function() {
                        rr(t[5]("resizestart", t[14])) && t[5]("resizestart", t[14]).apply(this, arguments)
                    }
                    )), Dr(i, "interactionupdate", (function() {
                        rr(t[5]("resizemove", t[14])) && t[5]("resizemove", t[14]).apply(this, arguments)
                    }
                    )), Dr(i, "interactionend", (function() {
                        rr(t[5]("resizeend", t[14])) && t[5]("resizeend", t[14]).apply(this, arguments)
                    }
                    )), $r(mu.call(null, i))],
                    l = !0)
                },
                p(e, l) {
                    t = e,
                    2 & l && o !== (o = `Drag ${t[17]} ${t[14]}`) && Or(i, "aria-label", o),
                    2 & l && n !== (n = "edge" === t[17] ? -1 : 0) && Or(i, "tabindex", n),
                    2 & l && r !== (r = t[14]) && Or(i, "data-direction", r),
                    3 & l && a !== (a = "edge" === t[17] ? "edge" : `${t[0]}`) && Or(i, "data-shape", a),
                    2 & l && s !== (s = `--tx:${t[15].x};--ty:${t[15].y};--sx:${t[16].x};--sy:${t[16].y};opacity:${t[18]}`) && Or(i, "style", s)
                },
                d(e) {
                    e && Pr(i),
                    l = !1,
                    nr(c)
                }
            }
        }
        function Hf(e) {
            let t, i = [], o = new Map, n = e[1];
            const r = e => e[14];
            for (let t = 0; t < n.length; t += 1) {
                let a = Nf(e, n, t)
                  , s = r(a);
                o.set(s, i[t] = Wf(s, a))
            }
            return {
                c() {
                    for (let e = 0; e < i.length; e += 1)
                        i[e].c();
                    t = Lr()
                },
                m(e, o) {
                    for (let t = 0; t < i.length; t += 1)
                        i[t].m(e, o);
                    Mr(e, t, o)
                },
                p(e, [a]) {
                    99 & a && (n = e[1],
                    i = Aa(i, a, r, 1, e, n, o, t.parentNode, Ea, Wf, t, Nf))
                },
                i: Jn,
                o: Jn,
                d(e) {
                    for (let t = 0; t < i.length; t += 1)
                        i[t].d(e);
                    e && Pr(t)
                }
            }
        }
        function jf(e, t, i) {
            let o, n, r, a, {rect: s=null} = t, {visible: l=!1} = t, {style: c} = t;
            const u = oa("isAnimated");
            cr(e, u, (e => i(11, a = e)));
            const d = ic(void 0, {
                precision: 1e-4,
                stiffness: .2,
                damping: .4
            });
            cr(e, d, (e => i(10, r = e)));
            const p = ic(0, {
                precision: .001
            });
            let h;
            cr(e, p, (e => i(9, n = e)));
            const m = ta();
            return e.$$set = e => {
                "rect"in e && i(7, s = e.rect),
                "visible"in e && i(8, l = e.visible),
                "style"in e && i(0, c = e.style)
            }
            ,
            e.$$.update = () => {
                2304 & e.$$.dirty && d.set(l ? 1 : .5, {
                    hard: !1 === a
                }),
                2304 & e.$$.dirty && p.set(l ? 1 : 0, {
                    hard: !1 === a
                }),
                1664 & e.$$.dirty && i(1, o = Object.keys(pe).map(( (e, t) => {
                    const i = pe[e]
                      , o = Bf[i](s)
                      , a = 1 === i.length ? "edge" : "corner"
                      , l = "corner" === a;
                    return {
                        key: i,
                        type: a,
                        scale: {
                            x: /^(t|b)$/.test(i) ? s.width : l ? cs(r, .5, 1.25) : 1,
                            y: /^(r|l)$/.test(i) ? s.height : l ? cs(r, .5, 1.25) : 1
                        },
                        translate: {
                            x: o.x,
                            y: o.y
                        },
                        opacity: n
                    }
                }
                )))
            }
            ,
            [c, o, u, d, p, (e, t) => ({detail: i}) => {
                h && t !== h || "resizestart" !== e && void 0 === h || ("resizestart" === e && (h = t),
                "resizeend" === e && (h = void 0),
                m(e, {
                    direction: t,
                    translation: i && i.translation
                }))
            }
            , e => ({detail: t}) => {
                m("resizestart", {
                    direction: e,
                    translation: {
                        x: 0,
                        y: 0
                    }
                }),
                m("resizemove", {
                    direction: e,
                    translation: t
                }),
                m("resizeend", {
                    direction: e,
                    translation: {
                        x: 0,
                        y: 0
                    }
                })
            }
            , s, l, n, r, a]
        }
        class Uf extends Na {
            constructor(e) {
                super(),
                Ba(this, e, jf, Hf, ar, {
                    rect: 7,
                    visible: 8,
                    style: 0
                })
            }
        }
        var Vf = e => {
            function t(t, i) {
                e.dispatchEvent(new CustomEvent(t,{
                    detail: i
                }))
            }
            const i = i => {
                i.preventDefault(),
                e.addEventListener("gesturechange", o),
                e.addEventListener("gestureend", n),
                t("gesturedown")
            }
              , o = e => {
                e.preventDefault(),
                t("gestureupdate", e.scale)
            }
              , n = e => {
                t("gestureup", e.scale),
                e.preventDefault(),
                r()
            }
              , r = () => {
                e.removeEventListener("gesturechange", o),
                e.removeEventListener("gestureend", n)
            }
            ;
            return e.addEventListener("gesturestart", i),
            {
                destroy: () => {
                    r(),
                    e.removeEventListener("gesturestart", i)
                }
            }
        }
          , qf = {
            [he]: fe,
            [me]: ge,
            [fe]: he,
            [ge]: me,
            [ye]: be,
            [$e]: ve,
            [be]: ye,
            [ve]: $e
        }
          , Gf = e => {
            const t = e === ge || e === me
              , i = e === he || e === fe;
            return [e === me || e === $e || e === be, e === ge || e === ve || e === ye, e === he || e === $e || e === ye, e === fe || e === be || e === ve, t, i, t || i]
        }
          , Kf = (e, t, i, o={}) => {
            const {target: n, translate: r} = t
              , {aspectRatio: a, minSize: s, maxSize: l} = o
              , c = xe[qf[n]]
              , u = ze(Ce(e.x, e.y), Ce(c[0] * e.width, c[1] * e.height))
              , d = xe[n]
              , p = ze(pt(e), Ce(d[0] * e.width, d[1] * e.height))
              , [h,m,f,g,y,$,b] = Gf(n);
            let v = r.x
              , x = r.y;
            y ? x = 0 : $ && (v = 0);
            const {inner: w, outer: S} = Xf(u, n, i, {
                aspectRatio: a,
                minSize: s,
                maxSize: l
            });
            let[_,k,C,T] = Dt(e);
            if (h ? T = u.x : m && (k = u.x),
            g ? _ = u.y : f && (C = u.y),
            h) {
                const e = w.x + w.width
                  , t = S.x + S.width;
                k = cs(p.x + v, e, t)
            } else if (m) {
                const e = S.x
                  , t = w.x;
                T = cs(p.x + v, e, t)
            }
            if (g) {
                const e = w.y + w.height
                  , t = S.y + S.height;
                C = cs(p.y + x, e, t)
            } else if (f) {
                const e = S.y
                  , t = w.y;
                _ = cs(p.y + x, e, t)
            }
            if (T > w.x && (T = w.x),
            k < w.x + w.width && (k = w.x + w.width),
            _ > w.y && (_ = w.y),
            C < w.y + w.height && (C = w.y + w.height),
            T < S.x) {
                const e = S.x - T;
                T = S.x,
                k += e
            }
            if (k > S.x + S.width) {
                const e = k - (S.x + S.width);
                k = S.x + S.width,
                T -= e
            }
            if (_ < S.y) {
                const e = S.y - _;
                _ = S.y,
                C += e
            }
            if (C > S.y + S.height) {
                const e = C - (S.y + S.height);
                C = S.y + S.height,
                _ -= e
            }
            if (a)
                if (b) {
                    let e = k - T
                      , t = C - _;
                    y ? (t = e / a,
                    _ = u.y - .5 * t,
                    C = u.y + .5 * t) : $ && (e = t * a,
                    T = u.x - .5 * e,
                    k = u.x + .5 * e)
                } else {
                    const e = Ce(p.x + v - u.x, p.y + x - u.y);
                    n === $e ? (e.x = Math.max(0, e.x),
                    e.y = Math.min(0, e.y)) : n === be ? (e.x = Math.max(0, e.x),
                    e.y = Math.max(0, e.y)) : n === ve ? (e.x = Math.min(0, e.x),
                    e.y = Math.max(0, e.y)) : n === ye && (e.x = Math.min(0, e.x),
                    e.y = Math.min(0, e.y));
                    const t = Re(e)
                      , i = Re(Ce(w.width, w.height))
                      , o = Re(Ce(S.width, S.height))
                      , r = cs(t, i, o)
                      , s = Ce(a, 1)
                      , l = Be(Ae(s), r);
                    n === $e ? (k = u.x + l.x,
                    _ = u.y - l.y) : n === be ? (k = u.x + l.x,
                    C = u.y + l.y) : n === ve ? (T = u.x - l.x,
                    C = u.y + l.y) : n === ye && (T = u.x - l.x,
                    _ = u.y - l.y)
                }
            return bt(T, _, k - T, C - _)
        }
        ;
        const Xf = (e, t, i, o) => {
            const {aspectRatio: n, minSize: r, maxSize: a} = o
              , s = t === me || t === $e || t === be
              , l = t === ge || t === ve || t === ye
              , c = t === he || t === $e || t === ye
              , u = t === fe || t === be || t === ve
              , d = t === ge || t === me
              , p = t === he || t === fe
              , h = pt(i);
            s ? (h.x = e.x,
            h.width -= e.x) : l && (h.width = e.x),
            u ? (h.y = e.y,
            h.height -= e.y) : c && (h.height = e.y);
            const m = (f = Math.min(h.width, a.width),
            g = Math.min(h.height, a.height),
            dt(0, 0, f, g));
            var f, g;
            if (n)
                if (d) {
                    const t = Math.min(e.y, i.height - e.y);
                    m.height = Math.min(2 * t, m.height)
                } else if (p) {
                    const t = Math.min(e.x, i.width - e.x);
                    m.width = Math.min(2 * t, m.width)
                }
            const y = n ? Ye(It(mt(r), n)) : r
              , $ = n ? Ye(Lt(m, n)) : m;
            let b, v, x, w;
            s ? b = e.x : l && (v = e.x),
            u ? x = e.y : c && (w = e.y),
            s ? v = b + y.width : l && (b = v - y.width),
            u ? w = x + y.height : c && (x = w - y.height),
            d ? (x = e.y - .5 * y.height,
            w = e.y + .5 * y.height) : p && (b = e.x - .5 * y.width,
            v = e.x + .5 * y.width);
            const S = gt([Ce(b, x), Ce(v, w)]);
            return s ? v = b + $.width : l && (b = v - $.width),
            u ? w = x + $.height : c && (x = w - $.height),
            d ? (x = e.y - .5 * $.height,
            w = e.y + .5 * $.height) : p && (b = e.x - .5 * $.width,
            v = e.x + .5 * $.width),
            b = Math.max(i.x, b),
            v = Math.min(i.x + i.width, v),
            x = Math.max(i.y, x),
            w = Math.min(i.y + i.height, w),
            {
                inner: S,
                outer: gt([Ce(b, x), Ce(v, w)])
            }
        }
        ;
        var Zf = e => 180 * e / Math.PI;
        function Yf(e) {
            let t, i, o;
            return i = new Of({
                props: {
                    elasticity: e[5],
                    min: e[9],
                    max: e[10],
                    value: e[11],
                    valueMin: Math.max(e[9], e[0]),
                    valueMax: Math.min(e[10], e[1]),
                    labelReset: e[6],
                    base: e[12],
                    valueLabel: `${Math.round(Zf(e[11]))}&deg;`,
                    oninputstart: e[2],
                    oninputmove: e[17],
                    oninputend: e[18]
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaImageRotator")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, [t]) {
                    const o = {};
                    32 & t && (o.elasticity = e[5]),
                    512 & t && (o.min = e[9]),
                    1024 & t && (o.max = e[10]),
                    2048 & t && (o.value = e[11]),
                    513 & t && (o.valueMin = Math.max(e[9], e[0])),
                    1026 & t && (o.valueMax = Math.min(e[10], e[1])),
                    64 & t && (o.labelReset = e[6]),
                    4096 & t && (o.base = e[12]),
                    2048 & t && (o.valueLabel = `${Math.round(Zf(e[11]))}&deg;`),
                    4 & t && (o.oninputstart = e[2]),
                    392 & t && (o.oninputmove = e[17]),
                    400 & t && (o.oninputend = e[18]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function Qf(e, t, i) {
            let o, n, r, a, s, l, c, {rotation: u} = t, {valueMin: d} = t, {valueMax: p} = t, {oninputstart: h=$} = t, {oninputmove: m=$} = t, {oninputend: f=$} = t, {elasticity: g=0} = t, {labelReset: y} = t, {rotationMin: b} = t, {rotationMax: v} = t;
            return e.$$set = e => {
                "rotation"in e && i(13, u = e.rotation),
                "valueMin"in e && i(0, d = e.valueMin),
                "valueMax"in e && i(1, p = e.valueMax),
                "oninputstart"in e && i(2, h = e.oninputstart),
                "oninputmove"in e && i(3, m = e.oninputmove),
                "oninputend"in e && i(4, f = e.oninputend),
                "elasticity"in e && i(5, g = e.elasticity),
                "labelReset"in e && i(6, y = e.labelReset),
                "rotationMin"in e && i(14, b = e.rotationMin),
                "rotationMax"in e && i(15, v = e.rotationMax)
            }
            ,
            e.$$.update = () => {
                16384 & e.$$.dirty && i(9, o = b + 1e-9),
                32768 & e.$$.dirty && i(10, n = v - 1e-9),
                1536 & e.$$.dirty && i(12, r = o + .5 * (n - o)),
                32768 & e.$$.dirty && i(16, a = 2 * v),
                8192 & e.$$.dirty && i(8, s = Math.sign(u)),
                73728 & e.$$.dirty && i(7, l = Math.round(Math.abs(u) / a) * a),
                8576 & e.$$.dirty && i(11, c = u - s * l)
            }
            ,
            [d, p, h, m, f, g, y, l, s, o, n, c, r, u, b, v, a, e => m(s * l + e), e => f(s * l + e)]
        }
        class Jf extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Qf, Yf, ar, {
                    rotation: 13,
                    valueMin: 0,
                    valueMax: 1,
                    oninputstart: 2,
                    oninputmove: 3,
                    oninputend: 4,
                    elasticity: 5,
                    labelReset: 6,
                    rotationMin: 14,
                    rotationMax: 15
                })
            }
        }
        function eg(e) {
            let t, i, o, n, r;
            return {
                c() {
                    t = Er("div"),
                    i = Er("p"),
                    o = Ar(e[0]),
                    n = Ar(" × "),
                    r = Ar(e[1]),
                    Or(t, "class", "PinturaImageInfo")
                },
                m(e, a) {
                    Mr(e, t, a),
                    kr(t, i),
                    kr(i, o),
                    kr(i, n),
                    kr(i, r)
                },
                p(e, [t]) {
                    1 & t && Wr(o, e[0]),
                    2 & t && Wr(r, e[1])
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function tg(e, t, i) {
            let {width: o} = t
              , {height: n} = t;
            return e.$$set = e => {
                "width"in e && i(0, o = e.width),
                "height"in e && i(1, n = e.height)
            }
            ,
            [o, n]
        }
        class ig extends Na {
            constructor(e) {
                super(),
                Ba(this, e, tg, eg, ar, {
                    width: 0,
                    height: 1
                })
            }
        }
        function og(e) {
            let t, i;
            return t = new Nd({
                props: {
                    class: "PinturaPresetListFilter",
                    layout: "row",
                    options: e[8],
                    selectedIndex: e[7],
                    onchange: e[10]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    256 & i && (o.options = e[8]),
                    128 & i && (o.selectedIndex = e[7]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function ng(e) {
            let t, i;
            return t = new cp({
                props: {
                    icon: e[0],
                    label: e[1],
                    labelClass: e[2],
                    hideLabel: e[3],
                    options: e[9],
                    selectedIndex: e[4],
                    onchange: e[5],
                    optionMapper: e[6],
                    $$slots: {
                        controls: [og]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, [i]) {
                    const o = {};
                    1 & i && (o.icon = e[0]),
                    2 & i && (o.label = e[1]),
                    4 & i && (o.labelClass = e[2]),
                    8 & i && (o.hideLabel = e[3]),
                    512 & i && (o.options = e[9]),
                    16 & i && (o.selectedIndex = e[4]),
                    32 & i && (o.onchange = e[5]),
                    64 & i && (o.optionMapper = e[6]),
                    262528 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        const rg = 'fill="none" stroke="currentColor"';
        function ag(e, t, i) {
            let o, n, r, {icon: a} = t, {label: s} = t, {labelClass: l} = t, {hideLabel: c} = t, {options: u} = t, {selectedIndex: d} = t, {onchange: p} = t, {optionMapper: h} = t, {filter: m="landscape"} = t, {onfilterchange: f=$} = t;
            const g = (e, t, i, o, n) => `\n    <rect ${rg} x="${e}" y="${t}" width="${i}" height="${o}" rx="${n}"/>`
              , y = (e, t) => `<path ${rg} d="M${e} ${t} l2 2 l3 -4"/>`;
            return e.$$set = e => {
                "icon"in e && i(0, a = e.icon),
                "label"in e && i(1, s = e.label),
                "labelClass"in e && i(2, l = e.labelClass),
                "hideLabel"in e && i(3, c = e.hideLabel),
                "options"in e && i(12, u = e.options),
                "selectedIndex"in e && i(4, d = e.selectedIndex),
                "onchange"in e && i(5, p = e.onchange),
                "optionMapper"in e && i(6, h = e.optionMapper),
                "filter"in e && i(11, m = e.filter),
                "onfilterchange"in e && i(13, f = e.onfilterchange)
            }
            ,
            e.$$.update = () => {
                6144 & e.$$.dirty && i(9, o = ( (e, t) => (e || []).map((e => W(e[0]) ? (e[1] = e[1].map(t),
                e) : t(e))))(u, (e => t => {
                    const [i,o,n={}] = t;
                    return Wi(i) && (n.hidden = "landscape" === e ? i < 1 : i > 1),
                    [i, o, n]
                }
                )(m))),
                2048 & e.$$.dirty && i(7, n = "landscape" === m ? 0 : 1),
                128 & e.$$.dirty && i(8, r = [["landscape", "Landscape", {
                    hideLabel: !0,
                    icon: g(2, 6, 19, 12, 2) + (0 === n ? y(9, 12) : "")
                }], ["portrait", "Portrait", {
                    hideLabel: !0,
                    icon: g(5, 3, 13, 18, 2) + (1 === n ? y(9, 12) : "")
                }]])
            }
            ,
            [a, s, l, c, d, p, h, n, r, o, e => {
                i(11, m = e.value),
                f(e.value)
            }
            , m, u, f]
        }
        class sg extends Na {
            constructor(e) {
                super(),
                Ba(this, e, ag, ng, ar, {
                    icon: 0,
                    label: 1,
                    labelClass: 2,
                    hideLabel: 3,
                    options: 12,
                    selectedIndex: 4,
                    onchange: 5,
                    optionMapper: 6,
                    filter: 11,
                    onfilterchange: 13
                })
            }
        }
        const lg = e => De(e, (e => we(e, 6)))
          , cg = e => Ft(e, (e => we(e, 6)))
          , ug = (e, t, i=1e-4) => Math.abs(e - t) < i;
        var dg = (e, t, i, o, n={}) => {
            const {aspectRatio: r} = n;
            e = cg(e),
            o = o.map(lg);
            const a = _t(e, qf[i.target])
              , s = De(a, (e => we(e, 6)))
              , l = r ? It(n.minSize, r) : n.minSize
              , c = r ? Lt(n.maxSize, r) : n.maxSize
              , u = _t(t, i.target);
            if (je(u, a) < 1) {
                t = pt(e);
                const i = Math.min(l.width / e.width, l.height / e.height);
                wt(t, i, a)
            }
            t = St(pt(t), l, c, a);
            let d = pt(t);
            t = cg(t);
            const p = qt(o, 1)
              , h = zt(e)
              , m = zt(t)
              , f = h.findIndex((e => Le(De(e, (e => we(e, 6))), s)))
              , g = e => p.map((t => Wt(t, e))).filter(Boolean).pop();
            if (r) {
                const t = m.map(( (e, t) => {
                    if (t === f)
                        return;
                    const i = Ce(a.x - e.x, a.y - e.y);
                    Ae(i),
                    Be(i, .5);
                    const o = Ce(a.x - i.x, a.y - i.y)
                      , n = st(o, lg(e))
                      , r = g(n);
                    if (!r)
                        return;
                    const s = h[t];
                    return {
                        intersection: r,
                        cornerDist: je(a, s),
                        intersectionDist: je(a, r)
                    }
                }
                )).filter(Boolean);
                if (t.length) {
                    const i = t.reduce(( (e, t) => {
                        const i = t.intersectionDist / t.cornerDist;
                        return i < e ? i : e
                    }
                    ), Number.MAX_SAFE_INTEGER);
                    d = pt(e),
                    wt(d, i, a)
                }
            } else {
                const e = 1 === i.target.length
                  , n = !(o[0].y === o[1].y || o[0].x === o[1].x)
                  , r = h.map(( (t, i) => {
                    if (i === f)
                        return;
                    const o = m[i]
                      , r = !ug(o.x, s.x) && !ug(o.y, s.y);
                    if (!e && !n && r)
                        return;
                    if (e && (ug(o.x, s.x) || ug(o.y, s.y)))
                        return;
                    const l = Me(e ? t : a)
                      , c = Fe(Me(l), o);
                    Ae(c),
                    Be(c, .5),
                    e ? ze(l, c) : Fe(l, c);
                    const u = st(l, o);
                    return g(u) || void 0
                }
                )).filter(Boolean);
                if (r.length) {
                    const [e,o,n,l] = Gf(i.target);
                    let[c,u,p,h] = Dt(t);
                    r.forEach(( ({x: t, y: i}) => {
                        const r = we(t, 6)
                          , a = we(i, 6);
                        n && !ug(a, s.y) && (c = Math.max(c, i)),
                        e && !ug(r, s.x) && (u = Math.min(u, t)),
                        l && !ug(a, s.y) && (p = Math.min(p, i)),
                        o && !ug(r, s.x) && (h = Math.max(h, t))
                    }
                    )),
                    d = dt((y = [c, u, p, h])[3], y[0], y[1] - y[3], y[2] - y[0]),
                    wt(d, .9999, a)
                }
            }
            var y;
            return St(d, l, c, a),
            d
        }
        ;
        function pg(e) {
            let t, i;
            return t = new yh({
                props: {
                    items: e[11]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    2048 & i[0] && (o.items = e[11]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function hg(e) {
            let t, i, o;
            return i = new vf({
                props: {
                    $$slots: {
                        default: [pg]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "slot", "header")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    2048 & t[0] | 4 & t[7] && (o.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function mg(e) {
            let t, i;
            return t = new du({
                props: {
                    onclick: e[88],
                    label: e[4].cropLabelButtonRecenter,
                    icon: e[4].cropIconButtonRecenter,
                    class: "PinturaButtonCenter",
                    disabled: !e[9],
                    hideLabel: !0,
                    style: `opacity: ${e[29]}; transform: translate3d(${e[30].x}px, ${e[30].y}px, 0)`
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] && (o.label = e[4].cropLabelButtonRecenter),
                    16 & i[0] && (o.icon = e[4].cropIconButtonRecenter),
                    512 & i[0] && (o.disabled = !e[9]),
                    1610612736 & i[0] && (o.style = `opacity: ${e[29]}; transform: translate3d(${e[30].x}px, ${e[30].y}px, 0)`),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function fg(e) {
            let t, i;
            return t = new Uf({
                props: {
                    rect: e[8],
                    visible: e[12],
                    style: e[1]
                }
            }),
            t.$on("resizestart", e[68]),
            t.$on("resizemove", e[69]),
            t.$on("resizeend", e[70]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    256 & i[0] && (o.rect = e[8]),
                    4096 & i[0] && (o.visible = e[12]),
                    2 & i[0] && (o.style = e[1]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function gg(e) {
            let t, i;
            return t = new ig({
                props: {
                    width: Math.round(e[13].width),
                    height: Math.round(e[13].height)
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8192 & i[0] && (o.width = Math.round(e[13].width)),
                    8192 & i[0] && (o.height = Math.round(e[13].height)),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function yg(e) {
            let t, i, o, n, r, a, s, l, c = e[21] && e[10] && mg(e), u = e[21] && fg(e), d = e[22] && gg(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    c && c.c(),
                    o = Ir(),
                    u && u.c(),
                    r = Ir(),
                    d && d.c(),
                    Or(i, "class", "PinturaStage"),
                    Or(t, "slot", "main")
                },
                m(p, h) {
                    Mr(p, t, h),
                    kr(t, i),
                    c && c.m(i, null),
                    kr(i, o),
                    u && u.m(i, null),
                    e[162](i),
                    kr(t, r),
                    d && d.m(t, null),
                    a = !0,
                    s || (l = [$r($c.call(null, i)), Dr(i, "measure", e[160]), Dr(i, "wheel", (function() {
                        rr(e[2] && e[87]) && (e[2] && e[87]).apply(this, arguments)
                    }
                    ), {
                        passive: !1
                    }), Dr(i, "interactionstart", e[74]), Dr(i, "interactionupdate", e[75]), Dr(i, "interactionrelease", e[77]), Dr(i, "interactionend", e[76]), $r(n = mu.call(null, i, {
                        drag: !0,
                        inertia: !0,
                        pinch: e[2],
                        shouldStartInteraction: Tg,
                        getEventPosition: e[163]
                    })), Dr(i, "gesturedown", e[84]), Dr(i, "gestureupdate", e[85]), Dr(i, "gestureup", e[86]), $r(Vf.call(null, i))],
                    s = !0)
                },
                p(r, a) {
                    (e = r)[21] && e[10] ? c ? (c.p(e, a),
                    2098176 & a[0] && ka(c, 1)) : (c = mg(e),
                    c.c(),
                    ka(c, 1),
                    c.m(i, o)) : c && (Sa(),
                    Ca(c, 1, 1, ( () => {
                        c = null
                    }
                    )),
                    _a()),
                    e[21] ? u ? (u.p(e, a),
                    2097152 & a[0] && ka(u, 1)) : (u = fg(e),
                    u.c(),
                    ka(u, 1),
                    u.m(i, null)) : u && (Sa(),
                    Ca(u, 1, 1, ( () => {
                        u = null
                    }
                    )),
                    _a()),
                    n && rr(n.update) && 16777220 & a[0] && n.update.call(null, {
                        drag: !0,
                        inertia: !0,
                        pinch: e[2],
                        shouldStartInteraction: Tg,
                        getEventPosition: e[163]
                    }),
                    e[22] ? d ? (d.p(e, a),
                    4194304 & a[0] && ka(d, 1)) : (d = gg(e),
                    d.c(),
                    ka(d, 1),
                    d.m(t, null)) : d && (Sa(),
                    Ca(d, 1, 1, ( () => {
                        d = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    a || (ka(c),
                    ka(u),
                    ka(d),
                    a = !0)
                },
                o(e) {
                    Ca(c),
                    Ca(u),
                    Ca(d),
                    a = !1
                },
                d(i) {
                    i && Pr(t),
                    c && c.d(),
                    u && u.d(),
                    e[162](null),
                    d && d.d(),
                    s = !1,
                    nr(l)
                }
            }
        }
        function $g(e) {
            let t, i, o, n;
            const r = [{
                class: "PinturaControlList"
            }, {
                tabs: e[7]
            }, e[18]];
            let a = {
                $$slots: {
                    default: [bg, ({tab: e}) => ({
                        218: e
                    }), ({tab: e}) => [0, 0, 0, 0, 0, 0, 0, e ? 2 : 0]]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < r.length; e += 1)
                a = tr(a, r[e]);
            t = new Fc({
                props: a
            }),
            t.$on("select", e[161]);
            const s = [{
                class: "PinturaControlPanels"
            }, {
                panelClass: "PinturaControlPanel"
            }, {
                panels: e[17]
            }, e[18]];
            let l = {
                $$slots: {
                    default: [wg, ({panel: e}) => ({
                        217: e
                    }), ({panel: e}) => [0, 0, 0, 0, 0, 0, 0, e ? 1 : 0]]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < s.length; e += 1)
                l = tr(l, s[e]);
            return o = new Xc({
                props: l
            }),
            {
                c() {
                    za(t.$$.fragment),
                    i = Ir(),
                    za(o.$$.fragment)
                },
                m(e, r) {
                    Fa(t, e, r),
                    Mr(e, i, r),
                    Fa(o, e, r),
                    n = !0
                },
                p(e, i) {
                    const n = 262272 & i[0] ? Ia(r, [r[0], 128 & i[0] && {
                        tabs: e[7]
                    }, 262144 & i[0] && La(e[18])]) : {};
                    6 & i[7] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n);
                    const a = 393216 & i[0] ? Ia(s, [s[0], s[1], 131072 & i[0] && {
                        panels: e[17]
                    }, 262144 & i[0] && La(e[18])]) : {};
                    511721496 & i[0] | 5 & i[7] && (a.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    o.$set(a)
                },
                i(e) {
                    n || (ka(t.$$.fragment, e),
                    ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    Oa(t, e),
                    e && Pr(i),
                    Oa(o, e)
                }
            }
        }
        function bg(e) {
            let t, i, o = e[218].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o)
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    2 & t[7] && o !== (o = e[218].label + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function vg(e) {
            let t, i;
            return t = new Of({
                props: {
                    elasticity: e[25] * e[44],
                    base: Cg,
                    min: e[23],
                    max: kg,
                    valueMin: e[27][0],
                    valueMax: e[27][1],
                    value: e[28],
                    labelReset: e[4].labelReset,
                    valueLabel: `${Math.round(100 * e[28])}%`,
                    oninputstart: e[81],
                    oninputmove: e[82],
                    oninputend: e[83]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    33554432 & i[0] && (o.elasticity = e[25] * e[44]),
                    8388608 & i[0] && (o.min = e[23]),
                    134217728 & i[0] && (o.valueMin = e[27][0]),
                    134217728 & i[0] && (o.valueMax = e[27][1]),
                    268435456 & i[0] && (o.value = e[28]),
                    16 & i[0] && (o.labelReset = e[4].labelReset),
                    268435456 & i[0] && (o.valueLabel = `${Math.round(100 * e[28])}%`),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function xg(e) {
            let t, i;
            return t = new Jf({
                props: {
                    elasticity: e[25] * e[44],
                    rotation: e[14],
                    labelReset: e[4].labelReset,
                    valueMin: e[26][0],
                    valueMax: e[26][1],
                    rotationMin: -e[3],
                    rotationMax: e[3],
                    oninputstart: e[71],
                    oninputmove: e[72],
                    oninputend: e[73]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    33554432 & i[0] && (o.elasticity = e[25] * e[44]),
                    16384 & i[0] && (o.rotation = e[14]),
                    16 & i[0] && (o.labelReset = e[4].labelReset),
                    67108864 & i[0] && (o.valueMin = e[26][0]),
                    67108864 & i[0] && (o.valueMax = e[26][1]),
                    8 & i[0] && (o.rotationMin = -e[3]),
                    8 & i[0] && (o.rotationMax = e[3]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function wg(e) {
            let t, i, o, n;
            const r = [xg, vg]
              , a = [];
            function s(e, t) {
                return e[217] === e[93] + "-rotation" ? 0 : e[217] === e[93] + "-zoom" ? 1 : -1
            }
            return ~(t = s(e)) && (i = a[t] = r[t](e)),
            {
                c() {
                    i && i.c(),
                    o = Lr()
                },
                m(e, i) {
                    ~t && a[t].m(e, i),
                    Mr(e, o, i),
                    n = !0
                },
                p(e, n) {
                    let l = t;
                    t = s(e),
                    t === l ? ~t && a[t].p(e, n) : (i && (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a()),
                    ~t ? (i = a[t],
                    i ? i.p(e, n) : (i = a[t] = r[t](e),
                    i.c()),
                    ka(i, 1),
                    i.m(o.parentNode, o)) : i = null)
                },
                i(e) {
                    n || (ka(i),
                    n = !0)
                },
                o(e) {
                    Ca(i),
                    n = !1
                },
                d(e) {
                    ~t && a[t].d(e),
                    e && Pr(o)
                }
            }
        }
        function Sg(e) {
            let t, i, o = e[19] && $g(e);
            return {
                c() {
                    t = Er("div"),
                    o && o.c(),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[16])
                },
                m(e, n) {
                    Mr(e, t, n),
                    o && o.m(t, null),
                    i = !0
                },
                p(e, n) {
                    e[19] ? o ? (o.p(e, n),
                    524288 & n[0] && ka(o, 1)) : (o = $g(e),
                    o.c(),
                    ka(o, 1),
                    o.m(t, null)) : o && (Sa(),
                    Ca(o, 1, 1, ( () => {
                        o = null
                    }
                    )),
                    _a()),
                    (!i || 65536 & n[0]) && Or(t, "style", e[16])
                },
                i(e) {
                    i || (ka(o),
                    i = !0)
                },
                o(e) {
                    Ca(o),
                    i = !1
                },
                d(e) {
                    e && Pr(t),
                    o && o.d()
                }
            }
        }
        function _g(e) {
            let t, i, o;
            function n(t) {
                e[164](t)
            }
            let r = {
                hasHeader: e[20],
                $$slots: {
                    footer: [Sg],
                    main: [yg],
                    header: [hg]
                },
                $$scope: {
                    ctx: e
                }
            };
            return void 0 !== e[15] && (r.root = e[15]),
            t = new Lf({
                props: r
            }),
            aa.push(( () => Da(t, "root", n))),
            t.$on("measure", e[165]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(e, o) {
                    const n = {};
                    1048576 & o[0] && (n.hasHeader = e[20]),
                    2146402302 & o[0] | 4 & o[7] && (n.$$scope = {
                        dirty: o,
                        ctx: e
                    }),
                    !i && 32768 & o[0] && (i = !0,
                    n.root = e[15],
                    ma(( () => i = !1))),
                    t.$set(n)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        const kg = 1
          , Cg = 0
          , Tg = (e, t) => e.target === t;
        function Mg(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, $, b, v, x, w, S, _, k, C, T, M, P, E, R, A, I, L, D, z, F, O, B, N, W, H, j, U, q, G, K, X, Z, Y, Q, J, ee, te, ie, oe, ne, re, le, ce, pe, he, me, fe, ge, Se, _e, ke, Te, Ee, Ie, De, Oe, Ne, We = Jn, He = () => (We(),
            We = sr(je, (e => i(12, R = e))),
            je);
            e.$$.on_destroy.push(( () => We()));
            let {isActive: je} = t;
            He();
            let {stores: Ue} = t
              , {cropImageSelectionCornerStyle: Ve="circle"} = t
              , {cropWillRenderImageSelectionGuides: qe=( (e, t) => {
                const i = "rotate" == e;
                return {
                    rows: i ? 5 : 3,
                    cols: i ? 5 : 3,
                    opacity: .25 * t
                }
            }
            )} = t
              , {cropAutoCenterImageSelectionTimeout: Ge} = t
              , {cropEnableZoomMatchImageAspectRatio: Ke=!0} = t
              , {cropEnableRotateMatchImageAspectRatio: Ze="never"} = t
              , {cropEnableRotationInput: Je=!0} = t
              , {cropEnableZoom: tt=!0} = t
              , {cropEnableZoomInput: st=!0} = t
              , {cropEnableZoomAutoHide: lt=!0} = t
              , {cropEnableImageSelection: ct=!0} = t
              , {cropEnableInfoIndicator: ut=!1} = t
              , {cropEnableZoomTowardsWheelPosition: dt=!0} = t
              , {cropEnableLimitWheelInputToCropSelection: ht=!0} = t
              , {cropEnableCenterImageSelection: ft=!0} = t
              , {cropEnableButtonRotateLeft: gt=!0} = t
              , {cropEnableButtonRotateRight: yt=!1} = t
              , {cropEnableButtonFlipHorizontal: St=!0} = t
              , {cropEnableButtonFlipVertical: _t=!1} = t
              , {cropSelectPresetOptions: Mt} = t
              , {cropEnableSelectPreset: Pt=!0} = t
              , {cropEnableFilterMatchAspectRatio: Et=!0} = t
              , {cropSelectPresetFilter: zt=!1} = t
              , {cropEnableButtonToggleCropLimit: Ot=!1} = t
              , {cropWillRenderTools: Bt=se} = t
              , {cropActiveTransformTool: Nt="rotation"} = t
              , {cropMinimizeToolbar: Wt="auto"} = t
              , {cropInteractionFocus: Ht="image"} = t
              , {cropRotationRange: jt=ue} = t
              , {cropMaskOpacity: Ut=.85} = t
              , {locale: Vt={}} = t;
            const qt = oa("isAnimated");
            cr(e, qt, (e => i(139, A = e)));
            const Gt = oa("elasticityMultiplier");
            cr(e, Gt, (e => i(25, Te = e)));
            const Kt = oa("redrawTrigger");
            cr(e, Kt, (e => i(159, ke = e)));
            const Xt = oa("imageIsStatic");
            cr(e, Xt, (e => i(145, B = e)));
            const Zt = oa("imageStaticVisualCorners");
            cr(e, Zt, (e => i(181, ce = e)));
            const Yt = oa("fixScrollDirection");
            cr(e, Yt, (e => i(175, ee = e)));
            let Qt = "idle";
            const Jt = ja();
            cr(e, Jt, (e => i(156, ge = e)));
            const ei = () => void 0 === re
              , ti = e => 1 / e
              , ii = e => {
                Et && zt !== e && (i(95, zt = e),
                re && 1 !== re && oi() && yr(Bi, re = ti(re), re))
            }
              , oi = () => {
                if (1 === re || !o)
                    return !1;
                const e = ti(re);
                return !!ud(ge).find(( ([t]) => t === e))
            }
              , ni = (e, t, i) => de(i) ? t.width === Math.round(e.height) || t.height === Math.round(e.width) : t.width === Math.round(e.width) || t.height === Math.round(e.height)
              , ri = e => {
                if ("never" !== Ze && (ei() || "always" === Ze && oi()) && ( (e, t, i) => {
                    const o = at(nt(Xe(t), i), (e => Math.abs(Math.round(e))))
                      , n = ot(o)
                      , r = vt(e);
                    return Le(n, r)
                }
                )(N, Z, Y) && ni(N, Z, Y)) {
                    yr(Ci, Y += e, Y);
                    const t = de(Y)
                      , i = t ? Z.height : Z.width
                      , o = t ? Z.width : Z.height;
                    yr(Di, N = bt(0, 0, i, o), N),
                    ei() || yr(Bi, re = ae(i, o), re)
                } else
                    yr(Ci, Y += e, Y)
            }
              , {history: ai, env: si, isInteracting: li, isInteractingFraction: ci, isTransformingImage: ui, rootRect: di, stageRect: pi, utilRect: hi, utilRectPadded: mi, rootLineColor: fi, allowPan: gi, allowZoom: yi, allowPlayPause: $i, rangeInputElasticity: bi, presentationScalar: vi, utilTools: xi, imagePreviewModifiers: wi, imageOutlineOpacity: Si, imageFlipX: _i, imageFlipY: ki, imageRotation: Ci, imageRotationRange: Ti, imageOutputSize: Mi, imageSelectionRect: Pi, imageSelectionRectSnapshot: Ei, imageSelectionRectIntent: Ri, imageSelectionRectPresentation: Ai, imageCropRectIntent: Ii, imageCropRectOrigin: Li, imageCropRect: Di, imageCropMinSize: zi, imageCropMaxSize: Fi, imageCropRange: Oi, imageCropAspectRatio: Bi, imageCropLimitToImage: Ni, imageSize: Wi, imageScalar: Hi, imageOverlayMarkup: ji, stagePadded: Vi, stageRecenter: qi} = Ue;
            let Gi;
            cr(e, si, (e => i(140, I = e))),
            cr(e, li, (e => i(144, O = e))),
            cr(e, ui, (e => i(173, K = e))),
            cr(e, di, (e => i(24, te = e))),
            cr(e, pi, (e => i(151, G = e))),
            cr(e, mi, (e => i(148, j = e))),
            cr(e, vi, (e => i(147, H = e))),
            cr(e, xi, (e => i(183, he = e))),
            cr(e, wi, (e => i(172, z = e))),
            cr(e, _i, (e => i(158, _e = e))),
            cr(e, ki, (e => i(157, Se = e))),
            cr(e, Ci, (e => i(14, Y = e))),
            cr(e, Ti, (e => i(26, Ee = e))),
            cr(e, Mi, (e => i(184, me = e))),
            cr(e, Pi, (e => i(150, q = e))),
            cr(e, Ei, (e => i(149, U = e))),
            cr(e, Ri, (e => i(182, pe = e))),
            cr(e, Ai, (e => i(143, F = e))),
            cr(e, Ii, (e => i(176, ie = e))),
            cr(e, Li, (e => i(178, ne = e))),
            cr(e, Di, (e => i(13, N = e))),
            cr(e, zi, (e => i(154, J = e))),
            cr(e, Fi, (e => i(180, le = e))),
            cr(e, Oi, (e => i(177, oe = e))),
            cr(e, Bi, (e => i(179, re = e))),
            cr(e, Ni, (e => i(153, Q = e))),
            cr(e, Wi, (e => i(152, Z = e))),
            cr(e, Hi, (e => i(146, W = e))),
            cr(e, Vi, (e => i(142, D = e)));
            const Ki = (e, t) => {
                const i = {
                    target: e,
                    translate: t
                }
                  , o = it(Xe(J), H)
                  , n = it(Xe(le), H);
                let r = Kf(U, i, {
                    ...j,
                    x: 0,
                    y: 0
                }, {
                    aspectRatio: re,
                    minSize: o,
                    maxSize: n
                });
                if (r = ( (e, t, i) => {
                    const [o,n,r,a] = Dt(e)
                      , s = {
                        ...e
                    };
                    if (o < t.y && (e.height = e.height - (t.y - o),
                    e.y = t.y),
                    n > t.x + t.width && (e.width = t.x + t.width - e.x),
                    r > t.y + t.height && (e.height = t.y + t.height - e.y),
                    a < t.x && (e.width = e.width - (t.x - a),
                    e.x = t.x),
                    i) {
                        const t = Math.min(1, s.width / e.width, s.height / e.height);
                        return kt(s, t)
                    }
                    return e
                }
                )(r, {
                    ...j,
                    x: 0,
                    y: 0
                }, re),
                !Q)
                    return {
                        boundsLimited: r,
                        boundsIntent: r
                    };
                let a = dg(U, r, i, ce, {
                    aspectRatio: re,
                    minSize: o,
                    maxSize: n
                });
                return {
                    boundsLimited: a,
                    boundsIntent: a
                }
            }
              , Xi = (e, t) => {
                const i = {
                    target: e,
                    translate: t
                }
                  , o = it(Xe(J), H)
                  , n = it(Xe(le), H)
                  , r = ( (e, t, i={}) => {
                    const {target: o, translate: n} = t
                      , {aspectRatio: r, minSize: a} = i
                      , s = xe[qf[o]]
                      , l = ze(pt(e), Ce(s[0] * e.width, s[1] * e.height))
                      , c = xe[o]
                      , u = ze(pt(e), Ce(c[0] * e.width, c[1] * e.height))
                      , [d,p,h,m,f,g,y] = Gf(o);
                    let $ = n.x
                      , b = n.y;
                    f ? b = 0 : g && ($ = 0);
                    let[v,x,w,S] = Dt(e);
                    if (d ? S = l.x : p && (x = l.x),
                    m ? v = l.y : h && (w = l.y),
                    d ? x = u.x + $ : p && (S = u.x + $),
                    m ? w = u.y + b : h && (v = u.y + b),
                    a && f && w - v < a.height) {
                        const e = a.height - (w - v);
                        v -= .5 * e,
                        w += .5 * e
                    }
                    if (a && g && x - S < a.width) {
                        const e = a.width - (x - S);
                        S -= .5 * e,
                        x += .5 * e
                    }
                    if (r)
                        if (y) {
                            let e = x - S
                              , t = w - v;
                            f ? (t = e / r,
                            v = l.y - .5 * t,
                            w = l.y + .5 * t) : g && (e = t * r,
                            S = l.x - .5 * e,
                            x = l.x + .5 * e)
                        } else {
                            const e = Ce(u.x + $ - l.x, u.y + b - l.y);
                            o === $e ? (e.x = Math.max(0, e.x),
                            e.y = Math.min(0, e.y)) : o === be ? (e.x = Math.max(0, e.x),
                            e.y = Math.max(0, e.y)) : o === ve ? (e.x = Math.min(0, e.x),
                            e.y = Math.max(0, e.y)) : o === ye && (e.x = Math.min(0, e.x),
                            e.y = Math.min(0, e.y));
                            const t = Re(e)
                              , i = Ce(r, 1)
                              , n = Be(Ae(i), t);
                            o === $e ? (x = l.x + n.x,
                            v = l.y - n.y) : o === be ? (x = l.x + n.x,
                            w = l.y + n.y) : o === ve ? (S = l.x - n.x,
                            w = l.y + n.y) : o === ye && (S = l.x - n.x,
                            v = l.y - n.y)
                        }
                    return bt(S, v, x - S, w - v)
                }
                )(U, i, {
                    aspectRatio: re,
                    minSize: o
                });
                return {
                    boundsLimited: Kf(U, i, {
                        ...j,
                        x: 0,
                        y: 0
                    }, {
                        aspectRatio: re,
                        minSize: o,
                        maxSize: n
                    }),
                    boundsIntent: r
                }
            }
            ;
            let Zi, Yi;
            const Qi = ({translation: e, scalar: t}) => {
                B && (t = 1,
                e = Pe(Me(e)));
                const i = Math.min(q.width / N.width, q.height / N.height)
                  , o = Be(Me(e), 1 / i);
                let n;
                if (Yi) {
                    const t = Fe(Me(Yi), e);
                    Yi = e,
                    n = xt(pt(N), t)
                } else
                    n = xt(pt(Zi), Pe(Me(o))),
                    void 0 !== t && wt(n, 1 / t);
                yr(Ii, ie = n, ie),
                yr(Di, N = n, N)
            }
              , Ji = Ua([Oi, Di], ( ([e,t], i) => {
                if (!t)
                    return;
                const [o,n] = e
                  , r = Tt(t);
                i([Ye(Ft(It(o, r), we)), Ye(Ft(Lt(n, r), we))])
            }
            ));
            cr(e, Ji, (e => i(174, X = e)));
            const eo = Ua([Wi, Ni, zi, Fi, Oi, Ci], ( ([e,t,i,o,n,r], a) => {
                if (!e)
                    return;
                const s = n[0]
                  , l = n[1];
                let c, u;
                t ? (c = ( (e, t, i) => de(i) ? 1 - 1 / Math.min(e.height / t.width, e.width / t.height) : 1 - 1 / Math.min(e.width / t.width, e.height / t.height))(e, l, r),
                u = Math.min(s.width / i.width, s.height / i.height)) : (c = -1,
                u = 1),
                a([c, u].map((e => we(e))))
            }
            ));
            cr(e, eo, (e => i(27, Ie = e)));
            const to = Ua([Wi, Di, Oi, Ci], ( ([e,t,i,o], n) => {
                if (!e || !t)
                    return n(0);
                let r;
                const a = i[0]
                  , s = i[1]
                  , l = t.width
                  , c = t.height
                  , u = Tt(t)
                  , d = de(o) ? et(e.height, e.width) : e
                  , p = Lt(d, u);
                if (l <= p.width || c <= p.height) {
                    const e = p.width - a.width
                      , t = p.height - a.height;
                    r = 0 === e || 0 === t ? 1 : 1 - Math.min((l - a.width) / e, (c - a.height) / t)
                } else {
                    const e = s.width - p.width
                      , t = s.height - p.height
                      , i = Lt({
                        width: e,
                        height: t
                    }, u);
                    r = -Math.min((l - p.width) / i.width, (c - p.height) / i.height)
                }
                n(r)
            }
            ));
            cr(e, to, (e => i(28, De = e)));
            const io = e => {
                const t = Tt(Zi);
                let i, o, n;
                const r = de(Y) ? et(Z.height, Z.width) : Z
                  , a = Lt(r, t);
                if (e >= 0) {
                    const r = a.width - oe[0].width
                      , s = a.height - oe[0].height;
                    i = a.width - r * e,
                    o = a.height - s * e,
                    n = It({
                        width: i,
                        height: o
                    }, t)
                } else {
                    const r = oe[1].width - a.width
                      , s = oe[1].height - a.height;
                    i = a.width + r * -e,
                    o = a.height + s * -e,
                    n = Lt({
                        width: i,
                        height: o
                    }, t)
                }
                i = n.width,
                o = n.height;
                const s = Zi.x + .5 * Zi.width - .5 * i
                  , l = Zi.y + .5 * Zi.height - .5 * o;
                yr(Di, N = {
                    x: s,
                    y: l,
                    width: i,
                    height: o
                }, N)
            }
            ;
            let oo;
            const no = e => {
                const t = wt(pt(oo), 1 / e);
                yr(Ii, ie = t, ie),
                yr(Di, N = t, N)
            }
            ;
            let ro;
            const ao = () => {
                qi.set({})
            }
            ;
            let so;
            const lo = ic(0, {
                precision: 1e-4
            });
            cr(e, lo, (e => i(29, Oe = e)));
            const co = ic();
            cr(e, co, (e => i(30, Ne = e)));
            const uo = Ua([Bi, Mi, Jt], ( ([e,t,i], n) => {
                if (!o)
                    return;
                const r = ud(i)
                  , a = [...r].map((e => e[0])).sort(( (e, t) => Ui(e[0]) && !Ui(t[0]) ? 1 : -1)).find((i => {
                    if (Ui(i) && t) {
                        const [o,n] = i
                          , r = t.width === o && t.height === n
                          , a = e === ae(o, n);
                        return r && a
                    }
                    return i === e
                }
                ));
                if (!a)
                    return n(void 0);
                n(r.map((e => e[0])).findIndex((e => Ui(e) ? ms(e, a) : e === a)))
            }
            ));
            cr(e, uo, (e => i(155, fe = e)));
            const po = (e, t) => {
                if (!o || -1 === e || void 0 === e)
                    return;
                const i = ud(t)[e][0];
                return i ? Ui(i) ? ae(i[0], i[1]) : i : void 0
            }
              , ho = Ua([fi, Ai, ci], ( ([e,t,i], o) => {
                const {rows: n, cols: r, opacity: a} = qe(Qt, i);
                if (!t || a <= 0)
                    return o([]);
                const {x: s, y: l, width: c, height: u} = t
                  , d = c / r
                  , p = u / n
                  , h = [];
                for (let t = 1; t <= n - 1; t++) {
                    const i = l + p * t;
                    h.push({
                        id: `image-selection-guide-row-${t}`,
                        points: [Ce(s, i), Ce(s + c, i)],
                        opacity: a,
                        strokeWidth: 1,
                        strokeColor: e
                    })
                }
                for (let t = 1; t <= r - 1; t++) {
                    const i = s + d * t;
                    h.push({
                        id: `image-selection-guide-col-${t}`,
                        points: [Ce(i, l), Ce(i, l + u)],
                        opacity: a,
                        strokeWidth: 1,
                        strokeColor: e
                    })
                }
                o(h)
            }
            ));
            cr(e, ho, (e => i(141, L = e)));
            const mo = `crop-${V()}`;
            let fo, go, yo = mo + "-" + (Je ? Nt : "zoom"), $o = yo;
            const bo = ic(A ? 20 : 0);
            return cr(e, bo, (e => i(138, E = e))),
            e.$$set = e => {
                "isActive"in e && He(i(0, je = e.isActive)),
                "stores"in e && i(97, Ue = e.stores),
                "cropImageSelectionCornerStyle"in e && i(1, Ve = e.cropImageSelectionCornerStyle),
                "cropWillRenderImageSelectionGuides"in e && i(98, qe = e.cropWillRenderImageSelectionGuides),
                "cropAutoCenterImageSelectionTimeout"in e && i(99, Ge = e.cropAutoCenterImageSelectionTimeout),
                "cropEnableZoomMatchImageAspectRatio"in e && i(100, Ke = e.cropEnableZoomMatchImageAspectRatio),
                "cropEnableRotateMatchImageAspectRatio"in e && i(101, Ze = e.cropEnableRotateMatchImageAspectRatio),
                "cropEnableRotationInput"in e && i(102, Je = e.cropEnableRotationInput),
                "cropEnableZoom"in e && i(2, tt = e.cropEnableZoom),
                "cropEnableZoomInput"in e && i(103, st = e.cropEnableZoomInput),
                "cropEnableZoomAutoHide"in e && i(104, lt = e.cropEnableZoomAutoHide),
                "cropEnableImageSelection"in e && i(105, ct = e.cropEnableImageSelection),
                "cropEnableInfoIndicator"in e && i(106, ut = e.cropEnableInfoIndicator),
                "cropEnableZoomTowardsWheelPosition"in e && i(107, dt = e.cropEnableZoomTowardsWheelPosition),
                "cropEnableLimitWheelInputToCropSelection"in e && i(108, ht = e.cropEnableLimitWheelInputToCropSelection),
                "cropEnableCenterImageSelection"in e && i(109, ft = e.cropEnableCenterImageSelection),
                "cropEnableButtonRotateLeft"in e && i(110, gt = e.cropEnableButtonRotateLeft),
                "cropEnableButtonRotateRight"in e && i(111, yt = e.cropEnableButtonRotateRight),
                "cropEnableButtonFlipHorizontal"in e && i(112, St = e.cropEnableButtonFlipHorizontal),
                "cropEnableButtonFlipVertical"in e && i(113, _t = e.cropEnableButtonFlipVertical),
                "cropSelectPresetOptions"in e && i(114, Mt = e.cropSelectPresetOptions),
                "cropEnableSelectPreset"in e && i(115, Pt = e.cropEnableSelectPreset),
                "cropEnableFilterMatchAspectRatio"in e && i(116, Et = e.cropEnableFilterMatchAspectRatio),
                "cropSelectPresetFilter"in e && i(95, zt = e.cropSelectPresetFilter),
                "cropEnableButtonToggleCropLimit"in e && i(117, Ot = e.cropEnableButtonToggleCropLimit),
                "cropWillRenderTools"in e && i(118, Bt = e.cropWillRenderTools),
                "cropActiveTransformTool"in e && i(119, Nt = e.cropActiveTransformTool),
                "cropMinimizeToolbar"in e && i(120, Wt = e.cropMinimizeToolbar),
                "cropInteractionFocus"in e && i(121, Ht = e.cropInteractionFocus),
                "cropRotationRange"in e && i(3, jt = e.cropRotationRange),
                "cropMaskOpacity"in e && i(122, Ut = e.cropMaskOpacity),
                "locale"in e && i(4, Vt = e.locale)
            }
            ,
            e.$$.update = () => {
                4096 & e.$$.dirty[0] | 268435456 & e.$$.dirty[3] && Xt.set("selection" === Ht && R),
                2097152 & e.$$.dirty[3] && i(129, o = Mt && Array.isArray(Mt) && Mt.length),
                2097152 & e.$$.dirty[3] | 32 & e.$$.dirty[4] && Jt.set(o ? Mt : []),
                4096 & e.$$.dirty[0] | 32768 & e.$$.dirty[4] && R && Si.set(1, {
                    hard: !A
                }),
                4096 & e.$$.dirty[0] && gi.set(!R),
                4096 & e.$$.dirty[0] && yi.set(!R),
                4096 & e.$$.dirty[0] && R && $i.set(!0),
                65536 & e.$$.dirty[4] && i(124, h = "overlay" === I.layoutMode),
                4194304 & e.$$.dirty[3] | 1 & e.$$.dirty[4] && i(128, x = Pt && !h),
                83886080 & e.$$.dirty[4] && i(137, l = j && q && Rt(j, q)),
                67117056 & e.$$.dirty[4] && i(135, c = !(!q || !l)),
                67119104 & e.$$.dirty[4] && i(133, u = c && Ct(q, l, (e => we(e, 5)))),
                16400 & e.$$.dirty[0] | 52297732 & e.$$.dirty[3] | 1879114288 & e.$$.dirty[4] | 31 & e.$$.dirty[5] && i(11, n = ke && Bt([gt && ["Button", "rotate-left", {
                    label: Vt.cropLabelButtonRotateLeft,
                    labelClass: "PinturaToolbarContentWide",
                    icon: Vt.cropIconButtonRotateLeft,
                    onclick: () => {
                        ri(-Math.PI / 2),
                        ai.write()
                    }
                }], yt && ["Button", "rotate-right", {
                    label: Vt.cropLabelButtonRotateRight,
                    labelClass: "PinturaToolbarContentWide",
                    icon: Vt.cropIconButtonRotateRight,
                    onclick: () => {
                        ri(Math.PI / 2),
                        ai.write()
                    }
                }], St && ["Button", "flip-horizontal", {
                    label: Vt.cropLabelButtonFlipHorizontal,
                    labelClass: "PinturaToolbarContentWide",
                    icon: Vt.cropIconButtonFlipHorizontal,
                    onclick: () => {
                        de(Y) ? yr(ki, Se = !Se, Se) : yr(_i, _e = !_e, _e),
                        ai.write()
                    }
                }], _t && ["Button", "flip-vertical", {
                    label: Vt.cropLabelButtonFlipVertical,
                    labelClass: "PinturaToolbarContentWide",
                    icon: Vt.cropIconButtonFlipVertical,
                    onclick: () => {
                        de(Y) ? yr(_i, _e = !_e, _e) : yr(ki, Se = !Se, Se),
                        ai.write()
                    }
                }], x && o && [!1 === zt ? "Dropdown" : sg, "select-preset", {
                    icon: pd(Vt.cropIconSelectPreset, Vt, po(fe, ge)),
                    label: pd(Vt.cropLabelSelectPreset, Vt, po(fe, ge)),
                    labelClass: "PinturaToolbarContentWide",
                    options: ge,
                    filter: zt,
                    onfilterchange: ii,
                    selectedIndex: fe,
                    onchange: ({value: e}) => {
                        Ui(e) ? (yr(Bi, re = ae(e[0], e[1]), re),
                        yr(Mi, me = Qe(e), me)) : yr(Bi, re = e, re),
                        u && ao(),
                        ai.write()
                    }
                    ,
                    optionMapper: e => {
                        let t = !1;
                        const i = Ui(e.value) ? e.value[0] / e.value[1] : e.value;
                        if (i) {
                            const e = ss(Z, Y, i);
                            t = e.width < J.width || e.height < J.height
                        }
                        return e.icon = ( (e, t={}) => {
                            const {width: i=24, height: o=24, bounds: n=16, radius: r=3} = t;
                            let a, s, l, c, u = Ui(e) ? ae(e[0], e[1]) : e, d = !!u;
                            return u = d ? u : 1,
                            l = u > 1 ? n : u * n,
                            c = l / u,
                            a = Math.round(.5 * (i - l)),
                            s = Math.round(.5 * (o - c)),
                            `<rect fill="${d ? "currentColor" : "none"}" stroke="${d ? "none" : "currentColor"}" stroke-width="${i / 16}" stroke-dasharray="${[i / 12, i / 6].join(" ")}" x="${a}" y="${s}" width="${l}" height="${c}" rx="${r}"/>`
                        }
                        )(e.value, {
                            bounds: 14
                        }),
                        {
                            ...e,
                            disabled: t
                        }
                    }
                }], Ot && ["Dropdown", "select-crop-limit", {
                    icon: pd(Vt.cropIconCropBoundary, Vt, Q),
                    label: Vt.cropLabelCropBoundary,
                    labelClass: "PinturaToolbarContentWide",
                    onchange: ({value: e}) => {
                        yr(Ni, Q = e, Q),
                        ai.write()
                    }
                    ,
                    options: [[!0, Vt.cropLabelCropBoundaryEdge, {
                        icon: pd(Vt.cropIconCropBoundary, Vt, !0)
                    }], [!1, Vt.cropLabelCropBoundaryNone, {
                        icon: pd(Vt.cropIconCropBoundary, Vt, !1)
                    }]]
                }]].filter(Boolean), I, ( () => Kt.set({}))).filter(Boolean)),
                6144 & e.$$.dirty[0] | 134217728 & e.$$.dirty[3] | 65537 & e.$$.dirty[4] && yr(xi, he = R && "never" !== Wt && ("always" === Wt || "short" === I.verticalSpace || h) ? n.map(( ([e,t,i]) => Array.isArray(i) ? [e, t, i] : [e, t, {
                    ...i,
                    hideLabel: !0
                }])) : [], he),
                536870912 & e.$$.dirty[4] && i(23, r = Q ? 0 : -1),
                150994944 & e.$$.dirty[4] && i(130, a = j && Ce(-(G.x - j.x), -(G.y - j.y))),
                524352 & e.$$.dirty[4] && i(131, s = F && a && Ce(Uu(F.x + .5 * F.width + a.x), Uu(F.y + .5 * F.height + a.y))),
                33554432 & e.$$.dirty[4] && i(134, d = null != U),
                16785408 & e.$$.dirty[4] && i(136, p = j && l && (l.height === j.height || l.width === j.width)),
                12587008 & e.$$.dirty[4] && i(132, m = !p && H < 1 && W < 1),
                3840 & e.$$.dirty[4] && i(9, f = c && !d && (!u || m)),
                8192 & e.$$.dirty[0] | 8192 & e.$$.dirty[3] | 1 & e.$$.dirty[4] && i(22, g = ut && !!N && !h),
                524352 & e.$$.dirty[4] && i(8, b = F && a && {
                    x: F.x + a.x,
                    y: F.y + a.y,
                    width: F.width,
                    height: F.height
                }),
                256 & e.$$.dirty[0] | 4096 & e.$$.dirty[3] | 1 & e.$$.dirty[4] && i(21, y = ct && !!b && !h),
                65600 & e.$$.dirty[3] | 2097280 & e.$$.dirty[4] && i(10, $ = ft && !!s && !Ge && !B),
                512 & e.$$.dirty[0] | 1073741888 & e.$$.dirty[3] | 1048576 & e.$$.dirty[4] && f && Ge && !O && (clearTimeout(so),
                i(123, so = setTimeout(ao, Ge))),
                1073741824 & e.$$.dirty[3] | 1048576 & e.$$.dirty[4] && O && clearTimeout(so),
                1536 & e.$$.dirty[0] | 32768 & e.$$.dirty[4] && lo.set($ && f ? 1 : 0, {
                    hard: !1 === A
                }),
                32896 & e.$$.dirty[4] && co.set(s, {
                    hard: !1 === A
                }),
                4096 & e.$$.dirty[0] | 262144 & e.$$.dirty[4] && (R && !D ? (yr(wi, z.crop = {
                    maskOpacity: Ut,
                    maskMarkupOpacity: Ut
                }, z),
                wi.set(z)) : (delete z.crop,
                wi.set(z))),
                131072 & e.$$.dirty[4] && L && ji.update((e => {
                    const t = e.filter((e => !/^image\-selection\-guide/.test(e.id)));
                    return R ? [...t, ...L] : t
                }
                )),
                65536 & e.$$.dirty[4] && i(127, v = "short" !== I.verticalSpace),
                134217728 & e.$$.dirty[3] | 9 & e.$$.dirty[4] && i(20, w = "never" === Wt && !h || v && "always" !== Wt),
                4 & e.$$.dirty[0] | 1024 & e.$$.dirty[3] && i(126, S = tt && st),
                2048 & e.$$.dirty[3] | 12 & e.$$.dirty[4] && i(125, _ = lt ? v && S : S),
                512 & e.$$.dirty[3] | 2 & e.$$.dirty[4] && i(19, k = Je || _),
                2 & e.$$.dirty[4] && (_ || i(5, $o = yo)),
                32 & e.$$.dirty[0] && i(18, C = {
                    name: mo,
                    selected: $o
                }),
                16 & e.$$.dirty[0] | 512 & e.$$.dirty[3] | 2 & e.$$.dirty[4] && i(7, T = [Je && {
                    id: mo + "-rotation",
                    label: Vt.cropLabelTabRotation
                }, _ && {
                    id: mo + "-zoom",
                    label: Vt.cropLabelTabZoom
                }].filter(Boolean)),
                128 & e.$$.dirty[0] && i(17, M = T.map((e => e.id))),
                64 & e.$$.dirty[0] | 1 & e.$$.dirty[4] && go && !go.children.length && h && go.dispatchEvent(new CustomEvent("measure",{
                    detail: go.rect
                })),
                4096 & e.$$.dirty[0] | 32768 & e.$$.dirty[4] && A && bo.set(R ? 0 : 20),
                16384 & e.$$.dirty[4] && i(16, P = E ? `transform: translateY(${E}px)` : void 0)
            }
            ,
            [je, Ve, tt, jt, Vt, $o, go, T, b, f, $, n, R, N, Y, fo, P, M, C, k, w, y, g, r, te, Te, Ee, Ie, De, Oe, Ne, qt, Gt, Kt, Xt, Zt, Yt, Jt, si, li, ui, di, pi, mi, bi, vi, xi, wi, _i, ki, Ci, Ti, Mi, Pi, Ei, Ri, Ai, Ii, Li, Di, zi, Fi, Oi, Bi, Ni, Wi, Hi, Vi, () => {
                Qt = "select",
                yr(li, O = !0, O),
                yr(Ei, U = pt(q), U),
                Gi = B ? Ki : Xi
            }
            , ({detail: e}) => {
                const {boundsLimited: t, boundsIntent: i} = Gi(e.direction, e.translation);
                yr(ui, K = !0, K),
                yr(Ri, pe = i, pe),
                yr(Pi, q = t, q)
            }
            , ({detail: e}) => {
                const {boundsLimited: t} = Gi(e.direction, e.translation);
                yr(ui, K = !1, K),
                yr(li, O = !1, O),
                yr(Ri, pe = void 0, pe),
                Re(e.translation) && (yr(Pi, q = t, q),
                ai.write()),
                yr(Ei, U = void 0, U),
                Qt = void 0
            }
            , () => {
                Qt = "rotate",
                yr(li, O = !0, O),
                yr(Li, ne = pt(N), ne)
            }
            , e => {
                yr(ui, K = !0, K),
                yr(Ci, Y = e, Y)
            }
            , e => {
                yr(ui, K = !1, K),
                yr(li, O = !1, O),
                yr(Ci, Y = e, Y),
                ai.write(),
                yr(Li, ne = void 0, ne)
            }
            , () => {
                Qt = "pan",
                Yi = void 0,
                yr(li, O = !0, O),
                Zi = pt(N)
            }
            , ({detail: e}) => {
                yr(ui, K = !0, K),
                Qi(e)
            }
            , ({detail: e}) => {
                yr(ui, K = !1, K),
                yr(li, O = !1, O),
                (Re(e.translation) > 0 || 0 !== e.scalar) && (Qi(e),
                ai.write()),
                yr(Ii, ie = void 0, ie),
                Zi = void 0
            }
            , ({detail: {translation: e}}) => {
                B && (e = Pe(Me(e))),
                Yi = e,
                yr(li, O = !1, O)
            }
            , Ji, eo, to, () => {
                Qt = "zoom",
                yr(li, O = !0, O),
                Zi = pt(N)
            }
            , e => {
                yr(ui, K = !1, K),
                io(e)
            }
            , e => {
                io(e),
                ai.write(),
                yr(ui, K = !1, K),
                yr(li, O = !1, O),
                Zi = void 0
            }
            , () => {
                Qt = "zoom",
                Zi || (oo = pt(N),
                yr(li, O = !0, O))
            }
            , ({detail: e}) => {
                oo && (yr(ui, K = !0, K),
                no(e))
            }
            , ({detail: e}) => {
                oo && (yr(ui, K = !1, K),
                yr(li, O = !1, O),
                no(e),
                yr(Ii, ie = void 0, ie),
                oo = void 0,
                ai.write())
            }
            , e => {
                const t = jh(e, te, G);
                if (ht && !At(q, t))
                    return;
                Qt = "zoom",
                yr(li, O = !0, O),
                yr(ui, K = !0, K),
                e.preventDefault(),
                e.stopPropagation();
                const i = vu(e, {
                    fixScrollDirection: ee
                })
                  , o = 1 + i / 100
                  , n = pt(N)
                  , r = 1 === Math.min(N.width / J.width, N.height / J.height);
                if (Ke && Q) {
                    const e = ni(N, Z, Y);
                    if (ei() && e && i > 0 && u) {
                        yr(li, O = !1, O),
                        yr(ui, K = !1, K);
                        const e = de(Y) ? mt({
                            height: Z.width,
                            width: Z.height
                        }) : mt(Z);
                        if (Ct(n, e))
                            return;
                        if (clearTimeout(ro),
                        Ct(ai.state.crop, e))
                            return;
                        return yr(Di, N = e, N),
                        void ai.write()
                    }
                }
                let a = vt(N);
                if (dt && "selection" !== Ht && i < 0 && !r) {
                    const e = Fe(Me(t), q)
                      , i = Math.min(q.width / N.width, q.height / N.height)
                      , o = wt(pt(q), 1.1);
                    a = At(o, t) ? ze(pt(N), Be(e, 1 / i)) : a
                }
                let s = wt(pt(N), o, a);
                if (rt(X[1], s) || (s = $t(vt(s), X[1])),
                rt(s, X[0]) || (s = $t(vt(s), X[0])),
                Ct(n, s, we))
                    return yr(li, O = !1, O),
                    void yr(ui, K = !1, K);
                yr(Di, N = Ft(s, (e => we(e, 5))), N),
                yr(li, O = !1, O),
                yr(ui, K = !1, K),
                clearTimeout(ro),
                ro = setTimeout(( () => {
                    ai.write()
                }
                ), 500)
            }
            , ao, lo, co, uo, ho, mo, bo, zt, "crop", Ue, qe, Ge, Ke, Ze, Je, st, lt, ct, ut, dt, ht, ft, gt, yt, St, _t, Mt, Pt, Et, Ot, Bt, Nt, Wt, Ht, Ut, so, h, _, S, v, x, o, a, s, m, u, d, c, p, l, E, A, I, L, D, F, O, B, W, H, j, U, q, G, Z, Q, J, fe, ge, Se, _e, ke, function(t) {
                na.call(this, e, t)
            }
            , ({detail: e}) => i(5, $o = e), function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    go = e,
                    i(6, go)
                }
                ))
            }
            , e => Hh(e), function(e) {
                fo = e,
                i(15, fo)
            }
            , function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var Pg = {
            util: ["crop", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, Mg, _g, ar, {
                        name: 96,
                        isActive: 0,
                        stores: 97,
                        cropImageSelectionCornerStyle: 1,
                        cropWillRenderImageSelectionGuides: 98,
                        cropAutoCenterImageSelectionTimeout: 99,
                        cropEnableZoomMatchImageAspectRatio: 100,
                        cropEnableRotateMatchImageAspectRatio: 101,
                        cropEnableRotationInput: 102,
                        cropEnableZoom: 2,
                        cropEnableZoomInput: 103,
                        cropEnableZoomAutoHide: 104,
                        cropEnableImageSelection: 105,
                        cropEnableInfoIndicator: 106,
                        cropEnableZoomTowardsWheelPosition: 107,
                        cropEnableLimitWheelInputToCropSelection: 108,
                        cropEnableCenterImageSelection: 109,
                        cropEnableButtonRotateLeft: 110,
                        cropEnableButtonRotateRight: 111,
                        cropEnableButtonFlipHorizontal: 112,
                        cropEnableButtonFlipVertical: 113,
                        cropSelectPresetOptions: 114,
                        cropEnableSelectPreset: 115,
                        cropEnableFilterMatchAspectRatio: 116,
                        cropSelectPresetFilter: 95,
                        cropEnableButtonToggleCropLimit: 117,
                        cropWillRenderTools: 118,
                        cropActiveTransformTool: 119,
                        cropMinimizeToolbar: 120,
                        cropInteractionFocus: 121,
                        cropRotationRange: 3,
                        cropMaskOpacity: 122,
                        locale: 4
                    }, null, [-1, -1, -1, -1, -1, -1, -1, -1])
                }
                get name() {
                    return this.$$.ctx[96]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[97]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get cropImageSelectionCornerStyle() {
                    return this.$$.ctx[1]
                }
                set cropImageSelectionCornerStyle(e) {
                    this.$$set({
                        cropImageSelectionCornerStyle: e
                    }),
                    $a()
                }
                get cropWillRenderImageSelectionGuides() {
                    return this.$$.ctx[98]
                }
                set cropWillRenderImageSelectionGuides(e) {
                    this.$$set({
                        cropWillRenderImageSelectionGuides: e
                    }),
                    $a()
                }
                get cropAutoCenterImageSelectionTimeout() {
                    return this.$$.ctx[99]
                }
                set cropAutoCenterImageSelectionTimeout(e) {
                    this.$$set({
                        cropAutoCenterImageSelectionTimeout: e
                    }),
                    $a()
                }
                get cropEnableZoomMatchImageAspectRatio() {
                    return this.$$.ctx[100]
                }
                set cropEnableZoomMatchImageAspectRatio(e) {
                    this.$$set({
                        cropEnableZoomMatchImageAspectRatio: e
                    }),
                    $a()
                }
                get cropEnableRotateMatchImageAspectRatio() {
                    return this.$$.ctx[101]
                }
                set cropEnableRotateMatchImageAspectRatio(e) {
                    this.$$set({
                        cropEnableRotateMatchImageAspectRatio: e
                    }),
                    $a()
                }
                get cropEnableRotationInput() {
                    return this.$$.ctx[102]
                }
                set cropEnableRotationInput(e) {
                    this.$$set({
                        cropEnableRotationInput: e
                    }),
                    $a()
                }
                get cropEnableZoom() {
                    return this.$$.ctx[2]
                }
                set cropEnableZoom(e) {
                    this.$$set({
                        cropEnableZoom: e
                    }),
                    $a()
                }
                get cropEnableZoomInput() {
                    return this.$$.ctx[103]
                }
                set cropEnableZoomInput(e) {
                    this.$$set({
                        cropEnableZoomInput: e
                    }),
                    $a()
                }
                get cropEnableZoomAutoHide() {
                    return this.$$.ctx[104]
                }
                set cropEnableZoomAutoHide(e) {
                    this.$$set({
                        cropEnableZoomAutoHide: e
                    }),
                    $a()
                }
                get cropEnableImageSelection() {
                    return this.$$.ctx[105]
                }
                set cropEnableImageSelection(e) {
                    this.$$set({
                        cropEnableImageSelection: e
                    }),
                    $a()
                }
                get cropEnableInfoIndicator() {
                    return this.$$.ctx[106]
                }
                set cropEnableInfoIndicator(e) {
                    this.$$set({
                        cropEnableInfoIndicator: e
                    }),
                    $a()
                }
                get cropEnableZoomTowardsWheelPosition() {
                    return this.$$.ctx[107]
                }
                set cropEnableZoomTowardsWheelPosition(e) {
                    this.$$set({
                        cropEnableZoomTowardsWheelPosition: e
                    }),
                    $a()
                }
                get cropEnableLimitWheelInputToCropSelection() {
                    return this.$$.ctx[108]
                }
                set cropEnableLimitWheelInputToCropSelection(e) {
                    this.$$set({
                        cropEnableLimitWheelInputToCropSelection: e
                    }),
                    $a()
                }
                get cropEnableCenterImageSelection() {
                    return this.$$.ctx[109]
                }
                set cropEnableCenterImageSelection(e) {
                    this.$$set({
                        cropEnableCenterImageSelection: e
                    }),
                    $a()
                }
                get cropEnableButtonRotateLeft() {
                    return this.$$.ctx[110]
                }
                set cropEnableButtonRotateLeft(e) {
                    this.$$set({
                        cropEnableButtonRotateLeft: e
                    }),
                    $a()
                }
                get cropEnableButtonRotateRight() {
                    return this.$$.ctx[111]
                }
                set cropEnableButtonRotateRight(e) {
                    this.$$set({
                        cropEnableButtonRotateRight: e
                    }),
                    $a()
                }
                get cropEnableButtonFlipHorizontal() {
                    return this.$$.ctx[112]
                }
                set cropEnableButtonFlipHorizontal(e) {
                    this.$$set({
                        cropEnableButtonFlipHorizontal: e
                    }),
                    $a()
                }
                get cropEnableButtonFlipVertical() {
                    return this.$$.ctx[113]
                }
                set cropEnableButtonFlipVertical(e) {
                    this.$$set({
                        cropEnableButtonFlipVertical: e
                    }),
                    $a()
                }
                get cropSelectPresetOptions() {
                    return this.$$.ctx[114]
                }
                set cropSelectPresetOptions(e) {
                    this.$$set({
                        cropSelectPresetOptions: e
                    }),
                    $a()
                }
                get cropEnableSelectPreset() {
                    return this.$$.ctx[115]
                }
                set cropEnableSelectPreset(e) {
                    this.$$set({
                        cropEnableSelectPreset: e
                    }),
                    $a()
                }
                get cropEnableFilterMatchAspectRatio() {
                    return this.$$.ctx[116]
                }
                set cropEnableFilterMatchAspectRatio(e) {
                    this.$$set({
                        cropEnableFilterMatchAspectRatio: e
                    }),
                    $a()
                }
                get cropSelectPresetFilter() {
                    return this.$$.ctx[95]
                }
                set cropSelectPresetFilter(e) {
                    this.$$set({
                        cropSelectPresetFilter: e
                    }),
                    $a()
                }
                get cropEnableButtonToggleCropLimit() {
                    return this.$$.ctx[117]
                }
                set cropEnableButtonToggleCropLimit(e) {
                    this.$$set({
                        cropEnableButtonToggleCropLimit: e
                    }),
                    $a()
                }
                get cropWillRenderTools() {
                    return this.$$.ctx[118]
                }
                set cropWillRenderTools(e) {
                    this.$$set({
                        cropWillRenderTools: e
                    }),
                    $a()
                }
                get cropActiveTransformTool() {
                    return this.$$.ctx[119]
                }
                set cropActiveTransformTool(e) {
                    this.$$set({
                        cropActiveTransformTool: e
                    }),
                    $a()
                }
                get cropMinimizeToolbar() {
                    return this.$$.ctx[120]
                }
                set cropMinimizeToolbar(e) {
                    this.$$set({
                        cropMinimizeToolbar: e
                    }),
                    $a()
                }
                get cropInteractionFocus() {
                    return this.$$.ctx[121]
                }
                set cropInteractionFocus(e) {
                    this.$$set({
                        cropInteractionFocus: e
                    }),
                    $a()
                }
                get cropRotationRange() {
                    return this.$$.ctx[3]
                }
                set cropRotationRange(e) {
                    this.$$set({
                        cropRotationRange: e
                    }),
                    $a()
                }
                get cropMaskOpacity() {
                    return this.$$.ctx[122]
                }
                set cropMaskOpacity(e) {
                    this.$$set({
                        cropMaskOpacity: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[4]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
            }
            ]
        };
        function Eg(e) {
            let t, i, o, n, r, a, s, l = e[77], c = (H(e[77].label) ? e[77].label(e[2]) : e[77].label) + "";
            function u(...t) {
                return e[51](e[77], ...t)
            }
            const d = () => e[52](i, l)
              , p = () => e[52](null, l);
            return {
                c() {
                    t = Er("div"),
                    i = Er("div"),
                    o = Ir(),
                    n = Er("span"),
                    r = Ar(c),
                    Or(i, "class", Lg),
                    Or(t, "slot", "option"),
                    Or(t, "class", "PinturaFilterOption")
                },
                m(e, l) {
                    Mr(e, t, l),
                    kr(t, i),
                    d(),
                    kr(t, o),
                    kr(t, n),
                    kr(n, r),
                    a || (s = [Dr(i, "measure", u), $r($c.call(null, i))],
                    a = !0)
                },
                p(t, i) {
                    l !== (e = t)[77] && (p(),
                    l = e[77],
                    d()),
                    4 & i[0] | 32768 & i[2] && c !== (c = (H(e[77].label) ? e[77].label(e[2]) : e[77].label) + "") && Wr(r, c)
                },
                d(e) {
                    e && Pr(t),
                    p(),
                    a = !1,
                    nr(s)
                }
            }
        }
        function Rg(e) {
            let t, i;
            return t = new Nd({
                props: {
                    locale: e[2],
                    layout: "row",
                    options: e[3],
                    selectedIndex: e[12],
                    onchange: e[32],
                    $$slots: {
                        option: [Eg, ({option: e}) => ({
                            77: e
                        }), ({option: e}) => [0, 0, e ? 32768 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    4 & i[0] && (o.locale = e[2]),
                    8 & i[0] && (o.options = e[3]),
                    4096 & i[0] && (o.selectedIndex = e[12]),
                    1028 & i[0] | 98304 & i[2] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Ag(e) {
            let t, i, o, n, r, a, s, l;
            function c(t) {
                e[54](t)
            }
            function u(t) {
                e[55](t)
            }
            function d(t) {
                e[56](t)
            }
            let p = {
                elasticity: e[13] * e[19],
                onscroll: e[53],
                $$slots: {
                    default: [Rg]
                },
                $$scope: {
                    ctx: e
                }
            };
            return void 0 !== e[4] && (p.maskFeatherStartOpacity = e[4]),
            void 0 !== e[5] && (p.maskFeatherEndOpacity = e[5]),
            void 0 !== e[6] && (p.maskFeatherSize = e[6]),
            i = new Su({
                props: p
            }),
            aa.push(( () => Da(i, "maskFeatherStartOpacity", c))),
            aa.push(( () => Da(i, "maskFeatherEndOpacity", u))),
            aa.push(( () => Da(i, "maskFeatherSize", d))),
            i.$on("measure", e[57]),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[11])
                },
                m(o, n) {
                    Mr(o, t, n),
                    Fa(i, t, null),
                    a = !0,
                    s || (l = [Dr(t, "transitionend", e[30]), Dr(t, "measure", e[58]), $r($c.call(null, t, {
                        observePosition: !0
                    }))],
                    s = !0)
                },
                p(e, s) {
                    const l = {};
                    8192 & s[0] && (l.elasticity = e[13] * e[19]),
                    128 & s[0] && (l.onscroll = e[53]),
                    5132 & s[0] | 65536 & s[2] && (l.$$scope = {
                        dirty: s,
                        ctx: e
                    }),
                    !o && 16 & s[0] && (o = !0,
                    l.maskFeatherStartOpacity = e[4],
                    ma(( () => o = !1))),
                    !n && 32 & s[0] && (n = !0,
                    l.maskFeatherEndOpacity = e[5],
                    ma(( () => n = !1))),
                    !r && 64 & s[0] && (r = !0,
                    l.maskFeatherSize = e[6],
                    ma(( () => r = !1))),
                    i.$set(l),
                    (!a || 2048 & s[0]) && Or(t, "style", e[11])
                },
                i(e) {
                    a || (ka(i.$$.fragment, e),
                    a = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    s = !1,
                    nr(l)
                }
            }
        }
        function Ig(e) {
            let t, i;
            return t = new Lf({
                props: {
                    $$slots: {
                        footer: [Ag]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            t.$on("measure", e[59]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16380 & i[0] | 65536 & i[2] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        let Lg = "PinturaFilterPreview";
        function Dg(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, $, b, v, x, w, S = Jn, _ = () => (S(),
            S = sr(M, (e => i(43, u = e))),
            M), k = Jn, C = () => (k(),
            k = sr(T, (e => i(49, b = e))),
            T);
            e.$$.on_destroy.push(( () => S())),
            e.$$.on_destroy.push(( () => k()));
            let {isActive: T} = t;
            C();
            let {isActiveFraction: M} = t;
            _();
            let {stores: P} = t
              , {locale: E} = t
              , {filterFunctions: R} = t
              , {filterOptions: A} = t;
            const I = oa("elasticityMultiplier");
            cr(e, I, (e => i(13, w = e)));
            const {history: L, interfaceImages: D, stageRectBase: z, utilRect: F, animation: O, scrollElasticity: B, imageSize: N, imagePreview: W, imageCropRect: j, imageRotation: U, imageFlipX: V, imageFlipY: q, imageBackgroundColor: G, imageGamma: K, imageColorMatrix: X, allowPan: Z, allowZoom: Y, allowZoomControls: Q, allowPlayPause: J} = P;
            cr(e, D, (e => i(60, d = e))),
            cr(e, z, (e => i(48, $ = e))),
            cr(e, F, (e => i(47, y = e))),
            cr(e, O, (e => i(50, v = e))),
            cr(e, N, (e => i(62, h = e))),
            cr(e, W, (e => i(42, c = e))),
            cr(e, G, (e => i(61, p = e))),
            cr(e, K, (e => i(44, m = e))),
            cr(e, X, (e => i(40, s = e)));
            const ee = ja({});
            cr(e, ee, (e => i(46, g = e)));
            const te = (e, t) => yr(ee, g[e.value] = t, g)
              , ie = Ua(ee, (e => {
                if (!e[void 0])
                    return;
                const t = e[void 0];
                return x && tt(x, t) ? x : Xe(t)
            }
            ));
            cr(e, ie, (e => i(63, x = e)));
            const oe = Ua([T, ie, j, N, U, V, q], ( ([e,t,i,o,n,r,a], s) => {
                if (!e || !t || !o)
                    return f;
                const l = mt(o)
                  , c = vt(l)
                  , u = ls(o, i, n)
                  , d = vt(u)
                  , p = Fe(Me(c), d)
                  , h = Pe(Me(p))
                  , m = Math.max(t.width / i.width, t.height / i.height);
                s({
                    origin: h,
                    translation: p,
                    rotation: {
                        x: a ? Math.PI : 0,
                        y: r ? Math.PI : 0,
                        z: n
                    },
                    scale: m
                })
            }
            ));
            cr(e, oe, (e => i(45, f = e)));
            const ne = ic(v ? 20 : 0);
            let re;
            cr(e, ne, (e => i(39, a = e)));
            const ae = {};
            let se, le, ce, ue, de, pe, he = {
                x: 0,
                y: 0
            };
            const me = ja([]);
            cr(e, me, (e => i(41, l = e)));
            const fe = e => {
                const t = {
                    ...e,
                    data: c,
                    size: h,
                    offset: {
                        ...e.offset
                    },
                    mask: {
                        ...e.mask
                    },
                    backgroundColor: p
                };
                return t.opacity = u,
                t.offset.y += a,
                t.mask.y += a,
                t.id = "filter",
                t
            }
              , ge = () => d.filter((e => "filter" !== e.id));
            return ea(( () => {
                D.set([])
            }
            )),
            e.$$set = e => {
                "isActive"in e && C(i(0, T = e.isActive)),
                "isActiveFraction"in e && _(i(1, M = e.isActiveFraction)),
                "stores"in e && i(34, P = e.stores),
                "locale"in e && i(2, E = e.locale),
                "filterFunctions"in e && i(35, R = e.filterFunctions),
                "filterOptions"in e && i(3, A = e.filterOptions)
            }
            ,
            e.$$.update = () => {
                if (262144 & e.$$.dirty[1] && Z.set(b),
                262144 & e.$$.dirty[1] && Y.set(b),
                262144 & e.$$.dirty[1] && Q.set(b),
                262144 & e.$$.dirty[1] && b && J.set(!1),
                8 & e.$$.dirty[0] && i(38, o = ud(A)),
                640 & e.$$.dirty[1] && i(12, n = ( (e, t) => {
                    if (!e || !e.filter || !t)
                        return 0;
                    const i = e.filter;
                    return t.findIndex(( ([e]) => {
                        if (!R[e])
                            return !1;
                        const t = R[e]();
                        return ms(t, i)
                    }
                    ))
                }
                )(s, o)),
                786432 & e.$$.dirty[1] && v && ne.set(b ? 0 : 20),
                512 & e.$$.dirty[0] | 458752 & e.$$.dirty[1] && b && y && $ && pe && i(37, de = {
                    x: $.x - y.x,
                    y: $.y - y.y + pe.y
                }),
                496 & e.$$.dirty[0] | 58096 & e.$$.dirty[1] && f && de && he && ue && re) {
                    const e = de.x + ue.x + he.x
                      , t = de.y
                      , i = ue.x + de.x
                      , n = i + ue.width;
                    me.set(o.map(( ([o], r) => {
                        const a = g[o]
                          , l = he.x + a.x
                          , c = l + a.width;
                        if (c < 0 || l > ue.width)
                            return !1;
                        const u = e + a.x
                          , d = t + a.y
                          , p = (e => ({
                            origin: Me(e.origin),
                            translation: Me(e.translation),
                            rotation: {
                                ...e.rotation
                            },
                            scale: e.scale
                        }))(f);
                        p.offset = Ce(.5 * a.width + u, .5 * a.height + d),
                        p.maskOpacity = 1,
                        p.mask = bt(u + 0, d, a.width + 0, a.height),
                        p.maskFeather = [1, 0, 1, 0, 1, n, 1, n],
                        l < ce && se < 1 && (p.maskFeather[0] = se,
                        p.maskFeather[1] = i,
                        p.maskFeather[2] = 1,
                        p.maskFeather[3] = i + ce),
                        c > ue.width - ce && le < 1 && (p.maskFeather[4] = le,
                        p.maskFeather[5] = n - ce,
                        p.maskFeather[6] = 1,
                        p.maskFeather[7] = n),
                        p.maskCornerRadius = re[o];
                        let h = s && Object.keys(s).filter((e => "filter" != e)).map((e => s[e])) || [];
                        return H(R[o]) && h.push(R[o]()),
                        p.colorMatrix = h.length ? Yn(h) : void 0,
                        p.gamma = m,
                        p
                    }
                    )).filter(Boolean))
                }
                if (7424 & e.$$.dirty[1])
                    if (u > 0 && l) {
                        const e = [...ge(), ...l.map(fe)];
                        D.set(e)
                    } else
                        D.set(ge());
                256 & e.$$.dirty[1] && i(11, r = a ? `transform: translateY(${a}px)` : void 0)
            }
            ,
            [T, M, E, A, se, le, ce, he, ue, pe, ae, r, n, w, I, D, z, F, O, B, N, W, G, K, X, ee, te, ie, oe, ne, e => {
                e.target.className === Lg && i(36, re = Object.keys(ae).reduce(( (e, t) => {
                    const i = ae[t]
                      , o = getComputedStyle(i)
                      , n = ["top-left", "top-right", "bottom-left", "bottom-right"].map((e => o.getPropertyValue(`border-${e}-radius`))).map(bu).map((e => 1.25 * e));
                    return e[t] = n,
                    e
                }
                ), {}))
            }
            , me, ({value: e}) => {
                yr(X, s = {
                    ...s,
                    filter: H(R[e]) ? R[e]() : void 0
                }, s),
                L.write()
            }
            , "filter", P, R, re, de, o, a, s, l, c, u, m, f, g, y, $, b, v, (e, t) => te(e, t.detail), function(e, t) {
                aa[e ? "unshift" : "push"](( () => {
                    ae[t.value] = e,
                    i(10, ae)
                }
                ))
            }
            , e => i(7, he = e), function(e) {
                se = e,
                i(4, se)
            }
            , function(e) {
                le = e,
                i(5, le)
            }
            , function(e) {
                ce = e,
                i(6, ce)
            }
            , e => i(8, ue = e.detail), e => i(9, pe = e.detail), function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var zg = {
            util: ["filter", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, Dg, Ig, ar, {
                        name: 33,
                        isActive: 0,
                        isActiveFraction: 1,
                        stores: 34,
                        locale: 2,
                        filterFunctions: 35,
                        filterOptions: 3
                    }, null, [-1, -1, -1])
                }
                get name() {
                    return this.$$.ctx[33]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get isActiveFraction() {
                    return this.$$.ctx[1]
                }
                set isActiveFraction(e) {
                    this.$$set({
                        isActiveFraction: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[34]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[2]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get filterFunctions() {
                    return this.$$.ctx[35]
                }
                set filterFunctions(e) {
                    this.$$set({
                        filterFunctions: e
                    }),
                    $a()
                }
                get filterOptions() {
                    return this.$$.ctx[3]
                }
                set filterOptions(e) {
                    this.$$set({
                        filterOptions: e
                    }),
                    $a()
                }
            }
            ]
        };
        function Fg(e) {
            let t, i, o, n;
            t = new Su({
                props: {
                    elasticity: e[6] * e[9],
                    class: "PinturaControlListScroller",
                    $$slots: {
                        default: [Bg]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            });
            const r = [{
                class: "PinturaControlPanels"
            }, {
                panelClass: "PinturaControlPanel"
            }, {
                panels: e[4]
            }, e[5]];
            let a = {
                $$slots: {
                    default: [Ng, ({panel: e}) => ({
                        42: e
                    }), ({panel: e}) => [0, e ? 2048 : 0]]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < r.length; e += 1)
                a = tr(a, r[e]);
            return o = new Xc({
                props: a
            }),
            {
                c() {
                    za(t.$$.fragment),
                    i = Ir(),
                    za(o.$$.fragment)
                },
                m(e, r) {
                    Fa(t, e, r),
                    Mr(e, i, r),
                    Fa(o, e, r),
                    n = !0
                },
                p(e, i) {
                    const n = {};
                    64 & i[0] && (n.elasticity = e[6] * e[9]),
                    38 & i[0] | 8192 & i[1] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n);
                    const a = 48 & i[0] ? Ia(r, [r[0], r[1], 16 & i[0] && {
                        panels: e[4]
                    }, 32 & i[0] && La(e[5])]) : {};
                    128 & i[0] | 10240 & i[1] && (a.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    o.$set(a)
                },
                i(e) {
                    n || (ka(t.$$.fragment, e),
                    ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    Oa(t, e),
                    e && Pr(i),
                    Oa(o, e)
                }
            }
        }
        function Og(e) {
            let t, i, o = e[43].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o)
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    4096 & t[1] && o !== (o = e[43].label + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Bg(e) {
            let t, i;
            const o = [{
                class: "PinturaControlList"
            }, {
                tabs: e[1]
            }, e[5]];
            let n = {
                $$slots: {
                    default: [Og, ({tab: e}) => ({
                        43: e
                    }), ({tab: e}) => [0, e ? 4096 : 0]]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new Fc({
                props: n
            }),
            t.$on("select", e[24]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 34 & i[0] ? Ia(o, [o[0], 2 & i[0] && {
                        tabs: e[1]
                    }, 32 & i[0] && La(e[5])]) : {};
                    12288 & i[1] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Ng(e) {
            let t, i;
            const o = [e[7][e[42]]];
            let n = {};
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new Of({
                props: n
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 128 & i[0] | 2048 & i[1] ? Ia(o, [La(e[7][e[42]])]) : {};
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Wg(e) {
            let t, i, o = e[5] && Fg(e);
            return {
                c() {
                    t = Er("div"),
                    o && o.c(),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[3])
                },
                m(e, n) {
                    Mr(e, t, n),
                    o && o.m(t, null),
                    i = !0
                },
                p(e, n) {
                    e[5] ? o ? (o.p(e, n),
                    32 & n[0] && ka(o, 1)) : (o = Fg(e),
                    o.c(),
                    ka(o, 1),
                    o.m(t, null)) : o && (Sa(),
                    Ca(o, 1, 1, ( () => {
                        o = null
                    }
                    )),
                    _a()),
                    (!i || 8 & n[0]) && Or(t, "style", e[3])
                },
                i(e) {
                    i || (ka(o),
                    i = !0)
                },
                o(e) {
                    Ca(o),
                    i = !1
                },
                d(e) {
                    e && Pr(t),
                    o && o.d()
                }
            }
        }
        function Hg(e) {
            let t, i;
            return t = new Lf({
                props: {
                    $$slots: {
                        footer: [Wg]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            t.$on("measure", e[25]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    254 & i[0] | 8192 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function jg(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m = Jn, f = () => (m(),
            m = sr(y, (e => i(21, c = e))),
            y);
            e.$$.on_destroy.push(( () => m()));
            let {stores: g} = t
              , {isActive: y} = t;
            f();
            let {locale: $={}} = t
              , {finetuneControlConfiguration: b} = t
              , {finetuneOptions: v} = t
              , {finetuneNudgePrecision: x} = t;
            const {history: w, animation: S, scrollElasticity: _, rangeInputElasticity: k, imageColorMatrix: C, imageConvolutionMatrix: T, imageGamma: M, imageVignette: P, imageNoise: E, allowPan: R, allowZoom: A, allowZoomControls: I, allowPlayPause: L} = g;
            cr(e, S, (e => i(22, u = e)));
            const D = {
                imageColorMatrix: C,
                imageConvolutionMatrix: T,
                imageGamma: M,
                imageVignette: P,
                imageNoise: E
            }
              , z = oa("elasticityMultiplier");
            cr(e, z, (e => i(6, p = e)));
            const F = `finetune-${V()}`
              , O = ja({});
            cr(e, O, (e => i(23, d = e)));
            const B = ja({});
            cr(e, B, (e => i(7, h = e)));
            let N = [];
            const W = ic(u ? 20 : 0);
            return cr(e, W, (e => i(20, l = e))),
            e.$$set = e => {
                "stores"in e && i(15, g = e.stores),
                "isActive"in e && f(i(0, y = e.isActive)),
                "locale"in e && i(16, $ = e.locale),
                "finetuneControlConfiguration"in e && i(17, b = e.finetuneControlConfiguration),
                "finetuneOptions"in e && i(18, v = e.finetuneOptions),
                "finetuneNudgePrecision"in e && i(19, x = e.finetuneNudgePrecision)
            }
            ,
            e.$$.update = () => {
                var t;
                2097152 & e.$$.dirty[0] && R.set(c),
                2097152 & e.$$.dirty[0] && A.set(c),
                2097152 & e.$$.dirty[0] && I.set(c),
                2097152 & e.$$.dirty[0] && c && L.set(!0),
                327680 & e.$$.dirty[0] && i(1, o = v ? v.map(( ([e,t]) => ({
                    id: e,
                    label: H(t) ? t($) : t
                }))) : []),
                2 & e.$$.dirty[0] && i(2, n = o.length ? o[0].id : void 0),
                4 & e.$$.dirty[0] && i(5, r = n && {
                    name: F,
                    selected: n
                }),
                2 & e.$$.dirty[0] && i(4, a = o.map((e => e.id))),
                131072 & e.$$.dirty[0] && b && (t = b,
                N && N.forEach((e => e())),
                N = a.map((e => {
                    const {getStore: i, getValue: o=se} = t[e];
                    return i(D).subscribe((t => {
                        const i = null != t ? o(t) : t;
                        yr(O, d = {
                            ...d,
                            [e]: i
                        }, d)
                    }
                    ))
                }
                ))),
                8519680 & e.$$.dirty[0] && b && d && yr(B, h = Object.keys(d).reduce(( (e, t) => {
                    const {base: i, min: o, max: n, getLabel: r, getStore: a, setValue: s=( (e, t) => e.set(t))} = b[t]
                      , l = a(D)
                      , c = null != d[t] ? d[t] : i;
                    return e[t] = {
                        base: i,
                        min: o,
                        max: n,
                        value: c,
                        valueLabel: r ? r(c, o, n, n - o) : Math.round(100 * c),
                        oninputmove: e => {
                            s(l, e)
                        }
                        ,
                        oninputend: e => {
                            s(l, e),
                            w.write()
                        }
                        ,
                        elasticity: p * k,
                        labelReset: $.labelReset,
                        nudgeMultiplier: x
                    },
                    e
                }
                ), {}), h),
                6291456 & e.$$.dirty[0] && u && W.set(c ? 0 : 20),
                1048576 & e.$$.dirty[0] && i(3, s = l ? `transform: translateY(${l}px)` : void 0)
            }
            ,
            [y, o, n, s, a, r, p, h, S, _, z, O, B, W, "finetune", g, $, b, v, x, l, c, u, d, ({detail: e}) => i(2, n = e), function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var Ug = {
            util: ["finetune", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, jg, Hg, ar, {
                        name: 14,
                        stores: 15,
                        isActive: 0,
                        locale: 16,
                        finetuneControlConfiguration: 17,
                        finetuneOptions: 18,
                        finetuneNudgePrecision: 19
                    }, null, [-1, -1])
                }
                get name() {
                    return this.$$.ctx[14]
                }
                get stores() {
                    return this.$$.ctx[15]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[16]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get finetuneControlConfiguration() {
                    return this.$$.ctx[17]
                }
                set finetuneControlConfiguration(e) {
                    this.$$set({
                        finetuneControlConfiguration: e
                    }),
                    $a()
                }
                get finetuneOptions() {
                    return this.$$.ctx[18]
                }
                set finetuneOptions(e) {
                    this.$$set({
                        finetuneOptions: e
                    }),
                    $a()
                }
                get finetuneNudgePrecision() {
                    return this.$$.ctx[19]
                }
                set finetuneNudgePrecision(e) {
                    this.$$set({
                        finetuneNudgePrecision: e
                    }),
                    $a()
                }
            }
            ]
        }
          , Vg = (e, t) => {
            const i = t.length;
            return e < 0 ? e % i + i : e >= i ? e % i : e
        }
        ;
        function qg(e, t, i) {
            const o = e.slice();
            return o[46] = t[i].key,
            o[47] = t[i].index,
            o[48] = t[i].translate,
            o[49] = t[i].scale,
            o[50] = t[i].selected,
            o[12] = t[i].rotate,
            o[51] = t[i].dir,
            o[52] = t[i].center,
            o[53] = t[i].type,
            o[2] = t[i].visible,
            o
        }
        function Gg(e) {
            let t, i;
            return {
                c() {
                    t = Er("div"),
                    Or(t, "class", "PinturaShapeManipulator"),
                    Or(t, "data-control", "point"),
                    Or(t, "style", i = `pointer-events:none;transform: translate3d(${e[52].x}px, ${e[52].y}px, 0) scale(${e[5]}, ${e[5]}); opacity: ${e[4]}`)
                },
                m(e, i) {
                    Mr(e, t, i)
                },
                p(e, o) {
                    56 & o[0] && i !== (i = `pointer-events:none;transform: translate3d(${e[52].x}px, ${e[52].y}px, 0) scale(${e[5]}, ${e[5]}); opacity: ${e[4]}`) && Or(t, "style", i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Kg(e, t) {
            let i, o, n, r, a, s, l, c, u, d;
            function p(...e) {
                return t[18](t[47], ...e)
            }
            let h = "edge" === t[53] && t[2] && Gg(t);
            return {
                key: e,
                first: null,
                c() {
                    i = Er("div"),
                    l = Ir(),
                    h && h.c(),
                    c = Lr(),
                    Or(i, "role", "button"),
                    Or(i, "aria-label", o = `Drag ${t[53]} ${t[46]}`),
                    Or(i, "tabindex", n = "edge" === t[53] ? -1 : 0),
                    Or(i, "class", "PinturaShapeManipulator"),
                    Or(i, "data-control", r = t[53]),
                    Or(i, "data-selected", a = t[50]),
                    Or(i, "style", s = `cursor:${t[51] ? t[51] + "-resize" : "move"};opacity:${t[4]};--tx:${t[48].x};--ty:${t[48].y};--r:${"edge" === t[53] ? t[12] : 0}rad;--sx:${"point" === t[53] ? t[5] : t[49].x};--sy:${"point" === t[53] ? t[5] : t[49].y};`),
                    this.first = i
                },
                m(e, o) {
                    Mr(e, i, o),
                    Mr(e, l, o),
                    h && h.m(e, o),
                    Mr(e, c, o),
                    u || (d = [Dr(i, "nudge", p), $r(fu.call(null, i, {
                        preventDefault: !0
                    })), Dr(i, "interactionstart", (function() {
                        rr(t[9]("start", t[47])) && t[9]("start", t[47]).apply(this, arguments)
                    }
                    )), Dr(i, "interactionupdate", (function() {
                        rr(t[9]("move", t[47])) && t[9]("move", t[47]).apply(this, arguments)
                    }
                    )), Dr(i, "interactionend", (function() {
                        rr(t[9]("end", t[47])) && t[9]("end", t[47]).apply(this, arguments)
                    }
                    )), $r(mu.call(null, i, {
                        observeKeys: !0
                    }))],
                    u = !0)
                },
                p(e, l) {
                    t = e,
                    8 & l[0] && o !== (o = `Drag ${t[53]} ${t[46]}`) && Or(i, "aria-label", o),
                    8 & l[0] && n !== (n = "edge" === t[53] ? -1 : 0) && Or(i, "tabindex", n),
                    8 & l[0] && r !== (r = t[53]) && Or(i, "data-control", r),
                    8 & l[0] && a !== (a = t[50]) && Or(i, "data-selected", a),
                    56 & l[0] && s !== (s = `cursor:${t[51] ? t[51] + "-resize" : "move"};opacity:${t[4]};--tx:${t[48].x};--ty:${t[48].y};--r:${"edge" === t[53] ? t[12] : 0}rad;--sx:${"point" === t[53] ? t[5] : t[49].x};--sy:${"point" === t[53] ? t[5] : t[49].y};`) && Or(i, "style", s),
                    "edge" === t[53] && t[2] ? h ? h.p(t, l) : (h = Gg(t),
                    h.c(),
                    h.m(c.parentNode, c)) : h && (h.d(1),
                    h = null)
                },
                d(e) {
                    e && Pr(i),
                    e && Pr(l),
                    h && h.d(e),
                    e && Pr(c),
                    u = !1,
                    nr(d)
                }
            }
        }
        function Xg(e) {
            let t, i, o, n;
            return {
                c() {
                    t = Er("div"),
                    Or(t, "role", "button"),
                    Or(t, "aria-label", "Drag rotator"),
                    Or(t, "tabindex", "0"),
                    Or(t, "class", "PinturaShapeManipulator"),
                    Or(t, "data-control", "rotate"),
                    Or(t, "style", i = `transform: translate3d(${e[0].x}px, ${e[0].y}px, 0) scale(${e[5]}, ${e[5]}); opacity: ${e[4]}`)
                },
                m(i, r) {
                    Mr(i, t, r),
                    o || (n = [Dr(t, "nudge", e[11]), $r(fu.call(null, t, {
                        preventDefault: !0
                    })), Dr(t, "interactionstart", e[12]("start")), Dr(t, "interactionupdate", e[12]("move")), Dr(t, "interactionend", e[12]("end")), $r(mu.call(null, t, {
                        observeKeys: !0
                    }))],
                    o = !0)
                },
                p(e, o) {
                    49 & o[0] && i !== (i = `transform: translate3d(${e[0].x}px, ${e[0].y}px, 0) scale(${e[5]}, ${e[5]}); opacity: ${e[4]}`) && Or(t, "style", i)
                },
                d(e) {
                    e && Pr(t),
                    o = !1,
                    nr(n)
                }
            }
        }
        function Zg(e) {
            let t, i, o = [], n = new Map, r = e[3];
            const a = e => e[46];
            for (let t = 0; t < r.length; t += 1) {
                let i = qg(e, r, t)
                  , s = a(i);
                n.set(s, o[t] = Kg(s, i))
            }
            let s = e[1] && Xg(e);
            return {
                c() {
                    for (let e = 0; e < o.length; e += 1)
                        o[e].c();
                    t = Ir(),
                    s && s.c(),
                    i = Lr()
                },
                m(e, n) {
                    for (let t = 0; t < o.length; t += 1)
                        o[t].m(e, n);
                    Mr(e, t, n),
                    s && s.m(e, n),
                    Mr(e, i, n)
                },
                p(e, l) {
                    1592 & l[0] && (r = e[3],
                    o = Aa(o, l, a, 1, e, r, n, t.parentNode, Ea, Kg, t, qg)),
                    e[1] ? s ? s.p(e, l) : (s = Xg(e),
                    s.c(),
                    s.m(i.parentNode, i)) : s && (s.d(1),
                    s = null)
                },
                i: Jn,
                o: Jn,
                d(e) {
                    for (let t = 0; t < o.length; t += 1)
                        o[t].d(e);
                    e && Pr(t),
                    s && s.d(e),
                    e && Pr(i)
                }
            }
        }
        function Yg(e, t, i) {
            let o, n, r, a;
            const s = ta()
              , l = .5 * ue
              , c = ce - l
              , u = ce + l
              , d = -ce
              , p = d - l
              , h = d + l
              , m = le - l
              , f = -le + l
              , g = l
              , y = -l
              , $ = ce - ue
              , b = $ - l
              , v = $ + l
              , x = le - ue
              , w = x - l
              , S = x + l
              , _ = d - ue
              , k = _ + l
              , C = _ - l
              , T = d + ue
              , M = T + l
              , P = T - l;
            let {visible: E=!1} = t
              , {points: R=[]} = t
              , {rotatorPoint: A} = t
              , {selectedPoint: I} = t
              , {enableDragEdges: L=!0} = t
              , {enableDragPoints: D=!0} = t
              , {enableRotatePoints: z=!0} = t;
            const F = oa("isAnimated");
            cr(e, F, (e => i(17, n = e)));
            const O = ic(.5, {
                precision: 1e-4,
                stiffness: .3,
                damping: .7
            });
            cr(e, O, (e => i(5, a = e)));
            const B = ic(0, {
                precision: .001,
                stiffness: .3,
                damping: .7
            });
            cr(e, B, (e => i(4, r = e)));
            const N = e => {
                let t = "";
                return (e <= u && e >= c || e >= p && e <= h) && (t = "ns"),
                (e <= f || e >= m || e >= y && e <= g) && (t = "ew"),
                (e >= w && e <= S || e <= M && e >= P) && (t = "nesw"),
                (e >= b && e <= v || e <= k && e >= C) && (t = "nwse"),
                t
            }
              , W = (e, t) => {
                s("resizestart", {
                    indexes: e,
                    translation: ke(),
                    isNudge: !0
                }),
                s("resizemove", {
                    indexes: e,
                    translation: t,
                    isNudge: !0
                }),
                s("resizeend", {
                    indexes: e,
                    translation: ke(),
                    isNudge: !0
                })
            }
            ;
            return e.$$set = e => {
                "visible"in e && i(2, E = e.visible),
                "points"in e && i(13, R = e.points),
                "rotatorPoint"in e && i(0, A = e.rotatorPoint),
                "selectedPoint"in e && i(14, I = e.selectedPoint),
                "enableDragEdges"in e && i(15, L = e.enableDragEdges),
                "enableDragPoints"in e && i(16, D = e.enableDragPoints),
                "enableRotatePoints"in e && i(1, z = e.enableRotatePoints)
            }
            ,
            e.$$.update = () => {
                131076 & e.$$.dirty[0] && O.set(E ? 1 : .5, {
                    hard: !1 === n
                }),
                131076 & e.$$.dirty[0] && B.set(E ? 1 : 0, {
                    hard: !1 === n
                }),
                8192 & e.$$.dirty[0] && i(3, o = ( (e, t) => {
                    let i = 0;
                    const o = Ve(e)
                      , n = []
                      , r = e.length;
                    for (; i < r; i++) {
                        const t = Vg(i - 1, e)
                          , r = Vg(i + 1, e)
                          , a = e[t]
                          , s = e[i]
                          , l = e[r]
                          , c = Math.atan2(l.y - s.y, l.x - s.x);
                        if (D) {
                            const e = Ae(Ce(a.x - s.x, a.y - s.y))
                              , t = Ae(Ce(l.x - s.x, l.y - s.y))
                              , o = Ce(e.x + t.x, e.y + t.y)
                              , r = L ? D && N(Math.atan2(o.y, o.x)) : void 0;
                            n.push({
                                index: [i],
                                key: `point-${i}`,
                                type: "point",
                                selected: I === i,
                                scale: {
                                    x: 1,
                                    y: 1
                                },
                                translate: {
                                    x: s.x,
                                    y: s.y
                                },
                                angle: void 0,
                                rotate: z,
                                center: s,
                                dir: r
                            })
                        }
                        if (!L)
                            continue;
                        if (Array.isArray(L) && !L.some(( ([e,t]) => i === e && r === t)))
                            continue;
                        const u = Ce(s.x + .5 * (l.x - s.x), s.y + .5 * (l.y - s.y));
                        n.push({
                            index: [i, r],
                            key: `edge-${i}`,
                            type: "edge",
                            scale: {
                                x: je(s, l),
                                y: 1
                            },
                            translate: {
                                x: s.x,
                                y: s.y
                            },
                            angle: c,
                            rotate: c,
                            center: u,
                            visible: Array.isArray(L),
                            dir: N(Math.atan2(o.y - u.y, o.x - u.x))
                        })
                    }
                    return n
                }
                )(R))
            }
            ,
            [A, z, E, o, r, a, F, O, B, (e, t) => ({detail: i}) => {
                const o = i && i.translation ? i.translation : Ce(0, 0);
                s(`resize${e}`, {
                    ...i,
                    indexes: t,
                    translation: o
                })
            }
            , W, ({detail: e}) => {
                s("rotatestart", {
                    translation: ke(),
                    isNudge: !0
                }),
                s("rotatemove", {
                    translation: e,
                    isNudge: !0
                }),
                s("rotateend", {
                    translation: ke(),
                    isNudge: !0
                })
            }
            , e => ({detail: t}) => {
                const i = t && t.translation ? t.translation : Ce(0, 0);
                s(`rotate${e}`, {
                    ...t,
                    translation: i
                })
            }
            , R, I, L, D, n, (e, {detail: t}) => W(e, t)]
        }
        class Qg extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Yg, Zg, ar, {
                    visible: 2,
                    points: 13,
                    rotatorPoint: 0,
                    selectedPoint: 14,
                    enableDragEdges: 15,
                    enableDragPoints: 16,
                    enableRotatePoints: 1
                }, null, [-1, -1])
            }
        }
        var Jg = (e, t) => {
            const i = Hh(e);
            return Fe(i, t)
        }
          , ey = e => document.createTextNode(e)
          , ty = e => (si() && e.endsWith("<div><br></div>") ? e.replace(/<div><br><\/div>$/, "<br><br>") : e).replace(/<div><br><\/div>/g, "<br>").replace(/<\/div>/g, "").replace(/<div>/g, "<br>");
        function iy(e) {
            let t, i;
            return {
                c() {
                    t = Er("pre"),
                    Or(t, "class", "PinturaContentEditable"),
                    Or(t, "style", i = `${e[7]};position:absolute;z-index:-1;pointer-events:none;`)
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[0]
                },
                p(e, o) {
                    1 & o[0] && (t.innerHTML = e[0]),
                    128 & o[0] && i !== (i = `${e[7]};position:absolute;z-index:-1;pointer-events:none;`) && Or(t, "style", i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function oy(e) {
            let t, i, o, n, r, a, s = e[8] && iy(e);
            return {
                c() {
                    s && s.c(),
                    t = Ir(),
                    i = Er("pre"),
                    Or(i, "class", "PinturaContentEditable"),
                    Or(i, "data-wrap-content", o = e[4] || e[5] ? "wrap" : "nowrap"),
                    Or(i, "contenteditable", ""),
                    Or(i, "spellcheck", e[1]),
                    Or(i, "autocorrect", e[2]),
                    Or(i, "autocapitalize", e[3]),
                    Or(i, "style", n = e[8] ? e[15](e[7]) : e[7])
                },
                m(o, n) {
                    s && s.m(o, n),
                    Mr(o, t, n),
                    Mr(o, i, n),
                    e[26](i),
                    r || (a = [Dr(i, "input", e[13]), Dr(i, "compositionend", e[12]), Dr(i, "paste", e[14]), Dr(i, "keydown", e[10]), Dr(i, "keyup", e[11]), Dr(i, "blur", e[9])],
                    r = !0)
                },
                p(e, r) {
                    e[8] ? s ? s.p(e, r) : (s = iy(e),
                    s.c(),
                    s.m(t.parentNode, t)) : s && (s.d(1),
                    s = null),
                    48 & r[0] && o !== (o = e[4] || e[5] ? "wrap" : "nowrap") && Or(i, "data-wrap-content", o),
                    2 & r[0] && Or(i, "spellcheck", e[1]),
                    4 & r[0] && Or(i, "autocorrect", e[2]),
                    8 & r[0] && Or(i, "autocapitalize", e[3]),
                    384 & r[0] && n !== (n = e[8] ? e[15](e[7]) : e[7]) && Or(i, "style", n)
                },
                i: Jn,
                o: Jn,
                d(o) {
                    s && s.d(o),
                    o && Pr(t),
                    o && Pr(i),
                    e[26](null),
                    r = !1,
                    nr(a)
                }
            }
        }
        function ny(e, t, i) {
            let o, n, {spellcheck: r="false"} = t, {autocorrect: a="off"} = t, {autocapitalize: s="off"} = t, {wrapLines: l=!0} = t, {allowNewline: c=!0} = t, {textFormat: u="text"} = t, {formatInput: d=se} = t, {formatPaste: p=se} = t, {style: h} = t, {innerHTML: m} = t, {oninput: f=$} = t, {enableTextStyleShortcuts: g=!1} = t;
            const y = () => {
                if (!v)
                    return;
                const e = document.createRange();
                e.selectNodeContents(v);
                const t = T();
                t.removeAllRanges(),
                t.addRange(e)
            }
              , b = ta();
            let v;
            document.execCommand("defaultParagraphSeparator", !1, "br");
            const x = e => e.replace(/<\/?(?:i|b|em|u|s|strike|strong|font)>/, "").replace(/style=".*?"/g, "").replace(/\n/gim, "<br>")
              , w = () => {
                i(0, m = v.innerHTML);
                const e = ty(m);
                b("input", e),
                f(e),
                requestAnimationFrame(( () => v && v.scrollTo(0, 0)))
            }
              , S = () => {
                P(v);
                const e = "html" === u ? v.innerHTML : x(v.innerHTML);
                i(6, v.innerHTML = d(e), v),
                E(v),
                w()
            }
              , _ = {
                b: "bold",
                i: "italic",
                u: "underline",
                s: "strikethrough"
            }
              , k = e => {
                const t = M("span");
                return t.dataset.bookmark = e,
                t
            }
              , C = (e, t, i) => {
                const o = k(i);
                if (e.nodeType === Node.TEXT_NODE) {
                    const n = e.textContent;
                    if ("start" === i) {
                        const i = ey(n.substring(0, t))
                          , r = ey(n.substring(t));
                        e.replaceWith(i, o, r)
                    } else {
                        const i = ey(n.substring(0, t))
                          , r = ey(n.substring(t));
                        e.replaceWith(i, o, r)
                    }
                } else
                    e.nodeType === Node.ELEMENT_NODE && e.insertBefore(o, e.childNodes[t])
            }
              , T = () => {
                const e = v.getRootNode();
                return "getSelection"in e ? e.getSelection() : document.getSelection()
            }
              , P = e => {
                const t = T();
                if (!t.getRangeAt || !t.rangeCount)
                    return;
                const i = t.getRangeAt(0)
                  , {startOffset: o, endOffset: n, startContainer: r, endContainer: a} = i;
                if (e.contains(i.startContainer) && e.contains(i.endContainer))
                    if (r.nodeType === Node.TEXT_NODE && r === a) {
                        const e = r.textContent
                          , t = e.substring(0, o)
                          , i = k("start")
                          , a = n - o > 0 ? e.substring(o, n) : ""
                          , s = k("end")
                          , l = e.substring(n);
                        r.replaceWith(t, i, a, s, l)
                    } else
                        C(r, o, "start"),
                        C(a, n + (r === a ? 1 : 0), "end")
            }
              , E = e => {
                const t = R(e, "start")
                  , i = R(e, "end");
                if (!t || !i)
                    return;
                const o = document.createRange();
                o.setStart(t, 0),
                o.setEnd(i, 0);
                const n = T();
                n.removeAllRanges(),
                n.addRange(o),
                t.remove(),
                i.remove()
            }
              , R = (e, t) => {
                const i = e.children;
                for (let e = 0; e < i.length; e++) {
                    const o = i[e];
                    if (o.dataset.bookmark === t)
                        return o;
                    if (o.children.length) {
                        const e = R(o, t);
                        if (e)
                            return e
                    }
                }
            }
            ;
            let A;
            return e.$$set = e => {
                "spellcheck"in e && i(1, r = e.spellcheck),
                "autocorrect"in e && i(2, a = e.autocorrect),
                "autocapitalize"in e && i(3, s = e.autocapitalize),
                "wrapLines"in e && i(4, l = e.wrapLines),
                "allowNewline"in e && i(5, c = e.allowNewline),
                "textFormat"in e && i(16, u = e.textFormat),
                "formatInput"in e && i(17, d = e.formatInput),
                "formatPaste"in e && i(18, p = e.formatPaste),
                "style"in e && i(19, h = e.style),
                "innerHTML"in e && i(0, m = e.innerHTML),
                "oninput"in e && i(20, f = e.oninput),
                "enableTextStyleShortcuts"in e && i(21, g = e.enableTextStyleShortcuts)
            }
            ,
            e.$$.update = () => {
                var t;
                if (64 & e.$$.dirty[0] && i(25, o = !!v),
                33554433 & e.$$.dirty[0] && o && m && (t = m) !== v.innerHTML && (i(6, v.innerHTML = t, v),
                v === document.activeElement && y()),
                524336 & e.$$.dirty[0])
                    if (!l && c) {
                        const e = h.includes(":right") ? "text-indent:-100px!important" : h.includes(":center") ? "" : "min-width:calc(100% + 100px)!important";
                        i(7, A = h + ";overflow:visible;" + e)
                    } else
                        i(7, A = h);
                524288 & e.$$.dirty[0] && i(8, n = h.includes("text-stroke"))
            }
            ,
            [m, r, a, s, l, c, v, A, n, () => {
                b("blur")
            }
            , e => {
                if (/escape/i.test(e.code))
                    return e.stopPropagation(),
                    void b("cancel");
                const t = e.ctrlKey || e.metaKey;
                if ("html" === u && t && /b|i|u|s/.test(e.key))
                    return g && (e => {
                        const t = _[e];
                        t && document.execCommand(t)
                    }
                    )(e.key),
                    void e.preventDefault();
                /enter/i.test(e.code) && (e.stopPropagation(),
                e.isComposing || (t ? b("confirm") : (c || e.preventDefault(),
                document.execCommand("insertLineBreak"),
                e.preventDefault())))
            }
            , () => {}
            , e => {
                "" !== e.data && S()
            }
            , e => {
                const {inputType: t} = e;
                "insertCompositionText" !== t && "deleteCompositionText" !== t && S()
            }
            , e => {
                e.preventDefault();
                const t = e.clipboardData.getData("text/plain")
                  , i = "html" === u ? t : x(t)
                  , o = p(i);
                if (!o.length)
                    return;
                const n = T().getRangeAt(0);
                n.deleteContents(),
                n.insertNode(document.createTextNode(o)),
                w()
            }
            , e => e.replace("-webkit-text-stroke", "--text-stroke").replace("text-shadow", "--text-shadow"), u, d, p, h, f, g, () => S(), () => v && v.focus(), y, o, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    v = e,
                    i(6, v)
                }
                ))
            }
            ]
        }
        class ry extends Na {
            constructor(e) {
                super(),
                Ba(this, e, ny, oy, ar, {
                    spellcheck: 1,
                    autocorrect: 2,
                    autocapitalize: 3,
                    wrapLines: 4,
                    allowNewline: 5,
                    textFormat: 16,
                    formatInput: 17,
                    formatPaste: 18,
                    style: 19,
                    innerHTML: 0,
                    oninput: 20,
                    enableTextStyleShortcuts: 21,
                    confirm: 22,
                    focus: 23,
                    select: 24
                }, null, [-1, -1])
            }
            get spellcheck() {
                return this.$$.ctx[1]
            }
            set spellcheck(e) {
                this.$$set({
                    spellcheck: e
                }),
                $a()
            }
            get autocorrect() {
                return this.$$.ctx[2]
            }
            set autocorrect(e) {
                this.$$set({
                    autocorrect: e
                }),
                $a()
            }
            get autocapitalize() {
                return this.$$.ctx[3]
            }
            set autocapitalize(e) {
                this.$$set({
                    autocapitalize: e
                }),
                $a()
            }
            get wrapLines() {
                return this.$$.ctx[4]
            }
            set wrapLines(e) {
                this.$$set({
                    wrapLines: e
                }),
                $a()
            }
            get allowNewline() {
                return this.$$.ctx[5]
            }
            set allowNewline(e) {
                this.$$set({
                    allowNewline: e
                }),
                $a()
            }
            get textFormat() {
                return this.$$.ctx[16]
            }
            set textFormat(e) {
                this.$$set({
                    textFormat: e
                }),
                $a()
            }
            get formatInput() {
                return this.$$.ctx[17]
            }
            set formatInput(e) {
                this.$$set({
                    formatInput: e
                }),
                $a()
            }
            get formatPaste() {
                return this.$$.ctx[18]
            }
            set formatPaste(e) {
                this.$$set({
                    formatPaste: e
                }),
                $a()
            }
            get style() {
                return this.$$.ctx[19]
            }
            set style(e) {
                this.$$set({
                    style: e
                }),
                $a()
            }
            get innerHTML() {
                return this.$$.ctx[0]
            }
            set innerHTML(e) {
                this.$$set({
                    innerHTML: e
                }),
                $a()
            }
            get oninput() {
                return this.$$.ctx[20]
            }
            set oninput(e) {
                this.$$set({
                    oninput: e
                }),
                $a()
            }
            get enableTextStyleShortcuts() {
                return this.$$.ctx[21]
            }
            set enableTextStyleShortcuts(e) {
                this.$$set({
                    enableTextStyleShortcuts: e
                }),
                $a()
            }
            get confirm() {
                return this.$$.ctx[22]
            }
            get focus() {
                return this.$$.ctx[23]
            }
            get select() {
                return this.$$.ctx[24]
            }
        }
        const ay = ["i", "b", "u", "strike"].map((e => ({
            tag: e,
            tagOpen: new RegExp(`<${e}>`,"g"),
            tagClose: new RegExp(`</${e}>`,"g"),
            placeholderOpen: new RegExp(`___${e}O___`,"g"),
            placeholderClose: new RegExp(`___${e}C___`,"g")
        })));
        var sy = (e, t) => W(e) ? parseFloat(e) / 100 * t : e
          , ly = (e, t) => ({
            x: Yi(e.x, t.width),
            y: Yi(e.y, t.height)
        });
        function cy(e, t, i) {
            const o = e.slice();
            return o[299] = t[i],
            o[301] = i,
            o
        }
        function uy(e, t) {
            let i, o, n, r, a, s, l, c, u, d, p, h = t[299].name + "";
            function m() {
                return t[189](t[301])
            }
            return n = new Op({
                props: {
                    color: t[299].color
                }
            }),
            {
                key: e,
                first: null,
                c() {
                    i = Er("li"),
                    o = Er("button"),
                    za(n.$$.fragment),
                    r = Ir(),
                    a = Er("span"),
                    s = Ar(h),
                    c = Ir(),
                    Or(o, "class", "PinturaShapeListItem"),
                    Or(o, "type", "button"),
                    Or(o, "aria-label", l = "Select shape " + t[299].name),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    kr(i, o),
                    Fa(n, o, null),
                    kr(o, r),
                    kr(o, a),
                    kr(a, s),
                    kr(i, c),
                    u = !0,
                    d || (p = Dr(o, "click", m),
                    d = !0)
                },
                p(e, i) {
                    t = e;
                    const r = {};
                    2097152 & i[0] && (r.color = t[299].color),
                    n.$set(r),
                    (!u || 2097152 & i[0]) && h !== (h = t[299].name + "") && Wr(s, h),
                    (!u || 2097152 & i[0] && l !== (l = "Select shape " + t[299].name)) && Or(o, "aria-label", l)
                },
                i(e) {
                    u || (ka(n.$$.fragment, e),
                    u = !0)
                },
                o(e) {
                    Ca(n.$$.fragment, e),
                    u = !1
                },
                d(e) {
                    e && Pr(i),
                    Oa(n),
                    d = !1,
                    p()
                }
            }
        }
        function dy(e) {
            let t, i;
            return t = new Qg({
                props: {
                    visible: !0,
                    points: e[12],
                    rotatorPoint: e[27],
                    selectedPoint: e[16],
                    enableDragEdges: e[17],
                    enableDragPoints: e[29],
                    enableRotatePoints: e[14]
                }
            }),
            t.$on("resizestart", e[38]),
            t.$on("resizemove", e[39]),
            t.$on("resizeend", e[40]),
            t.$on("rotatestart", e[41]),
            t.$on("rotatemove", e[42]),
            t.$on("rotateend", e[43]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    4096 & i[0] && (o.points = e[12]),
                    134217728 & i[0] && (o.rotatorPoint = e[27]),
                    65536 & i[0] && (o.selectedPoint = e[16]),
                    131072 & i[0] && (o.enableDragEdges = e[17]),
                    536870912 & i[0] && (o.enableDragPoints = e[29]),
                    16384 & i[0] && (o.enableRotatePoints = e[14]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function py(e) {
            let t, i, o, n;
            const r = [my, hy]
              , a = [];
            function s(e, t) {
                return "modal" === e[4] ? 0 : "inline" === e[4] ? 1 : -1
            }
            return ~(t = s(e)) && (i = a[t] = r[t](e)),
            {
                c() {
                    i && i.c(),
                    o = Lr()
                },
                m(e, i) {
                    ~t && a[t].m(e, i),
                    Mr(e, o, i),
                    n = !0
                },
                p(e, n) {
                    let l = t;
                    t = s(e),
                    t === l ? ~t && a[t].p(e, n) : (i && (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a()),
                    ~t ? (i = a[t],
                    i ? i.p(e, n) : (i = a[t] = r[t](e),
                    i.c()),
                    ka(i, 1),
                    i.m(o.parentNode, o)) : i = null)
                },
                i(e) {
                    n || (ka(i),
                    n = !0)
                },
                o(e) {
                    Ca(i),
                    n = !1
                },
                d(e) {
                    ~t && a[t].d(e),
                    e && Pr(o)
                }
            }
        }
        function hy(e) {
            let t, i, o, n, r, a = {
                formatInput: e[45],
                wrapLines: !!e[13].width,
                textFormat: e[13].format,
                enableTextStyleShortcuts: e[5],
                allowNewline: e[28],
                style: e[26]
            };
            return i = new ry({
                props: a
            }),
            e[192](i),
            i.$on("input", e[46]),
            i.$on("keyup", e[49]),
            i.$on("cancel", e[51]),
            i.$on("confirm", e[50]),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaInlineInput"),
                    Or(t, "style", e[25])
                },
                m(a, s) {
                    Mr(a, t, s),
                    Fa(i, t, null),
                    o = !0,
                    n || (r = Dr(t, "focusout", e[193]),
                    n = !0)
                },
                p(e, n) {
                    const r = {};
                    8192 & n[0] && (r.wrapLines = !!e[13].width),
                    8192 & n[0] && (r.textFormat = e[13].format),
                    32 & n[0] && (r.enableTextStyleShortcuts = e[5]),
                    268435456 & n[0] && (r.allowNewline = e[28]),
                    67108864 & n[0] && (r.style = e[26]),
                    i.$set(r),
                    (!o || 33554432 & n[0]) && Or(t, "style", e[25])
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(o) {
                    o && Pr(t),
                    e[192](null),
                    Oa(i),
                    n = !1,
                    r()
                }
            }
        }
        function my(e) {
            let t, i;
            return t = new Sh({
                props: {
                    panelOffset: e[2],
                    onconfirm: e[50],
                    oncancel: e[51],
                    buttonCancel: {
                        icon: e[6].shapeIconInputCancel,
                        label: e[6].shapeLabelInputCancel
                    },
                    buttonConfirm: {
                        icon: e[6].shapeIconInputConfirm,
                        label: e[6].shapeLabelInputConfirm,
                        hideLabel: !0
                    },
                    $$slots: {
                        default: [fy]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    4 & i[0] && (o.panelOffset = e[2]),
                    64 & i[0] && (o.buttonCancel = {
                        icon: e[6].shapeIconInputCancel,
                        label: e[6].shapeLabelInputCancel
                    }),
                    64 & i[0] && (o.buttonConfirm = {
                        icon: e[6].shapeIconInputConfirm,
                        label: e[6].shapeLabelInputConfirm,
                        hideLabel: !0
                    }),
                    83886336 & i[0] | 8388608 & i[9] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function fy(e) {
            let t, i, o;
            return {
                c() {
                    t = Er("textarea"),
                    Or(t, "spellcheck", "false"),
                    Or(t, "autocorrect", "off"),
                    Or(t, "autocapitalize", "off"),
                    Or(t, "style", e[26])
                },
                m(n, r) {
                    Mr(n, t, r),
                    e[190](t),
                    Hr(t, e[24]),
                    i || (o = [Dr(t, "keydown", e[48]), Dr(t, "keypress", e[47]), Dr(t, "keyup", e[49]), Dr(t, "input", e[46]), Dr(t, "input", e[191])],
                    i = !0)
                },
                p(e, i) {
                    67108864 & i[0] && Or(t, "style", e[26]),
                    16777216 & i[0] && Hr(t, e[24])
                },
                d(n) {
                    n && Pr(t),
                    e[190](null),
                    i = !1,
                    nr(o)
                }
            }
        }
        function gy(e) {
            let t, i, o, n, r;
            return i = new yh({
                props: {
                    items: e[22],
                    key: e[10]
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaShapeControls"),
                    Or(t, "style", e[23])
                },
                m(a, s) {
                    Mr(a, t, s),
                    Fa(i, t, null),
                    o = !0,
                    n || (r = [Dr(t, "measure", e[194]), $r($c.call(null, t))],
                    n = !0)
                },
                p(e, n) {
                    const r = {};
                    4194304 & n[0] && (r.items = e[22]),
                    1024 & n[0] && (r.key = e[10]),
                    i.$set(r),
                    (!o || 8388608 & n[0]) && Or(t, "style", e[23])
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    n = !1,
                    nr(r)
                }
            }
        }
        function yy(e) {
            let t, i, o, n, r, a, s, l, c, u, d = [], p = new Map, h = e[21];
            const m = e => e[299].id;
            for (let t = 0; t < h.length; t += 1) {
                let i = cy(e, h, t)
                  , o = m(i);
                p.set(o, d[t] = uy(o, i))
            }
            let f = e[15] && dy(e)
              , g = e[11] && py(e)
              , y = e[18] > 0 && gy(e);
            return {
                c() {
                    t = Er("div"),
                    i = Er("nav"),
                    o = Er("ul");
                    for (let e = 0; e < d.length; e += 1)
                        d[e].c();
                    n = Ir(),
                    f && f.c(),
                    r = Ir(),
                    g && g.c(),
                    a = Ir(),
                    y && y.c(),
                    Or(i, "class", "PinturaShapeList"),
                    Or(i, "data-visible", e[19]),
                    Or(t, "class", "PinturaShapeEditor"),
                    Or(t, "tabindex", "0")
                },
                m(p, h) {
                    Mr(p, t, h),
                    kr(t, i),
                    kr(i, o);
                    for (let e = 0; e < d.length; e += 1)
                        d[e].m(o, null);
                    kr(t, n),
                    f && f.m(t, null),
                    kr(t, r),
                    g && g.m(t, null),
                    kr(t, a),
                    y && y.m(t, null),
                    e[195](t),
                    l = !0,
                    c || (u = [Dr(i, "focusin", e[54]), Dr(i, "focusout", e[55]), Dr(t, "keydown", (function() {
                        rr(e[0] ? $ : e[44]) && (e[0] ? $ : e[44]).apply(this, arguments)
                    }
                    )), Dr(t, "nudge", (function() {
                        rr(e[0] ? $ : e[53]) && (e[0] ? $ : e[53]).apply(this, arguments)
                    }
                    )), Dr(t, "measure", e[188]), Dr(t, "pointermove", (function() {
                        rr(e[0] ? $ : e[56]) && (e[0] ? $ : e[56]).apply(this, arguments)
                    }
                    )), Dr(t, "pointerleave", (function() {
                        rr(e[0] ? $ : e[57]) && (e[0] ? $ : e[57]).apply(this, arguments)
                    }
                    )), Dr(t, "interactionstart", (function() {
                        rr(e[0] ? $ : e[32]) && (e[0] ? $ : e[32]).apply(this, arguments)
                    }
                    )), Dr(t, "interactionupdate", (function() {
                        rr(e[0] ? $ : e[34]) && (e[0] ? $ : e[34]).apply(this, arguments)
                    }
                    )), Dr(t, "interactioncancel", (function() {
                        rr(e[0] ? $ : e[33]) && (e[0] ? $ : e[33]).apply(this, arguments)
                    }
                    )), Dr(t, "interactionrelease", (function() {
                        rr(e[0] ? $ : e[35]) && (e[0] ? $ : e[35]).apply(this, arguments)
                    }
                    )), Dr(t, "interactionend", (function() {
                        rr(e[0] ? $ : e[36]) && (e[0] ? $ : e[36]).apply(this, arguments)
                    }
                    )), $r($c.call(null, t)), $r(fu.call(null, t)), $r(s = mu.call(null, t, {
                        drag: !0,
                        inertia: !0,
                        multiTouch: !1,
                        observeKeys: !0,
                        shouldStartInteraction: vy,
                        getEventPosition: e[196]
                    }))],
                    c = !0)
                },
                p(n, c) {
                    e = n,
                    2097282 & c[0] && (h = e[21],
                    Sa(),
                    d = Aa(d, c, m, 1, e, h, p, o, Ra, uy, null, cy),
                    _a()),
                    (!l || 524288 & c[0]) && Or(i, "data-visible", e[19]),
                    e[15] ? f ? (f.p(e, c),
                    32768 & c[0] && ka(f, 1)) : (f = dy(e),
                    f.c(),
                    ka(f, 1),
                    f.m(t, r)) : f && (Sa(),
                    Ca(f, 1, 1, ( () => {
                        f = null
                    }
                    )),
                    _a()),
                    e[11] ? g ? (g.p(e, c),
                    2048 & c[0] && ka(g, 1)) : (g = py(e),
                    g.c(),
                    ka(g, 1),
                    g.m(t, a)) : g && (Sa(),
                    Ca(g, 1, 1, ( () => {
                        g = null
                    }
                    )),
                    _a()),
                    e[18] > 0 ? y ? (y.p(e, c),
                    262144 & c[0] && ka(y, 1)) : (y = gy(e),
                    y.c(),
                    ka(y, 1),
                    y.m(t, null)) : y && (Sa(),
                    Ca(y, 1, 1, ( () => {
                        y = null
                    }
                    )),
                    _a()),
                    s && rr(s.update) && 8 & c[0] && s.update.call(null, {
                        drag: !0,
                        inertia: !0,
                        multiTouch: !1,
                        observeKeys: !0,
                        shouldStartInteraction: vy,
                        getEventPosition: e[196]
                    })
                },
                i(e) {
                    if (!l) {
                        for (let e = 0; e < h.length; e += 1)
                            ka(d[e]);
                        ka(f),
                        ka(g),
                        ka(y),
                        l = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < d.length; e += 1)
                        Ca(d[e]);
                    Ca(f),
                    Ca(g),
                    Ca(y),
                    l = !1
                },
                d(i) {
                    i && Pr(t);
                    for (let e = 0; e < d.length; e += 1)
                        d[e].d();
                    f && f.d(),
                    g && g.d(),
                    y && y.d(),
                    e[195](null),
                    c = !1,
                    nr(u)
                }
            }
        }
        const $y = 256
          , by = "markup-hover"
          , vy = (e, t) => e.target === t;
        function xy(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, b, v, x, w, S, _, k, C, T, M, P, E, R, A, I, L, D, z, F, O, B, N, H, j, U, q, G, K, Z, Y, Q, J, ee, te, ie, oe, ne, re, ae, le, ce, ue, de, pe, he, me, fe, ge = Jn, ye = () => (ge(),
            ge = sr(xe, (e => i(184, de = e))),
            xe);
            e.$$.on_destroy.push(( () => ge()));
            let {uid: $e=V()} = t
              , {ui: be} = t
              , {disabled: ve=!1} = t
              , {shapes: xe} = t;
            ye();
            let {selection: Se} = t
              , {offset: Te} = t
              , {contextRotation: Pe=0} = t
              , {contextFlipX: Re=!1} = t
              , {contextFlipY: Oe=!1} = t
              , {contextZoom: Ne=1} = t
              , {active: We=!1} = t
              , {opacity: Ue=1} = t
              , {parentRect: Ke} = t
              , {rootRect: Xe} = t
              , {utilRect: Ye} = t
              , {hoverColor: Qe} = t
              , {caretColor: Je} = t
              , {gridColor: tt} = t
              , {snapColor: it} = t
              , {textInputMode: ot="inline"} = t
              , {oninteractionstart: nt=$} = t
              , {oninteractionupdate: rt=$} = t
              , {oninteractionrelease: lt=$} = t
              , {oninteractionend: ut=$} = t
              , {oninteractioncancel: dt=$} = t
              , {onaddshape: pt=$} = t
              , {onupdateshape: ht=$} = t
              , {onselectshape: mt=$} = t
              , {onblurshape: $t=$} = t
              , {onremoveshape: xt=$} = t
              , {ontapshape: wt=$} = t
              , {onhovershape: St=$} = t
              , {ontriggerhistorywrite: _t=$} = t
              , {onhovercanvas: kt=$} = t
              , {ontapcanvas: Ct=$} = t
              , {onleavecanvas: Tt=$} = t
              , {beforeSelectShape: Mt=( () => !0)} = t
              , {beforeDeselectShape: Pt=( () => !0)} = t
              , {beforeRemoveShape: Rt=( () => !0)} = t
              , {beforeUpdateShape: At=( (e, t, i) => t)} = t
              , {willRenderShapeControls: It=se} = t
              , {willRenderShapeTextControls: Ft=se} = t
              , {willStartInteraction: Ot=( (e, t) => !0)} = t
              , {mapEditorPointToImagePoint: Bt} = t
              , {mapImagePointToEditorPoint: Nt} = t
              , {eraseRadius: Wt} = t
              , {selectRadius: Ht} = t
              , {enableButtonFlipVertical: Vt=!1} = t
              , {enableTapToAddText: qt=!0} = t
              , {enableMultiSelect: Qt=!1} = t
              , {enableTextStyleControls: Jt=!0} = t
              , {locale: ei} = t
              , {snapThreshold: ti=0} = t
              , {snapPointer: ii=!0} = t
              , {enableSnapToContext: oi=!0} = t
              , {gridSize: ni=0} = t;
            const ri = e => {
                if (0 === ti)
                    return [];
                let t;
                return oi && (t = {
                    ...Ke,
                    x: 0,
                    y: 0
                }),
                [...de.filter((t => t !== e)).filter((e => !Wo(e))).filter((e => (e => !0 !== e.disableAcceptSnap)(e))).map((e => xn({
                    ...e
                }, Ke))), t].filter(Boolean)
            }
              , ai = (e, t, i, o) => 0 === e ? {
                snapTargets: []
            } : {
                snapThreshold: e,
                gridSize: t,
                gridRect: i,
                snapTargets: ri(o)
            }
              , si = oa("isAnimated");
            cr(e, si, (e => i(185, he = e)));
            const li = e => e.set(lr(e))
              , ci = e => lr(e).find(Wo)
              , ui = (e, t) => {
                if (!ci(t))
                    return qo(e),
                    mi(e, t)
            }
              , di = e => {
                ci(e) && e.update((e => e.filter((e => !Wo(e)))))
            }
              , pi = e => {
                const t = ci(e);
                if (t)
                    return Go(t),
                    li(e),
                    t
            }
              , hi = (e, t, i=( (e, t) => ({
                ...e,
                ...t
            }))) => {
                ci(t) && t.update((t => t.map((t => Wo(t) ? i(t, e) : t))))
            }
              , mi = (e, t=xe) => (t.update((t => [...t, e])),
            e)
              , fi = (e, t, i) => {
                const o = At({
                    ...e
                }, t, {
                    ...i
                });
                return kn(e, o, i),
                e
            }
              , gi = (e, t) => {
                const i = je(e, t)
                  , o = Ie(e, t)
                  , n = Math.PI / 8
                  , r = n * Math.round(o / n) - Pe % n;
                t.x = e.x + i * Math.cos(r),
                t.y = e.y + i * Math.sin(r)
            }
              , yi = oa("keysPressed");
            cr(e, yi, (e => i(186, me = e)));
            const $i = (e, t, i) => 0 === e || t && i ? e : t || i ? -e : e
              , bi = e => {
                if (null === e.x && null === e.y)
                    return vi();
                e.x && i(140, xi = Bt({
                    x: e.x,
                    y: 0
                }).x),
                e.y && i(141, wi = Bt({
                    x: 0,
                    y: e.y
                }).y)
            }
              , vi = () => {
                i(140, xi = null),
                i(141, wi = null)
            }
            ;
            let xi = null
              , wi = null;
            const Si = (e, t) => {
                const i = Nt(e);
                return Bt(ze(i, t))
            }
              , _i = (e, t, i) => {
                const o = (i - t) / e + 1;
                return Array.from({
                    length: o
                }, ( (i, o) => t + o * e))
            }
              , ki = e => {
                let t = []
                  , i = []
                  , o = e.points;
                if (void 0 !== e.x1 && (o = [{
                    x: e.x1,
                    y: e.y1
                }, {
                    x: e.x2,
                    y: e.y2
                }]),
                o) {
                    const e = o.map(Nt)
                      , n = gt(e)
                      , r = e[0]
                      , a = e[e.length - 1];
                    t = [n.x, n.x + .5 * n.width, n.x + n.width, r.x, a.x],
                    i = [n.y, n.y + .5 * n.height, n.y + n.height, r.y, a.y]
                } else if (e.text || void 0 !== e.width || void 0 !== e.rx) {
                    let o;
                    if (e.text && void 0 === e.height) {
                        const t = ho(e.text, e);
                        o = bt(e.x, e.y, t.width, t.height)
                    } else
                        o = void 0 !== e.width ? ft(e) : ft({
                            x: e.x - e.rx,
                            y: e.y - e.ry,
                            width: 2 * e.rx,
                            height: 2 * e.ry
                        });
                    const n = zt(o).map(Nt)
                      , r = Math.abs(e.rotation) > 0 ? Et(o, e.rotation).map(Nt) : n
                      , a = gt(r)
                      , s = vt(a)
                      , l = .5 * a.width
                      , c = .5 * a.height;
                    t = [s.x - l, s.x, s.x + l],
                    i = [s.y - c, s.y, s.y + c]
                } else if (void 0 !== e.x) {
                    const o = Nt(e);
                    t = [o.x],
                    i = [o.y]
                }
                return {
                    x: t,
                    y: i
                }
            }
              , Ci = (e, t, i) => {
                let o, n, r, a = Number.Infinity, s = null, l = null;
                for (let c = 0; c < e.length; c++) {
                    n = e[c];
                    for (let e = 0; e < t.length; e++)
                        r = t[e],
                        o = Math.abs(n - r),
                        o < i && (null === l || o < a) && (a = o,
                        s = n,
                        l = r)
                }
                return {
                    origin: s,
                    target: l
                }
            }
              , Ti = (e, t, i, o, n) => {
                const r = {
                    x: null,
                    y: null
                }
                  , a = {
                    x: null,
                    y: null
                }
                  , s = t.map(ki);
                if (o > 0) {
                    const e = Nt({
                        x: 0,
                        y: 0
                    })
                      , t = Nt({
                        x: o,
                        y: o
                    })
                      , i = Nt({
                        x: n.width,
                        y: n.height
                    })
                      , r = t.x - e.x
                      , a = _i(r, e.x, i.x)
                      , l = _i(r, e.y, i.y);
                    s.push({
                        x: a,
                        y: l
                    })
                }
                return s.forEach((t => {
                    const {snapTranslation: o, snapLine: n} = ( (e, t, i) => {
                        const o = {
                            x: null,
                            y: null
                        }
                          , n = {
                            x: null,
                            y: null
                        }
                          , r = Ci(e.x, t.x, i);
                        null !== r.target && (o.x = r.target,
                        n.x = r.target - r.origin);
                        const a = Ci(e.y, t.y, i);
                        return null !== a.target && (o.y = a.target,
                        n.y = a.target - a.origin),
                        {
                            snapTranslation: n,
                            snapLine: o
                        }
                    }
                    )(e, t, i);
                    null !== o.x && (null === a.x || Math.abs(o.x) < Math.abs(a.x)) && (a.x = o.x || 0,
                    r.x = n.x),
                    null !== o.y && (null === a.y || Math.abs(o.y) < Math.abs(a.y)) && (a.y = o.y || 0,
                    r.y = n.y)
                }
                )),
                {
                    snapTranslation: a,
                    snapLines: r
                }
            }
              , Mi = (e, t) => (null !== t.x && (e.x += t.x),
            null !== t.y && (e.y += t.y),
            e)
              , Pi = (e, t, i, o) => {
                const {snapThreshold: n=0, gridSize: r=0, gridRect: a, snapTargets: s=[]} = o || {};
                let l = null;
                if (Do(e)) {
                    if (n) {
                        const o = xn({
                            ...e
                        }, Ke)
                          , l = Si(Mo(t), i)
                          , c = Si(Po(t), i)
                          , u = ki({
                            ...o,
                            x1: l.x,
                            y1: l.y,
                            x2: c.x,
                            y2: c.y
                        })
                          , {snapTranslation: d, snapLines: p} = Ti(u, s, n, r, a);
                        Mi(i, d),
                        bi(p)
                    }
                    const o = Si(Mo(t), i)
                      , c = Si(Po(t), i);
                    l = {
                        x1: o.x,
                        y1: o.y,
                        x2: c.x,
                        y2: c.y
                    }
                } else if (e.points) {
                    if (en(fo) && Ni(fo, {
                        selectedPoint: void 0
                    }),
                    n) {
                        const o = xn({
                            ...e
                        }, Ke)
                          , l = ki({
                            ...o,
                            points: t.points.map((e => Si(e, i)))
                        })
                          , {snapTranslation: c, snapLines: u} = Ti(l, s, n, r, a);
                        Mi(i, c),
                        bi(u)
                    }
                    l = {
                        points: t.points.map((e => Si(e, i)))
                    }
                } else if (Io(e) || Eo(e) || Lo(e)) {
                    if (n) {
                        const o = xn({
                            ...e
                        }, Ke)
                          , l = Si(t, i)
                          , c = ki({
                            ...o,
                            ...l
                        })
                          , {snapTranslation: u, snapLines: d} = Ti(c, s, n, r, a);
                        Mi(i, u),
                        bi(d)
                    }
                    l = Si(t, i)
                }
                l && (fi(e, l, Ke),
                Oi())
            }
              , Ei = {
                0: 1,
                1: 0,
                2: 3,
                3: 2
            }
              , Ri = {
                0: 3,
                1: 2,
                2: 1,
                3: 0
            };
            let Ai;
            const Ii = (e, t) => {
                const i = e.points.filter(( (e, i) => i !== t));
                Ni(e, {
                    points: i,
                    selectedPoint: void 0
                })
            }
              , Li = () => {
                if (de.length)
                    return de.find(Wo)
            }
              , Di = () => {
                if (de.length)
                    return de.findIndex(Wo)
            }
              , zi = () => {
                const e = Li();
                if (e)
                    return Go(e),
                    Oi(),
                    e
            }
              , Fi = () => {
                if (!Li())
                    return;
                const e = [...de];
                e.splice(Di(), 1),
                xe.set(e)
            }
              , Oi = () => {
                xe.set(de)
            }
              , Bi = (e, t=[], i=!0) => {
                t.filter(Boolean).forEach((t => delete e[t])),
                i && Oi()
            }
              , Ni = (e, t, i=!0) => {
                e = Object.assign(e, t),
                i && Oi()
            }
              , Hi = (e, t, i, o=!0) => {
                e[t] = i,
                o && Oi()
            }
              , Ui = (e, t=!0) => {
                de.forEach((t => Ni(t, e, !1))),
                t && Oi()
            }
              , Vi = () => [...de].reverse().filter(Bo)
              , qi = () => [...de].reverse().find(Bo)
              , Gi = () => !!qi()
              , Ki = (e, t=!0, i=!1) => {
                const o = de.filter((e => Zo(e) && Xo(e)))
                  , n = o.findIndex((t => t === e))
                  , r = ( (e, t=!1) => {
                    if (!Rt(e))
                        return !1;
                    xe.set(de.filter((t => t !== e))),
                    t || xt(e)
                }
                )(e, i);
                if (!1 === r)
                    return;
                if (Zi = e,
                o.length - 1 <= 0)
                    return Ji();
                if (!t)
                    return !0;
                const a = n - 1 < 0 ? o.length - 1 : n - 1;
                return to(o[a]),
                !0
            }
              , Xi = () => {
                if (a) {
                    const e = [];
                    return r.forEach(( (t, i) => {
                        Zo(t) && Ki(t, i === r.length - 1, !0) && e.push(t)
                    }
                    )),
                    void (e.length && _t())
                }
                const e = qi();
                e && Ki(e)
            }
            ;
            let Zi;
            const Ji = (e={}) => {
                const {storePrevious: t=!0} = e;
                Object.keys(Dn).forEach((e => Dn[e] = {}));
                const i = eo();
                t && (Zi = i),
                Ui({
                    isSelected: !1,
                    isEditing: !1,
                    _prerender: !1
                }),
                i && $t(i)
            }
              , eo = () => de.find(Bo)
              , to = (e, t=!0, i=!1) => {
                if (Wo(e))
                    return;
                const o = eo() || Zi
                  , n = Bo(e);
                Zi = void 0,
                Mt(o, e) && (i || Ji(),
                (e => {
                    e.isSelected = !0
                }
                )(e),
                !n && mt(e),
                t && Oi())
            }
              , io = e => {
                Mn && Mn.confirm && e.isEditing && Mn.confirm();
                const t = {
                    isSelected: !1,
                    isEditing: !1,
                    _prerender: !1
                };
                e.selectedPoint > -1 && (t.selectedPoint = void 0),
                Ni(e, t),
                $t(e)
            }
              , oo = e => {
                Ni(e, {
                    isSelected: !0,
                    isEditing: !0,
                    _prerender: "inline" === ot
                })
            }
              , no = e => {
                Ni(e, {
                    isSelected: !0,
                    isEditing: !1,
                    _prerender: !1
                })
            }
              , ro = e => {
                if (!e.length)
                    return [];
                const t = e.filter(Rt);
                return xe.set(de.filter((e => !t.includes(e)))),
                t
            }
              , ao = e => {
                const t = ho(e.text, e);
                return bt(e.x, e.y, e.width ? Math.min(e.width, t.width) : t.width, e.height ? Math.min(e.height, t.height) : t.height)
            }
              , so = e => {
                if (Ho(e))
                    return ft(e);
                if (Lo(e))
                    return yt(e);
                const t = ao(e);
                return t.width = Math.max(10, e.width || t.width),
                t
            }
              , lo = (e, t, i=0, o=( () => !0)) => [...e].reverse().filter(o).map((e => ({
                shape: e,
                priority: 1
            }))).filter((e => {
                const {shape: o} = e
                  , n = xn(So(o), Ke)
                  , r = i + .5 * (n.strokeWidth || 0);
                if (Io(n))
                    return Yt(t, r, n, o.rotation);
                if (Eo(n)) {
                    const i = so(n)
                      , a = Yt(t, r, i, o.rotation);
                    let s = !1;
                    if (a && !Bo(o)) {
                        const a = ao(n);
                        "right" !== o.textAlign || o.flipX || (a.x = i.x + i.width - a.width),
                        "center" === o.textAlign && (a.x = i.x + .5 * i.width - .5 * a.width),
                        s = Yt(t, r, a, o.rotation, vt(i)),
                        s || (e.priority = -1)
                    }
                    return a
                }
                return Lo(n) ? ( (e, t, i, o, n, r) => {
                    const a = Gt(Ce(i.x, i.y), i.rx, i.ry, o, n, r, 12);
                    return Zt(e, t, a)
                }
                )(t, r, n, o.rotation, o.flipX, o.flipY) : Do(n) ? Kt(t, Math.max(16, r), Mo(n), Po(n)) : zo(n) && n.pathClose ? Zt(t, r, n.points) : !!zo(n) && (1 === n.points.length ? He(t, n.points[0]) < r * r : Xt(t, Math.max(16, r), n.points))
            }
            )).sort(( (e, t) => e.priority < t.priority ? 1 : e.priority > t.priority ? -1 : 0)).map((e => e.shape))
              , co = (e, t, i, o=0) => {
                const n = Math.abs(o)
                  , r = st(t, i)
                  , a = ct(r, n)
                  , s = ( ({start: e, end: t}, i) => {
                    if (0 === i)
                        return [Ce(e.x, e.y), Ce(e.x, e.y), Ce(t.x, t.y), Ce(t.x, t.y)];
                    const o = Math.atan2(t.y - e.y, t.x - e.x)
                      , n = Math.sin(o) * i
                      , r = Math.cos(o) * i;
                    return [Ce(n + e.x, -r + e.y), Ce(-n + e.x, r + e.y), Ce(-n + t.x, r + t.y), Ce(n + t.x, -r + t.y)]
                }
                )(a, n)
                  , l = e.filter((e => {
                    const t = xn(So(e), Ke);
                    if (Do(t) || zo(t)) {
                        const e = t.points ? [...t.points] : [Mo(t), Po(t)];
                        return !!jt(a, e)
                    }
                    return ( (e, t) => !!e.find((e => Ut(e, t))) || !!t.find((t => Ut(t, e))))(s, ( (e, t=12) => {
                        if (Io(e))
                            return Et(e, e.rotation, vt(e));
                        if (Eo(e)) {
                            const t = so(e);
                            return Et(t, e.rotation, vt(t))
                        }
                        return Lo(e) ? Gt(Ce(e.x, e.y), e.rx, e.ry, e.rotation, e.flipX, e.flipY, t) : []
                    }
                    )(t))
                }
                ));
                return l
            }
            ;
            let uo, po, mo, fo, go, yo, $o, bo = !1, vo = !1, xo = !1;
            const wo = e => {
                $o = e.map((e => ({
                    shape: e,
                    shapeOrigin: So(e),
                    shapeOriginComputed: xn(So(e), Ke)
                })))
            }
              , _o = () => {
                clearTimeout(po),
                po = void 0,
                i(143, xo = !1),
                vi()
            }
            ;
            let ko = null;
            const Co = e => {
                const t = Wi(e.rotation) && 0 !== e.rotation;
                if (Io(e)) {
                    if (e.width < 1 && e.height < 1)
                        return;
                    const i = vt(e)
                      , o = zt(e);
                    return (e.flipX || e.flipY) && qe(o, e.flipX, e.flipY, i.x, i.y),
                    t ? Ge(o, e.rotation, i.x, i.y) : o
                }
                if (Lo(e)) {
                    if (e.rx < 1 && e.ry < 1)
                        return;
                    const i = e
                      , o = zt(yt(e));
                    return (e.flipX || e.flipY) && qe(o, e.flipX, e.flipY, i.x, i.y),
                    t ? Ge(o, e.rotation, i.x, i.y) : o
                }
                if (Do(e))
                    return [Mo(e), Po(e)];
                if (zo(e)) {
                    if (e.bitmap && !e.pathClose) {
                        const t = gt(e.points);
                        return t.x -= .5 * e.strokeWidth,
                        t.y -= .5 * e.strokeWidth,
                        t.width += e.strokeWidth,
                        t.height += e.strokeWidth,
                        Co({
                            ...e,
                            ...t
                        })
                    }
                    return [...e.points]
                }
                if (Eo(e)) {
                    if (e.width < 5 && e.height < 5)
                        return;
                    const i = so(e);
                    i.width = Math.max(10, i.width);
                    const o = vt(i)
                      , n = zt(i);
                    return (e.flipX || e.flipY) && qe(n, e.flipX, e.flipY, o.x, o.y),
                    t ? Ge(n, e.rotation, o.x, o.y) : n
                }
                return []
            }
              , To = e => {
                const t = Co(e);
                let i, o;
                return e.flipY ? (i = Ve([t[0], t[1]]),
                o = Ae(Ce(t[1].x - t[2].x, t[1].y - t[2].y))) : (i = Ve([t[2], t[3]]),
                o = Ae(Ce(t[2].x - t[1].x, t[2].y - t[1].y))),
                Be(o, 20 / Ne),
                {
                    origin: i,
                    dir: o
                }
            }
              , Oo = e => t => t.id === e
              , No = e => {
                const t = Oo(e);
                return e => e.filter((e => t => !e(t))(t))
            }
              , Uo = e => {
                const t = Oo(e)
                  , i = No(e);
                return () => be.update((e => e.some(t) ? i(e) : e))
            }
              , Vo = e => {
                const t = No(e);
                return (...e) => {
                    be.update((i => [...t(i), ...e.filter(Boolean)]))
                }
            }
              , rn = Uo(by)
              , an = Vo(by);
            let sn;
            const ln = "markup-manipulator-segment-" + $e
              , cn = Uo(ln)
              , un = Vo(ln)
              , dn = (e, t) => {
                const i = e[t]
                  , o = t - 1 < 0 ? e[e.length - 1] : e[t - 1]
                  , n = t + 1 < e.length ? e[t + 1] : e[0]
                  , r = Fe(Me(o), i);
                Ae(r);
                const a = ze(Be(r, 10), i)
                  , s = Fe(Me(n), i);
                return Ae(s),
                [a, i, ze(Be(s, 10), i)]
            }
              , pn = () => {
                i(144, sn = void 0),
                rn()
            }
              , mn = "markup-multi-selection-segment-" + $e
              , fn = Uo(mn)
              , gn = Vo(mn)
              , yn = (e, t) => {
                if (ti <= 0)
                    return e;
                if (t)
                    return vi(),
                    e;
                const i = Bt(e)
                  , n = ri()
                  , {snapTranslation: r, snapLines: a} = Ti(ki(i), n, ti, ni, o);
                return bi(a),
                Mi(e, r),
                e
            }
              , $n = ic(0);
            cr(e, $n, (e => i(187, fe = e)));
            const bn = `markup-grid-line-${$e}`
              , vn = Uo(bn)
              , wn = Vo(bn)
              , Sn = "markup-snap-line"
              , Cn = Uo(Sn)
              , Tn = Vo(Sn);
            let Mn;
            const Pn = e => {
                i(8, Mn.innerHTML = (e => ( (e, t=ay) => (t.forEach(( ({tag: t, placeholderOpen: i, placeholderClose: o}) => {
                    e = e.replace(i, `<${t}>`).replace(o, `</${t}>`)
                }
                )),
                e))(e = (e = ( (e, t=ay) => (t.forEach(( ({tag: t, tagOpen: i, tagClose: o}) => {
                    e = e.replace(i, `___${t}O___`).replace(o, `___${t}C___`)
                }
                )),
                e))(e)).replace(/ {2,}/g, " ").replace(/\u00a0/g, "&nbsp;").split("\n").join("<br>")))(e), Mn)
            }
              , En = () => {
                const e = (e => {
                    const t = void 0 === e.value ? e.innerHTML : e.value
                      , i = "text" === n.format ? ty(t).split(/<br>|<br\/>/g).join("\n").replace(/&nbsp;/g, String.fromCharCode(160)).replace(/&amp;/g, "&") : t;
                    return Ro(n) && !1 !== n.disableNewline ? (e => {
                        const t = e.split(/[\n\r]/g);
                        return t.length > 1 ? t.map((e => e.trim())).filter((e => e.length)).join(" ") : t[0]
                    }
                    )(i) : i
                }
                )(Mn)
                  , t = Qo(n, e)
                  , i = !0 === t ? e : t;
                let o = F.x
                  , r = F.y;
                if (!n.height) {
                    const e = Et({
                        ...B
                    }, n.rotation)
                      , t = ho(i, d)
                      , a = Et({
                        x: o,
                        y: r,
                        ...t
                    }, n.rotation)
                      , [s,,l] = e
                      , [c,,u] = a;
                    let p = s
                      , h = c;
                    n.flipX && (p = l,
                    h = u);
                    const m = Fe(Me(p), h);
                    o += m.x,
                    r += m.y
                }
                Ni(n, {
                    x: W(z.x) ? Yi(o, Ke.width) : o,
                    y: W(z.y) ? Yi(r, Ke.height) : r,
                    text: i
                })
            }
              , Rn = () => {
                c && zi(),
                Mn && Mn.confirm && Mn.confirm(),
                En(),
                no(n),
                ht(n)
            }
              , An = () => {
                c ? Fi() : (Ni(n, {
                    text: z.text,
                    x: z.x,
                    y: z.y
                }),
                no(n))
            }
              , In = (e, t, {flipX: i, flipY: o, rotation: n}, r="top left") => {
                let a, s;
                const [l,c,u,d] = Et(e, n)
                  , [p,h,m,f] = Et(t, n);
                return "top center" === r ? (a = Ve(o ? [d, u] : [l, c]),
                s = Ve(o ? [f, m] : [p, h])) : "top right" === r && !i || "top left" === r && i ? (a = o ? u : c,
                s = o ? m : h) : (a = o ? d : l,
                s = o ? f : p),
                Fe(Me(a), s)
            }
              , Ln = (e, t, i) => Ce(W(e.x) ? Yi(t.x + i.x, Ke.width) : t.x + i.x, W(e.y) ? Yi(t.y + i.y, Ke.height) : t.y + i.y)
              , Dn = {}
              , zn = () => Ii(n, n.selectedPoint)
              , Fn = () => oo(n)
              , On = () => {
                const e = at(ho(n.text, d), (e => Math.ceil(e)))
                  , t = ji(n, "height")
                  , i = !t && ji(n, "width")
                  , o = n.id;
                let r = Dn[o];
                r || (Dn[o] = {},
                r = Dn[o]);
                const a = e => {
                    const {width: t, ...i} = d
                      , o = ho(n.text, i)
                      , r = In(bt(d.x, d.y, e.width, e.height), bt(d.x, d.y, o.width, o.height), d, `top ${n.textAlign}`)
                      , a = !1 !== d.disableNewline;
                    Bi(n, ["width", "height", a && "textAlign"]),
                    Ni(n, {
                        ...Ln(n, d, r)
                    })
                }
                  , s = t => {
                    const i = et(r.width || d.width || e.width, e.height)
                      , o = r.textAlign || "left"
                      , a = In(bt(d.x, d.y, t.width, t.height), bt(d.x, d.y, i.width, i.height), d, `top ${o}`);
                    Bi(n, ["height"]),
                    Ni(n, {
                        ...Ln(n, d, a),
                        width: W(n.width) ? Yi(i.width, Ke.width) : i.width,
                        textAlign: o
                    })
                }
                  , l = t => {
                    const i = et(r.width || e.width, r.height || e.height)
                      , o = r.textAlign || "left"
                      , a = In(bt(d.x, d.y, t.width, t.height), bt(d.x, d.y, i.width, i.height), d, `top ${o}`);
                    Ni(n, {
                        ...Ln(n, d, a),
                        width: W(n.width) ? Yi(i.width, Ke.width) : i.width,
                        height: W(n.width) ? Yi(i.height, Ke.height) : i.height,
                        textAlign: o
                    })
                }
                ;
                if (t) {
                    r.textAlign = n.textAlign,
                    r.width = d.width,
                    r.height = d.height;
                    const e = et(d.width, d.height);
                    Jo(n, "auto-height") ? s(e) : Jo(n, "auto-width") && a(e)
                } else if (i) {
                    r.textAlign = n.textAlign,
                    r.width = d.width;
                    const t = et(d.width, e.height);
                    Jo(n, "auto-width") ? a(t) : Jo(n, "fixed-size") && l(t)
                } else {
                    r.textAlign = n.textAlign;
                    const t = et(Math.ceil(e.width), Math.ceil(e.height));
                    Jo(n, "fixed-size") ? l(t) : Jo(n, "auto-height") && s(t)
                }
            }
              , Bn = e => {
                e.stopPropagation();
                const t = n.flipX || !1;
                Hi(n, "flipX", !t),
                ht(n)
            }
              , Nn = e => {
                e.stopPropagation();
                const t = n.flipY || !1;
                Hi(n, "flipY", !t),
                ht(n)
            }
              , Wn = e => {
                Hi(n, "opacity", e)
            }
              , Hn = e => {
                Wn(e),
                ht(n)
            }
              , jn = e => {
                e.stopPropagation(),
                e.target.blur(),
                Xi()
            }
              , Un = e => {
                e.stopPropagation(),
                de.findIndex((e => e === n)) !== de.length - 1 && (xe.set(de.filter((e => e !== n)).concat([n])),
                ht(n))
            }
              , Vn = e => {
                e.stopPropagation(),
                qn()
            }
              , qn = () => {
                const e = (a ? r : [n]).filter(Yo).map((e => {
                    const t = So(e);
                    t.id = V();
                    const i = Ce(50, -50);
                    if (ji(t, "points")) {
                        const e = _n(t, ["points"], Ke);
                        e.points.forEach((e => {
                            e.x += i.x,
                            e.y += i.y
                        }
                        )),
                        kn(t, e, Ke)
                    } else if (Do(t)) {
                        const e = _n(t, ["x1", "y1", "x2", "y2"], Ke);
                        e.x1 += i.x,
                        e.y1 += i.y,
                        e.x2 += i.x,
                        e.y2 += i.y,
                        kn(t, e, Ke)
                    } else {
                        const e = _n(t, ["x", "y"], Ke);
                        e.x += 50,
                        e.y -= 50,
                        kn(t, e, Ke)
                    }
                    return xe.set([...de, t]),
                    pt(t),
                    t
                }
                ));
                if (e.length > 1)
                    return Ji(),
                    void e.forEach((e => {
                        to(e, !0, !0)
                    }
                    ));
                to(e[0])
            }
              , Gn = ic(0, {
                stiffness: .2,
                damping: .7
            });
            let Kn;
            cr(e, Gn, (e => i(18, pe = e)));
            const Xn = (e, t) => {
                const {disableTextLayout: i=[]} = t;
                return "height"in t ? i.includes("auto-height") ? e.shapeIconButtonTextLayoutAutoWidth : e.shapeIconButtonTextLayoutAutoHeight : "width"in t ? i.includes("auto-width") ? e.shapeIconButtonTextLayoutFixedSize : e.shapeIconButtonTextLayoutAutoWidth : i.includes("fixed-size") ? e.shapeIconButtonTextLayoutAutoHeight : e.shapeIconButtonTextLayoutFixedSize
            }
              , Zn = (e, t) => {
                const {disableTextLayout: i=[]} = t;
                return "height"in t ? i.includes("auto-height") ? e.shapeTitleButtonTextLayoutAutoWidth : e.shapeTitleButtonTextLayoutAutoHeight : "width"in t ? i.includes("auto-width") ? e.shapeTitleButtonTextLayoutFixedSize : e.shapeTitleButtonTextLayoutAutoWidth : i.includes("fixed-size") ? e.shapeTitleButtonTextLayoutAutoHeight : e.shapeTitleButtonTextLayoutFixedSize
            }
            ;
            let Yn, Qn = !1, er = ke();
            const tr = e => {
                St(e),
                i(144, sn = e)
            }
            ;
            let ir;
            return ea(( () => {
                Cn(),
                vn(),
                cn(),
                rn()
            }
            )),
            e.$$set = e => {
                "uid"in e && i(58, $e = e.uid),
                "ui"in e && i(59, be = e.ui),
                "disabled"in e && i(0, ve = e.disabled),
                "shapes"in e && ye(i(1, xe = e.shapes)),
                "selection"in e && i(60, Se = e.selection),
                "offset"in e && i(2, Te = e.offset),
                "contextRotation"in e && i(61, Pe = e.contextRotation),
                "contextFlipX"in e && i(62, Re = e.contextFlipX),
                "contextFlipY"in e && i(63, Oe = e.contextFlipY),
                "contextZoom"in e && i(64, Ne = e.contextZoom),
                "active"in e && i(65, We = e.active),
                "opacity"in e && i(66, Ue = e.opacity),
                "parentRect"in e && i(67, Ke = e.parentRect),
                "rootRect"in e && i(3, Xe = e.rootRect),
                "utilRect"in e && i(68, Ye = e.utilRect),
                "hoverColor"in e && i(69, Qe = e.hoverColor),
                "caretColor"in e && i(70, Je = e.caretColor),
                "gridColor"in e && i(71, tt = e.gridColor),
                "snapColor"in e && i(72, it = e.snapColor),
                "textInputMode"in e && i(4, ot = e.textInputMode),
                "oninteractionstart"in e && i(73, nt = e.oninteractionstart),
                "oninteractionupdate"in e && i(74, rt = e.oninteractionupdate),
                "oninteractionrelease"in e && i(75, lt = e.oninteractionrelease),
                "oninteractionend"in e && i(76, ut = e.oninteractionend),
                "oninteractioncancel"in e && i(77, dt = e.oninteractioncancel),
                "onaddshape"in e && i(78, pt = e.onaddshape),
                "onupdateshape"in e && i(79, ht = e.onupdateshape),
                "onselectshape"in e && i(80, mt = e.onselectshape),
                "onblurshape"in e && i(81, $t = e.onblurshape),
                "onremoveshape"in e && i(82, xt = e.onremoveshape),
                "ontapshape"in e && i(83, wt = e.ontapshape),
                "onhovershape"in e && i(84, St = e.onhovershape),
                "ontriggerhistorywrite"in e && i(85, _t = e.ontriggerhistorywrite),
                "onhovercanvas"in e && i(86, kt = e.onhovercanvas),
                "ontapcanvas"in e && i(87, Ct = e.ontapcanvas),
                "onleavecanvas"in e && i(88, Tt = e.onleavecanvas),
                "beforeSelectShape"in e && i(89, Mt = e.beforeSelectShape),
                "beforeDeselectShape"in e && i(90, Pt = e.beforeDeselectShape),
                "beforeRemoveShape"in e && i(91, Rt = e.beforeRemoveShape),
                "beforeUpdateShape"in e && i(92, At = e.beforeUpdateShape),
                "willRenderShapeControls"in e && i(93, It = e.willRenderShapeControls),
                "willRenderShapeTextControls"in e && i(94, Ft = e.willRenderShapeTextControls),
                "willStartInteraction"in e && i(95, Ot = e.willStartInteraction),
                "mapEditorPointToImagePoint"in e && i(96, Bt = e.mapEditorPointToImagePoint),
                "mapImagePointToEditorPoint"in e && i(97, Nt = e.mapImagePointToEditorPoint),
                "eraseRadius"in e && i(98, Wt = e.eraseRadius),
                "selectRadius"in e && i(99, Ht = e.selectRadius),
                "enableButtonFlipVertical"in e && i(100, Vt = e.enableButtonFlipVertical),
                "enableTapToAddText"in e && i(101, qt = e.enableTapToAddText),
                "enableMultiSelect"in e && i(102, Qt = e.enableMultiSelect),
                "enableTextStyleControls"in e && i(5, Jt = e.enableTextStyleControls),
                "locale"in e && i(6, ei = e.locale),
                "snapThreshold"in e && i(103, ti = e.snapThreshold),
                "snapPointer"in e && i(104, ii = e.snapPointer),
                "enableSnapToContext"in e && i(105, oi = e.enableSnapToContext),
                "gridSize"in e && i(106, ni = e.gridSize)
            }
            ,
            e.$$.update = () => {
                var t, $;
                if (32 & e.$$.dirty[2] | 8192 & e.$$.dirty[3] && i(172, o = ni > 0 ? {
                    x: 0,
                    y: 0,
                    ...Ke
                } : void 0),
                1 & e.$$.dirty[0] | 536870912 & e.$$.dirty[5] && i(148, n = !ve && de && (Li() || qi())),
                512 & e.$$.dirty[3] | 536870912 & e.$$.dirty[5] && i(164, r = Qt ? de.filter(Bo) : []),
                512 & e.$$.dirty[5] && i(163, a = r.length > 1),
                32 & e.$$.dirty[2] | 768 & e.$$.dirty[5] && i(183, s = a ? r.map((e => xn(So(e), Ke))) : []),
                16777216 & e.$$.dirty[4] && i(180, l = !!n),
                16777216 & e.$$.dirty[4] && i(166, c = n && Wo(n)),
                16777216 & e.$$.dirty[4] | 2048 & e.$$.dirty[5] && i(10, u = n && !c ? n.id : void 0),
                8 & e.$$.dirty[0] | 32 & e.$$.dirty[2] | 16777216 & e.$$.dirty[4] && i(13, d = Xe && n && xn(So(n), Ke)),
                16777216 & e.$$.dirty[4] | 2048 & e.$$.dirty[5] && i(146, p = !(!n || !c)),
                8192 & e.$$.dirty[0] | 16 & e.$$.dirty[2] | 16777216 & e.$$.dirty[4] && i(179, h = n && Ue && Co(d) || []),
                268435712 & e.$$.dirty[5] && i(176, m = a ? s.map(Co) : []),
                16777216 & e.$$.dirty[4] | 256 & e.$$.dirty[5] && i(182, f = !a && n && on(t = n) && nn(t) && !0 !== t.disableResize && (Ho(t) || Ao(t) || Lo(t) || Do(t) || zo(t) && ji(t, "pathClose")) && !Fo(n)),
                16777216 & e.$$.dirty[4] | 256 & e.$$.dirty[5] && i(14, g = !a && n && (e => on(e) && !0 !== e.disableRotate && (Ho(e) || ji(e, "text") || Lo(e)))(n) && !Fo(n)),
                16777216 & e.$$.dirty[4] | 134217728 & e.$$.dirty[5] && i(17, y = f && ji(n, "text") && !n.height ? [[1, 2], [3, 0]] : (!n || !Do(n) && !zo(n)) && f),
                131072 & e.$$.dirty[0] | 16777216 & e.$$.dirty[4] | 134217728 & e.$$.dirty[5] && i(29, b = !!n && !Array.isArray(y) && f),
                768 & e.$$.dirty[5] && i(181, v = a ? (e => {
                    const t = e.map((e => Co(xn(e, Ke)))).flat()
                      , i = gt(t);
                    return zt(i)
                }
                )(r) : []),
                16777216 & e.$$.dirty[4] | 16777472 & e.$$.dirty[5] && i(15, x = n && h.length > 1 || a),
                16 & e.$$.dirty[3] | 83886336 & e.$$.dirty[5] && i(177, w = a ? v.map(Nt) : h.map(Nt)),
                4 & e.$$.dirty[0] | 4194304 & e.$$.dirty[5] && i(12, S = w.map((e => Ce(e.x - Te.x, e.y - Te.y)))),
                16777216 & e.$$.dirty[4] && i(16, _ = n && n.points && Wi(n.selectedPoint) ? n.selectedPoint : -1),
                65536 & e.$$.dirty[0] && i(156, k = _ >= 0),
                69632 & e.$$.dirty[0] | 2 & e.$$.dirty[5] && i(161, C = k ? S[_] : void 0),
                16777216 & e.$$.dirty[4] | 33554432 & e.$$.dirty[5] && i(28, T = l && (Ao(n) ? !ji(n, "disableNewline") || !n.disableNewline : !1 === n.disableNewline)),
                16 & e.$$.dirty[3] | 1048576 & e.$$.dirty[4] && (sn && Nt && !Bo(sn) && Xo(sn) ? (e => {
                    const t = Co(xn(So(e), Ke));
                    if (!t)
                        return;
                    const i = t.map(Nt)
                      , o = !!e.pathClose || !(!e.bitmap && (zo(e) || Do(e)))
                      , n = "hook" === e.selectionStyle
                      , r = n ? i.map(( (e, t, i) => ({
                        id: by,
                        points: dn(i, t),
                        strokeColor: [0, 0, 0, .1],
                        strokeWidth: 2
                    }))) : [{
                        id: by,
                        points: i.map((e => Ce(e.x + 1, e.y + 1))),
                        strokeColor: [0, 0, 0, .1],
                        strokeWidth: 2,
                        pathClose: o
                    }]
                      , a = n ? i.map(( (e, t, i) => ({
                        id: by,
                        points: dn(i, t),
                        strokeColor: Qe,
                        strokeWidth: 2
                    }))) : [{
                        id: by,
                        points: i,
                        strokeColor: Qe,
                        strokeWidth: 2,
                        pathClose: o
                    }];
                    an(...r, ...a)
                }
                )(sn) : rn()),
                61440 & e.$$.dirty[0] | 16 & e.$$.dirty[2] && i(178, M = x && g && Ue && S ? (e => {
                    const t = To(e)
                      , i = Nt({
                        x: t.origin.x + t.dir.x,
                        y: t.origin.y + t.dir.y
                    });
                    return {
                        origin: Nt(t.origin),
                        position: i
                    }
                }
                )(d) : void 0),
                4 & e.$$.dirty[0] | 8388608 & e.$$.dirty[5] && i(27, P = M && Ce(M.position.x - Te.x, M.position.y - Te.y)),
                1 & e.$$.dirty[6] && i(171, I = !!(me || []).find((e => [91, 93, 17].includes(e)))),
                2048 & e.$$.dirty[3] | 65536 & e.$$.dirty[5] && i(173, E = !(I || !ii)),
                16 & e.$$.dirty[2] | 18874368 & e.$$.dirty[4] | 4458496 & e.$$.dirty[5] && n && w && Ue > 0 && (n === sn && pn(),
                ( (e, t, i) => {
                    if (!Xo(t))
                        return;
                    const o = zo(t)
                      , n = o && ji(t, "pathClose")
                      , r = n && (e => e.strokeWidth && ( (e, t) => {
                        const i = e.strokeColor;
                        return !!i && (3 === i.length || i[3] > 0)
                    }
                    )(e))(t)
                      , a = Wo(t)
                      , s = Fo(t)
                      , l = "hook" === t.selectionStyle
                      , c = !0 !== t.disableShowPoints
                      , {selectionOpacity: u=1} = t;
                    if (a && o && !n)
                        return;
                    const d = []
                      , p = [...w]
                      , m = p[p.length - 1]
                      , f = p[0]
                      , g = (s ? .05 : .1) * e * u
                      , y = g > 0
                      , $ = (s ? .5 : 1) * e * u
                      , b = $ > 0
                      , v = [0, 0, 0]
                      , x = [1, 1, 1]
                      , S = s ? 1 : 1.5;
                    me.includes(16) && m && i && gi(m, i);
                    const _ = p.length && n && a && i ? He(f, i) : 1 / 0
                      , k = p.length && n && a && i ? He(m, i) : 1 / 0
                      , C = _ <= $y
                      , T = k <= $y;
                    !C && i && p.push(i);
                    const P = p.length > 1
                      , E = !!t.pathClose || !(!t.bitmap && (zo(t) || Do(t))) || p.length > 2 && C;
                    P && y && (l ? d.push(...p.map(( (e, t, i) => ({
                        id: ln,
                        points: dn(i, t),
                        strokeColor: v,
                        opacity: g
                    })))) : d.push({
                        id: ln,
                        points: p.map((e => Ce(e.x + 1, e.y + 1))),
                        pathClose: E,
                        strokeColor: v,
                        strokeWidth: 2,
                        opacity: g
                    })),
                    n && y && c && d.push(...p.map((e => ({
                        id: ln,
                        ...e,
                        rx: 2 * S,
                        ry: 2 * S,
                        backgroundColor: v,
                        opacity: g
                    })))),
                    M && y && d.push({
                        id: ln,
                        points: [Ce(M.origin.x + 1, M.origin.y + 1), Ce(M.position.x + 1, M.position.y + 1)],
                        strokeColor: v,
                        strokeWidth: 2,
                        opacity: g
                    }),
                    P && b && (l ? d.push(...p.map(( (e, t, i) => ({
                        id: ln,
                        points: dn(i, t),
                        strokeColor: x,
                        strokeWidth: S,
                        opacity: $
                    })))) : d.push({
                        id: ln,
                        points: p,
                        pathClose: E,
                        strokeColor: x,
                        strokeWidth: S,
                        backgroundColor: a && n && t.backgroundColor && t.backgroundColor[3] > 0 ? t.backgroundColor : [0, 0, 0, 0],
                        opacity: $
                    })),
                    n && c && d.push(...p.map((e => ({
                        id: ln,
                        ...e,
                        rx: 3 * S,
                        ry: 3 * S,
                        backgroundColor: [.5, .5, .5],
                        strokeWidth: S,
                        strokeColor: x
                    })))),
                    n && a && c && w.length >= 3 && d.push({
                        ...f,
                        id: ln,
                        rx: S * (C ? 5 : 4),
                        ry: S * (C ? 5 : 4),
                        backgroundColor: C ? Qe : [.5, .5, .5],
                        strokeWidth: S,
                        strokeColor: x
                    }),
                    n && a && r && c && !C && h.length >= 2 && d.push({
                        ...m,
                        id: ln,
                        rx: S * (T ? 5 : 4),
                        ry: S * (T ? 5 : 4),
                        backgroundColor: T ? Qe : [.5, .5, .5],
                        strokeWidth: S,
                        strokeColor: x
                    }),
                    M && b && !l && d.push({
                        id: ln,
                        points: [{
                            x: M.origin.x,
                            y: M.origin.y
                        }, {
                            x: M.position.x,
                            y: M.position.y
                        }],
                        strokeColor: x,
                        strokeWidth: S,
                        opacity: $
                    }),
                    un(...d)
                }
                )(Ue, n, c && zo(n) ? yn({
                    ...Yn
                }, !E) : void 0)),
                16777216 & e.$$.dirty[4] && (n || (pn(),
                cn())),
                16 & e.$$.dirty[3] | 2097152 & e.$$.dirty[5])
                    if (m.length) {
                        fn();
                        const e = m.map((e => ({
                            id: mn,
                            points: e.map(Nt),
                            strokeWidth: 1,
                            strokeColor: [1, 1, 1, .5],
                            pathClose: !0
                        })));
                        gn(...e)
                    } else
                        fn();
                1048576 & e.$$.dirty[4] && i(174, R = !!sn),
                262144 & e.$$.dirty[4] && i(175, A = !!fo),
                2097152 & e.$$.dirty[4] | 1835008 & e.$$.dirty[5] && (!Yn || A || R || yn({
                    ...Yn
                }, !E)),
                512 & e.$$.dirty[2] | 8208 & e.$$.dirty[3] | 131072 & e.$$.dirty[5] | 2 & e.$$.dirty[6] && ni > 0 && o && Nt && ( (e, t, i, o) => {
                    const n = Nt({
                        x: 0,
                        y: 0
                    })
                      , r = Nt({
                        x: e,
                        y: e
                    })
                      , a = Nt({
                        x: t.width,
                        y: t.height
                    })
                      , s = r.x - n.x;
                    if ($n.set(s > 6 ? 1 : 0),
                    o <= 0)
                        return vn();
                    const l = _i(s, n.x, a.x).map((e => ({
                        id: bn,
                        opacity: o,
                        points: [{
                            x: e,
                            y: n.y
                        }, {
                            x: e,
                            y: a.y
                        }],
                        strokeWidth: 1,
                        strokeColor: i
                    })))
                      , c = _i(s, n.y, a.y).map((e => ({
                        id: bn,
                        opacity: o,
                        points: [{
                            x: n.x,
                            y: e
                        }, {
                            x: a.x,
                            y: e
                        }],
                        strokeWidth: 1,
                        strokeColor: i
                    })));
                    wn(...c, ...l)
                }
                )(ni, o, tt, fe),
                1024 & e.$$.dirty[2] | 16 & e.$$.dirty[3] | 196608 & e.$$.dirty[4] | 65536 & e.$$.dirty[5] && Nt && (I ? Cn() : ( (e, t, i) => {
                    if (null === e && null === t)
                        return Cn();
                    let o, n;
                    null !== e && (o = {
                        id: Sn,
                        strokeColor: i,
                        strokeWidth: 1.5,
                        points: [Nt({
                            x: e,
                            y: 0
                        }), Nt({
                            x: e,
                            y: Ke.height
                        })]
                    }),
                    null !== t && (n = {
                        id: Sn,
                        strokeColor: i,
                        strokeWidth: 1.5,
                        points: [Nt({
                            x: 0,
                            y: t
                        }), Nt({
                            x: Ke.width,
                            y: t
                        })]
                    }),
                    Tn(o, n)
                }
                )(xi, wi, it)),
                8 & e.$$.dirty[2] && (e => {
                    if (!e)
                        return Ui({
                            _prerender: !1
                        });
                    const t = de.find((e => e.isEditing));
                    t && Ni(t, {
                        _prerender: "inline" === ot
                    })
                }
                )(We),
                1 & e.$$.dirty[6] && me && me.length && ( () => {
                    const [e] = me;
                    8 !== e && 46 !== e || Gi() && (n.isEditing || (zo(n) && Wi(n.selectedPoint) ? setTimeout(( () => Ii(n, n.selectedPoint)), 0) : setTimeout(( () => Xi()), 0)))
                }
                )(),
                272 & e.$$.dirty[0] && Mn && "inline" === ot && Mn.focus(),
                16777216 & e.$$.dirty[4] && i(170, L = n && Eo(n)),
                16777216 & e.$$.dirty[4] | 32768 & e.$$.dirty[5] && i(11, D = L && !1 !== Qo(n) && Fo(n)),
                2048 & e.$$.dirty[0] && i(165, z = D ? {
                    ...n
                } : void 0),
                32 & e.$$.dirty[2] | 1024 & e.$$.dirty[5] && i(167, F = z && xn({
                    ...z
                }, Ke)),
                4096 & e.$$.dirty[5] && i(169, O = F && ho(F.text, F)),
                20480 & e.$$.dirty[5] && (B = F && bt(F.x, F.y, O.width, O.height)),
                2048 & e.$$.dirty[0] | 16777216 & e.$$.dirty[4] && i(24, N = D ? n.text : ""),
                2056 & e.$$.dirty[0] | 32 & e.$$.dirty[2] | 16777216 & e.$$.dirty[4] && i(168, H = Xe && n && D && xn({
                    ...So(n),
                    width: Wi(n.width) ? Math.floor(n.width) : void 0,
                    height: Wi(n.height) ? Math.floor(n.height) : void 0
                }, Ke)),
                2064 & e.$$.dirty[0] | 8192 & e.$$.dirty[5] && i(26, j = D && ( (e, t) => {
                    const {textAlign: i="left", fontFamily: o="sans-serif", fontWeight: n="normal", fontStyle: r="normal", letterSpacing: a="normal", textShadowX: s=0, textShadowY: l=0, textShadowBlur: c=0, textShadowColor: u, textOutlineWidth: d=0, textOutlineColor: p} = e
                      , h = "!important"
                      , m = `caret-color:${q};text-align:${i}${h};font-family:${o}${h};font-weight:${n}${h};font-style:${r}${h};letter-spacing:${Wi(a) ? a + "px" : "normal"}${h}`;
                    if ("modal" === t)
                        return m;
                    const f = d ? `;-webkit-text-stroke:${2 * d}px ${Qi(p)} ${h}` : ""
                      , g = c || s || l ? `;text-shadow:${s}px ${l}px ${c}px ${Qi(u)} ${h}` : "";
                    let y = e.fontSize
                      , $ = 1
                      , b = "";
                    y > 1e3 && X() && ($ = y / 1e3,
                    b = `transform-origin:0 0;transform:scale(${$})`,
                    y = 1e3);
                    let v = e.lineHeight / $;
                    const x = Qi(e.color)
                      , w = .5 * Math.max(0, y - v);
                    return `--font-scalar:${$};--bottom-inset:${w}px;padding:${w}px 0 0${h};color:${x}${h};font-size:${y}px${h};line-height:${v}px${h};${m};${b}${f}${g}`
                }
                )(H, ot)),
                2052 & e.$$.dirty[0] | 1073741824 & e.$$.dirty[1] | 4 & e.$$.dirty[2] | 8192 & e.$$.dirty[5] && i(25, U = D && ( (e, t, i, o) => {
                    let r, a;
                    e.width && e.height ? (r = vt(e),
                    a = Ze(e)) : (a = ho(n.text, d),
                    a.width = d.width || a.width,
                    r = Ce(e.x + .5 * a.width, e.y + .5 * a.height));
                    const s = Math.max(0, e.fontSize - e.lineHeight) + e.lineHeight
                      , l = Nt(r);
                    let c = l.x - t.x - .5 * a.width
                      , u = l.y - t.y - .5 * a.height
                      , p = e.flipX
                      , h = e.flipY
                      , m = e.rotation;
                    Re && Oe ? (p = !p,
                    h = !h) : Re ? (p = !p,
                    m = -m) : Oe && (h = !h,
                    m = -m),
                    m += o;
                    const f = i * (p ? -1 : 1)
                      , g = i * (h ? -1 : 1);
                    return `--line-height:${s}px;width:${a.width}px;height:${a.height}px;transform:translate(${c}px,${u}px) rotate(${m}rad) scale(${f}, ${g})`
                }
                )(H, Te, Ne, Pe)),
                256 & e.$$.dirty[2] && (q = Je ? Qi(Je) : "auto"),
                2320 & e.$$.dirty[0] && D && Mn && "inline" === ot && Pn(N),
                289406976 & e.$$.dirty[4] && i(152, G = n && !p ? n : G),
                268435456 & e.$$.dirty[4] && i(154, K = G && (e => !e.disableFlip && !Wo(e) && !jo(e) && (e => ji(e, "backgroundImage") || ji(e, "text"))(e))(G)),
                268435456 & e.$$.dirty[4] && i(149, Z = G && Jo(G)),
                268435456 & e.$$.dirty[4] && i(151, Y = G && Yo(G)),
                268435456 & e.$$.dirty[4] && i(150, Q = G && Zo(G)),
                268435456 & e.$$.dirty[4] | 256 & e.$$.dirty[5] && i(153, J = !a && G && (e => !0 !== e.disableReorder)(G)),
                268435456 & e.$$.dirty[4] && i(147, ee = G && !1 !== Qo(G)),
                268435456 & e.$$.dirty[4] && i(155, te = G && ji(G, "backgroundImage") && Ko(G, "opacity")),
                16777216 & e.$$.dirty[4] && i(158, ie = n && "html" === n.format),
                20971520 & e.$$.dirty[4] | 8 & e.$$.dirty[5] && i(162, oe = n && (!p || ie)),
                524288 & e.$$.dirty[4] | 1073741952 & e.$$.dirty[5] && Gn.set(oe && !xo ? 1 : 0, {
                    hard: !1 === he
                }),
                4096 & e.$$.dirty[0] | 160 & e.$$.dirty[5] && i(160, ne = oe && S.length ? ($ = gt(S),
                De(Ce($.x + .5 * $.width, $.y), Uu)) : ne),
                512 & e.$$.dirty[0] | 64 & e.$$.dirty[2] | 96 & e.$$.dirty[5] && i(159, re = (C || ne) && Kn && Ye && ( (e, t, i, o) => {
                    const n = e.x
                      , r = e.y
                      , a = n + e.width;
                    let s = Math.max(t.x - .5 * i.width, n)
                      , l = Math.max(t.y - i.height - 16, r);
                    return s + i.width > a && (s = a - i.width),
                    Ce(s, l)
                }
                )(Ye, C || ne, Kn)),
                262144 & e.$$.dirty[0] | 16 & e.$$.dirty[5] && i(23, ae = re && `transform: translate(${re.x}px, ${re.y}px);opacity:${pe}`),
                2048 & e.$$.dirty[0] && i(157, le = D ? "text" : "shape"),
                1088 & e.$$.dirty[0] | 131 & e.$$.dirty[3] | 2139095040 & e.$$.dirty[4] | 536870927 & e.$$.dirty[5] && i(22, ce = "text" === le && Ft && ie ? Bh(( () => Ft([["div", "text-styles", {
                    class: "PinturaShapeControlsGroup"
                }, [...[["bold", {
                    label: "B",
                    style: "font-weight:900;",
                    title: "Bold",
                    shortcut: ["CMD", "B"]
                }], ["italic", {
                    label: "I",
                    style: "font-family:Times New Roman;font-style:italic;",
                    title: "Italic",
                    shortcut: ["CMD", "I"]
                }], ["underline", {
                    label: "U",
                    style: "text-decoration:underline;",
                    title: "Underline",
                    shortcut: ["CMD", "U"]
                }], ["strikeThrough", {
                    label: "S",
                    style: "text-decoration:line-through;",
                    title: "Strikethrough",
                    shortcut: ["CMD", "S"]
                }]].map(( ([e,t]) => ["Button", "style-" + e, {
                    onclick: () => document.execCommand(e),
                    ...t,
                    style: "font-size:1.25em;text-underline-offset:1px;text-decoration-thickness:1.5px;font-weight:400;" + t.style
                }]))]], ["div", "text-reset", {
                    class: "PinturaShapeControlsGroup"
                }, [["Button", "style-reset", {
                    onclick: () => document.execCommand("removeFormat"),
                    style: "font-weight:400;",
                    label: '<span style="font-size:1.25em;font-style:italic;font-family:Times New Roman;text-decoration:underline;">T</span><span style="position:relative;top:.175rem;">&times;</span>',
                    title: "Remove styles"
                }]]]], u))) : "shape" === le && It && u ? Bh(( () => It(k ? [["div", "epsilon", {
                    class: "PinturaShapeControlsGroup"
                }, [["Button", "remove-point", {
                    onclick: zn,
                    label: ei.shapeTitleButtonRemove,
                    icon: ei.shapeIconButtonRemove,
                    shortcut: ["Backspace"],
                    hideLabel: !0
                }]]]] : [te && ["div", "alpha", {
                    class: "PinturaShapeControlsGroup"
                }, [["ToggleSlider", "adjust-opacity", {
                    onrelease: Hn,
                    onchange: Wn,
                    step: .01,
                    value: ji(n, "opacity") ? n.opacity : 1,
                    label: (e, t, i) => `${Math.round(e / i * 100)}%`,
                    min: 0,
                    max: 1,
                    direction: "x"
                }]]], ["div", "beta", {
                    class: "PinturaShapeControlsGroup"
                }, [K && ["Button", "flip-horizontal", {
                    onclick: Bn,
                    label: ei.shapeTitleButtonFlipHorizontal,
                    icon: ei.shapeIconButtonFlipHorizontal,
                    hideLabel: !0
                }], K && Vt && ["Button", "flip-vertical", {
                    onclick: Nn,
                    label: ei.shapeTitleButtonFlipVertical,
                    icon: ei.shapeIconButtonFlipVertical,
                    hideLabel: !0
                }], J && ["Button", "to-front", {
                    onclick: Un,
                    label: ei.shapeTitleButtonMoveToFront,
                    icon: ei.shapeIconButtonMoveToFront,
                    hideLabel: !0,
                    disabled: de[de.length - 1] === G
                }], Y && ["Button", "duplicate", {
                    onclick: Vn,
                    label: ei.shapeTitleButtonDuplicate,
                    icon: ei.shapeIconButtonDuplicate,
                    shortcut: ["CMD", "D"],
                    hideLabel: !0
                }], Q && ["Button", "remove", {
                    onclick: jn,
                    label: ei.shapeTitleButtonRemove,
                    icon: ei.shapeIconButtonRemove,
                    shortcut: ["Backspace"],
                    hideLabel: !0
                }]].filter(Boolean)], ee && Z && ["div", "gamma", {
                    class: "PinturaShapeControlsGroup"
                }, [["Button", "text-layout", {
                    onclick: On,
                    label: pd(Zn, ei, n),
                    icon: pd(Xn, ei, n),
                    hideLabel: !0
                }]]], ee && ["div", "delta", {
                    class: "PinturaShapeControlsGroup"
                }, [["Button", "edit-text", {
                    label: ei.shapeLabelInputText,
                    onclick: Fn
                }]]]].filter(Boolean), u))) : []),
                64 & e.$$.dirty[0] | 536870912 & e.$$.dirty[5] && i(21, ue = de.filter(Xo).filter((e => e.id)).filter((e => !Wo(e))).map((e => ({
                    id: e.id,
                    color: Eo(e) ? e.color : Do(e) ? e.strokeColor : e.backgroundColor,
                    name: e.name || ei[`shapeLabelTool${es(hn(e))}`]
                }))))
            }
            ,
            [ve, xe, Te, Xe, ot, Jt, ei, to, Mn, Kn, u, D, S, d, g, x, _, y, pe, Qn, ir, ue, ce, ae, N, U, j, P, T, b, si, yi, e => {
                const {origin: t} = e.detail
                  , o = Qt && me.includes(16);
                $o = void 0,
                i(142, fo = void 0),
                go = void 0,
                yo = void 0,
                bo = !1,
                mo = void 0,
                vo = !1,
                vi(),
                clearTimeout(po),
                po = setTimeout(( () => i(143, xo = !0)), 250);
                const s = Li();
                if (!s || zo(s) && ji(s, "pathClose") || zi(),
                uo = Bt(Me(t)),
                s && zo(s) && ji(s, "pathClose"))
                    return nt(e);
                const l = lo(de, uo, Ht, (e => Xo(e)))
                  , c = l.length && l.shift();
                if (n && Fo(n) && (Rn(),
                qt && (vo = !0)),
                !c && n && Fo(n) && io(n),
                Ot(t)) {
                    if (c && Bo(c))
                        return bo = !0,
                        i(142, fo = c),
                        a ? (o && io(c),
                        void wo(r)) : (go = So(fo),
                        void (yo = xn(So(fo), Ke)));
                    if (mo = c || void 0,
                    !nt(e) && c) {
                        if (to(c, !0, o),
                        i(142, fo = c),
                        a)
                            return wo(r);
                        go = So(fo),
                        yo = xn(So(fo), Ke)
                    }
                }
            }
            , e => {
                _o(),
                dt(e)
            }
            , e => {
                const {translation: t, ctrlKey: i, metaKey: n, shiftKey: a, position: s} = e.detail;
                if (fo) {
                    if (!nn(fo))
                        return;
                    if (Fo(fo))
                        return;
                    if (a) {
                        let e = Math.abs(t.x)
                          , i = Math.abs(t.y);
                        "x" === ko && (i -= 64),
                        "y" === ko && (e -= 64),
                        e > i ? (t.y = 0,
                        ko = "x") : i > e && (t.x = 0,
                        ko = "y")
                    } else
                        ko = null;
                    const e = i || n;
                    if ($o) {
                        if (!r.every(nn))
                            return;
                        return void $o.forEach(( ({shape: e, shapeOriginComputed: i}) => {
                            Pi(e, i, t, {
                                ...ai(0, ni, o, e)
                            })
                        }
                        ))
                    }
                    return Pi(fo, yo, t, {
                        ...ai(e ? 0 : ti, ni, o, fo)
                    })
                }
                rt(e)
            }
            , e => {
                if (_o(),
                fo) {
                    if (a)
                        return;
                    if (Fo(fo) && An(),
                    e.detail.isTap && zo(fo) && tn(fo)) {
                        const {position: t} = e.detail
                          , i = Bt(Me(t));
                        return void ( (e, t) => {
                            const i = e.points
                              , o = [];
                            for (let e = 0; e < i.length - 1; e++)
                                o.push([i[e], i[e + 1]]);
                            o.push([i[i.length - 1], i[0]]);
                            const n = o.findIndex(( ([e,i]) => Kt(t, 6, e, i)));
                            let r;
                            const a = [];
                            for (let e = 0; e < o.length; e++)
                                a.push(o[e][0]),
                                e === n && (r = e + 1,
                                a.push(t));
                            Ni(e, {
                                points: a,
                                selectedPoint: r
                            })
                        }
                        )(fo, i)
                    }
                    e.detail.isTap && bo && Eo(fo) && !1 !== Qo(fo) && oo(fo)
                } else
                    lt(e)
            }
            , e => {
                const t = mo && e.detail.isTap
                  , o = Qt && me.includes(16);
                if (e.detail.isTap && setTimeout(( () => {
                    Ct({
                        target: fo || mo,
                        position: uo
                    }, 0)
                }
                )),
                fo)
                    return wt(fo),
                    n = fo,
                    r = go,
                    JSON.stringify(n) !== JSON.stringify(r) && ht(fo),
                    void i(142, fo = void 0);
                var n, r;
                let a = !0;
                if (!o) {
                    const e = eo();
                    a = !e || Pt(e, mo || void 0),
                    a && Ji({
                        storePrevious: !1
                    })
                }
                ut(e),
                a && t && to(mo, !0, o)
            }
            , $n, e => {
                i(143, xo = !0),
                i(142, fo = n),
                yo = d
            }
            , e => {
                if (!fo)
                    return void i(143, xo = !1);
                const {translation: t, indexes: n, shiftKey: r, ctrlKey: a, metaKey: s, isNudge: l} = e.detail;
                ( (e, t, i, o, n) => {
                    const {shiftKey: r, snapThreshold: a=0, gridSize: s=0, gridRect: l, snapTargets: c=[]} = n || {}
                      , u = a ? (e, t, i) => {
                        const {snapTranslation: o, snapLines: n} = Ti(ki(e), c, a, s, l);
                        Mi(t, o),
                        bi(n);
                        const r = Si(i(), t);
                        e.x = r.x,
                        e.y = r.y
                    }
                    : $;
                    if (Do(e) || zo(e) && ji(e, "pathClose")) {
                        const [n] = i
                          , a = r ? gi : (e, t) => t;
                        let s, l, c;
                        if (Do(e))
                            0 === n ? (s = () => Mo(t),
                            l = e => a(Po(t), e),
                            c = (e, t) => {
                                e.x1 = t.x,
                                e.y1 = t.y
                            }
                            ) : 1 === n && (s = () => Po(t),
                            l = e => a(Mo(t), e),
                            c = (e, t) => {
                                e.x2 = t.x,
                                e.y2 = t.y
                            }
                            );
                        else {
                            const e = t.points;
                            s = () => ({
                                ...e[n]
                            }),
                            l = t => {
                                const i = e[Vg(n - 1, e)]
                                  , o = e[Vg(n + 1, e)];
                                a(i, t),
                                a(o, t)
                            }
                            ,
                            c = (e, t) => e.points = e.points.map(( (e, i) => n === i ? t : e))
                        }
                        const d = Si(s(), o);
                        u(d, o, s),
                        l(d),
                        c(e, d)
                    } else if (Ho(e) || Lo(e) || Ao(e)) {
                        let r, a, s = !1;
                        if (Lo(e))
                            r = yt(t);
                        else if (Ho(e))
                            r = ft(t);
                        else {
                            s = !0,
                            r = ft(t);
                            const e = ho(t.text, t);
                            r.height = e.height
                        }
                        e.aspectRatio ? a = e.aspectRatio : n.shiftKey && !s && (a = r.width / r.height);
                        const l = ft(r)
                          , c = vt(l)
                          , d = e.rotation
                          , p = zt(l)
                          , h = Et(l, d);
                        if (1 === i.length) {
                            let t = i[0];
                            e.flipX && (t = Ei[t]),
                            e.flipY && (t = Ri[t]);
                            const [n,r,s,l] = p
                              , m = Nt(h[t])
                              , f = ze({
                                ...m
                            }, o)
                              , g = Bt(f);
                            u(g, o, ( () => Bt(m)));
                            const y = Ce(g.x - h[t].x, g.y - h[t].y)
                              , $ = Ee(Me(y), -d)
                              , b = Ce(p[t].x + $.x, p[t].y + $.y);
                            let v;
                            0 === t && (v = s),
                            1 === t && (v = l),
                            2 === t && (v = n),
                            3 === t && (v = r);
                            const x = gt([v, b]);
                            if (a) {
                                const {width: e, height: t} = Lt(x, a)
                                  , [i,o,n,r] = Dt(x);
                                x.width = e,
                                x.height = t,
                                b.y < v.y && (x.y = n - t),
                                b.x < v.x && (x.x = o - e)
                            }
                            const w = Et(x, d, c)
                              , S = Ve(w)
                              , _ = Ee(w[0], -d, S)
                              , k = Ee(w[2], -d, S)
                              , C = gt([_, k]);
                            fi(e, Lo(e) ? _e(C) : C, Ke)
                        } else {
                            i = i.map((t => (e.flipX && (t = Ei[t]),
                            e.flipY && (t = Ri[t]),
                            t)));
                            const [t,n] = i.map((e => h[e]))
                              , r = {
                                x: t.x + .5 * (n.x - t.x),
                                y: t.y + .5 * (n.y - t.y)
                            }
                              , [l,m] = i.map((e => p[e]))
                              , [f,g] = i.map((e => {
                                const t = e + 2;
                                return t < 4 ? p[t] : p[t - 4]
                            }
                            ))
                              , y = {
                                x: f.x + .5 * (g.x - f.x),
                                y: f.y + .5 * (g.y - f.y)
                            }
                              , $ = Nt(r)
                              , b = ze({
                                ...$
                            }, o)
                              , v = Bt(b);
                            u(v, o, ( () => Bt($)));
                            const x = Ce(v.x - r.x, v.y - r.y)
                              , w = Ee(Me(x), -d)
                              , S = Fe(Me(l), m)
                              , _ = De(S, (e => 1 - Math.abs(Math.sign(e))))
                              , k = Ce(w.x * _.x, w.y * _.y);
                            ze(l, k),
                            ze(m, k);
                            const C = gt(p);
                            if (a) {
                                let e = C.width
                                  , t = C.height;
                                0 === _.y ? t = e / a : e = t * a,
                                C.width = e,
                                C.height = t,
                                0 === _.y ? C.y = y.y - .5 * t : C.x = y.x - .5 * e
                            }
                            const T = Et(C, d, c)
                              , M = Ve(T)
                              , P = Ee(T[0], -d, M)
                              , E = Ee(T[2], -d, M)
                              , R = gt([P, E]);
                            let A;
                            Lo(e) ? A = _e(R) : Ho(e) ? A = R : s && (A = {
                                x: R.x,
                                y: R.y,
                                width: R.width
                            }),
                            fi(e, A, Ke)
                        }
                    }
                    Oi()
                }
                )(fo, yo, n, t, {
                    shiftKey: !l && r,
                    ...ai(a || s ? 0 : ti, ni, o, fo)
                }),
                en(fo) && He(t) > 16 && Ni(fo, {
                    selectedPoint: void 0
                })
            }
            , e => {
                if (!fo)
                    return void i(143, xo = !1);
                to(fo);
                const {isTap: t, translation: o, indexes: r} = e.detail;
                t && (en(fo) && Ni(fo, {
                    selectedPoint: fo.selectedPoint === r[0] ? void 0 : r[0]
                }),
                wt(fo)),
                i(142, fo = void 0),
                i(143, xo = !1),
                ht(n)
            }
            , e => {
                Ai = To(d).origin,
                i(143, xo = !0),
                i(142, fo = n),
                yo = d
            }
            , e => {
                if (!fo)
                    return void i(143, xo = !1);
                const {translation: t, shiftKey: o} = e.detail;
                ( (e, t, i, o) => {
                    const n = so(xn(So(e), Ke))
                      , r = vt(n)
                      , a = Si(Ai, i);
                    let s = Ie(a, r) + Math.PI / 2;
                    if (o.shiftKey) {
                        const e = Math.PI / 16;
                        s = e * Math.round(s / e) - Pe % e
                    }
                    fi(e, {
                        rotation: s
                    }, Ke),
                    Oi()
                }
                )(fo, 0, t, {
                    shiftKey: o
                })
            }
            , () => {
                fo ? (to(fo),
                i(142, fo = void 0),
                i(143, xo = !1),
                ht(n)) : i(143, xo = !1)
            }
            , e => {
                const {key: t} = e
                  , i = /escape/i.test(t);
                if (Gi())
                    return i ? (e.preventDefault(),
                    e.stopPropagation(),
                    io(n)) : void (Y && "d" === t && (e.metaKey || e.ctrlKey) && (e.preventDefault(),
                    e.stopPropagation(),
                    qn()))
            }
            , e => {
                const t = Qo(n, e);
                return !0 === t ? e : t
            }
            , En, e => {
                const {target: t, key: i} = e
                  , o = t.value || t.innerText
                  , r = t.selectionStart || 0
                  , a = t.selectionEnd || o.length
                  , s = o.substring(0, r) + i + o.substring(a);
                if (Qo(n, s) !== s)
                    return e.preventDefault()
            }
            , e => Ro(n) && /enter/i.test(e.code) && !1 !== n.disableNewline ? e.preventDefault() : /arrow/i.test(e.code) ? e.stopPropagation() : /escape/i.test(e.key) ? An() : void 0, e => {
                const {key: t, ctrlKey: i, altKey: o} = e;
                if (/enter/i.test(t) && (i || o))
                    return Rn()
            }
            , Rn, An, Gn, e => {
                const t = Vi();
                t && (t.find(Fo) || t.find((e => !nn(e))) || t.forEach((t => {
                    i(142, fo = t),
                    yo = xn(So(fo), Ke),
                    Pi(fo, yo, e.detail)
                }
                )))
            }
            , e => {
                i(19, Qn = !0)
            }
            , ({relatedTarget: e}) => {
                e && e.classList.contains("shape-selector__button") || i(19, Qn = !1)
            }
            , e => {
                if ("touch" === e.pointerType || "PinturaShapeEditor" !== e.target.className)
                    return void Tt();
                (xo || po) && tr(void 0);
                const t = Jg(e, Xe);
                i(145, Yn = Me(t));
                const o = De(Bt(t), (e => Math.round(e)));
                if (Le(o, er))
                    return;
                if (er = Me(o),
                kt(xo, t, o),
                xo || po)
                    return;
                if (p)
                    return;
                const [n] = lo(de, o, 0, Xo);
                n && Wo(n) || tr(n)
            }
            , e => {
                "touch" !== e.pointerType && Tt()
            }
            , $e, be, Se, Pe, Re, Oe, Ne, We, Ue, Ke, Ye, Qe, Je, tt, it, nt, rt, lt, ut, dt, pt, ht, mt, $t, xt, wt, St, _t, kt, Ct, Tt, Mt, Pt, Rt, At, It, Ft, Ot, Bt, Nt, Wt, Ht, Vt, qt, Qt, ti, ii, oi, ni, li, ci, ui, di, pi, hi, mi, (e, t={}) => {
                let i, n, r, a = Lo(e), s = Eo(e), l = "relative" === t.position;
                const c = ri()
                  , u = e => {
                    if (!ti)
                        return e;
                    const t = Bt(e)
                      , {snapTranslation: i, snapLines: n} = Ti(ki(t), c, ti, ni, o);
                    return Mi(e, i),
                    bi(n),
                    e
                }
                  , d = !!eo()
                  , p = t.isSelection ? Se : xe
                  , h = "step" === t.inputMode;
                if (zo(e)) {
                    if (h) {
                        let t = !1;
                        const o = (e, i) => {
                            const o = ci(p)
                              , n = e && Ce(sy(e.x, Ke.width), sy(e.y, Ke.height))
                              , r = n && Nt(n);
                            me.includes(16) && r && gi(r, i);
                            const a = Bt(i)
                              , s = o.points.length ? o.points[0] : a
                              , c = Ce(sy(s.x, Ke.width), sy(s.y, Ke.height))
                              , u = Nt(c)
                              , d = He(u, i);
                            if (!t && 1 === o.points.length && d < 36)
                                return di(p);
                            if (o.points.length > 2 && d <= $y) {
                                o.pathClose = !0,
                                Xo(o) && to(o);
                                const e = pi(p);
                                return void pt(e)
                            }
                            const h = o.strokeWidth && o.strokeColor && (void 0 === o.strokeColor[3] || o.strokeColor[3] > 0)
                              , m = He(r, i);
                            if (h && o.points.length > 1 && m < $y) {
                                o.pathClose = !1,
                                o.backgroundColor = [0, 0, 0, 0],
                                Xo(o) && to(o);
                                const e = pi(p);
                                pt(e)
                            } else if (!(o.points.length > 0 && m < 100))
                                return l ? ly(a, Ke) : a
                        }
                        ;
                        return {
                            start: e => {
                                const a = ci(p)
                                  , {origin: s} = e.detail;
                                if (n = 4,
                                i = u(Me(s)),
                                r = Me(i),
                                a) {
                                    const e = a.points[a.points.length - 1]
                                      , t = o(e, i);
                                    return t && (a.points = [...a.points, t]),
                                    void hi({
                                        points: a.points
                                    }, p)
                                }
                                t = !0
                            }
                            ,
                            update: e => {
                                if (!t)
                                    return;
                                const n = ci(p);
                                if (!n)
                                    return;
                                const r = n.points[0]
                                  , a = o(r, Ce(i.x + e.detail.translation.x, i.y + e.detail.translation.y));
                                a && (n.points[1] = a,
                                hi({
                                    points: n.points
                                }, p))
                            }
                            ,
                            release: e => e.detail.preventInertia(),
                            cancel: () => {
                                di(p)
                            }
                            ,
                            end: o => {
                                if (!t)
                                    return;
                                const n = Bt(i)
                                  , r = l ? ly(n, Ke) : n
                                  , {isTap: a} = o.detail;
                                if (a && lo(de, n, 0, Xo).length)
                                    return di(p);
                                ui({
                                    ...e,
                                    points: [r]
                                }, p)
                            }
                        }
                    }
                    return {
                        start: t => {
                            const {origin: o} = t.detail;
                            n = 4,
                            i = Me(o),
                            r = Me(i);
                            const a = Bt(i)
                              , s = l ? ly(a, Ke) : a;
                            ui({
                                ...e,
                                points: [s]
                            }, p)
                        }
                        ,
                        update: e => {
                            const t = ci(p);
                            if (!t)
                                return;
                            const {translation: o} = e.detail
                              , a = Ce(i.x + o.x, i.y + o.y)
                              , s = je(r, a);
                            if (we(s, 5) <= n)
                                return;
                            const c = Ie(a, r)
                              , u = n - s;
                            r.x += u * Math.cos(c),
                            r.y += u * Math.sin(c);
                            const d = Bt(r)
                              , h = l ? ly(d, Ke) : d;
                            hi({
                                points: t.points.concat(h)
                            }, p)
                        }
                        ,
                        release: e => e.detail.preventInertia(),
                        cancel: () => {
                            di(p)
                        }
                        ,
                        end: e => {
                            const t = ci(p);
                            if (!t)
                                return;
                            if (e.detail.isTap) {
                                let e = !1;
                                if (t.bitmap ? (mo && (e = !0),
                                d && (e = !0)) : e = !0,
                                e)
                                    return di(p)
                            }
                            const i = pi(p);
                            pt(i)
                        }
                    }
                }
                return a || s || Io(e) ? {
                    start: t => {
                        const {origin: o} = t.detail;
                        i = u(Me(o));
                        const n = Bt(i)
                          , r = l ? ly(n, Ke) : n
                          , s = -1 * $i(Pe, Re, Oe)
                          , c = {
                            ...e,
                            rotation: s,
                            ...r
                        };
                        c.flipX = Re,
                        c.flipY = Oe,
                        delete c.position,
                        c.opacity = 0,
                        (a ? ["rx", "ry"] : ["width", "height"]).forEach((e => {
                            c[e] = l ? "0%" : 0
                        }
                        )),
                        ui(c, p)
                    }
                    ,
                    update: e => {
                        const t = ci(p);
                        if (!t)
                            return;
                        t.opacity = 1;
                        let {aspectRatio: o} = t
                          , {translation: n, shiftKey: r, ctrlKey: s} = e.detail;
                        !o && r && (o = 1);
                        const l = u(Ce(i.x + n.x, i.y + n.y))
                          , c = Bt(i)
                          , d = Bt(l);
                        if (o) {
                            const e = gt([c, d])
                              , t = Lt(e, o)
                              , i = d.x < c.x ? -1 : 1
                              , n = d.y < c.y ? -1 : 1;
                            d.x = c.x + t.width * i,
                            d.y = c.y + t.height * n
                        }
                        const h = {
                            x: c.x + .5 * (d.x - c.x),
                            y: c.y + .5 * (d.y - c.y)
                        }
                          , m = $i(Pe, Re, Oe);
                        Ee(c, m, h),
                        Ee(d, m, h);
                        const f = Math.min(c.x, d.x)
                          , g = Math.min(c.y, d.y);
                        let y = Math.max(c.x, d.x) - f
                          , $ = Math.max(c.y, d.y) - g
                          , b = {};
                        a ? (s ? (b.x = c.x,
                        b.y = c.y) : (b.x = f + .5 * y,
                        b.y = g + .5 * $),
                        b.rx = .5 * y,
                        b.ry = .5 * $) : (s ? (b.x = c.x - .5 * y,
                        b.y = c.y - .5 * $) : (b.x = f,
                        b.y = g),
                        b.width = y,
                        b.height = $),
                        hi(b, p, ( (e, t) => fi(e, t, Ke)))
                    }
                    ,
                    release: e => {
                        e.detail.preventInertia()
                    }
                    ,
                    cancel: () => {
                        di(p)
                    }
                    ,
                    end: e => {
                        const t = ci(p);
                        if (t) {
                            if (e.detail.isTap) {
                                if (Eo(t) && qt && vo)
                                    return di(p);
                                if (!Eo(t) || !qt || mo)
                                    return di(p);
                                delete t.width,
                                delete t.height,
                                !1 !== t.disableNewline && delete t.textAlign;
                                const e = xn({
                                    ...t
                                }, Ke)
                                  , o = ho(t.text, e)
                                  , n = Bt({
                                    x: i.x,
                                    y: i.y - .5 * o.height
                                })
                                  , r = Bt({
                                    x: i.x + o.width,
                                    y: i.y + .5 * o.height
                                })
                                  , a = {
                                    x: n.x + .5 * (r.x - n.x),
                                    y: n.y + .5 * (r.y - n.y)
                                }
                                  , s = $i(Pe, Re, Oe);
                                Ee(n, s, a),
                                Ee(r, s, a);
                                let l = Math.min(n.x, r.x)
                                  , c = Math.min(n.y, r.y);
                                l < 0 && (l = 0),
                                c < 0 && (c = 0),
                                l + o.width > Ke.width && (l = Ke.width - o.width),
                                c + o.height > Ke.height && (c = Ke.height - o.height),
                                t.x = W(t.x) ? Yi(l, Ke.width) : l,
                                t.y = W(t.y) ? Yi(c, Ke.height) : c
                            }
                            if (t.opacity = 1,
                            Eo(t))
                                pt(t);
                            else {
                                const e = pi(p);
                                pt(e)
                            }
                            Xo(t) && to(t),
                            Eo(t) && oo(t)
                        }
                    }
                } : Do(e) ? {
                    start: t => {
                        const {origin: o} = t.detail
                          , n = Bt(u(o))
                          , r = De(n, Uu);
                        i = Me(o),
                        ui({
                            ...e,
                            x1: l ? Yi(r.x, Ke.width) : r.x,
                            y1: l ? Yi(r.y, Ke.height) : r.y,
                            x2: l ? Yi(r.x, Ke.width) : r.x,
                            y2: l ? Yi(r.y, Ke.height) : r.y,
                            opacity: 0
                        }, p)
                    }
                    ,
                    update: e => {
                        if (!ci(p))
                            return;
                        const {translation: t} = e.detail
                          , o = u(ze(Me(i), t));
                        if (me.includes(16)) {
                            const e = je(i, o)
                              , t = Ie(i, o)
                              , n = Math.PI / 4
                              , r = n * Math.round(t / n);
                            o.x = i.x + e * Math.cos(r),
                            o.y = i.y + e * Math.sin(r)
                        }
                        const n = Bt(o);
                        hi({
                            x2: l ? Yi(n.x, Ke.width) : n.x,
                            y2: l ? Yi(n.y, Ke.height) : n.y,
                            opacity: 1
                        }, p)
                    }
                    ,
                    release: e => e.detail.preventInertia(),
                    cancel: () => {
                        di(p)
                    }
                    ,
                    end: e => {
                        const t = ci(p);
                        if (!t)
                            return;
                        if (e.detail.isTap)
                            return di(p);
                        t.opacity = 1;
                        const i = pi(p);
                        pt(i),
                        Xo(t) && to(i)
                    }
                } : void 0
            }
            , () => {
                let e, t;
                const i = Wt * Wt
                  , o = (e, t, o=!1) => {
                    const n = He(e, t);
                    if (!o && n < 2)
                        return !1;
                    const r = de.filter((e => !e.disableErase));
                    let a;
                    return a = n < i ? lo(de, Bt(t), Wt) : co(r, Bt(e), Bt(t), Wt),
                    ro(a).forEach(xt),
                    !0
                }
                ;
                return {
                    start: i => {
                        e = Ce(Math.round(i.detail.origin.x), Math.round(i.detail.origin.y)),
                        o(e, e, !0),
                        t = e
                    }
                    ,
                    update: i => {
                        const {translation: n} = i.detail
                          , r = Ce(Math.round(e.x + n.x), Math.round(e.y + n.y));
                        o(t, r) && (t = Me(r))
                    }
                    ,
                    release: e => e.detail.preventInertia(),
                    cancel: () => {
                        di(collection)
                    }
                    ,
                    end: () => {}
                }
            }
            , Li, Di, e => {
                if (!Li())
                    return qo(e),
                    mi(e)
            }
            , zi, Fi, (e={}) => ({
                id: V(),
                ...e
            }), Oi, Bi, Ni, Hi, (e, t, i=!0) => {
                de.forEach((i => Hi(i, e, t, !1))),
                i && Oi()
            }
            , Ui, Vi, qi, Gi, Ji, io, oo, no, ro, ao, so, lo, co, xi, wi, fo, xo, sn, Yn, p, ee, n, Z, Q, Y, G, J, K, te, k, le, ie, re, ne, C, oe, a, r, z, c, F, H, O, L, I, o, E, R, A, m, w, M, h, l, v, f, s, de, he, me, fe, function(t) {
                na.call(this, e, t)
            }
            , e => to(xe[e]), function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    Mn = e,
                    i(8, Mn)
                }
                ))
            }
            , function() {
                N = this.value,
                i(24, N),
                i(11, D),
                i(148, n),
                i(170, L),
                i(0, ve),
                i(184, de)
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    Mn = e,
                    i(8, Mn)
                }
                ))
            }
            , () => {
                ir && ir.focus()
            }
            , e => i(9, Kn = e.detail), function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    ir = e,
                    i(20, ir)
                }
                ))
            }
            , e => Jg(e, Xe)]
        }
        class wy extends Na {
            constructor(e) {
                super(),
                Ba(this, e, xy, yy, ar, {
                    uid: 58,
                    ui: 59,
                    disabled: 0,
                    shapes: 1,
                    selection: 60,
                    offset: 2,
                    contextRotation: 61,
                    contextFlipX: 62,
                    contextFlipY: 63,
                    contextZoom: 64,
                    active: 65,
                    opacity: 66,
                    parentRect: 67,
                    rootRect: 3,
                    utilRect: 68,
                    hoverColor: 69,
                    caretColor: 70,
                    gridColor: 71,
                    snapColor: 72,
                    textInputMode: 4,
                    oninteractionstart: 73,
                    oninteractionupdate: 74,
                    oninteractionrelease: 75,
                    oninteractionend: 76,
                    oninteractioncancel: 77,
                    onaddshape: 78,
                    onupdateshape: 79,
                    onselectshape: 80,
                    onblurshape: 81,
                    onremoveshape: 82,
                    ontapshape: 83,
                    onhovershape: 84,
                    ontriggerhistorywrite: 85,
                    onhovercanvas: 86,
                    ontapcanvas: 87,
                    onleavecanvas: 88,
                    beforeSelectShape: 89,
                    beforeDeselectShape: 90,
                    beforeRemoveShape: 91,
                    beforeUpdateShape: 92,
                    willRenderShapeControls: 93,
                    willRenderShapeTextControls: 94,
                    willStartInteraction: 95,
                    mapEditorPointToImagePoint: 96,
                    mapImagePointToEditorPoint: 97,
                    eraseRadius: 98,
                    selectRadius: 99,
                    enableButtonFlipVertical: 100,
                    enableTapToAddText: 101,
                    enableMultiSelect: 102,
                    enableTextStyleControls: 5,
                    locale: 6,
                    snapThreshold: 103,
                    snapPointer: 104,
                    enableSnapToContext: 105,
                    gridSize: 106,
                    syncShapeCollection: 107,
                    getShapeDraft: 108,
                    addShapeDraft: 109,
                    discardShapeDraft: 110,
                    confirmShapeDraft: 111,
                    updateShapeDraft: 112,
                    addShape: 113,
                    createShape: 114,
                    eraseShape: 115,
                    getMarkupItemDraft: 116,
                    getMarkupItemDraftIndex: 117,
                    addMarkupItemDraft: 118,
                    confirmMarkupItemDraft: 119,
                    discardMarkupItemDraft: 120,
                    createMarkupItem: 121,
                    syncShapes: 122,
                    removeMarkupShapeProps: 123,
                    updateMarkupShape: 124,
                    updateMarkupShapeProperty: 125,
                    updateMarkupItemsShapeProperty: 126,
                    updateMarkupShapeItems: 127,
                    getActiveMarkupItems: 128,
                    getActiveMarkupItem: 129,
                    hasActiveMarkupItem: 130,
                    blurShapes: 131,
                    selectShape: 7,
                    deselectMarkupItem: 132,
                    editMarkupItem: 133,
                    finishEditMarkupItem: 134,
                    removeMarkupItems: 135,
                    getTextShapeRect: 136,
                    getMarkupShapeRect: 137,
                    getShapesNearPosition: 138,
                    getShapesBetweenPoints: 139
                }, null, [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1])
            }
            get syncShapeCollection() {
                return this.$$.ctx[107]
            }
            get getShapeDraft() {
                return this.$$.ctx[108]
            }
            get addShapeDraft() {
                return this.$$.ctx[109]
            }
            get discardShapeDraft() {
                return this.$$.ctx[110]
            }
            get confirmShapeDraft() {
                return this.$$.ctx[111]
            }
            get updateShapeDraft() {
                return this.$$.ctx[112]
            }
            get addShape() {
                return this.$$.ctx[113]
            }
            get createShape() {
                return this.$$.ctx[114]
            }
            get eraseShape() {
                return this.$$.ctx[115]
            }
            get getMarkupItemDraft() {
                return this.$$.ctx[116]
            }
            get getMarkupItemDraftIndex() {
                return this.$$.ctx[117]
            }
            get addMarkupItemDraft() {
                return this.$$.ctx[118]
            }
            get confirmMarkupItemDraft() {
                return this.$$.ctx[119]
            }
            get discardMarkupItemDraft() {
                return this.$$.ctx[120]
            }
            get createMarkupItem() {
                return this.$$.ctx[121]
            }
            get syncShapes() {
                return this.$$.ctx[122]
            }
            get removeMarkupShapeProps() {
                return this.$$.ctx[123]
            }
            get updateMarkupShape() {
                return this.$$.ctx[124]
            }
            get updateMarkupShapeProperty() {
                return this.$$.ctx[125]
            }
            get updateMarkupItemsShapeProperty() {
                return this.$$.ctx[126]
            }
            get updateMarkupShapeItems() {
                return this.$$.ctx[127]
            }
            get getActiveMarkupItems() {
                return this.$$.ctx[128]
            }
            get getActiveMarkupItem() {
                return this.$$.ctx[129]
            }
            get hasActiveMarkupItem() {
                return this.$$.ctx[130]
            }
            get blurShapes() {
                return this.$$.ctx[131]
            }
            get selectShape() {
                return this.$$.ctx[7]
            }
            get deselectMarkupItem() {
                return this.$$.ctx[132]
            }
            get editMarkupItem() {
                return this.$$.ctx[133]
            }
            get finishEditMarkupItem() {
                return this.$$.ctx[134]
            }
            get removeMarkupItems() {
                return this.$$.ctx[135]
            }
            get getTextShapeRect() {
                return this.$$.ctx[136]
            }
            get getMarkupShapeRect() {
                return this.$$.ctx[137]
            }
            get getShapesNearPosition() {
                return this.$$.ctx[138]
            }
            get getShapesBetweenPoints() {
                return this.$$.ctx[139]
            }
        }
        function Sy(e) {
            let t, i, o;
            return i = new yh({
                props: {
                    items: e[2]
                }
            }),
            {
                c() {
                    t = Er("ul"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaShapeStyleList")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    4 & t && (o.items = e[2]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function _y(e) {
            let t, i;
            return t = new Su({
                props: {
                    class: "PinturaShapeStyles",
                    elasticity: e[0],
                    $$slots: {
                        default: [ky]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1 & i && (o.elasticity = e[0]),
                    131076 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function ky(e) {
            let t, i, o;
            return i = new yh({
                props: {
                    items: e[2]
                }
            }),
            {
                c() {
                    t = Er("ul"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaShapeStyleList")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    4 & t && (o.items = e[2]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function Cy(e) {
            let t, i, o, n;
            const r = [_y, Sy]
              , a = [];
            function s(e, t) {
                return e[1] ? 0 : 1
            }
            return i = s(e),
            o = a[i] = r[i](e),
            {
                c() {
                    t = Er("div"),
                    o.c(),
                    Or(t, "style", e[3])
                },
                m(e, o) {
                    Mr(e, t, o),
                    a[i].m(t, null),
                    n = !0
                },
                p(e, [l]) {
                    let c = i;
                    i = s(e),
                    i === c ? a[i].p(e, l) : (Sa(),
                    Ca(a[c], 1, 1, ( () => {
                        a[c] = null
                    }
                    )),
                    _a(),
                    o = a[i],
                    o ? o.p(e, l) : (o = a[i] = r[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(t, null)),
                    (!n || 8 & l) && Or(t, "style", e[3])
                },
                i(e) {
                    n || (ka(o),
                    n = !0)
                },
                o(e) {
                    Ca(o),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    a[i].d()
                }
            }
        }
        function Ty(e, t, i) {
            let o, n, r, a, s, l, {isActive: c=!1} = t, {controls: u=[]} = t, {locale: d} = t, {scrollElasticity: p} = t, {scrollEnable: h=!0} = t, {hideTitles: m=!1} = t, {willRenderControls: f=se} = t;
            const g = oa("redrawTrigger");
            cr(e, g, (e => i(14, a = e)));
            const y = oa("env");
            cr(e, y, (e => i(13, r = e)));
            const $ = oa("isAnimated");
            cr(e, $, (e => i(16, l = e)));
            const b = ic(0, {
                stiffness: .25,
                damping: .9
            });
            return cr(e, b, (e => i(15, s = e))),
            e.$$set = e => {
                "isActive"in e && i(8, c = e.isActive),
                "controls"in e && i(9, u = e.controls),
                "locale"in e && i(10, d = e.locale),
                "scrollElasticity"in e && i(0, p = e.scrollElasticity),
                "scrollEnable"in e && i(1, h = e.scrollEnable),
                "hideTitles"in e && i(11, m = e.hideTitles),
                "willRenderControls"in e && i(12, f = e.willRenderControls)
            }
            ,
            e.$$.update = () => {
                65792 & e.$$.dirty && b.set(c ? 1 : 0, {
                    hard: !1 === l
                }),
                33024 & e.$$.dirty && i(3, o = `opacity:${s};${c ? "" : "pointer-events:none;"}${s <= 0 ? "visibility:hidden" : ""}`),
                32256 & e.$$.dirty && i(2, n = a && f(u.map((e => ["ShapeStyle", e.id, {
                    title: e.componentProps.title,
                    locale: d,
                    hideTitle: m,
                    items: [[e.component, e.id, e.componentProps]]
                }])), r, ( () => g.set({}))))
            }
            ,
            [p, h, n, o, g, y, $, b, c, u, d, m, f, r, a, s, l]
        }
        class My extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Ty, Cy, ar, {
                    isActive: 8,
                    controls: 9,
                    locale: 10,
                    scrollElasticity: 0,
                    scrollEnable: 1,
                    hideTitles: 11,
                    willRenderControls: 12
                })
            }
        }
        function Py(e, t, i) {
            const o = e.slice();
            return o[15] = t[i].key,
            o[6] = t[i].controls,
            o[16] = t[i].isActive,
            o
        }
        function Ey(e, t) {
            let i, o, n;
            return o = new My({
                props: {
                    isActive: t[16],
                    controls: t[6],
                    locale: t[1],
                    scrollElasticity: t[2],
                    scrollEnable: t[3],
                    hideTitles: t[4],
                    willRenderControls: t[5]
                }
            }),
            {
                key: e,
                first: null,
                c() {
                    i = Lr(),
                    za(o.$$.fragment),
                    this.first = i
                },
                m(e, t) {
                    Mr(e, i, t),
                    Fa(o, e, t),
                    n = !0
                },
                p(e, i) {
                    t = e;
                    const n = {};
                    128 & i && (n.isActive = t[16]),
                    128 & i && (n.controls = t[6]),
                    2 & i && (n.locale = t[1]),
                    4 & i && (n.scrollElasticity = t[2]),
                    8 & i && (n.scrollEnable = t[3]),
                    16 & i && (n.hideTitles = t[4]),
                    32 & i && (n.willRenderControls = t[5]),
                    o.$set(n)
                },
                i(e) {
                    n || (ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(i),
                    Oa(o, e)
                }
            }
        }
        function Ry(e) {
            let t, i, o, n = [], r = new Map, a = e[7];
            const s = e => e[15];
            for (let t = 0; t < a.length; t += 1) {
                let i = Py(e, a, t)
                  , o = s(i);
                r.set(o, n[t] = Ey(o, i))
            }
            return {
                c() {
                    t = Er("div");
                    for (let e = 0; e < n.length; e += 1)
                        n[e].c();
                    Or(t, "class", i = Pc(["PinturaShapeStyleEditor", !e[3] && "PinturaShapeStyleEditorOverflow", e[0]]))
                },
                m(e, i) {
                    Mr(e, t, i);
                    for (let e = 0; e < n.length; e += 1)
                        n[e].m(t, null);
                    o = !0
                },
                p(e, [l]) {
                    190 & l && (a = e[7],
                    Sa(),
                    n = Aa(n, l, s, 1, e, a, r, t, Ra, Ey, null, Py),
                    _a()),
                    (!o || 9 & l && i !== (i = Pc(["PinturaShapeStyleEditor", !e[3] && "PinturaShapeStyleEditorOverflow", e[0]]))) && Or(t, "class", i)
                },
                i(e) {
                    if (!o) {
                        for (let e = 0; e < a.length; e += 1)
                            ka(n[e]);
                        o = !0
                    }
                },
                o(e) {
                    for (let e = 0; e < n.length; e += 1)
                        Ca(n[e]);
                    o = !1
                },
                d(e) {
                    e && Pr(t);
                    for (let e = 0; e < n.length; e += 1)
                        n[e].d()
                }
            }
        }
        function Ay(e, t, i) {
            let o, n, r, {class: a} = t, {controls: s={}} = t, {shapeProps: l} = t, {onchange: c} = t, {locale: u} = t, {scrollElasticity: d} = t, {scrollEnable: p=!0} = t, {hideTitles: h=!1} = t, {willRenderControls: m} = t;
            const f = [];
            return e.$$set = e => {
                "class"in e && i(0, a = e.class),
                "controls"in e && i(6, s = e.controls),
                "shapeProps"in e && i(8, l = e.shapeProps),
                "onchange"in e && i(9, c = e.onchange),
                "locale"in e && i(1, u = e.locale),
                "scrollElasticity"in e && i(2, d = e.scrollElasticity),
                "scrollEnable"in e && i(3, p = e.scrollEnable),
                "hideTitles"in e && i(4, h = e.hideTitles),
                "willRenderControls"in e && i(5, m = e.willRenderControls)
            }
            ,
            e.$$.update = () => {
                64 & e.$$.dirty && i(11, o = Object.keys(s).filter((e => s[e]))),
                2304 & e.$$.dirty && i(10, n = l && Object.keys(l).length && o && Ko(l) ? (e => {
                    const t = o.filter((t => t.split("_").every((t => ji(e, t) && Ko(e, t))))).map((t => {
                        const i = (e.settings && e.settings[t] || {}).control || t
                          , o = t.split("_")
                          , n = o.length > 1 ? o.map((t => e[t])) : e[t];
                        if (H(s[i])) {
                            const {title: o, component: r} = s[i](n, (e => {
                                c({
                                    [t]: e
                                })
                            }
                            ), {
                                selectedShapeId: e.id
                            });
                            return {
                                id: i,
                                component: yh,
                                componentProps: {
                                    title: o,
                                    items: r
                                }
                            }
                        }
                        let[r,a] = s[i];
                        if (W(r) && s[r]) {
                            const e = {
                                ...a
                            };
                            [r,a] = s[r],
                            a = {
                                ...a,
                                ...e
                            }
                        }
                        const l = H(a.options) ? a.options(e) : a.options;
                        return "RadioGroup" === r && (a.selectedIndex = -1),
                        {
                            id: i,
                            component: r,
                            componentProps: {
                                ...a,
                                options: l,
                                locale: u,
                                value: n,
                                optionLabelClass: "PinturaButtonLabel",
                                onchange: i => {
                                    const n = O(i) && !Ui(i) ? i.value : i;
                                    a.onchange && a.onchange(n, e);
                                    const r = o.length > 1 ? o.reduce(( (e, t, i) => ({
                                        ...e,
                                        [t]: Array.isArray(n) ? n[i] : n
                                    })), {}) : {
                                        [t]: n
                                    };
                                    c(r)
                                }
                            }
                        }
                    }
                    )).filter(Boolean);
                    return t
                }
                )(l) : []),
                1280 & e.$$.dirty && i(7, r = ( (e, t) => {
                    let i = f.find((t => t.key === e));
                    return i || (i = {
                        key: e,
                        controls: t
                    },
                    f.push(i)),
                    f.forEach((e => e.isActive = !1)),
                    i.controls = t,
                    i.isActive = !0,
                    f
                }
                )(l && Object.keys(l).length ? Object.keys(l).join("_") : "none", n || []))
            }
            ,
            [a, u, d, p, h, m, s, r, l, c, n, o]
        }
        class Iy extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Ay, Ry, ar, {
                    class: 0,
                    controls: 6,
                    shapeProps: 8,
                    onchange: 9,
                    locale: 1,
                    scrollElasticity: 2,
                    scrollEnable: 3,
                    hideTitles: 4,
                    willRenderControls: 5
                })
            }
        }
        var Ly = e => /<svg /.test(e);
        function Dy(e) {
            let t, i;
            return t = new yh({
                props: {
                    items: e[10]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1024 & i && (o.items = e[10]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function zy(e) {
            let t, i, o, n;
            const r = [Oy, Fy]
              , a = [];
            function s(e, t) {
                return e[8] ? 0 : 1
            }
            return t = s(e),
            i = a[t] = r[t](e),
            {
                c() {
                    i.c(),
                    o = Lr()
                },
                m(e, i) {
                    a[t].m(e, i),
                    Mr(e, o, i),
                    n = !0
                },
                p(e, n) {
                    let l = t;
                    t = s(e),
                    t === l ? a[t].p(e, n) : (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a(),
                    i = a[t],
                    i ? i.p(e, n) : (i = a[t] = r[t](e),
                    i.c()),
                    ka(i, 1),
                    i.m(o.parentNode, o))
                },
                i(e) {
                    n || (ka(i),
                    n = !0)
                },
                o(e) {
                    Ca(i),
                    n = !1
                },
                d(e) {
                    a[t].d(e),
                    e && Pr(o)
                }
            }
        }
        function Fy(e) {
            let t, i, o, n, r = e[10] && By(e);
            return o = new Su({
                props: {
                    scrollAutoCancel: e[9],
                    elasticity: e[0],
                    $$slots: {
                        default: [Ny]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    r && r.c(),
                    i = Ir(),
                    za(o.$$.fragment),
                    Or(t, "class", "PinturaShapePresetsFlat")
                },
                m(e, a) {
                    Mr(e, t, a),
                    r && r.m(t, null),
                    kr(t, i),
                    Fa(o, t, null),
                    n = !0
                },
                p(e, n) {
                    e[10] ? r ? (r.p(e, n),
                    1024 & n && ka(r, 1)) : (r = By(e),
                    r.c(),
                    ka(r, 1),
                    r.m(t, i)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a());
                    const a = {};
                    512 & n && (a.scrollAutoCancel = e[9]),
                    1 & n && (a.elasticity = e[0]),
                    536871070 & n && (a.$$scope = {
                        dirty: n,
                        ctx: e
                    }),
                    o.$set(a)
                },
                i(e) {
                    n || (ka(r),
                    ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(r),
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    r && r.d(),
                    Oa(o)
                }
            }
        }
        function Oy(e) {
            let t, i, o, n, r;
            i = new Su({
                props: {
                    elasticity: e[0],
                    class: "PinturaShapePresetsGroups",
                    $$slots: {
                        default: [qy]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            });
            const a = [{
                class: "PinturaControlPanels"
            }, {
                panelClass: "PinturaControlPanel"
            }, {
                panels: e[11]
            }, e[12]];
            let s = {
                $$slots: {
                    default: [Ky, ({panel: e, panelIsActive: t}) => ({
                        26: e,
                        27: t
                    }), ({panel: e, panelIsActive: t}) => (e ? 67108864 : 0) | (t ? 134217728 : 0)]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < a.length; e += 1)
                s = tr(s, a[e]);
            return n = new Xc({
                props: s
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    o = Ir(),
                    za(n.$$.fragment),
                    Or(t, "class", "PinturaShapePresetsGrouped")
                },
                m(e, a) {
                    Mr(e, t, a),
                    Fa(i, t, null),
                    kr(t, o),
                    Fa(n, t, null),
                    r = !0
                },
                p(e, t) {
                    const o = {};
                    1 & t && (o.elasticity = e[0]),
                    536876128 & t && (o.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    i.$set(o);
                    const r = 6144 & t ? Ia(a, [a[0], a[1], 2048 & t && {
                        panels: e[11]
                    }, 4096 & t && La(e[12])]) : {};
                    738206239 & t && (r.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    n.$set(r)
                },
                i(e) {
                    r || (ka(i.$$.fragment, e),
                    ka(n.$$.fragment, e),
                    r = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    Ca(n.$$.fragment, e),
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    Oa(n)
                }
            }
        }
        function By(e) {
            let t, i;
            return t = new yh({
                props: {
                    items: e[10]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1024 & i && (o.items = e[10]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Ny(e) {
            let t, i;
            return t = new Wu({
                props: {
                    items: e[7],
                    onclickitem: e[1],
                    ongrabitem: e[2],
                    ondragitem: e[3],
                    ondropitem: e[4]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    128 & i && (o.items = e[7]),
                    2 & i && (o.onclickitem = e[1]),
                    4 & i && (o.ongrabitem = e[2]),
                    8 & i && (o.ondragitem = e[3]),
                    16 & i && (o.ondropitem = e[4]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Wy(e) {
            let t, i;
            return t = new yh({
                props: {
                    items: e[10]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1024 & i && (o.items = e[10]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Hy(e) {
            let t, i;
            return t = new ou({
                props: {
                    $$slots: {
                        default: [jy]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    805306368 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function jy(e) {
            let t, i = e[28].icon + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    268435456 & o && i !== (i = e[28].icon + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Uy(e) {
            let t, i, o = e[28].label + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o)
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    268435456 & t && o !== (o = e[28].label + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Vy(e) {
            let t, i, o, n = e[28].icon && Hy(e), r = !e[28].hideLabel && Uy(e);
            return {
                c() {
                    n && n.c(),
                    t = Ir(),
                    r && r.c(),
                    i = Lr()
                },
                m(e, a) {
                    n && n.m(e, a),
                    Mr(e, t, a),
                    r && r.m(e, a),
                    Mr(e, i, a),
                    o = !0
                },
                p(e, o) {
                    e[28].icon ? n ? (n.p(e, o),
                    268435456 & o && ka(n, 1)) : (n = Hy(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[28].hideLabel ? r && (r.d(1),
                    r = null) : r ? r.p(e, o) : (r = Uy(e),
                    r.c(),
                    r.m(i.parentNode, i))
                },
                i(e) {
                    o || (ka(n),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    r && r.d(e),
                    e && Pr(i)
                }
            }
        }
        function qy(e) {
            let t, i, o, n = e[10] && Wy(e);
            const r = [{
                class: "PinturaControlList"
            }, {
                tabs: e[5]
            }, e[12], {
                layout: "compact"
            }];
            let a = {
                $$slots: {
                    default: [Vy, ({tab: e}) => ({
                        28: e
                    }), ({tab: e}) => e ? 268435456 : 0]
                },
                $$scope: {
                    ctx: e
                }
            };
            for (let e = 0; e < r.length; e += 1)
                a = tr(a, r[e]);
            return i = new Fc({
                props: a
            }),
            i.$on("select", e[18]),
            {
                c() {
                    n && n.c(),
                    t = Ir(),
                    za(i.$$.fragment)
                },
                m(e, r) {
                    n && n.m(e, r),
                    Mr(e, t, r),
                    Fa(i, e, r),
                    o = !0
                },
                p(e, o) {
                    e[10] ? n ? (n.p(e, o),
                    1024 & o && ka(n, 1)) : (n = Wy(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a());
                    const a = 4128 & o ? Ia(r, [r[0], 32 & o && {
                        tabs: e[5]
                    }, 4096 & o && La(e[12]), r[3]]) : {};
                    805306368 & o && (a.$$scope = {
                        dirty: o,
                        ctx: e
                    }),
                    i.$set(a)
                },
                i(e) {
                    o || (ka(n),
                    ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    Oa(i, e)
                }
            }
        }
        function Gy(e) {
            let t, i;
            return t = new Wu({
                props: {
                    items: e[13][e[26]].items,
                    disabled: e[13][e[26]].disabled,
                    onclickitem: e[1],
                    ongrabitem: e[2],
                    ondragitem: e[3],
                    ondropitem: e[4]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    67117056 & i && (o.items = e[13][e[26]].items),
                    67117056 & i && (o.disabled = e[13][e[26]].disabled),
                    2 & i && (o.onclickitem = e[1]),
                    4 & i && (o.ongrabitem = e[2]),
                    8 & i && (o.ondragitem = e[3]),
                    16 & i && (o.ondropitem = e[4]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Ky(e) {
            let t, i;
            return t = new Su({
                props: {
                    scroll: e[27] ? {
                        scrollOffset: 0,
                        animate: !1
                    } : void 0,
                    scrollAutoCancel: e[9],
                    elasticity: e[0],
                    $$slots: {
                        default: [Gy]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    134217728 & i && (o.scroll = e[27] ? {
                        scrollOffset: 0,
                        animate: !1
                    } : void 0),
                    512 & i && (o.scrollAutoCancel = e[9]),
                    1 & i && (o.elasticity = e[0]),
                    603987998 & i && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Xy(e) {
            let t, i, o, n;
            const r = [zy, Dy]
              , a = [];
            function s(e, t) {
                return e[9] ? 0 : e[10] ? 1 : -1
            }
            return ~(i = s(e)) && (o = a[i] = r[i](e)),
            {
                c() {
                    t = Er("div"),
                    o && o.c(),
                    Or(t, "class", "PinturaShapePresetsPalette")
                },
                m(e, o) {
                    Mr(e, t, o),
                    ~i && a[i].m(t, null),
                    n = !0
                },
                p(e, [n]) {
                    let l = i;
                    i = s(e),
                    i === l ? ~i && a[i].p(e, n) : (o && (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a()),
                    ~i ? (o = a[i],
                    o ? o.p(e, n) : (o = a[i] = r[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(t, null)) : o = null)
                },
                i(e) {
                    n || (ka(o),
                    n = !0)
                },
                o(e) {
                    Ca(o),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    ~i && a[i].d()
                }
            }
        }
        function Zy(e, t, i) {
            let o, n, r, a, s, l, c, u, d, {locale: p} = t, {presets: h} = t, {scrollElasticity: m} = t, {enableSelectImage: f=!0} = t, {willRenderPresetToolbar: g=se} = t, {onaddpreset: y=$} = t, {ongrabpreset: b} = t, {ondragpreset: v} = t, {ondroppreset: x} = t;
            const w = `presets-${V()}`
              , S = (e, t="") => Ly(e) ? e : Hi(e) ? Xi(e, t) : `<img src="${e}" alt="${t}"/>`
              , _ = e => ie(ti(e))
              , k = ["src", "alt", "thumb", "shape", "id", "mount", "disabled"]
              , C = e => e.map((e => (e => Ui(e) && W(e[0]) && Ui(e[1]))(e) ? {
                ...e[2],
                id: `${w}-${e[0].toLowerCase()}`,
                label: e[0],
                items: C(e[1])
            } : (e => {
                let t, i, o, n, r, a, s, l = e;
                return W(e) ? Hi(e) ? (t = e,
                r = e,
                n = S(t, r)) : (t = e,
                r = _(t),
                n = S(t, r)) : (t = e.src,
                r = e.alt || (W(t) ? _(t) : W(e.thumb) ? _(e.thumb) : void 0),
                n = S(e.thumb || t, r),
                i = e.shape,
                a = e.mount,
                s = e.disabled,
                o = Object.keys(e).reduce(( (t, i) => (k.includes(i) || (t[i] = e[i]),
                t)), {})),
                {
                    id: l,
                    src: t,
                    thumb: n,
                    shape: i,
                    shapeProps: o,
                    alt: r,
                    title: r,
                    mount: a,
                    disabled: s
                }
            }
            )(e)));
            return e.$$set = e => {
                "locale"in e && i(14, p = e.locale),
                "presets"in e && i(15, h = e.presets),
                "scrollElasticity"in e && i(0, m = e.scrollElasticity),
                "enableSelectImage"in e && i(16, f = e.enableSelectImage),
                "willRenderPresetToolbar"in e && i(17, g = e.willRenderPresetToolbar),
                "onaddpreset"in e && i(1, y = e.onaddpreset),
                "ongrabpreset"in e && i(2, b = e.ongrabpreset),
                "ondragpreset"in e && i(3, v = e.ondragpreset),
                "ondroppreset"in e && i(4, x = e.ondroppreset)
            }
            ,
            e.$$.update = () => {
                32768 & e.$$.dirty && i(7, o = C(h)),
                128 & e.$$.dirty && i(9, n = o.length),
                640 & e.$$.dirty && i(8, r = n && o.some((e => !!e.items))),
                384 & e.$$.dirty && i(5, a = r && o),
                384 & e.$$.dirty && i(13, s = r && o.reduce(( (e, t) => (e[t.id] = t,
                e)), {})),
                96 & e.$$.dirty && i(6, l = l || a && (a.find((e => !e.disabled)) || {}).id),
                64 & e.$$.dirty && i(12, c = {
                    name: w,
                    selected: l
                }),
                32 & e.$$.dirty && i(11, u = a && a.map((e => e.id))),
                212994 & e.$$.dirty && i(10, d = p && g([f && ["Button", "browse", {
                    label: p.shapeLabelButtonSelectSticker,
                    icon: p.shapeIconButtonSelectSticker,
                    onclick: () => {
                        Oh().then((e => {
                            e && y(e)
                        }
                        ))
                    }
                }]]))
            }
            ,
            [m, y, b, v, x, a, l, o, r, n, d, u, c, s, p, h, f, g, ({detail: e}) => i(6, l = e)]
        }
        class Yy extends Na {
            constructor(e) {
                super(),
                Ba(this, e, Zy, Xy, ar, {
                    locale: 14,
                    presets: 15,
                    scrollElasticity: 0,
                    enableSelectImage: 16,
                    willRenderPresetToolbar: 17,
                    onaddpreset: 1,
                    ongrabpreset: 2,
                    ondragpreset: 3,
                    ondroppreset: 4
                })
            }
        }
        function Qy(e) {
            let t, i, o, n;
            return t = new yh({
                props: {
                    items: e[30]
                }
            }),
            o = new Iy({
                props: {
                    locale: e[4],
                    shapeProps: e[49],
                    onchange: e[85],
                    controls: e[9],
                    scrollEnable: !1,
                    hideTitles: !0,
                    willRenderControls: e[165]
                }
            }),
            {
                c() {
                    za(t.$$.fragment),
                    i = Ir(),
                    za(o.$$.fragment)
                },
                m(e, r) {
                    Fa(t, e, r),
                    Mr(e, i, r),
                    Fa(o, e, r),
                    n = !0
                },
                p(e, i) {
                    const n = {};
                    1073741824 & i[0] && (n.items = e[30]),
                    t.$set(n);
                    const r = {};
                    16 & i[0] && (r.locale = e[4]),
                    262144 & i[1] && (r.shapeProps = e[49]),
                    512 & i[0] && (r.controls = e[9]),
                    o.$set(r)
                },
                i(e) {
                    n || (ka(t.$$.fragment, e),
                    ka(o.$$.fragment, e),
                    n = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    Ca(o.$$.fragment, e),
                    n = !1
                },
                d(e) {
                    Oa(t, e),
                    e && Pr(i),
                    Oa(o, e)
                }
            }
        }
        function Jy(e) {
            let t, i, o;
            return i = new vf({
                props: {
                    $$slots: {
                        default: [Qy]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "slot", "header")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    1073742352 & t[0] | 262144 & t[1] | 67108864 & t[6] && (o.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function e$(e) {
            let t, i;
            const o = [{
                locale: e[4]
            }, {
                ui: e[69]
            }, {
                shapes: e[5]
            }, {
                selection: e[58]
            }, {
                uid: e[20]
            }, {
                parentRect: e[37]
            }, {
                rootRect: e[55]
            }, {
                utilRect: e[39]
            }, {
                offset: e[50]
            }, {
                disabled: e[38]
            }, {
                contextRotation: e[23]
            }, {
                contextFlipX: e[24]
            }, {
                contextFlipY: e[25]
            }, {
                contextZoom: e[36] ? e[36].scale : void 0
            }, {
                active: e[35]
            }, {
                opacity: e[56]
            }, {
                hoverColor: e[57]
            }, {
                caretColor: e[57]
            }, {
                snapColor: e[57]
            }, {
                gridColor: [1, 1, 1, .125]
            }, {
                eraseRadius: e[47]
            }, {
                selectRadius: e[6]
            }, {
                enableButtonFlipVertical: e[10]
            }, {
                enableMultiSelect: e[14]
            }, {
                mapEditorPointToImagePoint: e[21]
            }, {
                mapImagePointToEditorPoint: e[22]
            }, {
                enableTapToAddText: e[13]
            }, {
                textInputMode: e[8]
            }, {
                snapThreshold: e[16]
            }, {
                snapPointer: !e[48]
            }, {
                enableSnapToContext: e[17]
            }, {
                gridSize: e[15]
            }, {
                willStartInteraction: e[95]
            }, {
                oninteractionstart: e[79]
            }, {
                oninteractionupdate: e[80]
            }, {
                oninteractionrelease: e[81]
            }, {
                oninteractionend: e[83]
            }, {
                oninteractioncancel: e[82]
            }, {
                onleavecanvas: e[87]
            }, {
                onhovercanvas: e[86]
            }, {
                onhovershape: e[89]
            }, {
                ontapcanvas: e[88]
            }, {
                onaddshape: e[156]
            }, {
                onselectshape: e[157]
            }, {
                onblurshape: e[158]
            }, {
                ontapshape: e[159]
            }, {
                onupdateshape: e[160]
            }, {
                onremoveshape: e[161]
            }, {
                ontriggerhistorywrite: e[162]
            }, e[42]];
            let n = {};
            for (let e = 0; e < o.length; e += 1)
                n = tr(n, o[e]);
            return t = new wy({
                props: n
            }),
            e[163](t),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const n = 66315632 & i[0] | 252381681 & i[1] | 255721600 & i[2] | 12 & i[3] ? Ia(o, [16 & i[0] && {
                        locale: e[4]
                    }, 128 & i[2] && {
                        ui: e[69]
                    }, 32 & i[0] && {
                        shapes: e[5]
                    }, 134217728 & i[1] && {
                        selection: e[58]
                    }, 1048576 & i[0] && {
                        uid: e[20]
                    }, 64 & i[1] && {
                        parentRect: e[37]
                    }, 16777216 & i[1] && {
                        rootRect: e[55]
                    }, 256 & i[1] && {
                        utilRect: e[39]
                    }, 524288 & i[1] && {
                        offset: e[50]
                    }, 128 & i[1] && {
                        disabled: e[38]
                    }, 8388608 & i[0] && {
                        contextRotation: e[23]
                    }, 16777216 & i[0] && {
                        contextFlipX: e[24]
                    }, 33554432 & i[0] && {
                        contextFlipY: e[25]
                    }, 32 & i[1] && {
                        contextZoom: e[36] ? e[36].scale : void 0
                    }, 16 & i[1] && {
                        active: e[35]
                    }, 33554432 & i[1] && {
                        opacity: e[56]
                    }, 67108864 & i[1] && {
                        hoverColor: e[57]
                    }, 67108864 & i[1] && {
                        caretColor: e[57]
                    }, 67108864 & i[1] && {
                        snapColor: e[57]
                    }, o[19], 65536 & i[1] && {
                        eraseRadius: e[47]
                    }, 64 & i[0] && {
                        selectRadius: e[6]
                    }, 1024 & i[0] && {
                        enableButtonFlipVertical: e[10]
                    }, 16384 & i[0] && {
                        enableMultiSelect: e[14]
                    }, 2097152 & i[0] && {
                        mapEditorPointToImagePoint: e[21]
                    }, 4194304 & i[0] && {
                        mapImagePointToEditorPoint: e[22]
                    }, 8192 & i[0] && {
                        enableTapToAddText: e[13]
                    }, 256 & i[0] && {
                        textInputMode: e[8]
                    }, 65536 & i[0] && {
                        snapThreshold: e[16]
                    }, 131072 & i[1] && {
                        snapPointer: !e[48]
                    }, 131072 & i[0] && {
                        enableSnapToContext: e[17]
                    }, 32768 & i[0] && {
                        gridSize: e[15]
                    }, 4 & i[3] && {
                        willStartInteraction: e[95]
                    }, 131072 & i[2] && {
                        oninteractionstart: e[79]
                    }, 262144 & i[2] && {
                        oninteractionupdate: e[80]
                    }, 524288 & i[2] && {
                        oninteractionrelease: e[81]
                    }, 2097152 & i[2] && {
                        oninteractionend: e[83]
                    }, 1048576 & i[2] && {
                        oninteractioncancel: e[82]
                    }, 33554432 & i[2] && {
                        onleavecanvas: e[87]
                    }, 16777216 & i[2] && {
                        onhovercanvas: e[86]
                    }, 134217728 & i[2] && {
                        onhovershape: e[89]
                    }, 67108864 & i[2] && {
                        ontapcanvas: e[88]
                    }, 1 & i[1] | 8 & i[3] && {
                        onaddshape: e[156]
                    }, 1 & i[1] && {
                        onselectshape: e[157]
                    }, 1 & i[1] && {
                        onblurshape: e[158]
                    }, 1 & i[1] && {
                        ontapshape: e[159]
                    }, 1 & i[1] | 8 & i[3] && {
                        onupdateshape: e[160]
                    }, 1 & i[1] | 8 & i[3] && {
                        onremoveshape: e[161]
                    }, 8 & i[3] && {
                        ontriggerhistorywrite: e[162]
                    }, 2048 & i[1] && La(e[42])]) : {};
                    t.$set(n)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(i) {
                    e[163](null),
                    Oa(t, i)
                }
            }
        }
        function t$(e) {
            let t, i, o, n, r, a = e[51] && e$(e);
            return {
                c() {
                    t = Er("div"),
                    a && a.c(),
                    Or(t, "slot", "main"),
                    Or(t, "style", i = `cursor:${e[46]}`)
                },
                m(i, s) {
                    Mr(i, t, s),
                    a && a.m(t, null),
                    e[164](t),
                    o = !0,
                    n || (r = [Dr(t, "keydown", e[84]), $r(xc.call(null, t)), Dr(t, "dropfiles", (function() {
                        rr(e[12] ? e[94] : $) && (e[12] ? e[94] : $).apply(this, arguments)
                    }
                    )), $r($c.call(null, t)), Dr(t, "measure", e[152])],
                    n = !0)
                },
                p(n, r) {
                    (e = n)[51] ? a ? (a.p(e, r),
                    1048576 & r[1] && ka(a, 1)) : (a = e$(e),
                    a.c(),
                    ka(a, 1),
                    a.m(t, null)) : a && (Sa(),
                    Ca(a, 1, 1, ( () => {
                        a = null
                    }
                    )),
                    _a()),
                    (!o || 32768 & r[1] && i !== (i = `cursor:${e[46]}`)) && Or(t, "style", i)
                },
                i(e) {
                    o || (ka(a),
                    o = !0)
                },
                o(e) {
                    Ca(a),
                    o = !1
                },
                d(i) {
                    i && Pr(t),
                    a && a.d(),
                    e[164](null),
                    n = !1,
                    nr(r)
                }
            }
        }
        function i$(e) {
            let t, i;
            return t = new Yy({
                props: {
                    locale: e[4],
                    presets: e[19],
                    enableSelectImage: e[11],
                    willRenderPresetToolbar: e[43],
                    onaddpreset: e[93],
                    ongrabpreset: e[90],
                    ondragpreset: e[91],
                    ondroppreset: e[92],
                    scrollElasticity: e[44]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] && (o.locale = e[4]),
                    524288 & i[0] && (o.presets = e[19]),
                    2048 & i[0] && (o.enableSelectImage = e[11]),
                    4096 & i[1] && (o.willRenderPresetToolbar = e[43]),
                    8192 & i[1] && (o.scrollElasticity = e[44]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function o$(e) {
            let t, i, o, n = "stack" === e[7] && n$(e), r = (e[53] && e[34] || "row" === e[7]) && s$(e);
            return {
                c() {
                    n && n.c(),
                    t = Ir(),
                    r && r.c(),
                    i = Lr()
                },
                m(e, a) {
                    n && n.m(e, a),
                    Mr(e, t, a),
                    r && r.m(e, a),
                    Mr(e, i, a),
                    o = !0
                },
                p(e, o) {
                    "stack" === e[7] ? n ? (n.p(e, o),
                    128 & o[0] && ka(n, 1)) : (n = n$(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[53] && e[34] || "row" === e[7] ? r ? (r.p(e, o),
                    128 & o[0] | 4194312 & o[1] && ka(r, 1)) : (r = s$(e),
                    r.c(),
                    ka(r, 1),
                    r.m(i.parentNode, i)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    o || (ka(n),
                    ka(r),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(r),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    r && r.d(e),
                    e && Pr(i)
                }
            }
        }
        function n$(e) {
            let t, i, o, n;
            const r = [a$, r$]
              , a = [];
            function s(e, t) {
                return e[45] ? 0 : 1
            }
            return i = s(e),
            o = a[i] = r[i](e),
            {
                c() {
                    t = Er("div"),
                    o.c(),
                    Or(t, "class", "PinturaControlPanels")
                },
                m(e, o) {
                    Mr(e, t, o),
                    a[i].m(t, null),
                    n = !0
                },
                p(e, n) {
                    let l = i;
                    i = s(e),
                    i === l ? a[i].p(e, n) : (Sa(),
                    Ca(a[l], 1, 1, ( () => {
                        a[l] = null
                    }
                    )),
                    _a(),
                    o = a[i],
                    o ? o.p(e, n) : (o = a[i] = r[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(t, null))
                },
                i(e) {
                    n || (ka(o),
                    n = !0)
                },
                o(e) {
                    Ca(o),
                    n = !1
                },
                d(e) {
                    e && Pr(t),
                    a[i].d()
                }
            }
        }
        function r$(e) {
            let t, i, o;
            return i = new Iy({
                props: {
                    locale: e[4],
                    shapeProps: e[49],
                    onchange: e[85],
                    controls: e[9],
                    scrollElasticity: e[44],
                    willRenderControls: e[18]
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaControlPanel")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    16 & t[0] && (o.locale = e[4]),
                    262144 & t[1] && (o.shapeProps = e[49]),
                    512 & t[0] && (o.controls = e[9]),
                    8192 & t[1] && (o.scrollElasticity = e[44]),
                    262144 & t[0] && (o.willRenderControls = e[18]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function a$(e) {
            let t, i, o;
            return i = new Yy({
                props: {
                    locale: e[4],
                    presets: e[19],
                    enableSelectImage: e[11],
                    willRenderPresetToolbar: e[43],
                    onaddpreset: e[93],
                    ongrabpreset: e[90],
                    ondragpreset: e[91],
                    ondroppreset: e[92],
                    scrollElasticity: e[44]
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "class", "PinturaControlPanel")
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, t) {
                    const o = {};
                    16 & t[0] && (o.locale = e[4]),
                    524288 & t[0] && (o.presets = e[19]),
                    2048 & t[0] && (o.enableSelectImage = e[11]),
                    4096 & t[1] && (o.willRenderPresetToolbar = e[43]),
                    8192 & t[1] && (o.scrollElasticity = e[44]),
                    i.$set(o)
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function s$(e) {
            let t, i;
            return t = new Su({
                props: {
                    class: "PinturaControlListScroller",
                    elasticity: e[44],
                    $$slots: {
                        default: [m$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8192 & i[1] && (o.elasticity = e[44]),
                    262801 & i[0] | 262154 & i[1] | 67108864 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function l$(e) {
            let t, i;
            return t = new Nd({
                props: {
                    locale: e[4],
                    class: "PinturaControlList",
                    optionClass: "PinturaControlListOption",
                    layout: "row",
                    options: e[32],
                    selectedIndex: e[32].findIndex(e[153]),
                    onchange: e[78],
                    $$slots: {
                        option: [p$, ({option: e}) => ({
                            211: e
                        }), ({option: e}) => [0, 0, 0, 0, 0, 0, e ? 33554432 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] && (o.locale = e[4]),
                    2 & i[1] && (o.options = e[32]),
                    1 & i[0] | 2 & i[1] && (o.selectedIndex = e[32].findIndex(e[153])),
                    16 & i[0] | 100663296 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function c$(e) {
            let t, i;
            return t = new ou({
                props: {
                    $$slots: {
                        default: [u$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] | 100663296 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function u$(e) {
            let t, i = (H(e[211].icon) ? e[211].icon(e[4]) : e[211].icon) + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    16 & o[0] | 33554432 & o[6] && i !== (i = (H(e[211].icon) ? e[211].icon(e[4]) : e[211].icon) + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function d$(e) {
            let t, i, o = (H(e[211].label) ? e[211].label(e[4]) : e[211].label) + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o)
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    16 & t[0] | 33554432 & t[6] && o !== (o = (H(e[211].label) ? e[211].label(e[4]) : e[211].label) + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function p$(e) {
            let t, i, o, n = e[211].icon && c$(e), r = !e[211].hideLabel && d$(e);
            return {
                c() {
                    t = Er("div"),
                    n && n.c(),
                    i = Ir(),
                    r && r.c(),
                    Or(t, "slot", "option")
                },
                m(e, a) {
                    Mr(e, t, a),
                    n && n.m(t, null),
                    kr(t, i),
                    r && r.m(t, null),
                    o = !0
                },
                p(e, o) {
                    e[211].icon ? n ? (n.p(e, o),
                    33554432 & o[6] && ka(n, 1)) : (n = c$(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t, i)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    e[211].hideLabel ? r && (r.d(1),
                    r = null) : r ? r.p(e, o) : (r = d$(e),
                    r.c(),
                    r.m(t, null))
                },
                i(e) {
                    o || (ka(n),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    n && n.d(),
                    r && r.d()
                }
            }
        }
        function h$(e) {
            let t, i;
            return t = new Iy({
                props: {
                    locale: e[4],
                    shapeProps: e[49],
                    onchange: e[85],
                    controls: e[9],
                    scrollEnable: !1,
                    hideTitles: !0,
                    willRenderControls: e[154]
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] && (o.locale = e[4]),
                    262144 & i[1] && (o.shapeProps = e[49]),
                    512 & i[0] && (o.controls = e[9]),
                    262144 & i[0] && (o.willRenderControls = e[154]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function m$(e) {
            let t, i, o, n = e[34] && l$(e), r = "row" === e[7] && h$(e);
            return {
                c() {
                    n && n.c(),
                    t = Ir(),
                    r && r.c(),
                    i = Lr()
                },
                m(e, a) {
                    n && n.m(e, a),
                    Mr(e, t, a),
                    r && r.m(e, a),
                    Mr(e, i, a),
                    o = !0
                },
                p(e, o) {
                    e[34] ? n ? (n.p(e, o),
                    8 & o[1] && ka(n, 1)) : (n = l$(e),
                    n.c(),
                    ka(n, 1),
                    n.m(t.parentNode, t)) : n && (Sa(),
                    Ca(n, 1, 1, ( () => {
                        n = null
                    }
                    )),
                    _a()),
                    "row" === e[7] ? r ? (r.p(e, o),
                    128 & o[0] && ka(r, 1)) : (r = h$(e),
                    r.c(),
                    ka(r, 1),
                    r.m(i.parentNode, i)) : r && (Sa(),
                    Ca(r, 1, 1, ( () => {
                        r = null
                    }
                    )),
                    _a())
                },
                i(e) {
                    o || (ka(n),
                    ka(r),
                    o = !0)
                },
                o(e) {
                    Ca(n),
                    Ca(r),
                    o = !1
                },
                d(e) {
                    n && n.d(e),
                    e && Pr(t),
                    r && r.d(e),
                    e && Pr(i)
                }
            }
        }
        function f$(e) {
            let t, i;
            return t = new Su({
                props: {
                    class: "PinturaControlListScroller",
                    elasticity: e[44],
                    $$slots: {
                        default: [b$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8192 & i[1] && (o.elasticity = e[44]),
                    134217744 & i[0] | 8388608 & i[1] | 67108864 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function g$(e) {
            let t, i;
            return t = new ou({
                props: {
                    $$slots: {
                        default: [y$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] | 100663296 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function y$(e) {
            let t, i = (H(e[211].icon) ? e[211].icon(e[4]) : e[211].icon) + "";
            return {
                c() {
                    t = Rr("g")
                },
                m(e, o) {
                    Mr(e, t, o),
                    t.innerHTML = i
                },
                p(e, o) {
                    16 & o[0] | 33554432 & o[6] && i !== (i = (H(e[211].icon) ? e[211].icon(e[4]) : e[211].icon) + "") && (t.innerHTML = i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function $$(e) {
            let t, i, o, n, r, a = (H(e[211].label) ? e[211].label(e[4]) : e[211].label) + "", s = e[211].icon && g$(e);
            return {
                c() {
                    t = Er("div"),
                    s && s.c(),
                    i = Ir(),
                    o = Er("span"),
                    n = Ar(a),
                    Or(t, "slot", "option")
                },
                m(e, a) {
                    Mr(e, t, a),
                    s && s.m(t, null),
                    kr(t, i),
                    kr(t, o),
                    kr(o, n),
                    r = !0
                },
                p(e, o) {
                    e[211].icon ? s ? (s.p(e, o),
                    33554432 & o[6] && ka(s, 1)) : (s = g$(e),
                    s.c(),
                    ka(s, 1),
                    s.m(t, i)) : s && (Sa(),
                    Ca(s, 1, 1, ( () => {
                        s = null
                    }
                    )),
                    _a()),
                    (!r || 16 & o[0] | 33554432 & o[6]) && a !== (a = (H(e[211].label) ? e[211].label(e[4]) : e[211].label) + "") && Wr(n, a)
                },
                i(e) {
                    r || (ka(s),
                    r = !0)
                },
                o(e) {
                    Ca(s),
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    s && s.d()
                }
            }
        }
        function b$(e) {
            let t, i;
            return t = new Nd({
                props: {
                    locale: e[4],
                    class: "PinturaControlList",
                    optionClass: "PinturaControlListOption",
                    layout: "row",
                    options: e[54],
                    selectedIndex: e[54].findIndex(e[155]),
                    onchange: e[77],
                    $$slots: {
                        option: [$$, ({option: e}) => ({
                            211: e
                        }), ({option: e}) => [0, 0, 0, 0, 0, 0, e ? 33554432 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    16 & i[0] && (o.locale = e[4]),
                    8388608 & i[1] && (o.options = e[54]),
                    134217728 & i[0] | 8388608 & i[1] && (o.selectedIndex = e[54].findIndex(e[155])),
                    16 & i[0] | 100663296 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function v$(e) {
            let t, i, o, n, r;
            const a = [o$, i$]
              , s = [];
            function l(e, t) {
                return e[52] ? 0 : e[45] ? 1 : -1
            }
            ~(i = l(e)) && (o = s[i] = a[i](e));
            let c = e[33] && f$(e);
            return {
                c() {
                    t = Er("div"),
                    o && o.c(),
                    n = Ir(),
                    c && c.c(),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[40])
                },
                m(e, o) {
                    Mr(e, t, o),
                    ~i && s[i].m(t, null),
                    kr(t, n),
                    c && c.m(t, null),
                    r = !0
                },
                p(e, u) {
                    let d = i;
                    i = l(e),
                    i === d ? ~i && s[i].p(e, u) : (o && (Sa(),
                    Ca(s[d], 1, 1, ( () => {
                        s[d] = null
                    }
                    )),
                    _a()),
                    ~i ? (o = s[i],
                    o ? o.p(e, u) : (o = s[i] = a[i](e),
                    o.c()),
                    ka(o, 1),
                    o.m(t, n)) : o = null),
                    e[33] ? c ? (c.p(e, u),
                    4 & u[1] && ka(c, 1)) : (c = f$(e),
                    c.c(),
                    ka(c, 1),
                    c.m(t, null)) : c && (Sa(),
                    Ca(c, 1, 1, ( () => {
                        c = null
                    }
                    )),
                    _a()),
                    (!r || 512 & u[1]) && Or(t, "style", e[40])
                },
                i(e) {
                    r || (ka(o),
                    ka(c),
                    r = !0)
                },
                o(e) {
                    Ca(o),
                    Ca(c),
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    ~i && s[i].d(),
                    c && c.d()
                }
            }
        }
        function x$(e) {
            let t, i;
            return t = new Lf({
                props: {
                    hasHeader: e[41],
                    $$slots: {
                        footer: [v$],
                        main: [t$],
                        header: [Jy]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            t.$on("measure", e[166]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    1024 & i[1] && (o.hasHeader = e[41]),
                    2080374769 & i[0] | 134216703 & i[1] | 67108864 & i[6] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function w$(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, $, b, v, x, w, S, _, k, C, T, M, P, E, R, A, I, L, D, z, F, O, B, N, H, j, U, V, q, G, K, X, Z, Y, Q, J, ee, te, ie, oe, ne, re, ae, le, ce, ue, de, pe, he, me, fe, ge, ye, $e, be = Jn, ve = () => (be(),
            be = sr(Ee, (e => i(35, K = e))),
            Ee), xe = Jn, we = () => (xe(),
            xe = sr(De, (e => i(145, Q = e))),
            De), Se = Jn, _e = () => (Se(),
            Se = sr(gt, (e => i(37, re = e))),
            gt), ke = Jn, Te = () => (ke(),
            ke = sr(Ae, (e => i(151, me = e))),
            Ae), Me = Jn, Pe = () => (Me(),
            Me = sr(Re, (e => i(56, ye = e))),
            Re);
            e.$$.on_destroy.push(( () => be())),
            e.$$.on_destroy.push(( () => xe())),
            e.$$.on_destroy.push(( () => Se())),
            e.$$.on_destroy.push(( () => ke())),
            e.$$.on_destroy.push(( () => Me()));
            let {isActive: Ee} = t;
            ve();
            let {isActiveFraction: Re} = t;
            Pe();
            let {isVisible: Ae} = t;
            Te();
            let {stores: Ie} = t
              , {locale: Le={}} = t
              , {shapes: De} = t;
            we();
            let {toolbar: ze=[]} = t
              , {toolShapes: Fe={}} = t
              , {toolActive: Oe} = t
              , {toolSelectRadius: Be} = t
              , {toolRetainStyles: Ne=!1} = t
              , {toolbarLayout: We="stack"} = t
              , {textInputMode: He} = t
              , {shapeControls: Ue={}} = t
              , {enableButtonFlipVertical: qe=!1} = t
              , {enablePresetSelectImage: Ge=!0} = t
              , {enablePresetDropImage: Ke=!0} = t
              , {enableSelectToolToAddShape: Xe=!1} = t
              , {enableAutoSelectMoveTool: Ze=["line", "arrow", "path", "rectangle", "ellipse", "text"]} = t
              , {enableTapToAddText: Ye=!1} = t
              , {enableMoveTool: Qe=!1} = t
              , {enableViewTool: Je=!1} = t
              , {enableToolShareStyles: et=!0} = t
              , {enableMultiSelect: tt=!1} = t
              , {gridSize: it=0} = t
              , {snapThreshold: ot=0} = t
              , {enableSnapToContext: nt=!0} = t
              , {willRenderHeaderTools: rt=se} = t
              , {willRenderPresetToolbar: at} = t
              , {willRenderShapeStyleControls: st} = t
              , {willStartInteraction: lt} = t
              , {shapePresets: ct=[]} = t
              , {utilKey: ut} = t
              , {mapScreenPointToImagePoint: dt} = t
              , {mapImagePointToScreenPoint: pt} = t
              , {imageRotation: ht=0} = t
              , {imageFlipX: mt=!1} = t
              , {imageFlipY: ft=!1} = t
              , {parentRect: gt} = t;
            _e();
            let {hooks: yt={}} = t;
            const $t = oa("selection");
            cr(e, $t, (e => i(150, de = e)));
            const bt = oa("isAnimated");
            cr(e, bt, (e => i(142, X = e)));
            const xt = oa("elasticityMultiplier");
            cr(e, xt, (e => i(146, J = e)));
            const wt = oa("ui");
            cr(e, wt, (e => i(176, pe = e)));
            const St = oa("keysPressed");
            let _t;
            cr(e, St, (e => i(149, ue = e)));
            const {env: kt, history: Ct, rootRect: Tt, rootColorSecondary: Mt, enablePanInput: Pt, enablePanInputStatus: Et, enableZoomInput: Rt, stageRect: It, utilRectPadded: Lt, scrollElasticity: Dt, imageOverlayMarkup: zt, imagePreviewModifiers: Ft, imageCropRect: Ot, shapePreprocessor: Bt, stageScalar: Nt, imageSelectionRect: Wt, imageTransformsInterpolated: Ht, imageSelectionPan: jt, imageSize: Ut, allowPan: Vt, allowZoom: qt, allowZoomControls: Gt, allowPlayPause: Kt} = Ie;
            cr(e, kt, (e => i(143, Z = e))),
            cr(e, Tt, (e => i(55, ge = e))),
            cr(e, Mt, (e => i(57, $e = e))),
            cr(e, Et, (e => i(38, le = e))),
            cr(e, It, (e => i(147, ee = e))),
            cr(e, Lt, (e => i(39, he = e))),
            cr(e, Ft, (e => i(177, fe = e))),
            cr(e, Ot, (e => i(175, ae = e))),
            cr(e, Nt, (e => i(173, oe = e))),
            cr(e, Wt, (e => i(174, ne = e))),
            cr(e, Ht, (e => i(36, te = e))),
            cr(e, jt, (e => i(172, ie = e))),
            cr(e, Ut, (e => i(148, ce = e)));
            let Xt = 0
              , Zt = {};
            const Yt = e => dt(Jg(e, ge));
            let Qt, Jt, ei, ti = {};
            const ii = e => {
                if (!zo(e) || !ji(e, "pathClose"))
                    return;
                const t = [...e.strokeColor];
                t[3] = 1,
                Qt.updateMarkupShape(e, {
                    pathClose: !1,
                    strokeColor: t
                }, !1),
                Qt.removeMarkupShapeProps(e, ["backgroundColor"], !1),
                Qt.confirmMarkupItemDraft(),
                Qt.selectShape(e),
                B("addshape", e),
                Ct.write()
            }
            ;
            let oi;
            const ni = (e, t) => Wi(e) ? e : e.endsWith("%") ? parseFloat(e) / 100 * t.width : void 0;
            let ri, ai, si;
            const li = (e, t, i) => {
                let o = !1;
                t || (o = !0,
                t = O ? dt(vt(ee)) : vt(ae)),
                t.x -= re.x || 0,
                t.y -= re.y || 0,
                (mt || ft) && (e.flipX = mt,
                e.flipY = ft);
                const n = Qt.getShapesNearPosition(Q, t);
                if (o && n.length) {
                    const e = .1 * Math.min(ae.width, ae.height);
                    t.x += Math.round(-e + Math.random() * e * 2),
                    t.y += Math.round(-e + Math.random() * e * 2)
                }
                if (0 !== ht && (e.rotation = mt && ft ? -ht : mt || ft ? ht : -ht),
                ji(e, "width") && ji(e, "height")) {
                    const {width: i, height: o} = _n(e, ["width", "height"], re);
                    kn(e, {
                        x: t.x - .5 * i,
                        y: t.y - .5 * o
                    }, re)
                } else if (Lo(e))
                    kn(e, {
                        x: t.x,
                        y: t.y
                    }, re);
                else if (Do(e)) {
                    const {x1: o, y1: n, x2: r, y2: a} = _n(e, ["x1", "y1", "x2", "y2"], re)
                      , s = je(Ce(o, n), Ce(r, a))
                      , l = W(i) ? mn(i, re.width) : s;
                    kn(e, {
                        x1: t.x - l,
                        y1: t.y + l,
                        x2: t.x + l,
                        y2: t.y - l
                    }, re)
                } else if (zo(e)) {
                    const {points: i} = _n(e, ["points"], re)
                      , o = Ve(i);
                    kn(e, {
                        points: i.map((e => ({
                            x: e.x + t.x - o.x,
                            y: e.y + t.y - o.y
                        })))
                    }, re)
                }
                return e
            }
              , ci = (e, t) => {
                const i = li(To(e, ae), t);
                return e.shape && (ji(e.shape, "x") && (i.x = e.shape.x),
                ji(e.shape, "y") && (i.y = e.shape.y)),
                ui(i)
            }
              , ui = e => {
                const {beforeAddShape: t=( () => !0)} = yt;
                if (t(e))
                    return Qt.addShape(e),
                    Qt.selectShape(e),
                    B("addshape", e),
                    Ct.write(),
                    e
            }
            ;
            let di = !1;
            const pi = () => {
                Ct.write()
            }
            ;
            let hi;
            const mi = oa("redrawTrigger");
            cr(e, mi, (e => i(144, Y = e)));
            const fi = []
              , gi = ic(X ? 20 : 0);
            return cr(e, gi, (e => i(141, G = e))),
            e.$$set = e => {
                "isActive"in e && ve(i(1, Ee = e.isActive)),
                "isActiveFraction"in e && Pe(i(2, Re = e.isActiveFraction)),
                "isVisible"in e && Te(i(3, Ae = e.isVisible)),
                "stores"in e && i(100, Ie = e.stores),
                "locale"in e && i(4, Le = e.locale),
                "shapes"in e && we(i(5, De = e.shapes)),
                "toolbar"in e && i(101, ze = e.toolbar),
                "toolShapes"in e && i(102, Fe = e.toolShapes),
                "toolActive"in e && i(0, Oe = e.toolActive),
                "toolSelectRadius"in e && i(6, Be = e.toolSelectRadius),
                "toolRetainStyles"in e && i(103, Ne = e.toolRetainStyles),
                "toolbarLayout"in e && i(7, We = e.toolbarLayout),
                "textInputMode"in e && i(8, He = e.textInputMode),
                "shapeControls"in e && i(9, Ue = e.shapeControls),
                "enableButtonFlipVertical"in e && i(10, qe = e.enableButtonFlipVertical),
                "enablePresetSelectImage"in e && i(11, Ge = e.enablePresetSelectImage),
                "enablePresetDropImage"in e && i(12, Ke = e.enablePresetDropImage),
                "enableSelectToolToAddShape"in e && i(104, Xe = e.enableSelectToolToAddShape),
                "enableAutoSelectMoveTool"in e && i(105, Ze = e.enableAutoSelectMoveTool),
                "enableTapToAddText"in e && i(13, Ye = e.enableTapToAddText),
                "enableMoveTool"in e && i(106, Qe = e.enableMoveTool),
                "enableViewTool"in e && i(107, Je = e.enableViewTool),
                "enableToolShareStyles"in e && i(108, et = e.enableToolShareStyles),
                "enableMultiSelect"in e && i(14, tt = e.enableMultiSelect),
                "gridSize"in e && i(15, it = e.gridSize),
                "snapThreshold"in e && i(16, ot = e.snapThreshold),
                "enableSnapToContext"in e && i(17, nt = e.enableSnapToContext),
                "willRenderHeaderTools"in e && i(109, rt = e.willRenderHeaderTools),
                "willRenderPresetToolbar"in e && i(110, at = e.willRenderPresetToolbar),
                "willRenderShapeStyleControls"in e && i(18, st = e.willRenderShapeStyleControls),
                "willStartInteraction"in e && i(111, lt = e.willStartInteraction),
                "shapePresets"in e && i(19, ct = e.shapePresets),
                "utilKey"in e && i(20, ut = e.utilKey),
                "mapScreenPointToImagePoint"in e && i(21, dt = e.mapScreenPointToImagePoint),
                "mapImagePointToScreenPoint"in e && i(22, pt = e.mapImagePointToScreenPoint),
                "imageRotation"in e && i(23, ht = e.imageRotation),
                "imageFlipX"in e && i(24, mt = e.imageFlipX),
                "imageFlipY"in e && i(25, ft = e.imageFlipY),
                "parentRect"in e && _e(i(26, gt = e.parentRect)),
                "hooks"in e && i(112, yt = e.hooks)
            }
            ,
            e.$$.update = () => {
                var t, ie, oe, ne;
                if (33554432 & e.$$.dirty[4] && i(124, o = ue.includes(18)),
                1049088 & e.$$.dirty[3] && (_t && Fe === _t || i(113, _t = Fe)),
                16 & e.$$.dirty[1] && Vt.set(K),
                16 & e.$$.dirty[1] && qt.set(K),
                16 & e.$$.dirty[1] && Gt.set(K),
                256 & e.$$.dirty[3] && i(33, n = Array.isArray(ze) && ze.length > 1 && Array.isArray(ze[0][1])),
                4 & e.$$.dirty[1] | 256 & e.$$.dirty[3] && i(54, r = n ? ze.map(( (e, t) => [t, e[0]])) : []),
                134217728 & e.$$.dirty[0] | 4 & e.$$.dirty[1] | 256 & e.$$.dirty[3] && i(140, a = n ? ze[Xt][1] : ze),
                524288 & e.$$.dirty[0] | 155648 & e.$$.dirty[3] | 65536 & e.$$.dirty[4] && i(32, s = ( (e, {willRenderPresetToolbar: t, shapePresets: i, enableViewTool: o, enableMoveTool: r}) => {
                    let a = 0 !== i.length || t ? e : e.filter((e => "preset" !== e[0]));
                    return n && (a = [["move", e => e.shapeLabelToolMove, {
                        icon: e => e.shapeIconToolMove
                    }], ["view", e => e.shapeLabelToolView, {
                        icon: e => e.shapeIconToolView
                    }], ...a]),
                    a = r ? a : a.filter((e => "move" !== e[0])),
                    o ? a : a.filter((e => "view" !== e[0]))
                }
                )(a, {
                    willRenderPresetToolbar: at,
                    shapePresets: ct,
                    enableMoveTool: Qe,
                    enableViewTool: Je
                })),
                2 & e.$$.dirty[1] && i(138, u = !!s.length),
                1 & e.$$.dirty[0] | 2 & e.$$.dirty[1] | 16384 & e.$$.dirty[4] && u && void 0 === Oe && i(0, Oe = s[0][0]),
                134217729 & e.$$.dirty[0] | 4 & e.$$.dirty[1] | 2097152 & e.$$.dirty[3] | 65536 & e.$$.dirty[4] && n && i(114, Zt = {
                    ...Zt,
                    [Xt]: a.map(( ([e]) => e)).includes(Oe) ? Oe : Zt[Xt] || a[0][0]
                }),
                512 & e.$$.dirty[0] && i(137, l = !!Object.keys(Ue).length),
                2 & e.$$.dirty[1] && i(34, c = s.length > 1),
                12 & e.$$.dirty[1] && i(53, d = c || n),
                1 & e.$$.dirty[0] && i(139, p = void 0 !== Oe),
                57344 & e.$$.dirty[4] && i(52, h = (!p || u) && l),
                536870912 & e.$$.dirty[0] && i(31, B = hi && (t = hi,
                (e, i) => {
                    t.dispatchEvent(Th(e, i))
                }
                )),
                1 & e.$$.dirty[0] | 17 & e.$$.dirty[1] && K && B && B("selectcontrol", Oe),
                16 & e.$$.dirty[1] && (K ? yr(Ft, fe[ut] = {
                    maskMarkupOpacity: .85
                }, fe) : delete fe[ut]),
                1 & e.$$.dirty[0] | 1048576 & e.$$.dirty[3] && i(136, m = Oe && _t[Oe] ? _t[Oe][1] : void 0),
                4096 & e.$$.dirty[4] && i(125, f = m && m.isSelection ? "selection" : "shapes"),
                3 & e.$$.dirty[4] && (e => {
                    if (!Qt)
                        return;
                    const t = Qt.getShapeDraft($t);
                    t && (e && (Jt = t.drawMode),
                    Qt.updateShapeDraft({
                        drawMode: e ? "subtract" : Jt
                    }, $t))
                }
                )("selection" === f && o),
                268435457 & e.$$.dirty[0] && Oe && Qt) {
                    const e = Qt.getMarkupItemDraft();
                    e && ii(e)
                }
                if (1 & e.$$.dirty[0] && Oe && Qt && "move" !== Oe && Qt.blurShapes(),
                16 & e.$$.dirty[1] | 134217728 & e.$$.dirty[4] && i(51, g = me && K),
                256 & e.$$.dirty[1] | 8388608 & e.$$.dirty[4] && i(50, y = he && Ce(ee.x - he.x, ee.y - he.y)),
                512 & e.$$.dirty[0] && i(135, $ = Object.keys(Ue)),
                16384 & e.$$.dirty[0] | 16 & e.$$.dirty[1] | 2097152 & e.$$.dirty[4] && i(122, b = tt ? K && Q.filter(Bo) : []),
                536870912 & e.$$.dirty[3] && i(123, v = b.length > 1),
                16 & e.$$.dirty[1] | 2097152 & e.$$.dirty[4] && i(119, x = K && Q.filter(Bo)[0]),
                16 & e.$$.dirty[1] | 2097152 & e.$$.dirty[4] && i(130, w = K && Q.find((e => No(e)))),
                16 & e.$$.dirty[1] | 2097152 & e.$$.dirty[4] && i(133, S = K && Q.find((e => Wo(e)))),
                1 & e.$$.dirty[0] | 16 & e.$$.dirty[1] | 1048576 & e.$$.dirty[3] && i(127, _ = K && _t[Oe] ? pn(So({
                    ..._t[Oe][0],
                    ...pe[ut] ? pe[ut][Oe] : {}
                })) : {}),
                1048576 & e.$$.dirty[3] && _t && i(115, ti = {}),
                1 & e.$$.dirty[0] | 4227072 & e.$$.dirty[3] | 2056 & e.$$.dirty[4] && i(126, k = _ && Object.keys(_).reduce(( (e, t) => {
                    const i = "disableStyle" === t
                      , o = "settings" === t
                      , n = !!$.find((e => e.split("_").includes(t)));
                    if (!i && !o && !n)
                        return e;
                    if (void 0 === _[t])
                        return e;
                    if (!0 === _.disableStyle)
                        return e;
                    if (_.disableStyle && _.disableStyle.includes(t))
                        return e;
                    if ("strokeWidth" === t && Object.keys(ti).includes("strokeWidth") && void 0 === ti[t] && ji(_, "points"))
                        return e[t] = _[t],
                        e;
                    const {share: r=!0} = _.settings && _.settings[t] || {}
                      , a = et && r ? ti : ti[Oe] || {};
                    return e[t] = ji(a, t) ? a[t] : _[t],
                    e
                }
                ), {})),
                1048577 & e.$$.dirty[0] | 1024 & e.$$.dirty[3] | 4 & e.$$.dirty[4] && (Ne ? ( (e, t, i) => {
                    const o = pe[e]
                      , n = o ? o[t] : {};
                    wt.set({
                        ...pe,
                        [e]: {
                            ...o,
                            [t]: {
                                ...n,
                                ...i
                            }
                        }
                    })
                }
                )(ut, Oe, k) : (ie = ut,
                wt.set({
                    [ie]: {}
                }))),
                16 & e.$$.dirty[1] | 67108864 & e.$$.dirty[3] | 67108868 & e.$$.dirty[4] && i(134, C = de && K ? x || k : void 0),
                1610612736 & e.$$.dirty[3] | 1536 & e.$$.dirty[4] && i(49, T = v ? function(e) {
                    const t = {};
                    return e.forEach((e => {
                        Object.entries(e).filter(( ([e]) => !e.startsWith("_"))).forEach(( ([e,i]) => {
                            ji(t, e) ? "disableStyle" === e && t[e].push(...i) : t[e] = i
                        }
                        ))
                    }
                    )),
                    t
                }(b) : C || S),
                1 & e.$$.dirty[0] | 8 & e.$$.dirty[4] && i(48, M = ji(_, "eraseRadius") || ji(_, "points") && !ji(_, "pathClose") || "move" === Oe || "view" === Oe),
                64 & e.$$.dirty[1] | 8 & e.$$.dirty[4] && i(47, P = _ && void 0 !== _.eraseRadius ? ni(_.eraseRadius, re) : void 0),
                16 & e.$$.dirty[1] | 33554432 & e.$$.dirty[4] && i(131, E = K && ue.includes(32)),
                1 & e.$$.dirty[0] | 16 & e.$$.dirty[1] && i(132, R = K && "view" === Oe),
                384 & e.$$.dirty[4] && i(129, A = R || E),
                96 & e.$$.dirty[4] && i(128, I = !!A && (!!w || Gu(document.activeElement))),
                16 & e.$$.dirty[1] | 48 & e.$$.dirty[4] && Pt.set(!K || A && !I),
                16 & e.$$.dirty[1] | 16 & e.$$.dirty[4] && Rt.set(!K || !I),
                64 & e.$$.dirty[1] | 12 & e.$$.dirty[4] && i(120, L = _.cursorStyle ? ( ({cursorStyle: e, cursorSize: t}, i, o) => {
                    let n;
                    const r = i[t];
                    if (void 0 === r ? n = ni(t, o) : Wi(r) ? n = r : W(r) && (n = $n(t, i[t], o),
                    "strokeWidth" === t && (n *= .5)),
                    !(n <= 0 || void 0 === n))
                        return {
                            size: n,
                            style: e
                        }
                }
                )(_, {
                    ..._,
                    ...k
                }, re) : void 0),
                33554432 & e.$$.dirty[3] | 16777216 & e.$$.dirty[4] && i(121, D = si && (ne = ce,
                (oe = si).x >= 0 && oe.y >= 0 && oe.x <= ne.width && oe.y <= ne.height)),
                1048576 & e.$$.dirty[0] | 160 & e.$$.dirty[1] | 427819008 & e.$$.dirty[3] | 3 & e.$$.dirty[4])
                    if (D && !ri && L && !le) {
                        const e = L.size * te.scale
                          , t = {
                            id: `cursor-${ut}`,
                            x: ai.x,
                            y: ai.y,
                            strokeWidth: .5,
                            strokeColor: [0, 0, 0]
                        };
                        "ellipse" === L.style && (t.rx = e,
                        t.ry = e);
                        const i = {
                            strokeWidth: 2.5,
                            strokeColor: [1, 1, 1],
                            opacity: .75
                        }
                          , n = [{
                            ...t,
                            ...i
                        }, t];
                        if ("selection" === f && o) {
                            const t = e
                              , o = ai.x + t
                              , r = ai.y + t + 4
                              , a = {
                                id: `cursor-${ut}`,
                                strokeWidth: .75,
                                strokeColor: [0, 0, 0],
                                points: [{
                                    x: o,
                                    y: r
                                }, {
                                    x: o + 4,
                                    y: r
                                }]
                            };
                            n.push({
                                ...a,
                                ...i,
                                strokeWidth: 2,
                                points: [{
                                    x: o - .5,
                                    y: r
                                }, {
                                    x: o + 4.5,
                                    y: r
                                }]
                            }, a)
                        }
                        (e => {
                            zt.update((t => [...t.filter((e => e.id !== `cursor-${ut}`)), ...e]))
                        }
                        )(n)
                    } else
                        zt.update((e => e.filter((e => e.id !== `cursor-${ut}`))));
                1 & e.$$.dirty[0] | 128 & e.$$.dirty[1] | 478150656 & e.$$.dirty[3] && i(46, z = D ? ( (e, t, i, o, n, r) => {
                    if (o)
                        return "grab";
                    if (e && !t)
                        return "none";
                    if (!t)
                        return "move" === r ? "default" : "crosshair";
                    let a = t || i;
                    return Bo(a) ? No(a) ? "modal" === He ? "default" : "text" : !nn(a) || v && !b.every(nn) ? "default" : "move" : "default"
                }
                )(L, ri, x, le, 0, Oe) : "default"),
                526337 & e.$$.dirty[0] | 131072 & e.$$.dirty[3] && i(45, F = "preset" === Oe && (ct.length > 0 || Ge || at)),
                64 & e.$$.dirty[1] && (O = !ji(re, "x") && !ji(re, "y")),
                4194304 & e.$$.dirty[4] && i(44, N = J * Dt),
                131072 & e.$$.dirty[3] | 1572864 & e.$$.dirty[4] && i(43, H = Y && at ? e => Bh(( () => at(e, ci, {
                    ...Z
                }, ( () => mi.set({}))))) : se),
                524288 & e.$$.dirty[3] && i(42, j = Object.keys(yt).reduce(( (e, t) => ("beforeAddShape" === t || void 0 === yt[t] || (e[t] = yt[t]),
                e)), {})),
                16 & e.$$.dirty[1] && (e => {
                    Q && De.update((t => t.map((t => (t._prerender = !!e && No(t),
                    t)))))
                }
                )(K),
                65536 & e.$$.dirty[3] | 1572864 & e.$$.dirty[4] && i(30, U = Y && rt([], Z, ( () => mi.set({})))),
                1073742336 & e.$$.dirty[0] && i(41, V = !!U.length || !!Object.keys(Ue).some((e => fi.includes(e)))),
                16 & e.$$.dirty[1] | 262144 & e.$$.dirty[4] && X && gi.set(K ? 0 : 20),
                131072 & e.$$.dirty[4] && i(40, q = G ? `transform: translateY(${G}px)` : void 0)
            }
            ,
            Kt.set(!1),
            [Oe, Ee, Re, Ae, Le, De, Be, We, He, Ue, qe, Ge, Ke, Ye, tt, it, ot, nt, st, ct, ut, dt, pt, ht, mt, ft, gt, Xt, Qt, hi, U, B, s, n, c, K, te, re, le, he, q, V, j, H, N, F, z, P, M, T, y, g, h, d, r, ge, ye, $e, $t, bt, xt, wt, St, kt, Tt, Mt, Et, It, Lt, zt, Ft, Ot, Nt, Wt, Ht, jt, Ut, ({index: e}, t) => {
                i(27, Xt = e),
                i(0, Oe = Zt[e])
            }
            , ({value: e}, t) => {
                i(0, Oe = e),
                (Xe || /enter/i.test(t.key)) && (e => {
                    const [t,i] = _t[e];
                    let o, n, r = "relative" === i.position;
                    const a = r ? "0%" : 0
                      , s = r ? "0%" : 0;
                    Io(t) || Eo(t) ? (n = r ? "20%" : .2 * re.width,
                    o = So(t),
                    o.x = a,
                    o.y = s,
                    kn(o, {
                        width: n,
                        height: n
                    }, re)) : Lo(t) ? (n = r ? "10%" : .1 * re.width,
                    o = So(t),
                    o.x = a,
                    o.y = s,
                    kn(o, {
                        rx: n,
                        ry: n
                    }, re)) : Do(t) && (n = r ? "10%" : .1 * re.width,
                    o = So(t),
                    o.x1 = a,
                    o.y1 = s,
                    o.x2 = a,
                    o.y2 = s),
                    o && Promise.resolve().then(( () => {
                        ui(li(o, void 0, n))
                    }
                    ))
                }
                )(e)
            }
            , e => {
                if ("eraser" === Oe)
                    ei = Qt.eraseShape();
                else if (Oe && _t[Oe]) {
                    const [e,t={}] = _t[Oe]
                      , {drawMode: i} = C;
                    "selection" === f && "new" === i && $t.set([]);
                    let n = {};
                    "selection" === f && (B("selectiondown", [...de]),
                    o && (Jt = e.drawMode,
                    n.drawMode = "subtract")),
                    ei = Qt.createShape({
                        ...e,
                        ...k,
                        ...n
                    }, t)
                } else
                    ei = void 0;
                return !!ei && (ei.start(e),
                !0)
            }
            , e => !!ei && (ei.update(e),
            !0), e => !!ei && (ei.release(e),
            !0), e => !!ei && (ei.cancel(e),
            ei = void 0,
            !0), e => {
                if (!ei)
                    return !1;
                if (ei.end(e),
                ei = void 0,
                "selection" === f) {
                    if (e.detail.isTap) {
                        const [e] = _t[Oe];
                        e.bitmap || $t.set([])
                    }
                    B("selectionup", [...de])
                }
                const t = Qt.getMarkupItemDraft()
                  , o = Qe && (!0 === Ze || Array.isArray(Ze) && Ze.includes(Oe));
                return t && !t.isEditing || !o || i(0, Oe = "move"),
                !0
            }
            , e => {
                const {key: t} = e
                  , i = Qt.getMarkupItemDraft();
                /escape/i.test(t) && i && (e.preventDefault(),
                e.stopPropagation(),
                Qt.discardMarkupItemDraft(),
                ei = void 0),
                /enter/i.test(t) && i && (e.preventDefault(),
                e.stopPropagation(),
                ii(i),
                ei = void 0)
            }
            , function(e) {
                Object.keys(e).forEach((t => {
                    const {retain: o=!0, share: n=!0} = _.settings && _.settings[t] || {};
                    o && (et && n ? i(115, ti[t] = e[t], ti) : (ti[Oe] || i(115, ti[Oe] = {}, ti),
                    i(115, ti[Oe][t] = e[t], ti)))
                }
                )),
                B("selectstyle", e),
                x && (v ? b.forEach((t => {
                    Qt.updateMarkupShape(t, ( (e, t) => {
                        const i = {};
                        return Object.entries(e).forEach(( ([e,o]) => {
                            ji(t, e) && (i[e] = o)
                        }
                        )),
                        i
                    }
                    )(e, t))
                }
                )) : Qt.updateMarkupShape(x, e),
                clearTimeout(oi),
                oi = setTimeout(( () => {
                    pi()
                }
                ), 200))
            }
            , (e, t, o) => {
                i(117, ai = t),
                i(118, si = o)
            }
            , () => {
                i(118, si = void 0),
                i(117, ai = void 0)
            }
            , e => {
                B("markuptap", e)
            }
            , e => i(116, ri = e), () => {
                di = !1
            }
            , (e, t) => {
                if (di)
                    return;
                const {beforeAddShape: i=( () => !0)} = yt
                  , o = Yt(t)
                  , n = Qt.getMarkupItemDraft()
                  , r = At(ae, {
                    x: o.x + (re.x || 0),
                    y: o.y + (re.y || 0)
                });
                if (n && !r && Qt.discardMarkupItemDraft(),
                r) {
                    if (!n) {
                        const n = To(e, ae)
                          , r = li(n, o);
                        return i(r) ? (qo(r),
                        void Qt.addShape(r)) : (di = !0,
                        void t.preventDefault())
                    }
                    Io(n) && (o.x -= .5 * n.width,
                    o.y -= .5 * n.height),
                    e.shape && (ji(e.shape, "x") && (o.x = e.shape.x),
                    ji(e.shape, "y") && (o.y = e.shape.y)),
                    Qt.updateMarkupShape(n, o)
                }
            }
            , (e, t) => {
                if (di)
                    return;
                const i = Yt(t);
                if (!At(ae, {
                    x: i.x + (re.x || 0),
                    y: i.y + (re.y || 0)
                }))
                    return void Qt.discardMarkupItemDraft();
                const o = Qt.confirmMarkupItemDraft();
                Qt.selectShape(o),
                B("addshape", o),
                Ct.write()
            }
            , e => ci(e), e => {
                return t = e.detail.resources,
                i = Yt(e.detail.event),
                t.forEach((e => ci(e, i)));
                var t, i
            }
            , e => {
                if (!lt)
                    return !0;
                const t = rectClone(ne);
                return rectScale(t, 1 / oe),
                rectTranslate(t, ie),
                rectScale(t, te.scale),
                lt(e, {
                    ...t,
                    x: t.x + ee.x,
                    y: t.y + ee.y
                })
            }
            , pi, mi, fi, gi, Ie, ze, Fe, Ne, Xe, Ze, Qe, Je, et, rt, at, lt, yt, _t, Zt, ti, ri, ai, si, x, L, D, b, v, o, f, k, _, I, A, w, E, R, S, C, $, m, l, u, p, a, G, X, Z, Y, Q, J, ee, ce, ue, de, me, function(t) {
                na.call(this, e, t)
            }
            , e => e[0] === Oe, (e, t, i) => {
                const o = e.filter(( ([,e]) => !fi.includes(e)));
                return st ? st(o, t, i) : o
            }
            , e => e[0] === Xt, e => {
                Promise.resolve().then(( () => {
                    B("addshape", e),
                    pi()
                }
                ))
            }
            , e => {
                B("selectshape", e)
            }
            , e => {
                Promise.resolve().then(( () => {
                    B("blurshape", e)
                }
                ))
            }
            , e => {
                B("tapshape", e)
            }
            , e => {
                B("updateshape", e),
                pi()
            }
            , e => {
                B("removeshape", e),
                pi()
            }
            , () => {
                pi()
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    Qt = e,
                    i(28, Qt)
                }
                ))
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    hi = e,
                    i(29, hi)
                }
                ))
            }
            , e => e.filter(( ([,e]) => fi.includes(e))), function(t) {
                na.call(this, e, t)
            }
            ]
        }
        class S$ extends Na {
            constructor(e) {
                super(),
                Ba(this, e, w$, x$, ar, {
                    isActive: 1,
                    isActiveFraction: 2,
                    isVisible: 3,
                    stores: 100,
                    locale: 4,
                    shapes: 5,
                    toolbar: 101,
                    toolShapes: 102,
                    toolActive: 0,
                    toolSelectRadius: 6,
                    toolRetainStyles: 103,
                    toolbarLayout: 7,
                    textInputMode: 8,
                    shapeControls: 9,
                    enableButtonFlipVertical: 10,
                    enablePresetSelectImage: 11,
                    enablePresetDropImage: 12,
                    enableSelectToolToAddShape: 104,
                    enableAutoSelectMoveTool: 105,
                    enableTapToAddText: 13,
                    enableMoveTool: 106,
                    enableViewTool: 107,
                    enableToolShareStyles: 108,
                    enableMultiSelect: 14,
                    gridSize: 15,
                    snapThreshold: 16,
                    enableSnapToContext: 17,
                    willRenderHeaderTools: 109,
                    willRenderPresetToolbar: 110,
                    willRenderShapeStyleControls: 18,
                    willStartInteraction: 111,
                    shapePresets: 19,
                    utilKey: 20,
                    mapScreenPointToImagePoint: 21,
                    mapImagePointToScreenPoint: 22,
                    imageRotation: 23,
                    imageFlipX: 24,
                    imageFlipY: 25,
                    parentRect: 26,
                    hooks: 112
                }, null, [-1, -1, -1, -1, -1, -1, -1])
            }
            get isActive() {
                return this.$$.ctx[1]
            }
            set isActive(e) {
                this.$$set({
                    isActive: e
                }),
                $a()
            }
            get isActiveFraction() {
                return this.$$.ctx[2]
            }
            set isActiveFraction(e) {
                this.$$set({
                    isActiveFraction: e
                }),
                $a()
            }
            get isVisible() {
                return this.$$.ctx[3]
            }
            set isVisible(e) {
                this.$$set({
                    isVisible: e
                }),
                $a()
            }
            get stores() {
                return this.$$.ctx[100]
            }
            set stores(e) {
                this.$$set({
                    stores: e
                }),
                $a()
            }
            get locale() {
                return this.$$.ctx[4]
            }
            set locale(e) {
                this.$$set({
                    locale: e
                }),
                $a()
            }
            get shapes() {
                return this.$$.ctx[5]
            }
            set shapes(e) {
                this.$$set({
                    shapes: e
                }),
                $a()
            }
            get toolbar() {
                return this.$$.ctx[101]
            }
            set toolbar(e) {
                this.$$set({
                    toolbar: e
                }),
                $a()
            }
            get toolShapes() {
                return this.$$.ctx[102]
            }
            set toolShapes(e) {
                this.$$set({
                    toolShapes: e
                }),
                $a()
            }
            get toolActive() {
                return this.$$.ctx[0]
            }
            set toolActive(e) {
                this.$$set({
                    toolActive: e
                }),
                $a()
            }
            get toolSelectRadius() {
                return this.$$.ctx[6]
            }
            set toolSelectRadius(e) {
                this.$$set({
                    toolSelectRadius: e
                }),
                $a()
            }
            get toolRetainStyles() {
                return this.$$.ctx[103]
            }
            set toolRetainStyles(e) {
                this.$$set({
                    toolRetainStyles: e
                }),
                $a()
            }
            get toolbarLayout() {
                return this.$$.ctx[7]
            }
            set toolbarLayout(e) {
                this.$$set({
                    toolbarLayout: e
                }),
                $a()
            }
            get textInputMode() {
                return this.$$.ctx[8]
            }
            set textInputMode(e) {
                this.$$set({
                    textInputMode: e
                }),
                $a()
            }
            get shapeControls() {
                return this.$$.ctx[9]
            }
            set shapeControls(e) {
                this.$$set({
                    shapeControls: e
                }),
                $a()
            }
            get enableButtonFlipVertical() {
                return this.$$.ctx[10]
            }
            set enableButtonFlipVertical(e) {
                this.$$set({
                    enableButtonFlipVertical: e
                }),
                $a()
            }
            get enablePresetSelectImage() {
                return this.$$.ctx[11]
            }
            set enablePresetSelectImage(e) {
                this.$$set({
                    enablePresetSelectImage: e
                }),
                $a()
            }
            get enablePresetDropImage() {
                return this.$$.ctx[12]
            }
            set enablePresetDropImage(e) {
                this.$$set({
                    enablePresetDropImage: e
                }),
                $a()
            }
            get enableSelectToolToAddShape() {
                return this.$$.ctx[104]
            }
            set enableSelectToolToAddShape(e) {
                this.$$set({
                    enableSelectToolToAddShape: e
                }),
                $a()
            }
            get enableAutoSelectMoveTool() {
                return this.$$.ctx[105]
            }
            set enableAutoSelectMoveTool(e) {
                this.$$set({
                    enableAutoSelectMoveTool: e
                }),
                $a()
            }
            get enableTapToAddText() {
                return this.$$.ctx[13]
            }
            set enableTapToAddText(e) {
                this.$$set({
                    enableTapToAddText: e
                }),
                $a()
            }
            get enableMoveTool() {
                return this.$$.ctx[106]
            }
            set enableMoveTool(e) {
                this.$$set({
                    enableMoveTool: e
                }),
                $a()
            }
            get enableViewTool() {
                return this.$$.ctx[107]
            }
            set enableViewTool(e) {
                this.$$set({
                    enableViewTool: e
                }),
                $a()
            }
            get enableToolShareStyles() {
                return this.$$.ctx[108]
            }
            set enableToolShareStyles(e) {
                this.$$set({
                    enableToolShareStyles: e
                }),
                $a()
            }
            get enableMultiSelect() {
                return this.$$.ctx[14]
            }
            set enableMultiSelect(e) {
                this.$$set({
                    enableMultiSelect: e
                }),
                $a()
            }
            get gridSize() {
                return this.$$.ctx[15]
            }
            set gridSize(e) {
                this.$$set({
                    gridSize: e
                }),
                $a()
            }
            get snapThreshold() {
                return this.$$.ctx[16]
            }
            set snapThreshold(e) {
                this.$$set({
                    snapThreshold: e
                }),
                $a()
            }
            get enableSnapToContext() {
                return this.$$.ctx[17]
            }
            set enableSnapToContext(e) {
                this.$$set({
                    enableSnapToContext: e
                }),
                $a()
            }
            get willRenderHeaderTools() {
                return this.$$.ctx[109]
            }
            set willRenderHeaderTools(e) {
                this.$$set({
                    willRenderHeaderTools: e
                }),
                $a()
            }
            get willRenderPresetToolbar() {
                return this.$$.ctx[110]
            }
            set willRenderPresetToolbar(e) {
                this.$$set({
                    willRenderPresetToolbar: e
                }),
                $a()
            }
            get willRenderShapeStyleControls() {
                return this.$$.ctx[18]
            }
            set willRenderShapeStyleControls(e) {
                this.$$set({
                    willRenderShapeStyleControls: e
                }),
                $a()
            }
            get willStartInteraction() {
                return this.$$.ctx[111]
            }
            set willStartInteraction(e) {
                this.$$set({
                    willStartInteraction: e
                }),
                $a()
            }
            get shapePresets() {
                return this.$$.ctx[19]
            }
            set shapePresets(e) {
                this.$$set({
                    shapePresets: e
                }),
                $a()
            }
            get utilKey() {
                return this.$$.ctx[20]
            }
            set utilKey(e) {
                this.$$set({
                    utilKey: e
                }),
                $a()
            }
            get mapScreenPointToImagePoint() {
                return this.$$.ctx[21]
            }
            set mapScreenPointToImagePoint(e) {
                this.$$set({
                    mapScreenPointToImagePoint: e
                }),
                $a()
            }
            get mapImagePointToScreenPoint() {
                return this.$$.ctx[22]
            }
            set mapImagePointToScreenPoint(e) {
                this.$$set({
                    mapImagePointToScreenPoint: e
                }),
                $a()
            }
            get imageRotation() {
                return this.$$.ctx[23]
            }
            set imageRotation(e) {
                this.$$set({
                    imageRotation: e
                }),
                $a()
            }
            get imageFlipX() {
                return this.$$.ctx[24]
            }
            set imageFlipX(e) {
                this.$$set({
                    imageFlipX: e
                }),
                $a()
            }
            get imageFlipY() {
                return this.$$.ctx[25]
            }
            set imageFlipY(e) {
                this.$$set({
                    imageFlipY: e
                }),
                $a()
            }
            get parentRect() {
                return this.$$.ctx[26]
            }
            set parentRect(e) {
                this.$$set({
                    parentRect: e
                }),
                $a()
            }
            get hooks() {
                return this.$$.ctx[112]
            }
            set hooks(e) {
                this.$$set({
                    hooks: e
                }),
                $a()
            }
        }
        var _$ = (e, t, i, o, n, r, a, s, l) => {
            const c = Me(e)
              , u = .5 * i.width
              , d = .5 * i.height
              , p = .5 * t.width
              , h = .5 * t.height
              , m = n.x + o.x
              , f = n.y + o.y;
            s && (c.x = i.width - c.x),
            l && (c.y = i.height - c.y);
            const g = Math.cos(r)
              , y = Math.sin(r);
            c.x -= u,
            c.y -= d;
            const $ = c.x * g - c.y * y
              , b = c.x * y + c.y * g;
            c.x = u + $,
            c.y = d + b,
            c.x *= a,
            c.y *= a,
            c.x += p,
            c.y += h,
            c.x += m,
            c.y += f,
            c.x -= u * a,
            c.y -= d * a;
            const v = (n.x - m) * a
              , x = (n.y - f) * a
              , w = v * g - x * y
              , S = v * y + x * g;
            return c.x += w,
            c.y += S,
            c
        }
          , k$ = (e, t, i, o, n, r, a, s, l) => {
            const c = Me(e)
              , u = ot(i)
              , d = ot(t)
              , p = Ce(n.x + o.x, n.y + o.y)
              , h = Math.cos(r)
              , m = Math.sin(r);
            c.x -= d.x,
            c.y -= d.y;
            const f = (n.x - p.x) * a
              , g = (n.y - p.y) * a
              , y = f * h - g * m
              , $ = f * m + g * h;
            c.x -= y,
            c.y -= $,
            c.x -= p.x,
            c.y -= p.y,
            c.x /= a,
            c.y /= a;
            const b = c.x * h + c.y * m
              , v = c.x * m - c.y * h;
            return c.x = b,
            c.y = -v,
            c.x += u.x,
            c.y += u.y,
            s && (c.x = i.width - c.x),
            l && (c.y = i.height - c.y),
            c
        }
          , C$ = e => "boolean" == typeof e;
        function T$(e) {
            let t, i, o;
            function n(t) {
                e[60](t)
            }
            let r = {
                utilKey: e[1],
                stores: e[5],
                locale: e[6],
                isActive: e[2],
                isActiveFraction: e[3],
                isVisible: e[4],
                mapScreenPointToImagePoint: e[46],
                mapImagePointToScreenPoint: e[45],
                imageRotation: e[47],
                imageFlipX: e[44],
                imageFlipY: e[43],
                shapes: e[49],
                toolbar: e[21] || e[7],
                toolShapes: e[22] || e[8],
                toolRetainStyles: e[9],
                enableSelectToolToAddShape: e[31],
                enableTapToAddText: e[32],
                enableViewTool: e[30],
                enableMoveTool: e[34],
                enableAutoSelectMoveTool: e[33],
                enableMultiSelect: e[35],
                snapThreshold: e[16],
                gridSize: Wi(e[18]) ? e[18] : e[15],
                enableSnapToContext: C$(e[19]) ? e[19] : e[17],
                enableToolShareStyles: e[13],
                shapeControls: e[23] || e[10],
                shapePresets: e[27],
                enableButtonFlipVertical: e[24],
                parentRect: e[50],
                enablePresetDropImage: e[26],
                enablePresetSelectImage: e[25],
                toolSelectRadius: e[11],
                textInputMode: e[12],
                willStartInteraction: e[14],
                willRenderPresetToolbar: e[28] || e[20],
                willRenderShapeStyleControls: e[29],
                hooks: {
                    willRenderShapeControls: e[36],
                    willRenderShapeTextControls: e[37],
                    beforeAddShape: e[38],
                    beforeRemoveShape: e[39],
                    beforeDeselectShape: e[40],
                    beforeSelectShape: e[41],
                    beforeUpdateShape: e[42]
                }
            };
            return void 0 !== e[0] && (r.toolActive = e[0]),
            t = new S$({
                props: r
            }),
            aa.push(( () => Da(t, "toolActive", n))),
            t.$on("measure", e[61]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(e, o) {
                    const n = {};
                    32 & o[0] && (n.stores = e[5]),
                    64 & o[0] && (n.locale = e[6]),
                    4 & o[0] && (n.isActive = e[2]),
                    8 & o[0] && (n.isActiveFraction = e[3]),
                    16 & o[0] && (n.isVisible = e[4]),
                    32768 & o[1] && (n.mapScreenPointToImagePoint = e[46]),
                    16384 & o[1] && (n.mapImagePointToScreenPoint = e[45]),
                    65536 & o[1] && (n.imageRotation = e[47]),
                    8192 & o[1] && (n.imageFlipX = e[44]),
                    4096 & o[1] && (n.imageFlipY = e[43]),
                    2097280 & o[0] && (n.toolbar = e[21] || e[7]),
                    4194560 & o[0] && (n.toolShapes = e[22] || e[8]),
                    512 & o[0] && (n.toolRetainStyles = e[9]),
                    1 & o[1] && (n.enableSelectToolToAddShape = e[31]),
                    2 & o[1] && (n.enableTapToAddText = e[32]),
                    1073741824 & o[0] && (n.enableViewTool = e[30]),
                    8 & o[1] && (n.enableMoveTool = e[34]),
                    4 & o[1] && (n.enableAutoSelectMoveTool = e[33]),
                    16 & o[1] && (n.enableMultiSelect = e[35]),
                    65536 & o[0] && (n.snapThreshold = e[16]),
                    294912 & o[0] && (n.gridSize = Wi(e[18]) ? e[18] : e[15]),
                    655360 & o[0] && (n.enableSnapToContext = C$(e[19]) ? e[19] : e[17]),
                    8192 & o[0] && (n.enableToolShareStyles = e[13]),
                    8389632 & o[0] && (n.shapeControls = e[23] || e[10]),
                    134217728 & o[0] && (n.shapePresets = e[27]),
                    16777216 & o[0] && (n.enableButtonFlipVertical = e[24]),
                    67108864 & o[0] && (n.enablePresetDropImage = e[26]),
                    33554432 & o[0] && (n.enablePresetSelectImage = e[25]),
                    2048 & o[0] && (n.toolSelectRadius = e[11]),
                    4096 & o[0] && (n.textInputMode = e[12]),
                    16384 & o[0] && (n.willStartInteraction = e[14]),
                    269484032 & o[0] && (n.willRenderPresetToolbar = e[28] || e[20]),
                    536870912 & o[0] && (n.willRenderShapeStyleControls = e[29]),
                    4064 & o[1] && (n.hooks = {
                        willRenderShapeControls: e[36],
                        willRenderShapeTextControls: e[37],
                        beforeAddShape: e[38],
                        beforeRemoveShape: e[39],
                        beforeDeselectShape: e[40],
                        beforeSelectShape: e[41],
                        beforeUpdateShape: e[42]
                    }),
                    !i && 1 & o[0] && (i = !0,
                    n.toolActive = e[0],
                    ma(( () => i = !1))),
                    t.$set(n)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function M$(e, t, i) {
            let o, n, r, a, s, l, c, u, d, {isActive: p} = t, {isActiveFraction: h} = t, {isVisible: m} = t, {stores: f} = t, {locale: g={}} = t, {markupEditorToolbar: y} = t, {markupEditorToolStyles: $} = t, {markupEditorToolRetainStyles: b} = t, {markupEditorShapeStyleControls: v} = t, {markupEditorToolSelectRadius: x} = t, {markupEditorTextInputMode: w} = t, {markupEditorToolShareStyles: S} = t, {markupEditorWillStartInteraction: _} = t, {markupEditorGridSize: k=0} = t, {markupEditorSnapThreshold: C=0} = t, {markupEditorSnapToContext: T=!1} = t, {annotateGridSize: M} = t, {annotateSnapToContext: P} = t, {willRenderShapePresetToolbar: E} = t, {annotateTools: R} = t, {annotateToolShapes: A} = t, {annotateShapeControls: I} = t, {annotateActiveTool: L} = t, {annotateEnableButtonFlipVertical: D=!1} = t, {annotateEnableSelectImagePreset: z=!1} = t, {annotateEnableDropImagePreset: F=!0} = t, {annotatePresets: O=[]} = t, {annotateWillRenderShapePresetToolbar: B} = t, {annotateWillRenderShapeStyleControls: N} = t, {enableViewTool: W} = t, {enableSelectToolToAddShape: H} = t, {enableTapToAddText: j} = t, {enableAutoSelectMoveTool: U} = t, {enableMoveTool: V} = t, {enableMultiSelect: q} = t, {willRenderShapeControls: G} = t, {willRenderShapeTextControls: K} = t, {beforeAddShape: X} = t, {beforeRemoveShape: Z} = t, {beforeDeselectShape: Y} = t, {beforeSelectShape: Q} = t, {beforeUpdateShape: J} = t;
            const {rootRect: ee, imageAnnotation: te, imageSize: ie, imageRotation: oe, imageFlipX: ne, imageFlipY: re, imageTransforms: ae, imageTransformsInterpolated: se} = f;
            return cr(e, ee, (e => i(59, u = e))),
            cr(e, ie, (e => i(58, c = e))),
            cr(e, oe, (e => i(47, d = e))),
            cr(e, ne, (e => i(44, a = e))),
            cr(e, re, (e => i(43, r = e))),
            cr(e, ae, (e => i(57, l = e))),
            cr(e, se, (e => i(56, s = e))),
            e.$$set = e => {
                "isActive"in e && i(2, p = e.isActive),
                "isActiveFraction"in e && i(3, h = e.isActiveFraction),
                "isVisible"in e && i(4, m = e.isVisible),
                "stores"in e && i(5, f = e.stores),
                "locale"in e && i(6, g = e.locale),
                "markupEditorToolbar"in e && i(7, y = e.markupEditorToolbar),
                "markupEditorToolStyles"in e && i(8, $ = e.markupEditorToolStyles),
                "markupEditorToolRetainStyles"in e && i(9, b = e.markupEditorToolRetainStyles),
                "markupEditorShapeStyleControls"in e && i(10, v = e.markupEditorShapeStyleControls),
                "markupEditorToolSelectRadius"in e && i(11, x = e.markupEditorToolSelectRadius),
                "markupEditorTextInputMode"in e && i(12, w = e.markupEditorTextInputMode),
                "markupEditorToolShareStyles"in e && i(13, S = e.markupEditorToolShareStyles),
                "markupEditorWillStartInteraction"in e && i(14, _ = e.markupEditorWillStartInteraction),
                "markupEditorGridSize"in e && i(15, k = e.markupEditorGridSize),
                "markupEditorSnapThreshold"in e && i(16, C = e.markupEditorSnapThreshold),
                "markupEditorSnapToContext"in e && i(17, T = e.markupEditorSnapToContext),
                "annotateGridSize"in e && i(18, M = e.annotateGridSize),
                "annotateSnapToContext"in e && i(19, P = e.annotateSnapToContext),
                "willRenderShapePresetToolbar"in e && i(20, E = e.willRenderShapePresetToolbar),
                "annotateTools"in e && i(21, R = e.annotateTools),
                "annotateToolShapes"in e && i(22, A = e.annotateToolShapes),
                "annotateShapeControls"in e && i(23, I = e.annotateShapeControls),
                "annotateActiveTool"in e && i(0, L = e.annotateActiveTool),
                "annotateEnableButtonFlipVertical"in e && i(24, D = e.annotateEnableButtonFlipVertical),
                "annotateEnableSelectImagePreset"in e && i(25, z = e.annotateEnableSelectImagePreset),
                "annotateEnableDropImagePreset"in e && i(26, F = e.annotateEnableDropImagePreset),
                "annotatePresets"in e && i(27, O = e.annotatePresets),
                "annotateWillRenderShapePresetToolbar"in e && i(28, B = e.annotateWillRenderShapePresetToolbar),
                "annotateWillRenderShapeStyleControls"in e && i(29, N = e.annotateWillRenderShapeStyleControls),
                "enableViewTool"in e && i(30, W = e.enableViewTool),
                "enableSelectToolToAddShape"in e && i(31, H = e.enableSelectToolToAddShape),
                "enableTapToAddText"in e && i(32, j = e.enableTapToAddText),
                "enableAutoSelectMoveTool"in e && i(33, U = e.enableAutoSelectMoveTool),
                "enableMoveTool"in e && i(34, V = e.enableMoveTool),
                "enableMultiSelect"in e && i(35, q = e.enableMultiSelect),
                "willRenderShapeControls"in e && i(36, G = e.willRenderShapeControls),
                "willRenderShapeTextControls"in e && i(37, K = e.willRenderShapeTextControls),
                "beforeAddShape"in e && i(38, X = e.beforeAddShape),
                "beforeRemoveShape"in e && i(39, Z = e.beforeRemoveShape),
                "beforeDeselectShape"in e && i(40, Y = e.beforeDeselectShape),
                "beforeSelectShape"in e && i(41, Q = e.beforeSelectShape),
                "beforeUpdateShape"in e && i(42, J = e.beforeUpdateShape)
            }
            ,
            e.$$.update = () => {
                503328768 & e.$$.dirty[1] && i(46, o = e => k$(e, u, c, s.origin, s.translation, l.rotation.z, s.scale, a, r)),
                503328768 & e.$$.dirty[1] && i(45, n = e => _$(e, u, c, s.origin, s.translation, l.rotation.z, s.scale, a, r))
            }
            ,
            [L, "annotate", p, h, m, f, g, y, $, b, v, x, w, S, _, k, C, T, M, P, E, R, A, I, D, z, F, O, B, N, W, H, j, U, V, q, G, K, X, Z, Y, Q, J, r, a, n, o, d, ee, te, ie, oe, ne, re, ae, se, s, l, c, u, function(e) {
                L = e,
                i(0, L)
            }
            , function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var P$ = {
            util: ["annotate", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, M$, T$, ar, {
                        name: 1,
                        isActive: 2,
                        isActiveFraction: 3,
                        isVisible: 4,
                        stores: 5,
                        locale: 6,
                        markupEditorToolbar: 7,
                        markupEditorToolStyles: 8,
                        markupEditorToolRetainStyles: 9,
                        markupEditorShapeStyleControls: 10,
                        markupEditorToolSelectRadius: 11,
                        markupEditorTextInputMode: 12,
                        markupEditorToolShareStyles: 13,
                        markupEditorWillStartInteraction: 14,
                        markupEditorGridSize: 15,
                        markupEditorSnapThreshold: 16,
                        markupEditorSnapToContext: 17,
                        annotateGridSize: 18,
                        annotateSnapToContext: 19,
                        willRenderShapePresetToolbar: 20,
                        annotateTools: 21,
                        annotateToolShapes: 22,
                        annotateShapeControls: 23,
                        annotateActiveTool: 0,
                        annotateEnableButtonFlipVertical: 24,
                        annotateEnableSelectImagePreset: 25,
                        annotateEnableDropImagePreset: 26,
                        annotatePresets: 27,
                        annotateWillRenderShapePresetToolbar: 28,
                        annotateWillRenderShapeStyleControls: 29,
                        enableViewTool: 30,
                        enableSelectToolToAddShape: 31,
                        enableTapToAddText: 32,
                        enableAutoSelectMoveTool: 33,
                        enableMoveTool: 34,
                        enableMultiSelect: 35,
                        willRenderShapeControls: 36,
                        willRenderShapeTextControls: 37,
                        beforeAddShape: 38,
                        beforeRemoveShape: 39,
                        beforeDeselectShape: 40,
                        beforeSelectShape: 41,
                        beforeUpdateShape: 42
                    }, null, [-1, -1])
                }
                get name() {
                    return this.$$.ctx[1]
                }
                get isActive() {
                    return this.$$.ctx[2]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get isActiveFraction() {
                    return this.$$.ctx[3]
                }
                set isActiveFraction(e) {
                    this.$$set({
                        isActiveFraction: e
                    }),
                    $a()
                }
                get isVisible() {
                    return this.$$.ctx[4]
                }
                set isVisible(e) {
                    this.$$set({
                        isVisible: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[5]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[6]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get markupEditorToolbar() {
                    return this.$$.ctx[7]
                }
                set markupEditorToolbar(e) {
                    this.$$set({
                        markupEditorToolbar: e
                    }),
                    $a()
                }
                get markupEditorToolStyles() {
                    return this.$$.ctx[8]
                }
                set markupEditorToolStyles(e) {
                    this.$$set({
                        markupEditorToolStyles: e
                    }),
                    $a()
                }
                get markupEditorToolRetainStyles() {
                    return this.$$.ctx[9]
                }
                set markupEditorToolRetainStyles(e) {
                    this.$$set({
                        markupEditorToolRetainStyles: e
                    }),
                    $a()
                }
                get markupEditorShapeStyleControls() {
                    return this.$$.ctx[10]
                }
                set markupEditorShapeStyleControls(e) {
                    this.$$set({
                        markupEditorShapeStyleControls: e
                    }),
                    $a()
                }
                get markupEditorToolSelectRadius() {
                    return this.$$.ctx[11]
                }
                set markupEditorToolSelectRadius(e) {
                    this.$$set({
                        markupEditorToolSelectRadius: e
                    }),
                    $a()
                }
                get markupEditorTextInputMode() {
                    return this.$$.ctx[12]
                }
                set markupEditorTextInputMode(e) {
                    this.$$set({
                        markupEditorTextInputMode: e
                    }),
                    $a()
                }
                get markupEditorToolShareStyles() {
                    return this.$$.ctx[13]
                }
                set markupEditorToolShareStyles(e) {
                    this.$$set({
                        markupEditorToolShareStyles: e
                    }),
                    $a()
                }
                get markupEditorWillStartInteraction() {
                    return this.$$.ctx[14]
                }
                set markupEditorWillStartInteraction(e) {
                    this.$$set({
                        markupEditorWillStartInteraction: e
                    }),
                    $a()
                }
                get markupEditorGridSize() {
                    return this.$$.ctx[15]
                }
                set markupEditorGridSize(e) {
                    this.$$set({
                        markupEditorGridSize: e
                    }),
                    $a()
                }
                get markupEditorSnapThreshold() {
                    return this.$$.ctx[16]
                }
                set markupEditorSnapThreshold(e) {
                    this.$$set({
                        markupEditorSnapThreshold: e
                    }),
                    $a()
                }
                get markupEditorSnapToContext() {
                    return this.$$.ctx[17]
                }
                set markupEditorSnapToContext(e) {
                    this.$$set({
                        markupEditorSnapToContext: e
                    }),
                    $a()
                }
                get annotateGridSize() {
                    return this.$$.ctx[18]
                }
                set annotateGridSize(e) {
                    this.$$set({
                        annotateGridSize: e
                    }),
                    $a()
                }
                get annotateSnapToContext() {
                    return this.$$.ctx[19]
                }
                set annotateSnapToContext(e) {
                    this.$$set({
                        annotateSnapToContext: e
                    }),
                    $a()
                }
                get willRenderShapePresetToolbar() {
                    return this.$$.ctx[20]
                }
                set willRenderShapePresetToolbar(e) {
                    this.$$set({
                        willRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get annotateTools() {
                    return this.$$.ctx[21]
                }
                set annotateTools(e) {
                    this.$$set({
                        annotateTools: e
                    }),
                    $a()
                }
                get annotateToolShapes() {
                    return this.$$.ctx[22]
                }
                set annotateToolShapes(e) {
                    this.$$set({
                        annotateToolShapes: e
                    }),
                    $a()
                }
                get annotateShapeControls() {
                    return this.$$.ctx[23]
                }
                set annotateShapeControls(e) {
                    this.$$set({
                        annotateShapeControls: e
                    }),
                    $a()
                }
                get annotateActiveTool() {
                    return this.$$.ctx[0]
                }
                set annotateActiveTool(e) {
                    this.$$set({
                        annotateActiveTool: e
                    }),
                    $a()
                }
                get annotateEnableButtonFlipVertical() {
                    return this.$$.ctx[24]
                }
                set annotateEnableButtonFlipVertical(e) {
                    this.$$set({
                        annotateEnableButtonFlipVertical: e
                    }),
                    $a()
                }
                get annotateEnableSelectImagePreset() {
                    return this.$$.ctx[25]
                }
                set annotateEnableSelectImagePreset(e) {
                    this.$$set({
                        annotateEnableSelectImagePreset: e
                    }),
                    $a()
                }
                get annotateEnableDropImagePreset() {
                    return this.$$.ctx[26]
                }
                set annotateEnableDropImagePreset(e) {
                    this.$$set({
                        annotateEnableDropImagePreset: e
                    }),
                    $a()
                }
                get annotatePresets() {
                    return this.$$.ctx[27]
                }
                set annotatePresets(e) {
                    this.$$set({
                        annotatePresets: e
                    }),
                    $a()
                }
                get annotateWillRenderShapePresetToolbar() {
                    return this.$$.ctx[28]
                }
                set annotateWillRenderShapePresetToolbar(e) {
                    this.$$set({
                        annotateWillRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get annotateWillRenderShapeStyleControls() {
                    return this.$$.ctx[29]
                }
                set annotateWillRenderShapeStyleControls(e) {
                    this.$$set({
                        annotateWillRenderShapeStyleControls: e
                    }),
                    $a()
                }
                get enableViewTool() {
                    return this.$$.ctx[30]
                }
                set enableViewTool(e) {
                    this.$$set({
                        enableViewTool: e
                    }),
                    $a()
                }
                get enableSelectToolToAddShape() {
                    return this.$$.ctx[31]
                }
                set enableSelectToolToAddShape(e) {
                    this.$$set({
                        enableSelectToolToAddShape: e
                    }),
                    $a()
                }
                get enableTapToAddText() {
                    return this.$$.ctx[32]
                }
                set enableTapToAddText(e) {
                    this.$$set({
                        enableTapToAddText: e
                    }),
                    $a()
                }
                get enableAutoSelectMoveTool() {
                    return this.$$.ctx[33]
                }
                set enableAutoSelectMoveTool(e) {
                    this.$$set({
                        enableAutoSelectMoveTool: e
                    }),
                    $a()
                }
                get enableMoveTool() {
                    return this.$$.ctx[34]
                }
                set enableMoveTool(e) {
                    this.$$set({
                        enableMoveTool: e
                    }),
                    $a()
                }
                get enableMultiSelect() {
                    return this.$$.ctx[35]
                }
                set enableMultiSelect(e) {
                    this.$$set({
                        enableMultiSelect: e
                    }),
                    $a()
                }
                get willRenderShapeControls() {
                    return this.$$.ctx[36]
                }
                set willRenderShapeControls(e) {
                    this.$$set({
                        willRenderShapeControls: e
                    }),
                    $a()
                }
                get willRenderShapeTextControls() {
                    return this.$$.ctx[37]
                }
                set willRenderShapeTextControls(e) {
                    this.$$set({
                        willRenderShapeTextControls: e
                    }),
                    $a()
                }
                get beforeAddShape() {
                    return this.$$.ctx[38]
                }
                set beforeAddShape(e) {
                    this.$$set({
                        beforeAddShape: e
                    }),
                    $a()
                }
                get beforeRemoveShape() {
                    return this.$$.ctx[39]
                }
                set beforeRemoveShape(e) {
                    this.$$set({
                        beforeRemoveShape: e
                    }),
                    $a()
                }
                get beforeDeselectShape() {
                    return this.$$.ctx[40]
                }
                set beforeDeselectShape(e) {
                    this.$$set({
                        beforeDeselectShape: e
                    }),
                    $a()
                }
                get beforeSelectShape() {
                    return this.$$.ctx[41]
                }
                set beforeSelectShape(e) {
                    this.$$set({
                        beforeSelectShape: e
                    }),
                    $a()
                }
                get beforeUpdateShape() {
                    return this.$$.ctx[42]
                }
                set beforeUpdateShape(e) {
                    this.$$set({
                        beforeUpdateShape: e
                    }),
                    $a()
                }
            }
            ]
        };
        function E$(e) {
            let t, i, o;
            function n(t) {
                e[52](t)
            }
            let r = {
                utilKey: e[1],
                stores: e[5],
                locale: e[6],
                isActive: e[2],
                isActiveFraction: e[3],
                isVisible: e[4],
                mapScreenPointToImagePoint: e[44],
                mapImagePointToScreenPoint: e[43],
                shapes: e[46],
                toolbar: e[20] || e[7],
                toolShapes: e[21] || e[8],
                toolRetainStyles: e[9],
                shapeControls: e[22] || e[10],
                shapePresets: e[26],
                enableSelectToolToAddShape: e[29],
                enableTapToAddText: e[30],
                enableViewTool: e[31],
                enableMoveTool: e[32],
                enableAutoSelectMoveTool: e[33],
                enableMultiSelect: e[34],
                snapThreshold: e[16],
                gridSize: Wi(e[18]) ? e[18] : e[15],
                enableSnapToContext: C$(e[19]) ? e[19] : e[17],
                enableToolShareStyles: e[13],
                enablePresetSelectImage: e[24],
                enablePresetDropImage: e[25],
                enableButtonFlipVertical: e[23],
                parentRect: e[45],
                toolSelectRadius: e[11],
                textInputMode: e[12],
                willStartInteraction: e[42],
                willRenderPresetToolbar: e[27] || e[14],
                willRenderShapeStyleControls: e[28],
                hooks: {
                    willRenderShapeControls: e[35],
                    willRenderShapeTextControls: e[36],
                    beforeAddShape: e[37],
                    beforeRemoveShape: e[38],
                    beforeDeselectShape: e[39],
                    beforeSelectShape: e[40],
                    beforeUpdateShape: e[41]
                }
            };
            return void 0 !== e[0] && (r.toolActive = e[0]),
            t = new S$({
                props: r
            }),
            aa.push(( () => Da(t, "toolActive", n))),
            t.$on("measure", e[53]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, i) {
                    Fa(t, e, i),
                    o = !0
                },
                p(e, o) {
                    const n = {};
                    32 & o[0] && (n.stores = e[5]),
                    64 & o[0] && (n.locale = e[6]),
                    4 & o[0] && (n.isActive = e[2]),
                    8 & o[0] && (n.isActiveFraction = e[3]),
                    16 & o[0] && (n.isVisible = e[4]),
                    8192 & o[1] && (n.mapScreenPointToImagePoint = e[44]),
                    4096 & o[1] && (n.mapImagePointToScreenPoint = e[43]),
                    1048704 & o[0] && (n.toolbar = e[20] || e[7]),
                    2097408 & o[0] && (n.toolShapes = e[21] || e[8]),
                    512 & o[0] && (n.toolRetainStyles = e[9]),
                    4195328 & o[0] && (n.shapeControls = e[22] || e[10]),
                    67108864 & o[0] && (n.shapePresets = e[26]),
                    536870912 & o[0] && (n.enableSelectToolToAddShape = e[29]),
                    1073741824 & o[0] && (n.enableTapToAddText = e[30]),
                    1 & o[1] && (n.enableViewTool = e[31]),
                    2 & o[1] && (n.enableMoveTool = e[32]),
                    4 & o[1] && (n.enableAutoSelectMoveTool = e[33]),
                    8 & o[1] && (n.enableMultiSelect = e[34]),
                    65536 & o[0] && (n.snapThreshold = e[16]),
                    294912 & o[0] && (n.gridSize = Wi(e[18]) ? e[18] : e[15]),
                    655360 & o[0] && (n.enableSnapToContext = C$(e[19]) ? e[19] : e[17]),
                    8192 & o[0] && (n.enableToolShareStyles = e[13]),
                    16777216 & o[0] && (n.enablePresetSelectImage = e[24]),
                    33554432 & o[0] && (n.enablePresetDropImage = e[25]),
                    8388608 & o[0] && (n.enableButtonFlipVertical = e[23]),
                    2048 & o[0] && (n.toolSelectRadius = e[11]),
                    4096 & o[0] && (n.textInputMode = e[12]),
                    2048 & o[1] && (n.willStartInteraction = e[42]),
                    134234112 & o[0] && (n.willRenderPresetToolbar = e[27] || e[14]),
                    268435456 & o[0] && (n.willRenderShapeStyleControls = e[28]),
                    2032 & o[1] && (n.hooks = {
                        willRenderShapeControls: e[35],
                        willRenderShapeTextControls: e[36],
                        beforeAddShape: e[37],
                        beforeRemoveShape: e[38],
                        beforeDeselectShape: e[39],
                        beforeSelectShape: e[40],
                        beforeUpdateShape: e[41]
                    }),
                    !i && 1 & o[0] && (i = !0,
                    n.toolActive = e[0],
                    ma(( () => i = !1))),
                    t.$set(n)
                },
                i(e) {
                    o || (ka(t.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function R$(e, t, i) {
            let o, n, r, a, s, {isActive: l} = t, {isActiveFraction: c} = t, {isVisible: u} = t, {stores: d} = t, {locale: p={}} = t, {markupEditorToolbar: h} = t, {markupEditorToolStyles: m} = t, {markupEditorToolRetainStyles: f} = t, {markupEditorShapeStyleControls: g} = t, {markupEditorToolSelectRadius: y} = t, {markupEditorTextInputMode: $} = t, {markupEditorToolShareStyles: b} = t, {willRenderShapePresetToolbar: v} = t, {markupEditorGridSize: x} = t, {markupEditorSnapThreshold: w} = t, {markupEditorSnapToContext: S=!0} = t, {decorateGridSize: _} = t, {decorateSnapToContext: k} = t, {decorateTools: C} = t, {decorateToolShapes: T} = t, {decorateShapeControls: M} = t, {decorateActiveTool: P} = t, {decorateEnableButtonFlipVertical: E=!1} = t, {decorateEnableSelectImagePreset: R=!1} = t, {decorateEnableDropImagePreset: A=!0} = t, {decoratePresets: I=[]} = t, {decorateWillRenderShapePresetToolbar: L} = t, {decorateWillRenderShapeStyleControls: D} = t, {enableSelectToolToAddShape: z} = t, {enableTapToAddText: F} = t, {enableViewTool: O} = t, {enableMoveTool: B} = t, {enableAutoSelectMoveTool: N} = t, {enableMultiSelect: W} = t, {willRenderShapeControls: H} = t, {willRenderShapeTextControls: j} = t, {beforeAddShape: U} = t, {beforeRemoveShape: V} = t, {beforeDeselectShape: q} = t, {beforeSelectShape: G} = t, {beforeUpdateShape: K} = t, {markupEditorWillStartInteraction: X} = t;
            const {imageCropRect: Z, imageDecoration: Y, imageSelectionRectPresentation: Q, imageTransformsInterpolated: J} = d;
            return cr(e, Q, (e => i(50, a = e))),
            cr(e, J, (e => i(51, s = e))),
            e.$$set = e => {
                "isActive"in e && i(2, l = e.isActive),
                "isActiveFraction"in e && i(3, c = e.isActiveFraction),
                "isVisible"in e && i(4, u = e.isVisible),
                "stores"in e && i(5, d = e.stores),
                "locale"in e && i(6, p = e.locale),
                "markupEditorToolbar"in e && i(7, h = e.markupEditorToolbar),
                "markupEditorToolStyles"in e && i(8, m = e.markupEditorToolStyles),
                "markupEditorToolRetainStyles"in e && i(9, f = e.markupEditorToolRetainStyles),
                "markupEditorShapeStyleControls"in e && i(10, g = e.markupEditorShapeStyleControls),
                "markupEditorToolSelectRadius"in e && i(11, y = e.markupEditorToolSelectRadius),
                "markupEditorTextInputMode"in e && i(12, $ = e.markupEditorTextInputMode),
                "markupEditorToolShareStyles"in e && i(13, b = e.markupEditorToolShareStyles),
                "willRenderShapePresetToolbar"in e && i(14, v = e.willRenderShapePresetToolbar),
                "markupEditorGridSize"in e && i(15, x = e.markupEditorGridSize),
                "markupEditorSnapThreshold"in e && i(16, w = e.markupEditorSnapThreshold),
                "markupEditorSnapToContext"in e && i(17, S = e.markupEditorSnapToContext),
                "decorateGridSize"in e && i(18, _ = e.decorateGridSize),
                "decorateSnapToContext"in e && i(19, k = e.decorateSnapToContext),
                "decorateTools"in e && i(20, C = e.decorateTools),
                "decorateToolShapes"in e && i(21, T = e.decorateToolShapes),
                "decorateShapeControls"in e && i(22, M = e.decorateShapeControls),
                "decorateActiveTool"in e && i(0, P = e.decorateActiveTool),
                "decorateEnableButtonFlipVertical"in e && i(23, E = e.decorateEnableButtonFlipVertical),
                "decorateEnableSelectImagePreset"in e && i(24, R = e.decorateEnableSelectImagePreset),
                "decorateEnableDropImagePreset"in e && i(25, A = e.decorateEnableDropImagePreset),
                "decoratePresets"in e && i(26, I = e.decoratePresets),
                "decorateWillRenderShapePresetToolbar"in e && i(27, L = e.decorateWillRenderShapePresetToolbar),
                "decorateWillRenderShapeStyleControls"in e && i(28, D = e.decorateWillRenderShapeStyleControls),
                "enableSelectToolToAddShape"in e && i(29, z = e.enableSelectToolToAddShape),
                "enableTapToAddText"in e && i(30, F = e.enableTapToAddText),
                "enableViewTool"in e && i(31, O = e.enableViewTool),
                "enableMoveTool"in e && i(32, B = e.enableMoveTool),
                "enableAutoSelectMoveTool"in e && i(33, N = e.enableAutoSelectMoveTool),
                "enableMultiSelect"in e && i(34, W = e.enableMultiSelect),
                "willRenderShapeControls"in e && i(35, H = e.willRenderShapeControls),
                "willRenderShapeTextControls"in e && i(36, j = e.willRenderShapeTextControls),
                "beforeAddShape"in e && i(37, U = e.beforeAddShape),
                "beforeRemoveShape"in e && i(38, V = e.beforeRemoveShape),
                "beforeDeselectShape"in e && i(39, q = e.beforeDeselectShape),
                "beforeSelectShape"in e && i(40, G = e.beforeSelectShape),
                "beforeUpdateShape"in e && i(41, K = e.beforeUpdateShape),
                "markupEditorWillStartInteraction"in e && i(42, X = e.markupEditorWillStartInteraction)
            }
            ,
            e.$$.update = () => {
                1048576 & e.$$.dirty[1] && i(49, o = s ? s.scale : 1),
                786432 & e.$$.dirty[1] && i(44, n = e => {
                    const t = Me(e);
                    return t.x -= a.x,
                    t.y -= a.y,
                    t.x /= o,
                    t.y /= o,
                    t
                }
                ),
                786432 & e.$$.dirty[1] && i(43, r = e => {
                    const t = Me(e);
                    return t.x *= o,
                    t.y *= o,
                    t.x += a.x,
                    t.y += a.y,
                    t
                }
                )
            }
            ,
            [P, "decorate", l, c, u, d, p, h, m, f, g, y, $, b, v, x, w, S, _, k, C, T, M, E, R, A, I, L, D, z, F, O, B, N, W, H, j, U, V, q, G, K, X, r, n, Z, Y, Q, J, o, a, s, function(e) {
                P = e,
                i(0, P)
            }
            , function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var A$ = {
            util: ["decorate", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, R$, E$, ar, {
                        name: 1,
                        isActive: 2,
                        isActiveFraction: 3,
                        isVisible: 4,
                        stores: 5,
                        locale: 6,
                        markupEditorToolbar: 7,
                        markupEditorToolStyles: 8,
                        markupEditorToolRetainStyles: 9,
                        markupEditorShapeStyleControls: 10,
                        markupEditorToolSelectRadius: 11,
                        markupEditorTextInputMode: 12,
                        markupEditorToolShareStyles: 13,
                        willRenderShapePresetToolbar: 14,
                        markupEditorGridSize: 15,
                        markupEditorSnapThreshold: 16,
                        markupEditorSnapToContext: 17,
                        decorateGridSize: 18,
                        decorateSnapToContext: 19,
                        decorateTools: 20,
                        decorateToolShapes: 21,
                        decorateShapeControls: 22,
                        decorateActiveTool: 0,
                        decorateEnableButtonFlipVertical: 23,
                        decorateEnableSelectImagePreset: 24,
                        decorateEnableDropImagePreset: 25,
                        decoratePresets: 26,
                        decorateWillRenderShapePresetToolbar: 27,
                        decorateWillRenderShapeStyleControls: 28,
                        enableSelectToolToAddShape: 29,
                        enableTapToAddText: 30,
                        enableViewTool: 31,
                        enableMoveTool: 32,
                        enableAutoSelectMoveTool: 33,
                        enableMultiSelect: 34,
                        willRenderShapeControls: 35,
                        willRenderShapeTextControls: 36,
                        beforeAddShape: 37,
                        beforeRemoveShape: 38,
                        beforeDeselectShape: 39,
                        beforeSelectShape: 40,
                        beforeUpdateShape: 41,
                        markupEditorWillStartInteraction: 42
                    }, null, [-1, -1])
                }
                get name() {
                    return this.$$.ctx[1]
                }
                get isActive() {
                    return this.$$.ctx[2]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get isActiveFraction() {
                    return this.$$.ctx[3]
                }
                set isActiveFraction(e) {
                    this.$$set({
                        isActiveFraction: e
                    }),
                    $a()
                }
                get isVisible() {
                    return this.$$.ctx[4]
                }
                set isVisible(e) {
                    this.$$set({
                        isVisible: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[5]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[6]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get markupEditorToolbar() {
                    return this.$$.ctx[7]
                }
                set markupEditorToolbar(e) {
                    this.$$set({
                        markupEditorToolbar: e
                    }),
                    $a()
                }
                get markupEditorToolStyles() {
                    return this.$$.ctx[8]
                }
                set markupEditorToolStyles(e) {
                    this.$$set({
                        markupEditorToolStyles: e
                    }),
                    $a()
                }
                get markupEditorToolRetainStyles() {
                    return this.$$.ctx[9]
                }
                set markupEditorToolRetainStyles(e) {
                    this.$$set({
                        markupEditorToolRetainStyles: e
                    }),
                    $a()
                }
                get markupEditorShapeStyleControls() {
                    return this.$$.ctx[10]
                }
                set markupEditorShapeStyleControls(e) {
                    this.$$set({
                        markupEditorShapeStyleControls: e
                    }),
                    $a()
                }
                get markupEditorToolSelectRadius() {
                    return this.$$.ctx[11]
                }
                set markupEditorToolSelectRadius(e) {
                    this.$$set({
                        markupEditorToolSelectRadius: e
                    }),
                    $a()
                }
                get markupEditorTextInputMode() {
                    return this.$$.ctx[12]
                }
                set markupEditorTextInputMode(e) {
                    this.$$set({
                        markupEditorTextInputMode: e
                    }),
                    $a()
                }
                get markupEditorToolShareStyles() {
                    return this.$$.ctx[13]
                }
                set markupEditorToolShareStyles(e) {
                    this.$$set({
                        markupEditorToolShareStyles: e
                    }),
                    $a()
                }
                get willRenderShapePresetToolbar() {
                    return this.$$.ctx[14]
                }
                set willRenderShapePresetToolbar(e) {
                    this.$$set({
                        willRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get markupEditorGridSize() {
                    return this.$$.ctx[15]
                }
                set markupEditorGridSize(e) {
                    this.$$set({
                        markupEditorGridSize: e
                    }),
                    $a()
                }
                get markupEditorSnapThreshold() {
                    return this.$$.ctx[16]
                }
                set markupEditorSnapThreshold(e) {
                    this.$$set({
                        markupEditorSnapThreshold: e
                    }),
                    $a()
                }
                get markupEditorSnapToContext() {
                    return this.$$.ctx[17]
                }
                set markupEditorSnapToContext(e) {
                    this.$$set({
                        markupEditorSnapToContext: e
                    }),
                    $a()
                }
                get decorateGridSize() {
                    return this.$$.ctx[18]
                }
                set decorateGridSize(e) {
                    this.$$set({
                        decorateGridSize: e
                    }),
                    $a()
                }
                get decorateSnapToContext() {
                    return this.$$.ctx[19]
                }
                set decorateSnapToContext(e) {
                    this.$$set({
                        decorateSnapToContext: e
                    }),
                    $a()
                }
                get decorateTools() {
                    return this.$$.ctx[20]
                }
                set decorateTools(e) {
                    this.$$set({
                        decorateTools: e
                    }),
                    $a()
                }
                get decorateToolShapes() {
                    return this.$$.ctx[21]
                }
                set decorateToolShapes(e) {
                    this.$$set({
                        decorateToolShapes: e
                    }),
                    $a()
                }
                get decorateShapeControls() {
                    return this.$$.ctx[22]
                }
                set decorateShapeControls(e) {
                    this.$$set({
                        decorateShapeControls: e
                    }),
                    $a()
                }
                get decorateActiveTool() {
                    return this.$$.ctx[0]
                }
                set decorateActiveTool(e) {
                    this.$$set({
                        decorateActiveTool: e
                    }),
                    $a()
                }
                get decorateEnableButtonFlipVertical() {
                    return this.$$.ctx[23]
                }
                set decorateEnableButtonFlipVertical(e) {
                    this.$$set({
                        decorateEnableButtonFlipVertical: e
                    }),
                    $a()
                }
                get decorateEnableSelectImagePreset() {
                    return this.$$.ctx[24]
                }
                set decorateEnableSelectImagePreset(e) {
                    this.$$set({
                        decorateEnableSelectImagePreset: e
                    }),
                    $a()
                }
                get decorateEnableDropImagePreset() {
                    return this.$$.ctx[25]
                }
                set decorateEnableDropImagePreset(e) {
                    this.$$set({
                        decorateEnableDropImagePreset: e
                    }),
                    $a()
                }
                get decoratePresets() {
                    return this.$$.ctx[26]
                }
                set decoratePresets(e) {
                    this.$$set({
                        decoratePresets: e
                    }),
                    $a()
                }
                get decorateWillRenderShapePresetToolbar() {
                    return this.$$.ctx[27]
                }
                set decorateWillRenderShapePresetToolbar(e) {
                    this.$$set({
                        decorateWillRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get decorateWillRenderShapeStyleControls() {
                    return this.$$.ctx[28]
                }
                set decorateWillRenderShapeStyleControls(e) {
                    this.$$set({
                        decorateWillRenderShapeStyleControls: e
                    }),
                    $a()
                }
                get enableSelectToolToAddShape() {
                    return this.$$.ctx[29]
                }
                set enableSelectToolToAddShape(e) {
                    this.$$set({
                        enableSelectToolToAddShape: e
                    }),
                    $a()
                }
                get enableTapToAddText() {
                    return this.$$.ctx[30]
                }
                set enableTapToAddText(e) {
                    this.$$set({
                        enableTapToAddText: e
                    }),
                    $a()
                }
                get enableViewTool() {
                    return this.$$.ctx[31]
                }
                set enableViewTool(e) {
                    this.$$set({
                        enableViewTool: e
                    }),
                    $a()
                }
                get enableMoveTool() {
                    return this.$$.ctx[32]
                }
                set enableMoveTool(e) {
                    this.$$set({
                        enableMoveTool: e
                    }),
                    $a()
                }
                get enableAutoSelectMoveTool() {
                    return this.$$.ctx[33]
                }
                set enableAutoSelectMoveTool(e) {
                    this.$$set({
                        enableAutoSelectMoveTool: e
                    }),
                    $a()
                }
                get enableMultiSelect() {
                    return this.$$.ctx[34]
                }
                set enableMultiSelect(e) {
                    this.$$set({
                        enableMultiSelect: e
                    }),
                    $a()
                }
                get willRenderShapeControls() {
                    return this.$$.ctx[35]
                }
                set willRenderShapeControls(e) {
                    this.$$set({
                        willRenderShapeControls: e
                    }),
                    $a()
                }
                get willRenderShapeTextControls() {
                    return this.$$.ctx[36]
                }
                set willRenderShapeTextControls(e) {
                    this.$$set({
                        willRenderShapeTextControls: e
                    }),
                    $a()
                }
                get beforeAddShape() {
                    return this.$$.ctx[37]
                }
                set beforeAddShape(e) {
                    this.$$set({
                        beforeAddShape: e
                    }),
                    $a()
                }
                get beforeRemoveShape() {
                    return this.$$.ctx[38]
                }
                set beforeRemoveShape(e) {
                    this.$$set({
                        beforeRemoveShape: e
                    }),
                    $a()
                }
                get beforeDeselectShape() {
                    return this.$$.ctx[39]
                }
                set beforeDeselectShape(e) {
                    this.$$set({
                        beforeDeselectShape: e
                    }),
                    $a()
                }
                get beforeSelectShape() {
                    return this.$$.ctx[40]
                }
                set beforeSelectShape(e) {
                    this.$$set({
                        beforeSelectShape: e
                    }),
                    $a()
                }
                get beforeUpdateShape() {
                    return this.$$.ctx[41]
                }
                set beforeUpdateShape(e) {
                    this.$$set({
                        beforeUpdateShape: e
                    }),
                    $a()
                }
                get markupEditorWillStartInteraction() {
                    return this.$$.ctx[42]
                }
                set markupEditorWillStartInteraction(e) {
                    this.$$set({
                        markupEditorWillStartInteraction: e
                    }),
                    $a()
                }
            }
            ]
        };
        function I$(e) {
            let t, i;
            return t = new S$({
                props: {
                    stores: e[3],
                    locale: e[4],
                    isActive: e[0],
                    isActiveFraction: e[1],
                    isVisible: e[2],
                    mapScreenPointToImagePoint: e[26],
                    mapImagePointToScreenPoint: e[25],
                    utilKey: "sticker",
                    shapePresets: e[5],
                    shapes: e[6] ? e[35] : e[36],
                    toolActive: "preset",
                    imageFlipX: !!e[6] && e[24],
                    imageFlipY: !!e[6] && e[23],
                    imageRotation: e[6] ? e[31] : 0,
                    parentRect: e[6] ? e[37] : e[33],
                    snapThreshold: e[29],
                    gridSize: e[28],
                    enableMultiSelect: e[12],
                    enableSnapToContext: e[27],
                    enablePresetDropImage: e[7],
                    enablePresetSelectImage: e[30],
                    enableButtonFlipVertical: e[10] || e[8],
                    toolSelectRadius: e[15],
                    willStartInteraction: e[22],
                    willRenderPresetToolbar: e[11] || e[9] || e[16],
                    hooks: {
                        willRenderShapeControls: e[13],
                        willRenderShapeTextControls: e[14],
                        beforeAddShape: e[17],
                        beforeRemoveShape: e[18],
                        beforeDeselectShape: e[19],
                        beforeSelectShape: e[20],
                        beforeUpdateShape: e[21]
                    }
                }
            }),
            t.$on("measure", e[60]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    8 & i[0] && (o.stores = e[3]),
                    16 & i[0] && (o.locale = e[4]),
                    1 & i[0] && (o.isActive = e[0]),
                    2 & i[0] && (o.isActiveFraction = e[1]),
                    4 & i[0] && (o.isVisible = e[2]),
                    67108864 & i[0] && (o.mapScreenPointToImagePoint = e[26]),
                    33554432 & i[0] && (o.mapImagePointToScreenPoint = e[25]),
                    32 & i[0] && (o.shapePresets = e[5]),
                    64 & i[0] && (o.shapes = e[6] ? e[35] : e[36]),
                    16777280 & i[0] && (o.imageFlipX = !!e[6] && e[24]),
                    8388672 & i[0] && (o.imageFlipY = !!e[6] && e[23]),
                    64 & i[0] | 1 & i[1] && (o.imageRotation = e[6] ? e[31] : 0),
                    64 & i[0] && (o.parentRect = e[6] ? e[37] : e[33]),
                    536870912 & i[0] && (o.snapThreshold = e[29]),
                    268435456 & i[0] && (o.gridSize = e[28]),
                    4096 & i[0] && (o.enableMultiSelect = e[12]),
                    134217728 & i[0] && (o.enableSnapToContext = e[27]),
                    128 & i[0] && (o.enablePresetDropImage = e[7]),
                    1073741824 & i[0] && (o.enablePresetSelectImage = e[30]),
                    1280 & i[0] && (o.enableButtonFlipVertical = e[10] || e[8]),
                    32768 & i[0] && (o.toolSelectRadius = e[15]),
                    4194304 & i[0] && (o.willStartInteraction = e[22]),
                    68096 & i[0] && (o.willRenderPresetToolbar = e[11] || e[9] || e[16]),
                    4087808 & i[0] && (o.hooks = {
                        willRenderShapeControls: e[13],
                        willRenderShapeTextControls: e[14],
                        beforeAddShape: e[17],
                        beforeRemoveShape: e[18],
                        beforeDeselectShape: e[19],
                        beforeSelectShape: e[20],
                        beforeUpdateShape: e[21]
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function L$(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, {isActive: $} = t, {isActiveFraction: b} = t, {isVisible: v} = t, {stores: x} = t, {locale: w={}} = t, {stickers: S=[]} = t, {stickerForceEnable: _=!1} = t, {stickerStickToImage: k=!1} = t, {stickerEnableSelectImagePreset: C=!0} = t, {stickerEnableDropImagePreset: T=!0} = t, {stickerEnableButtonFlipVertical: M=!1} = t, {stickerWillRenderShapePresetToolbar: P} = t, {stickerEnableSelectImage: E=!0} = t, {stickersEnableButtonFlipVertical: R=!1} = t, {stickersWillRenderShapePresetToolbar: A} = t, {markupEditorGridSize: I=0} = t, {markupEditorSnapThreshold: L=0} = t, {markupEditorSnapToContext: D=!1} = t, {enableMultiSelect: z} = t, {annotateGridSize: F} = t, {annotateSnapToContext: O} = t, {decorateGridSize: B} = t, {decorateSnapToContext: N} = t, {willRenderShapeControls: W} = t, {willRenderShapeTextControls: H} = t, {markupEditorToolSelectRadius: j} = t, {willRenderShapePresetToolbar: U} = t, {beforeAddShape: V} = t, {beforeRemoveShape: q} = t, {beforeDeselectShape: G} = t, {beforeSelectShape: K} = t, {beforeUpdateShape: X} = t, {markupEditorWillStartInteraction: Z} = t;
            const {rootRect: Y, imageCropRect: Q, imageSelectionRectPresentation: J, imageAnnotation: ee, imageDecoration: te, imageSize: ie, imageTransforms: oe, imageTransformsInterpolated: ne, imageRotation: re, imageFlipX: ae, imageFlipY: se} = x;
            return cr(e, Y, (e => i(59, g = e))),
            cr(e, J, (e => i(55, u = e))),
            cr(e, ie, (e => i(58, f = e))),
            cr(e, oe, (e => i(57, m = e))),
            cr(e, ne, (e => i(56, h = e))),
            cr(e, re, (e => i(31, y = e))),
            cr(e, ae, (e => i(24, p = e))),
            cr(e, se, (e => i(23, d = e))),
            e.$$set = e => {
                "isActive"in e && i(0, $ = e.isActive),
                "isActiveFraction"in e && i(1, b = e.isActiveFraction),
                "isVisible"in e && i(2, v = e.isVisible),
                "stores"in e && i(3, x = e.stores),
                "locale"in e && i(4, w = e.locale),
                "stickers"in e && i(5, S = e.stickers),
                "stickerForceEnable"in e && i(44, _ = e.stickerForceEnable),
                "stickerStickToImage"in e && i(6, k = e.stickerStickToImage),
                "stickerEnableSelectImagePreset"in e && i(45, C = e.stickerEnableSelectImagePreset),
                "stickerEnableDropImagePreset"in e && i(7, T = e.stickerEnableDropImagePreset),
                "stickerEnableButtonFlipVertical"in e && i(8, M = e.stickerEnableButtonFlipVertical),
                "stickerWillRenderShapePresetToolbar"in e && i(9, P = e.stickerWillRenderShapePresetToolbar),
                "stickerEnableSelectImage"in e && i(46, E = e.stickerEnableSelectImage),
                "stickersEnableButtonFlipVertical"in e && i(10, R = e.stickersEnableButtonFlipVertical),
                "stickersWillRenderShapePresetToolbar"in e && i(11, A = e.stickersWillRenderShapePresetToolbar),
                "markupEditorGridSize"in e && i(47, I = e.markupEditorGridSize),
                "markupEditorSnapThreshold"in e && i(48, L = e.markupEditorSnapThreshold),
                "markupEditorSnapToContext"in e && i(49, D = e.markupEditorSnapToContext),
                "enableMultiSelect"in e && i(12, z = e.enableMultiSelect),
                "annotateGridSize"in e && i(50, F = e.annotateGridSize),
                "annotateSnapToContext"in e && i(51, O = e.annotateSnapToContext),
                "decorateGridSize"in e && i(52, B = e.decorateGridSize),
                "decorateSnapToContext"in e && i(53, N = e.decorateSnapToContext),
                "willRenderShapeControls"in e && i(13, W = e.willRenderShapeControls),
                "willRenderShapeTextControls"in e && i(14, H = e.willRenderShapeTextControls),
                "markupEditorToolSelectRadius"in e && i(15, j = e.markupEditorToolSelectRadius),
                "willRenderShapePresetToolbar"in e && i(16, U = e.willRenderShapePresetToolbar),
                "beforeAddShape"in e && i(17, V = e.beforeAddShape),
                "beforeRemoveShape"in e && i(18, q = e.beforeRemoveShape),
                "beforeDeselectShape"in e && i(19, G = e.beforeDeselectShape),
                "beforeSelectShape"in e && i(20, K = e.beforeSelectShape),
                "beforeUpdateShape"in e && i(21, X = e.beforeUpdateShape),
                "markupEditorWillStartInteraction"in e && i(22, Z = e.markupEditorWillStartInteraction)
            }
            ,
            e.$$.update = () => {
                33554432 & e.$$.dirty[1] && i(54, o = h ? h.scale : 1),
                49152 & e.$$.dirty[1] && i(30, n = !1 !== C && E),
                131072 & e.$$.dirty[1] && i(29, r = L),
                64 & e.$$.dirty[0] | 2686976 & e.$$.dirty[1] && i(28, a = k ? Wi(F) ? F : I : Wi(B) ? B : I),
                64 & e.$$.dirty[0] | 5505024 & e.$$.dirty[1] && i(27, s = k ? C$(O) ? O : D : C$(N) ? N : D),
                25165888 & e.$$.dirty[0] | 528482304 & e.$$.dirty[1] && i(26, l = k ? e => k$(e, g, f, h.origin, h.translation, m.rotation.z, h.scale, p, d) : e => {
                    const t = Me(e);
                    return t.x -= u.x,
                    t.y -= u.y,
                    t.x /= o,
                    t.y /= o,
                    t
                }
                ),
                25165888 & e.$$.dirty[0] | 528482304 & e.$$.dirty[1] && i(25, c = k ? e => _$(e, g, f, h.origin, h.translation, m.rotation.z, h.scale, p, d) : e => {
                    const t = Me(e);
                    return t.x *= o,
                    t.y *= o,
                    t.x += u.x,
                    t.y += u.y,
                    t
                }
                )
            }
            ,
            [$, b, v, x, w, S, k, T, M, P, R, A, z, W, H, j, U, V, q, G, K, X, Z, d, p, c, l, s, a, r, n, y, Y, Q, J, ee, te, ie, oe, ne, re, ae, se, "sticker", _, C, E, I, L, D, F, O, B, N, o, u, h, m, f, g, function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var D$ = {
            util: ["sticker", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, L$, I$, ar, {
                        name: 43,
                        isActive: 0,
                        isActiveFraction: 1,
                        isVisible: 2,
                        stores: 3,
                        locale: 4,
                        stickers: 5,
                        stickerForceEnable: 44,
                        stickerStickToImage: 6,
                        stickerEnableSelectImagePreset: 45,
                        stickerEnableDropImagePreset: 7,
                        stickerEnableButtonFlipVertical: 8,
                        stickerWillRenderShapePresetToolbar: 9,
                        stickerEnableSelectImage: 46,
                        stickersEnableButtonFlipVertical: 10,
                        stickersWillRenderShapePresetToolbar: 11,
                        markupEditorGridSize: 47,
                        markupEditorSnapThreshold: 48,
                        markupEditorSnapToContext: 49,
                        enableMultiSelect: 12,
                        annotateGridSize: 50,
                        annotateSnapToContext: 51,
                        decorateGridSize: 52,
                        decorateSnapToContext: 53,
                        willRenderShapeControls: 13,
                        willRenderShapeTextControls: 14,
                        markupEditorToolSelectRadius: 15,
                        willRenderShapePresetToolbar: 16,
                        beforeAddShape: 17,
                        beforeRemoveShape: 18,
                        beforeDeselectShape: 19,
                        beforeSelectShape: 20,
                        beforeUpdateShape: 21,
                        markupEditorWillStartInteraction: 22
                    }, null, [-1, -1])
                }
                get name() {
                    return this.$$.ctx[43]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get isActiveFraction() {
                    return this.$$.ctx[1]
                }
                set isActiveFraction(e) {
                    this.$$set({
                        isActiveFraction: e
                    }),
                    $a()
                }
                get isVisible() {
                    return this.$$.ctx[2]
                }
                set isVisible(e) {
                    this.$$set({
                        isVisible: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[3]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[4]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get stickers() {
                    return this.$$.ctx[5]
                }
                set stickers(e) {
                    this.$$set({
                        stickers: e
                    }),
                    $a()
                }
                get stickerForceEnable() {
                    return this.$$.ctx[44]
                }
                set stickerForceEnable(e) {
                    this.$$set({
                        stickerForceEnable: e
                    }),
                    $a()
                }
                get stickerStickToImage() {
                    return this.$$.ctx[6]
                }
                set stickerStickToImage(e) {
                    this.$$set({
                        stickerStickToImage: e
                    }),
                    $a()
                }
                get stickerEnableSelectImagePreset() {
                    return this.$$.ctx[45]
                }
                set stickerEnableSelectImagePreset(e) {
                    this.$$set({
                        stickerEnableSelectImagePreset: e
                    }),
                    $a()
                }
                get stickerEnableDropImagePreset() {
                    return this.$$.ctx[7]
                }
                set stickerEnableDropImagePreset(e) {
                    this.$$set({
                        stickerEnableDropImagePreset: e
                    }),
                    $a()
                }
                get stickerEnableButtonFlipVertical() {
                    return this.$$.ctx[8]
                }
                set stickerEnableButtonFlipVertical(e) {
                    this.$$set({
                        stickerEnableButtonFlipVertical: e
                    }),
                    $a()
                }
                get stickerWillRenderShapePresetToolbar() {
                    return this.$$.ctx[9]
                }
                set stickerWillRenderShapePresetToolbar(e) {
                    this.$$set({
                        stickerWillRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get stickerEnableSelectImage() {
                    return this.$$.ctx[46]
                }
                set stickerEnableSelectImage(e) {
                    this.$$set({
                        stickerEnableSelectImage: e
                    }),
                    $a()
                }
                get stickersEnableButtonFlipVertical() {
                    return this.$$.ctx[10]
                }
                set stickersEnableButtonFlipVertical(e) {
                    this.$$set({
                        stickersEnableButtonFlipVertical: e
                    }),
                    $a()
                }
                get stickersWillRenderShapePresetToolbar() {
                    return this.$$.ctx[11]
                }
                set stickersWillRenderShapePresetToolbar(e) {
                    this.$$set({
                        stickersWillRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get markupEditorGridSize() {
                    return this.$$.ctx[47]
                }
                set markupEditorGridSize(e) {
                    this.$$set({
                        markupEditorGridSize: e
                    }),
                    $a()
                }
                get markupEditorSnapThreshold() {
                    return this.$$.ctx[48]
                }
                set markupEditorSnapThreshold(e) {
                    this.$$set({
                        markupEditorSnapThreshold: e
                    }),
                    $a()
                }
                get markupEditorSnapToContext() {
                    return this.$$.ctx[49]
                }
                set markupEditorSnapToContext(e) {
                    this.$$set({
                        markupEditorSnapToContext: e
                    }),
                    $a()
                }
                get enableMultiSelect() {
                    return this.$$.ctx[12]
                }
                set enableMultiSelect(e) {
                    this.$$set({
                        enableMultiSelect: e
                    }),
                    $a()
                }
                get annotateGridSize() {
                    return this.$$.ctx[50]
                }
                set annotateGridSize(e) {
                    this.$$set({
                        annotateGridSize: e
                    }),
                    $a()
                }
                get annotateSnapToContext() {
                    return this.$$.ctx[51]
                }
                set annotateSnapToContext(e) {
                    this.$$set({
                        annotateSnapToContext: e
                    }),
                    $a()
                }
                get decorateGridSize() {
                    return this.$$.ctx[52]
                }
                set decorateGridSize(e) {
                    this.$$set({
                        decorateGridSize: e
                    }),
                    $a()
                }
                get decorateSnapToContext() {
                    return this.$$.ctx[53]
                }
                set decorateSnapToContext(e) {
                    this.$$set({
                        decorateSnapToContext: e
                    }),
                    $a()
                }
                get willRenderShapeControls() {
                    return this.$$.ctx[13]
                }
                set willRenderShapeControls(e) {
                    this.$$set({
                        willRenderShapeControls: e
                    }),
                    $a()
                }
                get willRenderShapeTextControls() {
                    return this.$$.ctx[14]
                }
                set willRenderShapeTextControls(e) {
                    this.$$set({
                        willRenderShapeTextControls: e
                    }),
                    $a()
                }
                get markupEditorToolSelectRadius() {
                    return this.$$.ctx[15]
                }
                set markupEditorToolSelectRadius(e) {
                    this.$$set({
                        markupEditorToolSelectRadius: e
                    }),
                    $a()
                }
                get willRenderShapePresetToolbar() {
                    return this.$$.ctx[16]
                }
                set willRenderShapePresetToolbar(e) {
                    this.$$set({
                        willRenderShapePresetToolbar: e
                    }),
                    $a()
                }
                get beforeAddShape() {
                    return this.$$.ctx[17]
                }
                set beforeAddShape(e) {
                    this.$$set({
                        beforeAddShape: e
                    }),
                    $a()
                }
                get beforeRemoveShape() {
                    return this.$$.ctx[18]
                }
                set beforeRemoveShape(e) {
                    this.$$set({
                        beforeRemoveShape: e
                    }),
                    $a()
                }
                get beforeDeselectShape() {
                    return this.$$.ctx[19]
                }
                set beforeDeselectShape(e) {
                    this.$$set({
                        beforeDeselectShape: e
                    }),
                    $a()
                }
                get beforeSelectShape() {
                    return this.$$.ctx[20]
                }
                set beforeSelectShape(e) {
                    this.$$set({
                        beforeSelectShape: e
                    }),
                    $a()
                }
                get beforeUpdateShape() {
                    return this.$$.ctx[21]
                }
                set beforeUpdateShape(e) {
                    this.$$set({
                        beforeUpdateShape: e
                    }),
                    $a()
                }
                get markupEditorWillStartInteraction() {
                    return this.$$.ctx[22]
                }
                set markupEditorWillStartInteraction(e) {
                    this.$$set({
                        markupEditorWillStartInteraction: e
                    }),
                    $a()
                }
            }
            , ({stickers: e, stickerEnableSelectImage: t, stickerEnableSelectImagePreset: i, stickerEnableDropImagePreset: o, stickerForceEnable: n}) => e && e.length || t || i || o || n]
        };
        function z$(e) {
            let t, i, o, n, r, a = (e[14](e[34].value) || "") + "", s = (H(e[34].label) ? e[34].label(e[1]) : e[34].label) + "";
            return {
                c() {
                    t = Er("div"),
                    i = new Ur(!1),
                    o = Ir(),
                    n = Er("span"),
                    r = Ar(s),
                    i.a = o,
                    Or(t, "slot", "option")
                },
                m(e, s) {
                    Mr(e, t, s),
                    i.m(a, t),
                    kr(t, o),
                    kr(t, n),
                    kr(n, r)
                },
                p(e, t) {
                    8 & t[1] && a !== (a = (e[14](e[34].value) || "") + "") && i.p(a),
                    2 & t[0] | 8 & t[1] && s !== (s = (H(e[34].label) ? e[34].label(e[1]) : e[34].label) + "") && Wr(r, s)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function F$(e) {
            let t, i;
            return t = new Nd({
                props: {
                    locale: e[1],
                    class: "PinturaControlList",
                    layout: "row",
                    options: e[2],
                    selectedIndex: e[6],
                    onchange: e[12],
                    $$slots: {
                        option: [z$, ({option: e}) => ({
                            34: e
                        }), ({option: e}) => [0, e ? 8 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    2 & i[0] && (o.locale = e[1]),
                    4 & i[0] && (o.options = e[2]),
                    64 & i[0] && (o.selectedIndex = e[6]),
                    2 & i[0] | 24 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function O$(e) {
            let t, i, o, n, r;
            return i = new Iy({
                props: {
                    locale: e[1],
                    class: "PinturaControlPanels",
                    shapeProps: e[4],
                    onchange: e[13],
                    controls: e[3],
                    scrollElasticity: e[7]
                }
            }),
            n = new Su({
                props: {
                    elasticity: e[10],
                    $$slots: {
                        default: [F$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    o = Ir(),
                    za(n.$$.fragment),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[5])
                },
                m(e, a) {
                    Mr(e, t, a),
                    Fa(i, t, null),
                    kr(t, o),
                    Fa(n, t, null),
                    r = !0
                },
                p(e, o) {
                    const a = {};
                    2 & o[0] && (a.locale = e[1]),
                    16 & o[0] && (a.shapeProps = e[4]),
                    8 & o[0] && (a.controls = e[3]),
                    128 & o[0] && (a.scrollElasticity = e[7]),
                    i.$set(a);
                    const s = {};
                    70 & o[0] | 16 & o[1] && (s.$$scope = {
                        dirty: o,
                        ctx: e
                    }),
                    n.$set(s),
                    (!r || 32 & o[0]) && Or(t, "style", e[5])
                },
                i(e) {
                    r || (ka(i.$$.fragment, e),
                    ka(n.$$.fragment, e),
                    r = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    Ca(n.$$.fragment, e),
                    r = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i),
                    Oa(n)
                }
            }
        }
        function B$(e) {
            let t, i;
            return t = new Lf({
                props: {
                    $$slots: {
                        footer: [O$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            t.$on("measure", e[23]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    254 & i[0] | 16 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function N$(e, t, i) {
            let o, n, r, a, s, l, c, u, d = Jn, p = () => (d(),
            d = sr(h, (e => i(20, s = e))),
            h);
            e.$$.on_destroy.push(( () => d()));
            let {isActive: h} = t;
            p();
            let {stores: m} = t
              , {locale: f={}} = t
              , {frameStyles: g={}} = t
              , {frameOptions: y=[]} = t
              , {markupEditorShapeStyleControls: $} = t;
            const b = oa("elasticityMultiplier");
            cr(e, b, (e => i(22, u = e)));
            const {history: v, animation: x, scrollElasticity: w, imageFrame: S, allowPan: _, allowZoom: k, allowZoomControls: C, allowPlayPause: T} = m;
            cr(e, x, (e => i(21, l = e))),
            cr(e, S, (e => i(4, c = e)));
            let M, P = {};
            const E = ic(l ? 20 : 0);
            return cr(e, E, (e => i(19, a = e))),
            e.$$set = e => {
                "isActive"in e && p(i(0, h = e.isActive)),
                "stores"in e && i(17, m = e.stores),
                "locale"in e && i(1, f = e.locale),
                "frameStyles"in e && i(18, g = e.frameStyles),
                "frameOptions"in e && i(2, y = e.frameOptions),
                "markupEditorShapeStyleControls"in e && i(3, $ = e.markupEditorShapeStyleControls)
            }
            ,
            e.$$.update = () => {
                1048576 & e.$$.dirty[0] && _.set(s),
                1048576 & e.$$.dirty[0] && k.set(s),
                1048576 & e.$$.dirty[0] && C.set(s),
                1048576 & e.$$.dirty[0] && s && T.set(!0),
                4194304 & e.$$.dirty[0] && i(7, o = u * w),
                20 & e.$$.dirty[0] && i(6, n = c ? y.findIndex(( ([e]) => e === c.id)) : 0),
                3145728 & e.$$.dirty[0] && l && E.set(s ? 0 : 20),
                524288 & e.$$.dirty[0] && i(5, r = a ? `transform: translateY(${a}px)` : void 0)
            }
            ,
            [h, f, y, $, c, r, n, o, b, x, w, S, ({value: e}) => {
                const t = g[e];
                if (!t || !t.shape)
                    return S.set(void 0),
                    void v.write();
                const {shape: i} = t
                  , o = {
                    id: e,
                    ...So(i),
                    ...Object.keys(P).reduce(( (e, t) => i[t] ? (e[t] = P[t],
                    e) : e), {})
                };
                S.set(o),
                v.write()
            }
            , function(e) {
                ji(e, "frameColor") && (P.frameColor = e.frameColor),
                c && (kn(c, e),
                S.set(c),
                clearTimeout(M),
                M = setTimeout(( () => {
                    v.write()
                }
                ), 200))
            }
            , e => {
                const t = g[e];
                var i;
                if (t && t.thumb)
                    return i = t.thumb,
                    /div/i.test(i) || Ly(i) ? i : /rect|path|circle|line|<g>/i.test(i) ? `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" stroke-width="1" stroke="currentColor" fill="none" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round">${i}</svg>` : `<img src="${i}" alt=""/>`
            }
            , E, "frame", m, g, a, s, l, u, function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var W$ = {
            util: ["frame", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, N$, B$, ar, {
                        name: 16,
                        isActive: 0,
                        stores: 17,
                        locale: 1,
                        frameStyles: 18,
                        frameOptions: 2,
                        markupEditorShapeStyleControls: 3
                    }, null, [-1, -1])
                }
                get name() {
                    return this.$$.ctx[16]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[17]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[1]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get frameStyles() {
                    return this.$$.ctx[18]
                }
                set frameStyles(e) {
                    this.$$set({
                        frameStyles: e
                    }),
                    $a()
                }
                get frameOptions() {
                    return this.$$.ctx[2]
                }
                set frameOptions(e) {
                    this.$$set({
                        frameOptions: e
                    }),
                    $a()
                }
                get markupEditorShapeStyleControls() {
                    return this.$$.ctx[3]
                }
                set markupEditorShapeStyleControls(e) {
                    this.$$set({
                        markupEditorShapeStyleControls: e
                    }),
                    $a()
                }
            }
            , ({src: e}) => e && !Ls(e)]
        };
        function H$(e) {
            let t, i, o, n, r, a, s, l;
            return {
                c() {
                    t = Er("div"),
                    i = Er("input"),
                    n = Ir(),
                    r = Er("label"),
                    a = Ar(e[1]),
                    Or(i, "id", e[0]),
                    Or(i, "type", "number"),
                    Or(i, "min", "1"),
                    Or(i, "inputmode", "numeric"),
                    Or(i, "pattern", "[0-9]*"),
                    Or(i, "data-state", e[3]),
                    Or(i, "autocomplete", "off"),
                    Or(i, "placeholder", e[4]),
                    i.value = o = void 0 === e[5] ? "" : e[7](e[5] + ""),
                    Or(r, "for", e[0]),
                    Or(r, "title", e[2]),
                    Or(r, "aria-label", e[2]),
                    Or(t, "class", "PinturaInputDimension")
                },
                m(o, c) {
                    Mr(o, t, c),
                    kr(t, i),
                    kr(t, n),
                    kr(t, r),
                    kr(r, a),
                    s || (l = Dr(i, "input", e[8]),
                    s = !0)
                },
                p(e, [t]) {
                    1 & t && Or(i, "id", e[0]),
                    8 & t && Or(i, "data-state", e[3]),
                    16 & t && Or(i, "placeholder", e[4]),
                    160 & t && o !== (o = void 0 === e[5] ? "" : e[7](e[5] + "")) && i.value !== o && (i.value = o),
                    2 & t && Wr(a, e[1]),
                    1 & t && Or(r, "for", e[0]),
                    4 & t && Or(r, "title", e[2]),
                    4 & t && Or(r, "aria-label", e[2])
                },
                i: Jn,
                o: Jn,
                d(e) {
                    e && Pr(t),
                    s = !1,
                    l()
                }
            }
        }
        function j$(e, t, i) {
            let {id: o} = t
              , {label: n} = t
              , {title: r} = t
              , {state: a} = t
              , {placeholder: s} = t
              , {value: l} = t
              , {onchange: c} = t
              , {format: u=(e => e.replace(/\D/g, ""))} = t;
            return e.$$set = e => {
                "id"in e && i(0, o = e.id),
                "label"in e && i(1, n = e.label),
                "title"in e && i(2, r = e.title),
                "state"in e && i(3, a = e.state),
                "placeholder"in e && i(4, s = e.placeholder),
                "value"in e && i(5, l = e.value),
                "onchange"in e && i(6, c = e.onchange),
                "format"in e && i(7, u = e.format)
            }
            ,
            [o, n, r, a, s, l, c, u, e => c(u(e.currentTarget.value))]
        }
        class U$ extends Na {
            constructor(e) {
                super(),
                Ba(this, e, j$, H$, ar, {
                    id: 0,
                    label: 1,
                    title: 2,
                    state: 3,
                    placeholder: 4,
                    value: 5,
                    onchange: 6,
                    format: 7
                })
            }
        }
        function V$(e) {
            let t;
            return {
                c() {
                    t = Rr("g")
                },
                m(i, o) {
                    Mr(i, t, o),
                    t.innerHTML = e[2]
                },
                p(e, i) {
                    4 & i && (t.innerHTML = e[2])
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function q$(e) {
            let t, i, o, n, r, a, s, l;
            return r = new ou({
                props: {
                    $$slots: {
                        default: [V$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    i = Er("input"),
                    o = Ir(),
                    n = Er("label"),
                    za(r.$$.fragment),
                    Or(i, "id", e[0]),
                    Or(i, "class", "implicit"),
                    Or(i, "type", "checkbox"),
                    i.checked = e[1],
                    Or(n, "for", e[0]),
                    Or(n, "title", e[3])
                },
                m(c, u) {
                    Mr(c, t, u),
                    kr(t, i),
                    kr(t, o),
                    kr(t, n),
                    Fa(r, n, null),
                    a = !0,
                    s || (l = Dr(i, "change", e[5]),
                    s = !0)
                },
                p(e, [t]) {
                    (!a || 1 & t) && Or(i, "id", e[0]),
                    (!a || 2 & t) && (i.checked = e[1]);
                    const o = {};
                    68 & t && (o.$$scope = {
                        dirty: t,
                        ctx: e
                    }),
                    r.$set(o),
                    (!a || 1 & t) && Or(n, "for", e[0]),
                    (!a || 8 & t) && Or(n, "title", e[3])
                },
                i(e) {
                    a || (ka(r.$$.fragment, e),
                    a = !0)
                },
                o(e) {
                    Ca(r.$$.fragment, e),
                    a = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(r),
                    s = !1,
                    l()
                }
            }
        }
        function G$(e, t, i) {
            let {id: o} = t
              , {locked: n} = t
              , {icon: r} = t
              , {title: a} = t
              , {onchange: s} = t;
            return e.$$set = e => {
                "id"in e && i(0, o = e.id),
                "locked"in e && i(1, n = e.locked),
                "icon"in e && i(2, r = e.icon),
                "title"in e && i(3, a = e.title),
                "onchange"in e && i(4, s = e.onchange)
            }
            ,
            [o, n, r, a, s, e => s(e.currentTarget.checked)]
        }
        class K$ extends Na {
            constructor(e) {
                super(),
                Ba(this, e, G$, q$, ar, {
                    id: 0,
                    locked: 1,
                    icon: 2,
                    title: 3,
                    onchange: 4
                })
            }
        }
        function X$(e) {
            let t;
            return {
                c() {
                    t = Ar("Save")
                },
                m(e, i) {
                    Mr(e, t, i)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function Z$(e) {
            let t, i, o, n, r, a, s, l, c, u, d, p, h, m = e[1].resizeLabelFormCaption + "";
            return l = new yh({
                props: {
                    items: e[4]
                }
            }),
            u = new du({
                props: {
                    type: "submit",
                    class: "implicit",
                    $$slots: {
                        default: [X$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("form"),
                    i = Er("div"),
                    o = Er("fieldset"),
                    n = Er("legend"),
                    r = Ar(m),
                    a = Ir(),
                    s = Er("div"),
                    za(l.$$.fragment),
                    c = Ir(),
                    za(u.$$.fragment),
                    Or(n, "class", "implicit"),
                    Or(s, "class", "PinturaFieldsetInner"),
                    Or(i, "class", "PinturaFormInner"),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[3])
                },
                m(m, f) {
                    Mr(m, t, f),
                    kr(t, i),
                    kr(i, o),
                    kr(o, n),
                    kr(n, r),
                    kr(o, a),
                    kr(o, s),
                    Fa(l, s, null),
                    e[65](s),
                    kr(i, c),
                    Fa(u, i, null),
                    d = !0,
                    p || (h = [Dr(s, "focusin", e[15]), Dr(s, "focusout", e[16]), Dr(t, "submit", zr(e[17]))],
                    p = !0)
                },
                p(e, i) {
                    (!d || 2 & i[0]) && m !== (m = e[1].resizeLabelFormCaption + "") && Wr(r, m);
                    const o = {};
                    16 & i[0] && (o.items = e[4]),
                    l.$set(o);
                    const n = {};
                    16 & i[3] && (n.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    u.$set(n),
                    (!d || 8 & i[0]) && Or(t, "style", e[3])
                },
                i(e) {
                    d || (ka(l.$$.fragment, e),
                    ka(u.$$.fragment, e),
                    d = !0)
                },
                o(e) {
                    Ca(l.$$.fragment, e),
                    Ca(u.$$.fragment, e),
                    d = !1
                },
                d(i) {
                    i && Pr(t),
                    Oa(l),
                    e[65](null),
                    Oa(u),
                    p = !1,
                    nr(h)
                }
            }
        }
        function Y$(e) {
            let t, i;
            return t = new Lf({
                props: {
                    $$slots: {
                        footer: [Z$]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            t.$on("measure", e[66]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    30 & i[0] | 16 & i[3] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function Q$(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h, m, f, g, y, $, b, v, x, w, S, _, k, C, T, M, P, E, R, A, I = Jn, L = () => (I(),
            I = sr(z, (e => i(49, h = e))),
            z);
            e.$$.on_destroy.push(( () => I()));
            const D = (e, t=0, i=9999) => {
                if (W(e) && !(e = e.replace(/\D/g, "")).length)
                    return;
                const o = Math.round(e);
                return Number.isNaN(o) ? void 0 : cs(o, t, i)
            }
            ;
            let {isActive: z} = t;
            L();
            let {stores: F} = t
              , {locale: O={}} = t
              , {resizeMinSize: B=et(1, 1)} = t
              , {resizeMaxSize: N=et(9999, 9999)} = t
              , {resizeAspectRatioLocked: H=!1} = t
              , {resizeEnableButtonLockAspectRatio: j=!0} = t
              , {resizeSizePresetOptions: U} = t
              , {resizeWidthPresetOptions: q} = t
              , {resizeHeightPresetOptions: G} = t
              , {resizeWillRenderFooter: K=se} = t;
            const X = ic(0, {
                stiffness: .15,
                damping: .3
            });
            cr(e, X, (e => i(54, $ = e)));
            const {animation: Z, imageSize: Y, imageCropRect: Q, imageCropRectAspectRatio: J, imageCropAspectRatio: ee, imageOutputSize: te, imageSelectionZoom: ie, imageSelectionPan: oe, history: ne, env: re, allowPan: le, allowZoom: ce, allowZoomControls: ue, allowPlayPause: de} = F;
            cr(e, Z, (e => i(50, m = e))),
            cr(e, Y, (e => i(73, E = e))),
            cr(e, Q, (e => i(52, g = e))),
            cr(e, J, (e => i(53, y = e))),
            cr(e, ee, (e => i(72, C = e))),
            cr(e, te, (e => i(61, k = e))),
            cr(e, ie, (e => i(74, R = e))),
            cr(e, oe, (e => i(75, A = e))),
            cr(e, re, (e => i(51, f = e)));
            const pe = V();
            let he, me, fe, ge, ye, $e, be = ke();
            const ve = (e, t, i, o, n) => null != e && i !== t ? e >= o[t] && e <= n[t] ? "valid" : "invalid" : "undetermined"
              , xe = (e, t, i) => Math.round(null != e ? e / t : i.height)
              , we = () => {
                H && me && fe && ("width" === ge ? i(39, fe = Math.round(me / y)) : "height" === ge ? i(38, me = Math.round(fe * y)) : ("width" === ye ? i(39, fe = Math.round(me / y)) : "height" === ye && i(38, me = Math.round(fe * y)),
                Se()))
            }
              , Se = e => {
                let t = D(me)
                  , o = D(fe)
                  , n = t
                  , r = o
                  , a = n && r
                  , s = e || y;
                if (!n && !r)
                    return;
                n && !r ? r = Math.round(n / s) : r && !n && (n = Math.round(r * s)),
                s = e || a ? ae(n, r) : y;
                let l = et(n, r);
                rt(N, l) || (l = Lt(N, s)),
                rt(l, B) || (l = It(B, s)),
                i(38, me = null != t ? Math.round(l.width) : void 0),
                i(39, fe = null != o ? Math.round(l.height) : void 0)
            }
              , _e = () => {
                Se();
                const {width: e, height: t} = k || {};
                e === me && t === fe || (me || fe ? (me && fe && yr(ee, C = me / fe, C),
                yr(te, k = et(me, fe), k)) : (yr(ee, C = E.width / E.height, C),
                yr(ee, C = void 0, C),
                yr(te, k = void 0, k)),
                ne.write())
            }
              , Ce = te.subscribe((e => {
                if (!e)
                    return i(38, me = void 0),
                    void i(39, fe = void 0);
                i(38, me = e.width),
                i(39, fe = e.height),
                Se()
            }
            ))
              , Te = ee.subscribe((e => {
                (me || fe) && e && (me && fe && ae(me, fe) !== e ? (i(39, fe = me / e),
                Se(e)) : Se())
            }
            ))
              , Me = e => W(e[0]) ? (e[1] = e[1].map(Me),
            e) : Wi(e) ? [e, "" + e] : e
              , Pe = e => {
                if (W(e[0]))
                    return e[1] = e[1].map(Pe),
                    e;
                let[t,i] = e;
                if (Wi(t) && Wi(i)) {
                    const [e,o] = [t, i];
                    i = `${e} &times; ${o}`,
                    t = [e, o]
                }
                return [t, i]
            }
              , Ee = ja();
            cr(e, Ee, (e => i(60, _ = e)));
            const Re = ja();
            cr(e, Re, (e => i(64, P = e)));
            const Ae = ja();
            cr(e, Ae, (e => i(58, w = e)));
            const Ie = ja();
            cr(e, Ie, (e => i(63, M = e)));
            const Le = ja();
            cr(e, Le, (e => i(56, v = e)));
            const De = ja();
            cr(e, De, (e => i(62, T = e)));
            const ze = Ua([te, Re], ( ([e,t], i) => {
                if (!t)
                    return i(-1);
                const o = t.findIndex(( ([t]) => {
                    if (!t && !e)
                        return !0;
                    if (!t)
                        return !1;
                    const [i,o] = t;
                    return e.width === i && e.height === o
                }
                ));
                i(o < 0 ? 0 : o)
            }
            ));
            cr(e, ze, (e => i(59, S = e)));
            const Fe = Ua([te, Ie], ( ([e,t], i) => {
                if (!t)
                    return i(-1);
                const o = t.findIndex(( ([t]) => !t && !e || !!t && e.width === t));
                i(o < 0 ? 0 : o)
            }
            ));
            cr(e, Fe, (e => i(57, x = e)));
            const Oe = Ua([te, De], ( ([e,t], i) => {
                if (!t)
                    return i(-1);
                const o = t.findIndex(( ([t]) => !t && !e || !!t && e.height === t));
                i(o < 0 ? 0 : o)
            }
            ));
            let Be, Ne;
            cr(e, Oe, (e => i(55, b = e)));
            const We = oa("redrawTrigger")
              , He = ic(m ? 20 : 0);
            return cr(e, He, (e => i(48, p = e))),
            ea(( () => {
                Ce(),
                Te()
            }
            )),
            e.$$set = e => {
                "isActive"in e && L(i(0, z = e.isActive)),
                "stores"in e && i(30, F = e.stores),
                "locale"in e && i(1, O = e.locale),
                "resizeMinSize"in e && i(31, B = e.resizeMinSize),
                "resizeMaxSize"in e && i(32, N = e.resizeMaxSize),
                "resizeAspectRatioLocked"in e && i(28, H = e.resizeAspectRatioLocked),
                "resizeEnableButtonLockAspectRatio"in e && i(33, j = e.resizeEnableButtonLockAspectRatio),
                "resizeSizePresetOptions"in e && i(34, U = e.resizeSizePresetOptions),
                "resizeWidthPresetOptions"in e && i(35, q = e.resizeWidthPresetOptions),
                "resizeHeightPresetOptions"in e && i(36, G = e.resizeHeightPresetOptions),
                "resizeWillRenderFooter"in e && i(37, K = e.resizeWillRenderFooter)
            }
            ,
            e.$$.update = () => {
                262144 & e.$$.dirty[1] && le.set(!h),
                262144 & e.$$.dirty[1] && ce.set(!h),
                262144 & e.$$.dirty[1] && ue.set(!h),
                262144 & e.$$.dirty[1] && h && de.set(!0),
                536870920 & e.$$.dirty[1] && U && (yr(Ee, _ = U.map(Pe), _),
                yr(Re, P = ud(_), P)),
                536870912 & e.$$.dirty[1] && i(47, a = !!_),
                268435456 & e.$$.dirty[1] | 4 & e.$$.dirty[2] && i(46, o = S > -1 && P[S][1]),
                134217744 & e.$$.dirty[1] && q && (yr(Ae, w = q.map(Me), w),
                yr(Ie, M = ud(w), M)),
                134283264 & e.$$.dirty[1] && i(44, s = !a && w),
                67108864 & e.$$.dirty[1] | 2 & e.$$.dirty[2] && i(45, n = x > -1 && M[x][1]),
                33554464 & e.$$.dirty[1] && G && (yr(Le, v = G.map(Me), v),
                yr(De, T = ud(v), T)),
                33619968 & e.$$.dirty[1] && i(43, l = !a && v),
                16777216 & e.$$.dirty[1] | 1 & e.$$.dirty[2] && i(42, r = b > -1 && T[b][1]),
                77824 & e.$$.dirty[1] && i(41, c = !a && !s && !l),
                268435458 & e.$$.dirty[0] | 1072824263 & e.$$.dirty[1] && i(4, u = We && Bh(( () => {
                    return K([a && ["Dropdown", "size-presets", {
                        label: o,
                        options: _,
                        onchange: e => {
                            return (t = e.value) && !Be && (Be = {
                                ...g
                            },
                            Ne = C),
                            t ? (yr(ee, C = ae(t[0], t[1]), C),
                            yr(te, k = Qe(t), k)) : (yr(Q, g = Be, g),
                            yr(ee, C = Ne, C),
                            yr(te, k = void 0, k),
                            Be = void 0,
                            Ne = void 0),
                            void ne.write();
                            var t
                        }
                        ,
                        selectedIndex: S
                    }], s && ["Dropdown", "width-presets", {
                        label: n,
                        options: w,
                        onchange: e => {
                            i(38, me = e.value),
                            _e()
                        }
                        ,
                        selectedIndex: x
                    }], s && l && ["span", "times", {
                        class: "PinturaResizeLabel",
                        innerHTML: "&times;"
                    }], l && ["Dropdown", "height-presets", {
                        label: r,
                        options: v,
                        onchange: e => {
                            i(39, fe = e.value),
                            _e()
                        }
                        ,
                        selectedIndex: b
                    }], c && [U$, "width-input", {
                        id: `width-${pe}`,
                        title: O.resizeTitleInputWidth,
                        label: O.resizeLabelInputWidth,
                        placeholder: (e = D(fe),
                        t = y,
                        u = g,
                        Math.round(null != e ? e * t : u.width)),
                        value: me,
                        state: ve(D(me), "width", ge, B, N),
                        onchange: e => {
                            i(38, me = e),
                            we()
                        }
                    }], c && j && [K$, "aspect-ratio-lock", {
                        id: `aspect-ratio-lock-${pe}`,
                        title: O.resizeTitleButtonMaintainAspectRatio,
                        icon: W(O.resizeIconButtonMaintainAspectRatio) ? O.resizeIconButtonMaintainAspectRatio : O.resizeIconButtonMaintainAspectRatio(H, $),
                        locked: H,
                        onchange: e => {
                            i(28, H = e),
                            we()
                        }
                    }], c && [U$, "height-input", {
                        id: `height-${pe}`,
                        title: O.resizeTitleInputHeight,
                        label: O.resizeLabelInputHeight,
                        placeholder: xe(D(me), y, g),
                        value: fe,
                        state: ve(D(fe), "height", ge, B, N),
                        onchange: e => {
                            i(39, fe = e),
                            we()
                        }
                    }]].filter(Boolean), {
                        ...f
                    }, ( () => We.set({})));
                    var e, t, u
                }
                )).filter(Boolean)),
                268435456 & e.$$.dirty[0] && X.set(H ? 1 : 0),
                512 & e.$$.dirty[1] && ge && (ye = ge),
                262144 & e.$$.dirty[1] && h && (be = A,
                $e = R),
                1074003968 & e.$$.dirty[1] && (h ? setTimeout(( () => {
                    return e = k,
                    yr(oe, A = ke(), A),
                    void yr(ie, R = e && g ? e.width / g.width || e.height / g.height : 1, R);
                    var e
                }
                ), 0) : (yr(oe, A = be, A),
                yr(ie, R = $e, R))),
                786432 & e.$$.dirty[1] && m && He.set(h ? 0 : 20),
                131072 & e.$$.dirty[1] && i(3, d = p ? `transform: translateY(${p}px)` : void 0)
            }
            ,
            [z, O, he, d, u, X, Z, Y, Q, J, ee, te, ie, oe, re, e => {
                const t = e.target.id;
                /width/.test(t) ? i(40, ge = "width") : /height/.test(t) ? i(40, ge = "height") : /aspectRatio/i.test(t) ? i(40, ge = "lock") : i(40, ge = void 0)
            }
            , e => {
                he.contains(e.relatedTarget) || _e(),
                i(40, ge = void 0)
            }
            , _e, Ee, Re, Ae, Ie, Le, De, ze, Fe, Oe, He, H, "resize", F, B, N, j, U, q, G, K, me, fe, ge, c, r, l, s, n, o, a, p, h, m, f, g, y, $, b, v, x, w, S, _, k, T, M, P, function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    he = e,
                    i(2, he)
                }
                ))
            }
            , function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var J$ = {
            util: ["resize", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, Q$, Y$, ar, {
                        name: 29,
                        isActive: 0,
                        stores: 30,
                        locale: 1,
                        resizeMinSize: 31,
                        resizeMaxSize: 32,
                        resizeAspectRatioLocked: 28,
                        resizeEnableButtonLockAspectRatio: 33,
                        resizeSizePresetOptions: 34,
                        resizeWidthPresetOptions: 35,
                        resizeHeightPresetOptions: 36,
                        resizeWillRenderFooter: 37
                    }, null, [-1, -1, -1, -1])
                }
                get name() {
                    return this.$$.ctx[29]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[30]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[1]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get resizeMinSize() {
                    return this.$$.ctx[31]
                }
                set resizeMinSize(e) {
                    this.$$set({
                        resizeMinSize: e
                    }),
                    $a()
                }
                get resizeMaxSize() {
                    return this.$$.ctx[32]
                }
                set resizeMaxSize(e) {
                    this.$$set({
                        resizeMaxSize: e
                    }),
                    $a()
                }
                get resizeAspectRatioLocked() {
                    return this.$$.ctx[28]
                }
                set resizeAspectRatioLocked(e) {
                    this.$$set({
                        resizeAspectRatioLocked: e
                    }),
                    $a()
                }
                get resizeEnableButtonLockAspectRatio() {
                    return this.$$.ctx[33]
                }
                set resizeEnableButtonLockAspectRatio(e) {
                    this.$$set({
                        resizeEnableButtonLockAspectRatio: e
                    }),
                    $a()
                }
                get resizeSizePresetOptions() {
                    return this.$$.ctx[34]
                }
                set resizeSizePresetOptions(e) {
                    this.$$set({
                        resizeSizePresetOptions: e
                    }),
                    $a()
                }
                get resizeWidthPresetOptions() {
                    return this.$$.ctx[35]
                }
                set resizeWidthPresetOptions(e) {
                    this.$$set({
                        resizeWidthPresetOptions: e
                    }),
                    $a()
                }
                get resizeHeightPresetOptions() {
                    return this.$$.ctx[36]
                }
                set resizeHeightPresetOptions(e) {
                    this.$$set({
                        resizeHeightPresetOptions: e
                    }),
                    $a()
                }
                get resizeWillRenderFooter() {
                    return this.$$.ctx[37]
                }
                set resizeWillRenderFooter(e) {
                    this.$$set({
                        resizeWillRenderFooter: e
                    }),
                    $a()
                }
            }
            ]
        };
        function eb(e) {
            let t, i;
            return t = new S$({
                props: {
                    stores: e[3],
                    locale: e[4],
                    isActive: e[0],
                    isActiveFraction: e[1],
                    isVisible: e[2],
                    mapScreenPointToImagePoint: e[10],
                    mapImagePointToScreenPoint: e[9],
                    enableMultiSelect: e[6],
                    utilKey: "redact",
                    imageRotation: e[11],
                    imageFlipX: e[8],
                    imageFlipY: e[7],
                    shapes: e[12],
                    toolbar: ["rect"],
                    toolShapes: {
                        rectangle: [{
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        }]
                    },
                    toolActive: "rectangle",
                    parentRect: e[14],
                    enablePresetDropImage: !1,
                    enablePresetSelectImage: !1,
                    willStartInteraction: e[5],
                    hooks: {
                        willRenderShapeControls: e[25]
                    }
                }
            }),
            t.$on("measure", e[26]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, [i]) {
                    const o = {};
                    8 & i && (o.stores = e[3]),
                    16 & i && (o.locale = e[4]),
                    1 & i && (o.isActive = e[0]),
                    2 & i && (o.isActiveFraction = e[1]),
                    4 & i && (o.isVisible = e[2]),
                    1024 & i && (o.mapScreenPointToImagePoint = e[10]),
                    512 & i && (o.mapImagePointToScreenPoint = e[9]),
                    64 & i && (o.enableMultiSelect = e[6]),
                    2048 & i && (o.imageRotation = e[11]),
                    256 & i && (o.imageFlipX = e[8]),
                    128 & i && (o.imageFlipY = e[7]),
                    32 & i && (o.willStartInteraction = e[5]),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function tb(e, t, i) {
            let o, n, r, a, s, l, c, u, d, {isActive: p} = t, {isActiveFraction: h} = t, {isVisible: m} = t, {stores: f} = t, {locale: g={}} = t, {markupEditorWillStartInteraction: y} = t, {enableMultiSelect: $} = t;
            const {imageRedaction: b, rootRect: v, imageSize: x, imageRotation: w, imageFlipX: S, imageFlipY: _, imageTransforms: k, imageTransformsInterpolated: C} = f;
            return cr(e, v, (e => i(24, u = e))),
            cr(e, x, (e => i(23, c = e))),
            cr(e, w, (e => i(11, d = e))),
            cr(e, S, (e => i(8, a = e))),
            cr(e, _, (e => i(7, r = e))),
            cr(e, k, (e => i(22, l = e))),
            cr(e, C, (e => i(21, s = e))),
            e.$$set = e => {
                "isActive"in e && i(0, p = e.isActive),
                "isActiveFraction"in e && i(1, h = e.isActiveFraction),
                "isVisible"in e && i(2, m = e.isVisible),
                "stores"in e && i(3, f = e.stores),
                "locale"in e && i(4, g = e.locale),
                "markupEditorWillStartInteraction"in e && i(5, y = e.markupEditorWillStartInteraction),
                "enableMultiSelect"in e && i(6, $ = e.enableMultiSelect)
            }
            ,
            e.$$.update = () => {
                31457664 & e.$$.dirty && i(10, o = e => k$(e, u, c, s.origin, s.translation, l.rotation.z, s.scale, a, r)),
                31457664 & e.$$.dirty && i(9, n = e => _$(e, u, c, s.origin, s.translation, l.rotation.z, s.scale, a, r))
            }
            ,
            [p, h, m, f, g, y, $, r, a, n, o, d, b, v, x, w, S, _, k, C, "redact", s, l, c, u, e => (( (e, t) => {
                const i = Lm(e, t);
                pu(i, (t => Am(t) === e))
            }
            )("to-front", Im(e[0])),
            e), function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var ib = {
            util: ["redact", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, tb, eb, ar, {
                        name: 20,
                        isActive: 0,
                        isActiveFraction: 1,
                        isVisible: 2,
                        stores: 3,
                        locale: 4,
                        markupEditorWillStartInteraction: 5,
                        enableMultiSelect: 6
                    })
                }
                get name() {
                    return this.$$.ctx[20]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get isActiveFraction() {
                    return this.$$.ctx[1]
                }
                set isActiveFraction(e) {
                    this.$$set({
                        isActiveFraction: e
                    }),
                    $a()
                }
                get isVisible() {
                    return this.$$.ctx[2]
                }
                set isVisible(e) {
                    this.$$set({
                        isVisible: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[3]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[4]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get markupEditorWillStartInteraction() {
                    return this.$$.ctx[5]
                }
                set markupEditorWillStartInteraction(e) {
                    this.$$set({
                        markupEditorWillStartInteraction: e
                    }),
                    $a()
                }
                get enableMultiSelect() {
                    return this.$$.ctx[6]
                }
                set enableMultiSelect(e) {
                    this.$$set({
                        enableMultiSelect: e
                    }),
                    $a()
                }
            }
            , ({src: e}) => e && !Ls(e)]
        };
        function ob(e) {
            let t, i, o = (H(e[32].label) ? e[32].label(e[1]) : e[32].label) + "";
            return {
                c() {
                    t = Er("span"),
                    i = Ar(o)
                },
                m(e, o) {
                    Mr(e, t, o),
                    kr(t, i)
                },
                p(e, t) {
                    2 & t[0] | 2 & t[1] && o !== (o = (H(e[32].label) ? e[32].label(e[1]) : e[32].label) + "") && Wr(i, o)
                },
                d(e) {
                    e && Pr(t)
                }
            }
        }
        function nb(e) {
            let t, i, o, n = (e[11](e[32].value) || "") + "", r = e[32].label && ob(e);
            return {
                c() {
                    t = Er("div"),
                    i = new Ur(!1),
                    o = Ir(),
                    r && r.c(),
                    i.a = o,
                    Or(t, "slot", "option")
                },
                m(e, a) {
                    Mr(e, t, a),
                    i.m(n, t),
                    kr(t, o),
                    r && r.m(t, null)
                },
                p(e, o) {
                    2 & o[1] && n !== (n = (e[11](e[32].value) || "") + "") && i.p(n),
                    e[32].label ? r ? r.p(e, o) : (r = ob(e),
                    r.c(),
                    r.m(t, null)) : r && (r.d(1),
                    r = null)
                },
                d(e) {
                    e && Pr(t),
                    r && r.d()
                }
            }
        }
        function rb(e) {
            let t, i;
            return t = new Nd({
                props: {
                    locale: e[1],
                    class: "PinturaControlList",
                    layout: "row",
                    options: e[2],
                    selectedIndex: e[4],
                    onchange: e[10],
                    $$slots: {
                        option: [nb, ({option: e}) => ({
                            32: e
                        }), ({option: e}) => [0, e ? 2 : 0]]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    2 & i[0] && (o.locale = e[1]),
                    4 & i[0] && (o.options = e[2]),
                    16 & i[0] && (o.selectedIndex = e[4]),
                    2 & i[0] | 6 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function ab(e) {
            let t, i, o;
            return i = new Su({
                props: {
                    elasticity: e[5],
                    $$slots: {
                        default: [rb]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            {
                c() {
                    t = Er("div"),
                    za(i.$$.fragment),
                    Or(t, "slot", "footer"),
                    Or(t, "style", e[3])
                },
                m(e, n) {
                    Mr(e, t, n),
                    Fa(i, t, null),
                    o = !0
                },
                p(e, n) {
                    const r = {};
                    32 & n[0] && (r.elasticity = e[5]),
                    22 & n[0] | 4 & n[1] && (r.$$scope = {
                        dirty: n,
                        ctx: e
                    }),
                    i.$set(r),
                    (!o || 8 & n[0]) && Or(t, "style", e[3])
                },
                i(e) {
                    o || (ka(i.$$.fragment, e),
                    o = !0)
                },
                o(e) {
                    Ca(i.$$.fragment, e),
                    o = !1
                },
                d(e) {
                    e && Pr(t),
                    Oa(i)
                }
            }
        }
        function sb(e) {
            let t, i;
            return t = new Lf({
                props: {
                    $$slots: {
                        footer: [ab]
                    },
                    $$scope: {
                        ctx: e
                    }
                }
            }),
            t.$on("measure", e[22]),
            {
                c() {
                    za(t.$$.fragment)
                },
                m(e, o) {
                    Fa(t, e, o),
                    i = !0
                },
                p(e, i) {
                    const o = {};
                    62 & i[0] | 4 & i[1] && (o.$$scope = {
                        dirty: i,
                        ctx: e
                    }),
                    t.$set(o)
                },
                i(e) {
                    i || (ka(t.$$.fragment, e),
                    i = !0)
                },
                o(e) {
                    Ca(t.$$.fragment, e),
                    i = !1
                },
                d(e) {
                    Oa(t, e)
                }
            }
        }
        function lb(e, t, i) {
            let o, n, r, a, s, l, c, u, d, p, h = Jn, m = () => (h(),
            h = sr(f, (e => i(17, l = e))),
            f);
            e.$$.on_destroy.push(( () => h()));
            let {isActive: f} = t;
            m();
            let {stores: g} = t
              , {locale: y={}} = t
              , {fillOptions: $=[]} = t;
            const b = e => e.map((e => (e => Ui(e) && W(e[0]) && Ui(e[1]))(e) ? [e[0], b(e[1]), e[2]] : (e => [Array.isArray(e) && 3 === e.length ? [...e, 1] : e, void 0, {
                disabled: !1
            }])(e)))
              , v = oa("elasticityMultiplier");
            cr(e, v, (e => i(21, p = e)));
            const {history: x, animation: w, scrollElasticity: S, imageBackgroundColor: _, imageBackgroundImage: k, allowPan: C, allowZoom: T, allowZoomControls: M, allowPlayPause: P} = g;
            cr(e, w, (e => i(18, c = e))),
            cr(e, _, (e => i(20, d = e))),
            cr(e, k, (e => i(19, u = e)));
            const E = ic(c ? 20 : 0);
            return cr(e, E, (e => i(16, s = e))),
            e.$$set = e => {
                "isActive"in e && m(i(0, f = e.isActive)),
                "stores"in e && i(14, g = e.stores),
                "locale"in e && i(1, y = e.locale),
                "fillOptions"in e && i(15, $ = e.fillOptions)
            }
            ,
            e.$$.update = () => {
                32768 & e.$$.dirty[0] && i(2, o = b($)),
                131072 & e.$$.dirty[0] && C.set(l),
                131072 & e.$$.dirty[0] && T.set(l),
                131072 & e.$$.dirty[0] && M.set(l),
                131072 & e.$$.dirty[0] && l && P.set(!0),
                2097152 & e.$$.dirty[0] && i(5, n = p * S),
                1572868 & e.$$.dirty[0] && i(4, r = o.findIndex(( ([e]) => u ? e === u : Array.isArray(e) ? ms(e, d) : void 0)) || 0),
                393216 & e.$$.dirty[0] && c && E.set(l ? 0 : 20),
                65536 & e.$$.dirty[0] && i(3, a = s ? `transform: translateY(${s}px)` : void 0)
            }
            ,
            [f, y, o, a, r, n, v, w, _, k, ({value: e}) => {
                W(e) && (yr(_, d = void 0, d),
                yr(k, u = e, u)),
                Ui(e) && (yr(_, d = e, d),
                yr(k, u = void 0, u)),
                x.write()
            }
            , e => {
                if (W(e))
                    return `<div class="PinturaFillTile"><img src="${e}" alt="" width="48" height="64"/></div>`;
                if (Ui(e)) {
                    const [t,i,o,n] = e.map(( (e, t) => t < 3 ? Math.round(255 * e) : e));
                    return `<div class="PinturaFillTile" data-transparent="${n < 1}"><div style="background-color:rgba(${t},${i},${o},${n})"></div></div>`
                }
                return "<div></div>"
            }
            , E, "fill", g, $, s, l, c, u, d, p, function(t) {
                na.call(this, e, t)
            }
            ]
        }
        var cb = {
            util: ["fill", class extends Na {
                constructor(e) {
                    super(),
                    Ba(this, e, lb, sb, ar, {
                        name: 13,
                        isActive: 0,
                        stores: 14,
                        locale: 1,
                        fillOptions: 15
                    }, null, [-1, -1])
                }
                get name() {
                    return this.$$.ctx[13]
                }
                get isActive() {
                    return this.$$.ctx[0]
                }
                set isActive(e) {
                    this.$$set({
                        isActive: e
                    }),
                    $a()
                }
                get stores() {
                    return this.$$.ctx[14]
                }
                set stores(e) {
                    this.$$set({
                        stores: e
                    }),
                    $a()
                }
                get locale() {
                    return this.$$.ctx[1]
                }
                set locale(e) {
                    this.$$set({
                        locale: e
                    }),
                    $a()
                }
                get fillOptions() {
                    return this.$$.ctx[15]
                }
                set fillOptions(e) {
                    this.$$set({
                        fillOptions: e
                    }),
                    $a()
                }
            }
            , ({src: e, fillOptions: t}) => e && !Ls(e) && t && t.length]
        };
        const ub = '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M18 6L6 18M6 6l12 12"></path></path></g>'
          , db = '<path fill="none" d="M9 15 L12 9 L15 15 M10 13.5 h3" stroke="currentColor" stroke-width=".125em"/>';
        var pb = {
            labelReset: "Reset",
            labelDefault: "Default",
            labelAuto: "Auto",
            labelNone: "None",
            labelEdit: "Edit",
            labelClose: "Close",
            labelSupportError: e => `${e.join(", ")} not supported on this browser`,
            labelColor: "Color",
            labelWidth: "Width",
            labelSize: "Size",
            labelOffset: "Offset",
            labelAmount: "Amount",
            labelInset: "Inset",
            labelRadius: "Radius",
            labelColorPalette: "Color palette",
            labelSizeExtraSmall: "Extra small",
            labelSizeSmall: "Small",
            labelSizeMediumSmall: "Medium small",
            labelSizeMedium: "Medium",
            labelSizeMediumLarge: "Medium large",
            labelSizeLarge: "Large",
            labelSizeExtraLarge: "Extra large",
            labelButtonCancel: "Cancel",
            labelButtonUndo: "Undo",
            labelButtonRedo: "Redo",
            labelButtonRevert: "Revert",
            labelButtonExport: "Done",
            labelZoomIn: "Zoom in",
            labelZoomOut: "Zoom out",
            labelZoomFit: "Fit to view",
            labelZoomActual: "Actual size",
            iconZoomIn: '<path stroke="currentColor" stroke-width=".125em" d="M8 12 h8 M12 8 v8" />',
            iconZoomOut: '<path stroke="currentColor" stroke-width=".125em" d="M9 12 h6" />',
            iconSupportError: '<g fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><g><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></g>',
            iconButtonClose: ub,
            iconButtonRevert: '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M7.388 18.538a8 8 0 10-2.992-9.03"/><path fill="currentColor" d="M2.794 11.696L2.37 6.714l5.088 3.18z"/><path d="M12 8v4M12 12l4 2"/></g>',
            iconButtonUndo: '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M10 8h4c2.485 0 5 2 5 5s-2.515 5-5 5h-4"/><path fill="currentColor" d="M5 8l4-3v6z"/></g>',
            iconButtonRedo: '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M14 8h-4c-2.485 0-5 2-5 5s2.515 5 5 5h4"/><path fill="currentColor" d="M19 8l-4-3v6z"/></g>',
            iconButtonExport: '<polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" stroke-width=".125em"></polyline>',
            statusLabelButtonClose: "Close",
            statusIconButtonClose: ub,
            statusLabelLoadImage: e => e && e.task ? e.error ? "IMAGE_TOO_SMALL" === e.error.code ? "Minimum image size is {minWidth} &times; {minHeight}" : "Error loading image" : "blob-to-bitmap" === e.task ? "Preparing image&hellip;" : "Loading image&hellip;" : "Waiting for image",
            statusLabelProcessImage: e => {
                if (e && e.task)
                    return "store" === e.task ? e.error ? "Error uploading image" : "Uploading image&hellip;" : e.error ? "Error processing image" : "Processing image&hellip;"
            }
        };
        const hb = {
            shapeLabelButtonSelectSticker: "Select image",
            shapeIconButtonSelectSticker: '<g fill="none" stroke="currentColor" stroke-width="0.0625em"><path d="M8 21 L15 11 L19 15"/><path d="M15 2 v5 h5"/><path d="M8 2 h8 l4 4 v12 q0 4 -4 4 h-8 q-4 0 -4 -4 v-12 q0 -4 4 -4z"/></g><circle fill="currentColor" cx="10" cy="8" r="1.5"/>',
            shapeIconButtonFlipHorizontal: '<g stroke="currentColor" stroke-width=".125em"><path fill="none" d="M6 6.5h5v11H6z"/><path fill="currentColor" d="M15 6.5h3v11h-3z"/><path d="M11 4v16" fill="currentColor"/></g>',
            shapeIconButtonFlipVertical: '<g stroke="currentColor" stroke-width=".125em"><rect x="7" y="8" width="11" height="5" fill="none"/><rect x="7" y="17" width="11" height="2" fill="currentColor"/><line x1="5" y1="13" x2="20" y2="13"/></g>',
            shapeIconButtonRemove: '<g fill="none" fill-rule="evenodd"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M7.5 7h9z"/><path d="M7.916 9h8.168a1 1 0 01.99 1.14l-.972 6.862a2 2 0 01-1.473 1.653c-.877.23-1.753.345-2.629.345-.876 0-1.752-.115-2.628-.345a2 2 0 01-1.473-1.653l-.973-6.862A1 1 0 017.916 9z" fill="currentColor"/><rect fill="currentColor" x="10" y="5" width="4" height="3" rx="1"/></g>',
            shapeIconButtonDuplicate: '<g fill="none" fill-rule="evenodd"><path d="M15 13.994V16a2 2 0 01-2 2H8a2 2 0 01-2-2v-5a2 2 0 012-2h2.142" stroke="currentColor" stroke-width=".125em"/><path d="M15 9V8a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1zm-4-4h6a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2V7a2 2 0 012-2z" fill="currentColor"/></g>',
            shapeIconButtonMoveToFront: '<g fill="none" fill-rule="evenodd"><rect fill="currentColor" x="11" y="13" width="8" height="2" rx="1"/><rect fill="currentColor" x="9" y="17" width="10" height="2" rx="1"/><path d="M11.364 8H10a5 5 0 000 10M12 6.5L14.5 8 12 9.5z" stroke="currentColor" stroke-width=".125em" stroke-linecap="round"/></g>',
            shapeIconButtonTextLayoutAutoWidth: `${db}`,
            shapeIconButtonTextLayoutAutoHeight: `<g fill="currentColor"><circle cx="4" cy="12" r="1.5"/><circle cx="20" cy="12" r="1.5"/></g>${db}`,
            shapeIconButtonTextLayoutFixedSize: `<g fill="currentColor"><circle cx="5" cy="6" r="1.5"/><circle cx="19" cy="6" r="1.5"/><circle cx="19" cy="19" r="1.5"/><circle cx="5" cy="19" r="1.5"/></g>${db}`,
            shapeTitleButtonTextLayoutAutoWidth: "Auto width",
            shapeTitleButtonTextLayoutAutoHeight: "Auto height",
            shapeTitleButtonTextLayoutFixedSize: "Fixed size",
            shapeTitleButtonFlipHorizontal: "Flip Horizontal",
            shapeTitleButtonFlipVertical: "Flip Vertical",
            shapeTitleButtonRemove: "Remove",
            shapeTitleButtonDuplicate: "Duplicate",
            shapeTitleButtonMoveToFront: "Move to front",
            shapeLabelInputText: "Edit text",
            shapeIconInputCancel: '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M18 6L6 18M6 6l12 12"/></g>',
            shapeIconInputConfirm: '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><polyline points="20 6 9 17 4 12"/></g>',
            shapeLabelInputCancel: "Cancel",
            shapeLabelInputConfirm: "Confirm",
            shapeLabelStrokeNone: "No outline",
            shapeLabelFontStyleNormal: "Normal",
            shapeLabelFontStyleBold: "Bold",
            shapeLabelFontStyleItalic: "Italic",
            shapeLabelFontStyleItalicBold: "Bold Italic",
            shapeTitleBackgroundColor: "Fill color",
            shapeTitleCornerRadius: "Corner radius",
            shapeTitleFontFamily: "Font",
            shapeTitleFontSize: "Font size",
            shapeTitleFontStyle: "Font style",
            shapeTitleLineHeight: "Line height",
            shapeTitleLineStart: "Start",
            shapeTitleLineEnd: "End",
            shapeTitleStrokeWidth: "Line width",
            shapeTitleStrokeColor: "Line color",
            shapeTitleLineDecorationBar: "Bar",
            shapeTitleLineDecorationCircle: "Circle",
            shapeTitleLineDecorationSquare: "Square",
            shapeTitleLineDecorationArrow: "Arrow",
            shapeTitleLineDecorationCircleSolid: "Circle solid",
            shapeTitleLineDecorationSquareSolid: "Square solid",
            shapeTitleLineDecorationArrowSolid: "Arrow solid",
            shapeIconLineDecorationBar: '<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H16"/><path d="M16,8 V16"/></g>',
            shapeIconLineDecorationCircle: '<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><circle fill="none" stroke-width=".125em" cx="16" cy="12" r="4"/></g>',
            shapeIconLineDecorationSquare: '<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><rect fill="none" stroke-width=".125em" x="12" y="8" width="8" height="8"/></g>',
            shapeIconLineDecorationArrow: '<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H16 M13,7 l6,5 l-6,5" fill="none"/></g>',
            shapeIconLineDecorationCircleSolid: '<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><circle fill="currentColor" cx="16" cy="12" r="4"/></g>',
            shapeIconLineDecorationSquareSolid: '<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><rect fill="currentColor" x="12" y="8" width="8" height="8"/></g>',
            shapeIconLineDecorationArrowSolid: '<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H16"/><path d="M13,7 l6,5 l-6,5z" fill="currentColor"/></g>',
            shapeTitleColorTransparent: "Transparent",
            shapeTitleColorWhite: "White",
            shapeTitleColorSilver: "Silver",
            shapeTitleColorGray: "Gray",
            shapeTitleColorBlack: "Black",
            shapeTitleColorNavy: "Navy",
            shapeTitleColorBlue: "Blue",
            shapeTitleColorAqua: "Aqua",
            shapeTitleColorTeal: "Teal",
            shapeTitleColorOlive: "Olive",
            shapeTitleColorGreen: "Green",
            shapeTitleColorYellow: "Yellow",
            shapeTitleColorOrange: "Orange",
            shapeTitleColorRed: "Red",
            shapeTitleColorMaroon: "Maroon",
            shapeTitleColorFuchsia: "Fuchsia",
            shapeTitleColorPurple: "Purple",
            shapeTitleTextOutline: "Text outline",
            shapeTitleTextOutlineWidth: "Width",
            shapeTitleTextShadow: "Text shadow",
            shapeTitleTextShadowBlur: "Blur",
            shapeTitleTextColor: "Font color",
            shapeTitleTextAlign: "Text align",
            shapeTitleTextAlignLeft: "Left align text",
            shapeTitleTextAlignCenter: "Center align text",
            shapeTitleTextAlignRight: "Right align text",
            shapeIconTextAlignLeft: '<g stroke-width=".125em" stroke="currentColor"><line x1="5" y1="8" x2="15" y2="8"/><line x1="5" y1="12" x2="19" y2="12"/><line x1="5" y1="16" x2="14" y2="16"/></g>',
            shapeIconTextAlignCenter: '<g stroke-width=".125em" stroke="currentColor"><line x1="7" y1="8" x2="17" y2="8"/><line x1="5" y1="12" x2="19" y2="12"/><line x1="8" y1="16" x2="16" y2="16"/></g>',
            shapeIconTextAlignRight: '<g stroke-width=".125em" stroke="currentColor"><line x1="9" y1="8" x2="19" y2="8"/><line x1="5" y1="12" x2="19" y2="12"/><line x1="11" y1="16" x2="19" y2="16"/></g>',
            shapeLabelToolMove: "Move",
            shapeLabelToolView: "View",
            shapeLabelToolSharpie: "Sharpie",
            shapeLabelToolEraser: "Eraser",
            shapeLabelToolPath: "Path",
            shapeLabelToolRectangle: "Rectangle",
            shapeLabelToolEllipse: "Ellipse",
            shapeLabelToolArrow: "Arrow",
            shapeLabelToolLine: "Line",
            shapeLabelToolText: "Text",
            shapeLabelToolPreset: "Stickers",
            shapeIconToolView: '<g stroke-width=".125em" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M10.98 9.703V2.567c0-1.19 1.19-1.785 1.784-1.785.595 0 1.784.595 1.784 1.785v3.568"/><path d="M14.548 9.703V4.35c0-1.19 1.19-1.784 1.784-1.784.595 0 1.784.594 1.784 1.784v2.973"/><path d="M18.116 10.244V7.271c0-1.19 1.19-1.784 1.784-1.784.595 0 1.785.595 1.785 1.784 0 1.19 0 8.92-1.19 12.488-1.19 3.569-10.704 4.758-13.678 0-2.973-4.757-2.973-4.757-4.163-6.541-1.189-1.784-1.153-2.974-.594-3.568.558-.595 1.784-1.19 2.973.594 1.277 1.916 2.07 2.907 2.379 2.974V5.487c0-1.19 1.19-1.784 1.784-1.784.595 0 1.784.595 1.784 1.784V8.46"/></g>',
            shapeIconToolMove: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M6 2 L6 19 L18 13 Z M13 18 L16 24" stroke="currentColor" stroke-width=".125em" fill="none" fill-rule="evenodd" stroke-linejoin="round"/></g>',
            shapeIconToolSharpie: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M2.025 5c5.616-2.732 8.833-3.857 9.65-3.374C12.903 2.351.518 12.666 2.026 14 3.534 15.334 16.536.566 17.73 2.566 18.924 4.566 3.98 17.187 4.831 18c.851.813 9.848-6 11.643-6 1.087 0-2.53 5.11-2.92 7-.086.41 3.323-1.498 4.773-1 .494.17.64 2.317 1.319 3 .439.443 1.332.776 2.679 1" stroke="currentColor" stroke-width=".125em" fill="none" fill-rule="evenodd" stroke-linejoin="round"/></g>',
            shapeIconToolEraser: '<g stroke-width=".125em" stroke="currentColor" stroke-linecap="round" fill="none"><g transform="translate(3, 15) rotate(-45)"><rect x="0" y="0" width="18" height="10" rx="3"/></g><line x1="11" y1="21" x2="18" y2="21"/><line x1="20" y1="21" x2="22" y2="21"/></g>',
            shapeIconToolPath: '<g stroke-width=".125em" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" fill="none"><circle cx="21" cy="3" r="2"/><circle cx="9" cy="9" r="2"/><circle cx="3" cy="21" r="2"/><path d="M19 4 11 8 M8 11 4 19"/></g>',
            shapeIconToolRectangle: '<g stroke-width=".125em" stroke="currentColor" fill="none"><rect x="1" y="1" width="22" height="22" rx="4"/></g>',
            shapeIconToolEllipse: '<g stroke-width=".125em" stroke="currentColor" fill="none"><circle cx="12" cy="12" r="11"/></g>',
            shapeIconToolArrow: '<g stroke-width=".125em" stroke="currentColor" fill="none"><line x1="20" y1="3" x2="6" y2="21"/><path d="m10 6 L21.5 1 L20 13.5" fill="currentColor" stroke="none"/></g>',
            shapeIconToolLine: '<g stroke-width=".125em" stroke="currentColor" fill="none"><line x1="20" y1="3" x2="6" y2="21"/></g>',
            shapeIconToolText: '<g stroke="none" fill="currentColor" transform="translate(6,0)"><path d="M8.14 20.085c.459 0 .901-.034 1.329-.102a8.597 8.597 0 001.015-.21v1.984c-.281.135-.695.247-1.242.336a9.328 9.328 0 01-1.477.133c-3.312 0-4.968-1.745-4.968-5.235V6.804H.344v-1.25l2.453-1.078L3.89.819h1.5v3.97h4.97v2.015H5.39v10.078c0 1.031.245 1.823.735 2.375s1.161.828 2.015.828z"/>',
            shapeIconToolPreset: '<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M12 22c2.773 0 1.189-5.177 3-7 1.796-1.808 7-.25 7-3 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10z"></path><path d="M20 17c-3 3-5 5-8 5"></path></g>',
            shapeTitleSelectionMode: "Selection mode",
            shapeTitleBrushSize: "Brush size",
            shapeLabelSelectionModeNew: "New",
            shapeLabelSelectionModeAdd: "Add",
            shapeLabelSelectionModeSubtract: "Remove",
            shapeLabelToolSelectionBrush: "Brush",
            shapeLabelToolSelectionLassoo: "Lassoo",
            shapeLabelToolSelectionRectangle: "Rectangle marquee",
            shapeLabelToolSelectionEllipse: "Ellipse marquee",
            shapeIconSelectionModeNew: '<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 17H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.5"/><rect width="12" height="12" x="9" y="9" fill="currentColor" fill-opacity=".25" rx="2"/></g>',
            shapeIconSelectionModeAdd: '<g fill="none" fill-rule="evenodd" stroke="currentColor"><path fill="currentColor" fill-opacity=".25" stroke-linecap="round" stroke-linejoin="round" d="M15 3a2 2 0 0 1 2 2v4h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Z"/><path d="M13 15h4M15 13v4"/></g>',
            shapeIconSelectionModeSubtract: '<g fill="none" fill-rule="evenodd" stroke="currentColor"><path fill="currentColor" fill-opacity=".25" stroke-linecap="round" stroke-linejoin="round" d="M15 3a2 2 0 0 1 2 2v4h-6a2 2 0 0 0-1.995 1.85L9 11v6H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Z"/><rect width="12" height="12" x="9" y="9" stroke-linecap="round" stroke-linejoin="round" rx="2"/><path d="M13 15h4"/></g>',
            shapeIconToolSelectionBrush: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M2.025 5c5.616-2.732 8.833-3.857 9.65-3.374C12.903 2.351.518 12.666 2.026 14 3.534 15.334 16.536.566 17.73 2.566 18.924 4.566 3.98 17.187 4.831 18c.851.813 9.848-6 11.643-6 1.087 0-2.53 5.11-2.92 7-.086.41 3.323-1.498 4.773-1 .494.17.64 2.317 1.319 3 .439.443 1.332.776 2.679 1" stroke="currentColor" fill-rule="evenodd" stroke-linejoin="round"/></g>',
            shapeIconToolSelectionLassoo: '<g fill="none" fill-rule="evenodd" stroke-width=".125em" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M11.428 17.702a18.46 18.46 0 0 0 4.085-1.595c5.851-3.112 9.019-8.599 7.074-12.256-1.945-3.657-8.265-4.1-14.116-.988C2.619 5.974-.55 11.46 1.396 15.118c.63 1.186 1.72 2.033 3.105 2.532"/><ellipse cx="8" cy="18.5" rx="3.5" ry="2.833" transform="rotate(-15 8 18.5)"/><path stroke-linecap="round" d="M5 18c3.347 1.048 5.514 1.881 6.5 2.5.859.54 1.517.994 1.5 2.364"/></g>',
            shapeIconToolSelectionRectangle: '<g stroke-width=".125em" stroke="currentColor"><path d="M9 1 h6 m4 0 h4v4 m0 4 v6 m0 4 v4h-4 m-4 0 h-6 m-4 0 h-4v-4 m0 -4 v-6 m0 -4 v-4h4" fill="none" /></g>',
            shapeIconToolSelectionEllipse: '<path stroke-width=".125em" stroke="currentColor" d="M1.21 9.853a11.054 11.054 0 0 0 0 4.294m1.643 3.965a11.054 11.054 0 0 0 3.035 3.035m3.965 1.644a11.054 11.054 0 0 0 4.294 0m3.965-1.644a11.054 11.054 0 0 0 3.035-3.035m1.644-3.965a11.054 11.054 0 0 0 0-4.294m-1.644-3.965a11.054 11.054 0 0 0-3.035-3.035m-3.965-1.644a11.054 11.054 0 0 0-4.294 0M5.888 2.853a11.054 11.054 0 0 0-3.035 3.035"/>'
        };
        var mb = (e, t) => {
            const i = Object.getOwnPropertyDescriptors(e);
            Object.keys(i).forEach((o => {
                i[o].get ? Object.defineProperty(t, o, {
                    get: () => e[o],
                    set: t => e[o] = t
                }) : t[o] = e[o]
            }
            ))
        }
        ;
        _() && HTMLElement;
        const {document: fb, window: gb} = Pa;
        function yb(e) {
            let t, i, o, n;
            return ha(e[27]),
            {
                c() {
                    t = Ir(),
                    i = Er("div"),
                    Or(i, "class", e[4]),
                    Or(i, "style", e[5])
                },
                m(r, a) {
                    Mr(r, t, a),
                    Mr(r, i, a),
                    e[28](i),
                    o || (n = [Dr(gb, "keydown", e[10]), Dr(gb, "orientationchange", e[11]), Dr(gb, "resize", e[27]), Dr(fb.body, "focusin", (function() {
                        rr(!e[1] && e[7]) && (!e[1] && e[7]).apply(this, arguments)
                    }
                    )), Dr(fb.body, "focusout", (function() {
                        rr(e[2] && e[8]) && (e[2] && e[8]).apply(this, arguments)
                    }
                    )), Dr(i, "wheel", e[9], {
                        passive: !1
                    })],
                    o = !0)
                },
                p(t, o) {
                    e = t,
                    16 & o[0] && Or(i, "class", e[4]),
                    32 & o[0] && Or(i, "style", e[5])
                },
                i: Jn,
                o: Jn,
                d(r) {
                    r && Pr(t),
                    r && Pr(i),
                    e[28](null),
                    o = !1,
                    nr(n)
                }
            }
        }
        function $b(e, t, i) {
            let o, n, r, a, s, l, c, u;
            const d = ta();
            let {root: p} = t
              , {preventZoomViewport: h=!0} = t
              , {preventScrollBodyIfNeeded: m=!0} = t
              , {preventFooterOverlapIfNeeded: f=!0} = t
              , {class: g} = t
              , y = !0
              , $ = !1
              , b = !1
              , v = _() && document.documentElement
              , x = _() && document.body
              , w = _() && document.head;
            const S = ic(0, {
                precision: .001,
                damping: .5
            });
            cr(e, S, (e => i(26, u = e)));
            const k = S.subscribe((e => {
                b && e >= 1 ? (i(19, b = !1),
                i(1, y = !1),
                d("show")) : $ && e <= 0 && (i(18, $ = !1),
                i(1, y = !0),
                d("hide"))
            }
            ));
            let C, T, P, E = !1;
            const R = () => document.querySelector("meta[name=viewport]")
              , A = () => Array.from(document.querySelectorAll("meta[name=theme-color]"));
            let I;
            let L, D, z, F = 0;
            const O = () => {
                D || (D = M("div", {
                    style: "position:fixed;height:100vh;top:0"
                }),
                x.append(D))
            }
            ;
            let B;
            Qr(( () => {
                f && ki() && O()
            }
            )),
            Jr(( () => {
                D && (i(21, z = D.offsetHeight),
                D.remove(),
                D = void 0)
            }
            ));
            const N = () => v.style.setProperty("--pintura-document-height", `${window.innerHeight}px`);
            return ea(( () => {
                v.classList.remove("PinturaModalBodyLock"),
                k()
            }
            )),
            e.$$set = e => {
                "root"in e && i(0, p = e.root),
                "preventZoomViewport"in e && i(12, h = e.preventZoomViewport),
                "preventScrollBodyIfNeeded"in e && i(13, m = e.preventScrollBodyIfNeeded),
                "preventFooterOverlapIfNeeded"in e && i(14, f = e.preventFooterOverlapIfNeeded),
                "class"in e && i(15, g = e.class)
            }
            ,
            e.$$.update = () => {
                67895298 & e.$$.dirty[0] && i(25, o = b || $ ? u : y ? 0 : 1),
                4096 & e.$$.dirty[0] && (n = "width=device-width,height=device-height,initial-scale=1" + (h ? ",maximum-scale=1,user-scalable=0" : "")),
                786434 & e.$$.dirty[0] && i(22, r = !b && !y && !$),
                12 & e.$$.dirty[0] && (E || i(20, L = F)),
                2097160 & e.$$.dirty[0] && i(24, a = Wi(z) ? "--viewport-pad-footer:" + (z > F ? 0 : 1) : ""),
                51380224 & e.$$.dirty[0] && i(5, s = `opacity:${o};height:${L}px;--editor-modal:1;${a}`),
                32768 & e.$$.dirty[0] && i(4, l = Pc(["pintura-editor", "PinturaModal", g])),
                8192 & e.$$.dirty[0] && i(23, c = m && ki() && /15_/.test(navigator.userAgent)),
                12582912 & e.$$.dirty[0] && c && (e => {
                    e ? (B = window.scrollY,
                    v.classList.add("PinturaDocumentLock"),
                    N(),
                    window.addEventListener("resize", N)) : (window.removeEventListener("resize", N),
                    v.classList.remove("PinturaDocumentLock"),
                    Wi(B) && window.scrollTo(0, B),
                    B = void 0)
                }
                )(r)
            }
            ,
            [p, y, E, F, l, s, S, e => {
                Gu(e.target) && (i(2, E = !0),
                I = F)
            }
            , e => {
                if (Gu(e.target))
                    if (clearTimeout(void 0),
                    I === F)
                        i(2, E = !1);
                    else {
                        const e = F;
                        ( (e, t) => {
                            const i = () => {
                                e() ? t() : requestAnimationFrame(i)
                            }
                            ;
                            requestAnimationFrame(i)
                        }
                        )(( () => F !== e), ( () => i(2, E = !1)))
                    }
            }
            , e => {
                e.target && /PinturaStage/.test(e.target.className) && e.preventDefault()
            }
            , e => {
                const {key: t} = e;
                if (!/escape/i.test(t))
                    return;
                const i = e.target;
                if (i && /input|textarea/i.test(i.nodeName))
                    return;
                const o = document.querySelectorAll(".PinturaModal");
                o[o.length - 1] === p && d("close")
            }
            , O, h, m, f, g, () => {
                if (b || !y)
                    return;
                i(19, b = !0);
                const e = R() || M("meta", {
                    name: "viewport"
                });
                C = !C && e.getAttribute("content"),
                e.setAttribute("content", n + (/cover/.test(C) ? ",viewport-fit=cover" : "")),
                e.parentNode || w.append(e);
                const t = getComputedStyle(p).getPropertyValue("--color-background")
                  , o = A();
                if (o.length)
                    T = o.map((e => e.getAttribute("content")));
                else {
                    const e = M("meta", {
                        name: "theme-color"
                    });
                    w.append(e),
                    o.push(e)
                }
                o.forEach((e => e.setAttribute("content", `rgb(${t})`))),
                clearTimeout(P),
                P = setTimeout(( () => S.set(1)), 250)
            }
            , () => {
                if ($ || y)
                    return;
                clearTimeout(P),
                i(18, $ = !0);
                const e = R();
                C ? e.setAttribute("content", C) : e.remove();
                const t = A();
                T ? t.forEach(( (e, t) => {
                    e.setAttribute("content", T[t])
                }
                )) : t.forEach((e => e.remove())),
                S.set(0)
            }
            , $, b, L, z, r, c, a, o, u, function() {
                i(3, F = gb.innerHeight)
            }
            , function(e) {
                aa[e ? "unshift" : "push"](( () => {
                    p = e,
                    i(0, p)
                }
                ))
            }
            ]
        }
        class bb extends Na {
            constructor(e) {
                super(),
                Ba(this, e, $b, yb, ar, {
                    root: 0,
                    preventZoomViewport: 12,
                    preventScrollBodyIfNeeded: 13,
                    preventFooterOverlapIfNeeded: 14,
                    class: 15,
                    show: 16,
                    hide: 17
                }, null, [-1, -1])
            }
            get root() {
                return this.$$.ctx[0]
            }
            set root(e) {
                this.$$set({
                    root: e
                }),
                $a()
            }
            get preventZoomViewport() {
                return this.$$.ctx[12]
            }
            set preventZoomViewport(e) {
                this.$$set({
                    preventZoomViewport: e
                }),
                $a()
            }
            get preventScrollBodyIfNeeded() {
                return this.$$.ctx[13]
            }
            set preventScrollBodyIfNeeded(e) {
                this.$$set({
                    preventScrollBodyIfNeeded: e
                }),
                $a()
            }
            get preventFooterOverlapIfNeeded() {
                return this.$$.ctx[14]
            }
            set preventFooterOverlapIfNeeded(e) {
                this.$$set({
                    preventFooterOverlapIfNeeded: e
                }),
                $a()
            }
            get class() {
                return this.$$.ctx[15]
            }
            set class(e) {
                this.$$set({
                    class: e
                }),
                $a()
            }
            get show() {
                return this.$$.ctx[16]
            }
            get hide() {
                return this.$$.ctx[17]
            }
        }
        const vb = (e, t, i, o) => {
            const n = Ce(t.x - e.x, t.y - e.y)
              , r = Ae(n)
              , a = 5 * i;
            let s;
            s = o ? .5 * a : Math.ceil(.5 * (a - 1));
            const l = Be(Me(r), s);
            return {
                anchor: Me(e),
                offset: l,
                normal: r,
                solid: o,
                size: a,
                sizeHalf: s
            }
        }
          , xb = (e, t, i) => {
            const {strokeWidth: o, strokeColor: n, strokeJoin: r, strokeCap: a, ...s} = e
              , {anchor: l, offset: c, normal: u, solid: d, size: p, sizeHalf: h} = t
              , m = l.x
              , f = l.y
              , g = Be(Me(u), p)
              , y = Ce(m + g.x, f + g.y);
            if (Be(g, .55),
            d) {
                ze(i, c);
                const e = Be(Me(u), .5 * h);
                return [{
                    ...s,
                    points: [Ce(m - e.x, f - e.y), Ce(y.x - g.y, y.y + g.x), Ce(y.x + g.y, y.y - g.x)],
                    pathClose: !0,
                    backgroundColor: n
                }]
            }
            {
                const e = Be((e => {
                    const t = e.x;
                    return e.x = -e.y,
                    e.y = t,
                    e
                }
                )(Me(u)), .5)
                  , t = Ce(m - e.x, f - e.y)
                  , i = Ce(m + e.x, f + e.y);
                return [{
                    ...s,
                    points: [Ce(y.x + g.y, y.y - g.x), t, Ce(m, f), i, Ce(y.x - g.y, y.y + g.x)],
                    pathClose: !1,
                    strokeWidth: o,
                    strokeColor: n,
                    strokeJoin: r,
                    strokeCap: a
                }]
            }
        }
          , wb = (e, t, i) => {
            const {strokeWidth: o, strokeColor: n, ...r} = e
              , {anchor: a, solid: s, offset: l, normal: c, sizeHalf: u} = t;
            return ze(i, l),
            s && ze(i, Pe(Me(c))),
            [{
                ...r,
                x: a.x,
                y: a.y,
                rx: u,
                ry: u,
                backgroundColor: s ? n : void 0,
                strokeWidth: s ? void 0 : o,
                strokeColor: s ? void 0 : n
            }]
        }
          , Sb = (e, t) => {
            const {strokeWidth: i, strokeColor: o, strokeJoin: n, strokeCap: r, ...a} = e
              , {anchor: s, offset: l} = t;
            return [{
                ...a,
                points: [Ce(s.x - l.y, s.y + l.x), Ce(s.x + l.y, s.y - l.x)],
                strokeWidth: i,
                strokeColor: o,
                strokeJoin: n,
                strokeCap: r
            }]
        }
          , _b = (e, t, i) => {
            const {strokeWidth: o, strokeColor: n, ...r} = e
              , {anchor: a, solid: s, offset: l, normal: c, sizeHalf: u} = t;
            return ze(i, l),
            [{
                ...r,
                x: a.x - u,
                y: a.y - u,
                width: 2 * u,
                height: 2 * u,
                rotation: (d = c,
                Math.atan2(d.y, d.x)),
                backgroundColor: s ? n : void 0,
                strokeWidth: s ? void 0 : o,
                strokeColor: s ? void 0 : n
            }];
            var d
        }
          , kb = (e, t) => {
            const i = parseFloat(e) * t;
            return W(e) ? `${i}%` : i
        }
          , Cb = (e, t) => W(e) ? mn(e, t) : e
          , Tb = e => [{
            ...e,
            frameStyle: "line",
            frameInset: 0,
            frameOffset: 0,
            frameSize: e.frameSize ? kb(e.frameSize, 2) : "2.5%",
            frameRadius: e.frameRound ? kb(e.frameSize, 2) : 0
        }]
          , Mb = ({width: e, height: t, frameImage: i, frameSize: o="15%", frameOutset: n=0, frameSlices: r={
            x1: .15,
            y1: .15,
            x2: .85,
            y2: .85
        }}, {isPreview: a}) => {
            if (!i)
                return [];
            const s = Math.sqrt(e * t)
              , l = Cb(o, s)
              , c = a ? l : Math.round(l)
              , u = c
              , d = Cb(n, s)
              , p = 2 * d
              , {x1: h, x2: m, y1: f, y2: g} = r
              , y = {
                x0: 0,
                y0: 0,
                x1: c,
                y1: u,
                x2: e - c,
                y2: t - u,
                x3: e,
                y3: t,
                cw: c,
                ch: u,
                ew: e - c - c,
                eh: t - u - u
            }
              , $ = a ? 1 : 0
              , b = 2 * $
              , v = d > 0
              , x = {
                expandsCanvas: v,
                width: y.cw,
                height: y.ch,
                backgroundImage: i
            };
            return [{
                expandsCanvas: v,
                x: y.x1 - $ - d,
                y: y.y0 - d,
                width: y.ew + b + p,
                height: y.ch,
                backgroundCorners: [{
                    x: h,
                    y: 0
                }, {
                    x: m,
                    y: 0
                }, {
                    x: m,
                    y: f
                }, {
                    x: h,
                    y: f
                }],
                backgroundImage: i
            }, {
                expandsCanvas: v,
                x: y.x1 - $ - d,
                y: y.y2 + d,
                width: y.ew + b + p,
                height: y.ch,
                backgroundCorners: [{
                    x: h,
                    y: g
                }, {
                    x: m,
                    y: g
                }, {
                    x: m,
                    y: 1
                }, {
                    x: h,
                    y: 1
                }],
                backgroundImage: i
            }, {
                expandsCanvas: v,
                x: y.x0 - d,
                y: y.y1 - $ - d,
                width: y.cw,
                height: y.eh + b + p,
                backgroundCorners: [{
                    x: 0,
                    y: f
                }, {
                    x: h,
                    y: f
                }, {
                    x: h,
                    y: g
                }, {
                    x: 0,
                    y: g
                }],
                backgroundImage: i
            }, {
                expandsCanvas: v,
                x: y.x2 + d,
                y: y.y1 - $ - d,
                width: y.cw,
                height: y.eh + b + p,
                backgroundCorners: [{
                    x: m,
                    y: f
                }, {
                    x: 1,
                    y: f
                }, {
                    x: 1,
                    y: g
                }, {
                    x: m,
                    y: g
                }],
                backgroundImage: i
            }, {
                ...x,
                x: y.x0 - d,
                y: y.y0 - d,
                backgroundCorners: [{
                    x: 0,
                    y: 0
                }, {
                    x: h,
                    y: 0
                }, {
                    x: h,
                    y: f
                }, {
                    x: 0,
                    y: f
                }]
            }, {
                ...x,
                x: y.x2 + d,
                y: y.y0 - d,
                backgroundCorners: [{
                    x: m,
                    y: 0
                }, {
                    x: 1,
                    y: 0
                }, {
                    x: 1,
                    y: f
                }, {
                    x: m,
                    y: f
                }]
            }, {
                ...x,
                x: y.x2 + d,
                y: y.y2 + d,
                backgroundCorners: [{
                    x: m,
                    y: g
                }, {
                    x: 1,
                    y: g
                }, {
                    x: 1,
                    y: 1
                }, {
                    x: m,
                    y: 1
                }]
            }, {
                ...x,
                x: y.x0 - d,
                y: y.y2 + d,
                backgroundCorners: [{
                    x: 0,
                    y: g
                }, {
                    x: h,
                    y: g
                }, {
                    x: h,
                    y: 1
                }, {
                    x: 0,
                    y: 1
                }]
            }]
        }
          , Pb = ({x: e, y: t, width: i, height: o, frameInset: n="3.5%", frameSize: r=".25%", frameColor: a=[1, 1, 1], frameOffset: s="5%", frameAmount: l=1, frameRadius: c=0, expandsCanvas: u=!1}, {isPreview: d}) => {
            const p = Math.sqrt(i * o);
            let h = Cb(r, p);
            const m = Cb(n, p)
              , f = Cb(s, p);
            let g = 0;
            d || (h = Math.max(1, Math.round(h)),
            g = h % 2 == 0 ? 0 : .5);
            const y = Cb(kb(c, l), p);
            return new Array(l).fill(void 0).map(( (n, r) => {
                const s = f * r;
                let l = e + m + s
                  , c = t + m + s
                  , p = e + i - m - s
                  , $ = t + o - m - s;
                return d || (l = Math.round(l),
                c = Math.round(c),
                p = Math.round(p),
                $ = Math.round($)),
                {
                    x: l + g,
                    y: c + g,
                    width: p - l,
                    height: $ - c,
                    cornerRadius: y > 0 ? y - s : 0,
                    strokeWidth: h,
                    strokeColor: a,
                    expandsCanvas: u
                }
            }
            ))
        }
          , Eb = ({x: e, y: t, width: i, height: o, frameSize: n=".25%", frameOffset: r=0, frameInset: a="2.5%", frameColor: s=[1, 1, 1]}, {isPreview: l}) => {
            const c = Math.sqrt(i * o);
            let u = Cb(n, c)
              , d = Cb(a, c)
              , p = Cb(r, c)
              , h = 0;
            l || (u = Math.max(1, Math.round(u)),
            d = Math.round(d),
            p = Math.round(p),
            h = u % 2 == 0 ? 0 : .5);
            const m = p - d
              , f = e + d + h
              , g = t + d + h
              , y = e + i - d - h
              , $ = t + o - d - h;
            return [{
                points: [Ce(f + m, g), Ce(y - m, g)]
            }, {
                points: [Ce(y, g + m), Ce(y, $ - m)]
            }, {
                points: [Ce(y - m, $), Ce(f + m, $)]
            }, {
                points: [Ce(f, $ - m), Ce(f, g + m)]
            }].map((e => (e.strokeWidth = u,
            e.strokeColor = s,
            e)))
        }
          , Rb = ({x: e, y: t, width: i, height: o, frameSize: n=".25%", frameInset: r="2.5%", frameLength: a="2.5%", frameColor: s=[1, 1, 1]}, {isPreview: l}) => {
            const c = Math.sqrt(i * o);
            let u = Cb(n, c)
              , d = Cb(r, c)
              , p = Cb(a, c)
              , h = 0;
            l || (u = Math.max(1, Math.round(u)),
            d = Math.round(d),
            p = Math.round(p),
            h = u % 2 == 0 ? 0 : .5);
            const m = e + d + h
              , f = t + d + h
              , g = e + i - d - h
              , y = t + o - d - h;
            return [{
                points: [Ce(m, f + p), Ce(m, f), Ce(m + p, f)]
            }, {
                points: [Ce(g - p, f), Ce(g, f), Ce(g, f + p)]
            }, {
                points: [Ce(g, y - p), Ce(g, y), Ce(g - p, y)]
            }, {
                points: [Ce(m + p, y), Ce(m, y), Ce(m, y - p)]
            }].map((e => (e.strokeWidth = u,
            e.strokeColor = s,
            e)))
        }
          , Ab = ({x: e, y: t, width: i, height: o, frameColor: n=[1, 1, 1]}, {isPreview: r}) => {
            const a = Math.sqrt(i * o)
              , s = .1 * a;
            let l = .2 * a
              , c = 0;
            const u = .5 * s;
            return r ? c = 1 : l = Math.ceil(l),
            n.length = 3,
            [{
                id: "border",
                x: e - u + c,
                y: t - u + c,
                width: i + s - 2 * c,
                height: o + l - 2 * c,
                frameStyle: "line",
                frameInset: 0,
                frameOffset: 0,
                frameSize: s,
                frameColor: n,
                expandsCanvas: !0
            }, {
                id: "chin",
                x: e - u,
                y: o - c,
                width: i + s,
                height: l,
                backgroundColor: n,
                expandsCanvas: !0
            }].filter(Boolean)
        }
          , Ib = ul
          , Lb = pl
          , Db = (e={}) => {
            const {blurAmount: t, dataSizeScalar: i, scrambleAmount: o, backgroundColor: n} = e;
            return (e, r) => (async (e, t={}) => {
                if (!e)
                    return;
                const {width: i, height: o} = e
                  , {dataSize: n=96, dataSizeScalar: r=1, scrambleAmount: a=4, blurAmount: s=6, outputFormat: l="canvas", backgroundColor: c=[0, 0, 0]} = t
                  , u = Math.round(n * r)
                  , d = Math.min(u / i, u / o)
                  , p = Math.floor(i * d)
                  , h = Math.floor(o * d)
                  , m = M("canvas", {
                    width: p,
                    height: h
                })
                  , f = m.getContext("2d", {
                    willReadFrequently: !0
                });
                if (c.length = 3,
                f.fillStyle = Qi(c),
                f.fillRect(0, 0, p, h),
                R(e)) {
                    const t = M("canvas", {
                        width: i,
                        height: o
                    });
                    t.getContext("2d", {
                        willReadFrequently: !0
                    }).putImageData(e, 0, 0),
                    f.drawImage(t, 0, 0, p, h),
                    E(t)
                } else
                    f.drawImage(e, 0, 0, p, h);
                const g = f.getImageData(0, 0, p, h)
                  , y = [];
                if (a > 0 && y.push([Xl, {
                    amount: a
                }]),
                s > 0)
                    for (let e = 0; e < s; e++)
                        y.push([zi, {
                            matrix: Zl
                        }]);
                let $;
                if (y.length) {
                    const e = (t, i) => `(err, imageData) => {\n(${t[i][0].toString()})(Object.assign({ imageData: imageData }, filterInstructions[${i}]), \n${t[i + 1] ? e(t, i + 1) : "done"})\n}`
                      , t = `function (options, done) {\nconst filterInstructions = options.filterInstructions;\nconst imageData = options.imageData;\n(${e(y, 0)})(null, imageData)\n}`
                      , i = await G(t, [{
                        imageData: g,
                        filterInstructions: y.map((e => e[1]))
                    }], [g.data.buffer]);
                    $ = Ii(i)
                } else
                    $ = g;
                return "canvas" === l ? (f.putImageData($, 0, 0),
                m) : $
            }
            )(e, {
                blurAmount: t,
                scrambleAmount: o,
                backgroundColor: n,
                ...r,
                dataSizeScalar: i || r.dataSizeScalar
            })
        }
          , zb = yf
          , Fb = {
            markupEditorToolbar: ( (e=["move", "view", "sharpie", "eraser", "path", "line", "arrow", "rectangle", "ellipse", "text", "preset"]) => e.map((e => W(e) ? Xm(e) : Array.isArray(e) ? O(e[1]) ? Xm(e[0], void 0, e[1]) : Xm(e[0], e[1], e[2]) : void 0)).filter(Boolean))(),
            markupEditorToolStyles: (e => {
                const t = {
                    sharpie: Km("path", {
                        bitmap: !0,
                        strokeJoin: "round",
                        strokeCap: "round",
                        strokeWidth: Vm,
                        strokeColor: [...Um],
                        cursorStyle: "ellipse",
                        cursorSize: "strokeWidth",
                        disableErase: !1,
                        disableResize: !0,
                        disableMove: !0
                    }),
                    eraser: Km("eraser"),
                    path: Km("path", {
                        pathClose: void 0,
                        strokeWidth: Vm,
                        strokeColor: [...Um],
                        backgroundColor: [0, 0, 0, 0]
                    }, {
                        inputMode: "step"
                    }),
                    line: Km("line", {
                        strokeColor: [...Um],
                        strokeWidth: Vm
                    }),
                    arrow: Km("line", {
                        lineStart: "none",
                        lineEnd: "arrow-solid",
                        strokeColor: [...Um],
                        strokeWidth: Vm
                    }),
                    rectangle: Km("rectangle", {
                        strokeColor: [...qm],
                        backgroundColor: [...Um]
                    }),
                    ellipse: Km("ellipse", {
                        strokeColor: [...qm],
                        backgroundColor: [...Um]
                    }),
                    text: Km("text", {
                        color: [...Um],
                        fontSize: "2%"
                    })
                };
                return e && Object.entries(e).forEach(( ([e,i]) => {
                    Array.isArray(i) ? t[e] = i : O(i) && t[e] && (t[e] = [{
                        ...t[e][0],
                        ...i
                    }, t[e][1]])
                }
                )),
                t
            }
            )(),
            markupEditorShapeStyleControls: yf()
        }
          , Ob = Pg
          , Bb = zg
          , Nb = Ug
          , Wb = P$
          , Hb = A$
          , jb = D$
          , Ub = W$
          , Vb = ib
          , qb = J$
          , Gb = cb
          , Kb = zm
          , Xb = Dm
          , Zb = {
            frameStyles: {
                solidSharp: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "solid",
                        frameSize: "2.5%"
                    },
                    thumb: '<rect stroke-width="5" x="0" y="0" width="100%" height="100%"/>'
                },
                solidRound: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "solid",
                        frameSize: "2.5%",
                        frameRound: !0
                    },
                    thumb: '<rect stroke-width="5" x="0" y="0" width="100%" height="100%" rx="12%"/>'
                },
                lineSingle: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "line",
                        frameInset: "2.5%",
                        frameSize: ".3125%",
                        frameRadius: 0
                    },
                    thumb: '<div style="top:.5em;left:.5em;right:.5em;bottom:.5em;box-shadow:inset 0 0 0 1px currentColor"></div>'
                },
                lineMultiple: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "line",
                        frameAmount: 2,
                        frameInset: "2.5%",
                        frameSize: ".3125%",
                        frameOffset: "1.25%",
                        frameRadius: 0
                    },
                    thumb: '<div style="top:.75em;left:.75em;right:.75em;bottom:.75em; outline: 3px double"></div>'
                },
                edgeSeparate: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "edge",
                        frameInset: "2.5%",
                        frameOffset: "5%",
                        frameSize: ".3125%"
                    },
                    thumb: '<div style="top:.75em;left:.5em;bottom:.75em;border-left:1px solid"></div><div style="top:.75em;right:.5em;bottom:.75em;border-right:1px solid"></div><div style="top:.5em;left:.75em;right:.75em;border-top:1px solid"></div><div style="bottom:.5em;left:.75em;right:.75em;border-bottom:1px solid"></div>'
                },
                edgeCross: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "edge",
                        frameInset: "2.5%",
                        frameSize: ".3125%"
                    },
                    thumb: '<div style="top:-.5em;left:.5em;right:.5em;bottom:-.5em; box-shadow: inset 0 0 0 1px currentColor"></div><div style="top:.5em;left:-.5em;right:-.5em;bottom:.5em;box-shadow:inset 0 0 0 1px currentColor"></div>'
                },
                edgeOverlap: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "edge",
                        frameOffset: "1.5%",
                        frameSize: ".3125%"
                    },
                    thumb: '<div style="top:.3125em;left:.5em;bottom:.3125em;border-left:1px solid"></div><div style="top:.3125em;right:.5em;bottom:.3125em;border-right:1px solid"></div><div style="top:.5em;left:.3125em;right:.3125em;border-top:1px solid"></div><div style="bottom:.5em;left:.3125em;right:.3125em;border-bottom:1px solid"></div>'
                },
                hook: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "hook",
                        frameInset: "2.5%",
                        frameSize: ".3125%",
                        frameLength: "5%"
                    },
                    thumb: '<div style="top:.5em;left:.5em;width:.75em;height:.75em; border-left: 1px solid;border-top: 1px solid;"></div><div style="top:.5em;right:.5em;width:.75em;height:.75em; border-right: 1px solid;border-top: 1px solid;"></div><div style="bottom:.5em;left:.5em;width:.75em;height:.75em; border-left: 1px solid;border-bottom: 1px solid;"></div><div style="bottom:.5em;right:.5em;width:.75em;height:.75em; border-right: 1px solid;border-bottom: 1px solid;"></div>'
                },
                polaroid: {
                    shape: {
                        frameColor: [1, 1, 1],
                        frameStyle: "polaroid"
                    },
                    thumb: '<rect stroke-width="20%" x="-5%" y="-5%" width="110%" height="96%"/>'
                }
            },
            frameOptions: [[void 0, e => e.labelNone], ["solidSharp", e => e.frameLabelMatSharp], ["solidRound", e => e.frameLabelMatRound], ["lineSingle", e => e.frameLabelLineSingle], ["lineMultiple", e => e.frameLabelLineMultiple], ["edgeCross", e => e.frameLabelEdgeCross], ["edgeSeparate", e => e.frameLabelEdgeSeparate], ["edgeOverlap", e => e.frameLabelEdgeOverlap], ["hook", e => e.frameLabelCornerHooks], ["polaroid", e => e.frameLabelPolaroid]]
        }
          , Yb = pb
          , Qb = hb
          , Jb = {
            cropLabel: "Crop",
            cropIcon: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M23 17H9a2 2 0 0 1-2-2v-5m0-3V1 M1 7h14a2 2 0 0 1 2 2v7m0 4v3"/></g>',
            cropIconButtonRecenter: '<path stroke="currentColor" fill="none" stroke-width="2" stroke-linejoin="bevel" d="M1.5 7.5v-6h6M1.5 16.5v6h6M22.5 16.5v6h-6M22.5 7.5v-6h-6"/><circle cx="12" cy="12" r="3.5" fill="currentColor" stroke="none"/>',
            cropIconButtonRotateLeft: '<g stroke="none" fill="currentColor"><path fill="none" d="M-1-1h582v402H-1z"/><rect x="3" rx="1" height="12" width="12" y="9"/><path d="M15 5h-1a5 5 0 015 5 1 1 0 002 0 7 7 0 00-7-7h-1.374l.747-.747A1 1 0 0011.958.84L9.603 3.194a1 1 0 000 1.415l2.355 2.355a1 1 0 001.415-1.414l-.55-.55H15z"/></g>',
            cropIconButtonRotateRight: '<g stroke="none" fill="currentColor"><path fill="none" d="M-1-1h582v402H-1z"/><path d="M11.177 5H10a5 5 0 00-5 5 1 1 0 01-2 0 7 7 0 017-7h1.374l-.747-.747A1 1 0 0112.042.84l2.355 2.355a1 1 0 010 1.415l-2.355 2.354a1 1 0 01-1.415-1.414l.55-.55z"/><rect rx="1" height="12" width="12" y="9" x="9"/></g>',
            cropIconButtonFlipVertical: '<g stroke="none" fill="currentColor"><path d="M19.993 12.143H7a1 1 0 0 1-1-1V5.994a1 1 0 0 1 1.368-.93l12.993 5.15a1 1 0 0 1-.368 1.93z"/><path d="M19.993 14a1 1 0 0 1 .368 1.93L7.368 21.078A1 1 0 0 1 6 20.148V15a1 1 0 0 1 1-1h12.993z" opacity=".6"/></g>',
            cropIconButtonFlipHorizontal: '<g stroke="none" fill="currentColor"><path d="M11.93 7.007V20a1 1 0 0 1-1 1H5.78a1 1 0 0 1-.93-1.368l5.15-12.993a1 1 0 0 1 1.929.368z"/><path d="M14 7.007V20a1 1 0 0 0 1 1h5.149a1 1 0 0 0 .93-1.368l-5.15-12.993A1 1 0 0 0 14 7.007z" opacity=".6"/></g>',
            cropIconSelectPreset: (e, t) => {
                const [i,o,n] = t ? [t < 1 ? 1 : .3, 1 === t ? .85 : .5, t > 1 ? 1 : .3] : [.2, .3, .4];
                return `<g fill="currentColor">\n            <rect opacity="${i}" x="2" y="4" width="10" height="18" rx="1"/>\n            <rect opacity="${o}" x="4" y="8" width="14" height="14" rx="1"/>\n            <rect opacity="${n}" x="6" y="12" width="17" height="10" rx="1"/>\n        </g>`
            }
            ,
            cropIconCropBoundary: (e, t) => {
                const [i,o,n,r] = t ? [.3, 1, 0, 0] : [0, 0, .3, 1];
                return `<g fill="currentColor">\n            <rect opacity="${i}" x="2" y="3" width="20" height="20" rx="1"/>\n            <rect opacity="${o}" x="7" y="8" width="10" height="10" rx="1"/>\n            <rect opacity="${n}" x="4" y="8" width="14" height="14" rx="1"/>\n            <rect opacity="${r}" x="12" y="4" width="10" height="10" rx="1"/>\n        </g>`
            }
            ,
            cropLabelButtonRecenter: "Recenter",
            cropLabelButtonRotateLeft: "Rotate left",
            cropLabelButtonRotateRight: "Rotate right",
            cropLabelButtonFlipHorizontal: "Flip horizontal",
            cropLabelButtonFlipVertical: "Flip vertical",
            cropLabelSelectPreset: "Crop shape",
            cropLabelCropBoundary: "Crop boundary",
            cropLabelCropBoundaryEdge: "Edge of image",
            cropLabelCropBoundaryNone: "None",
            cropLabelTabRotation: "Rotation",
            cropLabelTabZoom: "Scale"
        }
          , ev = {
            fillLabel: "Fill",
            fillIcon: '\n    <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em">\n        <g transform="rotate(60, 12, 12)">\n            <rect x="4" y="4" width="14" height="16" rx="3"/>\n        </g>\n        <path d="M21 13 L21 21"></path>\n        <path d="M4.5 12.5 L19 12.5"></path>\n    </g>\n    '
        }
          , tv = {
            filterLabel: "Filter",
            filterIcon: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M18.347 9.907a6.5 6.5 0 1 0-1.872 3.306M3.26 11.574a6.5 6.5 0 1 0 2.815-1.417 M10.15 17.897A6.503 6.503 0 0 0 16.5 23a6.5 6.5 0 1 0-6.183-8.51"/></g>',
            filterLabelChrome: "Chrome",
            filterLabelFade: "Fade",
            filterLabelCold: "Cold",
            filterLabelWarm: "Warm",
            filterLabelPastel: "Pastel",
            filterLabelMonoDefault: "Mono",
            filterLabelMonoNoir: "Noir",
            filterLabelMonoWash: "Wash",
            filterLabelMonoStark: "Stark",
            filterLabelSepiaDefault: "Sepia",
            filterLabelSepiaBlues: "Blues",
            filterLabelSepiaRust: "Rust",
            filterLabelSepiaColor: "Color"
        }
          , iv = {
            finetuneLabel: "Finetune",
            finetuneIcon: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M4 1v5.5m0 3.503V23M12 1v10.5m0 3.5v8M20 1v15.5m0 3.5v3M2 7h4M10 12h4M18 17h4"/></g>',
            finetuneLabelBrightness: "Brightness",
            finetuneLabelContrast: "Contrast",
            finetuneLabelSaturation: "Saturation",
            finetuneLabelExposure: "Exposure",
            finetuneLabelTemperature: "Temperature",
            finetuneLabelGamma: "Gamma",
            finetuneLabelClarity: "Clarity",
            finetuneLabelVignette: "Vignette"
        }
          , ov = {
            resizeLabel: "Resize",
            resizeIcon: '<g stroke-width=".125em" stroke="currentColor" fill="none"><rect x="2" y="12" width="10" height="10" rx="2"/><path d="M4 11.5V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5"/><path d="M14 10l3.365-3.365M14 6h4v4"/></g>',
            resizeLabelFormCaption: "Image output size",
            resizeLabelInputWidth: "w",
            resizeTitleInputWidth: "Width",
            resizeLabelInputHeight: "h",
            resizeTitleInputHeight: "Height",
            resizeTitleButtonMaintainAspectRatio: "Maintain aspectratio",
            resizeIconButtonMaintainAspectRatio: (e, t) => `<defs><mask id="mask1" x="0" y="0" width="24" height="24" ><rect x="0" y="0" width="24" height="10" fill="#fff" stroke="none"/></mask></defs><g fill="none" fill-rule="evenodd"><g  mask="url(#mask1)"><path transform="translate(0 ${3 * (t - 1)})" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" d="M9.401 10.205v-.804a2.599 2.599 0 0 1 5.198 0V17"/></g><rect fill="currentColor" x="7" y="10" width="10" height="7" rx="1.5"/></g>`
        }
          , nv = {
            decorateLabel: "Decorate",
            decorateIcon: '<g fill="none" fill-rule="evenodd"><path stroke="currentColor" stroke-width=".125em" stroke-linecap="round" stroke-linejoin="round" d="M12 18.5l-6.466 3.4 1.235-7.2-5.23-5.1 7.228-1.05L12 2l3.233 6.55 7.229 1.05-5.231 5.1 1.235 7.2z"/></g>'
        }
          , rv = {
            annotateLabel: "Annotate",
            annotateIcon: '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M17.086 2.914a2.828 2.828 0 1 1 4 4l-14.5 14.5-5.5 1.5 1.5-5.5 14.5-14.5z"/></g>'
        }
          , av = {
            stickerLabel: "Sticker",
            stickerIcon: '<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M12 22c2.773 0 1.189-5.177 3-7 1.796-1.808 7-.25 7-3 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10z"/><path d="M20 17c-3 3-5 5-8 5"/></g>'
        }
          , sv = {
            frameLabel: "Frame",
            frameIcon: '<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em">\n            <rect x="2" y="2" width="20" height="20" rx="4"/>\n            <rect x="6" y="6" width="12" height="12" rx="1"/>\n        </g>',
            frameLabelMatSharp: "Mat",
            frameLabelMatRound: "Bevel",
            frameLabelLineSingle: "Line",
            frameLabelLineMultiple: "Zebra",
            frameLabelEdgeSeparate: "Inset",
            frameLabelEdgeOverlap: "Plus",
            frameLabelEdgeCross: "Lumber",
            frameLabelCornerHooks: "Hook",
            frameLabelPolaroid: "Polaroid"
        }
          , lv = {
            redactLabel: "Redact",
            redactIcon: '<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M 4 5 l 1 -1"/><path d="M 4 10 l 6 -6"/><path d="M 4 15 l 11 -11"/><path d="M 4 20 l 16 -16"/><path d="M 9 20 l 11 -11"/><path d="M 14 20 l 6 -6"/><path d="M 19 20 l 1 -1"/></g>'
        }
          , cv = (e={}, t) => {
            const {sub: i, pub: o} = oo()
              , n = {}
              , r = ( (e={}, t) => new bb({
                target: t || document.body,
                props: {
                    class: e.class,
                    preventZoomViewport: e.preventZoomViewport,
                    preventScrollBodyIfNeeded: e.preventScrollBodyIfNeeded,
                    preventFooterOverlapIfNeeded: e.preventFooterOverlapIfNeeded
                }
            }))(e, t)
              , a = () => {
                r.hide && r.hide()
            }
              , s = () => {
                r.show && r.show()
            }
              , l = (e => {
                const t = {}
                  , {sub: i, pub: o} = oo();
                _() && null !== document.doctype || console.warn("Browser is in quirks mode, add <!DOCTYPE html> to page to fix render issues");
                const n = ks();
                mb(n, t);
                const r = ( (e, t) => {
                    const i = {}
                      , o = new wm({
                        target: e,
                        props: {
                            stores: t,
                            pluginComponents: Array.from(Pm)
                        }
                    });
                    let n = !1;
                    const r = () => {
                        n || (_() && window.removeEventListener("pagehide", r),
                        o && (n = !0,
                        o.$destroy()))
                    }
                    ;
                    Cm || (Cm = new Set(Zc(wm).filter((e => !_m.includes(e))))),
                    Cm.forEach((e => {
                        Object.defineProperty(i, e, {
                            get: () => o[e],
                            set: km.includes(e) ? t => {
                                o[e] = {
                                    ...o[e],
                                    ...t
                                }
                            }
                            : t => o[e] = t
                        })
                    }
                    )),
                    Object.defineProperty(i, "previewImageData", {
                        get: () => o.imagePreviewCurrent
                    }),
                    Tm.forEach((e => {
                        const t = Mm[e]
                          , n = t[0];
                        Object.defineProperty(i, e, {
                            get: () => o.pluginInterface[n][e],
                            set: i => {
                                const n = t.reduce(( (t, n) => (t[n] = {
                                    ...o.pluginOptions[n],
                                    [e]: i
                                },
                                t)), {});
                                o.pluginOptions = {
                                    ...o.pluginOptions,
                                    ...n
                                }
                            }
                        })
                    }
                    )),
                    Object.defineProperty(i, "element", {
                        get: () => o.root,
                        set: () => {}
                    });
                    const a = o.history;
                    return ts(i, {
                        on: (e, t) => {
                            if (n)
                                return () => {}
                                ;
                            if (/undo|redo|revert|writehistory/.test(e))
                                return a.on(e, t);
                            const i = [o.sub(e, t), o.$on(e, (e => t(e instanceof CustomEvent && !e.detail ? void 0 : e)))].filter(Boolean);
                            return () => i.forEach((e => e()))
                        }
                        ,
                        updateImagePreview: e => {
                            o.imagePreviewSrc = e
                        }
                        ,
                        close: () => !n && o.pub("close"),
                        destroy: r
                    }),
                    Object.defineProperty(i, "history", {
                        get: () => ({
                            undo: () => a.undo(),
                            redo: () => a.redo(),
                            revert: () => a.revert(),
                            get: () => a.get(),
                            getCollapsed: () => a.get().splice(0, a.index + 1),
                            set: e => a.set(e),
                            write: e => a.write(e),
                            get length() {
                                return a.length()
                            },
                            get index() {
                                return a.index
                            },
                            set index(e) {
                                a.index = e
                            }
                        })
                    }),
                    _() && window.addEventListener("pagehide", r),
                    i
                }
                )(e, n.stores);
                mb(r, t);
                const a = ["loadImage", "processImage", "abortProcessImage", "abortLoadImage"].map((e => r.on(e, (t => {
                    const i = n[e](t && t.detail);
                    i instanceof Promise && i.catch($)
                }
                ))))
                  , s = (e, t) => {
                    const o = i(e, t)
                      , a = n.on(e, t)
                      , s = r.on(e, t);
                    return () => {
                        o(),
                        a(),
                        s()
                    }
                }
                ;
                t.handleEvent = $;
                const l = Em.map((e => s(e, (i => t.handleEvent(e, i)))));
                return ts(t, {
                    on: s,
                    updateImage: e => new Promise(( (i, o) => {
                        const r = t.history.get()
                          , a = t.history.index
                          , s = t.imageState;
                        n.loadImage(e).then((e => {
                            t.history.set(r),
                            t.history.index = a,
                            t.imageState = s,
                            i(e)
                        }
                        )).catch(o)
                    }
                    )),
                    close: () => {
                        o("close")
                    }
                    ,
                    destroy: () => {
                        [...a, ...l].forEach((e => e())),
                        r.destroy(),
                        n.destroy(),
                        o("destroy")
                    }
                }),
                setTimeout(( () => o("init", t)), 0),
                t
            }
            )(r.root);
            mb(l, n),
            n.handleEvent = $,
            l.handleEvent = (e, t) => {
                if ("init" === e)
                    return n.handleEvent(e, n);
                n.handleEvent(e, t)
            }
            ,
            l.on("close", (async () => {
                const {willClose: t} = e;
                if (!t)
                    return a();
                await t() && a()
            }
            ));
            const c = (e, t) => /show|hide/.test(e) ? i(e, t) : l.on(e, t)
              , u = ["show", "hide"].map((e => c(e, (t => n.handleEvent(e, t)))))
              , d = () => {
                u.forEach((e => e())),
                a(),
                r.$destroy(),
                l.destroy()
            }
            ;
            return ts(n, {
                on: c,
                destroy: d,
                hide: a,
                show: s
            }),
            Object.defineProperty(n, "modal", {
                get: () => r.root,
                set: () => {}
            }),
            r.$on("close", l.close),
            r.$on("show", ( () => o("show"))),
            r.$on("hide", ( () => {
                o("hide"),
                !1 !== e.enableAutoDestroy && d()
            }
            )),
            !1 !== e.enableAutoHide && l.on("process", a),
            l.on("loadstart", s),
            !1 !== e.enableButtonClose && (e.enableButtonClose = !0),
            delete e.class,
            Object.assign(n, e),
            n
        }
          , uv = (e=[]) => (e => {
            const t = (i, o={
                isPreview: !0
            }) => {
                const n = e.map((e => {
                    const n = e(i, o);
                    if (n)
                        return n.map((e => t(e, o)))
                }
                )).filter(Boolean).flat();
                return n.length ? n.flat().map(( (e, t) => (e.id = i.id + "_" + t,
                e))) : i
            }
            ;
            return t
        }
        )([( (e={}) => (t, i) => {
            if (!ji(t, "frameStyle"))
                return;
            const o = t.frameStyle
              , n = e[o];
            if (!n)
                return;
            const {frameStyle: r, ...a} = t;
            return n(a, i)
        }
        )({
            solid: Tb,
            hook: Rb,
            line: Pb,
            edge: Eb,
            polaroid: Ab,
            nine: Mb
        }), ( (e={}) => t => {
            if (!t.lineStart && !t.lineEnd)
                return;
            const i = []
              , {x1: o, y1: n, x2: r, y2: a, lineStart: s, lineEnd: l, strokeWidth: c, strokeColor: u, strokeJoin: d, strokeCap: p, strokeDash: h, bitmap: m, aboveFrame: f, opacity: g} = t
              , y = Ce(o, n)
              , $ = Ce(r, a)
              , b = [y, $]
              , v = {
                bitmap: m,
                aboveFrame: f,
                opacity: g,
                strokeColor: u,
                strokeWidth: c,
                strokeJoin: d,
                strokeCap: p
            };
            if (s) {
                const [t,o] = s.split("-")
                  , n = e[t];
                if (n) {
                    const e = vb(y, $, c, !!o);
                    i.push(...n(v, e, y))
                }
            }
            if (l) {
                const [t,o] = l.split("-")
                  , n = e[t];
                if (n) {
                    const e = vb($, y, c, !!o);
                    i.push(...n(v, e, $))
                }
            }
            return [{
                ...v,
                strokeDash: h,
                points: b
            }, ...i]
        }
        )({
            arrow: xb,
            circle: wb,
            square: _b,
            bar: Sb
        }), ...e])
          , dv = (e={}) => {
            ( (...e) => {
                e.filter((e => !!e.util)).forEach((e => {
                    const [t,i,o=( () => !0)] = e.util;
                    Pm.has(t) || (Pm.set(t, {
                        Component: i,
                        isSupported: o
                    }),
                    Zc(i).filter((e => !Sm.includes(e))).forEach((e => {
                        Tm.add(e),
                        Mm[e] ? Mm[e].push(t) : Mm[e] = [t]
                    }
                    )))
                }
                ))
            }
            )(Ob, Bb, Nb, Wb, Hb, jb, Ub, Vb, qb, Gb);
            const t = ( (e={}) => {
                let t, i, o;
                return Array.isArray(e.imageReader) || (t = e.imageReader,
                delete e.imageReader),
                Array.isArray(e.imageWriter) ? i = Lb() : (i = H(e.imageWriter) ? e.imageWriter : Lb(e.imageWriter),
                delete e.imageWriter),
                H(e.imageScrambler) || (o = e.imageScrambler,
                delete e.imageScrambler),
                {
                    imageReader: Ib(t),
                    imageWriter: i,
                    imageOrienter: {
                        read: w,
                        apply: F
                    },
                    imageScrambler: Db(o)
                }
            }
            )(e)
              , i = {
                ...Yb,
                ...Qb,
                ...Jb,
                ...ev,
                ...tv,
                ...iv,
                ...sv,
                ...lv,
                ...ov,
                ...nv,
                ...rv,
                ...av,
                ...e.locale
            };
            delete e.locale;
            const o = "function" == typeof e.shapePreprocessor ? e.shapePreprocessor : uv(e.shapePreprocessor);
            return delete e.shapePreprocessor,
            e.markupEditorShapeStyleControls && Object.entries(e.markupEditorShapeStyleControls).every(( ([e,t]) => /Options$/.test(e) || !Array.isArray(t))) && (e.markupEditorShapeStyleControls = zb({
                ...e.markupEditorShapeStyleControls
            })),
            Va([{
                ...t,
                shapePreprocessor: o,
                utils: ["trim", "crop", "filter", "finetune", "retouch", "annotate", "decorate", "sticker", "fill", "frame", "redact", "resize"],
                ...Kb,
                ...Xb,
                ...Zb,
                ...Fb,
                stickerStickToImage: !0,
                locale: i
            }, e])
        }
          , pv = (e, t) => cv(dv(e), t);
        var hv = __webpack_require__(755);
        function mv(o) {
            var n = "";
            return o.Elements.forEach((function(o, r) {
                switch (o.ElementType) {
                case "TextInput":
                case "NumberInputNew":
                    var a = function(i) {
                        var o = null != i.MinValue ? i.MinValue : 0
                          , n = null != i.Maxvalue ? i.Maxvalue : 1e5;
                        let r = null != i.Maxdecimals ? i.Maxdecimals : 0
                          , a = null != i.enableToolTip && i.enableToolTip
                          , s = a ? i.toolTip : null
                          , l = null != i.isQuantity && i.isQuantity;
                        var c = null != i.Maxdecimals ? (0,
                        t.TY)(i.Maxdecimals) : 1
                          , u = fv(i)
                          , d = i.Name.replace(/"/g, "&quot;");
                        let p = !0 === a ? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + s + "<i></i></span></span>" : "";
                        return "<div class='element' data-element='" + i.Identifier + "' " + u.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + i.Name + p + "</label><input onkeyup='PriceUpdation(this)' onchange='PriceUpdation(\n      this)' data-identifier='" + i.Identifier + "' class='calc-prop numInput-cpc' step='" + c + "' min='" + o + "' max='" + n + "' onblur='CheckNumberInputValidity(this," + r + ");' data-rangeenabled='" + i.value_range_enabled + "' data-calcname='" + i.Name + "' name=\"properties[" + d + "]\" data-cpc_isquantity='" + l + "' value='" + i.DefaultValue + "' type='number'/></div>"
                    }(o);
                    n += a;
                    break;
                case "SelectList":
                    var s = function(t) {
                        var i = fv(t)
                          , o = t.Name.replace(/"/g, "&quot;");
                        let n = null != t.enableToolTip && t.enableToolTip
                          , r = n ? t.toolTip : null
                          , a = !0 === n ? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + r + "<i></i></span></div>" : "";
                        var s = "<div class='element' data-element='" + t.Identifier + "' " + i.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + a + "</label><select style='border:1px solid yellow' data-identifier='" + t.Identifier + "' onchange='ChangeEvent(null, this)' class='calc-prop' data-calcname='" + o + "' name=\"properties[" + o + ']">';
                        return t.Options.forEach((e => {
                            let t = e.label.replace(/'/g, "&#39;").replace(/"/g, "&quot;");
                            s += "<option data-val='" + e.value + "' data-label='" + t + "'>" + e.label + "</option>"
                        }
                        )),
                        s += "</select ></div >"
                    }(o);
                    n += s;
                    break;
                case "ImageSelector":
                    s = function(t) {
                        var i = fv(t)
                          , o = t.enableSwatch;
                        let n = null != t.enableToolTip && t.enableToolTip
                          , r = n ? t.toolTip : null
                          , a = !0 === n ? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + r + "<i></i></span></div>" : "";
                        var s = "";
                        if (!1 === o)
                            s = "<div class='element' " + i.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + a + "</label><select style='border:1px solid yellow' data-showimage='" + t.showImage + "' data-identifier='" + t.Identifier + "' onchange='ChangeEvent(\"" + t.ElementType + "\", this)' class='calc-prop' data-calcname='" + t.Name + "' name=\"properties[" + t.Name + '">',
                            t.Options.forEach((e => {
                                s += "<option data-val='" + e.value + "' data-label='" + e.label + "' data-imgsrc='" + e.filepath + "'  >" + e.label + "</option>"
                            }
                            )),
                            s += "</select ></div>",
                            t.Options.forEach((e => {
                                s += "<img src='" + e.filepath + "' style='display:none' />"
                            }
                            ));
                        else {
                            s = "<div class='element' " + i.conditionalTemplate + "><label class='element-label' data-identifier='" + t.Identifier + "' style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + a + "</label><fieldset class='swatch-picker'>";
                            let o = 0;
                            t.Options.forEach((e => {
                                o++;
                                let i = 1 === o ? "checked" : "";
                                s += "<labele class='swatch-label ctooltip' title='" + e.label + "'><input type='radio' class='calc-prop' data-identifier='" + t.Identifier + "' " + i + " data-showimage='" + t.showImage + "' value='" + e.label + "' data-val='" + e.value + "' data-imgsrc='" + e.filepath + "' data-calcname='" + t.Name + "' name=\"properties[" + t.Name + ']" onchange=\'ChangeEvent("' + t.ElementType + "\", this)' /><img src='" + e.filepath + "' /></labele>"
                            }
                            )),
                            s += "</fieldset></div>"
                        }
                        return s
                    }(o),
                    n += s;
                    break;
                case "PhotoEditor":
                    var l = function(t) {
                        var i = t.isRequired
                          , o = fv(t);
                        let n = null != t.enableToolTip && t.enableToolTip
                          , r = n ? t.toolTip : null
                          , a = t.properties ?? {}
                          , s = !0 === n ? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + r + "<i></i></span></span>" : ""
                          , l = "";
                        window.openEditor = function() {
                            const e = pv({
                                src: l
                            });
                            e.on("close", ( () => {
                                c()
                            }
                            )),
                            e.on("process", (e => {
                                c(e)
                            }
                            )),
                            hv("#previewloader").show(),
                            hv("#file-preview").hide(),
                            hv(".photoEditor_Editbutton").hide()
                        }
                        ;
                        const c = e => {
                            if (e) {
                                l = e.dest,
                                document.querySelector("#file-preview")?.setAttribute("src", URL.createObjectURL(e.dest));
                                let t = document.getElementById("photoeditor");
                                const i = new DataTransfer;
                                i.items.add(e.dest),
                                t.files = i.files
                            }
                            hv("#previewloader").hide(),
                            hv("#file-preview").show(),
                            hv(".photoEditor_Editbutton").show()
                        }
                        ;
                        return window.previewPhoto = e => {
                            const t = document.getElementById("photoeditor").files;
                            if (t) {
                                const i = new FileReader;
                                let o = document.getElementById("file-preview");
                                i.onload = function(t) {
                                    l = t.target.result,
                                    o.setAttribute("src", l),
                                    e?.type ? openEditor() : (hv("#previewloader").hide(),
                                    hv("#file-preview").show(),
                                    hv(".photoEditor_Editbutton").show())
                                }
                                ,
                                i.readAsDataURL(t[0])
                            }
                        }
                        ,
                        `<div class='element' data-element='${t.Identifier}'\n    ${o.conditionalTemplate}\n    >\n    <label style='color:${e.calculatorStyling.upperTextColor}'>\n    ${t.Name} \n    ${s} \n    </label>\n    <input \n    type="file"\n    id='photoeditor' \n    class='calc-prop' \n    data-identifier='${t.Identifier}' \n    data-isrequired=${i}\n    name = 'properties[${t.Name}]'\n    onchange='previewPhoto(event)'/>\n    <div class="photo-editor-container">\n      <div id="previewloader" style='display:none'>\n        <img  src="https://app.custompricecalculator.com/loading-spinner.gif"/>\n        <p>Loading Preview</p>\n      </div>\n      <img id="file-preview" />\n      <div \n      class="photoEditor_Editbutton" \n      style ='display:none;background-color:${a?.editButtonBG};color:${a?.editButtonTextColor}' \n      onclick="openEditor()">\n      ${a.editButtonText ? a.editButtonText : "Edit"} \n      </div>\n    </div>\n    </div>`
                    }(o);
                    n += l;
                    break;
                case "TextEditor":
                    a = function(t) {
                        var i = null != t.TextValue ? t.TextValue : ""
                          , o = fv(t);
                        let n = null != t.enableToolTip && t.enableToolTip
                          , r = n ? t.toolTip : null
                          , a = !0 === n ? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + r + "<i></i></span></span>" : "";
                        return "<div class='element' data-element='" + t.Identifier + "' " + o.conditionalTemplate + " ><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + i + a + "</label></div>"
                    }(o),
                    n += a;
                    break;
                case "ImageUpload":
                    var c = function(t) {
                        var i = t.isRequired
                          , o = fv(t);
                        let n = null != t.enableToolTip && t.enableToolTip
                          , r = n ? t.toolTip : null
                          , a = !0 === n ? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + r + "<i></i></span></span>" : "";
                        return "<div class='element' data-element='" + t.Identifier + "' " + o.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + a + "</label><input id='fileinput' class='calc-prop' data-identifier='" + t.Identifier + "' data-isrequired='" + i + "' type='file' name=\"properties[" + t.Name + ']" /></div>'
                    }(o);
                    n += c;
                    break;
                case "LongTextInput":
                    var u = function(t) {
                        var i = null != t.MinCharacters ? t.MinCharacters : 0
                          , o = null != t.MaxCharacters ? t.MaxCharacters : 1e5
                          , n = t.isRequired
                          , r = fv(t);
                        let a = null != t.enableToolTip && t.enableToolTip
                          , s = a ? t.toolTip : null
                          , l = !0 === a ? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + s + "<i></i></span></span>" : "";
                        return "<div class='element' data-element='" + t.Identifier + "' " + r.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + l + "</label><textarea class='calc-prop' data-identifier='" + t.Identifier + "' data-isrequired='" + n + "' minlength='" + i + "' maxlength='" + o + "' onblur='UpdatePrice() || validity.valid || (value = \"\");' data-calcname='" + t.Name + "' name=\"properties[" + t.Name + "]\" placeholder='" + t.Placeholder + "' data-lengthToggle='" + t.lengthToggle + "'></textarea></div>"
                    }(o);
                    n += u;
                    break;
                case "Checkbox":
                    u = function(t) {
                        var i = t.checkedValue
                          , o = t.uncheckedValue
                          , n = t.isRequired
                          , r = fv(t);
                        let a = null != t.enableToolTip && t.enableToolTip
                          , s = a ? t.toolTip : null
                          , l = !0 === a ? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + s + "<i></i></span></div>" : "";
                        return "<div class='element checkbox-element' data-element='" + t.Identifier + "' data-isrequired='" + n + "' " + r.conditionalTemplate + "'><input class='calc-prop checkbox' data-identifier='" + t.Identifier + "' data-isrequired='" + n + "'' onchange='ChangeEvent(null)' type='checkbox' value='" + i + "' name=\"properties[" + t.Name + "]\" data-calcname='" + t.Name + "' data-checkedvalue='" + i + "' data-uncheckedvalue='" + o + "'/><span style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + l + "</span></div>"
                    }(o),
                    n += u;
                    break;
                case "Radio":
                    var d = function(t) {
                        var i = fv(t)
                          , o = t.Name.replace(/"/g, "&quot;");
                        let n = null != t.enableToolTip && t.enableToolTip
                          , r = n ? t.toolTip : null
                          , a = !0 === n ? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + r + "<i></i></span></div>" : "";
                        var s = "<div class='element checkbox-element' data-element='" + t.Identifier + "' " + i.conditionalTemplate + "'><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + a + "</label>";
                        let l = 0;
                        return t.Options.forEach((i => {
                            let n = 0 === l ? "checked" : "";
                            s += "<input class='calc-prop radio' data-identifier='" + t.Identifier + "' type='radio' onchange='ChangeEvent(null)' data-val='" + i.value + "' value='" + i.label + "' name=\"properties[" + o + ']" ' + n + " data-calcname='" + t.Name + "'/><span style='color:" + e.calculatorStyling.upperTextColor + "'>" + i.label + "</span>",
                            l++
                        }
                        )),
                        s += "</div>"
                    }(o);
                    n += d;
                    break;
                case "Calculation":
                    a = function(t) {
                        let o = parseFloat(t.formula_minvalue);
                        o = Number(o).toFixed(t.formula_decimals);
                        var n = fv(t);
                        let r = null != t.isQuantity && t.isQuantity;
                        var a = t.Name.replace(e.spaceRegex, "_");
                        a = a.replace(e.specialCharactersRegex, "");
                        let s = null != t.enableToolTip && t.enableToolTip
                          , l = s ? t.toolTip : null
                          , c = !0 === s ? "<div class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + l + "<i></i></span></div>" : ""
                          , u = (0,
                        i.qp)() + s.enableCurrencyConversion != null && t.enableCurrencyConversion ? "<span class='formula-block'>  <span id='calcElementPriceTicker' class='calculation-element calc-prop money cpc-priceTicker' style='display:inline-block; font-size:inherit !important' name=\"properties[" + t.Name + "]\" data-minvalue='" + t.formula_minvalue + "' data-element_name='" + t.Name + "' data-val='" + t.formula_minvalue + "' data-decimals='" + t.formula_decimals + "' data-formula='" + t.formula + "' data-cpc_isquantity='" + r + "' id='formula_" + t.Name + "'>" + t.formula_prefix + o + "</span></span>" : "<span class='formula-block'> " + t.formula_prefix + " <label id='calcElementPriceTicker' class='calculation-element calc-prop' name=\"properties[" + t.Name + "]\" data-minvalue='" + t.formula_minvalue + "' data-element_name='" + t.Name + "' data-val='" + t.formula_minvalue + "' data-decimals='" + t.formula_decimals + "' data-formula='" + t.formula + "' data-cpc_isquantity='" + r + "' id='formula_" + t.Name + "'>" + o + "</label><suffix>" + t.formula_suffix + "</suffix></span>";
                        return "<div class='element' data-element='" + t.Identifier + "' " + n.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + t.Name + c + "</label>" + u + "</div><input type='hidden' id='calculation_inp_" + a + "' name=\"properties[" + t.Name + "]\" data-cpc_isquantity='" + r + "' value='" + t.formula_minvalue + "' />"
                    }(o),
                    n += a;
                    break;
                case "Lookup":
                    a = function(i) {
                        var o = null != i.input1_minvalue ? i.input1_minvalue : 0
                          , n = null != i.input1_maxvalue ? i.input1_maxvalue : 1e5;
                        let r = null != i.input1_maxdecimals.Maxdecimals ? i.input1_maxdecimals.Maxdecimals : 0;
                        n = Math.round(n, r);
                        var a = null != i.input1_maxdecimals ? (0,
                        t.TY)(i.input1_maxdecimals) : 1
                          , s = null != i.input1_isformula && i.input1_isformula
                          , l = null != i.input2_minvalue ? i.input2_minvalue : 0
                          , c = null != i.input1_maxvalue ? i.input2_maxvalue : 1e5;
                        let u = null != i.input2_maxdecimals.Maxdecimals ? i.input2_maxdecimals.Maxdecimals : 0;
                        c = Math.round(c, u);
                        var d = null != i.input2_maxdecimals ? (0,
                        t.TY)(i.input2_maxdecimals) : 1
                          , p = null != i.input2_isformula && i.input2_isformula
                          , h = fv(i)
                          , m = ""
                          , f = s ? "hide-element" : ""
                          , g = p ? "hide-element" : "";
                        let y = s ? "lookup-element-with-formula" : ""
                          , $ = p ? "lookup-element-with-formula" : ""
                          , b = null != i.enableToolTip && i.enableToolTip
                          , v = b ? i.toolTip : null
                          , x = !0 === b ? "<span class='c-tooltip'><i class='fas fa-info-circle'></i><span class='right'>" + v + "<i></i></span></span>" : "";
                        return m += "<div class='element " + f + "' data-element='" + i.Identifier + "_1' " + h.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + i.input1_label + x + "</label><input onfocusout='ChangeEvent(null)' data-lookup='true' data-lookupelementindex='1' data-identifier='" + i.Identifier + "' class='calc-prop " + y + "' step='" + a + "' data-minvalue='" + o + "' min='" + o + "' max='" + n + "' onblur='validity.valid || (value = \"\");' data-calcname='" + i.input1_label + "' data-isformula='" + s + "' data-formula='" + i.input1_formula + "' name=\"properties[" + i.input1_label + "]\" value='" + i.input1_minvalue + "' type='number'/></div>",
                        m += "<div class='element " + g + "' data-element='" + i.Identifier + "_2' " + h.conditionalTemplate + "><label style='color:" + e.calculatorStyling.upperTextColor + "'>" + i.input2_label + x + "</label><input onfocusout='ChangeEvent(null)' data-lookup='true' data-lookupelementindex='2' data-identifier='" + i.Identifier + "' class='calc-prop " + $ + "' step='" + d + "' data-minvalue='" + l + "' min='" + l + "' max='" + c + "' onblur='validity.valid || (value = \"\");' data-calcname='" + i.input2_label + "' data-isformula='" + p + "' data-formula='" + i.input2_formula + "' name=\"properties[" + i.input2_label + "]\" value='" + i.input2_minvalue + "' type='number'/></div>"
                    }(o),
                    n += a;
                    break;
                case "PriceMarker":
                    a = function(o) {
                        e.cpc_currentPrice = o.DefaultValue,
                        e.priceMarkerDecimals = o.Decimals,
                        e.miniMumCartValue = parseFloat(o.DefaultValue),
                        e.miniMumCartValue = Number(e.miniMumCartValue).toFixed(o.Decimals);
                        var n = "rounded" === e.calculatorStyling.border ? "rounded-edges-bottom" : ""
                          , r = (0,
                        t.x_)()
                          , a = (0,
                        t.MM)();
                        null === e.calculatorStyling.loaderText && (e.calculatorStyling.loaderText = "");
                        var s = "<div class='loading-anim' style='display:none'><img src='https://app.custompricecalculator.com/loading-spinner.gif'><p id='cpc_loader_text'>" + e.calculatorStyling.loaderText + "</p></div>"
                          , l = (0,
                        t.tQ)(Number(e.miniMumCartValue), +e.cpc_configData.thousandSeperator, +e.cpc_configData.decimalSeperator);
                        let c = (0,
                        i.qp)() ? " <span id='priceTicker' class='money cpc-priceTicker' data-origMoney='' style='color:" + e.calculatorStyling.priceTextColor + "'; display:inline> " + o.Prefix + " " + l + "</span><suffix>" + o.Suffix + "</suffix></span>" : o.Prefix + " <label id='priceTicker' style='color:" + e.calculatorStyling.priceTextColor + "'>" + l + "</label><suffix>" + o.Suffix + "</suffix></span>";
                        return r + a + s + "<div id='errDialog' title='Title' style=display:none;'><p id='dialogMsg'> Message. </p></div><div class='price-marker " + n + "' style='background-color:" + e.calculatorStyling.priceBackground + ";color:" + e.calculatorStyling.priceTextColor + "'><label style='color:" + e.calculatorStyling.priceTextColor + "'>" + o.Name + "</label><span id='calculator-final-value'> " + c + "</div>"
                    }(o),
                    n += a
                }
            }
            )),
            n += "<input id='variantIdCustom' name='id' type='hidden' value='0' />"
        }
        function fv(e) {
            var t = !1 == (!0 !== e.conditional_display) ? "style='display:none;'" : ""
              , i = e.conditional_display_selected_element
              , o = e.conditional_display_selected_element_value;
            return {
                displayStyle: t,
                conditionalElement: i,
                conditionalElementValue: o,
                conditionalTemplate: t + " data-conditionalelement='" + i + "' data-conditionalelementvalue='" + o + "'"
            }
        }
        function gv(t, i) {
            let o = e.cpc_configData.alertMessageNumberInput
              , n = 0
              , r = ""
              , a = !0;
            var s = (t.value.split(".")[1] || "").length;
            if (!t.validity.valid)
                for (var l in t.validity)
                    t.validity[l] && (n++,
                    r = l.toLowerCase());
            if ((n > 1 || 1 == t.step && "stepmismatch" == r || s > i || 1 == n && 1 == n && "stepmismatch" != r && (null == hv(t).data("lookup") || null == hv(t).data("lookup") && 1 != hv(t).data("lookup"))) && (a = !1),
            0 == t.value.length || !a) {
                if (t.setAttribute("style", "border:1px solid red !important;"),
                t.value = t.min || 0,
                null == t.nextSibling)
                    if (o.replace("{input_range_min}", "").replace("{input_range_max}", "").trim().length > 0) {
                        let e = t.getAttribute("min")
                          , i = t.getAttribute("max");
                        o = o.replace("{input_range_min}", e).replace("{input_range_max}", i).trim(),
                        t.insertAdjacentHTML("afterend", "<label style='color:red;'>" + o + "</label>")
                    } else
                        t.insertAdjacentHTML("afterend", "<label style='color:red;'>Value out of range</label>");
                return (0,
                h.cD)(),
                !1
            }
            return t.style.setProperty("border", ""),
            null != t.nextSibling && t.nextSibling.remove(),
            (0,
            h.cD)(),
            !0
        }
        window.PriceUpdation = h.iO,
        window.CheckNumberInputValidity = gv,
        window.ChangeEvent = h.kg,
        window.UpdatePrice = h.cD,
        hv(window).ready((function() {
            (0,
            t.rQ)()
        }
        ));
        var yv = __webpack_require__(755);
        function $v() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
            var i = !1
              , o = null;
            if ([].forEach((e => {
                !1 === i && yv("." + e)[0] && (o = e,
                i = !0)
            }
            )),
            !1 === e.cpc_waitforcartconfirmation) {
                if (!0 === i)
                    yv("." + o).trigger("click");
                else {
                    var n = bv();
                    window.location.href = n
                }
                yv(".loading-anim").hide()
            } else
                fetch("/cart.js?cache=false&q=" + Math.random()).then((e => e.json())).then((function(e) {
                    if (-1 === JSON.stringify(e).search('"price":0')) {
                        if (!0 === i)
                            yv("." + o).trigger("click");
                        else {
                            var n = bv();
                            window.location.href = n
                        }
                        yv(".loading-anim").hide()
                    } else
                        t++,
                        setTimeout(( () => {
                            console.log("waiting for cart confirmation"),
                            $v(t)
                        }
                        ), 1e3)
                }
                )).catch((function(e) {
                    return console.log(e),
                    !1
                }
                ))
        }
        function bv() {
            const e = new URL(window.location.href)
              , t = e.pathname.split("/").filter(Boolean);
            let i;
            return i = t.length > 0 && 2 === t[0].length ? `/${t[0]}/cart` : "/cart",
            `${e.origin}${i}`
        }
        var vv = __webpack_require__(196)
          , xv = __webpack_require__(755)
          , wv = __webpack_require__(755);
        async function Sv(i) {
            i.preventDefault(),
            i.stopImmediatePropagation(),
            i.stopPropagation(),
            xv(".loading-anim").show();
            var o = function() {
                var t = []
                  , i = {};
                for (var o in yv(".calc-prop").each((function(o, n) {
                    let r = yv(n).is(":hidden")
                      , a = void 0 !== yv(n).data("lookup")
                      , s = !!a && !0 === yv(n).data("isformula");
                    if ("number" == (d = yv(n).prop("type"))) {
                        var l = gv(n);
                        if (void 0 !== l && !l)
                            return e.isError = !0,
                            void yv(n).addClass("error-border")
                    }
                    if (!1 === r || !0 === s) {
                        var c = yv(n).attr("name")
                          , u = yv(n).val();
                        let e = yv(n).is(":checkbox")
                          , o = yv(n).is("select");
                        var d = yv(n).prop("nodeName");
                        if (!0 === yv(n).is(":radio")) {
                            if (!1 === yv(n).is(":checked"))
                                return !0;
                            void 0 === yv(n).data("showimage") && (u = yv(n).data("val"))
                        } else if ("LABEL" === d)
                            u = yv(n).data("val");
                        else if (!0 === e) {
                            let e = yv(n).is(":checked");
                            yv(n).data("checkedvalue"),
                            yv(n).data("uncheckedvalue"),
                            u = e ? "Checked" : "Unchecked"
                        } else
                            !0 === o && (u = yv(n).children("option:selected").data("label"));
                        if ("length" === (c = (c = c.replace("properties[", "")).replace("]", "")) && (c = "Length"),
                        !0 === a) {
                            let e = yv(n).data("lookupelementindex")
                              , t = yv(n).data("identifier");
                            if (void 0 === i[t]) {
                                var p = {
                                    elementName: t,
                                    input1: 0,
                                    input2: 0
                                };
                                1 === e ? p.input1 = parseFloat(yv(n).val()) : 2 === e && (p.input2 = parseFloat(yv(n).val())),
                                i[t] = p
                            } else {
                                let o = i[t];
                                1 === e ? o.input1 = parseFloat(yv(n).val()) : 2 === e && (o.input2 = parseFloat(yv(n).val()))
                            }
                        } else
                            t[c] = u
                    }
                }
                )),
                i)
                    t[o] = i[o];
                return t.shopify_product_price = e.cpc_product_default_price,
                e.cpc_metaFields.forEach((e => {
                    t["shopify_meta_" + e.key] = e.value
                }
                )),
                t
            }();
            !0 !== (0,
            vv.vK)() ? xv.ajax({
                method: "POST",
                url: e.baseCalculatorNewApiUrl + "variant",
                data: JSON.stringify({
                    calculatorId: e.cpc_calculatorId,
                    productId: window.meta.product.id,
                    properties: {
                        ...o
                    }
                }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            }).done((function(o) {
                if (xv("#Quantity")) {
                    var n = i.value;
                    n && Number(n)
                }
                if ("object" == typeof o && null !== o)
                    return (0,
                    t.vC)(),
                    void xv(".loading-anim").hide();
                document.getElementById("variantIdCustom").value = o,
                (0,
                vv.V8)(),
                (0,
                vv.Hf)(),
                function() {
                    yv(".loading-anim").show(),
                    console.log("posting product data...");
                    var t = e.productForm;
                    let i = 1;
                    console.log(t),
                    [...t.elements].forEach((e => {
                        if (!0 === yv(e).data("cpc_isquantity")) {
                            let o = yv(e).attr("name");
                            i = t.elements[o].value,
                            yv(e).remove()
                        }
                    }
                    ));
                    var o = new FormData(t);
                    o.append("quantity", i),
                    yv.ajax({
                        type: "POST",
                        url: "/cart/add",
                        data: o,
                        xhr: function() {
                            var t = new window.XMLHttpRequest;
                            if (null !== e.calculatorStyling && null !== e.calculatorStyling.fileUploadProgressText && "" !== e.calculatorStyling.fileUploadProgressText) {
                                let i = 1;
                                t.upload.addEventListener("progress", (function(t) {
                                    if (i++,
                                    t.lengthComputable && i > 2) {
                                        var o = t.loaded / t.total * 100;
                                        console.log("percentComplete", o),
                                        o = o.toFixed(2),
                                        yv("#cpc_loader_text").html(e.calculatorStyling.fileUploadProgressText + " " + o + " %")
                                    }
                                }
                                ), !1)
                            }
                            return t
                        },
                        processData: !1,
                        contentType: !1,
                        success: function() {
                            null !== e.calculatorStyling && "" !== e.calculatorStyling.loaderText && yv("#cpc_loader_text").html(e.calculatorStyling.loaderText),
                            $v()
                        },
                        error: function(t) {
                            console.log("add to cart request errored", t),
                            null !== e.calculatorStyling && "" !== e.calculatorStyling.loaderText && yv("#cpc_loader_text").html(e.calculatorStyling.loaderText),
                            $v()
                        }
                    })
                }()
            }
            )).fail((function(e, t, i) {
                console.error("Error:", t, i);
                let o = "An error occurred during the request: " + t;
                400 === e.status || 500 === e.status ? o = e.responseText : "timeout" === t ? o = "Request timed out." : "abort" === t && (o = "Request was aborted."),
                wv("#errDialog").attr("title", "Error"),
                wv("#dialogMsg").text(o.replace(/"/g, "")),
                wv("#errDialog").dialog({
                    modal: !0
                })
            }
            )) : xv(".loading-anim").hide()
        }
        __webpack_require__(912),
        __webpack_require__(466);
        var _v = __webpack_require__(755);
        var kv = __webpack_require__(755);
        __webpack_require__(89),
        __webpack_require__(837),
        __webpack_require__(697),
        kv(document).ready((function() {
            if (void 0 === String.prototype.replaceAll && (String.prototype.replaceAll = function(e, t) {
                return this.replace(new RegExp(e,"g"), ( () => t))
            }
            ),
            !1 === e.cpc_pageLoaded) {
                if (e.cpc_pageLoaded = !0,
                console.log("calculator loading"),
                "undefined" != typeof Shopify)
                    e.cpc_shopUrl = Shopify.shop,
                    e.cpc_languageCode = Shopify.locale,
                    void 0 !== window.meta.product && (e.cpc_productId = window.meta.product.id);
                else {
                    console.log("calculator loading in preview mode");
                    var i = kv("#calculator_preview_storeurl").val();
                    e.cpc_shopUrl = i,
                    e.cpc_isPreview = !0
                }
                null == document.querySelector('select[name="oldId"]') && async function() {
                    const i = window.location.pathname
                      , o = window.location.href;
                    var n = await async function(t) {
                        var i = `${e.baseCalculatorNewApiUrl}calculator/app/pageurl?pageUrl=${t}`;
                        const o = await fetch(i);
                        return o.ok && 204 !== o.status ? await o.json() : null
                    }(o);
                    n ? async function(i) {
                        let {calcUniqueIden: o, elementSelector: n} = i;
                        var r;
                        if (null == (r = o) || 0 == r || null == r) {
                            document.getElementById("calculator-block");
                            var a = document.getElementById("custom-calculator");
                            if (null == (r = _v(a).attr("data-calculatorid")) || null == r)
                                return void console.log("No calculator found");
                            console.log("CalculatorId found from Fallback Method", r)
                        }
                        if (null != r && null != r) {
                            e.cpc_calculatorId = r,
                            console.log("calculator found", r),
                            (0,
                            vv.yu)(),
                            ["product-price", "product-single__price", "selector-wrapper", "current_price", "product__price", "shopify-payment-button", "single-option-selector"].forEach((e => {
                                _v("." + e).addClass("hide-element")
                            }
                            ));
                            var s = document.createElement("link");
                            s.setAttribute("rel", "stylesheet"),
                            s.setAttribute("type", "text/css"),
                            s.setAttribute("href", e.baseCalculatorNewApiUrl + "store/style/app?shop=" + e.cpc_shopUrl),
                            document.getElementsByTagName("head")[0].appendChild(s);
                            var l = document.createElement("link");
                            l.setAttribute("rel", "stylesheet"),
                            l.setAttribute("type", "text/css"),
                            l.setAttribute("href", `${e.cdnURL}/plugins.css`),
                            document.getElementsByTagName("head")[0].appendChild(l),
                            _v("#custom-calculator").hide();
                            var c = async function(t, i) {
                                var o = e.baseCalculatorNewApiUrl + "calculator/app?calculatorId=" + t + "&isPreview=" + i + "&shop=" + e.cpc_shopUrl + "&languageCode=" + e.cpc_languageCode;
                                return await fetch(o)
                            }(r, e.cpc_isPreview);
                            c.then((e => e.json())).then((i => {
                                e.cpc_data = i.calculatorData,
                                e.cpc_metaFields = i.metaFields;
                                let o = {
                                    smartVariantAutoDeletion: !1,
                                    alertMessageNumberInput: "Please enter a value between range {input_range_min} and {input_range_max}",
                                    thousandSeperator: 0,
                                    decimalSeperator: 0
                                };
                                i.configuration && (o = i.configuration),
                                localStorage.setItem("cpc_configData", JSON.stringify(o)),
                                e.cpc_configData = o,
                                e.calculatorStyling = i.styling,
                                e.cpc_waitforcartconfirmation = i.waitForCartConfirmation,
                                console.log("meta-fields", e.cpc_metaFields);
                                var a = mv(e.cpc_data)
                                  , s = document.querySelector(n) ?? document.querySelector(`#${n}`) ?? document.querySelector(`.${n}`);
                                null == s && (s = document.querySelector("form[action='/cart/add'] button[type=submit]")),
                                console.log("render-block", s);
                                var l = "rounded" === e.calculatorStyling.border ? "class='rounded-edges'" : "";
                                _v(s).append("<div id='calculator' data-calcid='" + r + "' " + l + " style='background-color:" + e.calculatorStyling.upperBackground + "'>" + a + "</div>");
                                var c = e.baseCalculatorNewApiUrl + "store/script/app?shop=" + e.cpc_shopUrl;
                                if (null != c && c.length > 0) {
                                    var u = document.createElement("script");
                                    u.setAttribute("type", "text/javascript"),
                                    u.setAttribute("src", c),
                                    u.defer = !0,
                                    u.setAttribute("crossorigin", "anonymous"),
                                    document.getElementsByTagName("head")[0].appendChild(u)
                                }
                                (0,
                                h.Q8)(),
                                (0,
                                h.cD)(),
                                (0,
                                t.rQ)()
                            }
                            ))
                        }
                    }(n) : "CART" === i.substring(i.lastIndexOf("/") + 1).toUpperCase() ? async function() {
                        window.CPC_CartQuantityOnChange = a,
                        await async function() {
                            var t = e.baseCalculatorNewApiUrl + "store/app?shop=" + e.cpc_shopUrl;
                            await fetch(t).then((e => e.json())).then((t => {
                                e.cpc_fasterCheckoutConfig = t
                            }
                            ))
                        }(),
                        a()
                    }() : async function() {
                        var i, o;
                        if (xv('form[action*="/cart/add"]').each((function(t, o) {
                            var n = xv(o).data("cpc-product-form");
                            o.querySelector('[type="submit"]') && (void 0 === i || void 0 !== n && 1 == n) && (i = null !== o ? o.querySelector('[type="submit"]') : null,
                            e.productForm = o),
                            o.querySelector('button[class*="cart"]') && (void 0 === i || void 0 !== n && 1 == n) && (i = null !== o ? o.querySelector('button[class*="cart"]') : null,
                            e.productForm = o)
                        }
                        )),
                        e.cpc_productId > 0) {
                            var n = await async function() {
                                try {
                                    let t;
                                    return await fetch(e.baseCalculatorNewApiUrl + "calculator/app/productid/" + e.cpc_productId + "?shop=" + e.cpc_shopUrl).then((e => e.json())).then((async function(e) {
                                        void 0 !== e && (t = e)
                                    }
                                    )),
                                    t
                                } catch (e) {}
                            }();
                            null != n && null != n.calcUniqueIden && null != n.calcUniqueIden && "" != n.calcUniqueIden && (console.log("CalculatorId found from API"),
                            o = n.calcUniqueIden)
                        }
                        if (null == o || 0 == o || null == o) {
                            document.getElementById("calculator-block");
                            var r = document.getElementById("custom-calculator");
                            if (null == (o = xv(r).attr("data-calculatorid")) || null == o)
                                return void console.log("No calculator found");
                            console.log("CalculatorId found from Fallback Method", o)
                        }
                        if (null != o && null != o) {
                            var a;
                            e.cpc_calculatorId = o,
                            console.log("calculator found", o),
                            console.log("product Id", e.cpc_productId),
                            (0,
                            vv.yu)(),
                            await async function() {
                                try {
                                    if (!1 === e.cpc_isPreview) {
                                        let t = window.location.origin + window.location.pathname
                                          , o = new URLSearchParams(window.location.search).toString();
                                        void 0 === o && (o = "");
                                        let n = o.startsWith("preview_key");
                                        var i = t + ".js?d=" + Math.random();
                                        !0 === n && (i = t + ".js?" + o + "&d=" + Math.random()),
                                        await fetch(i).then((e => e.json())).then((async function(t) {
                                            if (void 0 !== t) {
                                                var i = t.variants[0];
                                                void 0 !== i && (e.cpc_product_default_price = i.price / 100)
                                            }
                                        }
                                        )),
                                        console.log("shopify product price", e.cpc_product_default_price)
                                    } else
                                        console.log("Calculator in preview mode"),
                                        e.cpc_product_default_price = 10
                                } catch (i) {
                                    var o = "Shopify Price Error:. ProductId =" + e.cpc_productId;
                                    (0,
                                    t.fJ)(i, o),
                                    e.cpc_product_default_price = 0,
                                    setTimeout((function() {
                                        window.location.reload()
                                    }
                                    ), 3e3)
                                }
                            }(),
                            ["product-price", "product-single__price", "selector-wrapper", "current_price", "product__price", "shopify-payment-button", "single-option-selector"].forEach((e => {
                                xv("." + e).addClass("hide-element")
                            }
                            )),
                            null !== (a = document.querySelector('select[name="id"]')) && (e.baseVariantId = a.value,
                            a.setAttribute("name", "oldId")),
                            null !== (a = document.querySelector('input[name="id"]')) && (e.baseVariantId = a.value,
                            a.setAttribute("name", "oldId")),
                            e.productForm.addEventListener("submit", (function(e) {
                                e.preventDefault(),
                                e.stopImmediatePropagation(),
                                e.stopPropagation()
                            }
                            ));
                            var s = document.createElement("link");
                            if (s.setAttribute("rel", "stylesheet"),
                            s.setAttribute("type", "text/css"),
                            s.setAttribute("href", e.baseCalculatorNewApiUrl + "store/style/app?shop=" + e.cpc_shopUrl),
                            document.getElementsByTagName("head")[0].appendChild(s),
                            !document.getElementById("cdn-plugin-css")) {
                                var l = document.createElement("link");
                                l.setAttribute("rel", "stylesheet"),
                                l.setAttribute("type", "text/css"),
                                l.setAttribute("href", `${e.cdnURL}/plugins.css`),
                                l.id = "cdn-plugin-css",
                                document.getElementsByTagName("head")[0].appendChild(l)
                            }
                            var c = i;
                            let n = c.cloneNode(!0);
                            c && c.parentNode ? c.parentNode.replaceChild(n, c) : c.replaceWith(n),
                            (i = n).addEventListener("click", await Sv),
                            xv("#custom-calculator").hide();
                            var u = async function(t, i) {
                                var o = e.baseCalculatorNewApiUrl + "calculator/app?calculatorId=" + t + "&productId=" + e.cpc_productId + "&isPreview=" + i + "&shop=" + e.cpc_shopUrl + "&languageCode=" + e.cpc_languageCode;
                                return await fetch(o)
                            }(o, e.cpc_isPreview);
                            u.then((e => e.json())).then((n => {
                                e.cpc_data = n.calculatorData,
                                e.cpc_metaFields = n.metaFields;
                                let r = {
                                    smartVariantAutoDeletion: !1,
                                    alertMessageNumberInput: "Please enter a value between range {input_range_min} and {input_range_max}",
                                    thousandSeperator: 0,
                                    decimalSeperator: 0
                                };
                                n.configuration && (r = n.configuration),
                                localStorage.setItem("cpc_configData", JSON.stringify(r)),
                                e.cpc_configData = r,
                                e.calculatorStyling = n.styling,
                                e.cpc_waitforcartconfirmation = n.waitForCartConfirmation,
                                console.log("meta-fields", e.cpc_metaFields);
                                var a = mv(e.cpc_data)
                                  , s = document.querySelector(".add-to-cart");
                                null == s && (s = document.querySelector("form[action='/cart/add'] button[type=submit]")),
                                null == s && (s = i),
                                s = i,
                                console.log("render-block", s);
                                var l = "rounded" === e.calculatorStyling.border ? "class='rounded-edges'" : "";
                                xv(s).parent().prepend("<div id='calculator' data-calcid='" + o + "' " + l + " style='background-color:" + e.calculatorStyling.upperBackground + "'>" + a + "</div>");
                                var c = e.baseCalculatorNewApiUrl + "store/script/app?shop=" + e.cpc_shopUrl;
                                if (null != c && c.length > 0) {
                                    var u = document.createElement("script");
                                    u.setAttribute("type", "text/javascript"),
                                    u.setAttribute("src", c),
                                    u.defer = !0,
                                    u.setAttribute("crossorigin", "anonymous"),
                                    document.getElementsByTagName("head")[0].appendChild(u)
                                }
                                (0,
                                h.rd)(),
                                (0,
                                t.rQ)()
                            }
                            ))
                        }
                    }()
                }()
            }
        }
        ))
    }
    )()
}
)();
